/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2199),
    getSymbols = __webpack_require__(4664),
    keys = __webpack_require__(5950);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 79:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3702),
    listCacheDelete = __webpack_require__(80),
    listCacheGet = __webpack_require__(4739),
    listCacheHas = __webpack_require__(8655),
    listCacheSet = __webpack_require__(1175);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 80:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PlanificationDelete_PlanificationDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PlanificationDelete/PlanificationDelete.vue?vue&type=template&id=34e40042
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.hidden},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_vm._v(" "+_vm._s(_vm.termText('construction.deleteMsg', 'planning'))+" ")]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/utils/text.ts
var utils_text = __webpack_require__(2579);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PlanificationDelete/PlanificationDelete.ts?vue&type=script&lang=ts&external





var PlanificationDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationDelete, _super);
    function PlanificationDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(PlanificationDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    PlanificationDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    PlanificationDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    PlanificationDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.hidden();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/construction/planification/' + this.value.id)
            .then(function (response) {
            _this.deleted(response.data);
            _this.hidden();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    PlanificationDelete.prototype.hidden = function () {
        this.errorMsg = null;
        this.modalState = false;
        this.$emit('hidden');
    };
    PlanificationDelete.prototype.deleted = function (construction) {
        interface_vue_.emitter.emit('planificationDeleted', { planification: this.value, construction: construction });
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PlanificationDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], PlanificationDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], PlanificationDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PlanificationDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], PlanificationDelete.prototype, "watchModalState", null);
    PlanificationDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            methods: {
                termText: utils_text/* termText */.a
            }
        })
    ], PlanificationDelete);
    return PlanificationDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var PlanificationDeletevue_type_script_lang_ts_external = (PlanificationDelete);

;// ./src/components/PlanificationDelete/PlanificationDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationDelete_PlanificationDeletevue_type_script_lang_ts_external = (PlanificationDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PlanificationDelete/PlanificationDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PlanificationDelete_PlanificationDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationDelete_PlanificationDelete = (component.exports);

/***/ }),

/***/ 270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(7068),
    isObjectLike = __webpack_require__(346);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 317:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 392:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(7237),
    basePropertyDeep = __webpack_require__(7255),
    isKey = __webpack_require__(8586),
    toKey = __webpack_require__(7797);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(8077),
    hasPath = __webpack_require__(9326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(756),
    keys = __webpack_require__(5950);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 938:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223),
    MapCache = __webpack_require__(3661);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 1042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 1074:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 1126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(5389),
    baseSum = __webpack_require__(7721);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),

/***/ 1175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 1380:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 1420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 1459:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PlanificationItem_PlanificationItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PlanificationItem/PlanificationItem.vue?vue&type=template&id=196ef3e2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"visible":_vm.value !== null,"size":"lg","scrollable":""},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-row',{staticClass:"w-100"},[(_vm.planification && _vm.can('construction', 3))?_c('b-col',[_c('PlanificationForm',{staticClass:"mr-2 d-inline-block",attrs:{"value":_vm.planification,"variant":"primary","label":"Modifier"},on:{"updated":_vm.planificationUpdated}}),_c('PlanificationDelete',{staticClass:"d-inline-block",attrs:{"value":_vm.planification},on:{"deleted":_vm.planificationDeleted}})],1):_vm._e(),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.close'))+" ")])],1)],1)]}}])},[(!_vm.planification || _vm.loading)?_c('Spinner'):[_c('b-row',{staticClass:"mb-4"},[_c('b-col',[_c('b-button-group',[(_vm.can('construction', 1) && _vm.planification.construction_id && _vm.$route.path !== _vm.$router.resolve({ name: 'construction-item', params: { id: String(_vm.planification.construction_id) } }).href)?_c('b-button',{attrs:{"variant":"primary","size":"sm","to":{ name: 'construction-item', params: { id: String(_vm.planification.construction_id) }}}},[_vm._v(" Fiche chantier ")]):_vm._e(),_c('InterventionDownload',{attrs:{"label":"Fiche d'intervention","type":"planification","variant":"primary","size":"sm","disabled":_vm.planification?.document_status !== 1},model:{value:(_vm.planification),callback:function ($$v) {_vm.planification=$$v},expression:"planification"}})],1),(_vm.app.electronic_sign_status && !_vm.signed && _vm.can('sales-signatures', 1) && _vm.can('construction', 2))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
            title: _vm.signSendTitle
          }),expression:"{\n            title: signSendTitle\n          }"}],staticClass:"d-inline-block ml-2"},[_c('SignSend',{staticClass:"mr-2",attrs:{"size":"sm","variant":"primary","value":{
              documents: [
                {
                  document_type: 'planification',
                  document_id: _vm.planification.id,
                  document: _vm.planification,
                  file: _vm.planification.pdf,
                  signable_document: _vm.planification?.can_be_signed
                }
              ]
            },"disabled":_vm.signSendTitle !== null,"withDirectSign":""},on:{"sended":_vm.sended}})],1):_vm._e()],1),(_vm.can('planificationStatus', 1))?_c('b-col',{attrs:{"cols":"auto"}},[_c('PlanificationStatus',{attrs:{"value":_vm.planification,"size":"sm"},on:{"updated":_vm.planificationUpdated}})],1):_vm._e()],1),(_vm.app.electronic_sign_status && _vm.planification?.signatures)?_c('SignState',{attrs:{"signatures":_vm.planification.signatures},on:{"signed":state => _vm.signed = state,"waiting":state => _vm.waitingSign = state}}):_vm._e(),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Début"}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.planification.begin))+" ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Fin"}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.planification.end))+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Durée"}},[_vm._v(" "+_vm._s(_vm.parseDuration(_vm.planification.duration))+" ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Statut"}},[_vm._v(" "+_vm._s(_vm.$t('constructions.planification.status.' + _vm.planification.status))+" ")])],1)],1),_c('b-row',[(_vm.construction.customer)?_c('b-col',[_c('div',{staticClass:"alert alert-secondary pb-0"},[_c('b-form-group',{attrs:{"label":"Client"}},[_vm._v(" "+_vm._s(_vm.construction.customer.name)+" ")]),(_vm.construction?.customer?.phone)?_c('b-form-group',{attrs:{"label":"Téléphone"}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.construction.customer.phone))+" ")]):_vm._e(),(_vm.construction?.customer?.mobile)?_c('b-form-group',{attrs:{"label":"Portable"}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.construction.customer.mobile))+" ")]):_vm._e()],1)]):_vm._e(),(_vm.construction.contact)?_c('b-col',[_c('div',{class:{ 'alert alert-secondary pb-0': !_vm.construction.customer, 'p-2': _vm.construction.customer }},[_c('b-form-group',{attrs:{"label":"Contact"}},[_vm._v(" "+_vm._s(_vm.construction.contact.fullname)+" ")]),(_vm.construction?.contact?.phone)?_c('b-form-group',{attrs:{"label":"Téléphone"}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.construction.contact.phone))+" ")]):_vm._e(),(_vm.construction?.contact?.mobile)?_c('b-form-group',{attrs:{"label":"Portable"}},[_vm._v(" "+_vm._s(_vm.showPhone(_vm.construction.contact.mobile))+" ")]):_vm._e()],1)]):_vm._e()],1),_c('b-form-group',{attrs:{"label":_vm.uppercaseFirst(_vm.termText('planification.tabTitle', 'technician', true))}},[(_vm.planification.technicians.length > 0)?_c('ul',_vm._l((_vm.planification.technicians),function(technican,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(technican.name)+" ")])}),0):_c('span',{staticClass:"small"},[_vm._v(" Aucun technicien ")])]),(_vm.planification.custom_fields && _vm.planification.custom_fields.length > 0)?_c('CustomFieldsDisplay',{staticClass:"mb-4",attrs:{"type":"planification","value":_vm.planification.custom_fields,"titleClass":"form-title-alt mt-0"}}):_vm._e(),_c('b-tabs',{staticClass:"mt-3",attrs:{"content-class":"pt-2"}},[_c('b-tab',{attrs:{"title":"Contenu"}},[(!_vm.planification.construction)?_c('div',[_c('TextareaView',{attrs:{"value":_vm.planification.description}})],1):_c('table',{staticClass:"table table-sm table-bordered mb-0"},[(_vm.hasQuantity)?_c('thead',[_c('tr',{staticClass:"small"},[_c('th',{staticStyle:{"width":"35px"}},[_vm._v(" Qté ")]),_c('th',[_vm._v("Description")])])]):_vm._e(),_c('tbody',[(_vm.planification?.all_contents)?_vm._l((_vm.planification?.construction?.contents),function(content,i){return _c('tr',{key:i},[(_vm.hasQuantity)?_c('td',{staticClass:"text-center"},[(content.quantity > 0)?_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity))+" ")]):_vm._e()]):_vm._e(),_c('td',[_c('FroalaView',{attrs:{"value":content.designation}})],1)])}):_vm._l((_vm.planification?.contents),function(content,i){return _c('tr',{key:i},[(_vm.hasQuantity)?_c('td',{staticClass:"text-center"},[(content.quantity > 0)?_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity))+" ")]):_vm._e()]):_vm._e(),_c('td',[_c('FroalaView',{attrs:{"value":content.content.designation}})],1)])})],2)])]),_c('b-tab',{attrs:{"title":"Commentaires","lazy":""}},[_c('CommentsList',{attrs:{"type":"planification","id":_vm.planification.id}})],1),_c('b-tab',{attrs:{"title":"Fichiers","lazy":""}},[_c('FilesList',{attrs:{"type":"planification","id":_vm.planification.id,"btnMode":"","btnSize":"sm","btnLabel":"Sélectionner des fichiers"}})],1)],1)]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/sales-vue"
var sales_vue_ = __webpack_require__(2779);
// EXTERNAL MODULE: ./src/mixins/DurationMixin.ts
var DurationMixin = __webpack_require__(3790);
// EXTERNAL MODULE: ./src/fetchDatas/planification.ts
var planification = __webpack_require__(3385);
// EXTERNAL MODULE: ./src/utils/text.ts
var utils_text = __webpack_require__(2579);
// EXTERNAL MODULE: ./src/components/PlanificationDelete/PlanificationDelete.vue + 3 modules
var PlanificationDelete = __webpack_require__(229);
// EXTERNAL MODULE: ./src/components/PlanificationStatus/PlanificationStatus.vue + 3 modules
var PlanificationStatus = __webpack_require__(6229);
// EXTERNAL MODULE: ./src/components/InterventionDownload/InterventionDownload.vue + 3 modules
var InterventionDownload = __webpack_require__(2172);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PlanificationItem/PlanificationItem.ts?vue&type=script&lang=ts&external













var PlanificationItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationItem, _super);
    function PlanificationItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.planification = null;
        _this.loading = false;
        _this.signed = false;
        _this.waitingSign = false;
        return _this;
    }
    PlanificationItem.prototype.mounted = function () {
        interface_vue_.emitter.on('planificationPdfGenerated', this.planificationPdfGenerated);
    };
    PlanificationItem.prototype.beforeDestroy = function () {
        interface_vue_.emitter.off('planificationPdfGenerated', this.planificationPdfGenerated);
    };
    Object.defineProperty(PlanificationItem.prototype, "hasQuantity", {
        get: function () {
            var _a, _b;
            var contents = (_a = this.planification) === null || _a === void 0 ? void 0 : _a.contents;
            return ((_b = contents === null || contents === void 0 ? void 0 : contents.filter(function (content) { return content.content.quantity > 1; })) !== null && _b !== void 0 ? _b : []).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationItem.prototype, "construction", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.planification) === null || _a === void 0 ? void 0 : _a.construction) !== null && _b !== void 0 ? _b : this.planification;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationItem.prototype, "signSendTitle", {
        get: function () {
            var _a, _b;
            if (this.waitingSign) {
                return 'Un demande de signature est déjà en attente';
            }
            switch ((_a = this.planification) === null || _a === void 0 ? void 0 : _a.document_status) {
                case 0:
                case 1:
                    return 'Pdf en cours de génération';
                case 3:
                    return 'Erreur lors de la génération du PDF';
                default:
                    if (!((_b = this.planification) === null || _b === void 0 ? void 0 : _b.can_be_signed)) {
                        return 'Ce document ne peut pas être signé';
                    }
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    PlanificationItem.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.value) {
                            return [2 /*return*/];
                        }
                        if (!(0,planification/* needFetchPlanification */.GU)(this.value)) return [3 /*break*/, 2];
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, (0,planification/* fetchPlanification */.i_)(this.value.id)];
                    case 1:
                        _a.planification = _b.sent();
                        this.loading = false;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PlanificationItem.prototype.planificationUpdated = function (value) {
        this.planification = value;
        this.$emit('updated', value);
    };
    PlanificationItem.prototype.planificationDeleted = function () {
        this.$emit('deleted', this.planification);
        this.$emit('hidden');
    };
    PlanificationItem.prototype.sended = function (signature) {
        var planification = this.planification;
        if (!planification.signatures) {
            planification.signatures = [];
        }
        planification.signatures.push(signature);
    };
    PlanificationItem.prototype.planificationPdfGenerated = function (datas) {
        var _a;
        if (datas.id === ((_a = this.planification) === null || _a === void 0 ? void 0 : _a.id)) {
            this.planification.can_be_signed = datas.can_be_signed;
            this.planification.document_status = datas.status;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], PlanificationItem.prototype, "watchValue", null);
    PlanificationItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BButtonGroup: external_bootstrap_vue_.BButtonGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                Spinner: interface_vue_.Spinner, CommentsList: interface_vue_.CommentsList, FilesList: interface_vue_.FilesList, TextareaView: interface_vue_.TextareaView,
                'PlanificationForm': function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3785)); },
                PlanificationDelete: PlanificationDelete/* default */.A,
                PlanificationStatus: PlanificationStatus/* default */.A,
                InterventionDownload: InterventionDownload/* default */.A,
                SignSend: sales_vue_.SignSend, SignState: sales_vue_.SignState,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapState)('app', ['app'])),
            methods: {
                termText: utils_text/* termText */.a, uppercaseFirst: utils_text/* uppercaseFirst */.t
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], PlanificationItem);
    return PlanificationItem;
}((0,lib/* Mixins */.Xe)(DurationMixin/* default */.A, interface_vue_.DateMixin, interface_vue_.NumberMixin, interface_vue_.PhoneMixin)));
/* harmony default export */ var PlanificationItemvue_type_script_lang_ts_external = (PlanificationItem);

;// ./src/components/PlanificationItem/PlanificationItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationItem_PlanificationItemvue_type_script_lang_ts_external = (PlanificationItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PlanificationItem/PlanificationItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PlanificationItem_PlanificationItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationItem_PlanificationItem = (component.exports);

/***/ }),

/***/ 1549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2032),
    hashDelete = __webpack_require__(3862),
    hashGet = __webpack_require__(6721),
    hashHas = __webpack_require__(2749),
    hashSet = __webpack_require__(5749);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isKey = __webpack_require__(8586),
    stringToPath = __webpack_require__(1802),
    toString = __webpack_require__(3222);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 1799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    baseIsEqual = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 1802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2224);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    Uint8Array = __webpack_require__(7828),
    eq = __webpack_require__(5288),
    equalArrays = __webpack_require__(5911),
    mapToArray = __webpack_require__(317),
    setToArray = __webpack_require__(4247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 2032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 2054:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 2172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ InterventionDownload_InterventionDownload; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InterventionDownload/InterventionDownload.vue?vue&type=template&id=0bd8b372
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.computedTitle }),expression:"{ title: computedTitle }"}],staticClass:"btn-group"},[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.computedDisabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":"","busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"hidden":_vm.hidden},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:_vm._e()],2)],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/utils/text.ts
var utils_text = __webpack_require__(2579);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/InterventionDownload/InterventionDownload.ts?vue&type=script&lang=ts&external





var InterventionDownload = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(InterventionDownload, _super);
    function InterventionDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(InterventionDownload.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InterventionDownload.prototype, "computedDisabled", {
        get: function () {
            var _a;
            return (_a = this.value.document_status !== 2) !== null && _a !== void 0 ? _a : this.disabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InterventionDownload.prototype, "computedTitle", {
        get: function () {
            switch (this.value.document_status) {
                case 0:
                case 1:
                    return 'Pdf en cours de génération';
                case 3:
                    return 'Erreur lors de la génération du PDF';
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InterventionDownload.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : (this.type === 'construction' ? (0,utils_text/* termText */.a)('construction.pdf', 'chantier') : (0,utils_text/* termText */.a)('construction.pdf', 'planning'));
        },
        enumerable: false,
        configurable: true
    });
    InterventionDownload.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    InterventionDownload.prototype.watchModalState = function (state) {
        if (state) {
            this.process();
        }
    };
    InterventionDownload.prototype.getUrl = function () {
        var url = '/construction';
        if (this.type === 'planification') {
            url += '/planification';
        }
        return url + '/';
    };
    InterventionDownload.prototype.process = function () {
        var _this = this;
        this.$kwSales.axios.get(this.getUrl() + this.value.id + '/document')
            .then(function (response) {
            var file = response.data;
            _this.downloadFile(file.file, file.filename);
            _this.modalState = false;
            _this.hidden();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            throw new Error(error);
        });
    };
    InterventionDownload.prototype.hidden = function () {
        this.$emit('hidden');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], InterventionDownload.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], InterventionDownload.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], InterventionDownload.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InterventionDownload.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InterventionDownload.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], InterventionDownload.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], InterventionDownload.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], InterventionDownload.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], InterventionDownload.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState', { immediate: true })
    ], InterventionDownload.prototype, "watchModalState", null);
    InterventionDownload = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, Spinner: interface_vue_.Spinner
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], InterventionDownload);
    return InterventionDownload;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var InterventionDownloadvue_type_script_lang_ts_external = (InterventionDownload);

;// ./src/components/InterventionDownload/InterventionDownload.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var InterventionDownload_InterventionDownloadvue_type_script_lang_ts_external = (InterventionDownloadvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/InterventionDownload/InterventionDownload.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  InterventionDownload_InterventionDownloadvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InterventionDownload_InterventionDownload = (component.exports);

/***/ }),

/***/ 2175:
/***/ (function(module) {

"use strict";
module.exports = require("@fullcalendar/common");

/***/ }),

/***/ 2199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    isArray = __webpack_require__(6449);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 2224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(104);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 2355:
/***/ (function(module) {

"use strict";
module.exports = require("@fullcalendar/scrollgrid");

/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2507:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(8754),
    hasUnicode = __webpack_require__(9698),
    stringToArray = __webpack_require__(3912),
    toString = __webpack_require__(3222);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: function() { return /* binding */ termText; },
/* harmony export */   t: function() { return /* binding */ uppercaseFirst; }
/* harmony export */ });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

var uppercaseFirst = function (value) {
    if (value === '' || value === null || value === undefined) {
        return null;
    }
    value = String(value);
    return value.charAt(0).toUpperCase() + value.slice(1);
};
var termText = function (translation, key, more, variables) {
    if (more === void 0) { more = false; }
    var i18n = (vue__WEBPACK_IMPORTED_MODULE_0___default().prototype).$kwConstructions.i18n;
    var config = (vue__WEBPACK_IMPORTED_MODULE_0___default().prototype).$kwConstructions.store.getters['user/teamConfigs'];
    var customize = config['construction_customize'];
    var term = config['construction_customize_' + key + '_' + (more ? 'more' : 'one')];
    var type;
    if (customize && term) {
        type = config['construction_customize_' + key + '_gender'];
    }
    else {
        term = i18n.t('constructions.terms.' + key + (more ? 'More' : 'One'));
        switch (key) {
            case 'planification':
            case 'planning':
                type = 'female';
                break;
            default:
                type = 'male';
        }
    }
    if (['a', 'e', 'i', 'o', 'u', 'y', 'h'].includes(term.substr(0, 1))) {
        type = 'neutral';
    }
    var translationKey = 'constructions.' + translation + '_';
    switch (type) {
        case 'male':
            translationKey += 'm';
            break;
        case 'female':
        case 'feminine':
            translationKey += 'f';
            break;
        case 'neutral':
            translationKey += 'n';
            break;
    }
    return String(i18n.t(translationKey, Object.assign({ term: term }, variables)));
};



/***/ }),

/***/ 2651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(4218);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 2749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 2779:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/sales-vue");

/***/ }),

/***/ 2804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 2993:
/***/ (function(module) {

/*!
 * froala_editor v4.5.2 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2025 Froala Labs
 */

!function(e,t){ true?module.exports=t():0}(this,function(){"use strict";function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,r=Array(t);n<t;n++)r[n]=e[n];return r}function y(e,t,n,r,o,i,a){try{var s=e[i](a),l=s.value}catch(e){return void n(e)}s.done?t(l):Promise.resolve(l).then(r,o)}function S(e,t){var n="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!n){if(Array.isArray(e)||(n=l(e))||t&&e&&"number"==typeof e.length){n&&(e=n);var r=0,o=function(){};return{s:o,n:function(){return r>=e.length?{done:!0}:{done:!1,value:e[r++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,a=!0,s=!1;return{s:function(){n=n.call(e)},n:function(){var e=n.next();return a=e.done,e},e:function(e){s=!0,i=e},f:function(){try{a||null==n["return"]||n["return"]()}finally{if(s)throw i}}}}function $(){$=function(){return a};var d,a={},e=Object.prototype,f=e.hasOwnProperty,s=Object.defineProperty||function(e,t,n){e[t]=n.value},t="function"==typeof Symbol?Symbol:{},i=t.iterator||"@@iterator",n=t.asyncIterator||"@@asyncIterator",r=t.toStringTag||"@@toStringTag";function o(e,t,n){return Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{o({},"")}catch(d){o=function(e,t,n){return e[t]=n}}function l(e,t,n,r){var o=t&&t.prototype instanceof v?t:v,i=Object.create(o.prototype),a=new w(r||[]);return s(i,"_invoke",{value:function c(i,a,s){var l=u;return function(e,t){if(l===g)throw Error("Generator is already running");if(l===C){if("throw"===e)throw t;return{value:d,done:!0}}for(s.method=e,s.arg=t;;){var n=s.delegate;if(n){var r=M(n,s);if(r){if(r===m)continue;return r}}if("next"===s.method)s.sent=s._sent=s.arg;else if("throw"===s.method){if(l===u)throw l=C,s.arg;s.dispatchException(s.arg)}else"return"===s.method&&s.abrupt("return",s.arg);l=g;var o=p(i,a,s);if("normal"===o.type){if(l=s.done?C:h,o.arg===m)continue;return{value:o.arg,done:s.done}}"throw"===o.type&&(l=C,s.method="throw",s.arg=o.arg)}}}(e,n,a)}),i}function p(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}a.wrap=l;var u="suspendedStart",h="suspendedYield",g="executing",C="completed",m={};function v(){}function c(){}function b(){}var L={};o(L,i,function(){return this});var E=Object.getPrototypeOf,y=E&&E(E(O([])));y&&y!==e&&f.call(y,i)&&(L=y);var S=b.prototype=v.prototype=Object.create(L);function N(e){["next","throw","return"].forEach(function(t){o(e,t,function(e){return this._invoke(t,e)})})}function T(l,c){var t;s(this,"_invoke",{value:function(n,r){function e(){return new c(function(e,t){!function s(e,t,n,r){var o=p(l[e],l,t);if("throw"!==o.type){var i=o.arg,a=i.value;return a&&"object"==typeof a&&f.call(a,"__await")?c.resolve(a.__await).then(function(e){s("next",e,n,r)},function(e){s("throw",e,n,r)}):c.resolve(a).then(function(e){i.value=e,n(i)},function(e){return s("throw",e,n,r)})}r(o.arg)}(n,r,e,t)})}return t=t?t.then(e,e):e()}})}function M(e,t){var n=t.method,r=e.iterator[n];if(r===d)return t.delegate=null,"throw"===n&&e.iterator["return"]&&(t.method="return",t.arg=d,M(e,t),"throw"===t.method)||"return"!==n&&(t.method="throw",t.arg=new TypeError("The iterator does not provide a '"+n+"' method")),m;var o=p(r,e.iterator,t.arg);if("throw"===o.type)return t.method="throw",t.arg=o.arg,t.delegate=null,m;var i=o.arg;return i?i.done?(t[e.resultName]=i.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=d),t.delegate=null,m):i:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,m)}function A(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function x(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function w(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(A,this),this.reset(!0)}function O(e){if(e||""===e){var t=e[i];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function o(){for(;++n<e.length;)if(f.call(e,n))return o.value=e[n],o.done=!1,o;return o.value=d,o.done=!0,o};return r.next=r}}throw new TypeError(typeof e+" is not iterable")}return s(S,"constructor",{value:c.prototype=b,configurable:!0}),s(b,"constructor",{value:c,configurable:!0}),c.displayName=o(b,r,"GeneratorFunction"),a.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===c||"GeneratorFunction"===(t.displayName||t.name))},a.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,b):(e.__proto__=b,o(e,r,"GeneratorFunction")),e.prototype=Object.create(S),e},a.awrap=function(e){return{__await:e}},N(T.prototype),o(T.prototype,n,function(){return this}),a.AsyncIterator=T,a.async=function(e,t,n,r,o){void 0===o&&(o=Promise);var i=new T(l(e,t,n,r),o);return a.isGeneratorFunction(t)?i:i.next().then(function(e){return e.done?e.value:i.next()})},N(S),o(S,r,"Generator"),o(S,i,function(){return this}),o(S,"toString",function(){return"[object Generator]"}),a.keys=function(e){var t=Object(e),n=[];for(var r in t)n.push(r);return n.reverse(),function o(){for(;n.length;){var e=n.pop();if(e in t)return o.value=e,o.done=!1,o}return o.done=!0,o}},a.values=O,w.prototype={constructor:w,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=d,this.done=!1,this.delegate=null,this.method="next",this.arg=d,this.tryEntries.forEach(x),!e)for(var t in this)"t"===t.charAt(0)&&f.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=d)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(n){if(this.done)throw n;var r=this;function e(e,t){return i.type="throw",i.arg=n,r.next=e,t&&(r.method="next",r.arg=d),!!t}for(var t=this.tryEntries.length-1;0<=t;--t){var o=this.tryEntries[t],i=o.completion;if("root"===o.tryLoc)return e("end");if(o.tryLoc<=this.prev){var a=f.call(o,"catchLoc"),s=f.call(o,"finallyLoc");if(a&&s){if(this.prev<o.catchLoc)return e(o.catchLoc,!0);if(this.prev<o.finallyLoc)return e(o.finallyLoc)}else if(a){if(this.prev<o.catchLoc)return e(o.catchLoc,!0)}else{if(!s)throw Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return e(o.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;0<=n;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&f.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var o=r;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,m):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),m},finish:function(e){for(var t=this.tryEntries.length-1;0<=t;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),x(n),m}},"catch":function(e){for(var t=this.tryEntries.length-1;0<=t;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var o=r.arg;x(n)}return o}}throw Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:O(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=d),m}},a}function E(e,t){return function n(e){if(Array.isArray(e))return e}(e)||function d(e,t){var n=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=n){var r,o,i,a,s=[],l=!0,c=!1;try{if(i=(n=n.call(e)).next,0===t){if(Object(n)!==n)return;l=!1}else for(;!(l=(r=i.call(n)).done)&&(s.push(r.value),s.length!==t);l=!0);}catch(e){c=!0,o=e}finally{try{if(!l&&null!=n["return"]&&(a=n["return"](),Object(a)!==a))return}finally{if(c)throw o}}return s}}(e,t)||l(e,t)||function r(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function N(e){return function t(e){if(Array.isArray(e))return o(e)}(e)||function n(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||l(e)||function r(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function x(e){return(x="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){if(e){if("string"==typeof e)return o(e,t);var n={}.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?o(e,t):void 0}}Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(e){var t=this;if(!document.documentElement.contains(t))return null;do{if(t.matches(e))return t;t=t.parentElement||t.parentNode}while(null!==t&&1===t.nodeType);return null}),Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector||Element.prototype.oMatchesSelector||Element.prototype.webkitMatchesSelector||function(e){for(var t=(this.document||this.ownerDocument).querySelectorAll(e),n=t.length;0<=--n&&t.item(n)!==this;);return-1<n}),Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(e,t){if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(null!=o)for(var i in o)Object.prototype.hasOwnProperty.call(o,i)&&(n[i]=o[i])}return n},writable:!0,configurable:!0}),function(){var a=/^\s*:scope/gi,s=/,\s*:scope/gi,l=document.createElement("div");function e(e,t){var i=e[t];e[t]=function(e){var t,n=!1,r=!1;if(!e||Array.isArray(e)||!e.match(a)&&!e.match(s))return i.call(this,e);this.parentNode||(l.appendChild(this),r=!0);var o=this.parentNode;return this.id||(this.id="rootedQuerySelector_id_".concat((new Date).getTime()),n=!0),t=i.call(o,e.replace(a,"#".concat(this.id)).replace(s,",#".concat(this.id))),n&&(this.id=""),r&&l.removeChild(this),t}}try{var t=l.querySelectorAll(":scope *");if(!t||Array.isArray(t))throw"error"}catch(n){e(Element.prototype,"querySelector"),e(Element.prototype,"querySelectorAll"),e(HTMLElement.prototype,"querySelector"),e(HTMLElement.prototype,"querySelectorAll")}}(),"document"in self&&("classList"in document.createElement("_")&&(!document.createElementNS||"classList"in document.createElementNS("http://www.w3.org/2000/svg","g"))||function(e){if("Element"in e){var t="classList",n="prototype",r=e.Element[n],o=Object,i=String[n].trim||function(){return this.replace(/^\s+|\s+$/g,"")},a=Array[n].indexOf||function(e){for(var t=0,n=this.length;t<n;t++)if(t in this&&this[t]===e)return t;return-1},s=function s(e,t){this.name=e,this.code=DOMException[e],this.message=t},l=function l(e,t){if(""===t)throw new s("SYNTAX_ERR","The token must not be empty.");if(/\s/.test(t))throw new s("INVALID_CHARACTER_ERR","The token must not contain space characters.");return a.call(e,t)},c=function c(e){for(var t=i.call(e.getAttribute("class")||""),n=t?t.split(/\s+/):[],r=0,o=n.length;r<o;r++)this.push(n[r]);this._updateClassName=function(){e.setAttribute("class",this.toString())}},d=c[n]=[],f=function f(){return new c(this)};if(s[n]=Error[n],d.item=function(e){return this[e]||null},d.contains=function(e){return~l(this,e+"")},d.add=function(){for(var e,t=arguments,n=0,r=t.length,o=!1;e=t[n]+"",~l(this,e)||(this.push(e),o=!0),++n<r;);o&&this._updateClassName()},d.remove=function(){var e,t,n=arguments,r=0,o=n.length,i=!1;do{for(e=n[r]+"",t=l(this,e);~t;)this.splice(t,1),i=!0,t=l(this,e)}while(++r<o);i&&this._updateClassName()},d.toggle=function(e,t){var n=this.contains(e),r=n?!0!==t&&"remove":!1!==t&&"add";return r&&this[r](e),!0===t||!1===t?t:!n},d.replace=function(e,t){var n=l(e+"");~n&&(this.splice(n,1,t),this._updateClassName())},d.toString=function(){return this.join(" ")},o.defineProperty){var p={get:f,enumerable:!0,configurable:!0};try{o.defineProperty(r,t,p)}catch(u){void 0!==u.number&&-2146823252!==u.number||(p.enumerable=!1,o.defineProperty(r,t,p))}}else o[n].__defineGetter__&&r.__defineGetter__(t,f)}}(self),function(){var e=document.createElement("_");if(e.classList.add("c1","c2"),!e.classList.contains("c2")){var t=function Dg(e){var Dg=DOMTokenList.prototype[e];DOMTokenList.prototype[e]=function(e){var t,n=arguments.length;for(t=0;t<n;t++)e=arguments[t],Dg.call(this,e)}};t("add"),t("remove")}if(e.classList.toggle("c3",!1),e.classList.contains("c3")){var n=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(e,t){return 1 in arguments&&!this.contains(e)==!t?t:n.call(this,e)}}"replace"in document.createElement("_").classList||(DOMTokenList.prototype.replace=function(e,t){var n=this.toString().split(" "),r=n.indexOf(e+"");~r&&(n=n.slice(r),this.remove.apply(this,n),this.add(t),this.add.apply(this,n.slice(1)))}),e=null}()),function(){var e,t=-1;if("Microsoft Internet Explorer"===navigator.appName?(e=navigator.userAgent,null!==new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})").exec(e)&&(t=parseFloat(RegExp.$1))):"Netscape"===navigator.appName&&(e=navigator.userAgent,null!==new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})").exec(e)&&(t=parseFloat(RegExp.$1))),!("undefined"==typeof window||"undefined"==typeof document||"undefined"==typeof HTMLElement||t<0)){var n=!1;try{var r=document.createElement("div");r.addEventListener("focus",function(e){e.preventDefault(),e.stopPropagation()},!0),r.focus(Object.defineProperty({},"preventScroll",{get:function(){if(navigator&&"undefined"!=typeof navigator.userAgent&&navigator.userAgent&&navigator.userAgent.match(/Edge\/1[7-8]/))return n=!1;n=!0}}))}catch(s){}if(HTMLElement.prototype.nativeFocus===undefined&&!n){HTMLElement.prototype.nativeFocus=HTMLElement.prototype.focus;var o=function o(e){for(var t=e.parentNode,n=[],r=document.scrollingElement||document.documentElement;t&&t!==r;)(t.offsetHeight<t.scrollHeight||t.offsetWidth<t.scrollWidth)&&n.push([t,t.scrollTop,t.scrollLeft]),t=t.parentNode;return t=r,n.push([t,t.scrollTop,t.scrollLeft]),n},i=function i(e){for(var t=0;t<e.length;t++)e[t][0].scrollTop=e[t][1],e[t][0].scrollLeft=e[t][2];e=[]},a=function a(e){if(e&&e.preventScroll){var t=o(this);if("function"==typeof setTimeout){var n=this;setTimeout(function(){n.nativeFocus(),i(t)},0)}else this.nativeFocus(),i(t)}else this.nativeFocus()};HTMLElement.prototype.focus=a}}}();function H(e,t,n){if("string"!=typeof e)return new H.Bootstrap(e,t,n);var r=document.querySelectorAll(e);t&&t.iframe_document&&(r=t.iframe_document.querySelectorAll(e));for(var o=[],i=0;i<r.length;i++){var a=r[i]["data-froala.editor"];a?o.push(a):o.push(new H.Bootstrap(r[i],t,n))}return 1==o.length?o[0]:o}H.RegisterPlugins=function(e){for(var t=0;t<e.length;t++)e[t].call(H)},Object.assign(H,{DEFAULTS:{allowStylingOnNonEditable:!1,initOnClick:!1,pluginsEnabled:null,pluginsDisabled:null},MODULES:{},PLUGINS:{},VERSION:"4.5.2",INSTANCES:[],OPTS_MAPPING:{},SHARED:{},ID:0}),H.MODULES.node=function(a){var n=a.$;function s(e){return e&&"IFRAME"!==e.tagName?Array.prototype.slice.call(e.childNodes||[]):[]}function l(e){return!!e&&(e.nodeType===Node.ELEMENT_NODE&&0<=H.BLOCK_TAGS.indexOf(e.tagName.toLowerCase()))}function c(e){var t={},n=e.attributes;if(n)for(var r=0;r<n.length;r++){var o=n[r];t[o.nodeName]=o.value}return t}function t(e){for(var t="",n=c(e),r=Object.keys(n),o=0;o<r.length;o++){var i=r[o],a=n[i];a.indexOf("'")<0&&0<=a.indexOf('"')?t+=" ".concat(i,"='").concat(a,"'"):(0<=a.indexOf('"')&&0<=a.indexOf("'")&&(a=a.replace(/"/g,"&quot;")),t+=" ".concat(i,'="').concat(a,'"'))}return t}function r(e){return e===a.el}return{isBlock:l,isEmpty:function d(e,t){if(!e)return!0;if(e.querySelector("table"))return!1;var n=s(e);1===n.length&&l(n[0])&&(n=s(n[0]));for(var r=!1,o=0;o<n.length;o++){var i=n[o];if(!(t&&a.node.hasClass(i,"fr-marker")||i.nodeType===Node.TEXT_NODE&&0===i.textContent.length)){if("BR"!==i.tagName&&0<(i.textContent||"").replace(/\u200B/gi,"").replace(/\n/g,"").length)return!1;if(r)return!1;"BR"===i.tagName&&(r=!0)}}return!(e.querySelectorAll(H.VOID_ELEMENTS.join(",")).length-e.querySelectorAll("br").length||e.querySelector("".concat(a.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"),":not(.fr-marker)"))||1<e.querySelectorAll(H.BLOCK_TAGS.join(",")).length||e.querySelector("".concat(a.opts.htmlDoNotWrapTags.join(":not(.fr-marker),"),":not(.fr-marker)")))},blockParent:function o(e){for(;e&&e.parentNode!==a.el&&(!e.parentNode||!a.node.hasClass(e.parentNode,"fr-inner"));)if(l(e=e.parentNode))return e;return null},deepestParent:function i(e,t,n){if(void 0===t&&(t=[]),void 0===n&&(n=!0),t.push(a.el),0<=t.indexOf(e.parentNode)||e.parentNode&&a.node.hasClass(e.parentNode,"fr-inner")||e.parentNode&&0<=H.SIMPLE_ENTER_TAGS.indexOf(e.parentNode.tagName)&&n)return null;for(;t.indexOf(e.parentNode)<0&&e.parentNode&&!a.node.hasClass(e.parentNode,"fr-inner")&&(H.SIMPLE_ENTER_TAGS.indexOf(e.parentNode.tagName)<0||!n)&&(!l(e)||l(e.parentNode))&&(!l(e)||!l(e.parentNode)||!n);)e=e.parentNode;return e},rawAttributes:c,attributes:t,clearAttributes:function f(e){for(var t=e.attributes,n=t.length-1;0<=n;n--){var r=t[n];e.removeAttribute(r.nodeName)}},openTagString:function p(e){return"<".concat(e.tagName.toLowerCase()).concat(t(e),">")},closeTagString:function u(e){return"</".concat(e.tagName.toLowerCase(),">")},isFirstSibling:function h(e,t){void 0===t&&(t=!0);for(var n=e.previousSibling;n&&t&&a.node.hasClass(n,"fr-marker");)n=n.previousSibling;return!n||n.nodeType===Node.TEXT_NODE&&""===n.textContent&&h(n)},isLastSibling:function g(e,t){void 0===t&&(t=!0);for(var n=e.nextSibling;n&&t&&a.node.hasClass(n,"fr-marker");)n=n.nextSibling;return!n||n.nodeType===Node.TEXT_NODE&&""===n.textContent&&g(n)},isList:function C(e){return!!e&&0<=["UL","OL"].indexOf(e.tagName)},isLink:function m(e){return!!e&&e.nodeType===Node.ELEMENT_NODE&&"a"===e.tagName.toLowerCase()},isElement:r,contents:s,isVoid:function v(e){return e&&e.nodeType===Node.ELEMENT_NODE&&0<=H.VOID_ELEMENTS.indexOf((e.tagName||"").toLowerCase())},hasFocus:function b(e){return e===a.doc.activeElement&&(!a.doc.hasFocus||a.doc.hasFocus())&&Boolean(r(e)||e.type||e.href||~e.tabIndex)},isEditable:function L(e){return(!e.getAttribute||"false"!==e.getAttribute("contenteditable"))&&["STYLE","SCRIPT"].indexOf(e.tagName)<0},isDeletable:function E(e){return e&&e.nodeType===Node.ELEMENT_NODE&&e.getAttribute("class")&&0<=(e.getAttribute("class")||"").indexOf("fr-deletable")},hasClass:function y(e,t){return e instanceof n&&(e=e.get(0)),e&&e.classList&&e.classList.contains(t)},filter:function S(e){return a.browser.msie?e:{acceptNode:e}}}},Object.assign(H.DEFAULTS,{DOMPurify:window.DOMPurify,htmlAllowedTags:["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","br","button","canvas","caption","cite","code","col","colgroup","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meter","nav","noscript","object","ol","optgroup","option","output","p","param","pre","progress","queue","rp","rt","ruby","s","samp","script","style","section","select","small","source","span","strike","strong","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","var","video","wbr"],htmlRemoveTags:["script","style"],htmlAllowedAttrs:["accept","accept-charset","accesskey","action","align","allowfullscreen","allowtransparency","alt","async","autocomplete","autofocus","autoplay","autosave","background","bgcolor","border","charset","cellpadding","cellspacing","checked","cite","class","color","cols","colspan","content","contenteditable","contextmenu","controls","coords","data","data-.*","datetime","default","defer","dir","dirname","disabled","download","draggable","dropzone","enctype","for","form","formaction","frameborder","headers","height","hidden","high","href","hreflang","http-equiv","icon","id","ismap","itemprop","keytype","kind","label","lang","language","list","loop","low","max","maxlength","media","method","min","mozallowfullscreen","multiple","muted","name","novalidate","open","optimum","pattern","ping","placeholder","playsinline","poster","preload","pubdate","radiogroup","readonly","rel","required","reversed","rows","rowspan","sandbox","scope","scoped","scrolling","seamless","selected","shape","size","sizes","span","src","srcdoc","srclang","srcset","start","step","summary","spellcheck","style","tabindex","target","title","type","translate","usemap","value","valign","webkitallowfullscreen","width","wrap"],htmlAllowedStyleProps:[".*"],htmlAllowComments:!0,htmlUntouched:!1,preserveTabSpaces:!1,fullPage:!1}),H.HTML5Map={B:"STRONG",I:"EM",STRIKE:"S"},H.MODULES.clean=function(C){var m,v,b,L,f=C.$;function o(e){if(e.nodeType===Node.ELEMENT_NODE&&e.getAttribute("class")&&0<=e.getAttribute("class").indexOf("fr-marker"))return!1;var t,n=C.node.contents(e),r=[];for(t=0;t<n.length;t++)n[t].nodeType!==Node.ELEMENT_NODE||C.node.isVoid(n[t])?n[t].nodeType===Node.TEXT_NODE&&(n[t].textContent=n[t].textContent.replace(/\u200b/g,"")):n[t].textContent.replace(/\u200b/g,"").length!==n[t].textContent.length&&o(n[t]);if(e.nodeType===Node.ELEMENT_NODE&&!C.node.isVoid(e)&&(e.normalize(),n=C.node.contents(e),r=e.querySelectorAll(".fr-marker"),n.length-r.length==0)){for(t=0;t<n.length;t++)if(n[t].nodeType===Node.ELEMENT_NODE&&(n[t].getAttribute("class")||"").indexOf("fr-marker")<0)return!1;for(t=0;t<r.length;t++)e.parentNode.insertBefore(r[t].cloneNode(!0),e);return e.parentNode.removeChild(e),!1}}function s(e,t){if(e.nodeType===Node.COMMENT_NODE)return"\x3c!--".concat(e.nodeValue,"--\x3e");if(e.nodeType===Node.TEXT_NODE)return t?e.textContent.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"):C.opts.preserveTabSpaces?e.textContent.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\u00A0/g,"&nbsp;").replace(/\t/g," ".repeat(C.opts.tabSpaces)||" ".repeat(4)):e.textContent.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\u00A0/g,"&nbsp;").replace(/\t/g,"");if(e.nodeType!==Node.ELEMENT_NODE)return e.outerHTML;if(e.nodeType===Node.ELEMENT_NODE&&0<=["STYLE","SCRIPT","NOSCRIPT"].indexOf(e.tagName))return e.outerHTML;if(e.nodeType===Node.ELEMENT_NODE&&"svg"===e.tagName){var n=document.createElement("div"),r=e.cloneNode(!0);return n.appendChild(r),n.innerHTML}if("IFRAME"===e.tagName)return e.outerHTML.replace(/&lt;/g,"<").replace(/&gt;/g,">");var o=e.childNodes;if(0===o.length)return e.outerHTML;for(var i="",a=0;a<o.length;a++)"PRE"===e.tagName&&(t=!0),i+=s(o[a],t);return C.node.openTagString(e)+i+C.node.closeTagString(e)}var l=[];function E(e){var t=e.replace(/;;/gi,";");return";"!==(t=t.replace(/^;/gi,"")).charAt(t.length)&&(t+=";"),t}function c(e){var t;for(t in e)if(Object.prototype.hasOwnProperty.call(e,t)){var n=t.match(b),r=null;"style"===t&&C.opts.htmlAllowedStyleProps.length&&(r=e[t].match(L)),n&&r?e[t]=E(r.join(";")):n&&("style"!==t||r)||delete e[t]}for(var o="",i=Object.keys(e).sort(),a=0;a<i.length;a++)e[t=i[a]].indexOf('"')<0?o+=" ".concat(t,'="').concat(e[t],'"'):o+=" ".concat(t,"='").concat(e[t],"'");return o}function d(e,t){var n,r=document.implementation.createHTMLDocument("Froala DOC").createElement("DIV");f(r).append(e);var o="";if(r){var i=C.node.contents(r);for(n=0;n<i.length;n++)t(i[n]);for(i=C.node.contents(r),n=0;n<i.length;n++)o+=s(i[n])}return o}function p(e,t,n){var r=e=function i(e){return l=[],e=(e=(e=(e=e.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,function(e){return l.push(e),"[FROALA.EDITOR.SCRIPT ".concat(l.length-1,"]")})).replace(/<noscript\b[^<]*(?:(?!<\/noscript>)<[^<]*)*<\/noscript>/gi,function(e){return l.push(e),"[FROALA.EDITOR.NOSCRIPT ".concat(l.length-1,"]")})).replace(/<meta((?:[\w\W]*?)) http-equiv="/g,'<meta$1 data-fr-http-equiv="')).replace(/<img((?:[\w\W]*?)) src="/g,'<img$1 data-fr-src="')}(e),o=null;return C.opts.fullPage&&(r=C.html.extractNode(e,"body")||(0<=e.indexOf("<body")?"":e),n&&(o=C.html.extractNode(e,"head")||"")),r=d(r,t),o&&(o=d(o,t)),function a(e){return e=(e=(e=e.replace(/\[FROALA\.EDITOR\.SCRIPT ([\d]*)\]/gi,function(e,t){return 0<=C.opts.htmlRemoveTags.indexOf("script")?"":l[parseInt(t,10)]})).replace(/\[FROALA\.EDITOR\.NOSCRIPT ([\d]*)\]/gi,function(e,t){if(0<=C.opts.htmlRemoveTags.indexOf("noscript"))return"";var n=l[parseInt(t,10)].replace(/&lt;/g,"<").replace(/&gt;/g,">"),r=f(n);if(r&&r.length){var o=d(r.html(),u);r.html(o),n=r.get(0).outerHTML}return n})).replace(/<img((?:[\w\W]*?)) data-fr-src="/g,'<img$1 src="')}(function s(e,t,n){if(C.opts.fullPage){var r=C.html.extractDoctype(n),o=c(C.html.extractNodeAttrs(n,"html"));t=null===t?C.html.extractNode(n,"head")||"<title></title>":t;var i=c(C.html.extractNodeAttrs(n,"head")),a=c(C.html.extractNodeAttrs(n,"body"));return"".concat(r,"<html").concat(o,"><head").concat(i,">").concat(t,"</head><body").concat(a,">").concat(e,"</body></html>")}return e}(r,o,e))}function y(e){var t=C.doc.createElement("DIV");return t.innerText=e,t.textContent}function u(e){for(var t=C.node.contents(e),n=0;n<t.length;n++)t[n].nodeType!==Node.TEXT_NODE&&u(t[n]);!function g(n){if("SPAN"===n.tagName&&0<=(n.getAttribute("class")||"").indexOf("fr-marker"))return!1;if("PRE"===n.tagName&&function h(e){var t=e.innerHTML;0<=t.indexOf("\n")&&(e.innerHTML=t.replace(/\n/g,"<br>"))}(n),n.nodeType===Node.ELEMENT_NODE&&(n.getAttribute("data-fr-src")&&0!==n.getAttribute("data-fr-src").indexOf("blob:")&&n.setAttribute("data-fr-src",C.helpers.sanitizeURL(y(n.getAttribute("data-fr-src")))),n.getAttribute("href")&&n.setAttribute("href",C.helpers.sanitizeURL(y(n.getAttribute("href")))),n.getAttribute("src")&&n.setAttribute("src",C.helpers.sanitizeURL(y(n.getAttribute("src")))),n.getAttribute("srcdoc")&&n.setAttribute("srcdoc",C.clean.html(n.getAttribute("srcdoc"))),0<=["TABLE","TBODY","TFOOT","TR"].indexOf(n.tagName)&&(n.innerHTML=n.innerHTML.trim())),!C.opts.pasteAllowLocalImages&&n.nodeType===Node.ELEMENT_NODE&&"IMG"===n.tagName&&n.getAttribute("data-fr-src")&&0===n.getAttribute("data-fr-src").indexOf("file://"))return n.parentNode.removeChild(n),!1;if(n.nodeType===Node.ELEMENT_NODE&&H.HTML5Map[n.tagName]&&""===C.node.attributes(n)){var e=H.HTML5Map[n.tagName],t="<".concat(e,">").concat(n.innerHTML,"</").concat(e,">");n.insertAdjacentHTML("beforebegin",t),(n=n.previousSibling).parentNode.removeChild(n.nextSibling)}if(C.opts.htmlAllowComments||n.nodeType!==Node.COMMENT_NODE)if(n.tagName&&n.tagName.match(v)){if("STYLE"==n.tagName&&C.helpers.isMac()){var r,o=n.innerHTML.trim(),i=[],a=/{([^}]+)}/g;for(o=o.replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*|<!--[\s\S]*?-->$/,"");r=a.exec(o);)i.push(r[1]);for(var s=function s(t){var e=o.substring(0,o.indexOf("{")).trim();0==!/^[a-z_-][a-z\d_-]*$/i.test(e)&&n.parentNode.querySelectorAll(e).forEach(function(e){e.removeAttribute("class"),e.setAttribute("style",i[t])}),o=o.substring(o.indexOf("}")+1)},l=0;-1!=o.indexOf("{");l++)s(l)}n.parentNode.removeChild(n)}else if(n.tagName&&!n.tagName.match(m))"svg"===n.tagName?n.parentNode.removeChild(n):C.browser.safari&&"path"===n.tagName&&n.parentNode&&"svg"===n.parentNode.tagName||(n.outerHTML=n.innerHTML);else{var c=n.attributes;if(c)for(var d=c.length-1;0<=d;d--){var f=c[d],p=f.nodeName.match(b),u=null;"style"===f.nodeName&&C.opts.htmlAllowedStyleProps.length&&(u=f.value.match(L)),p&&u?f.value=E(u.join(";")):p&&("style"!==f.nodeName||u)||n.removeAttribute(f.nodeName)}}else 0!==n.data.indexOf("[FROALA.EDITOR")&&n.parentNode.removeChild(n)}(e)}return{_init:function e(){C.opts.fullPage&&f.merge(C.opts.htmlAllowedTags,["head","title","style","link","base","body","html","meta"])},html:function h(e,t,n,r){if(void 0===t&&(t=[]),void 0===n&&(n=[]),void 0===r&&(r=!1),0<=e.indexOf("<plaintext>")){e=e.replace(/<plaintext>/g,"").replace(/<\/plaintext>/g,"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\u00A0/g,"&nbsp;").replace(/\t/g,C.opts.preserveTabSpaces?" ".repeat(C.opts.tabSpaces||4):"");var o=C.html.defaultTag();C.opts.enter!=H.ENTER_BR&&(e="<".concat(o,">").concat(e,"</").concat(o,">"))}var i,a=f.merge([],C.opts.htmlAllowedTags);for(i=0;i<t.length;i++)0<=a.indexOf(t[i])&&a.splice(a.indexOf(t[i]),1);var s=f.merge([],C.opts.htmlAllowedAttrs);for(i=0;i<n.length;i++)0<=s.indexOf(n[i])&&s.splice(s.indexOf(n[i]),1);if(s.push("data-fr-.*"),s.push("fr-.*"),m=new RegExp("^".concat(a.join("$|^"),"$"),"gi"),b=new RegExp("^".concat(s.join("$|^"),"$"),"gi"),v=new RegExp("^".concat(C.opts.htmlRemoveTags.join("$|^"),"$"),"gi"),L=C.opts.htmlAllowedStyleProps.length?new RegExp("((^|;|\\s)".concat(C.opts.htmlAllowedStyleProps.join(":.+?(?=;|$))|((^|;|\\s)"),":.+?(?=(;)|$))"),"gi"):null,e=p(e,u,!0),"undefined"!=typeof C.opts.DOMPurify){var l={ALLOW_UNKNOWN_PROTOCOLS:!0};1===C.opts.htmlAllowedTags.length&&".*"===C.opts.htmlAllowedTags[0]||(l.ALLOWED_TAGS=C.opts.htmlAllowedTags),1===C.opts.htmlAllowedAttrs.length&&".*"===C.opts.htmlAllowedAttrs[0]||(l.ALLOWED_ATTR=C.opts.htmlAllowedAttrs),e=C.opts.DOMPurify.sanitize(e,l)}return e},toHTML5:function r(){var e=C.el.querySelectorAll(Object.keys(H.HTML5Map).join(","));if(e.length){var t=!1;C.el.querySelector(".fr-marker")||(C.selection.save(),t=!0);for(var n=0;n<e.length;n++)""===C.node.attributes(e[n])&&f(e[n]).replaceWith("<".concat(H.HTML5Map[e[n].tagName],">").concat(e[n].innerHTML,"</").concat(H.HTML5Map[e[n].tagName],">"));t&&C.selection.restore()}},tables:function t(){!function d(){for(var e=C.el.querySelectorAll("tr"),t=0,n=0;n<e.length;n++){var r=e[n].outerHTML.match(/rowspan="([0-9]+)"/);r&&(t+=Number(r[1])-1);for(var o=e[n].children,i=!0,a=0;a<o.length;a++)if("TH"!==o[a].tagName){i=!1;break}if(!1!==i&&0!==o.length)if(1===o.length&&"TH"===o[0].tagName&&t)t--;else{var s=e[n],l=s.closest("table");if(l){var c=l.querySelector("thead");c||(c=C.doc.createElement("THEAD"),l.insertBefore(c,l.firstChild)),c.contains(s)||c.appendChild(s)}}}}(),function s(){for(var e=C.$el.find("table[style]"),t=0;t<e.length;t++){var n=f(e[t]);n.attr("style").indexOf("width")<0&&n.css("width","100%")}for(var r=C.$el.find("td[width]"),o=0;o<r.length;o++){var i=f(r[o]),a=i.attr("width");a&&(i.css("width",a),i.removeAttr("width"))}}()},lists:function g(){!function s(){var e,t=[];do{if(t.length){var n=t[0],r=C.doc.createElement("ul");n.parentNode.insertBefore(r,n);do{var o=n;n=n.nextSibling,r.appendChild(o)}while(n&&"LI"===n.tagName)}t=[];for(var i=C.el.querySelectorAll("li"),a=0;a<i.length;a++)e=i[a],C.node.isList(e.parentNode)||t.push(i[a])}while(0<t.length)}(),function i(){for(var e=C.el.querySelectorAll("ol + ol, ul + ul"),t=0;t<e.length;t++){var n=e[t];if(C.node.isList(n.previousSibling)&&C.node.openTagString(n)===C.node.openTagString(n.previousSibling)){for(var r=C.node.contents(n),o=0;o<r.length;o++)n.previousSibling.appendChild(r[o]);n.parentNode.removeChild(n)}}}(),function a(){for(var e=C.el.querySelectorAll("ul, ol"),t=0;t<e.length;t++)for(var n=C.node.contents(e[t]),r=null,o=n.length-1;0<=o;o--)!n[o].tagName&&C.opts.htmlUntouched||"LI"===n[o].tagName||"UL"==n[o].tagName||"OL"==n[o].tagName?r=null:"BR"==n[o].tagName?f(n[o]).remove():(r||(r=f(C.doc.createElement("LI"))).insertBefore(n[o]),r.prepend(n[o]))}(),function l(){var e,t,n;do{t=!1;var r=C.el.querySelectorAll("li:empty");for(e=0;e<r.length;e++)r[e].parentNode.removeChild(r[e]);var o=C.el.querySelectorAll("ul, ol");for(e=0;e<o.length;e++)(n=o[e]).querySelector("LI")||(t=!0,n.parentNode.removeChild(n))}while(!0===t)}(),function o(){for(var e=C.el.querySelectorAll("ul > ul, ol > ol, ul > ol, ol > ul"),t=0;t<e.length;t++){var n=e[t],r=n.previousSibling;r&&("LI"===r.tagName?r.appendChild(n):f(n).wrap("<li></li>"))}}(),function c(){for(var e=C.el.querySelectorAll("li > ul, li > ol"),t=0;t<e.length;t++){var n=e[t];if(n.nextSibling)for(var r=n.nextSibling;0<r.childNodes.length;)n.append(r.childNodes[0])}}(),function d(){for(var e=C.el.querySelectorAll("li > ul, li > ol"),t=0;t<e.length;t++){var n=e[t];if(C.node.isFirstSibling(n)&&"none"!=n.parentNode.style.listStyleType)f(n).before("<br/>");else if(n.previousSibling&&"BR"===n.previousSibling.tagName){for(var r=n.previousSibling.previousSibling;r&&C.node.hasClass(r,"fr-marker");)r=r.previousSibling;r&&"BR"!==r.tagName&&f(n.previousSibling).remove()}}}(),function n(){for(var e=C.el.querySelectorAll("li:empty"),t=0;t<e.length;t++)f(e[t]).remove()}(),function r(){for(var e=C.el.querySelectorAll("ul, ol"),t=0;t<e.length;t++)for(var n=e[t],a=C.node.contents(n),s=function s(){var e=a[l],t=C.node.contents(e);if(e.nodeType!==Node.ELEMENT_NODE)return 0;var n=e.querySelectorAll("ul, ol");if(0<n.length&&1==t.length&&t[0].nodeType===Node.ELEMENT_NODE){var r=n[0],o=a[l-1];if(!o)return 0;var i=f(o).data("tracking")&&C.opts.trackChangesEnabled;N(r.querySelectorAll("li")).reverse().forEach(function(e){if(i){var t="pending-".concat(C.id,"-").concat(C.track_changes.getPendingChanges().length),n=C.opts.showChangesEnabled?'class="fr-highlight-change"':"",r=e.innerHTML;e.innerHTML='<span data-tracking="true" data-track-id="'.concat(t,'" ').concat(n,">").concat(r,"</span>"),C.track_changes.pushChange(t)}}),o.append(r),e.remove()}},l=0;l<a.length;l++)s()}()},invisibleSpaces:function n(e){return e.replace(/\u200b/g,"").length===e.length?e:C.clean.exec(e,o)},exec:p}},H.XS=0,H.SM=1,H.MD=2,H.LG=3;H.LinkRegExCommon="[".concat("a-z\\u0080-\\u009f\\u00a1-\\uffff0-9-_\\.","]{1,}"),H.LinkRegExEnd="((:[0-9]{1,5})|)(((\\/|\\?|#)[a-z\\u00a1-\\uffff0-9@?\\|!^=%&amp;\\/~+#-\\'*-_{}]*)|())",H.LinkRegExTLD="((".concat(H.LinkRegExCommon,")(\\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))"),H.LinkRegExHTTP="((ftp|http|https):\\/\\/".concat(H.LinkRegExCommon,")"),H.LinkRegExAuth="((ftp|http|https):\\/\\/[\\u0021-\\uffff]{1,}@".concat(H.LinkRegExCommon,")"),H.LinkRegExWWW="(www\\.".concat(H.LinkRegExCommon,"\\.[a-z0-9-]{2,24})"),H.LinkRegEx="(".concat(H.LinkRegExTLD,"|").concat(H.LinkRegExHTTP,"|").concat(H.LinkRegExWWW,"|").concat(H.LinkRegExAuth,")").concat(H.LinkRegExEnd),H.LinkProtocols=["mailto","tel","sms","notes","data"],H.MAIL_REGEX=/.+@.+\..+/i,H.MODULES.helpers=function(i){var a,s=i.$;function e(){var e={},t=function i(){var e,t=-1;return"Microsoft Internet Explorer"===navigator.appName?(e=navigator.userAgent,null!==new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})").exec(e)&&(t=parseFloat(RegExp.$1))):"Netscape"===navigator.appName&&(e=navigator.userAgent,null!==new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})").exec(e)&&(t=parseFloat(RegExp.$1))),t}();if(0<t)e.msie=!0;else{var n=navigator.userAgent.toLowerCase(),r=/(edge)[ /]([\w.]+)/.exec(n)||/(chrome)[ /]([\w.]+)/.exec(n)||/(webkit)[ /]([\w.]+)/.exec(n)||/(opera)(?:.*version|)[ /]([\w.]+)/.exec(n)||/(msie) ([\w.]+)/.exec(n)||n.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(n)||[],o=r[1]||"";r[2];r[1]&&(e[o]=!0),e.chrome?e.webkit=!0:e.webkit&&(e.safari=!0)}return e.msie&&(e.version=t),e}function t(){return(/(iPad|iPhone|iPod)/g.test(navigator.userAgent)||function e(){return navigator.maxTouchPoints&&2<navigator.maxTouchPoints&&/Macintosh/.test(navigator.userAgent)}())&&!o()}function n(){return/(Android)/g.test(navigator.userAgent)&&!o()}function r(){return/(Blackberry)/g.test(navigator.userAgent)}function o(){return/(Windows Phone)/gi.test(navigator.userAgent)}var l=null;return{_init:function c(){i.browser=e()},isIOS:t,isMac:function d(){return null===l&&(l=0<=navigator.platform.toUpperCase().indexOf("MAC")),l},getIOSVersion:function f(){if(t()){var e=navigator.userAgent.match(/OS (\d)?\d_\d(_\d)?/i)||navigator.userAgent.match(/\b[0-9]+_[0-9]+(?:_[0-9]+)?\b/);return e&&e.length&&Math.abs(e[0].split("_")[0].replace("OS ",""))||NaN}return NaN},getSafariVersion:function p(){var e=navigator.userAgent;if(-1!==e.indexOf("Safari")){var t=e.match(/Version\/(\d+\.\d+)/);if(t)return parseInt(t[1])}return null},isAndroid:n,isBlackberry:r,isWindowsPhone:o,isMobile:function u(){return n()||t()||r()},isEmail:function h(e){return!/^(https?:|ftps?:|)\/\//i.test(e)&&H.MAIL_REGEX.test(e)},requestAnimationFrame:function g(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(e){window.setTimeout(e,1e3/60)}},getPX:function C(e){return parseInt(e,10)||0},screenSize:function m(e){try{var t=0;if((t=e?i.$box.width():i.$sc.width())<768)return H.XS;if(768<=t&&t<992)return H.SM;if(992<=t&&t<1200)return H.MD;if(1200<=t)return H.LG}catch(n){return H.LG}},isTouch:function v(){return"ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch},sanitizeURL:function b(e){if(i.opts.DOMPurify){var t={ALLOW_UNKNOWN_PROTOCOLS:!0,ALLOWED_URI_REGEXP:/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|xxx):|[^a-z]|[a-z+.]+(?:[^a-z+.\-:]|$))/i};1===i.opts.htmlAllowedTags.length&&".*"===i.opts.htmlAllowedTags[0]||(t.ALLOWED_TAGS=i.opts.htmlAllowedTags),1===i.opts.htmlAllowedAttrs.length&&".*"===i.opts.htmlAllowedAttrs[0]||(t.ALLOWED_ATTR=i.opts.htmlAllowedAttrs),e=i.opts.DOMPurify.sanitize(e,t)}return e=e.replace(/(["'/]|\s+)on\w+=(?:"[^"]*"|'[^']*'|[^>\s]+)/gi,""),/^(https?:|ftps?:|)\/\//i.test(e)?e:/^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e)?e:new RegExp("^(".concat(H.LinkProtocols.join("|"),"):"),"i").test(e)?e:e=encodeURIComponent(e).replace(/%23/g,"#").replace(/%2F/g,"/").replace(/%25/g,"%").replace(/mailto%3A/gi,"mailto:").replace(/file%3A/gi,"file:").replace(/sms%3A/gi,"sms:").replace(/tel%3A/gi,"tel:").replace(/notes%3A/gi,"notes:").replace(/data%3Aimage/gi,"data:image").replace(/blob%3A/gi,"blob:").replace(/%3A(\d)/gi,":$1").replace(/webkit-fake-url%3A/gi,"webkit-fake-url:").replace(/%3F/g,"?").replace(/%3D/g,"=").replace(/%26/g,"&").replace(/&amp;/g,"&").replace(/%2C/g,",").replace(/%3B/g,";").replace(/%2B/g,"+").replace(/%40/g,"@").replace(/%5B/g,"[").replace(/%5D/g,"]").replace(/%7B/g,"{").replace(/%7D/g,"}").replace(/%[0-1]+[0-9]+|%[0-1]+[A-F]+/g,"")},isArray:function L(e){return e&&!Object.prototype.propertyIsEnumerable.call(e,"length")&&"object"===x(e)&&"number"==typeof e.length},RGBToHex:function E(e){function t(e){return"0".concat(parseInt(e,10).toString(16)).slice(-2)}try{if(!e||"transparent"===e)return"";if(/^#[0-9A-F]{6}$/i.test(e)||/^#[0-9A-F]{8}$/i.test(e))return e.toUpperCase();var n=e.match(/^rgb\(\s*(\d+),\s*(\d+),\s*(\d+)\s*\)$/i);if(n)return"#".concat(t(n[1])).concat(t(n[2])).concat(t(n[3])).toUpperCase();if(n=e.match(/^rgba\(\s*(\d+),\s*(\d+),\s*(\d+),\s*(\d*\.?\d+)\s*\)$/i))return"#".concat(t(n[1])).concat(t(n[2])).concat(t(n[3])).concat(t(Math.round(255*parseFloat(n[4])))).toUpperCase()}catch(r){return null}},HEXtoRGB:function y(e){if(e=e.replace(/^#/,""),/^rgba?\(\d+,\s*\d+,\s*\d+(,\s*(0|1|0?\.\d+))?\)$/i.test(e))return e;if(3!==e.length&&4!==e.length||(e=e.split("").map(function(e){return e+e}).join("")),6===e.length){var t=/^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);return t?"rgb(".concat(parseInt(t[1],16),", ").concat(parseInt(t[2],16),", ").concat(parseInt(t[3],16),")"):""}if(8===e.length){var n=/^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);if(n){var r=parseInt(n[1],16),o=parseInt(n[2],16),i=parseInt(n[3],16),a=parseInt(n[4],16)/255;return"rgba(".concat(r,", ").concat(o,", ").concat(i,", ").concat(a.toFixed(2),")")}}return""},isURL:function S(e){return!!/^(https?:|ftps?:|)\/\//i.test(e)&&(e=String(e).replace(/</g,"%3C").replace(/>/g,"%3E").replace(/"/g,"%22").replace(/ /g,"%20"),new RegExp("^".concat(H.LinkRegExHTTP).concat(H.LinkRegExEnd,"$"),"gi").test(e))},getAlignment:function N(e){e.css||(e=s(e));var t=(e.css("text-align")||"").replace(/-(.*)-/g,"");if(["left","right","justify","center"].indexOf(t)<0){if(!a){var n=s('<div dir="'.concat("rtl"===i.opts.direction?"rtl":"auto",'" style="text-align: ').concat(i.$el.css("text-align"),'; position: fixed; left: -3000px;"><span id="s1">.</span><span id="s2">.</span></div>'));s("body").first().append(n);var r=n.find("#s1").get(0).getBoundingClientRect().left,o=n.find("#s2").get(0).getBoundingClientRect().left;n.remove(),a=r<o?"left":"right"}t=a}return t},scrollTop:function T(){return i.o_win.pageYOffset?i.o_win.pageYOffset:i.o_doc.documentElement&&i.o_doc.documentElement.scrollTop?i.o_doc.documentElement.scrollTop:i.o_doc.body.scrollTop?i.o_doc.body.scrollTop:0},scrollLeft:function M(){return i.o_win.pageXOffset?i.o_win.pageXOffset:i.o_doc.documentElement&&i.o_doc.documentElement.scrollLeft?i.o_doc.documentElement.scrollLeft:i.o_doc.body.scrollLeft?i.o_doc.body.scrollLeft:0},isInViewPort:function A(e){var t=e.getBoundingClientRect();return 0<=(t={top:Math.round(t.top),bottom:Math.round(t.bottom)}).top&&t.bottom<=(window.innerHeight||document.documentElement.clientHeight)||t.top<=0&&t.bottom>=(window.innerHeight||document.documentElement.clientHeight)}}},H.MODULES.events=function(l){var e,i=l.$,a={};function s(e,t,n){C(e,t,n)}function c(e){if(void 0===e&&(e=!0),!l.$wp)return!1;if(l.helpers.isIOS()&&l.$win.get(0).focus(),l.core.hasFocus())return!1;if(!l.core.hasFocus()&&e){var t=l.$win.scrollTop();if(l.browser.msie&&l.$box&&l.$box.css("position","fixed"),l.browser.msie&&l.$wp&&l.$wp.css("overflow","visible"),l.browser.msie&&l.$sc&&l.$sc.css("position","fixed"),l.browser.msie||(p(),l.el.focus(),l.events.trigger("focus"),f()),l.browser.msie&&l.$sc&&l.$sc.css("position",""),l.browser.msie&&l.$box&&l.$box.css("position",""),l.browser.msie&&l.$wp&&l.$wp.css("overflow","auto"),t!==l.$win.scrollTop()&&l.$win.scrollTop(t),!l.selection.info(l.el).atStart)return!1}if(!l.core.hasFocus()||0<l.$el.find(".fr-marker").length)return!1;if(l.selection.info(l.el).atStart&&l.selection.isCollapsed()&&null!==l.html.defaultTag()){var n=l.markers.insert();if(n&&!l.node.blockParent(n)){i(n).remove();var r=l.$el.find(l.html.blockTagsQuery()).get(0);r&&(i(r).prepend(H.MARKERS),l.selection.restore())}else n&&i(n).remove()}}var d=!1;function f(){e=!0}function p(){e=!1}function u(){return e}function h(e,t,n){var r,o=e.split(" ");if(1<o.length){for(var i=0;i<o.length;i++)h(o[i],t,n);return!0}void 0===n&&(n=!1),r=0!==e.indexOf("shared.")?(a[e]=a[e]||[],a[e]):(l.shared._events[e]=l.shared._events[e]||[],l.shared._events[e]),n?r.unshift(t):r.push(t)}var g=[];function C(e,t,n,r,o){"function"==typeof n&&(o=r,r=n,n=!1);var i=o?l.shared.$_events:g,a=o?l.sid:l.id,s="".concat(t.trim().split(" ").join(".ed".concat(a," ")),".ed").concat(a);n?e.on(s,n,r):e.on(s,r),i.push([e,s])}function t(e){for(var t=0;t<e.length;t++)e[t][0].off(e[t][1])}function m(e,t,n){if(!l.edit.isDisabled()||n){var r,o;if(0!==e.indexOf("shared."))r=a[e];else{if(0<l.shared.count)return!1;r=l.shared._events[e]}if(r)for(var i=0;i<r.length;i++)if(!1===(o=r[i].apply(l,t)))return!1;return(!l.opts.events||!l.opts.events[e]||!1!==(o=l.opts.events[e].apply(l,t)))&&o}}function v(){for(var e in a)Object.prototype.hasOwnProperty.call(a,e)&&delete a[e]}function b(){for(var e in l.shared._events)Object.prototype.hasOwnProperty.call(l.shared._events,e)&&delete l.shared._events[e]}return{_init:function L(){l.shared.$_events=l.shared.$_events||[],l.shared._events={},function e(){l.helpers.isMobile()?(l._mousedown="touchstart",l._mouseup="touchend",l._move="touchmove",l._mousemove="touchmove"):(l._mousedown="mousedown",l._mouseup="mouseup",l._move="",l._mousemove="mousemove")}(),function t(){s(l.$el,"click mouseup mousemove mousedown touchstart touchend dragenter dragover dragleave dragend drop dragstart",function(e){m(e.type,[e])}),h("mousedown",function(){for(var e=0;e<H.INSTANCES.length;e++)H.INSTANCES[e]!==l&&H.INSTANCES[e].popups&&H.INSTANCES[e].popups.areVisible()&&H.INSTANCES[e].$el.find(".fr-marker").remove()})}(),function n(){s(l.$win,l._mousedown,function(e){m("window.mousedown",[e]),f()}),s(l.$win,l._mouseup,function(e){m("window.mouseup",[e])}),s(l.$win,"beforeinput cut copy keydown keyup touchmove touchend",function(e){m("window.".concat(e.type),[e])})}(),function r(){s(l.$doc,"dragend drop",function(e){m("document.".concat(e.type),[e])})}(),function o(){s(l.$el,"beforeinput keydown keypress keyup input",function(e){m(e.type,[e])})}(),function i(){s(l.$el,"focus",function(e){u()&&(c(!1),!1===d&&(m(e.type,[e]),l.helpers.isMobile()&&p()))}),s(l.$el,"blur",function(e){u()&&!0===d&&(m(e.type,[e]),l.helpers.isMobile()&&l.opts.toolbarContainer&&(l.shared.selected_editor=l.id),f())}),C(l.$el,"mousedown",'[contenteditable="true"]',function(){p(),l.$el.blur()}),h("focus",function(){d=!0}),h("blur",function(){d=!1})}(),f(),function a(){s(l.$el,"cut copy paste beforepaste",function(e){m(e.type,[e])})}(),h("destroy",v),h("shared.destroy",b)},on:h,trigger:m,bindClick:function r(e,t,n){C(e,l._mousedown,t,function(e){l.edit.isDisabled()||function n(e){var t=i(e.currentTarget);return l.edit.isDisabled()||l.node.hasClass(t.get(0),"fr-disabled")?(e.preventDefault(),!1):"mousedown"===e.type&&1!==e.which||(l.helpers.isMobile()||e.preventDefault(),(l.helpers.isAndroid()||l.helpers.isWindowsPhone())&&0===t.parents(".fr-dropdown-menu").length&&(e.preventDefault(),e.stopPropagation()),t.addClass("fr-selected"),void l.events.trigger("commands.mousedown",[t]))}(e)},!0),C(e,"".concat(l._mouseup," ").concat(l._move),t,function(e){l.edit.isDisabled()||(l.helpers.isIOS()&&null!==l.selection.get().focusNode&&l.selection.save(),function o(e,t){var n=i(e.currentTarget);if(l.edit.isDisabled()||l.node.hasClass(n.get(0),"fr-disabled"))return e.preventDefault(),!1;if("mouseup"===e.type&&1!==e.which)return!0;if(l.button.getButtons(".fr-selected",!0).get(0)==n.get(0)&&!l.node.hasClass(n.get(0),"fr-selected"))return!0;if("touchmove"!==e.type){if(e.stopPropagation(),e.stopImmediatePropagation(),e.preventDefault(),!l.node.hasClass(n.get(0),"fr-selected"))return l.button.getButtons(".fr-selected",!0).removeClass("fr-selected"),!1;if(l.button.getButtons(".fr-selected",!0).removeClass("fr-selected"),n.data("dragging")||n.attr("disabled"))return n.removeData("dragging"),!1;var r=n.data("timeout");r&&(clearTimeout(r),n.removeData("timeout")),t.apply(l,[e])}else n.data("timeout")||n.data("timeout",setTimeout(function(){n.data("dragging",!0)},100))}(e,n))},!0),C(e,"mousedown click mouseup",t,function(e){l.edit.isDisabled()||e.stopPropagation()},!0),h("window.mouseup",function(){l.edit.isDisabled()||(e.find(t).removeClass("fr-selected"),f())}),C(e,"mouseover",t,function(){i(this).hasClass("fr-options")&&i(this).prev(".fr-btn").addClass("fr-btn-hover"),i(this).next(".fr-btn").hasClass("fr-options")&&i(this).next(".fr-btn").addClass("fr-btn-hover")}),C(e,"mouseout",t,function(){i(this).hasClass("fr-options")&&i(this).prev(".fr-btn").removeClass("fr-btn-hover"),i(this).next(".fr-btn").hasClass("fr-options")&&i(this).next(".fr-btn").removeClass("fr-btn-hover")})},disableBlur:p,enableBlur:f,blurActive:u,focus:c,chainTrigger:function E(e,t,n){if(!l.edit.isDisabled()||n){var r,o;if(0!==e.indexOf("shared."))r=a[e];else{if(0<l.shared.count)return!1;r=l.shared._events[e]}if(r)for(var i=0;i<r.length;i++)void 0!==(o=r[i].apply(l,[t]))&&(t=o);return l.opts.events&&l.opts.events[e]&&void 0!==(o=l.opts.events[e].apply(l,[t]))&&(t=o),t}},$on:C,$off:function n(){t(g),g=[],0===l.shared.count&&(t(l.shared.$_events),l.shared.$_events=[])}}},Object.assign(H.DEFAULTS,{indentMargin:20}),H.COMMANDS={bold:{title:"Bold",toggle:!0,refresh:function(e){var t=this.format.is("strong");e.toggleClass("fr-active",t).attr("aria-pressed",t)}},italic:{title:"Italic",toggle:!0,refresh:function(e){var t=this.format.is("em");e.toggleClass("fr-active",t).attr("aria-pressed",t)}},underline:{title:"Underline",toggle:!0,refresh:function(e){var t=this.format.is("u");e.toggleClass("fr-active",t).attr("aria-pressed",t)}},strikeThrough:{title:"Strikethrough",toggle:!0,refresh:function(e){var t=this.format.is("s");e.toggleClass("fr-active",t).attr("aria-pressed",t)}},subscript:{title:"Subscript",toggle:!0,refresh:function(e){var t=this.format.is("sub");e.toggleClass("fr-active",t).attr("aria-pressed",t)}},superscript:{title:"Superscript",toggle:!0,refresh:function(e){var t=this.format.is("sup");e.toggleClass("fr-active",t).attr("aria-pressed",t)}},outdent:{title:"Decrease Indent"},indent:{title:"Increase Indent"},undo:{title:"Undo",undo:!1,forcedRefresh:!0,disabled:!0},redo:{title:"Redo",undo:!1,forcedRefresh:!0,disabled:!0},insertHR:{title:"Insert Horizontal Line"},clearFormatting:{title:"Clear Formatting"},selectAll:{title:"Select All",undo:!1},moreText:{title:"More Text",undo:!1},moreParagraph:{title:"More Paragraph",undo:!1},moreRich:{title:"More Rich",undo:!1},moreMisc:{title:"More Misc",undo:!1}},H.RegisterCommand=function(e,t){H.COMMANDS[e]=t},H.MODULES.commands=function(f){var p=f.$;function a(e){return f.html.defaultTag()&&(e="<".concat(f.html.defaultTag(),">").concat(e,"</").concat(f.html.defaultTag(),">")),e}var s={bold:function(){e("bold","strong")},subscript:function(){f.format.is("sup")&&f.format.remove("sup"),e("subscript","sub")},superscript:function(){f.format.is("sub")&&f.format.remove("sub"),e("superscript","sup")},italic:function(){e("italic","em")},strikeThrough:function(){e("strikeThrough","s")},underline:function(){e("underline","u")},undo:function(){f.undo.run()},redo:function(){f.undo.redo()},indent:function(){r(1)},outdent:function(){r(-1)},show:function(){f.opts.toolbarInline&&f.toolbar.showInline(null,!0)},insertHR:function(){f.selection.remove();var e="";f.core.isEmpty()&&(e=a(e="<br>"));var t='<hr id="fr-just" class="fr-just">'.concat(e);f.opts.trackChangesEnabled&&(t=f.track_changes.wrapInTracking(p(t),"hrWrapper").get(0).outerHTML);f.html.insert(t);var n,r=f.$el.find("hr#fr-just").length?f.$el.find("hr#fr-just"):f.$el.find(".fr-just");r.removeAttr("id"),r.removeAttr("class");var o=f.opts.trackChangesEnabled&&"SPAN"===r[0].parentNode.tagName&&"P"===r[0].parentNode.parentNode.tagName;if(0===r.next().length){var i=f.html.defaultTag();i&&!o?r.after(p(f.doc.createElement(i)).append("<br>").get(0)):o?r[0].parentNode.after(p(f.doc.createElement(i)).append("<br>").get(0)):r.after("<br>")}r.prev().is("hr")?n=f.selection.setAfter(r.get(0),!1):r.next().is("hr")?n=f.selection.setBefore(r.get(0),!1):o||f.selection.setAfter(r.get(0),!1)?f.selection.setAfter(r[0].parentNode,!1):f.selection.setBefore(r.get(0),!1),n||void 0===n||(e=a(e="".concat(H.MARKERS,"<br>")),r.after(e)),f.selection.restore()},clearFormatting:function(){f.format.remove()},selectAll:function(){f.doc.execCommand("selectAll",!1,!1),function d(){var e=null,t=null,n=null,r=null,o=!0===f.opts.iframe,i=p(".fr-iframe")[0],a=o?p(i.contentWindow.document.body):f.$el;if(o&&i){var s=i.contentWindow;n=s.document.createRange.bind(s.document),r=s.getSelection()}else n=document.createRange.bind(document),r=window.getSelection();if(f.selection.isCollapsed()){r.removeAllRanges();var l=a.contents();if(e=l.first()[0],t=l.last()[0],e&&t){var c=n();c.setStart(e,0),c.setEnd(t,t.nodeType===Node.TEXT_NODE?t.textContent.length:t.childNodes.length),r.addRange(c),f.selection.save()}}}()},moreText:function(e){t(e)},moreParagraph:function(e){t(e)},moreRich:function(e){t(e)},moreMisc:function(e){t(e)},moreTrackChanges:function(){t("trackChanges")}};function t(e){var t=f.$tb.find("[data-cmd=".concat(e,"]")),n=f.$tb.find("[data-cmd=html]");f.opts.trackChangesEnabled||f.markdown&&f.markdown.isEnabled()?n&&n.addClass("fr-disabled"):n&&n.removeClass("fr-disabled"),function r(n){f.helpers.isMobile()&&f.opts.toolbarInline&&f.events.disableBlur();var e=f.$tb.find('.fr-more-toolbar[data-name="'.concat(n.attr("data-group-name"),'"]'));"trackChanges"===n.data("cmd")&&(e=f.$tb.find('.fr-more-toolbar[data-name="'.concat(n.attr("id"),'"]')));if(f.$tb.find(".fr-open").not(n).not('[data-cmd="trackChanges"]').removeClass("fr-open"),n.toggleClass("fr-open"),f.$tb.find(".fr-more-toolbar").removeClass("fr-overflow-visible"),f.$tb.find(".fr-expanded").not(e).length){var t=f.$tb.find(".fr-expanded").not(e);t.each(function(e,t){0!=p(t).data("name").indexOf("trackChanges-")&&0!=p(t).data("name").indexOf("moreRich-")?p(t).toggleClass("fr-expanded"):n.parents('[data-name^="moreRich-"]').length||0==p(t).data("name").indexOf("trackChanges-")||p(t).find('[id^="trackChanges-"]').length&&f.opts.trackChangesEnabled||p(t).toggleClass("fr-expanded")}),e.toggleClass("fr-expanded")}else e.toggleClass("fr-expanded"),f.$box.toggleClass("fr-toolbar-open"),f.$tb.toggleClass("fr-toolbar-open")}(t),f.toolbar.setMoreToolbarsHeight()}function n(e,t){if(!(f.markdown&&f.markdown.isEnabled()&&("bold"===e||"italic"===e||"underline"===e)||f.opts.trackChangesEnabled&&"markdown"===e)&&!1!==f.events.trigger("commands.before",p.merge([e],t||[]))){var n=H.COMMANDS[e]&&H.COMMANDS[e].callback||s[e],r=!0,o=!1;if(H.COMMANDS[e]&&("undefined"!=typeof H.COMMANDS[e].focus&&(r=H.COMMANDS[e].focus),"undefined"!=typeof H.COMMANDS[e].accessibilityFocus&&(o=H.COMMANDS[e].accessibilityFocus)),!f.core.hasFocus()&&r||!f.core.hasFocus()&&o&&f.accessibility.hasFocus()){var i=f.selection.ranges()[0];f.opts.allowStylingOnNonEditable&&i&&p(i.startContainer).parentsUntil(f.$el,'[contenteditable="false"]').length&&f.selection.save(),f.el.focus({preventScroll:!0}),f.events.trigger("focus")}H.COMMANDS[e]&&!1!==H.COMMANDS[e].undo&&(f.$el.find(".fr-marker").length&&(f.events.disableBlur(),f.selection.restore()),f.undo.saveStep()),n&&n.apply(f,p.merge([e],t||[])),f.events.trigger("commands.after",p.merge([e],t||[])),H.COMMANDS[e]&&!1!==H.COMMANDS[e].undo&&f.undo.saveStep()}}function e(e,t){f.format.toggle(t)}function r(e){f.selection.save(),f.html.wrap(!0,!0,!0,!0),f.selection.restore();for(var t=f.selection.blocks(),n=0;n<t.length;n++)if("LI"!==t[n].tagName&&"LI"!=t[n].parentNode.tagName&&("LI"!==t[n].tagName||"LI"!==t[n].parentNode.tagName)){var r=p(t[n]);"LI"!=t[n].tagName&&"LI"==t[n].parentNode.tagName&&(r=p(t[n].parentNode));var o="rtl"===f.opts.direction||"rtl"===r.css("direction")?"margin-right":"margin-left",i=f.helpers.getPX(r.css(o)),a=f.helpers.getPX(r.css("text-indent"));if(r.width()<2*f.opts.indentMargin&&0<e||i+a<=0&&e<0)continue;"UL"!=t[n].parentNode.tagName&&"OL"!=t[n].parentNode.tagName&&"LI"!=t[n].parentNode.tagName&&r.css(o,Math.max(i+e*f.opts.indentMargin,0)||""),r.removeClass("fr-temp-div")}f.selection.save(),f.html.unwrap(),f.selection.restore()}function o(e){return function(){n(e)}}var i={};for(var l in s)Object.prototype.hasOwnProperty.call(s,l)&&(i[l]=o(l));return Object.assign(i,{exec:n,_init:function c(){f.events.on("keydown",function(e){var t=f.selection.element();if((e.ctrlKey||e.metaKey)&&"a"===e.key&&(e.preventDefault(),n("selectAll")),t&&"HR"===t.tagName&&!f.keys.isArrow(e.which))return e.preventDefault(),!1}),f.events.on("keyup",function(e){var t=f.selection.element();if(t&&"HR"===t.tagName)if(e.which===H.KEYCODE.ARROW_LEFT||e.which===H.KEYCODE.ARROW_UP){if(t.previousSibling)return f.node.isBlock(t.previousSibling)?f.selection.setAtEnd(t.previousSibling):p(t).before(H.MARKERS),f.selection.restore(),!1}else if((e.which===H.KEYCODE.ARROW_RIGHT||e.which===H.KEYCODE.ARROW_DOWN)&&t.nextSibling)return f.node.isBlock(t.nextSibling)?f.selection.setAtStart(t.nextSibling):p(t).after(H.MARKERS),f.selection.restore(),!1}),f.events.on("mousedown",function(e){if(e.target&&"HR"===e.target.tagName)return e.preventDefault(),e.stopPropagation(),!1}),f.events.on("mouseup",function(){var e=f.selection.element();e===f.selection.endElement()&&e&&"HR"===e.tagName&&(e.nextSibling&&(f.node.isBlock(e.nextSibling)?f.selection.setAtStart(e.nextSibling):p(e).after(H.MARKERS)),f.selection.restore())})}})},H.MODULES.cursorLists=function(v){var b=v.$;function L(e){for(var t=e;"LI"!==t.tagName;)t=t.parentNode;return t}function E(e){for(var t=e;!v.node.isList(t);)t=t.parentNode;return t}function y(e){for(var t="",n=0;n<e.length;n++){var r=e[n];t+="".concat(r.name,"='").concat(r.value,"' ")}return t}return{_startEnter:function S(e){var t,n=L(e),r=n.nextSibling,o=n.previousSibling,i=v.html.defaultTag();if(v.node.isEmpty(n,!0)&&r){for(var a="",s="",l=e.parentNode;!v.node.isList(l)&&l.parentNode&&("LI"!==l.parentNode.tagName||l.parentNode===n);)-1<["OL","LI","UL"].indexOf(l.tagName)&&(a=v.node.openTagString(l)+a,s+=v.node.closeTagString(l)),l=l.parentNode;a=v.node.openTagString(l)+a,s+=v.node.closeTagString(l);var c="";if(l.parentNode&&"LI"===l.parentNode.tagName)if(l.parentNode.attributes.length){var d=y(l.parentNode.attributes);c="".concat(s,"<li ").concat(d,">").concat(H.MARKERS,"<br>").concat(a)}else c="".concat(s,"<li>").concat(H.MARKERS,"<br>").concat(a);else c=i?"".concat(s,"<").concat(i,">").concat(H.MARKERS,"<br></").concat(i,">").concat(a):"".concat(s+H.MARKERS,"<br>").concat(a);for(;["UL","OL"].indexOf(l.tagName)<0||l.parentNode&&"LI"===l.parentNode.tagName;)l=l.parentNode;b(n).replaceWith('<span id="fr-break"></span>');var f=v.node.openTagString(l)+b(l).html()+v.node.closeTagString(l);f=f.replace(/<span id="fr-break"><\/span>/g,c),b(l).replaceWith(f),v.$el.find("li:empty").remove(),v.$el.find("li > p > span:empty").length&&v.$el.find("li > p > span:empty")[0].parentNode.parentNode.remove()}else if(o&&r||!v.node.isEmpty(n,!0)){var p="<br>",u=e.parentNode;for(u&&"A"===u.tagName&&(u=null);u&&"LI"!==u.tagName;)p=v.node.openTagString(u)+p+v.node.closeTagString(u),u=u.parentNode;if(u&&u.attributes.length){var h=y(u.attributes);b(n).before("<li ".concat(h,">").concat(p,"</li>"))}else b(n).before("<li>".concat(p,"</li>"));b(e).remove()}else if(o){t=E(n);for(var g="".concat(H.MARKERS,"<br>"),C=e.parentNode;C&&"LI"!==C.tagName;)g=v.node.openTagString(C)+g+v.node.closeTagString(C),C=C.parentNode;if(t.parentNode&&"LI"===t.parentNode.tagName)if(t.parentNode.attributes.length){var m=y(t.parentNode.attributes);b(t.parentNode).after("<li ".concat(m,">").concat(g,"</li>"))}else b(t.parentNode).after("<li>".concat(g,"</li>"));else i?b(t).after("<".concat(i,">").concat(g,"</").concat(i,">")):b(t).after(g);b(n).remove()}else(t=E(n)).parentNode&&"LI"===t.parentNode.tagName?r?b(t.parentNode).before("".concat(v.node.openTagString(n)+H.MARKERS,"<br></li>")):b(t.parentNode).after("".concat(v.node.openTagString(n)+H.MARKERS,"<br></li>")):i?b(t).before("<".concat(i,">").concat(H.MARKERS,"<br></").concat(i,">")):b(t).before("".concat(H.MARKERS,"<br>")),b(n).remove()},_middleEnter:function c(e){for(var t=L(e),n="",r=e,o="",i="",a=!1;r!==t;){var s="A"===(r=r.parentNode).tagName&&v.cursor.isAtEnd(e,r)?"fr-to-remove":"";a||r==t||v.node.isBlock(r)||(a=!0,o+=H.INVISIBLE_SPACE),o=v.node.openTagString(b(r).clone().addClass(s).get(0))+o,i+=v.node.closeTagString(r)}n=i+n+o+H.MARKERS+(v.opts.keepFormatOnDelete?H.INVISIBLE_SPACE:""),b(e).replaceWith('<span id="fr-break"></span>');var l=v.node.openTagString(t)+b(t).html()+v.node.closeTagString(t);l=l.replace(/<span id="fr-break"><\/span>/g,n),b(t).replaceWith(l)},_endEnter:function l(e){for(var t=L(e),n=H.MARKERS,r="",o=e,i=!1;o!==t;)if(!(o=o.parentNode).classList.contains("fr-img-space-wrap")&&!o.classList.contains("fr-img-space-wrap2")){var a="A"===o.tagName&&v.cursor.isAtEnd(e,o)?"fr-to-remove":"";i||o===t||v.node.isBlock(o)||(i=!0,r+=H.INVISIBLE_SPACE),r=v.node.openTagString(b(o).clone().addClass(a).get(0))+r,n+=v.node.closeTagString(o)}var s=r+n;b(e).remove(),b(t).after(s)},_backspace:function u(e){var t=L(e),n=t.previousSibling;if(n){var r=b(n).children().last(),o=r[0]&&r[0].tagName?r[0].tagName:"",i="P"===o,a=0<b(n).find("table").length;["TABLE","TBODY","TR","TD","TH"].includes(o)||a&&i||(n=b(n).find(v.html.blockTagsQuery()).get(-1)||n),b(e).replaceWith(H.MARKERS);var s=v.node.contents(n);s.length&&"BR"===s[s.length-1].tagName&&b(s[s.length-1]).remove(),b(t).find(v.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode===t&&b(this).replaceWith(b(this).html()+(v.node.isEmpty(this)?"":"<br>"))});for(var l,c=v.node.contents(t)[0];c&&!v.node.isList(c);)l=c.nextSibling,b(n).append(c),c=l;for(n=t.previousSibling;c;)l=c.nextSibling,b(n).append(c),c=l;1<(s=v.node.contents(n)).length&&"BR"===s[s.length-1].tagName&&b(s[s.length-1]).remove(),b(t).remove()}else{var d=E(t);if(b(e).replaceWith(H.MARKERS),d.parentNode&&"LI"===d.parentNode.tagName){var f=d.previousSibling;v.node.isBlock(f)?(b(t).find(v.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode===t&&b(this).replaceWith(b(this).html()+(v.node.isEmpty(this)?"":"<br>"))}),b(f).append(b(t).html())):b(d).before(b(t).html())}else{var p=v.html.defaultTag();p&&0===b(t).find(v.html.blockTagsQuery()).length?b(d).before("<".concat(p,">").concat(b(t).html(),"</").concat(p,">")):b(d).before(b(t).html())}b(t).remove(),v.html.wrap(),0===b(d).find("li").length&&b(d).remove()}},_del:function d(e){var t,n=L(e),r=n.nextSibling;if(r){(t=v.node.contents(r)).length&&"BR"===t[0].tagName&&b(t[0]).remove(),b(r).find(v.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode===r&&b(this).replaceWith(b(this).html()+(v.node.isEmpty(this)?"":"<br>"))});for(var o,i=e,a=v.node.contents(r)[0];a&&!v.node.isList(a);)o=a.nextSibling,b(i).after(a),i=a,a=o;for(;a;)o=a.nextSibling,b(n).append(a),a=o;b(e).replaceWith(H.MARKERS),b(r).remove()}else{for(var s=n;!s.nextSibling&&s!==v.el;)s=s.parentNode;if(s===v.el)return!1;if(s=s.nextSibling,v.node.isBlock(s)){if(H.NO_DELETE_TAGS.indexOf(s.tagName)<0){if(b(e).replaceWith(H.MARKERS),(t=v.node.contents(n)).length&&"BR"===t[t.length-1].tagName&&b(t[t.length-1]).remove(),s.isContentEditable&&"DIV"===s.tagName&&(!v.node.isBlock(s.previousSibling)||"DIV"===s.previousSibling.tagName))return;b(n).append(b(s).html()),b(s).remove()}}else{for((t=v.node.contents(n)).length&&"BR"===t[t.length-1].tagName&&b(t[t.length-1]).remove(),b(e).replaceWith(H.MARKERS);s&&!v.node.isBlock(s)&&"BR"!==s.tagName;)b(n).append(b(s)),s=s.nextSibling;b(s).remove()}}}}},H.NO_DELETE_TAGS=["TH","TD","TR","TABLE","FORM"],H.SIMPLE_ENTER_TAGS=["TH","TD","LI","DL","DT","FORM"],H.MODULES.cursor=function(b){var L=b.$,E=function E(e){var t=null;e&&e.nodeType===Node.TEXT_NODE&&e.nodeValue.trim()&&(t=e);var n=function(e){L(e).contents().each(function(){this.nodeType===Node.TEXT_NODE&&this.nodeValue.trim()?t=this:this.nodeType===Node.ELEMENT_NODE&&n(this)})};return n(e),t};function u(e){return!!e&&(b.node.isBlock(e)?"P"!==e.tagName||!e.nextElementSibling||!e.parentElement||"OL"!==e.nextElementSibling.tagName||"LI"!==e.parentElement.tagName:e.nextSibling&&e.nextSibling.nodeType===Node.TEXT_NODE&&0===e.nextSibling.textContent.replace(/\u200b/g,"").length?u(e.nextSibling):!(e.nextSibling&&(!e.previousSibling||"BR"!==e.nextSibling.tagName||e.nextSibling.nextSibling))&&u(e.parentNode))}function h(e){return!!e&&(!!b.node.isBlock(e)||(e.previousSibling&&e.previousSibling.nodeType===Node.TEXT_NODE&&0===e.previousSibling.textContent.replace(/\u200b/g,"").length?h(e.previousSibling):!e.previousSibling&&(!(e.previousSibling||!b.node.hasClass(e.parentNode,"fr-inner"))||h(e.parentNode))))}function g(e,t){return!!e&&(e!==b.$wp.get(0)&&(e.previousSibling&&e.previousSibling.nodeType===Node.TEXT_NODE&&0===e.previousSibling.textContent.replace(/\u200b/g,"").length?g(e.previousSibling,t):!e.previousSibling&&(e.parentNode===t||g(e.parentNode,t))))}function C(e,t){return!!e&&(e!==b.$wp.get(0)&&(e.nextSibling&&e.nextSibling.nodeType===Node.TEXT_NODE&&0===e.nextSibling.textContent.replace(/\u200b/g,"").length?C(e.nextSibling,t):!(e.nextSibling&&(!e.previousSibling||"BR"!==e.nextSibling.tagName||e.nextSibling.nextSibling))&&(e.parentNode===t||C(e.parentNode,t))))}function m(e){return 0<L(e).parentsUntil(b.$el,"LI").length&&0===L(e).parentsUntil("LI","TABLE").length}function y(e,t){var n=new RegExp("".concat(t?"^":"","(([\\uD83C-\\uDBFF\\uDC00-\\uDFFF]+\\u200D)*[\\uD83C-\\uDBFF\\uDC00-\\uDFFF]{2})").concat(t?"":"$"),"i"),r=e.match(n);return r?r[0].length:1}function S(e){for(var t,n=e;!n.previousSibling;)if(n=n.parentNode,b.node.isElement(n))return!1;n=n.previousSibling;var r=b.opts.htmlAllowedEmptyTags,o=n.tagName&&n.tagName.toLowerCase();if((!b.node.isBlock(n)||n.lastChild&&o&&0<=r.indexOf(o))&&b.node.isEditable(n)){for(t=b.node.contents(n);n.nodeType!==Node.TEXT_NODE&&!b.node.isDeletable(n)&&t.length&&b.node.isEditable(n);)n=t[t.length-1],t=b.node.contents(n);if(n.nodeType===Node.TEXT_NODE){var i=n.textContent,a=i.length;if(i.length&&"\n"===i[i.length-1])return n.textContent=i.substring(0,a-2),0===n.textContent.length&&n.parentNode.removeChild(n),S(e);if(b.opts.tabSpaces&&i.length>=b.opts.tabSpaces||b.opts.preserveTabSpaces&&4<=i.length){var s=b.opts.tabSpaces?b.opts.tabSpaces:4;0===i.substr(i.length-s,i.length-1).replace(/ /g,"").replace(new RegExp(H.UNICODE_NBSP,"g"),"").length&&(a=i.length-s+1)}n.textContent=i.substring(0,a-y(i));var l=n.textContent;(b.opts.enter===H.ENTER_BR&&0<l.length&&" "===l.charAt(l.length-1)||0===l.length&&e.previousSibling&&3===e.previousSibling.nodeType&&"TD"!==e.parentNode.tagName&&"LI"!==e.parentNode.tagName&&i!==String.fromCharCode(8203))&&(e.insertAdjacentHTML("beforebegin",H.INVISIBLE_SPACE),n=n.nextSibling),b.opts.trackChangesEnabled&&0===n.textContent.length&&L(n.parentElement).data("tracking")&&0===L(n.parentElement).find("[data-tracking-deleted=true]").length&&(L(e).insertBefore(n.parentElement),L(n.parentElement).remove(),n=L(e)[0].previousSibling),b.opts.htmlUntouched&&!e.nextSibling&&n.textContent.length&&" "===n.textContent[n.textContent.length-1]&&(n.textContent=n.textContent.substring(0,n.textContent.length-1)+H.UNICODE_NBSP);var c=i.length!==n.textContent.length;if(b.opts.enter!==H.ENTER_BR&&n&&n.previousSibling&&n.previousSibling.previousSibling&&"BR"===n.previousSibling.previousSibling.tagName&&0===n.textContent.length&&n.previousSibling.previousSibling.remove(),0===n.textContent.length&&"LI"===n.parentNode.tagName&&n.previousSibling&&"BR"===n.previousSibling.tagName&&n.previousSibling.remove(),0===n.textContent.length)if(c&&b.opts.keepFormatOnDelete)L(n).after(H.INVISIBLE_SPACE+H.MARKERS);else if(0!==i.length&&b.node.isBlock(n.parentNode))L(n).after(H.MARKERS);else if((2!=n.parentNode.childNodes.length||n.parentNode!=e.parentNode)&&1!=n.parentNode.childNodes.length||b.node.isBlock(n.parentNode)||b.node.isElement(n.parentNode)||!b.node.isDeletable(n.parentNode)){for(var d,f=n;!b.node.isElement(n.parentNode)&&b.node.isEmpty(n.parentNode)&&H.NO_DELETE_TAGS.indexOf(n.parentNode.tagName)<0;)if("A"===(n=n.parentNode).tagName){var p=n.childNodes[0];for(L(n).before(p),d=!0;0<p.childNodes.length;)p=p.childNodes[0];n.parentNode.removeChild(n),n=p;break}d||(n=f),L(n).after(H.MARKERS),b.node.isElement(n.parentNode)&&!e.nextSibling&&n.previousSibling&&"BR"===n.previousSibling.tagName&&L(e).after("<br>");var u=n.parentNode;n.parentNode.removeChild(n),b.node.isEmpty(u)&&L(u).html(H.INVISIBLE_SPACE+H.MARKERS)}else L(n.parentNode).after(H.MARKERS),L(n.parentNode).remove();else L(n).after(H.MARKERS)}else b.node.isDeletable(n)?(L(n).after(H.MARKERS),L(n).remove()):e.nextSibling&&"BR"===e.nextSibling.tagName&&b.node.isVoid(n)&&"BR"!==n.tagName?(L(e.nextSibling).remove(),L(e).replaceWith(H.MARKERS)):!1!==b.events.trigger("node.remove",[L(n)])&&(b.opts.enter===H.ENTER_BR&&"BR"===n.tagName?L(E(n.previousSibling)).after(H.MARKERS):L(n).after(H.MARKERS),L(n).remove())}else if(H.NO_DELETE_TAGS.indexOf(n.tagName)<0&&(b.node.isEditable(n)||b.node.isDeletable(n)))if(b.node.isDeletable(n))L(e).replaceWith(H.MARKERS),L(n).remove();else if(b.node.isEmpty(n)&&!b.node.isList(n))L(n).remove(),L(e).replaceWith(H.MARKERS);else{for(b.node.isList(n)&&(n=L(n).find("li").last().get(0)),(t=b.node.contents(n))&&0<t.length&&"BR"===t[t.length-1].tagName&&L(t[t.length-1]).remove(),t=b.node.contents(n);t&&0<t.length&&b.node.isBlock(t[t.length-1]);)n=t[t.length-1],t=b.node.contents(n);var h=E(n),g=h&&0<L(h).parents("span").length;if(b.opts.enter===H.ENTER_BR&&g){var C=L(n).find("span").last().get(0);C?L(E(C)).after(H.MARKERS):L(n).append(H.MARKERS)}else L(n).append(H.MARKERS);for(var m=e;!m.previousSibling;)m=m.parentNode;for(;m&&"BR"!==m.tagName&&!b.node.isBlock(m);){var v=m;m=m.nextSibling,L(n).append(v)}m&&"BR"===m.tagName&&L(m).remove(),L(e).remove()}else e.nextSibling&&"BR"===e.nextSibling.tagName&&L(e.nextSibling).remove();return!0}function i(e){var t=0<L(e).parentsUntil(b.$el,"BLOCKQUOTE").length,n=b.node.deepestParent(e,[],!t);if(n&&"BLOCKQUOTE"===n.tagName){var r=b.node.deepestParent(e,[L(e).parentsUntil(b.$el,"BLOCKQUOTE").get(0)]);r&&r.nextSibling&&(n=r)}if(null!==n){var o,i=n.nextSibling;if(b.node.isBlock(n)&&(b.node.isEditable(n)||b.node.isDeletable(n))&&i&&H.NO_DELETE_TAGS.indexOf(i.tagName)<0)if(b.node.isDeletable(i))L(i).remove(),L(e).replaceWith(H.MARKERS);else if(b.node.isBlock(i)&&b.node.isEditable(i))if(b.node.isList(i))if(b.node.isEmpty(n,!0))L(n).remove(),L(i).find("li").first().prepend(H.MARKERS);else{var a=L(i).find("li").first();"BLOCKQUOTE"===n.tagName&&(o=b.node.contents(n)).length&&b.node.isBlock(o[o.length-1])&&(n=o[o.length-1]),0===a.find("ul, ol").length&&(L(e).replaceWith(H.MARKERS),a.find(b.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode===a.get(0)&&L(this).replaceWith(L(this).html()+(b.node.isEmpty(this)?"":"<br>"))}),L(n).append(b.node.contents(a.get(0))),a.remove(),0===L(i).find("li").length&&L(i).remove())}else{if((o=b.node.contents(i)).length&&"BR"===o[0].tagName&&L(o[0]).remove(),"BLOCKQUOTE"!==i.tagName&&"BLOCKQUOTE"===n.tagName)for(o=b.node.contents(n);o.length&&b.node.isBlock(o[o.length-1]);)n=o[o.length-1],o=b.node.contents(n);else if("BLOCKQUOTE"===i.tagName&&"BLOCKQUOTE"!==n.tagName)for(o=b.node.contents(i);o.length&&b.node.isBlock(o[0]);)i=o[0],o=b.node.contents(i);L(e).replaceWith(H.MARKERS),L(n).append(i.innerHTML),L(i).remove()}else{for(L(e).replaceWith(H.MARKERS);i&&"BR"!==i.tagName&&!b.node.isBlock(i)&&b.node.isEditable(i);){var s=i;i=i.nextSibling,L(n).append(s)}i&&"BR"===i.tagName&&b.node.isEditable(i)&&L(i).remove()}}}function n(e){for(var t,n=e;!n.nextSibling;)if(n=n.parentNode,b.node.isElement(n))return!1;if("BR"===(n=n.nextSibling).tagName&&b.node.isEditable(n))if(n.nextSibling){if(b.node.isBlock(n.nextSibling)&&b.node.isEditable(n.nextSibling)){if(!(H.NO_DELETE_TAGS.indexOf(n.nextSibling.tagName)<0))return void L(n).remove();n=n.nextSibling,L(n.previousSibling).remove()}}else if(u(n)){if(m(e))b.cursorLists._del(e);else b.node.deepestParent(n)&&((!b.node.isEmpty(b.node.blockParent(n))||(b.node.blockParent(n).nextSibling&&H.NO_DELETE_TAGS.indexOf(b.node.blockParent(n).nextSibling.tagName))<0)&&L(n).remove(),n&&n.parentNode&&8203===n.parentNode.textContent.charCodeAt()&&n.parentNode.childNodes[1]&&"BR"===n.parentNode.childNodes[1].tagName&&n.parentNode.tagName.toLowerCase()===b.html.defaultTag()&&n.parentNode.nextSibling&&"TABLE"===n.parentNode.nextSibling.tagName&&L(n.parentNode).remove(),i(e));return}if(!b.node.isBlock(n)&&b.node.isEditable(n)){for(t=b.node.contents(n);n.nodeType!==Node.TEXT_NODE&&t.length&&!b.node.isDeletable(n)&&b.node.isEditable(n);)n=t[0],t=b.node.contents(n);n.nodeType===Node.TEXT_NODE?(L(n).before(H.MARKERS),n.textContent.length&&(n.textContent=n.textContent.substring(y(n.textContent,!0),n.textContent.length))):b.node.isDeletable(n)?(L(n).before(H.MARKERS),L(n).remove()):!1!==b.events.trigger("node.remove",[L(n)])&&(L(n).before(H.MARKERS),L(n).remove()),L(e).remove()}else if(H.NO_DELETE_TAGS.indexOf(n.tagName)<0&&(b.node.isEditable(n)||b.node.isDeletable(n)))if(b.node.isDeletable(n))L(e).replaceWith(H.MARKERS),L(n).remove();else if(b.node.isList(n))e.previousSibling?(L(n).find("li").first().prepend(e),b.cursorLists._backspace(e)):(L(n).find("li").first().prepend(H.MARKERS),L(e).remove());else if((t=b.node.contents(n))&&0<t.length&&"BR"===t[0].tagName&&L(t[0]).remove(),t&&0<t.length&&"BLOCKQUOTE"===n.tagName){var r=t[0];for(L(e).before(H.MARKERS);r&&"BR"!==r.tagName;){var o=r;r=r.nextSibling,L(e).before(o)}r&&"BR"===r.tagName&&L(r).remove()}else L(e).after(L(n).html()).after(H.MARKERS),L(n).remove()}function a(){for(var e=b.el.querySelectorAll("blockquote:empty"),t=0;t<e.length;t++)e[t].parentNode.removeChild(e[t])}function v(e,t,n){var r,o=b.node.deepestParent(e,[],!n);if(o&&"BLOCKQUOTE"===o.tagName)return C(e,o)?(r=b.html.defaultTag(),t?L(e).replaceWith("<br>"+H.MARKERS):r?L(o).after("<".concat(r,">").concat(H.MARKERS,"<br></").concat(r,">")):L(o).after("".concat(H.MARKERS,"<br>")),L(e).remove()):N(e,t,n),!1;if(null===o)(r=b.html.defaultTag())&&b.node.isElement(e.parentNode)?L(e).replaceWith("<".concat(r,">").concat(H.MARKERS,"<br></").concat(r,">")):!e.previousSibling||L(e.previousSibling).is("br")||e.nextSibling?L(e).replaceWith("<br>".concat(H.MARKERS)):L(e).replaceWith("<br>".concat(H.MARKERS,"<br>"));else{var i=e,a="";"PRE"!=o.tagName||e.nextSibling||(t=!0),b.node.isBlock(o)&&!t||(a="<br/>");var s,l="",c="",d="",f="";(r=b.html.defaultTag())&&b.node.isBlock(o)&&(d="<".concat(r,">"),f="</".concat(r,">"),o.tagName===r.toUpperCase()&&(d=b.node.openTagString(L(o).clone().removeAttr("id").get(0))));do{if(i=i.parentNode,!t||i!==o||t&&!b.node.isBlock(o))if(l+=b.node.closeTagString(i),i===o&&b.node.isBlock(o))c=d+c;else{var p=("A"===i.tagName||b.node.hasClass(i,"fa"))&&C(e,i)?"fr-to-remove":"";c="isPasted"===i.getAttribute("id")?b.node.openTagString(L(i).clone().attr("style","").addClass(p).get(0))+c:b.node.openTagString(L(i).clone().addClass(p).get(0))+c}}while(i!==o);a=l+a+c+(e.parentNode===o&&b.node.isBlock(o)?"":H.INVISIBLE_SPACE)+H.MARKERS,b.node.isBlock(o)&&!L(o).find("*").last().is("br")&&L(o).append("<br/>"),L(e).after('<span id="fr-break"></span>'),L(e).remove(),o.nextSibling&&!b.node.isBlock(o.nextSibling)||b.node.isBlock(o)||L(o).after("<br>"),s=(s=!t&&b.node.isBlock(o)?b.node.openTagString(o)+L(o).html()+f:b.node.openTagString(o)+L(o).html()+b.node.closeTagString(o)).replace(/<span id="fr-break"><\/span>/g,a),L(o).replaceWith(s)}}function N(e,t,n){var r=b.node.deepestParent(e,[],!n);if(null===r)b.html.defaultTag()&&e.parentNode===b.el?L(e).replaceWith("<".concat(b.html.defaultTag(),">").concat(H.MARKERS,"<br></").concat(b.html.defaultTag(),">")):(e.nextSibling&&!b.node.isBlock(e.nextSibling)||L(e).after("<br>"),L(e).replaceWith("<br>".concat(H.MARKERS)));else if(e.previousSibling&&"IMG"==e.previousSibling.tagName||e.nextSibling&&"IMG"==e.nextSibling.tagName)L(e).replaceWith("<"+b.html.defaultTag()+">"+H.MARKERS+"<br></"+b.html.defaultTag()+">");else{var o=e,i="";"PRE"===r.tagName&&(t=!0),b.node.isBlock(r)&&!t||(i="<br>");var a="",s="";do{var l=o;if(o=o.parentNode,"BLOCKQUOTE"===r.tagName&&b.node.isEmpty(l)&&!b.node.hasClass(l,"fr-marker")&&L(l).contains(e)&&L(l).after(e),"BLOCKQUOTE"!==r.tagName||!C(e,o)&&!g(e,o))if(!t||o!==r||t&&!b.node.isBlock(r)){a+=b.node.closeTagString(o);var c="A"==o.tagName&&C(e,o)||b.node.hasClass(o,"fa")?"fr-to-remove":"";s=b.node.openTagString(L(o).clone().addClass(c).removeAttr("id").get(0))+s,b.opts.enter!==H.ENTER_DIV&&o===r&&"DIV"===r.tagName&&(a="<br>",s="")}else"BLOCKQUOTE"==r.tagName&&t&&(s=a="")}while(o!==r);var d=r===e.parentNode&&b.node.isBlock(r)||e.nextSibling;if("BLOCKQUOTE"===r.tagName)if(e.previousSibling&&b.node.isBlock(e.previousSibling)&&e.nextSibling&&"BR"===e.nextSibling.tagName&&(L(e.nextSibling).after(e),e.nextSibling&&"BR"===e.nextSibling.tagName&&L(e.nextSibling).remove()),t)i=a+i+H.MARKERS+s;else{var f=b.html.defaultTag();i="".concat(a+i+(f?"<".concat(f,">"):"")+H.MARKERS,"<br>").concat(f?"</".concat(f,">"):"").concat(s)}else i=a+i+s+(d?"":H.INVISIBLE_SPACE)+H.MARKERS;L(e).replaceWith('<span id="fr-break"></span>');var p=b.node.openTagString(r)+L(r).html()+b.node.closeTagString(r);p=p.replace(/<span id="fr-break"><\/span>/g,i),L(r).replaceWith(p)}}function T(e){var t=e.getBoundingClientRect(),n=window.pageXOffset||document.documentElement.scrollLeft,r=window.pageYOffset||document.documentElement.scrollTop;return b.opts.iframe?{top:t.top+b.$wp.offset().top,left:t.left+n}:{top:t.top+r,left:t.left+n}}function M(){var e=b.selection.get(),t=null;if(b.selection.inEditor()&&e.rangeCount)for(var n=b.selection.ranges(),r=0;r<n.length;r++){var o=n[r];t=b.selection.rangeElement(o.startContainer,o.startOffset);break}return t}return{enter:function A(e){var t=b.markers.insert();if(!t)return!0;for(var n=t.parentNode;n&&!b.node.isElement(n);){if("false"===n.getAttribute("contenteditable"))return L(t).replaceWith(H.MARKERS),b.selection.restore(),!1;if("true"===n.getAttribute("contenteditable"))break;n=n.parentNode}b.el.normalize();var r=!1;0<L(t).parentsUntil(b.$el,"BLOCKQUOTE").length&&(r=!0),L(t).parentsUntil(b.$el,"TD, TH").length&&(r=!1),u(t)?!m(t)||e||r?v(t,e,r):b.cursorLists._endEnter(t):h(t)?!m(t)||e||r?function f(e,t,n){var r,o=b.node.deepestParent(e,[],!n);if(o&&"TABLE"===o.tagName)return L(o).find("td, th").first().prepend(e),f(e,t,n);if(o&&"BLOCKQUOTE"===o.tagName)if(g(e,o)){if(!t)return(r=b.html.defaultTag())?L(o).before("<".concat(r,">").concat(H.MARKERS,"<br></").concat(r,">")):L(o).before("".concat(H.MARKERS,"<br>")),L(e).remove(),!1}else C(e,o)?v(e,t,!0):N(e,t,!0);if(null===o)(r=b.html.defaultTag())&&b.node.isElement(e.parentNode)?L(e).replaceWith("<".concat(r,">").concat(H.MARKERS,"<br></").concat(r,">")):L(e).replaceWith("<br>".concat(H.MARKERS));else{if(r=b.html.defaultTag(),b.node.isBlock(o))if("PRE"===o.tagName&&(t=!0),t)L(e).remove(),L(o).prepend("<br>".concat(H.MARKERS));else if(e.nextSibling&&"IMG"==e.nextSibling.tagName||e.nextSibling&&e.nextSibling.nextElementSibling&&"IMG"==e.nextSibling.nextElementSibling)L(e).replaceWith("<"+b.html.defaultTag()+">"+H.MARKERS+"<br></"+b.html.defaultTag()+">");else{if(b.node.isEmpty(o,!0))return v(e,t,n);if(b.opts.keepFormatOnDelete||"DIV"===o.tagName||"div"===b.html.defaultTag())if(!b.opts.keepFormatOnDelete&&"DIV"===o.tagName||"div"===b.html.defaultTag())L(o).before("<"+b.html.defaultTag()+"><br></"+b.html.defaultTag()+">");else if(b.opts.keepFormatOnDelete&&!b.opts.htmlUntouched&&"DIV"!==o.tagName&&"div"!==b.html.defaultTag()&&h(b.selection.get().focusNode))L(o).before("".concat(b.node.openTagString(L(o).clone().removeAttr("id").get(0)),"<br>").concat(b.node.closeTagString(o)));else{for(var i=e,a=H.INVISIBLE_SPACE;i!==o&&!b.node.isElement(i);)i=i.parentNode,a=b.node.openTagString(i)+a+b.node.closeTagString(i);L(o).before(a)}else L(o).before("".concat(b.node.openTagString(L(o).clone().removeAttr("id").get(0)),"<br>").concat(b.node.closeTagString(o)))}else L(o).before("<br>");L(e).remove()}}(t,e,r):b.cursorLists._startEnter(t):!m(t)||e||r?N(t,e,r):b.cursorLists._middleEnter(t),function p(){b.$el.find(".fr-to-remove").each(function(){for(var e=b.node.contents(this),t=0;t<e.length;t++)e[t].nodeType===Node.TEXT_NODE&&(e[t].textContent=e[t].textContent.replace(/\u200B/g,""));L(this).replaceWith(this.innerHTML)})}(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists(),b.spaces.normalizeAroundCursor()),b.selection.restore();var o=b.o_win.innerHeight;if(b.$oel[0].offsetHeight>o){var i=M();if(i){var a=T(i);a=a.top;var s=i.getBoundingClientRect().top;b.opts.iframe&&(s=s+b.$wp.offset().top-b.helpers.scrollTop()),b.opts.scrollableContainer&&b.opts.enter!==H.ENTER_BR&&"BR"===i.tagName&&s+20===o&&(s=a=i.parentNode.offsetTop),i.parentNode&&"TD"===i.parentNode.tagName&&o<s?b.o_win.scroll(0,s-50):"BR"===i.tagName&&s<0?b.o_win.scroll(0,a-80):b.opts.scrollableContainer&&o<s+20?b.o_win.scroll(0,a-o+50):b.opts.scrollableContainer&&s+2*b.$tb.height()>b.$sc[0].scrollTop+L(b.$sc).height()&&b.$sc[0].scroll(0,a-L(b.$sc).height()+2*b.$tb.height())}}else if(b.opts.scrollableContainer&&b.opts.toolbarSticky){var l=M();if(l){var c=T(l);c=c.top;var d=l.getBoundingClientRect().top;b.opts.enter!==H.ENTER_BR&&"BR"===l.tagName&&(d=c=l.parentNode.offsetTop),(b.opts.iframe&&d+2*b.$tb.height()>b.$sc[0].scrollTop+L(b.$sc).height()||d+2*b.$tb.height()>L(b.$sc).height())&&b.$sc[0].scroll(0,c-L(b.$sc).height()+2*b.$tb.height())}}},backspace:function s(){var e=!1,t=b.markers.insert();if(!t)return!0;for(var n=t.parentNode;n&&!b.node.isElement(n);){if("false"===n.getAttribute("contenteditable"))return L(t).replaceWith(H.MARKERS),b.selection.restore(),!1;if(n.innerText.length&&"true"===n.getAttribute("contenteditable"))break;n=n.parentNode}b.el.normalize();var r=t.previousSibling;if(r){var o=r.textContent;o&&o.length&&8203===o.charCodeAt(o.length-1)&&(1===o.length?L(r).remove():r.textContent=r.textContent.substr(0,o.length-y(o)))}return u(t)?m(t)&&g(t,L(t).parents("li").first().get(0))?b.cursorLists._backspace(t):e=S(t):h(t)?m(t)&&g(t,L(t).parents("li").first().get(0))?b.cursorLists._backspace(t):function c(e){for(var t=0<L(e).parentsUntil(b.$el,"BLOCKQUOTE").length,n=b.node.deepestParent(e,[],!t),r=n;n&&!n.previousSibling&&"BLOCKQUOTE"!==n.tagName&&n.parentElement!==b.el&&!b.node.hasClass(n.parentElement,"fr-inner")&&H.SIMPLE_ENTER_TAGS.indexOf(n.parentElement.tagName)<0;)n=n.parentElement;if(n&&"BLOCKQUOTE"===n.tagName){var o=b.node.deepestParent(e,[L(e).parentsUntil(b.$el,"BLOCKQUOTE").get(0)]);o&&o.previousSibling&&(r=n=o)}if(null!==n){var i,a=n.previousSibling;if(b.node.isBlock(n)&&b.node.isEditable(n))if(a&&H.NO_DELETE_TAGS.indexOf(a.tagName)<0){if(b.node.isDeletable(a))L(a).remove(),L(e).replaceWith(H.MARKERS);else if(b.node.isEditable(a))if(b.node.isBlock(a))if(b.node.isEmpty(a)&&!b.node.isList(a))L(a).remove(),L(e).after(b.opts.keepFormatOnDelete?H.INVISIBLE_SPACE:"");else{if(b.node.isList(a)&&(a=L(a).find("li").last().get(0)),(i=b.node.contents(a)).length&&"BR"===i[i.length-1].tagName&&L(i[i.length-1]).remove(),"BLOCKQUOTE"===a.tagName&&"BLOCKQUOTE"!==n.tagName)for(i=b.node.contents(a);i.length&&b.node.isBlock(i[i.length-1]);)a=i[i.length-1],i=b.node.contents(a);else if("BLOCKQUOTE"!==a.tagName&&"BLOCKQUOTE"===r.tagName)for(i=b.node.contents(r);i.length&&b.node.isBlock(i[0]);)r=i[0],i=b.node.contents(r);if(b.node.isEmpty(n))L(e).remove(),b.selection.setAtEnd(a,!0);else{L(e).replaceWith(H.MARKERS);var s=a.childNodes;b.node.isBlock(s[s.length-1])?L(s[s.length-1]).append(r.innerHTML):L(a).append(r.innerHTML)}L(r).remove(),b.node.isEmpty(n)&&L(n).remove()}else L(e).replaceWith(H.MARKERS),"BLOCKQUOTE"===n.tagName&&a.nodeType===Node.ELEMENT_NODE?L(a).remove():(L(a).after(b.node.isEmpty(n)?"":L(n).html()),L(n).remove(),"BR"===a.tagName&&L(a).remove())}else if(a)8203===n.textContent.charCodeAt()&&n.childNodes[1]&&"BR"===n.childNodes[1].tagName&&n.tagName.toLowerCase()===b.html.defaultTag()&&n.previousSibling&&"TABLE"===n.previousSibling.tagName&&L(n).remove();else if(n&&"BLOCKQUOTE"===n.tagName&&0===L(n).text().replace(/\u200B/g,"").length)L(n).remove();else{var l=n.nextSibling;b.node.isEmpty(n)&&n.parentNode&&b.node.isEditable(n.parentNode)&&!l&&(n.parentNode!=b.el&&"TD"!==n.parentNode.tagName?L(n.parentNode).remove():n.parentNode!=b.el&&"TD"===n.parentNode.tagName&&L(n).remove())}}}(t):e=S(t),L(t).remove(),a(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists(),b.spaces.normalizeAroundCursor()),b.selection.restore(),e},del:function r(){var e=b.markers.insert();if(!e)return!1;if(b.el.normalize(),u(e))if(m(e))if(0===L(e).parents("li").first().find("ul, ol").length)b.cursorLists._del(e);else{var t=L(e).parents("li").first().find("ul, ol").first().find("li").first();(t=t.find(b.html.blockTagsQuery()).get(-1)||t).prepend(e),b.cursorLists._backspace(e)}else i(e);else h(e),n(e);L(e).remove(),a(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore()},isAtEnd:C,isAtStart:g}},H.MODULES.data=function(f){function p(e){return e}function c(e){for(var t=e.toString(),n=0,r=0;r<t.length;r++)n+=parseInt(t.charAt(r),10);return 10<n?n%9+1:n}function d(e,t,n){for(var r=Math.abs(n);0<r--;)e-=t;return n<0&&(e+=123),e}function u(e){return e&&"block"!==e.css("display")?(e.remove(),!0):e&&0===f.helpers.getPX(e.css("height"))?(e.remove(),!0):!(!e||"absolute"!==e.css("position")&&"fixed"!==e.css("position")||(e.remove(),0))}function h(e){return e&&0===f.$box.find(e).length}function g(){if(10<e&&(f[p(M("0ppecjvc=="))](),setTimeout(function(){L.FE=null},10)),!f.$box)return!1;f.$wp.prepend(M(p(M(N)))),v=f.$wp.find("> div").first(),b=v.find("> a"),"rtl"===f.opts.direction&&v.css("left","auto").css("right",0).attr("direction","rtl"),e++}function C(e){for(var t=[M("9qqG-7amjlwq=="),M("KA3B3C2A6D1D5H5H1A3=="),M("3B9B3B5F3C4G3E3=="),M("QzbzvxyB2yA-9m=="),M("ji1kacwmgG5bc=="),M("nmA-13aogi1A3c1jd=="),M("BA9ggq=="),M("emznbjbH3fij=="),M("tkC-22d1qC-13sD1wzF-7=="),M("tA3jjf=="),M("1D1brkm==")],n=0;n<t.length;n++)if(String.prototype.endsWith||(String.prototype.endsWith=function(e,t){return(void 0===t||t>this.length)&&(t=this.length),this.substring(t-e.length,t)===e}),e.endsWith(t[n]))return!0;return!1}function m(){var e=M(p(n)),t=M(p("tzgatD-13eD1dtdrvmF3c1nrC-7saQcdav==")).split(".");try{return window.parent.document.querySelector(e)&&window[t[1]][t[2]]}catch(e){return!1}}var v,b,L=f.$,E="sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2FC1A3NB2IF1HE1TH4WB8eB-11zVG2F3I3yYB5ZG4CB2DA15CC5AD3F1A1KG1oLA10B1A6wQF1H3vgale2C4F4XA2qc2A5D5B3pepmriKB3OE1HD1fUC10pjD-11E-11TB4YJ3bC-16zE-11yc1B2CE2BC3jhjKC1pdA-21OA6C1D5B-8vF4QA11pD6sqf1C3lldA-16BD4A2H3qoEA7bB-16rmNH5H1F1vSB7RE2A3TH4YC5A5b1A4d1B3whepyAC3AA2zknC3mbgf1SC4WH4PD8TC5ZB2C3H3jb2A5ZA2EF2aoFC5qqHC4B1H1zeGA7UA5RF4TA29TA6ZC4d1C3hyWA10A3rBB2E3decorationRD3QC10UD3E6E6ZD2F3F3fme2E5uxxrEC9C3E4fB-11azhHB1LD7D6VF4VVTPC6b1C4TYG3qzDD6B3B3AH4I2H2kxbHE1JD1yihfd1QD6WB1D4mhrc1B5rvFG3A14A7cDA2OC1AA1JB5zC-16KA6WB4C-8wvlTB5A5lkZB2C2C7zynBD2D2bI-7C-21d1HE2cubyvPC8A6VB3aroxxZE4C4F4e1I2BE1WjdifH1H4A14NA1GB1YG-10tWA3A14A9sVA2C5XH2A29b2A6gsleGG2jaED2D-13fhE1OA8NjwytyTD4e1sc1D-16ZC3B5C-9e1C2FB6EFF5B2C2JH4E1C2tdLE5A3UG4G-7b2D3B4fA-9oh1G3kqvB4AG3ibnjcAC6D2B1cDA9KC2QA6bRC4VA30RB8hYB2A4A-8h1A21A2B2==",y="7D4YH4fkhHB3pqDC3H2E1fkMD1IB1NF1D3QD9wB5rxqlh1A8c2B4ZA3FD2AA6FB5EB3jJG4D2J-7aC-21GB6PC5RE4TC11QD6XC4XE3XH3mlvnqjbaOA2OC2BE6A1fmI-7ujwbc1G5f1F3e1C11mXF4owBG3E1yD1E4F1D2D-8B-8C-7yC-22HD1MF5UE4cWA3D8D6a1B2C3H3a3I3sZA4B3A2akfwEB3xHD5D1F1wIC11pA-16xdxtVI2C9A6YC4a1A2F3B2GA6B4C3lsjyJB1eMA1D-11MF5PE4ja1D3D7byrf1C3e1C7D-16lwqAF3H2A1B-21wNE1MA1OG1HB2A-16tSE5UD4RB3icRA4F-10wtwzBB3E1C3CC2DA8LA2LA1EB1kdH-8uVB7decorg1J2B7B6qjrqGI2J1C6ijehIB1hkemC-13hqkrH4H-7QD6XF5XF3HLNAC3CB2aD2CD2KB10B4ycg1A-8KA4H4B11jVB5TC4yqpB-21pd1E4pedzGB6MD5B3ncB-7MA4LD2JB6PD5uH-8TB9C7YD5XD2E3I3jmiDB3zeimhLD8E2F2JC1H-9ivkPC5lG-10SB1D3H3A-21rc1A3d1E3fsdqwfGA2KA1OrC-22LA6D1B4afUB16SC7AitC-8qYA11fsxcajGA15avjNE2A-9h1hDB16B9tPC1C5F5UC1G3B8d2A5d1D4RnHJ3C3JB5D3ucMG1yzD-17hafjC-8VD3yWC6e1YD2H3ZE2C8C5oBA3H3D2vFA4WzJC4C2i1A-65fNB8afWA1H4A26mvkC-13ZB3E3h1A21BC4eFB2GD2AA5ghqND2A2B2==",n="MekC-11nB-8tIzpD7pewxvzC6mD-16xerg1==",S="lC4B3A3B2B5A1C2E4G1A2==",N="sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2EE1MA2ND1KD1IE4cA-21pSD2D5ve1G3h1A8b1E5ZC3CD2FA16mC5OC5E1hpnG1NA10B1D7hkUD4I-7b2C3C5nXD2E3F3whidEC2EH3GI2mJE2E2bxci1WA10VC7pllSG2F3A7xd1A4ZC3DB2aaeGA2DE4H2E1j1ywD-13FD1A3VE4WA3D8C6wuc1A2hf1B5B7vnrrjA1B9ic1mpbD1oMB1iSB7rWC4RI4G-7upB6jd1A2F3H2EA4FD3kDF4A2moc1anJD1TD4VI4b2C7oeQF4c1E3XC7ZA3C3G3uDB2wGB6D1JC4D1JD4C1hTE6QC5pH4pD3C-22D7c1A3textAA4gdlB2mpozkmhNC1mrxA3yWA5edhg1I2H3B7ozgmvAI3I2B5GD1LD2RSNH1KA1XA5SB4PA3sA9tlmC-9tnf1G3nd1coBH4I2I2JC3C-16LE6A1tnUA3vbwQB1G3f1A20a3A8a1C6pxAB2eniuE1F3kH2lnjB2hB-16XA5PF1G4zwtYA5B-11mzTG2B9pHB3BE2hGH3B3B2cMD5C1F1wzPA8E7VG5H5vD3H-7C8tyvsVF2I1G2A5fE3bg1mgajoyxMA4fhuzSD8aQB2B4g1A20ukb1A4B3F3GG2CujjanIC1ObiB11SD1C5pWC1D4YB8YE5FE-11jXE2F-7jB4CC2G-10uLH4E1C2tA-13yjUH5d1H1A7sWD5E4hmjF-7pykafoGA16hDD4joyD-8OA33B3C2tC7cRE4SA31a1B8d1e2A4F4g1A2A22CC5zwlAC2C1A12==",T=function(){for(var e=0,t=document.domain,n=t.split("."),r="_gd".concat((new Date).getTime());e<n.length-1&&-1===document.cookie.indexOf("".concat(r,"=").concat(r));)t=n.slice(-1-++e).join("."),document.cookie="".concat(r,"=").concat(r,";domain=").concat(t,";");return document.cookie="".concat(r,"=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=").concat(t,";"),(t||"").replace(/(^\.*)|(\.*$)/g,"")}(),M=p(function A(e){if(!e)return e;for(var t="",n=p("charCodeAt"),r=p("fromCharCode"),o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".indexOf(e[0]),i=1;i<e.length-2;i++){for(var a=c(++o),s=e[n](i),l="";/[0-9-]/.test(e[i+1]);)l+=e[++i];s=d(s,a,l=parseInt(l,10)||0),s^=o-1&31,t+=String[r](s)}return t}),e=0;return{_init:function x(){var e=f.opts.key||[""],t=M(p("ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=="));"string"==typeof e&&(e=[e]);for(var n,r,o,i=!(f.ul=!0),a=0,s=0;s<e.length;s++){var l=(r=e[s],4===(o=(M(r)||"").split("|")).length&&"V3"===o[0]?[o[1],o[3],o[2]]:[null,null,""]),c=l[2];if(c===M(p(M("LGnD1KNZf1CPBYCAZB-8F3UDSLLSG1VFf1A3C2==")))||0<=c.indexOf(T,c.length-T.length)||C(T)||m()){if(null!==(n=l[1])&&!(0==n.indexOf("TRIAL")?(n=new Date(n.replace(/TRIAL/,"")),new Date(n)<new Date&&(E=y,1)):new Date(n)<new Date(M(S)))||!(0<(T||"").length)||C(T)||m()){f.ul=!1;break}i=!0,N=E,a=l[0]||-1}}var d=new Image;!0===f.ul&&(g(),d.src=i?"".concat(p(M(t)),"e=").concat(a):"".concat(p(M(t)),"u")),!0===f.ul&&(f.events.on("contentChanged",function(){(function e(){return u(v)||u(b)||h(v)||h(b)})()&&g()}),f.events.on("html.get",function(e){return e+M("qD2H-9G3ioD-17qA1tE1B-8qI3A4hA-13C-11E2C1njfldD1E6pg1C-8sC3hfbkcD2G3stC-22gqgB3G2B-7vtoA4nweeD1A31A15B9uC-16A1F5dkykdc1B8dE-11bA3F2D3A9gd1E7F2tlI-8H-7vtxB2A5B2C3B2F2B5A6ldbyC4iqC-22D-17E-13mA3D2dywiB3oxlvfC1H4C2TjqbzlnI3ntB4E3qA2zaqsC6D3pmnkoE3C6D5wvuE3bwifdhB6hch1E4xibD-17dmrC1rG-7pntnF6nB-8F1D2A11C8plrkmF2F3MC-16bocqA2WwA-21ayeA1C4d1isC-22rD-13D6DfjpjtC2E6hB2G2G4A-7D2==")})),f.events.on("html.set",function(){var e=f.el.querySelector('[data-f-id="pbf"]');e&&L(e).remove()}),f.events.on("destroy",function(){v&&v.length&&v.remove()},!0)}}},H.MODULES.edit=function(t){function e(){if(t.browser.mozilla)try{t.doc.execCommand("enableObjectResizing",!1,"false"),t.doc.execCommand("enableInlineTableEditing",!1,"false")}catch(e){}if(t.browser.msie)try{t.doc.body.addEventListener("mscontrolselect",function(e){return e.srcElement.focus(),!1})}catch(e){}}var n=!1;function r(){return n}return{_init:function o(){t.events.on("focus",function(){r()?t.edit.off():t.edit.on()})},on:function i(){t.$wp?(t.$el.attr("contenteditable",!0),t.$el.removeClass("fr-disabled").attr("aria-disabled",!1),e()):t.$el.is("a")&&t.$el.attr("contenteditable",!0),t.events.trigger("edit.on",[],!0),n=!1},off:function a(){t.events.disableBlur(),t.$wp?(t.$el.attr("contenteditable",!1),t.$el.addClass("fr-disabled").attr("aria-disabled",!0)):t.$el.is("a")&&t.$el.attr("contenteditable",!1),t.events.trigger("edit.off"),t.events.enableBlur(),n=!0},disableDesign:e,isDisabled:r}},H.MODULES.format=function(x){var w=x.$;function O(e,t){var n=e;for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(n+="id"===r?"#".concat(t[r]):"class"===r?".".concat(t[r]):"[".concat(r,'="').concat(t[r],'"]'));return n}function k(e,t){return!(!e||e.nodeType!==Node.ELEMENT_NODE)&&(e.matches||e.matchesSelector||e.msMatchesSelector||e.mozMatchesSelector||e.webkitMatchesSelector||e.oMatchesSelector).call(e,t)}function b(s,l,c){var d,e,t,n={strong:{prop:"font-weight",val:"bold"},em:{prop:"font-style",val:"italic"}};if(s){var r="LI"===s.tagName?s:w(s).parentsUntil(x.$el,"li").get(0),o=w(r).find(".fr-marker[data-type=false]").get(0);if("LI"!==s.parentNode.parentNode.tagName||!o||null!=o.previousSibling){if(x.node.isBlock(s)&&s.hasAttribute("contenteditable")&&"false"===s.getAttribute("contenteditable")&&!x.opts.allowStylingOnNonEditable||s.parentNode&&s.parentNode.hasAttribute("contenteditable")&&"false"===s.parentNode.getAttribute("contenteditable")&&!x.opts.allowStylingOnNonEditable){if(s.nextSibling&&w(s.nextSibling).hasClass("fr-marker"))return;if(s.nextSibling)return void b(s.nextSibling,l,c);if(s.parentNode)return void b(s.parentNode,l,c)}for(;s&&s.nodeType===Node.COMMENT_NODE;)s=s.nextSibling;if(s){if(x.node.isBlock(s)&&"HR"!==s.tagName&&"LI"!==s.tagName)return x.node.hasClass(s.firstChild,"fr-marker")?b(s.firstChild.nextSibling,l,c):b(s.firstChild,l,c),!1;var f=w(x.doc.createElement(l));if(f.attr(c),!("span"===l&&s.parentNode&&"span"===s.parentNode.tagName.toLowerCase())&&s.parentNode&&s.parentNode.hasAttribute("contenteditable")&&"false"===s.parentNode.getAttribute("contenteditable")&&x.opts.allowStylingOnNonEditable){for(var i=s.parentNode,a=w(x.doc.createElement(l)).attr(c);i.firstChild;)a.append(i.firstChild);return w(i).append(a),void(w(i.lastChild.lastChild).hasClass("fr-marker")||b(i.nextSibling,l,c))}f.insertBefore(s),(d=L(s))&&(0<=["strong","em"].indexOf(l)||"span"===l&&c.hasOwnProperty("style"))&&(t="span"===l?(e=(n=c.style.replace(/;$/,"").split(":"))[0].trim(),n[1].trim()):(e=n[l].prop,n[l].val),"background-color"!==e&&(w(d).css(e,t),function v(e,t){var n,r=e.childNodes;for(n=0;n<r.length;n++)0<=["UL","OL","LI"].indexOf(r[n].tagName)&&""===r[n].style[t]&&w(r[n]).css(t,"initial")}(d,e)));for(var p,u=s,h=!1,g=function g(){var t=u;if("SPAN"===u.tagName&&w(u).hasClass("fr-tracking-deleted"))return u=u.nextSibling,0;if(x.node.isBlock(u)&&"HR"!==s.tagName)return b(u.firstChild,l,c),{v:!1};if("SPAN"===u.tagName&&x.node.isEditable(u))return f.is(":empty")&&f.remove(),b(u.firstChild,l,c),{v:!1};if(u.tagName&&u.hasAttribute("contenteditable")&&"false"===u.getAttribute("contenteditable")&&!x.opts.allowStylingOnNonEditable){var e=f.get(0).parentNode,n=u.nextSibling;return"P"===u.parentNode.tagName&&null==u.nextSibling?n=u.parentNode.nextSibling:!n&&e&&e.nextSibling&&"DIV"===e.nextSibling.tagName&&(n=e.nextSibling),b(n,l,c),{v:void 0}}if(!x.node.isEditable(u.parentNode)&&!x.opts.allowStylingOnNonEditable)return x.selection.restore(),x.toolbar.disable(),{v:void 0};if(u=u.nextSibling,"span"!=l||d)f.append(t);else{var r=t;["u","s"].forEach(function(e){0<w(t).parents(e).length&&(r=w(r).wrap("<".concat(e,"></").concat(e,">")).get(0).parentNode,h=!0)});var o=function i(t){return[].filter.call(t.parentNode.childNodes,function(e){return e.nodeType===Node.TEXT_NODE&&e!==t})}(r);0<o.length&&0<w(r).parents("u, s").length&&(o.forEach(function(e){var t=null,n=null;0<w(r).parents("u").length&&(n=t=document.createElement("u")),0<w(r).parents("s").length&&(n=n?(t.appendChild(document.createElement("s")),t.firstChild):t=document.createElement("s")),n.appendChild(e.cloneNode()),e.replaceWith(t)}),x.selection.restore(),x.selection.save()),f.append(r)}x.browser.mozilla&&0<f.length&&function a(e){if(w(e).parentsUntil(x.$el,"TABLE").length){for(var t=null,n=e.nextSibling;n;)"BR"===n.nodeName&&(t=n),n=n.nextSibling;t&&!t.nextSibling&&"TD"!=t.parentNode.nodeName&&t.parentNode.textContent&&t.remove()}}(f[0])};u&&!w(u).hasClass("fr-marker")&&0===w(u).find(".fr-marker").length&&"UL"!==u.tagName&&"OL"!==u.tagName;)if(0!==(p=g())&&p)return p.v;if(u)(w(u).find(".fr-marker").length||"UL"===u.tagName||"OL"===u.tagName)&&b(u.firstChild,l,c);else{for(var C=f.get(0).parentNode;C&&!C.nextSibling&&!x.node.isElement(C);)C=C.parentNode;if(C){var m=C.nextSibling;m&&(x.node.isBlock(m)?"HR"===m.tagName?b(m.nextSibling,l,c):b(m.firstChild,l,c):b(m,l,c))}}f.is(":empty")?f.remove():h&&(f.parents("u, s").get().forEach(function(e){var t=e.parentNode;if(t){var n=document.createDocumentFragment();e.childNodes.forEach(function(e){n.appendChild(e.cloneNode(!0))}),t.replaceChild(n,e)}}),x.selection.restore(),x.selection.save())}}}}function l(e,t){var n;if(void 0===t&&(t={}),t.style&&delete t.style,x.selection.isCollapsed()){x.markers.insert();var r=x.$el.find(".fr-marker");r.get(0).nextSibling&&x.node.isBlock(r.get(0).nextSibling)&&!r.get(0).previousSibling&&"LI"===r.get(0).parentNode.tagName&&r.get(0).nextSibling.prepend(r.get(0)),r.replaceWith(function l(e,t){var n="<".concat(e);for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(n+=" ".concat(r,'="').concat(t[r],'"'));return n+=">"}(e,t)+H.INVISIBLE_SPACE+H.MARKERS+function c(e){return"</".concat(e,">")}(e)),x.selection.restore()}else{x.selection.save();var o,i=x.$el.find('.fr-marker[data-type="true"]').length&&x.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling;b(i,e,t),w(i).parent().find("a:empty").remove();do{for(o=x.$el.find("".concat(O(e,t)," > ").concat(O(e,t))),n=0;n<o.length;n++)o[n].outerHTML=o[n].innerHTML}while(o.length);x.el.normalize();var a=x.el.querySelectorAll(".fr-marker");for(n=0;n<a.length;n++){var s=w(a[n]);!0===s.data("type")?k(s.get(0).nextSibling,O(e,t))&&s.next().prepend(s):k(s.get(0).previousSibling,O(e,t))&&s.prev().append(s)}x.selection.restore()}}function $(e,t,n,r){if(!r){var o=!1;if(!0===e.data("type"))for(;x.node.isFirstSibling(e.get(0))&&!e.parent().is(x.$el)&&!e.parent().is("ol")&&!e.parent().is("ul");)e.parent().before(e),o=!0;else if(!1===e.data("type"))for(;x.node.isLastSibling(e.get(0))&&!e.parent().is(x.$el)&&!e.parent().is("ol")&&!e.parent().is("ul");)e.parent().after(e),o=!0;if(o)return!0}if(e.parents(t).length||void 0===t){var i,a="",s="",l=e.parent();if("A"===l[0].tagName&&(l=l.parent()),l.is(x.$el)||x.node.isBlock(l.get(0)))return!1;for(;!(x.node.isBlock(l.parent().get(0))||void 0!==t&&k(l.get(0),O(t,n))||["#document","HTML","BODY"].includes(l.parent().get(0).nodeName.toUpperCase()));)a+=x.node.closeTagString(l.get(0)),s=x.node.openTagString(l.get(0))+s,l=l.parent();var c=e.get(0).outerHTML;return e.replaceWith('<span id="mark"></span>'),i=l.html().replace(/<span id="mark"><\/span>/,a+x.node.closeTagString(l.get(0))+s+c+a+x.node.openTagString(l.get(0))+s),l.replaceWith(x.node.openTagString(l.get(0))+i+x.node.closeTagString(l.get(0))),!0}return!1}function c(e,t){void 0===t&&(t={}),t.style&&delete t.style;var n=x.selection.isCollapsed();x.selection.save();var r=x.$el.find(".fr-marker");if(e&&r.length&&(r[0].parentNode&&r[0].parentNode.tagName===e.toUpperCase()||r[1].parentNode.tagName===e.toUpperCase())){var o=r[0];r[0].parentNode.tagName!==e.toUpperCase()&&(o=r[1]);for(var i=o.parentNode.previousSibling;null!=i;)i.nodeType===Node.TEXT_NODE&&(i.textContent=i.textContent.replace(/\u200B/g,"")),i=i.previousSibling;for(var a=o.parentNode.nextSibling;null!=a;)a.nodeType===Node.TEXT_NODE&&(a.textContent=a.textContent.replace(/\u200B/g,"")),a=a.nextSibling}for(var s=!0;s;){s=!1;for(var l=x.$el.find(".fr-marker"),c=0;c<l.length;c++){var d=w(l[c]),f=null;if(d.attr("data-cloned")||n||(f=d.clone().removeClass("fr-marker").addClass("fr-clone"),d.data("type")&&"true"===d.data("type").toString()?d.attr("data-cloned",!0).after(f):d.attr("data-cloned",!0).before(f)),$(d,e,t,n)){s=!0;break}}}!function M(e,t,n,r){for(var o,i={strong:{prop:"font-weight",val:"bold"},em:{prop:"font-style",val:"italic"}},a=x.node.contents(e.get(0)),s=0;s<a.length;s++){var l=a[s];if(l.innerHTML&&8203==l.innerHTML.charCodeAt()&&l.tagName.toLocaleLowerCase()==n&&l.childNodes.length<2&&!x.helpers.isMobile()&&(l.outerHTML=l.innerHTML),x.node.hasClass(l,"fr-marker"))t=(t+1)%2;else if(t)if(0<w(l).find(".fr-marker").length)t=M(w(l),t,n,r);else{(o="LI"===l.tagName?l:w(l).parentsUntil(x.$el,"li").get(0))&&(void 0===n||0<=["strong","em"].indexOf(n))&&(n?w(o).css(i[n].prop,""):o.style=""),(o=l.parentNode!==x.el?l.parentNode:null)&&1===o.nodeType&&["p","strong","u","em","s","sub","sup","a"].indexOf(n)<0&&o.hasAttribute("style")&&"SPAN"!==o.tagName&&"LI"!==o.tagName?o.style="":l&&1===l.nodeType&&l.hasAttribute("style")&&["p","strong","u","em","s","sub","sup","a"].indexOf(n)<0&&(x.browser.msie?w(l).attr("style",""):l.style="");for(var c=w(l).find(n||"*:not(br)"),d=c.length-1;0<=d;d--){var f=c[d];if((o="LI"===f.tagName?f:w(f).parentsUntil(x.$el,"li").get(0))&&(!n||0<=["strong","em"].indexOf(n))&&(n?w(o).css(i[n].prop,""):o.style=""),"A"===f.tagName||x.node.isBlock(f)||x.node.isVoid(f)||void 0!==n&&!k(f,O(n,r)))x.node.isBlock(f)&&void 0===n&&"TABLE"!==l.tagName&&"VIDEO"!==f.tagName&&x.node.clearAttributes(f);else{var p="IFRAME"===f.tagName&&f.parentNode&&"SPAN"===f.parentNode.tagName&&x.node.hasClass(f.parentNode,"fr-video")||"SPAN"===f.tagName&&x.node.hasClass(f,"fr-video");x.node.hasClass(f,"fr-clone")||p||x.node.hasClass(f,"fr-tracking-deleted")||w(f).data("tracking")||(f.outerHTML=f.innerHTML)}}"A"!==l.tagName&&void 0===n&&l.nodeType===Node.ELEMENT_NODE&&!x.node.isVoid(l)||k(l,O(n,r))?x.node.isBlock(l)?l.style="":x.node.hasClass(l,"fr-clone")||x.node.hasClass(l,"fr-video")||x.opts.trackChangesEnabled?!x.node.hasClass(l,"fr-clone")&&!x.node.hasClass(l,"fr-video")&&x.opts.trackChangesEnabled&&l.parentNode&&(l.outerHTML=l.innerHTML):l.outerHTML=l.innerHTML:void 0===n&&l.nodeType===Node.ELEMENT_NODE&&x.node.isBlock(l)&&!["TABLE","VIDEO"].includes(l.tagName)&&x.node.clearAttributes(l)}else 0<w(l).find(".fr-marker").length&&(t=M(w(l),t,n,r))}return t}(x.$el,0,e,t),n||(x.$el.find(".fr-marker").remove(),x.$el.find(".fr-clone").removeClass("fr-clone").addClass("fr-marker")),n&&x.$el.find(".fr-marker").before(H.INVISIBLE_SPACE).after(H.INVISIBLE_SPACE),x.html.cleanEmptyTags(),x.el.normalize(),x.selection.restore();var p=x.win.getSelection()&&x.win.getSelection().anchorNode;if(p){var u=x.node.blockParent(p),h=!!p.textContent.replace(/\u200B/g,"").length,g=x.win.getSelection().getRangeAt(0),C=g.startOffset,m=g.endOffset;x.selection.text().replace(/\u200B/g,"").length||function A(e,t){if(e&&t){if(e.isSameNode(t)?e.textContent=e.textContent.replace(/\u200B(?=.*\u200B)/g,""):e.nodeType===Node.TEXT_NODE&&(e.textContent=e.textContent.replace(/\u200B/g,"")),!e.childNodes.length)return!1;Array.isArray(e.childNodes)&&e.childNodes.forEach(function(e){A(e,t)})}}(u,p);var v=x.win.getSelection().getRangeAt(0);if(p.nodeType===Node.TEXT_NODE){if(!h||!x.selection.text().length&&C===m){var b=p.textContent.search(/\u200B/g)+1;if(x.browser.msie){var L=x.doc.createRange();x.selection.get().removeAllRanges(),L.setStart(p,b),L.setEnd(p,b),x.selection.get().addRange(L)}else"a"!==e&&(v.setStart(p,b),v.setEnd(p,b))}}else{var E,y,S=0,N=w(p).contents();if(x.browser.msie){for(;y=N[S];)y.nodeType===Node.TEXT_NODE&&0<=y.textContent.search(/\u200B/g)&&(E=y),S++;E=w(E)}else E=N.filter(function(e){return e.nodeType===Node.TEXT_NODE&&0<=e.textContent.search(/\u200B/g)});if(E.length&&!x.opts.trackChangesEnabled){var T=E.text().search(/\u200B/g)+1;v.setStart(E.get(0),T),v.setEnd(E.get(0),T)}}}}function t(e,t){var n,r,o,i,a,s,l,c=null;if(x.selection.isCollapsed()){x.markers.insert();var d=(r=x.$el.find(".fr-marker")).parent();if(x.node.openTagString(d.get(0))==='<span style="'.concat(e,": ").concat(d.css(e),';">')){if(x.node.isEmpty(d.get(0)))c=w(x.doc.createElement("span")).attr("style","".concat(e,": ").concat(t,";")).html("".concat(H.INVISIBLE_SPACE).concat(H.MARKERS)),d.replaceWith(c);else{var f={};f["style*"]="".concat(e,":"),$(r,"span",f,!0),r=x.$el.find(".fr-marker"),t?(c=w(x.doc.createElement("span")).attr("style","".concat(e,": ").concat(t,";")).html("".concat(H.INVISIBLE_SPACE).concat(H.MARKERS)),r.replaceWith(c)):r.replaceWith(H.INVISIBLE_SPACE+H.MARKERS)}x.html.cleanEmptyTags()}else x.node.isEmpty(d.get(0))&&d.is("span")?(r.replaceWith(H.MARKERS),d.css(e,t)):(r.get(0).nextSibling&&x.node.isBlock(r.get(0).nextSibling)&&!r.get(0).previousSibling&&"LI"===r.get(0).parentNode.tagName&&r.get(0).nextSibling.prepend(r.get(0)),c=w(t?'<span style="'.concat(e,": ").concat(t,';">').concat(H.INVISIBLE_SPACE).concat(H.MARKERS,"</span>"):"<span>".concat(H.INVISIBLE_SPACE).concat(H.MARKERS,"</span>")),r.replaceWith(c));c&&v(c,e,t)}else{if(x.selection.save(),null===t||"color"===e&&0<x.$el.find(".fr-marker").parents("u, a").length){var p=x.$el.find(".fr-marker");for(n=0;n<p.length;n++)if(!0===(r=w(p[n])).data("type")||"true"===r.data("type"))for(;x.node.isFirstSibling(r.get(0))&&!r.parent().is(x.$el)&&!x.node.isElement(r.parent().get(0))&&!x.node.isBlock(r.parent().get(0));)r.parent().before(r);else for(;x.node.isLastSibling(r.get(0))&&!r.parent().is(x.$el)&&!x.node.isElement(r.parent().get(0))&&!x.node.isBlock(r.parent().get(0));)r.parent().after(r)}for(var u=x.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling;u.firstChild;)u=u.firstChild;var h={"class":"fr-unprocessed"};for(t&&(h.style="".concat(e,": ").concat(t,";")),b(u,"span",h),x.$el.find(".fr-marker + .fr-unprocessed").each(function(){w(this).prepend(w(this).prev())}),x.$el.find(".fr-unprocessed + .fr-marker").each(function(){w(this).prev().append(w(this))}),(t||"").match(/\dem$/)&&x.$el.find("span.fr-unprocessed").removeClass("fr-unprocessed");0<x.$el.find("span.fr-unprocessed").length;){if(o=L(c=x.$el.find("span.fr-unprocessed").first().removeClass("fr-unprocessed")),c.parent().get(0).normalize(),c.parent().is("span")&&1===c.parent().get(0).childNodes.length){var g=t;x.browser.msie&&!t&&(g=""),c.parent().css(e,g);var C=c;c=c.parent(),C.replaceWith(C.html()),1!==c.parent().get(0).childNodes.length||t||"background-color"!==e||c.parents("span").css(e,t)}for(i=c.find("span"),o&&"background-color"!==e&&(o.normalize(),i=w(o).find("span:not(.fr-unprocessed)")),n=i.length-1;0<=n;n--)a=i[n],s=e,l=void 0,(l=w(a)).css(s,""),""===l.attr("style")&&l.replaceWith(l.html());v(c,e,t)}}!function m(){var e;for(;0<x.$el.find(".fr-split:empty").length;)x.$el.find(".fr-split:empty").remove();x.$el.find(".fr-split").removeClass("fr-split"),x.$el.find('[style=""]').removeAttr("style"),x.$el.find('[class=""]').removeAttr("class"),x.html.cleanEmptyTags();for(var t=x.$el.find("span"),n=t.length-1;0<=n;n--){var r=t[n];r.attributes&&0!==r.attributes.length||w(r).replaceWith(r.innerHTML)}x.el.normalize();var o=x.$el.find("span[style] + span[style]");for(e=0;e<o.length;e++){var i=w(o[e]),a=w(o[e]).prev();i.get(0).previousSibling===a.get(0)&&x.node.openTagString(i.get(0))===x.node.openTagString(a.get(0))&&(i.prepend(a.html()),a.remove())}x.$el.find("span[style] span[style]").each(function(){if(0<=w(this).attr("style").indexOf("font-size")){var e=w(this).parents("span[style]");e.attr("style")&&0<=e.attr("style").indexOf("background-color")&&(w(this).attr("style",function o(e,t){var n=function n(e){return e.split(";").reduce(function(e,t){var n=t.split(":"),r=E(n,2),o=r[0],i=r[1];return o&&i&&(e[o.trim()]=i.trim()),e},{})},r=Object.assign(n(t),n(e));return Object.entries(r).map(function(e){var t=E(e,2),n=t[0],r=t[1];return"".concat(n,": ").concat(r)}).join("; ")}(w(this).attr("style"),e.attr("style"))),$(w(this),"span[style]",{},!1))}}),x.el.normalize(),x.selection.restore()}()}function L(e){var t,n,r,o,i,a;if(t="LI"===e.tagName?e:w(e).parentsUntil(x.$el,"li").get(0)){if((a=x.selection.info(t)).atStart&&a.atEnd)return t;if(a.atStart&&!a.atEnd&&(n=w(t).find(".fr-marker[data-type=false]").get(0),r=w(n).parentsUntil(x.$el,"li").get(0),o=w(n).parentsUntil(r).get(-1),(i=n.nextSibling)&&0<=["UL","OL"].indexOf(i.tagName)||!r.isSameNode(t)||!i&&("LI"===o.tagName||!o.nextSibling||0<=["UL","OL"].indexOf(o.nextSibling.tagName)||x.node.isVoid(o.nextSibling))))return t}}function v(e,t,n){var r,o,i,a=e.parentsUntil(x.$el,"span[style]"),s=[];for(r=a.length-1;0<=r;r--)o=a[r],i=t,0===w(o).attr("style").indexOf("".concat(i,":"))||0<=w(o).attr("style").indexOf(";".concat(i,":"))||0<=w(o).attr("style").indexOf("; ".concat(i,":"))||s.push(a[r]);if((a=a.not(s)).length){var l="",c="",d="",f="",p=e.get(0);do{if(p=p.parentNode,["TABLE","TD","TR"].includes(p.tagName))break;w(p).addClass("fr-split"),l+=x.node.closeTagString(p),c=x.node.openTagString(w(p).clone().addClass("fr-split").get(0))+c,a.get(0)!==p&&(d+=x.node.closeTagString(p),f=x.node.openTagString(w(p).clone().addClass("fr-split").get(0))+f)}while(a.get(0)!==p);var u="".concat(l+x.node.openTagString(w(a.get(0)).clone().css(t,n||"").get(0))+f+e.css(t,"").get(0).outerHTML+d,"</span>").concat(c);e.replaceWith('<span id="fr-break"></span>');var h=a.get(0).outerHTML;w(a.get(0)).replaceWith(h.replace(/<span id="fr-break"><\/span>/g,function(){return u}))}}function d(e,t){void 0===t&&(t={}),t.style&&delete t.style;var n=x.selection.ranges(0),r=n.startContainer;if(r.nodeType===Node.ELEMENT_NODE&&0<r.childNodes.length&&r.childNodes[n.startOffset]&&(r=r.childNodes[n.startOffset]),!n.collapsed&&r.nodeType===Node.TEXT_NODE&&n.startOffset===(r.textContent||"").length){for(;!x.node.isBlock(r.parentNode)&&!r.nextSibling;)r=r.parentNode;r.nextSibling&&(r=r.nextSibling)}for(var o=r;o&&o.nodeType===Node.ELEMENT_NODE&&!k(o,O(e,t));)o=o.firstChild;if(o&&o.nodeType===Node.ELEMENT_NODE&&k(o,O(e,t)))return!0;var i=r;for(i&&i.nodeType!==Node.ELEMENT_NODE&&(i=i.parentNode);i&&i.nodeType===Node.ELEMENT_NODE&&i!==x.el&&!k(i,O(e,t));)i=i.parentNode;return!(!i||i.nodeType!==Node.ELEMENT_NODE||i===x.el||!k(i,O(e,t)))}return{is:d,toggle:function f(e,t){if(x.browser.safari&&x.shared.safariSelection){var n=x.shared.safariSelection,r=n.startContainer,o=n.endContainer,i=n.startOffset,a=n.endOffset,s=x.doc.createRange();s.setStart(r,i),s.setEnd(o,a),x.selection.get().removeAllRanges(),x.selection.get().addRange(s),x.shared.safariSelection=null}d(e,t)?c(e,t):l(e,t)},apply:l,remove:c,applyStyle:t,removeStyle:function n(e){t(e,null)}}},H.MODULES.spaces=function(p){var u=p.$;function r(e,t){var n=e.previousSibling,r=e.nextSibling,o=e.textContent,i=e.parentNode,a=[H.ENTER_P,H.ENTER_DIV,H.ENTER_BR];if(!p.html.isPreformatted(i)){t&&(o=p.opts.preserveTabSpaces?o.replace(/[\f\n\r\v]{2,}/g," "):o.replace(/[\f\n\r\t\v ]{2,}/g," "),r&&"BR"!==r.tagName&&!p.node.isBlock(r)||!(p.node.isBlock(i)||p.node.isLink(i)&&!i.nextSibling||p.node.isElement(i))||(o=o.replace(/[\f\n\r\t\v ]{1,}$/g,"")),n&&"BR"!==n.tagName&&!p.node.isBlock(n)||!(p.node.isBlock(i)||p.node.isLink(i)&&!i.previousSibling||p.node.isElement(i))||(o=o.replace(/^[\f\n\r\t\v ]{1,}/g,"")),(p.node.isBlock(r)||p.node.isBlock(n))&&(!n||n&&"A"!==n.tagName)&&(o=o.replace(/^[\f\n\r\t\v ]{1,}/g,""))," "===o&&(n&&p.node.isVoid(n)||r&&p.node.isVoid(r))&&!(n&&r&&p.node.isVoid(n)||r&&n&&p.node.isVoid(r))&&(o="")),(!n&&p.node.isBlock(r)||!r&&p.node.isBlock(n))&&p.node.isBlock(i)&&i!==p.el&&(o=o.replace(/^[\f\n\r\t\v ]{1,}/g,"")),t||(o=o.replace(new RegExp(H.UNICODE_NBSP,"g")," "));var s=i.nextSibling&&i.nextSibling.tagName,l=i.previousSibling&&i.previousSibling.tagName,c=["SPAN","STRONG","U","EM"];s||u(i).parent().each(function(){return-1!==c.indexOf(this.tagName)&&(this.nextSibling?(s=this.nextSibling&&this.nextSibling.tagName,!1):void 0)}),l||u(i).parent().each(function(){return-1!==c.indexOf(this.tagName)&&(this.previousSibling?(l=this.previousSibling&&this.previousSibling.tagName,!1):void 0)});for(var d="",f=0;f<o.length;f++)32!=o.charCodeAt(f)||0!==f&&32!=d.charCodeAt(f-1)||e.nodeType===Node.TEXT_NODE&&"SPAN"===i.tagName&&i.parentNode&&0<=c.indexOf(i.parentNode.tagName)&&(0<=c.indexOf(s)||0<=c.indexOf(l))||!((p.opts.enter===H.ENTER_BR||p.opts.enter===H.ENTER_DIV)&&(n&&"BR"===n.tagName||r&&"BR"===r.tagName)||n&&r&&n.tagName===r.tagName||!(n&&r&&p.node.isVoid(n)||n&&r&&p.node.isVoid(r))||n&&r&&0<=["STRONG","U","EM"].indexOf(n.tagName)&&"BR"===r.tagName)?d+=o[f]:d+=H.UNICODE_NBSP;p.browser.chrome&&1<d.length&&32===d.charCodeAt(d.length-1)&&(r&&r.nextSibling&&r.nextSibling.nextSibling&&"BR"===r.nextSibling.nextSibling.tagName||r&&"BR"===r.tagName)&&(d=d.substring(0,d.length-1)+H.UNICODE_NBSP),!(!r||r&&p.node.isBlock(r)||r&&r.nodeType===Node.ELEMENT_NODE&&p.win.getComputedStyle(r)&&"block"===p.win.getComputedStyle(r).display)||e.nodeType===Node.TEXT_NODE&&"SPAN"===i.tagName&&i.parentNode&&0<=c.indexOf(i.parentNode.tagName)&&(0<=c.indexOf(s)||0<=c.indexOf(l))||(!p.node.isVoid(n)||n&&-1!==["P","DIV","BR"].indexOf(n.tagName)&&-1!==a.indexOf(p.opts.enter))&&(d=d.replace(/ $/,H.UNICODE_NBSP)),!n||p.node.isVoid(n)||p.node.isBlock(n)||1!==(d=d.replace(/^\u00A0([^ $])/," $1")).length||160!==d.charCodeAt(0)||!r||p.node.isVoid(r)||p.node.isBlock(r)||p.node.hasClass(n,"fr-marker")&&p.node.hasClass(r,"fr-marker")||(d=" "),t||(d=d.replace(/([^ \u00A0])\u00A0([^ \u00A0])/g,"$1 $2")),e.textContent!==d&&(e.textContent=d)}}function l(e,t){if(void 0!==e&&e||(e=p.el),void 0===t&&(t=!1),!e.getAttribute||"false"!==e.getAttribute("contenteditable"))if(e.nodeType===Node.TEXT_NODE)r(e,t);else if(e.nodeType===Node.ELEMENT_NODE)for(var n=p.doc.createTreeWalker(e,NodeFilter.SHOW_TEXT,p.node.filter(function(e){for(var t=e.parentNode;t&&t!==p.el;){if("STYLE"===t.tagName||"IFRAME"===t.tagName)return!1;if("PRE"===t.tagName)return!1;t=t.parentNode}return null!==e.textContent.match(/([ \u00A0\f\n\r\t\v]{2,})|(^[ \u00A0\f\n\r\t\v]{1,})|([ \u00A0\f\n\r\t\v]{1,}$)/g)&&!p.node.hasClass(e.parentNode,"fr-marker")}),!1);n.nextNode();)r(n.currentNode,t)}return{normalize:l,normalizeAroundCursor:function c(){for(var e=[],t=p.el.querySelectorAll(".fr-marker"),n=0;n<t.length;n++){for(var r=null,o=p.node.blockParent(t[n]),i=(r=o||t[n]).nextSibling,a=r.previousSibling;i&&"BR"===i.tagName;)i=i.nextSibling;for(;a&&"BR"===a.tagName;)a=a.previousSibling;r&&e.indexOf(r)<0&&e.push(r),a&&e.indexOf(a)<0&&e.push(a),i&&e.indexOf(i)<0&&e.push(i)}for(var s=0;s<e.length;s++)l(e[s])}}},H.INVISIBLE_SPACE="&#8203;",H.HAIR_SPACE="&#8202;",H.START_MARKER='<span class="fr-marker" data-id="0" data-type="true" style="display: none; line-height: 0;">'.concat(H.INVISIBLE_SPACE,"</span>"),H.END_MARKER='<span class="fr-marker" data-id="0" data-type="false" style="display: none; line-height: 0;">'.concat(H.INVISIBLE_SPACE,"</span>"),H.MARKERS=H.START_MARKER+H.END_MARKER,H.MODULES.markers=function(d){var f=d.$;function l(){if(!d.$wp)return null;try{var e=d.selection.ranges(0),t=e.commonAncestorContainer;if(t!==d.el&&!d.$el.contains(t))return null;var n=e.cloneRange(),r=e.cloneRange();n.collapse(!0);var o=f(d.doc.createElement("SPAN")).addClass("fr-marker").attr("style","display: none; line-height: 0;").html(H.INVISIBLE_SPACE).get(0);if(n.insertNode(o),o=d.$el.find("span.fr-marker").get(0)){for(var i=o.nextSibling;i&&i.nodeType===Node.TEXT_NODE&&0===i.textContent.length;)f(i).remove(),i=d.$el.find("span.fr-marker").get(0).nextSibling;return d.selection.clear(),d.selection.get().addRange(r),o}return null}catch(a){}}function c(){d.$el.find(".fr-marker").remove()}return{place:function p(e,t,n){var r,o,i;try{var a=e.cloneRange();if(a.collapse(t),a.insertNode(function l(e,t){var n=f(d.doc.createElement("SPAN"));return n.addClass("fr-marker").attr("data-id",t).attr("data-type",e).attr("style","display: ".concat(d.browser.safari?"none":"inline-block","; line-height: 0;")).html(H.INVISIBLE_SPACE),n.get(0)}(t,n)),!0===t)for(i=(r=d.$el.find('span.fr-marker[data-type="true"][data-id="'.concat(n,'"]')).get(0)).nextSibling;i&&i.nodeType===Node.TEXT_NODE&&0===i.textContent.length;)f(i).remove(),i=r.nextSibling;if(!0===t&&!e.collapsed){for(;!d.node.isElement(r.parentNode)&&!i;)-1</\bfa\b/g.test(r.parentNode.className)&&"I"===r.parentNode.tagName?f(r.parentNode).before(r):f(r.parentNode).after(r),i=r.nextSibling;if(i&&i.nodeType===Node.ELEMENT_NODE&&d.node.isBlock(i)&&"HR"!==i.tagName){for(o=[i];i=o[0],(o=d.node.contents(i))[0]&&d.node.isBlock(o[0]););f(i).prepend(f(r))}}if(!1===t&&!e.collapsed){if((i=(r=d.$el.find('span.fr-marker[data-type="false"][data-id="'.concat(n,'"]')).get(0)).previousSibling)&&i.nodeType===Node.ELEMENT_NODE&&d.node.isBlock(i)&&!["TABLE","HR"].includes(i.tagName)){for(o=[i];i=o[o.length-1],(o=d.node.contents(i))[o.length-1]&&d.node.isBlock(o[o.length-1]););f(i).append(f(r))}(r.parentNode&&0<=["TD","TH"].indexOf(r.parentNode.tagName)||!r.previousSibling&&d.node.isBlock(r.parentElement))&&(r.parentNode.previousSibling&&!r.previousSibling?f(r.parentNode.previousSibling).append(r):0<=["TD","TH"].indexOf(r.parentNode.tagName)&&r.parentNode.firstChild===r&&(r.parentNode.previousSibling?f(r.parentNode.previousSibling).append(r):r.parentNode.parentNode&&r.parentNode.parentNode.previousSibling&&f(r.parentNode.parentNode.previousSibling).append(r)))}var s=d.$el.find('span.fr-marker[data-type="'.concat(t,'"][data-id="').concat(n,'"]')).get(0);return s&&(s.style.display="none"),s}catch(c){return null}},insert:l,split:function a(){d.selection.isCollapsed()||d.selection.remove();var e=d.$el.find(".fr-marker").get(0);if(e||(e=l()),!e)return null;var t=d.node.deepestParent(e);if(t||(t=d.node.blockParent(e))&&"LI"!==t.tagName&&(t=null),t)if(d.node.isBlock(t)&&d.node.isEmpty(t))"LI"!==t.tagName||t.parentNode.firstElementChild!==t||d.node.isEmpty(t.parentNode)?f(t).replaceWith('<span class="fr-marker"></span>'):f(t).append('<span class="fr-marker"></span>');else if(d.cursor.isAtStart(e,t))f(t).before('<span class="fr-marker"></span>'),f(e).remove();else if(d.cursor.isAtEnd(e,t))f(t).after('<span class="fr-marker"></span>'),f(e).remove();else if("true"!==t.contentEditable){for(var n=e,r="",o="";n=n.parentNode,r+=d.node.closeTagString(n),o=d.node.openTagString(n)+o,n!==t;);f(e).replaceWith('<span id="fr-break"></span>');var i=d.node.openTagString(t)+f(t).html()+d.node.closeTagString(t);i=i.replace(/<span id="fr-break"><\/span>/g,"".concat(r,'<span class="fr-marker"></span>').concat(o)),f(t).replaceWith(i)}return d.$el.find(".fr-marker").get(0)},insertAtPoint:function u(e){var t,n=e.clientX,r=e.clientY;c();var o=null;if("undefined"!=typeof d.doc.caretPositionFromPoint?(t=d.doc.caretPositionFromPoint(n,r),(o=d.doc.createRange()).setStart(t.offsetNode,t.offset),o.setEnd(t.offsetNode,t.offset)):"undefined"!=typeof d.doc.caretRangeFromPoint&&(t=d.doc.caretRangeFromPoint(n,r),(o=d.doc.createRange()).setStart(t.startContainer,t.startOffset),o.setEnd(t.startContainer,t.startOffset)),null!==o&&"undefined"!=typeof d.win.getSelection){var i=d.win.getSelection();i.removeAllRanges(),i.addRange(o)}else if("undefined"!=typeof d.doc.body.createTextRange)try{(o=d.doc.body.createTextRange()).moveToPoint(n,r);var a=o.duplicate();a.moveToPoint(n,r),o.setEndPoint("EndToEnd",a),o.select()}catch(s){return!1}l()},remove:c}},H.MODULES.selection=function(E){var y=E.$;function s(){var e="";return E.win.getSelection?e=E.win.getSelection():E.doc.getSelection?e=E.doc.getSelection():E.doc.selection&&(e=E.doc.selection.createRange().text),e.toString()}function L(){return E.win.getSelection?E.win.getSelection():E.doc.getSelection?E.doc.getSelection():E.doc.selection.createRange()}function p(e){var t=L(),n=[];if(t&&t.getRangeAt&&t.rangeCount){n=[];for(var r=0;r<t.rangeCount;r++)n.push(t.getRangeAt(r))}else n=E.doc.createRange?[E.doc.createRange()]:[];return void 0!==e?n[e]:n}function S(){var e=L();try{e.removeAllRanges?e.removeAllRanges():e.empty?e.empty():e.clear&&e.clear()}catch(t){}}function u(e,t){var n=e;return n.nodeType===Node.ELEMENT_NODE&&0<n.childNodes.length&&n.childNodes[t]&&(n=n.childNodes[t]),n.nodeType===Node.TEXT_NODE&&(n=n.parentNode),n}function N(){if(E.$wp){E.markers.remove();var e,t,n=p(),r=[];for(t=0;t<n.length;t++)if(n[t].startContainer!==E.doc||E.browser.msie){var o=(e=n[t]).collapsed,i=E.markers.place(e,!0,t),a=E.markers.place(e,!1,t);if(void 0!==i&&i||!o||(y(".fr-marker").remove(),E.selection.setAtEnd(E.el)),E.el.normalize(),E.browser.safari&&!o)try{(e=E.doc.createRange()).setStartAfter(i),e.setEndBefore(a),r.push(e)}catch(s){}}if(E.browser.safari&&r.length)for(E.selection.clear(),t=0;t<r.length;t++)E.selection.get().addRange(r[t])}}function T(){var e,t=E.el.querySelectorAll('.fr-marker[data-type="true"]');if(!E.$wp)return E.markers.remove(),!1;if(0===t.length)return!1;if(E.browser.msie||E.browser.edge)for(e=0;e<t.length;e++)t[e].style.display="inline-block";E.core.hasFocus()||E.browser.msie||E.browser.webkit||E.$el.focus(),S();var n=L();for(e=0;e<t.length;e++){var r=y(t[e]).data("id"),o=t[e],i=E.doc.createRange(),a=E.$el.find('.fr-marker[data-type="false"][data-id="'.concat(r,'"]'));(E.browser.msie||E.browser.edge)&&a.css("display","inline-block");var s=null;if(0<a.length){a=a[0];try{for(var l=!1,c=o.nextSibling,d=null;c&&c.nodeType===Node.TEXT_NODE&&0===c.textContent.length;)c=(d=c).nextSibling,y(d).remove();for(var f=a.nextSibling;f&&f.nodeType===Node.TEXT_NODE&&0===f.textContent.length;)f=(d=f).nextSibling,y(d).remove();if(o.nextSibling===a||a.nextSibling===o){for(var p=o.nextSibling===a?o:a,u=p===o?a:o,h=p.previousSibling;h&&h.nodeType===Node.TEXT_NODE&&0===h.length;)h=(d=h).previousSibling,y(d).remove();if(h&&h.nodeType===Node.TEXT_NODE)for(;h&&h.previousSibling&&h.previousSibling.nodeType===Node.TEXT_NODE;)h.previousSibling.textContent+=h.textContent,h=h.previousSibling,y(h.nextSibling).remove();for(var g=u.nextSibling;g&&g.nodeType===Node.TEXT_NODE&&0===g.length;)g=(d=g).nextSibling,y(d).remove();if(g&&g.nodeType===Node.TEXT_NODE)for(;g&&g.nextSibling&&g.nextSibling.nodeType===Node.TEXT_NODE;)g.nextSibling.textContent=g.textContent+g.nextSibling.textContent,g=g.nextSibling,y(g.previousSibling).remove();if(h&&(E.node.isVoid(h)||E.node.isBlock(h))&&(h=null),g&&(E.node.isVoid(g)||E.node.isBlock(g))&&(g=null),h&&g&&h.nodeType===Node.TEXT_NODE&&g.nodeType===Node.TEXT_NODE){y(o).remove(),y(a).remove();var C=h.textContent.length;h.textContent+=g.textContent,y(g).remove(),E.spaces.normalize(h),i.setStart(h,C),i.setEnd(h,C),l=!0}else!h&&g&&g.nodeType===Node.TEXT_NODE?(y(o).remove(),y(a).remove(),E.opts.htmlUntouched||E.spaces.normalize(g),s=y(E.doc.createTextNode("\u200b")).get(0),y(g).before(s),i.setStart(g,0),i.setEnd(g,0),l=!0):!g&&h&&h.nodeType===Node.TEXT_NODE&&(y(o).remove(),y(a).remove(),E.opts.htmlUntouched||E.spaces.normalize(h),s=y(E.doc.createTextNode("\u200b")).get(0),y(h).after(s),i.setStart(h,h.textContent.length),i.setEnd(h,h.textContent.length),l=!0)}if(!l){var m=void 0,v=void 0;v=(E.browser.chrome||E.browser.edge||E.helpers.isIOS())&&o.nextSibling===a?(m=M(a,i,!0)||i.setStartAfter(a),M(o,i,!1)||i.setEndBefore(o)):(o.previousSibling===a&&(a=(o=a).nextSibling),a.nextSibling&&"BR"===a.nextSibling.tagName||!a.nextSibling&&E.node.isBlock(o.previousSibling)||o.previousSibling&&"BR"===o.previousSibling.tagName||(o.style.display="inline",a.style.display="inline",s=y(E.doc.createTextNode("\u200b")).get(0)),m=M(o,i,!0)||y(o).before(s)&&i.setStartBefore(o),M(a,i,!1)||y(a).after(s)&&i.setEndAfter(a)),"function"==typeof m&&m(),"function"==typeof v&&v()}}catch(b){}}s&&y(s).remove();try{n.addRange(i)}catch(b){}}E.markers.remove()}function M(e,t,n){var r,o=e.previousSibling,i=e.nextSibling;return o&&i&&o.nodeType===Node.TEXT_NODE&&i.nodeType===Node.TEXT_NODE?(r=o.textContent.length,n?(i.textContent=o.textContent+i.textContent,y(o).remove(),y(e).remove(),E.opts.htmlUntouched||E.spaces.normalize(i),function(){t.setStart(i,r)}):(o.textContent+=i.textContent,y(i).remove(),y(e).remove(),E.opts.htmlUntouched||E.spaces.normalize(o),function(){t.setEnd(o,r)})):o&&!i&&o.nodeType===Node.TEXT_NODE?(r=o.textContent.length,n?(E.opts.htmlUntouched||E.spaces.normalize(o),function(){t.setStart(o,r)}):(E.opts.htmlUntouched||E.spaces.normalize(o),function(){t.setEnd(o,r)})):!(!i||o||i.nodeType!==Node.TEXT_NODE)&&(n?(E.opts.htmlUntouched||E.spaces.normalize(i),function(){t.setStart(i,0)}):(E.opts.htmlUntouched||E.spaces.normalize(i),function(){t.setEnd(i,0)}))}function A(){for(var e=p(),t=0;t<e.length;t++)if(!e[t].collapsed)return!1;return!0}function o(e){var t,n,r=!1,o=!1;if(E.win.getSelection){var i=E.win.getSelection();i.rangeCount&&((n=(t=i.getRangeAt(0)).cloneRange()).selectNodeContents(e),n.setEnd(t.startContainer,t.startOffset),r=a(n),n.selectNodeContents(e),n.setStart(t.endContainer,t.endOffset),o=a(n))}else E.doc.selection&&"Control"!==E.doc.selection.type&&((n=(t=E.doc.selection.createRange()).duplicate()).moveToElementText(e),n.setEndPoint("EndToStart",t),r=a(n),n.moveToElementText(e),n.setEndPoint("StartToEnd",t),o=a(n));return{atStart:r,atEnd:o}}function a(e){return""===e.toString().replace(/[\u200B-\u200D\uFEFF]/g,"")}function x(e,t){void 0===t&&(t=!0);var n=y(e).html();n&&n.replace(/\u200b/g,"").length!==n.length&&y(e).html(n.replace(/\u200b/g,""));for(var r=E.node.contents(e),o=0;o<r.length;o++)r[o].nodeType!==Node.ELEMENT_NODE?y(r[o]).remove():(x(r[o],0===o),0===o&&(t=!1));if(e.nodeType===Node.TEXT_NODE){var i=y(document.createElement("span")).attr("data-first","true").attr("data-text","true");y(e)[0].replaceWith(i[0])}else t&&y(e).attr("data-first",!0)}function w(){return 0===y(this).find("fr-inner").length}function h(){try{if(!E.$wp)return!1;for(var e=p(0).commonAncestorContainer;e&&!E.node.isElement(e);)e=e.parentNode;return!!E.node.isElement(e)}catch(t){return!1}}function r(e,t){if(!e||0<e.getElementsByClassName("fr-marker").length)return!1;for(var n=e.firstChild;n&&(E.node.isBlock(n)||t&&!E.node.isVoid(n)&&n.nodeType===Node.ELEMENT_NODE);)n=(e=n).firstChild;e.innerHTML=H.MARKERS+e.innerHTML}function i(e,t){if(!e||0<e.getElementsByClassName("fr-marker").length)return!1;for(var n=e.lastChild;n&&(E.node.isBlock(n)||t&&!E.node.isVoid(n)&&n.nodeType===Node.ELEMENT_NODE);)n=(e=n).lastChild;var r=E.doc.createElement("SPAN");for(r.setAttribute("id","fr-sel-markers"),r.innerHTML=H.MARKERS;e.parentNode&&E.opts.htmlAllowedEmptyTags&&0<=E.opts.htmlAllowedEmptyTags.indexOf(e.tagName.toLowerCase());)e=e.parentNode;e.appendChild(r);var o=e.querySelector("#fr-sel-markers");o.outerHTML=o.innerHTML}return{text:s,get:L,ranges:p,clear:S,element:function l(){var e=L();try{if(e.rangeCount){var t,n=p(0),r=n.startContainer;if(E.node.isElement(r)&&0===n.startOffset&&r.childNodes.length)for(;r.childNodes.length&&r.childNodes[0].nodeType===Node.ELEMENT_NODE;)r=r.childNodes[0];if(r.nodeType===Node.TEXT_NODE&&n.startOffset===(r.textContent||"").length&&r.nextSibling&&(r=r.nextSibling),r.nodeType===Node.ELEMENT_NODE){var o=!1;if(E.node.isElement(r)&&""==r.textContent&&"IMG"==r.childNodes[0].tagName&&r.childNodes.length)for(;r.childNodes.length&&r.childNodes[0].nodeType===Node.ELEMENT_NODE;)r=r.childNodes[0];if(0<r.childNodes.length&&r.childNodes[n.startOffset]){for(t=r.childNodes[n.startOffset];t&&t.nodeType===Node.TEXT_NODE&&0===t.textContent.length;)t=t.nextSibling;if(t&&t.textContent.replace(/\u200B/g,"")===s().replace(/\u200B/g,"")&&(r=t,o=!0),!o&&1<r.childNodes.length&&0<n.startOffset&&r.childNodes[n.startOffset-1]){for(t=r.childNodes[n.startOffset-1];t&&t.nodeType===Node.TEXT_NODE&&0===t.textContent.length;)t=t.nextSibling;t&&t.textContent.replace(/\u200B/g,"")===s().replace(/\u200B/g,"")&&(r=t,o=!0)}}else!n.collapsed&&r.nextSibling&&r.nextSibling.nodeType===Node.ELEMENT_NODE&&(t=r.nextSibling)&&t.textContent.replace(/\u200B/g,"")===s().replace(/\u200B/g,"")&&(r=t,o=!0);!o&&0<r.childNodes.length&&y(r.childNodes[0]).text().replace(/\u200B/g,"")===s().replace(/\u200B/g,"")&&["BR","IMG","HR"].indexOf(r.childNodes[0].tagName)<0&&(r=r.childNodes[0])}for(;r.nodeType!==Node.ELEMENT_NODE&&r.parentNode;)r=r.parentNode;for(var i=r;i&&"HTML"!==i.tagName;){if(i===E.el)return r;i=y(i).parent()[0]}}}catch(a){}return E.el},endElement:function c(){var e=L();try{if(e.rangeCount){var t,n=p(0),r=n.endContainer;if(r.nodeType===Node.ELEMENT_NODE){var o=!1;0<r.childNodes.length&&r.childNodes[n.endOffset]&&y(r.childNodes[n.endOffset]).text()===s()?(r=r.childNodes[n.endOffset],o=!0):!n.collapsed&&r.previousSibling&&r.previousSibling.nodeType===Node.ELEMENT_NODE?(t=r.previousSibling)&&t.textContent.replace(/\u200B/g,"")===s().replace(/\u200B/g,"")&&(r=t,o=!0):!n.collapsed&&0<r.childNodes.length&&r.childNodes[n.endOffset]&&(t=r.childNodes[n.endOffset].previousSibling).nodeType===Node.ELEMENT_NODE&&t&&t.textContent.replace(/\u200B/g,"")===s().replace(/\u200B/g,"")&&(r=t,o=!0),!o&&0<r.childNodes.length&&y(r.childNodes[r.childNodes.length-1]).text()===s()&&["BR","IMG","HR"].indexOf(r.childNodes[r.childNodes.length-1].tagName)<0&&(r=r.childNodes[r.childNodes.length-1])}for(r.nodeType===Node.TEXT_NODE&&0===n.endOffset&&r.previousSibling&&r.previousSibling.nodeType===Node.ELEMENT_NODE&&(r=r.previousSibling);r.nodeType!==Node.ELEMENT_NODE&&r.parentNode;)r=r.parentNode;for(var i=r;i&&"HTML"!==i.tagName;){if(i===E.el)return r;i=y(i).parent()[0]}}}catch(a){}return E.el},save:N,restore:T,isCollapsed:A,isFull:function d(){if(A())return!1;E.selection.save();var e,t=E.el.querySelectorAll("td, th, img, br, iframe");for(e=0;e<t.length;e++)(t[e].nextSibling||"IMG"===t[e].tagName||"IFRAME"===t[e].tagName)&&(t[e].innerHTML='<span class="fr-mk" style="display: none;">&nbsp;</span>'.concat(t[e].innerHTML));var n=!1,r=o(E.el);for(r.atStart&&r.atEnd&&(n=!0),t=E.el.querySelectorAll(".fr-mk"),e=0;e<t.length;e++)t[e].parentNode.removeChild(t[e]);return E.selection.restore(),n},inEditor:h,remove:function O(){if(A())return!0;var e;function t(e){for(var t=e.previousSibling;t&&t.nodeType===Node.TEXT_NODE&&0===t.textContent.length;){var n=t;t=t.previousSibling,y(n).remove()}return t}function n(e){for(var t=e.nextSibling;t&&t.nodeType===Node.TEXT_NODE&&0===t.textContent.length;){var n=t;t=t.nextSibling,y(n).remove()}return t}N();var r=E.$el.find('.fr-marker[data-type="true"]');for(e=0;e<r.length;e++)for(var o=r[e];!(t(o)||E.node.isBlock(o.parentNode)||E.$el.is(o.parentNode)||E.node.hasClass(o.parentNode,"fr-inner"));)y(o.parentNode).before(o);var i=E.$el.find('.fr-marker[data-type="false"]');for(e=0;e<i.length;e++){for(var a=i[e];!(n(a)||E.node.isBlock(a.parentNode)||E.$el.is(a.parentNode)||E.node.hasClass(a.parentNode,"fr-inner"));)y(a.parentNode).after(a);a.parentNode&&E.node.isBlock(a.parentNode)&&E.node.isEmpty(a.parentNode)&&!E.$el.is(a.parentNode)&&!E.node.hasClass(a.parentNode,"fr-inner")&&E.opts.keepFormatOnDelete&&y(a.parentNode).after(a)}if(function b(){for(var e=E.$el.find(".fr-marker"),t=0;t<e.length;t++)if(y(e[t]).parentsUntil('.fr-element, [contenteditable="true"]','[contenteditable="false"]').length)return!1;return!0}()){!function L(e,t){var n=E.node.contents(e.get(0));0<=["TD","TH"].indexOf(e.get(0).tagName)&&1===e.find(".fr-marker").length&&(E.node.hasClass(n[0],"fr-marker")||"BR"==n[0].tagName&&E.node.hasClass(n[0].nextElementSibling,"fr-marker"))&&e.attr("data-del-cell",!0);for(var r=0;r<n.length;r++){var o=n[r];E.node.hasClass(o,"fr-marker")?t=(t+1)%2:t?0<y(o).find(".fr-marker").length?t=L(y(o),t):["TD","TH"].indexOf(o.tagName)<0&&!E.node.hasClass(o,"fr-inner")?!E.opts.keepFormatOnDelete||0<E.$el.find("[data-first]").length||E.node.isVoid(o)?y(o).remove():x(o):E.node.hasClass(o,"fr-inner")?0===y(o).find(".fr-inner").length?y(o).html("<br>"):y(o).find(".fr-inner").filter(w).html("<br>"):(y(o).empty(),y(o).attr("data-del-cell",!0)):0<y(o).find(".fr-marker").length&&(t=L(y(o),t))}return t}(E.$el,0);var s=E.$el.find('[data-first="true"]');if(s.length)E.$el.find(".fr-marker").remove(),s.append(H.INVISIBLE_SPACE+H.MARKERS).removeAttr("data-first"),s.attr("data-text")&&s.replaceWith(s.html());else for(E.$el.find("table").filter(function(){return 0<y(this).find("[data-del-cell]").length&&y(this).find("[data-del-cell]").length===y(this).find("td, th").length}).remove(),E.$el.find("[data-del-cell]").removeAttr("data-del-cell"),r=E.$el.find('.fr-marker[data-type="true"]'),e=0;e<r.length;e++){var l=r[e],c=l.nextSibling,d=E.$el.find('.fr-marker[data-type="false"][data-id="'.concat(y(l).data("id"),'"]')).get(0);if(d){if(l&&(!c||c!==d)){var f=E.node.blockParent(l),p=E.node.blockParent(d),u=!1,h=!1;if(f&&0<=["UL","OL"].indexOf(f.tagName)&&(u=!(f=null)),p&&0<=["UL","OL"].indexOf(p.tagName)&&(h=!(p=null)),y(l).after(d),f!==p)if(null!==f||u)if(null!==p||h||0!==y(f).parentsUntil(E.$el,"table").length)f&&p&&0===y(f).parentsUntil(E.$el,"table").length&&0===y(p).parentsUntil(E.$el,"table").length&&!y(f).contains(p)&&!y(p).contains(f)&&(y(f).append(y(p).html()),y(p).remove());else{for(c=f;!c.nextSibling&&c.parentNode!==E.el;)c=c.parentNode;for(c=c.nextSibling;c&&"BR"!==c.tagName;){var g=c.nextSibling;y(f).append(c),c=g}c&&"BR"===c.tagName&&y(c).remove()}else{var C=E.node.deepestParent(l);C?(y(C).after(y(p).html()),y(p).remove()):0===y(p).parentsUntil(E.$el,"table").length&&(y(l).next().after(y(p).html()),y(p).remove())}}}else d=y(l).clone().attr("data-type",!1),y(l).after(d)}}E.$el.find("li:empty").remove(),E.opts.keepFormatOnDelete||E.html.fillEmptyBlocks(),E.html.cleanEmptyTags(!0),E.opts.htmlUntouched||(E.clean.lists(),E.$el.find("li:empty").append("<br>"),E.spaces.normalize());var m=E.$el.find(".fr-marker").last().get(0),v=E.$el.find(".fr-marker").first().get(0);void 0!==m&&void 0!==v&&!m.nextSibling&&v.previousSibling&&"BR"===v.previousSibling.tagName&&E.node.isElement(m.parentNode)&&E.node.isElement(v.parentNode)&&E.$el.append("<br>"),T()},blocks:function g(e,t){var n,r,o=[],i=L();if(h()&&i.rangeCount){var a=p();for(n=0;n<a.length;n++){var s=a[n],l=u(s.startContainer,s.startOffset),c=u(s.endContainer,s.endOffset);(r=E.node.blockParent(l))&&o.indexOf(r)<0&&o.push(r),(E.node.isBlock(l)||E.node.hasClass(l,"fr-inner"))&&o.indexOf(l)<0&&o.push(l);for(var d=[],f=l;f!==c&&f!==E.el;)d.indexOf(f)<0&&f.children&&f.children.length?(d.push(f),f=f.children[0]):f.nextSibling?f=f.nextSibling:f.parentNode&&(f=f.parentNode,d.push(f)),E.node.isBlock(f)&&d.indexOf(f)<0&&o.indexOf(f)<0&&(f!==c||0<s.endOffset)&&o.push(f);E.node.isBlock(c)&&o.indexOf(c)<0&&0<s.endOffset&&o.push(c),(r=E.node.blockParent(c))&&o.indexOf(r)<0&&o.push(r)}}for(n=o.length-1;0<n;n--)if(y(o[n-1]).contains(o[n])){if(e&&y(o[n]).find("ul, ol").length)continue;if(t&&"LI"==o[n-1].tagName)continue;o.splice(n-1,1)}else if(y(o[n]).contains(o[n-1])){if(e&&y(o[n]).find("ul, ol").length)continue;o.splice(n,1)}return o},info:o,setAtEnd:i,setAtStart:r,setBefore:function f(e,t){void 0===t&&(t=!0);for(var n=e.previousSibling;n&&n.nodeType===Node.TEXT_NODE&&0===n.textContent.length;)n=n.previousSibling;return n?(E.node.isBlock(n)?i(n):"BR"===n.tagName?y(n).before(H.MARKERS):y(n).after(H.MARKERS),!0):!!t&&(E.node.isBlock(e)?r(e):y(e).before(H.MARKERS),!0)},setAfter:function C(e,t){void 0===t&&(t=!0);for(var n=e.nextSibling;n&&n.nodeType===Node.TEXT_NODE&&0===n.textContent.length;)n=n.nextSibling;return n?(E.node.isBlock(n)?r(n):y(n).before(H.MARKERS),!0):!!t&&(E.node.isBlock(e)?i(e):y(e).after(H.MARKERS),!0)},rangeElement:u}},Object.assign(H.DEFAULTS,{language:null}),H.LANGUAGE={},H.MODULES.language=function(e){var t;return{_init:function n(){H.LANGUAGE&&(t=H.LANGUAGE[e.opts.language]),t&&t.direction&&(e.opts.direction=t.direction)},translate:function r(e){return t&&t.translation[e]&&t.translation[e].length?t.translation[e]:e}}},Object.assign(H.DEFAULTS,{placeholderText:"Type something"}),H.MODULES.placeholder=function(f){var p=f.$;function e(){f.$placeholder||function d(){f.$placeholder=p(f.doc.createElement("SPAN")).addClass("fr-placeholder"),f.$wp.append(f.$placeholder)}();var e=f.opts.iframe?f.$iframe.prev().outerHeight(!0):f.$el.prev().outerHeight(!0),t=0,n=0,r=0,o=0,i=0,a=0,s=f.node.contents(f.el),l=p(f.selection.element()).css("text-align");if(s.length&&s[0].nodeType===Node.ELEMENT_NODE){var c=p(s[0]);(0<f.$wp.prev().length||0<f.$el.prev().length)&&f.ready&&(t=f.helpers.getPX(c.css("margin-top")),o=f.helpers.getPX(c.css("padding-top")),n=f.helpers.getPX(c.css("margin-left")),r=f.helpers.getPX(c.css("margin-right")),i=f.helpers.getPX(c.css("padding-left")),a=f.helpers.getPX(c.css("padding-right"))),f.$placeholder.css("font-size",c.css("font-size")),f.$placeholder.css("line-height",c.css("line-height"))}else f.$placeholder.css("font-size",f.$el.css("font-size")),f.$placeholder.css("line-height",f.$el.css("line-height"));f.$wp.addClass("show-placeholder"),f.$placeholder.css({marginTop:Math.max(f.helpers.getPX(f.$el.css("margin-top")),t)+(e||0),paddingTop:Math.max(f.helpers.getPX(f.$el.css("padding-top")),o),paddingLeft:Math.max(f.helpers.getPX(f.$el.css("padding-left")),i),marginLeft:Math.max(f.helpers.getPX(f.$el.css("margin-left")),n),paddingRight:Math.max(f.helpers.getPX(f.$el.css("padding-right")),a),marginRight:Math.max(f.helpers.getPX(f.$el.css("margin-right")),r),textAlign:l}).text(f.language.translate(f.opts.placeholderText||f.$oel.attr("placeholder")||"")),f.$placeholder.html(f.$placeholder.text().replace(/\n/g,"<br>"))}function t(){f.$wp.removeClass("show-placeholder")}function n(){if(!f.$wp)return!1;f.core.isEmpty()?e():t()}return{_init:function r(){if(!f.$wp)return!1;f.events.on("init input keydown keyup contentChanged initialized",n)},show:e,hide:t,refresh:n,isVisible:function o(){return!f.$wp||f.node.hasClass(f.$wp.get(0),"show-placeholder")}}},H.UNICODE_NBSP=String.fromCharCode(160),H.VOID_ELEMENTS=["area","base","br","col","embed","hr","img","input","keygen","link","menuitem","meta","param","source","track","wbr"],H.BLOCK_TAGS=["address","article","aside","audio","blockquote","canvas","details","dd","div","dl","dt","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","li","main","nav","noscript","ol","output","p","pre","section","table","tbody","td","tfoot","th","thead","tr","ul","video"],Object.assign(H.DEFAULTS,{htmlAllowedEmptyTags:["textarea","a","iframe","object","video","style","script",".fa",".fr-emoticon",".fr-inner","path","line","hr"],htmlDoNotWrapTags:["script","style"],htmlSimpleAmpersand:!1,htmlIgnoreCSSProperties:[],htmlExecuteScripts:!0}),H.MODULES.html=function(R){var b=R.$;function v(){return R.opts.enter===H.ENTER_P?"p":R.opts.enter===H.ENTER_DIV?"div":R.opts.enter===H.ENTER_BR?null:void 0}function s(e,t){return!(!e||e===R.el)&&(t?-1!=["PRE","SCRIPT","STYLE"].indexOf(e.tagName)||s(e.parentNode,t):-1!==["PRE","SCRIPT","STYLE"].indexOf(e.tagName))}function i(e){var t,n=[],r=[];if(e){var o=R.el.querySelectorAll(".fr-marker");for(t=0;t<o.length;t++){var i=R.node.blockParent(o[t])||o[t];if(i){var a=i.nextSibling,s=i.previousSibling;i&&r.indexOf(i)<0&&R.node.isBlock(i)&&r.push(i),s&&R.node.isBlock(s)&&r.indexOf(s)<0&&r.push(s),a&&R.node.isBlock(a)&&r.indexOf(a)<0&&r.push(a)}}}else r=R.el.querySelectorAll(p());var l=p();for(l+=",".concat(H.VOID_ELEMENTS.join(",")),l+=", .fr-inner",l+=",".concat(R.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"),":not(.fr-marker)"),t=r.length-1;0<=t;t--)if(!(r[t].textContent&&0<r[t].textContent.replace(/\u200B|\n/g,"").length||0<r[t].querySelectorAll(l).length)){for(var c=R.node.contents(r[t]),d=!1,f=0;f<c.length;f++)if(c[f].nodeType!==Node.COMMENT_NODE&&c[f].textContent&&0<c[f].textContent.replace(/\u200B|\n/g,"").length){d=!0;break}d||n.push(r[t])}return n}function p(){return H.BLOCK_TAGS.join(", ")}function e(e){var t,n,r=b.merge([],H.VOID_ELEMENTS);r=b.merge(r,R.opts.htmlAllowedEmptyTags),r=void 0===e?b.merge(r,H.BLOCK_TAGS):b.merge(r,H.NO_DELETE_TAGS),t=R.el.querySelectorAll("*:empty:not(".concat(r.join("):not("),"):not(.fr-marker):not(template)"));do{n=!1;for(var o=0;o<t.length;o++)0!==t[o].attributes.length&&void 0===t[o].getAttribute("href")||(t[o].parentNode.removeChild(t[o]),n=!0);(t=R.el.querySelectorAll("*:empty:not(".concat(r.join("):not("),"):not(.fr-marker):not(template)"))).length||(t=R.el.querySelectorAll("a[href]:not([name]):empty"))}while(t.length&&n)}function a(e,t){var n=v();if(t&&(n="div"),n){var r=R.doc.createDocumentFragment(),o=null,i=!1,a=e.firstChild,s=!1,l=null,c=R.selection.ranges(),d=null,f=null,p=null;c.length&&(d=c[0].endContainer,f=c[0].startOffset,p=c[0].endOffset);for(var u=!1,h=function h(e,t){e===d?(u=!0,l=t.lastChild):0<=Array.from(e.childNodes).indexOf(d)&&(u=!0,l=t.lastChild.childNodes[Array.from(e.childNodes).indexOf(d)])};a;){var g=a.nextSibling;if(a.nodeType===Node.ELEMENT_NODE&&(R.node.isBlock(a)||0<=R.opts.htmlDoNotWrapTags.indexOf(a.tagName.toLowerCase())&&!R.node.hasClass(a,"fr-marker")))o=null,r.appendChild(a.cloneNode(!0));else if(a.nodeType!==Node.ELEMENT_NODE&&a.nodeType!==Node.TEXT_NODE)o=null,r.appendChild(a.cloneNode(!0));else if("BR"===a.tagName)null===o?(o=R.doc.createElement(n),t&&(o.setAttribute("class","fr-temp-div"),o.setAttribute("data-empty",!0)),o.appendChild(a.cloneNode(!0)),a&&a.parentNode&&["TD","TH"].indexOf(a.parentNode.tagName)<0&&(r.appendChild(o),s=!0)):!1===i&&(o.appendChild(R.doc.createElement("br")),t&&(o.setAttribute("class","fr-temp-div"),o.setAttribute("data-empty",!0))),o=null;else{var C=a.textContent;if(a.nodeType!==Node.TEXT_NODE||0<C.replace(/\n/g,"").replace(/(^ *)|( *$)/g,"").length||C.replace(/(^ *)|( *$)/g,"").length&&C.indexOf("\n")<0){if("SPAN"===a.tagName&&b(a).hasClass("fr-marker")&&!a.previousSibling&&(a.nextSibling&&"TABLE"==a.nextSibling.tagName||a.nextSibling&&a.nextSibling.nextSibling&&"TABLE"==a.nextSibling.nextSibling.tagName)){r.appendChild(a),h(a,r),a=g;continue}if("SPAN"===a.tagName&&b(a).hasClass("fr-marker")&&a.previousSibling&&a.previousSibling.nodeType===Node.ELEMENT_NODE&&(a.nextSibling&&"TABLE"==a.nextSibling.tagName||a.nextSibling&&a.nextSibling.nextSibling&&"TABLE"==a.nextSibling.nextSibling.tagName)){r.appendChild(a),s=!0,h(a,r),a=g;continue}null===o&&(o=R.doc.createElement(n),s=!0,t&&o.setAttribute("class","fr-temp-div"),r.appendChild(o),i=!1),o.appendChild(a.cloneNode(!0)),i||R.node.hasClass(a,"fr-marker")||a.nodeType===Node.TEXT_NODE&&0===C.replace(/ /g,"").length||(i=!0),h(a,o)}else s=!0}a=g}if(s&&(e.innerHTML="",e.appendChild(r),u)){var m=R.doc.createRange();R.selection.get().removeAllRanges(),m.setStart(l,f),m.setEnd(l,p),R.selection.get().addRange(m)}}}function l(e,t){for(var n=e.length-1;0<=n;n--)a(e[n],t)}function t(e,t,n,r,o){if(!R.$wp)return!1;void 0===e&&(e=!1),void 0===t&&(t=!1),void 0===n&&(n=!1),void 0===r&&(r=!1),void 0===o&&(o=!1);var i=R.$wp.scrollTop();a(R.el,e),r&&l(R.el.querySelectorAll(".fr-inner"),e),t&&l(R.el.querySelectorAll("td, th"),e),n&&l(R.el.querySelectorAll("blockquote"),e),o&&l(R.el.querySelectorAll("li"),e),i!==R.$wp.scrollTop()&&R.$wp.scrollTop(i)}function n(e){if(void 0===e&&(e=R.el),e&&0<=["SCRIPT","STYLE","PRE"].indexOf(e.tagName))return!1;for(var t=R.doc.createTreeWalker(e,NodeFilter.SHOW_TEXT,R.node.filter(function(e){return null!==e.textContent.match(/([ \n]{2,})|(^[ \n]{1,})|([ \n]{1,}$)/g)}),!1);t.nextNode();){var n=t.currentNode;if(!s(n.parentNode,!0)){var r=R.node.isBlock(n.parentNode)||R.node.isElement(n.parentNode),o=void 0;if(o=R.opts.preserveTabSpaces?n.textContent.replace(/\n/g," ").replace(/^[ ]{2,}/g," ").replace(/[ ]{2,}$/g," "):n.textContent.replace(/(?!^)( ){2,}(?!$)/g," ").replace(/\n/g," ").replace(/^[ ]{2,}/g," ").replace(/[ ]{2,}$/g," "),r){var i=n.previousSibling,a=n.nextSibling;i&&a&&" "===o?o=R.node.isBlock(i)&&R.node.isBlock(a)?"":" ":(i||(o=o.replace(/^ */,"")),a||(o=o.replace(/ *$/,"")))}n.textContent=o}}}function r(e,t,n){var r=new RegExp(t,"gi").exec(e);return r?r[n]:null}function B(e){var t=e.doctype,n="<!DOCTYPE html>";return t&&(n="<!DOCTYPE ".concat(t.name).concat(t.publicId?' PUBLIC "'.concat(t.publicId,'"'):"").concat(!t.publicId&&t.systemId?" SYSTEM":"").concat(t.systemId?' "'.concat(t.systemId,'"'):"",">")),n}function c(e){var t=e.parentNode;if(t&&(R.node.isBlock(t)||R.node.isElement(t))&&["TD","TH"].indexOf(t.tagName)<0){for(var n=e.previousSibling,r=e.nextSibling;n&&(n.nodeType===Node.TEXT_NODE&&0===n.textContent.replace(/\n|\r/g,"").length||R.node.hasClass(n,"fr-tmp"));)n=n.previousSibling;if(r)return!1;n&&t&&"BR"!==n.tagName&&!R.node.isBlock(n)&&!r&&0<t.textContent.replace(/\u200B/g,"").length&&0<n.textContent.length&&!R.node.hasClass(n,"fr-marker")&&(R.el===t&&!r&&R.opts.enter===H.ENTER_BR&&R.browser.msie||e.parentNode.removeChild(e))}else!t||R.node.isBlock(t)||R.node.isElement(t)||e.previousSibling||e.nextSibling||!R.node.isDeletable(e.parentNode)||c(e.parentNode)}function L(){R.opts.htmlUntouched||(e(),t(),n(),R.spaces.normalize(null,!0),R.html.fillEmptyBlocks(),R.clean.lists(),R.clean.tables(),R.clean.toHTML5(),R.html.cleanBRs()),R.selection.restore(),o(),R.placeholder.refresh()}function o(){R.node.isEmpty(R.el)&&(null!==v()?R.el.querySelector(p())||R.el.querySelector("".concat(R.opts.htmlDoNotWrapTags.join(":not(.fr-marker),"),":not(.fr-marker)"))||(R.core.hasFocus()?(R.$el.html("<".concat(v(),">").concat(H.MARKERS,"<br/></").concat(v(),">")),R.selection.restore()):R.$el.html("<".concat(v(),"><br/></").concat(v(),">"))):R.el.querySelector("*:not(.fr-marker):not(br)")||(R.core.hasFocus()?(R.$el.html("".concat(H.MARKERS,"<br/>")),R.selection.restore()):R.$el.html("<br/>")))}function E(e,t){return r(e,"<".concat(t,"[^>]*?>([\\w\\W]*)</").concat(t,">"),1)}function y(e,t){var n=b("<div ".concat(r(e,"<".concat(t,"([^>]*?)>"),1)||"",">"));return R.node.rawAttributes(n.get(0))}function S(e){return(r(e,"<!DOCTYPE([^>]*?)>",0)||"<!DOCTYPE html>").replace(/\n/g," ").replace(/ {2,}/g," ")}function N(e,t){R.opts.htmlExecuteScripts?e.html(t):e.get(0).innerHTML=t}function V(e){var t;(t=/:not\(([^)]*)\)/g).test(e)&&(e=e.replace(t,"     $1 "));var n=100*(e.match(/(#[^\s+>~.[:]+)/g)||[]).length+10*(e.match(/(\[[^]]+\])/g)||[]).length+10*(e.match(/(\.[^\s+>~.[:]+)/g)||[]).length+10*(e.match(/(:[\w-]+\([^)]*\))/gi)||[]).length+10*(e.match(/(:[^\s+>~.[:]+)/g)||[]).length+(e.match(/(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi)||[]).length;return n+=((e=(e=e.replace(/[*\s+>~]/g," ")).replace(/[#.]/g," ")).match(/([^\s+>~.[:]+)/g)||[]).length}function I(e){if(R.events.trigger("html.processGet",[e]),e&&e.getAttribute&&""===e.getAttribute("class")&&e.removeAttribute("class"),e&&e.getAttribute&&""===e.getAttribute("style")&&e.removeAttribute("style"),e&&e.nodeType===Node.ELEMENT_NODE){var t,n=e.querySelectorAll('[class=""],[style=""]');for(t=0;t<n.length;t++){var r=n[t];""===r.getAttribute("class")&&r.removeAttribute("class"),""===r.getAttribute("style")&&r.removeAttribute("style")}if("BR"===e.tagName)c(e);else{var o=e.querySelectorAll("br");for(t=0;t<o.length;t++)c(o[t])}}}function P(e,t){return e[3]-t[3]}function z(){for(var e=R.el.querySelectorAll("input, textarea"),t=0;t<e.length;t++)"checkbox"!==e[t].type&&"radio"!==e[t].type||(e[t].checked?e[t].setAttribute("checked",e[t].checked):R.$(e[t]).removeAttr("checked")),e[t].getAttribute("value")&&e[t].setAttribute("value",e[t].value)}function d(e){var t=R.doc.createElement("div");return t.innerHTML=e,null!==t.querySelector(p())}function f(e){var t=null;if(void 0===e&&(t=R.selection.element()),R.opts.keepFormatOnDelete)return!1;var n,r,o=t?(t.textContent.match(/\u200B/g)||[]).length-t.querySelectorAll(".fr-marker").length:0;if((R.el.textContent.match(/\u200B/g)||[]).length-R.el.querySelectorAll(".fr-marker").length===o)return!1;do{r=!1,n=R.el.querySelectorAll("*:not(.fr-marker)");for(var i=0;i<n.length;i++){var a=n[i];if(t!==a){var s=a.textContent;0===a.children.length&&1===s.length&&8203===s.charCodeAt(0)&&["TD","STRONG","SPAN","EM","U","S","SUB","SUP"].indexOf(a.tagName)<0&&(b(a).remove(),r=!0)}}}while(r)}function u(){f(),R.placeholder&&setTimeout(R.placeholder.refresh,0)}return{defaultTag:v,isPreformatted:s,emptyBlocks:i,emptyBlockTagsQuery:function h(){return"".concat(H.BLOCK_TAGS.join(":empty, "),":empty")},blockTagsQuery:p,fillEmptyBlocks:function g(e){var t=i(e);R.node.isEmpty(R.el)&&R.opts.enter===H.ENTER_BR&&t.push(R.el);for(var n=0;n<t.length;n++){var r=t[n];"false"===r.getAttribute("contenteditable")||r.querySelector("".concat(R.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"),":not(.fr-marker)"))||R.node.isVoid(r)||"TABLE"===r.tagName||"TBODY"===r.tagName||"TR"===r.tagName||"UL"===r.tagName||"OL"===r.tagName||r.querySelector("br")||r.appendChild(R.doc.createElement("br"))}if(R.browser.msie&&R.opts.enter===H.ENTER_BR){var o=R.node.contents(R.el);o.length&&o[o.length-1].nodeType===Node.TEXT_NODE&&R.$el.append("<br>")}},cleanEmptyTags:e,cleanWhiteTags:f,cleanBlankSpaces:n,blocks:function C(){return R.$el.get(0).querySelectorAll(p())},getDoctype:B,set:function T(e){var t=R.clean.html((e||"").trim(),[],[],R.opts.fullPage);if(R.opts.useClasses){var n=b("<div>").html(t)[0],r=R.opts.fontFamilyDefaultSelection&&"Font Family"!=R.opts.fontFamilyDefaultSelection?R.opts.fontFamilyDefaultSelection:"",o=R.opts.fontSizeDefaultSelection&&R.opts.fontSizeUnit&&"Font Size"!=R.opts.fontSizeDefaultSelection?R.opts.fontSizeDefaultSelection+R.opts.fontSizeUnit:"";if(1===n.children.length&&"DIV"===n.children[0].tagName&&(o||r)){var i=n.children[0].style,a=r&&o?2:r||o?1:0;i.length==a&&r==i.fontFamily&&o==i.fontSize&&(t=n.children[0].innerHTML)}}var s=new RegExp("%3A//","g"),l=t.replace(s,"://");if(R.opts.fullPage){var c=E(l,"body")||(0<=l.indexOf("<body")?"":l),d=y(l,"body"),f=E(l,"head")||"<title></title>",p=y(l,"head"),u=b("<div>");u.append(f).contents().each(function(){(this.nodeType===Node.COMMENT_NODE||0<=["BASE","LINK","META","NOSCRIPT","SCRIPT","STYLE","TEMPLATE","TITLE"].indexOf(this.tagName))&&this.parentNode.removeChild(this)});var h=u.html().trim();f=b("<div>").append(f).contents().map(function(){return this.nodeType===Node.COMMENT_NODE?"\x3c!--".concat(this.nodeValue,"--\x3e"):0<=["BASE","LINK","META","NOSCRIPT","SCRIPT","STYLE","TEMPLATE","TITLE"].indexOf(this.tagName)?this.outerHTML:""}).toArray().join("");var g=S(l),C=y(l,"html");N(R.$el,"".concat(h,"\n").concat(c)),R.node.clearAttributes(R.el),R.$el.attr(d),R.$el.addClass("fr-view"),R.$el.attr("spellcheck",R.opts.spellcheck),R.$el.attr("dir",R.opts.direction),N(R.$head,f),R.node.clearAttributes(R.$head.get(0)),R.$head.attr(p),R.node.clearAttributes(R.$html.get(0)),R.$html.attr(C),R.iframe_document.doctype.parentNode.replaceChild(function v(e,t){var n=e.match(/<!DOCTYPE ?([^ ]*) ?([^ ]*) ?"?([^"]*)"? ?"?([^"]*)"?>/i);return n?t.implementation.createDocumentType(n[1],n[3],n[4]):t.implementation.createDocumentType("html")}(g,R.iframe_document),R.iframe_document.doctype)}else N(R.$el,l);var m=R.edit.isDisabled();R.edit.on(),R.core.injectStyle(R.opts.iframeDefaultStyle+R.opts.iframeStyle),L(),R.opts.useClasses||(R.$el.find("[fr-original-class]").each(function(){this.setAttribute("class",this.getAttribute("fr-original-class")),this.removeAttribute("fr-original-class")}),R.$el.find("[fr-original-style]").each(function(){this.setAttribute("style",this.getAttribute("fr-original-style")),this.removeAttribute("fr-original-style")})),m&&R.edit.off(),R.events.trigger("html.set"),R.events.trigger("charCounter.update"),R.events.trigger("wordCounter.update")},syncInputs:z,get:function Z(e,t){if(!R.$wp)return R.$oel.clone().removeClass("fr-view").removeAttr("contenteditable").get(0).outerHTML;var n="";R.events.trigger("html.beforeGet");var r,o,i=[],a={},s=[];if(z(),!R.opts.useClasses&&!t){var l=new RegExp("^".concat(R.opts.htmlIgnoreCSSProperties.join("$|^"),"$"),"gi");for(r=0;r<R.doc.styleSheets.length;r++){var c=void 0,d=0;try{c=R.doc.styleSheets[r].cssRules,R.doc.styleSheets[r].ownerNode&&"STYLE"===R.doc.styleSheets[r].ownerNode.nodeType&&(d=1)}catch(_){}if(c)for(var f=0,p=c.length;f<p;f++)if(c[f].selectorText&&0<c[f].style.cssText.length){var u=c[f].selectorText.replace(/body \s tbody \.fr-view /g,"").replace(/::/g,":"),h=void 0;try{h=R.el.querySelectorAll(u)}catch(_){h=[]}for(o=0;o<h.length;o++){!h[o].getAttribute("fr-original-style")&&h[o].getAttribute("style")?(h[o].setAttribute("fr-original-style",h[o].getAttribute("style")),i.push(h[o])):h[o].getAttribute("fr-original-style")||(h[o].setAttribute("fr-original-style",""),i.push(h[o])),a[h[o]]||(a[h[o]]={});for(var g=1e3*d+V(c[f].selectorText),C=c[f].style.cssText.split(";"),m=0;m<C.length;m++){var v=C[m].trim().split(":")[0];if(v&&!v.match(l)&&((!a[h[o]][v]||a[h[o]][v]&&""==h[o].getAttribute("fr-original-style"))&&(a[h[o]][v]=0)<=(h[o].getAttribute("fr-original-style")||"").indexOf("".concat(v,":"))&&(a[h[o]][v]=1e4),g>=a[h[o]][v]&&(a[h[o]][v]=g,C[m].trim().length))){var b=C[m].trim().split(":");b.splice(0,1);var L=b.join(":").trim();-1<L.indexOf("!important")&&(g+=1),s.push([h[o],v.trim(),L,g])}}}}}for(s.sort(P),r=0;r<s.length;r++){var E=s[r];E[0].style[E[1]]=E[2].replace(/!important/,"")}for(r=0;r<i.length;r++)if(i[r].getAttribute("class")&&(i[r].setAttribute("fr-original-class",i[r].getAttribute("class")),i[r].removeAttribute("class")),0<(i[r].getAttribute("fr-original-style")||"").trim().length){var y=i[r].getAttribute("fr-original-style").split(";");for(o=0;o<y.length;o++)if(0<y[o].indexOf(":")){var S=y[o].split(":"),N=S[0];S.splice(0,1),i[r].style[N.trim()]=S.join(":").trim()}}}if(R.node.isEmpty(R.el))R.opts.fullPage&&(n=B(R.iframe_document),n+="<html".concat(R.node.attributes(R.$html.get(0)),">").concat(R.$html.find("head").get(0).outerHTML,"<body></body></html>"));else if(void 0===e&&(e=!1),R.opts.fullPage){n=B(R.iframe_document),R.$el.removeClass("fr-view");var T=R.opts.heightMin,M=R.opts.height,A=R.opts.heightMax;R.opts.heightMin=null,R.opts.height=null,R.opts.heightMax=null,R.size.refresh(),n+="<html".concat(R.node.attributes(R.$html.get(0)),">").concat(R.$html.html(),"</html>"),R.opts.iframe&&R.$html&&0<R.$html.find(".fr-element").length&&(n=R.$html.find(".fr-element").html()),R.opts.heightMin=T,R.opts.height=M,R.opts.heightMax=A,R.size.refresh(),R.$el.addClass("fr-view")}else n=R.$el.html(),R.opts.iframe&&R.$html&&0<R.$html.find(".fr-element").length&&(n=R.$html.find(".fr-element").html());if(!R.opts.useClasses&&!t)for(r=0;r<i.length;r++)i[r].getAttribute("fr-original-class")&&(i[r].setAttribute("class",i[r].getAttribute("fr-original-class")),i[r].removeAttribute("fr-original-class")),null!==i[r].getAttribute("fr-original-style")&&void 0!==i[r].getAttribute("fr-original-style")?(0!==i[r].getAttribute("fr-original-style").length?i[r].setAttribute("style",i[r].getAttribute("fr-original-style")):i[r].removeAttribute("style"),i[r].removeAttribute("fr-original-style")):i[r].removeAttribute("style");R.opts.fullPage&&(n=(n=(n=(n=(n=(n=(n=(n=n.replace(/<style data-fr-style="true">(?:[\w\W]*?)<\/style>/g,"")).replace(/<link([^>]*)data-fr-style="true"([^>]*)>/g,"")).replace(/<style(?:[\w\W]*?)class="firebugResetStyles"(?:[\w\W]*?)>(?:[\w\W]*?)<\/style>/g,"")).replace(/<body((?:[\w\W]*?)) spellcheck="true"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$2>$3</body>")).replace(/<body((?:[\w\W]*?)) contenteditable="(true|false)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$3>$4</body>")).replace(/<body((?:[\w\W]*?)) dir="([\w]*)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$3>$4</body>")).replace(/<body((?:[\w\W]*?))class="([\w\W]*?)(fr-rtl|fr-ltr)([\w\W]*?)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,'<body$1class="$2$4"$5>$6</body>')).replace(/<body((?:[\w\W]*?)) class=""((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$2>$3</body>")),R.opts.htmlSimpleAmpersand&&(n=n.replace(/&amp;/gi,"&")),R.events.trigger("html.afterGet"),e||(n=n.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi,"")),n=R.clean.invisibleSpaces(n),n=R.clean.exec(n,I);var x=R.events.chainTrigger("html.get",n);"string"==typeof x&&(n=x),n=(n=n.replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g,function(e){return e.replace(/<br>/g,"\n")})).replace(/<meta((?:[\w\W]*?)) data-fr-http-equiv="/g,'<meta$1 http-equiv="');var w=R.opts.fontSizeDefaultSelection&&R.opts.fontSizeUnit&&"Font Size"!=R.opts.fontSizeDefaultSelection,O=R.opts.fontFamilyDefaultSelection&&"Font Family"!=R.opts.fontFamilyDefaultSelection;if(R.opts.useClasses&&!t&&(w||O)){var k="";if(w&&(k+="font-size: ".concat(R.opts.fontSizeDefaultSelection).concat(R.opts.fontSizeUnit,";")),O&&(k+="font-family: ".concat(R.opts.fontFamilyDefaultSelection,";")),R.opts.fullPage){var $=(new DOMParser).parseFromString(n,"text/html"),H=document.createElement("style");k&&(H.innerHTML="body{".concat(k,"}"),$.head.appendChild(H),n="<!DOCTYPE html>".concat($.documentElement.outerHTML))}else{var D=document.createElement("div");k&&(D.style.cssText=k),D.innerHTML=n,n=D.outerHTML}}return n},getSelected:function m(){function e(e,t){for(;t&&(t.nodeType===Node.TEXT_NODE||!R.node.isBlock(t))&&!R.node.isElement(t)&&!R.node.hasClass(t,"fr-inner")&&(R.opts.enter!==H.ENTER_BR||t!==R.$el[0]);)t&&t.nodeType!==Node.TEXT_NODE&&b(e).wrapContent(t),t=t.parentNode;t&&e.innerHTML===t.innerHTML?e.innerHTML=t.outerHTML:t&&"DIV"!==t.tagName&&"LI"!==t.tagName&&t.innerText&&-1!=t.innerText.indexOf(e.innerHTML)&&t!==R.$el.get(0)&&(e.innerHTML=R.node.openTagString(t)+e.innerHTML+R.node.closeTagString(t))}var t,n,r="";if("undefined"!=typeof R.win.getSelection){R.browser.mozilla&&(R.selection.save(),1<R.$el.find('.fr-marker[data-type="false"]').length&&(R.$el.find('.fr-marker[data-type="false"][data-id="0"]').remove(),R.$el.find('.fr-marker[data-type="false"]:last').attr("data-id","0"),R.$el.find(".fr-marker").not('[data-id="0"]').remove()),R.selection.restore());for(var o=R.selection.ranges(),i=0;i<o.length;i++){var a=document.createElement("div");a.appendChild(o[i].cloneContents()),e(a,(n=t=void 0,n=null,R.win.getSelection?(t=R.win.getSelection())&&t.rangeCount&&((n=t.getRangeAt(0).commonAncestorContainer).nodeType===Node.ELEMENT_NODE||R.opts.enter===H.ENTER_BR&&n.parentNode===R.$el[0]||(n=n.parentNode)):(t=R.doc.selection)&&"Control"!==t.type&&(n=t.createRange().parentElement()),null!==n&&(0<=b(n).parents().toArray().indexOf(R.el)||n===R.el)?n:null)),0<b(a).find(".fr-element").length&&(a=R.el),r+=a.innerHTML}}else"undefined"!=typeof R.doc.selection&&"Text"===R.doc.selection.type&&(r=R.doc.selection.createRange().htmlText);return r},insert:function M(e,t,n){if(!1===R.events.trigger("html.beforeInsert",[e,t,n]))return!1;var r;if(R.selection.isCollapsed()||R.selection.remove(),r=t?e:R.clean.html(e),0===e.indexOf('<i class="fa ')&&(r="<span>&nbsp;".concat(r,"</span>")),e.indexOf('class="fr-marker"')<0&&(r=function s(e){var t=R.doc.createElement("div");return t.innerHTML=e,R.selection.setAtEnd(t,!0),t.innerHTML}(r)),R.node.isEmpty(R.el)&&!R.opts.keepFormatOnDelete&&d(r))R.opts.trackChangesEnabled?R.track_changes.pasteInEmptyEdior(r):R.el.innerHTML=r;else{(function l(){var e=R.selection.ranges(0).commonAncestorContainer;return e!==R.el&&!R.$el.contains(e)})()&&R.selection.restore();var o=R.markers.insert();if(o)if(R.opts.trackChangesEnabled)R.track_changes.pasteInEdior(r);else{R.node.isLastSibling(o)&&b(o).parent().hasClass("fr-deletable")&&b(o).insertAfter(b(o).parent());var i=R.node.blockParent(o);if((d(r)||n)&&(R.node.deepestParent(o)||i&&"LI"===i.tagName)){i&&"LI"===i.tagName&&(r=function c(e){if(!R.html.defaultTag())return e;var t=R.doc.createElement("div");t.innerHTML=e;for(var n=t.querySelectorAll(":scope > ".concat(R.html.defaultTag())),r=n.length-1;0<=r;r--){var o=n[r];R.node.isBlock(o.previousSibling)||(o.previousSibling&&!R.node.isEmpty(o)&&b("<br>").insertAfter(o.previousSibling),o.outerHTML=o.innerHTML)}return t.innerHTML}(r));var a=R.selection.element();if(a&&b(a).parentsUntil(R.el,"ul, ol").length&&"LI"!=o.parentNode.tagName&&("DIV"==b(r).get(0).tagName&&1==b(r).length&&"UL"==b(r).get(0).firstChild.tagName?r=b(r).get(0).firstChild.innerHTML:"UL"==b(r).get(0).tagName&&(r=b(r).get(0).innerHTML),o=R.markers.split()),!(o=R.markers.split()))return!1;o.outerHTML=r}else o.outerHTML=r}else R.el.innerHTML+=r}L(),R.keys.positionCaret(),R.events.trigger("html.inserted")},wrap:t,unwrap:function A(){R.$el.find("div.fr-temp-div").each(function(){this.previousSibling&&this.previousSibling.nodeType===Node.TEXT_NODE&&b(this).before("<br>"),b(this).attr("data-empty")||!this.nextSibling||R.node.isBlock(this.nextSibling)&&!b(this.nextSibling).hasClass("fr-temp-div")?b(this).replaceWith(b(this).html()):b(this).replaceWith("".concat(b(this).html(),"<br>"))}),R.$el.find(".fr-temp-div").removeClass("fr-temp-div").filter(function(){return""===b(this).attr("class")}).removeAttr("class")},escapeEntities:function x(e){return e.replace(/</gi,"&lt;").replace(/>/gi,"&gt;").replace(/"/gi,"&quot;").replace(/'/gi,"&#39;")},checkIfEmpty:o,extractNode:E,extractNodeAttrs:y,extractDoctype:S,cleanBRs:function w(){for(var e=R.el.getElementsByTagName("br"),t=0;t<e.length;t++)c(e[t])},_init:function O(){R.events.$on(R.$el,"mousemove","span.fr-word-select",function(e){var t=window.getSelection();t=window.getSelection();var n=document.createRange();n.selectNodeContents(e.target),t.removeAllRanges(),t.addRange(n)}),R.$wp&&(R.events.on("mouseup",u),R.events.on("keydown",u),R.events.on("contentChanged",o))},_setHtml:N}},H.ENTER_P=0,H.ENTER_DIV=1,H.ENTER_BR=2,H.KEYCODE={BACKSPACE:8,TAB:9,ENTER:13,SHIFT:16,CTRL:17,ALT:18,ESC:27,SPACE:32,ARROW_LEFT:37,ARROW_UP:38,ARROW_RIGHT:39,ARROW_DOWN:40,DELETE:46,ZERO:48,ONE:49,TWO:50,THREE:51,FOUR:52,FIVE:53,SIX:54,SEVEN:55,EIGHT:56,NINE:57,FF_SEMICOLON:59,FF_EQUALS:61,QUESTION_MARK:63,A:65,B:66,C:67,D:68,E:69,F:70,G:71,H:72,I:73,J:74,K:75,L:76,M:77,N:78,O:79,P:80,Q:81,R:82,S:83,T:84,U:85,V:86,W:87,X:88,Y:89,Z:90,META:91,NUM_ZERO:96,NUM_ONE:97,NUM_TWO:98,NUM_THREE:99,NUM_FOUR:100,NUM_FIVE:101,NUM_SIX:102,NUM_SEVEN:103,NUM_EIGHT:104,NUM_NINE:105,NUM_MULTIPLY:106,NUM_PLUS:107,NUM_MINUS:109,NUM_PERIOD:110,NUM_DIVISION:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,FF_HYPHEN:173,SEMICOLON:186,DASH:189,EQUALS:187,COMMA:188,HYPHEN:189,PERIOD:190,SLASH:191,APOSTROPHE:192,TILDE:192,SINGLE_QUOTE:222,OPEN_SQUARE_BRACKET:219,BACKSLASH:220,CLOSE_SQUARE_BRACKET:221,IME:229},Object.assign(H.DEFAULTS,{enter:H.ENTER_P,multiLine:!0,tabSpaces:0}),H.MODULES.keys=function(C){var m,n,r,s=C.$,v=!1;function b(e){if(C.selection.isCollapsed())if(["INPUT","BUTTON","TEXTAREA"].indexOf(e.target&&e.target.tagName)<0&&C.cursor.backspace(),C.helpers.isIOS()){var t=C.selection.ranges(0);t.deleteContents(),t.insertNode(document.createTextNode("\u200b")),C.selection.get().modify("move","forward","character")}else["INPUT","BUTTON","TEXTAREA"].indexOf(e.target&&e.target.tagName)<0&&e.preventDefault(),e.stopPropagation();else e.preventDefault(),e.stopPropagation(),C.selection.remove();C.placeholder.refresh()}function L(e){["INPUT","BUTTON","TEXTAREA"].indexOf(e.target&&e.target.tagName)<0&&e.preventDefault(),e.stopPropagation(),""!==C.selection.text()||C.selection.element().hasAttribute("contenteditable")&&"false"===C.selection.element().getAttribute("contenteditable")||!C.selection.isCollapsed()&&"IMG"==C.selection.element().tagName?C.selection.remove():C.cursor.del(),C.placeholder.refresh()}function e(){if(C.browser.mozilla&&C.selection.isCollapsed()&&!v){var e=C.selection.ranges(0),t=e.startContainer,n=e.startOffset;t&&t.nodeType===Node.TEXT_NODE&&n<=t.textContent.length&&0<n&&32===t.textContent.charCodeAt(n-1)&&(C.selection.save(),C.spaces.normalize(),C.selection.restore())}}function t(){C.selection.isFull()&&setTimeout(function(){var e=C.html.defaultTag();e?C.$el.html("<".concat(e,">").concat(H.MARKERS,"<br/></").concat(e,">")):C.$el.html("".concat(H.MARKERS,"<br/>")),C.selection.restore(),C.placeholder.refresh(),C.button.bulkRefresh(),C.undo.saveStep()},0)}function o(){v=!1}function i(){v=!1}function E(){var e=C.html.defaultTag();e?C.$el.html("<".concat(e,">").concat(H.MARKERS,"<br/></").concat(e,">")):C.$el.html("".concat(H.MARKERS,"<br/>")),C.selection.restore()}function y(e,t){var n=(e&&e.parentElement).parentElement;if(e.parentElement&&(-1<e.innerHTML.indexOf("<span")||-1<e.parentElement.innerHTML.indexOf("<span")||n&&-1<e.parentElement.parentElement.innerHTML.indexOf("<span"))&&(e.classList.contains("fr-img-space-wrap")||e.parentElement.classList.contains("fr-img-space-wrap")||n&&e.parentElement.parentElement.classList.contains("fr-img-space-wrap"))){if(s(e.parentElement).is("p")){var r=e.parentElement.innerHTML;return(r=r.replace(/<br>/g,"")).length<1?e.parentElement.insertAdjacentHTML("afterbegin","&nbsp;"):"&nbsp;"!=r&&" "!=r&&"Backspace"==t.key?b(t):"&nbsp;"!=r&&" "!=r&&"Delete"==t.key&&L(t),!0}if(s(e).is("p")){var o=e.innerHTML.replace(/<br>/g,"");return o.length<1?e.insertAdjacentHTML("afterbegin","&nbsp;"):"&nbsp;"!=o&&" "!=o&&"Backspace"==t.key?b(t):"&nbsp;"!=o&&" "!=o&&"Delete"==t.key&&L(t),!0}}return!1}function a(e){var t=C.selection.element();if(t&&0<=["INPUT","TEXTAREA"].indexOf(t.tagName))return!0;if(e&&T(e.which)){var n=C.selection.element(),r=C.selection.get(),o=r.anchorNode,i=r.anchorOffset;if(o.nodeType===Node.TEXT_NODE&&0<i&&1<o.textContent.length&&8203===o.textContent.charCodeAt(i)){S(n);var a=C.doc.createRange();C.selection.get().removeAllRanges();var s=Math.max(0,Math.min(i-1,o.textContent.length-1));a.setStart(o,s),a.setEnd(o,s),C.selection.get().addRange(a)}return!0}C.events.disableBlur();var l=e.which;if(16===l)return!0;if((m=l)===H.KEYCODE.IME)return v=!0;if(v=!1,N(e))return!0;var c=M(l)&&!N(e)&&!e.altKey,d=l===H.KEYCODE.BACKSPACE||l===H.KEYCODE.DELETE;if((C.selection.isFull()&&!C.opts.keepFormatOnDelete&&!C.placeholder.isVisible()||d&&C.placeholder.isVisible()&&C.opts.keepFormatOnDelete)&&(c||d)&&(E(),!M(l)))return e.preventDefault(),!0;if(l===H.KEYCODE.ENTER)!C.helpers.isIOS()&&e.shiftKey||t.classList.contains("fr-inner")||t.parentElement.classList.contains("fr-inner")?function f(e){e.preventDefault(),e.stopPropagation(),C.opts.multiLine&&(C.selection.isCollapsed()||C.selection.remove(),C.cursor.enter(!0))}(e):function p(e){C.opts.multiLine?(C.helpers.isIOS()||(e.preventDefault(),e.stopPropagation()),C.selection.isCollapsed()||C.selection.remove(),C.cursor.enter()):(e.preventDefault(),e.stopPropagation())}(e);else if(l===H.KEYCODE.BACKSPACE&&(e.metaKey||e.ctrlKey))!function u(){setTimeout(function(){C.events.disableBlur(),C.events.focus()},0)}();else if(l!==H.KEYCODE.BACKSPACE||N(e)||e.altKey)if(l!==H.KEYCODE.DELETE||N(e)||e.altKey||e.shiftKey)l===H.KEYCODE.SPACE?function h(e){var t=C.selection.element();if(!C.helpers.isMobile()&&t&&"A"===t.tagName){e.preventDefault(),e.stopPropagation(),C.selection.isCollapsed()||C.selection.remove();var n=C.markers.insert();if(n){var r=n.previousSibling;!n.nextSibling&&n.parentNode&&"A"===n.parentNode.tagName?(n.parentNode.insertAdjacentHTML("afterend","&nbsp;".concat(H.MARKERS)),n.parentNode.removeChild(n)):(r&&r.nodeType===Node.TEXT_NODE&&1===r.textContent.length&&160===r.textContent.charCodeAt(0)?r.textContent+=" ":n.insertAdjacentHTML("beforebegin","&nbsp;"),n.outerHTML=H.MARKERS),C.selection.restore()}}}(e):l===H.KEYCODE.TAB?function g(e){if(0<C.opts.tabSpaces)if(C.selection.isCollapsed()){C.undo.saveStep(),e.preventDefault(),e.stopPropagation();for(var t="",n=0;n<C.opts.tabSpaces;n++)t+="&nbsp;";C.html.insert(t),C.placeholder.refresh(),C.undo.saveStep()}else e.preventDefault(),e.stopPropagation(),e.shiftKey?C.commands.outdent():C.commands.indent()}(e):N(e)||!M(e.which)||C.selection.isCollapsed()||e.ctrlKey||e.altKey||C.browser.mozilla||C.selection.remove();else{if(y(t,e))return e.preventDefault(),void e.stopPropagation();C.placeholder.isVisible()?(C.opts.keepFormatOnDelete||E(),e.preventDefault(),e.stopPropagation()):L(e)}else{if(y(t,e))return e.preventDefault(),void e.stopPropagation();C.placeholder.isVisible()?(C.opts.keepFormatOnDelete||E(),e.preventDefault(),e.stopPropagation()):b(e)}C.events.enableBlur()}function S(e){var t=e;-1<["STRONG","U","EM"].indexOf(e.nodeName)&&e.parentNode&&(t=e.parentNode);for(var n=C.doc.createTreeWalker(t,NodeFilter.SHOW_TEXT,C.node.filter(function(e){return/\u200B/gi.test(e.textContent)}),!1);n.nextNode();){var r=n.currentNode;r.textContent=r.textContent.replace(/\u200B/gi,"")}}function l(){if(!C.$wp)return!0;var e;if(C.opts.height||C.opts.heightMax){e=C.position.getBoundingRect().top,(C.helpers.isIOS()||C.helpers.isAndroid())&&(e-=C.helpers.scrollTop()),C.opts.iframe&&(e+=C.$iframe.offset().top);var t=C.selection.blocks(),n=null;if(t&&0<t.length&&t[0].offsetTop&&(n=t[0].getBoundingClientRect().top,3===C.selection.get().anchorNode.nodeType)){var r=C.doc.createRange(),o=C.selection.get().anchorNode,i=C.selection.get().anchorOffset;r.selectNode(o),r.setStart(o,i),n=r.getBoundingClientRect().top}if(!C.opts.iframe&&e>C.$wp.offset().top-C.helpers.scrollTop()+C.$wp.height()-20)C.$wp.scrollTop(e+C.$wp.scrollTop()-(C.$wp.height()+C.$wp.offset().top)+C.helpers.scrollTop()+20);else if(C.opts.iframe&&n)if(C.$wp.scrollTop()>n)C.$wp.scrollTop(n-20);else if(n+20>C.$wp.scrollTop()+C.$wp.height()){var a=n-C.$wp.height()+50;C.$wp.scrollTop(a)}}else e=C.position.getBoundingRect().top,C.opts.toolbarBottom&&(e+=C.opts.toolbarStickyOffset),(C.helpers.isIOS()||C.helpers.isAndroid())&&(e-=C.helpers.scrollTop()),C.opts.iframe&&(e+=C.$iframe.offset().top,e-=C.helpers.scrollTop()),(e+=C.opts.toolbarStickyOffset)>C.o_win.innerHeight-20&&s(C.o_win).scrollTop(e+C.helpers.scrollTop()-C.o_win.innerHeight+20),e=C.position.getBoundingRect().top,C.opts.toolbarBottom||(e-=C.opts.toolbarStickyOffset),(C.helpers.isIOS()||C.helpers.isAndroid())&&(e-=C.helpers.scrollTop()),C.opts.iframe&&(e+=C.$iframe.offset().top,e-=C.helpers.scrollTop()),e<100&&s(C.o_win).scrollTop(e+C.helpers.scrollTop()-100)}function c(e){var t=C.selection.element();if(t&&0<=["INPUT","TEXTAREA"].indexOf(t.tagName))return!0;if(e&&0===e.which&&m&&(e.which=m),C.helpers.isAndroid()&&C.browser.mozilla)return!0;if(v)return!1;if(e&&C.helpers.isIOS()&&e.which===H.KEYCODE.ENTER&&C.doc.execCommand("undo"),!C.selection.isCollapsed())return!0;if(e&&(e.which===H.KEYCODE.META||e.which===H.KEYCODE.CTRL))return!0;if(e&&T(e.which))return!0;if(e&&!C.helpers.isIOS()&&(e.which===H.KEYCODE.ENTER||e.which===H.KEYCODE.BACKSPACE||37<=e.which&&e.which<=40&&!C.browser.msie))try{l()}catch(i){}var n=C.selection.element();if(function a(e){if(!e)return!1;var t=e.innerHTML;return!!((t=t.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi,""))&&/\u200B/.test(t)&&0<t.replace(/\u200B/gi,"").length)}(n)&&!C.node.hasClass(n,"fr-marker")&&"IFRAME"!==n.tagName&&function s(e){return!C.helpers.isIOS()||0===((e.textContent||"").match(/[\u3041-\u3096\u30A0-\u30FF\u4E00-\u9FFF\u3130-\u318F\uAC00-\uD7AF]/gi)||[]).length}(n)){C.selection.save();var r=C.$el.find(".fr-marker")[1],o=(e||"").which;C.opts.enter===H.ENTER_BR&&n===C.$el.get(0)&&8===o&&null==r.nextSibling||S(n),C.selection.restore()}}function N(e){if(-1!==navigator.userAgent.indexOf("Mac OS X")){if(e.metaKey&&!e.altKey)return!0}else if(e.ctrlKey&&!e.altKey)return!0;return!1}function T(e){if(e>=H.KEYCODE.ARROW_LEFT&&e<=H.KEYCODE.ARROW_DOWN)return!0}function M(e){if(e>=H.KEYCODE.ZERO&&e<=H.KEYCODE.NINE)return!0;if(e>=H.KEYCODE.NUM_ZERO&&e<=H.KEYCODE.NUM_MULTIPLY)return!0;if(e>=H.KEYCODE.A&&e<=H.KEYCODE.Z)return!0;if(C.browser.webkit&&0===e)return!0;switch(e){case H.KEYCODE.SPACE:case H.KEYCODE.QUESTION_MARK:case H.KEYCODE.NUM_PLUS:case H.KEYCODE.NUM_MINUS:case H.KEYCODE.NUM_PERIOD:case H.KEYCODE.NUM_DIVISION:case H.KEYCODE.SEMICOLON:case H.KEYCODE.FF_SEMICOLON:case H.KEYCODE.DASH:case H.KEYCODE.EQUALS:case H.KEYCODE.FF_EQUALS:case H.KEYCODE.COMMA:case H.KEYCODE.PERIOD:case H.KEYCODE.SLASH:case H.KEYCODE.APOSTROPHE:case H.KEYCODE.SINGLE_QUOTE:case H.KEYCODE.OPEN_SQUARE_BRACKET:case H.KEYCODE.BACKSLASH:case H.KEYCODE.CLOSE_SQUARE_BRACKET:return!0;default:return!1}}function d(e){var t=e.which;if(N(e)||37<=t&&t<=40||!M(t)&&t!==H.KEYCODE.DELETE&&t!==H.KEYCODE.BACKSPACE&&t!==H.KEYCODE.ENTER&&t!==H.KEYCODE.IME)return!0;n||(r=C.snapshot.get(),C.undo.canDo()||C.undo.saveStep()),clearTimeout(n),n=setTimeout(function(){n=null,C.undo.saveStep()},Math.max(250,C.opts.typingTimer))}function f(e){var t=e.which;if(N(e)||37<=t&&t<=40)return!0;r&&n?(C.undo.saveStep(r),r=null):void 0!==t&&0!==t||r||n||C.undo.saveStep()}function p(e){if(e&&"BR"===e.tagName)return!1;try{return 0===(e.textContent||"").length&&e.querySelector&&!e.querySelector(":scope > br")||e.childNodes&&1===e.childNodes.length&&e.childNodes[0].getAttribute&&("false"===e.childNodes[0].getAttribute("contenteditable")||C.node.hasClass(e.childNodes[0],"fr-img-caption"))}catch(t){return!1}}function u(e){var t=C.el.childNodes,n=C.html.defaultTag(),r=C.node.blockParent(C.selection.blocks()[0]);function o(e){return!!s(e).parentsUntil(C.$el,'[contenteditable="false"]').length}r&&"TR"==r.tagName&&r.getAttribute("contenteditable")==undefined&&(r=r.closest("table"));var i=window.getSelection(),a=0<i.rangeCount&&(o(i.getRangeAt(0).startContainer)||o(i.getRangeAt(0).endContainer));return!C.node.isEditable(e.target)||o(e.target)||a?C.toolbar.disable():C.toolbar.enable(),!(!e.target||e.target===C.el)||(0===t.length||void(t[0].offsetHeight+t[0].offsetTop<=e.offsetY?p(t[t.length-1])&&(n?C.$el.append("<".concat(n,">").concat(H.MARKERS,"<br></").concat(n,">")):C.$el.append("".concat(H.MARKERS,"<br>")),C.selection.restore(),l()):e.offsetY<=10&&p(t[0])&&(n?C.$el.prepend("<".concat(n,">").concat(H.MARKERS,"<br></").concat(n,">")):C.$el.prepend("".concat(H.MARKERS,"<br>")),C.selection.restore(),l())))}function h(){n&&clearTimeout(n)}return{_init:function g(){C.events.on("keydown",d),C.events.on("input",e),C.events.on("mousedown",i),C.events.on("keyup input",f),C.events.on("keypress",o),C.events.on("keydown",a),C.events.on("keyup",c),C.events.on("destroy",h),C.events.on("html.inserted",c),C.events.on("cut",t),C.opts.multiLine&&C.events.on("click",u),C.events.on("initialized",function(){C.el.addEventListener("compositionstart",function(){if(C.selection.isCollapsed()){var e=C.selection.ranges(0),t=e.startContainer,n=e.startOffset;if(t&&t.nodeType===Node.TEXT_NODE&&n<=t.textContent.length&&0<n&&8203===t.textContent.charCodeAt(n-1)){C.selection.save();var r=C.$el.find(".fr-marker");s(r.get(0).previousSibling).before(H.HAIR_SPACE),r.get(0).previousSibling.textContent=r.get(0).previousSibling.textContent.replace(/\u200B/gi,""),C.selection.restore()}}}),C.el.addEventListener("compositionend",function(){if(C.selection.isCollapsed()){var e=C.selection.ranges(0),t=e.startContainer,n=e.startOffset;if(t&&t.nodeType===Node.TEXT_NODE&&n<=t.textContent.length&&0<n&&8202===t.textContent.charCodeAt(0)){C.selection.save();var r=C.$el.find(".fr-marker");r.get(0).previousSibling.textContent=r.get(0).previousSibling.textContent.replace(/\u200A/gi,""),C.selection.restore()}}})})},ctrlKey:N,isCharacter:M,isArrow:T,forceUndo:function A(){n&&(clearTimeout(n),C.undo.saveStep(),r=null)},isIME:function x(){return v},isBrowserAction:function w(e){var t=e.which;return N(e)||t===H.KEYCODE.F5},positionCaret:l}},Object.assign(H.DEFAULTS,{pastePlain:!1,pasteDeniedTags:["colgroup","col","meta"],pasteDeniedAttrs:["class","id"],pasteAllowedStyleProps:[".*"],pasteAllowLocalImages:!1}),H.MODULES.paste=function(M){var l,c,d,f,p,A,o,x=M.$;function r(e,t){var n=2<arguments.length&&arguments[2]!==undefined&&arguments[2];o=n;try{M.win.localStorage.setItem("fr-copied-html",e),M.win.localStorage.setItem("fr-copied-text",t)}catch(r){}}function e(e){var t=M.html.getSelected();"cut"===e.type&&M.opts.trackChangesEnabled||(o=!1),o&&(t=M.win.localStorage.getItem("fr-copied-html"));var n=x(M.doc.createElement("div")).html(t).text();o||r(t,n),"cut"===e.type&&(M.undo.saveStep(),M.opts.trackChangesEnabled&&o&&(e.clipboardData.setData("text/plain",n),e.clipboardData.setData("text/html",t),M.selection.get().deleteFromDocument(),e.preventDefault()),setTimeout(function(){M.selection.save(),M.html.wrap(),M.selection.restore(),M.events.focus(),M.undo.saveStep()},0))}var u,n=!1;function t(d){if("INPUT"===(u=d).target.nodeName&&"text"===d.target.type)return!0;if(M.edit.isDisabled())return!1;if(i(d.target))return!1;if(n)return!1;d.originalEvent&&(d=d.originalEvent);var e=navigator.userAgent.match(/(chrome(?=\/))\/?\s*(\d+)/i)||[],t=3<=e.length?e[2]:0;return M.helpers.isAndroid()&&M.browser.chrome&&99<t&&navigator.clipboard?(navigator.clipboard.read({unsanitized:["text/html"]}).then(function(){var t=function e(s){return function(){var e=this,a=arguments;return new Promise(function(t,n){var r=s.apply(e,a);function o(e){y(r,t,n,o,i,"next",e)}function i(e){y(r,t,n,o,i,"throw",e)}o(void 0)})}}($().mark(function c(t){var n,r,o,i,a,s,l;return $().wrap(function(e){for(;;)switch(e.prev=e.next){case 0:n=t[0].types,r=new DataTransfer,o=S(n),e.prev=3,o.s();case 5:if((i=o.n()).done){e.next=21;break}return a=i.value,e.next=9,t[0].getType(a);case 9:if(s=e.sent,a.startsWith("text"))return e.next=13,s.text();e.next=16;break;case 13:e.t0=e.sent,e.next=17;break;case 16:e.t0=s;case 17:l=e.t0,a.startsWith("text")?r.setData(a,l):r.items.add(new File([l],"file"));case 19:e.next=5;break;case 21:e.next=26;break;case 23:e.prev=23,e.t1=e["catch"](3),o.e(e.t1);case 26:return e.prev=26,o.f(),e.finish(26);case 29:return e.abrupt("return",h(d,r));case 30:case"end":return e.stop()}},c,null,[[3,23,26,29]])}));return function(e){return t.apply(this,arguments)}}()),d.preventDefault(),!1):h(d)}function h(e,t){var n=t||e&&e.clipboardData;if(n&&n.getData){var r=(n||window.clipboardData).getData("text/html")||"";if(r.match('content="Microsoft OneNote')){var o=/<body[^>]*>((.|[\n\r])*)<\/body>/im.exec(r)[1];return M.html.insert(M.clean.html(o)),e.preventDefault&&(e.stopPropagation(),e.preventDefault()),!1}}if(!1===M.events.trigger("paste.before",[e,t]))return e.preventDefault(),!1;if(n&&n.getData){var i="";if(f=n.types,M.helpers.isArray(f))for(var a=0;a<f.length;a++)i+="".concat(f[a],";");else i=f;if(l="",/text\/rtf/.test(i)&&(c=n.getData("text/rtf")),/text\/html/.test(i)?(l=n.getData("text/html"),M.browser.mozilla&&("<p></p>"===l||""===l||/<!--StartFragment-->([ ])<!--EndFragment-->/.test(l)||/<!--StartFragment-->([<p></p>]*)<!--EndFragment-->/.test(l))&&(l=M.win.localStorage.getItem("fr-copied-html"))):/text\/uri-list/.test(i)&&M.browser.safari?l=n.getData("text/uri-list"):/text\/rtf/.test(i)&&M.browser.safari?l=c:/public.rtf/.test(i)&&M.browser.safari&&(l=n.getData("text/rtf")),d=n.getData("text"),""!==l)return m(),e.preventDefault&&(e.stopPropagation(),e.preventDefault()),!1;l=null}return function s(){if(M.selection.save(),M.events.disableBlur(),l=null,p){p.html("");var e=g(M.selection.get().anchorNode)+M.$wp.offset().top;p.css("top",e),M.browser.edge&&M.opts.iframe&&M.$el.append(p)}else{var t=document.getElementsByTagName("BODY")[0],n=window.getComputedStyle(t).transform;if("none"!==n){var r=g(M.selection.get().anchorNode)+M.$wp.offset().top;p=x('<div contenteditable="true" style="position: fixed; top: '+r+'px; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%; -moz-user-select: text; -webkit-user-select: text; -ms-user-select: text; user-select: text;" tabIndex="-1"></div>')}else p=x('<div contenteditable="true" style="position: fixed; top: 0; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%; -moz-user-select: text; -webkit-user-select: text; -ms-user-select: text; user-select: text;" tabIndex="-1"></div>');M.browser.webkit||M.browser.mozilla?("none"===n&&p.css("top",M.$sc.scrollTop()),M.$el.after(p)):M.browser.edge&&M.opts.iframe?M.$el.append(p):M.$box.after(p),M.events.on("destroy",function(){p.remove()})}var o;M.helpers.isIOS()&&M.$sc&&(o=M.$sc.scrollTop());M.opts.iframe&&M.$el.attr("contenteditable","false");M.helpers.isIOS()&&M.$sc&&M.$sc.scrollTop(o);var i=u.clipboardData.getData("Text");if(4e5<i.length){u.preventDefault();var a=C(i);p.get(0).innerText="",p.get(0).appendChild(a)}else p.focus();M.win.setTimeout(m,1)}(),!1}function i(e){return e&&"false"===e.contentEditable}function a(e){if(e.originalEvent&&(e=e.originalEvent),i(e.target))return!1;if(e&&e.dataTransfer&&e.dataTransfer.getData){var t="";if(f=e.dataTransfer.types,M.helpers.isArray(f))for(var n=0;n<f.length;n++)t+="".concat(f[n],";");else t=f;if(l="",/text\/rtf/.test(t)&&(c=e.dataTransfer.getData("text/rtf")),/text\/html/.test(t)?l=e.dataTransfer.getData("text/html"):/text\/rtf/.test(t)&&M.browser.safari?l=c:/text\/plain/.test(t)&&!this.browser.mozilla&&(l=M.html.escapeEntities(e.dataTransfer.getData("text/plain")).replace(/\n/g,"<br>")),""!==l){M.keys.forceUndo(),A=M.snapshot.get(),M.selection.save(),M.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-helper");var r=M.markers.insertAtPoint(e);if(M.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-placeholder"),M.$el.find(".fr-marker-helper").addClass("fr-marker").removeClass("fr-marker-helper"),M.selection.restore(),M.selection.remove(),M.$el.find(".fr-marker-placeholder").addClass("fr-marker").removeClass("fr-marker-placeholder"),!1!==r){var o=M.el.querySelector(".fr-marker");return x(o).replaceWith(H.MARKERS),M.selection.restore(),m(),e.preventDefault&&(e.stopPropagation(),e.preventDefault()),!1}}else l=null}}function g(e){return e.nodeType===Node.TEXT_NODE?e.parentNode.offsetTop:e.offsetTop}function C(e){var n=M.html.defaultTag()||"p",t=e.split(/\n/g),r=document.createDocumentFragment();return t.forEach(function(e){var t=document.createElement(n);t.appendChild(""===e?document.createElement("br"):document.createTextNode(e)),r.appendChild(t)}),r}function m(){M.opts.iframe&&M.$el.attr("contenteditable","true"),M.browser.edge&&M.opts.iframe&&M.$box.after(p),A||(M.keys.forceUndo(),A=M.snapshot.get()),l||(l=p.get(0).innerHTML,d=p.text(),M.$el[0].setAttribute("plainpaste",!0),M.selection.restore(),M.events.enableBlur());var e=l.match(/(MSFontService|class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument|LibreOffice)/gi),t=M.events.chainTrigger("paste.beforeCleanup",l);if(t&&"string"==typeof t){l=t;var n=(new DOMParser).parseFromString(t,"text/html");d=n.body.innerText}(!e||e&&!1!==M.events.trigger("paste.wordPaste",[l]))&&s(l,e)}function w(){var e=null;try{e=M.win.localStorage.getItem("fr-copied-text")}catch(t){}return!(!e||!d||f&&-1===f.indexOf("text/html")||d.replace(/\u00A0/gi," ").replace(/\r|\n/gi,"")!==e.replace(/\u00A0/gi," ").replace(/\r|\n/gi,"")&&d.replace(/\s/g,"")!==e.replace(/\s/g,""))}function O(e){for(var t="",n=0;n++<e;)t+="&nbsp;";return t}function s(e,t,n){var r,o=null,i=null;if(0<=e.toLowerCase().indexOf("<body")){var a="";0<=e.indexOf("<style")&&(a=e.replace(/[.\s\S\w\W<>]*(<style[^>]*>[\s]*[.\s\S\w\W<>]*[\s]*<\/style>)[.\s\S\w\W<>]*/gi,"$1")),e=(e=(e=a+e.replace(/[.\s\S\w\W<>]*<body[^>]*>[\s]*([.\s\S\w\W<>]*)[\s]*<\/body>[.\s\S\w\W<>]*/gi,"$1")).replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g,function(e){return e.replace(/\n/g,"<br />")})).replace(/ \n/g," ").replace(/\n /g," ").replace(/([^>])\n([^<])/g,"$1 $2")}var s=!1;0<=e.indexOf('id="docs-internal-guid')&&(e=e.replace(/^[\w\W\s\S]* id="docs-internal-guid[^>]*>([\w\W\s\S]*)<\/b>[\w\W\s\S]*$/g,"$1"),s=!0),(0<=e.indexOf('content="Sheets"')||0<=e.indexOf("google-sheets-html-origin"))&&(e=e.replace(/width:0px;/g,""));var l=!1;if(!t)if((l=w())&&(e=M.win.localStorage.getItem("fr-copied-html")),l)e=M.clean.html(e,M.opts.pasteDeniedTags,M.opts.pasteDeniedAttrs);else{var c=M.opts.htmlAllowedStyleProps;M.opts.htmlAllowedStyleProps=M.opts.pasteAllowedStyleProps,M.opts.htmlAllowComments=!1,e=(e=(e=e.replace(/<span class="Apple-tab-span">\s*<\/span>/g,O(M.opts.tabSpaces||4))).replace(/<span class="Apple-tab-span" style="white-space:pre">(\t*)<\/span>/g,function(e,t){return O(t.length*(M.opts.tabSpaces||4))})).replace(/\t/g,O(M.opts.tabSpaces||4)),e=M.clean.html(e,M.opts.pasteDeniedTags,M.opts.pasteDeniedAttrs),M.opts.htmlAllowedStyleProps=c,M.opts.htmlAllowComments=!0,M.html.defaultTag()&&"div"===M.html.defaultTag()||(e=k(e)),e=(e=e.replace(/\r/g,"")).replace(/^ */g,"").replace(/ *$/g,"")}!t||M.wordPaste&&n||(0===(e=e.replace(/^\n*/g,"").replace(/^ /g,"")).indexOf("<colgroup>")&&(e="<table>".concat(e,"</table>")),e=k(e=function y(e){var t;e=(e=(e=(e=(e=(e=(e=(e=(e=(e=(e=(e=(e=(e=(e=e.replace(/<p(.*?)class="?'?MsoListParagraph"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ul><li>$3</li></ul>")).replace(/<p(.*?)class="?'?NumberedText"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ol><li>$3</li></ol>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ul><li$3>$5</li>")).replace(/<p(.*?)class="?'?NumberedTextCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ol><li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li>")).replace(/<p(.*?)class="?'?NumberedTextCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListBullet"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li></ul>")).replace(/<p(.*?)class="?'?NumberedTextCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li></ol>")).replace(/<span([^<]*?)style="?'?mso-list:Ignore"?'?([\s\S]*?)>([\s\S]*?)<span/gi,"<span><span")).replace(/<!--\[if !supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi,"")).replace(/<!\[if !supportLists\]>([\s\S]*?)<!\[endif\]>/gi,"")).replace(/(\n|\r| class=(")?Mso[a-zA-Z0-9]+(")?)/gi," ")).replace(/<!--[\s\S]*?-->/gi,"")).replace(/<(\/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>/gi,"");var n,r=["style","script","applet","embed","noframes","noscript"];for(t=0;t<r.length;t++){var o=new RegExp("<".concat(r[t],".*?").concat(r[t],"(.*?)>"),"gi");e=e.replace(o,"")}for(e=(e=(e=e.replace(/&nbsp;/gi," ")).replace(/<td([^>]*)><\/td>/g,"<td$1><br></td>")).replace(/<th([^>]*)><\/th>/g,"<th$1><br></th>");(e=(n=e).replace(/<[^/>][^>]*><\/[^>]+>/gi,""))!==n;);e=(e=e.replace(/<lilevel([^1])([^>]*)>/gi,'<li data-indent="true"$2>')).replace(/<lilevel1([^>]*)>/gi,"<li$1>"),e=(e=(e=M.clean.html(e,M.opts.pasteDeniedTags,M.opts.pasteDeniedAttrs)).replace(/<a>(.[^<]+)<\/a>/gi,"$1")).replace(/<br> */g,"<br>");var i=M.o_doc.createElement("div");i.innerHTML=e;var a=i.querySelectorAll("li[data-indent]");for(t=0;t<a.length;t++){var s=a[t],l=s.previousElementSibling;if(l&&"LI"===l.tagName){var c=l.querySelector(":scope > ul, :scope > ol");c||(c=document.createElement("ul"),l.appendChild(c)),c.appendChild(s)}else s.removeAttribute("data-indent")}return M.html.cleanBlankSpaces(i),e=i.innerHTML}(e))),M.opts.pastePlain&&(e=function S(e){var t,n=null,r=M.doc.createElement("div");r.innerHTML=e;var o=w(),i=r.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote");for(t=0;t<i.length;t++)if((n=i[t]).textContent){var a=o?n.innerHTML:n.innerText,s=M.clean.html("<".concat(M.html.defaultTag()||"DIV",">").concat(a,"</").concat(M.html.defaultTag()||"DIV",">"));n.outerHTML=s}for(t=(i=r.querySelectorAll("*:not(".concat("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote, ul, ol, li, table, tbody, thead, tr, td, br, img".split(",").join("):not("),")"))).length-1;0<=t;t--)(n=i[t]).outerHTML=n.innerHTML;return function l(e){for(var t=M.node.contents(e),n=0;n<t.length;n++)t[n].nodeType!==Node.TEXT_NODE&&t[n].nodeType!==Node.ELEMENT_NODE?t[n].parentNode.removeChild(t[n]):l(t[n])}(r),r.innerHTML}(e));var d=M.events.chainTrigger("paste.afterCleanup",e);if(M.$el[0].removeAttribute("plainpaste",!0),"string"==typeof d&&(e=d),""!==e){var f=M.o_doc.createElement("div");0<=(f.innerHTML=e).indexOf("<body>")?(M.html.cleanBlankSpaces(f),M.spaces.normalize(f,!0)):M.spaces.normalize(f);var p=f.getElementsByTagName("span");for(r=p.length-1;0<=r;r--){var u=p[r];0===u.attributes.length&&(u.outerHTML=u.innerHTML)}if(!0===M.opts.linkAlwaysBlank){var h=f.getElementsByTagName("a");for(r=h.length-1;0<=r;r--){var g=h[r];g.getAttribute("target")||g.setAttribute("target","_blank")}}var C=M.selection.element(),m=!1;if(C&&x(C).parentsUntil(M.el,"ul, ol").length&&(m=!0),m){var v=f.children;1===v.length&&0<=["OL","UL"].indexOf(v[0].tagName)&&(v[0].outerHTML=v[0].innerHTML)}if(!s){var b=f.getElementsByTagName("br");for(r=b.length-1;0<=r;r--){var L=b[r];M.node.isBlock(L.previousSibling)&&L.parentNode.removeChild(L)}}if(M.opts.enter===H.ENTER_BR)for(r=(o=f.querySelectorAll("p, div")).length-1;0<=r;r--)0===(i=o[r]).attributes.length&&(i.outerHTML=i.innerHTML+(i.nextSibling&&!M.node.isEmpty(i)?"<br>":""));else if(M.opts.enter===H.ENTER_DIV)for(r=(o=f.getElementsByTagName("p")).length-1;0<=r;r--)0===(i=o[r]).attributes.length&&(i.outerHTML="<div>".concat(i.innerHTML,"</div>"));else M.opts.enter===H.ENTER_P&&1===f.childNodes.length&&"P"===f.childNodes[0].tagName&&0===f.childNodes[0].attributes.length&&(f.childNodes[0].outerHTML=f.childNodes[0].innerHTML);if(f.childNodes[0]instanceof HTMLHeadingElement&&M.selection.element().tagName===f.childNodes[0].tagName&&(f.childNodes[0].outerHTML=f.childNodes[0].innerHTML),f.children&&0<f.children.length)if(M.opts.trackChangesEnabled)for(var E=0;E<f.children.length;E++)f.children[E].setAttribute("id","isPasted");else f.children[0].setAttribute("id","isPasted");e=(e=f.innerHTML).replace(/\n/g,""),l&&(e=function N(e){var t,n=M.o_doc.createElement("div");n.innerHTML=e;var r=n.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(H.VOID_ELEMENTS.join("):not("),"):not(").concat(M.opts.htmlAllowedEmptyTags.join("):not("),")"));for(;r.length;){for(t=0;t<r.length;t++)r[t].parentNode.removeChild(r[t]);r=n.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(H.VOID_ELEMENTS.join("):not("),"):not(").concat(M.opts.htmlAllowedEmptyTags.join("):not("),")"))}return n.innerHTML}(e)),M.html.insert(e,!0)}!function T(){M.events.trigger("paste.after")}(),M.undo.saveStep(A),A=null,M.undo.saveStep()}function v(e){for(var t=e.length-1;0<=t;t--)e[t].attributes&&e[t].attributes.length&&e.splice(t,1);return e}function k(e){var t,n=M.o_doc.createElement("div");n.innerHTML=e;for(var r=v(Array.prototype.slice.call(n.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])")));r.length;){var o=r[r.length-1];if(M.html.defaultTag()&&"div"!==M.html.defaultTag())o.querySelector(M.html.blockTagsQuery())?o.outerHTML=o.innerHTML:o.outerHTML="<".concat(M.html.defaultTag(),">").concat(o.innerHTML,"</").concat(M.html.defaultTag(),">");else{var i=o.querySelectorAll("*");!i.length||"BR"!==i[i.length-1].tagName&&0===o.innerText.length?o.outerHTML=o.innerHTML+(o.nextSibling?"<br>":""):!i.length||"BR"!==i[i.length-1].tagName||i[i.length-1].nextSibling?o.outerHTML=o.innerHTML+(o.nextSibling?"<br>":""):o.outerHTML=o.innerHTML}r=v(Array.prototype.slice.call(n.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])")))}for(r=v(Array.prototype.slice.call(n.querySelectorAll("div:not([style])")));r.length;){for(t=0;t<r.length;t++){var a=r[t],s=a.innerHTML.replace(/\u0009/gi,"").trim();a.outerHTML=s}r=v(Array.prototype.slice.call(n.querySelectorAll("div:not([style])")))}return n.innerHTML}function b(){M.el.removeEventListener("copy",e),M.el.removeEventListener("cut",e),M.el.removeEventListener("paste",t)}return{_init:function L(){M.el.addEventListener("copy",e),M.el.addEventListener("cut",e),M.el.addEventListener("paste",t,{capture:!0}),M.events.on("drop",a),M.browser.msie&&M.browser.version<11&&(M.events.on("mouseup",function(e){2===e.button&&(setTimeout(function(){n=!1},50),n=!0)},!0),M.events.on("beforepaste",t)),M.events.on("destroy",b)},cleanEmptyTagsAndDivs:k,getRtfClipboard:function E(){return c},saveCopiedText:r,clean:s,replaceNewLines:C}},Object.assign(H.DEFAULTS,{shortcutsEnabled:[],shortcutsHint:!0}),H.SHORTCUTS_MAP={},H.RegisterShortcut=function(e,t,n,r,o,i){H.SHORTCUTS_MAP[(o?"^":"")+(i?"@":"")+e]={cmd:t,val:n,letter:r,shift:o,option:i},H.DEFAULTS.shortcutsEnabled.push(t)},H.RegisterShortcut(H.KEYCODE.E,"show",null,"E",!1,!1),H.RegisterShortcut(H.KEYCODE.B,"bold",null,"B",!1,!1),H.RegisterShortcut(H.KEYCODE.I,"italic",null,"I",!1,!1),H.RegisterShortcut(H.KEYCODE.U,"underline",null,"U",!1,!1),H.RegisterShortcut(H.KEYCODE.S,"strikeThrough",null,"S",!1,!1),H.RegisterShortcut(H.KEYCODE.CLOSE_SQUARE_BRACKET,"indent",null,"]",!1,!1),H.RegisterShortcut(H.KEYCODE.OPEN_SQUARE_BRACKET,"outdent",null,"[",!1,!1),H.RegisterShortcut(H.KEYCODE.Z,"undo",null,"Z",!1,!1),H.RegisterShortcut(H.KEYCODE.Z,"redo",null,"Z",!0,!1),H.RegisterShortcut(H.KEYCODE.Y,"redo",null,"Y",!1,!1),H.MODULES.shortcuts=function(s){var r=null;var l=!1;function e(e){if(!s.core.hasFocus())return!0;var t=e.which,n=-1!==navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey;if("keyup"===e.type&&l&&t!==H.KEYCODE.META)return l=!1;"keydown"===e.type&&(l=!1);var r=(e.shiftKey?"^":"")+(e.altKey?"@":"")+t,o=s.node.blockParent(s.selection.blocks()[0]);if(o&&"TR"==o.tagName&&o.getAttribute("contenteditable")==undefined&&(o=o.closest("table")),n&&H.SHORTCUTS_MAP[r]&&(!o||"false"!==o.getAttribute("contenteditable"))){var i=H.SHORTCUTS_MAP[r].cmd;if(i&&0<=s.opts.shortcutsEnabled.indexOf(i)){var a=H.SHORTCUTS_MAP[r].val;if(!1===s.events.trigger("shortcut",[e,i,a]))return!(l=!0);if(i&&(s.commands[i]||H.COMMANDS[i]&&H.COMMANDS[i].callback))return e.preventDefault(),e.stopPropagation(),"keydown"===e.type&&((s.commands[i]||H.COMMANDS[i].callback)(),l=!0),!1}}}return{_init:function t(){s.events.on("keydown",e,!0),s.events.on("keyup",e,!0)},get:function o(e){if(!s.opts.shortcutsHint)return null;if(!r)for(var t in r={},H.SHORTCUTS_MAP)Object.prototype.hasOwnProperty.call(H.SHORTCUTS_MAP,t)&&0<=s.opts.shortcutsEnabled.indexOf(H.SHORTCUTS_MAP[t].cmd)&&(r["".concat(H.SHORTCUTS_MAP[t].cmd,".").concat(H.SHORTCUTS_MAP[t].val||"")]={shift:H.SHORTCUTS_MAP[t].shift,option:H.SHORTCUTS_MAP[t].option,letter:H.SHORTCUTS_MAP[t].letter});var n=r[e];return n?(s.helpers.isMac()?String.fromCharCode(8984):"".concat(s.language.translate("Ctrl"),"+"))+(n.shift?s.helpers.isMac()?String.fromCharCode(8679):"".concat(s.language.translate("Shift"),"+"):"")+(n.option?s.helpers.isMac()?String.fromCharCode(8997):"".concat(s.language.translate("Alt"),"+"):"")+n.letter:null}}},H.MODULES.snapshot=function(l){function n(e){for(var t=e.parentNode.childNodes,n=0,r=null,o=0;o<t.length;o++){if(r){var i=t[o].nodeType===Node.TEXT_NODE&&""===t[o].textContent,a=r.nodeType===Node.TEXT_NODE&&t[o].nodeType===Node.TEXT_NODE,s=r.nodeType===Node.TEXT_NODE&&""===r.textContent;i||a||s||n++}if(t[o]===e)return n;r=t[o]}}function o(e){var t=[];if(!e.parentNode)return[];for(;!l.node.isElement(e);)t.push(n(e)),e=e.parentNode;return t.reverse()}function i(e,t){for(;e&&e.nodeType===Node.TEXT_NODE;){var n=e.previousSibling;n&&n.nodeType===Node.TEXT_NODE&&(t+=n.textContent.length),e=n}return t}function c(e){for(var t=l.el,n=0;n<e.length;n++)t=t.childNodes[e[n]];return t}function r(e,t){try{var n=c(t.scLoc),r=t.scOffset,o=c(t.ecLoc),i=t.ecOffset,a=l.doc.createRange();a.setStart(n,r),a.setEnd(o,i),e.addRange(a)}catch(s){}}return{get:function a(){var e,t={};if(l.events.trigger("snapshot.before"),t.html=(l.$wp?l.$el.html():l.$oel.get(0).outerHTML).replace(/ style=""/g,""),t.ranges=[],l.$wp&&l.selection.inEditor()&&l.core.hasFocus())for(var n=l.selection.ranges(),r=0;r<n.length;r++)t.ranges.push({scLoc:o((e=n[r]).startContainer),scOffset:i(e.startContainer,e.startOffset),ecLoc:o(e.endContainer),ecOffset:i(e.endContainer,e.endOffset)});return l.events.trigger("snapshot.after",[t]),t},restore:function s(e){l.$el.html()!==e.html&&(l.opts.htmlExecuteScripts?l.$el.html(e.html):l.el.innerHTML=e.html);var t=l.selection.get();l.selection.clear(),l.events.focus(!0);for(var n=0;n<e.ranges.length;n++)r(t,e.ranges[n])},equal:function d(e,t){return e.html===t.html&&(!l.core.hasFocus()||JSON.stringify(e.ranges)===JSON.stringify(t.ranges))}}},H.MODULES.undo=function(n){function e(e){var t=e.which;n.keys.ctrlKey(e)&&(t===H.KEYCODE.Z&&e.shiftKey&&e.preventDefault(),t===H.KEYCODE.Z&&e.preventDefault())}var t=null;function r(){if(n.undo_stack&&!n.undoing)for(;n.undo_stack.length>n.undo_index;)n.undo_stack.pop()}function o(){n.undo_index=0,n.undo_stack=[]}function i(){n.undo_stack=[]}return{_init:function a(){o(),n.events.on("initialized",function(){t=(n.$wp?n.$el.html():n.$oel.get(0).outerHTML).replace(/ style=""/g,"")}),n.events.on("blur",function(){n.el.querySelector(".fr-dragging")||n.undo.saveStep()}),n.events.on("keydown",e),n.events.on("destroy",i)},run:function s(){if(1<n.undo_index){n.undoing=!0;var e=n.undo_stack[--n.undo_index-1];clearTimeout(n._content_changed_timer),n.snapshot.restore(e),t=e.html,n.popups.hideAll(),n.toolbar.enable(),n.events.trigger("contentChanged"),n.events.trigger("commands.undo"),n.undoing=!1,n.selection.restore()}},redo:function l(){if(n.undo_index<n.undo_stack.length){n.undoing=!0;var e=n.undo_stack[n.undo_index++];clearTimeout(n._content_changed_timer),n.snapshot.restore(e),t=e.html,n.popups.hideAll(),n.toolbar.enable(),n.events.trigger("contentChanged"),n.events.trigger("commands.redo"),n.undoing=!1}},canDo:function c(){return!(0===n.undo_stack.length||n.undo_index<=1)},canRedo:function d(){return n.undo_index!==n.undo_stack.length},dropRedo:r,reset:o,saveStep:function f(e){if(!(!n.undo_stack||n.undoing||n.el.querySelector(".fr-marker")||n.el.querySelector(".fr-marker")&&n.opts.iframe&&n.markdown&&!n.markdown.isEnabled()))if(void 0===e){if((e=n.snapshot.get())&&e.html&&n.undo_stack[n.undo_stack.length-1]&&e.html===n.undo_stack[n.undo_stack.length-1].html)return;n.undo_stack[n.undo_index-1]&&n.snapshot.equal(n.undo_stack[n.undo_index-1],e)||(r(),n.undo_stack.push(e),n.undo_index++,function o(e,t){var n=t.split("fr-selected-cell").join("");n=n.split(' class=""').join("");var r=e.split("fr-selected-cell").join("");return n===(r=r.split(' class=""').join(""))}(t,e.html)||(n.events.trigger("contentChanged"),t=e.html))}else r(),0<n.undo_index?n.undo_stack[n.undo_index-1]=e:(n.undo_stack.push(e),n.undo_index++)}}},Object.assign(H.DEFAULTS,{height:null,heightMax:null,heightMin:null,width:null}),H.MODULES.size=function(r){function e(){o(),r.opts.height&&r.$el.css("minHeight",r.opts.height-r.helpers.getPX(r.$el.css("padding-top"))-r.helpers.getPX(r.$el.css("padding-bottom")));var e=!1;if(r.opts.fullPage)for(var t=r.$el.find("span,p,div"),n=0;n<t.length;n++)if(t[n].style.height&&t[n].style.height.includes("vh")){e=!0;break}r.opts.fullPage&&e&&(r.opts.heightMin&&r.$iframe.css("minHeight",r.opts.heightMin),r.opts.heightMax&&r.$iframe.css("maxHeight",r.opts.heightMax),r.$el.css("overflow-y","auto")),r.opts.iframe&&r.markdown&&r.markdown.isEnabled()?r.$iframe.height(r.$wp.parent().outerHeight(!0)):r.$iframe.height(r.$el.outerHeight(!0))}function o(){r.opts.heightMin?r.$el.css("minHeight",r.opts.heightMin):r.$el.css("minHeight",""),r.opts.heightMax?(r.$wp.css("maxHeight",r.opts.heightMax),r.$wp.css("overflow","auto")):(r.$wp.css("maxHeight",""),r.$wp.css("overflow","")),r.opts.height?(r.$wp.css("height",r.opts.height),r.$wp.css("overflow","auto"),r.$el.css("minHeight",r.opts.height-r.helpers.getPX(r.$el.css("padding-top"))-r.helpers.getPX(r.$el.css("padding-bottom")))):(r.$wp.css("height",""),r.opts.heightMin||r.$el.css("minHeight",""),r.opts.heightMax||r.$wp.css("overflow","")),r.opts.width&&r.$box.width(r.opts.width)}return{_init:function t(){if(!r.$wp)return!1;o(),r.$iframe&&(r.events.on("keyup keydown",function(){setTimeout(e,0)},!0),r.events.on("commands.after html.set init initialized paste.after",e))},syncIframe:e,refresh:o}},Object.assign(H.DEFAULTS,{documentReady:!1,editorClass:null,typingTimer:500,iframe:!1,requestWithCORS:!0,requestWithCredentials:!1,requestHeaders:{},useClasses:!0,spellcheck:!0,iframeDefaultStyle:'html{margin:0px;height:auto;}body{height:auto;padding:20px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;min-height:20px;}body:after{content:"";display:block;clear:both;}body::-moz-selection{background:#b5d6fd;color:#000;}body::selection{background:#b5d6fd;color:#000;}',iframeStyle:"",iframeStyleFiles:[],direction:"auto",zIndex:1,tabIndex:null,disableRightClick:!1,scrollableContainer:"body",keepFormatOnDelete:!1,theme:null}),H.MODULES.core=function(l){var c=l.$;function n(){if(l.$box.addClass("fr-box".concat(l.opts.editorClass?" ".concat(l.opts.editorClass):"")),l.$box.attr("role","application"),l.$wp.addClass("fr-wrapper"),l.opts.documentReady&&l.$box.addClass("fr-document"),function a(){l.opts.iframe||l.$el.addClass("fr-element fr-view");var e=l.opts.fontSizeDefaultSelection&&l.opts.fontSizeUnit&&"Font Size"!=l.opts.fontSizeDefaultSelection,t=l.opts.fontFamilyDefaultSelection&&"Font Family"!=l.opts.fontFamilyDefaultSelection;if(e||t){var n="";if(e&&(n+="font-size: ".concat(l.opts.fontSizeDefaultSelection).concat(l.opts.fontSizeUnit,"; ")),t&&(n+="font-family: ".concat(l.opts.fontFamilyDefaultSelection,";")),1==l.opts.iframe)l.opts.iframeStyle+=l.opts.enter===H.ENTER_BR?"body, div, p, ol, ul, table { ".concat(n," }"):"body p, div, ol, ul, table { ".concat(n," }");else{var r=c(document.getElementById("default-styles")),o="default-styles-".concat(l.id);n=l.opts.enter===H.ENTER_BR?".fr-element.fr-view.".concat(o,",.fr-box .").concat(o," p, .fr-box .").concat(o," div, .fr-box .").concat(o," table, .fr-box .").concat(o," ol, .fr-box .").concat(o," ul{ ").concat(n," }"):".fr-box .".concat(o," p, .fr-box .").concat(o," div, .fr-box .").concat(o," table, .fr-box .").concat(o," ol, .fr-box .").concat(o," ul{  ").concat(n," }"),0==r.length&&(r=c(document.createElement("style")).attr("id","default-styles"),c("head").append(r)),r.append(n),c("head").append(r),l.$el.addClass(o)}}(l.opts.height&&l.opts.height<window.innerHeight||l.opts.heightMax&&l.opts.heightMax<window.innerHeight)&&l.$el.addClass("fr-element-scroll-visible")}(),l.opts.iframe){l.$iframe.addClass("fr-iframe"),l.$el.addClass("fr-view");for(var e=0;e<l.o_doc.styleSheets.length;e++){var t=void 0,n=!1;try{t=l.o_doc.styleSheets[e].cssRules}catch(s){}if(l.o_doc.styleSheets[e].href&&(-1<l.o_doc.styleSheets[e].href.indexOf("codemirror")||-1<l.o_doc.styleSheets[e].href.indexOf("font-awesome"))&&(n=!(t=null)),t)for(var r=0,o=t.length;r<o;r++)if(!t[r].selectorText||0!==t[r].selectorText.indexOf(".fr-view")&&0!==t[r].selectorText.indexOf(".fr-element")&&0!==t[r].selectorText.indexOf(".fr-box.fr-basic .fr-element")&&0!==t[r].selectorText.indexOf(".fr-markdown-view")&&0!==t[r].selectorText.indexOf(".fr-markdown-editor")&&0!==t[r].selectorText.indexOf(".fr-wrapper-markdown")&&0!==t[r].selectorText.indexOf(".gutter-horizontal")&&0!==t[r].selectorText.indexOf(".e-resize-handler")&&0!==t[r].selectorText.indexOf(".fr-find-replace-highlight")&&0!==t[r].selectorText.indexOf(".fr-find-replace-current-highlight"))try{n&&l.o_doc.styleSheets[e].href&&t[r].selectorText&&(l.opts.iframeStyle+="".concat(t[r].selectorText,"{").concat(t[r].style.cssText,"}"),n=!1)}catch(s){}else 0<t[r].style.cssText.length&&(0===t[r].selectorText.indexOf(".fr-box.fr-basic .fr-element")&&(l.opts.iframeStyle+="".concat(t[r].selectorText,"{").concat(t[r].style.cssText,"}")),0===t[r].selectorText.indexOf(".fr-view")?l.opts.iframeStyle+="".concat(t[r].selectorText.replace(/\.fr-view/g,"body"),"{").concat(t[r].style.cssText,"}"):l.opts.iframeStyle+="".concat(t[r].selectorText.replace(/\.fr-element/g,"body"),"{").concat(t[r].style.cssText,"}"));else if(l.o_doc.styleSheets[e].href&&(-1<l.o_doc.styleSheets[e].href.indexOf("codemirror")||-1<l.o_doc.styleSheets[e].href.indexOf("font-awesome")||-1<l.o_doc.styleSheets[e].href.indexOf("froala-editor"))){var i=c("<link rel='stylesheet' type='text/css' href='".concat(l.o_doc.styleSheets[e].href,"'>"));l.$head.append(i)}}}"auto"!==l.opts.direction&&l.$box.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(l.opts.direction)),l.$el.attr("dir",l.opts.direction),l.$wp.attr("dir",l.opts.direction),1<l.opts.zIndex&&l.$box.css("z-index",l.opts.zIndex),l.opts.theme&&l.$box.addClass("".concat(l.opts.theme,"-theme")),l.opts.tabIndex=l.opts.tabIndex||l.$oel.attr("tabIndex"),l.opts.tabIndex&&l.$el.attr("tabIndex",l.opts.tabIndex)}return{_init:function r(){if(H.INSTANCES.push(l),function e(){l.drag_support={filereader:"undefined"!=typeof FileReader,formdata:Boolean(l.win.FormData),progress:"upload"in new XMLHttpRequest}}(),l.$wp){n(),l.html.set(l._original_html),l.$el.attr("spellcheck",l.opts.spellcheck),l.helpers.isMobile()&&(l.$el.attr("autocomplete",l.opts.spellcheck?"on":"off"),l.$el.attr("autocorrect",l.opts.spellcheck?"on":"off"),l.$el.attr("autocapitalize",l.opts.spellcheck?"on":"off")),l.opts.disableRightClick&&l.events.$on(l.$el,"contextmenu",function(e){if(2===e.button)return e.preventDefault(),e.stopPropagation(),!1});try{l.doc.execCommand("styleWithCSS",!1,!1)}catch(t){}}"TEXTAREA"===l.$oel.get(0).tagName&&(l.events.on("contentChanged",function(){l.$oel.val(l.html.get())}),l.events.on("form.submit",function(){l.$oel.val(l.html.get())}),l.events.on("form.reset",function(){l.html.set(l._original_html)}),l.$oel.val(l.html.get())),l.helpers.isIOS()&&l.events.$on(l.$doc,"selectionchange",function(){l.$doc.get(0).hasFocus()||l.$win.get(0).focus()}),l.events.trigger("init"),l.opts.autofocus&&!l.opts.initOnClick&&l.$wp&&l.events.on("initialized",function(){l.events.focus(!0)})},destroy:function o(e){"TEXTAREA"===l.$oel.get(0).tagName&&l.$oel.val(e),l.$box&&l.$box.removeAttr("role"),l.$wp&&("TEXTAREA"===l.$oel.get(0).tagName?(l.$el.html(""),l.$wp.html(""),l.$box.replaceWith(l.$oel),l.$oel.show()):(l.$wp.replaceWith(e),l.$el.html(""),l.$box.removeClass("fr-view fr-ltr fr-box ".concat(l.opts.editorClass||"")),l.opts.theme&&l.$box.addClass("".concat(l.opts.theme,"-theme"))));var t=document.getElementById("default-styles");t&&t.childNodes.forEach(function(e){1<=e.data.search("default-styles-".concat(l.id))&&t.removeChild(e)}),this.$wp=null,this.$el=null,this.el=null,this.$box=null},isEmpty:function e(){return l.node.isEmpty(l.el)},getXHR:function i(e,t){var n=new XMLHttpRequest;for(var r in n.open(t,e,!0),l.opts.requestWithCredentials&&(n.withCredentials=!0),l.opts.requestHeaders)Object.prototype.hasOwnProperty.call(l.opts.requestHeaders,r)&&n.setRequestHeader(r,l.opts.requestHeaders[r]);return n},injectStyle:function a(e){if(l.opts.iframe){l.$head.find("style[data-fr-style], link[data-fr-style]").remove(),l.$head.append('<style data-fr-style="true">'.concat(e,"</style>"));for(var t=0;t<l.opts.iframeStyleFiles.length;t++){var n=c('<link data-fr-style="true" rel="stylesheet" href="'.concat(l.opts.iframeStyleFiles[t],'">'));n.get(0).addEventListener("load",l.size.syncIframe),l.$head.append(n)}}},hasFocus:function t(){return l.browser.mozilla&&l.helpers.isMobile()?l.selection.inEditor():l.node.hasFocus(l.el)||0<l.$el.find("*:focus").length},sameInstance:function s(e){if(!e)return!1;var t=e.data("instance");return!!t&&t.id===l.id}}},H.POPUP_TEMPLATES={"text.edit":"[_EDIT_]"},H.RegisterTemplate=function(e,t){H.POPUP_TEMPLATES[e]=t},H.MODULES.popups=function(u){var r,d=u.$;u.shared.popups||(u.shared.popups={});var h,g=u.shared.popups;function C(e,t){t.isVisible()||(t=u.$sc),t.is(g[e].data("container"))||(g[e].data("container",t),t.append(g[e]))}function o(e){var t;e.find(".fr-upload-progress").addClass("fr-height-set"),e.find(".fr-upload-progress").removeClass("fr-height-auto"),u.popups.get("filesManager.insert").removeClass("fr-height-auto"),e.find(".fr-files-upload-layer").hasClass("fr-active")&&(t=1),e.find(".fr-files-by-url-layer").hasClass("fr-active")&&(t=2),e.find(".fr-files-embed-layer").hasClass("fr-active")&&(t=3),e.find(".fr-upload-progress-layer").get(0).clientHeight+10<e.find(".fr-upload-progress").get(0).clientHeight&&e.find(".fr-upload-progress").addClass("fr-height-auto"),400<e[0].clientHeight&&(e[0].childNodes[4].style.height="".concat(e[0].clientHeight-(e[0].childNodes[0].clientHeight+e[0].childNodes[t].clientHeight)-80,"px"))}var i=2e3;function a(){d(this).toggleClass("fr-not-empty",!0)}function s(){var e=d(this);e.toggleClass("fr-not-empty",""!==e.val())}function m(e){return g[e]&&u.node.hasClass(g[e],"fr-active")&&u.core.sameInstance(g[e])||!1}function v(e){for(var t in g)if(Object.prototype.hasOwnProperty.call(g,t)&&m(t)&&(void 0===e||g[t].data("instance")===e))return g[t];return!1}function n(e){var t=null;if(t="string"!=typeof e?e:g[e],"filesManager.insert"===e&&u.filesManager!==undefined&&u.filesManager.isChildWindowOpen())return!1;if(t&&u.node.hasClass(t,"fr-active")&&(t.removeClass("fr-active fr-above"),u.events.trigger("popups.hide.".concat(e)),u.$tb&&(1<u.opts.zIndex?u.$tb.css("zIndex",u.opts.zIndex+1):u.$tb.css("zIndex","")),u.events.disableBlur(),t.find("input, textarea, button").each(function(){this===this.ownerDocument.activeElement&&this.blur()}),t.find("input, textarea").attr("disabled","disabled"),h))for(var n=0;n<h.length;n++)d(h[n]).removeClass("fr-btn-active-popup")}function b(e){for(var t in void 0===e&&(e=[]),g)Object.prototype.hasOwnProperty.call(g,t)&&e.indexOf(t)<0&&n(t)}function t(){u.shared.exit_flag=!0}function L(){u.shared.exit_flag=!1}function l(){return u.shared.exit_flag}function c(e,t){var n,r=function c(e,t){var n=H.POPUP_TEMPLATES[e];if(!n)return null;for(var r in"function"==typeof n&&(n=n.apply(u)),t)Object.prototype.hasOwnProperty.call(t,r)&&(n=n.replace("[_".concat(r.toUpperCase(),"_]"),t[r]));return n}(e,t),o=d(u.doc.createElement("DIV"));if(!r)return"filesManager.insert"===e?o.addClass("fr-popup fr-files-manager fr-empty"):o.addClass("fr-popup fr-empty"),(n=d("body").first()).append(o),o.data("container",n),g[e]=o;"filesManager.insert"===e?o.addClass("fr-popup fr-files-manager".concat(u.helpers.isMobile()?" fr-mobile":" fr-desktop").concat(u.opts.toolbarInline?" fr-inline":"")):o.addClass("fr-popup".concat(u.helpers.isMobile()?" fr-mobile":" fr-desktop").concat(u.opts.toolbarInline?" fr-inline":"")),o.html(r),u.opts.theme&&o.addClass("".concat(u.opts.theme,"-theme")),1<u.opts.zIndex&&(!u.opts.editInPopup&&u.$tb?u.$tb.css("z-index",u.opts.zIndex+2):o.css("z-index",u.opts.zIndex+2)),"auto"!==u.opts.direction&&o.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(u.opts.direction)),o.find("input, textarea").attr("dir",u.opts.direction).attr("disabled","disabled"),(n=d("body").first()).append(o),o.data("container",n);var i=(g[e]=o).find(".fr-color-hex-layer");if(0<i.length){var a=u.helpers.getPX(o.find(".fr-color-set > span").css("width")),s=u.helpers.getPX(i.css("paddingLeft")),l=u.helpers.getPX(i.css("paddingRight"));i.css("width",a*u.opts.colorsStep+s+l)}return u.button.bindCommands(o,!1),o}function E(a){var s=g[a];return{_windowResize:function(){var e=s.data("instance")||u;if(!e.helpers.isMobile()&&s.isVisible()){var t=s.find(".fr-file-progress-bar-layer");if("file.insert"===a&&0<t.length&&t.hasClass("fr-active")){var n=u.$tb.find('.fr-command[data-cmd="insertFile"]');e.events.disableBlur();var r=u.button.getPosition(n),o=r.left,i=r.top;u.position.at(o,i,g[a],0),e.events.enableBlur()}else e.events.disableBlur(),e.popups.hide(a),e.events.enableBlur()}},_inputFocus:function(e){var t=s.data("instance")||u,n=d(e.currentTarget);if(n.is("input:file")&&n.closest(".fr-layer").addClass("fr-input-focus"),e.preventDefault(),e.stopPropagation(),setTimeout(function(){t.events.enableBlur()},100),t.helpers.isMobile()){var r=d(t.o_win).scrollTop();setTimeout(function(){d(t.o_win).scrollTop(r)},0)}},_inputBlur:function(e){var t=s.data("instance")||u,n=d(e.currentTarget);n.is("input:file")&&n.closest(".fr-layer").removeClass("fr-input-focus"),document.activeElement!==this&&d(this).isVisible()&&(t.events.blurActive()&&t.events.trigger("blur"),t.events.enableBlur())},_editorKeydown:function(e){var t=s.data("instance")||u;t.keys.ctrlKey(e)||e.which===H.KEYCODE.ALT||e.which===H.KEYCODE.ESC||(m(a)&&s.findVisible(".fr-back").length?t.button.exec(s.findVisible(".fr-back").first()):e.which!==H.KEYCODE.ALT&&t.popups.hide(a))},_preventFocus:function(e){var t=s.data("instance")||u,n=e.originalEvent?e.originalEvent.target||e.originalEvent.originalTarget:null;"mouseup"===e.type||d(n).is(":focus")||t.events.disableBlur(),"mouseup"!==e.type||d(n).hasClass("fr-command")||0<d(n).parents(".fr-command").length||d(n).hasClass("fr-dropdown-content")||d(n).hasClass("fr-dropdown-menu")||u.button.hideActiveDropdowns(s),(u.browser.safari||u.browser.mozilla)&&"mousedown"===e.type&&d(n).is("input[type=file]")&&t.events.disableBlur();var r="input, textarea, button, select, label, .fr-command";if(n&&!d(n).is(r)&&0===d(n).parents(r).length)return e.stopPropagation(),!1;n&&d(n).is(r)&&e.stopPropagation(),L()},_editorMouseup:function(){s.isVisible()&&l()&&0<s.findVisible("input:focus, textarea:focus, button:focus, select:focus").length&&u.events.disableBlur()},_windowMouseup:function(e){if(!u.core.sameInstance(s))return!0;var t=s.data("instance")||u;s.isVisible()&&l()&&(e.stopPropagation(),t.markers.remove(),t.popups.hide(a),L())},_windowKeydown:function(e){if(!u.core.sameInstance(s))return!0;var t=s.data("instance")||u,n=e.which;if(H.KEYCODE.ESC===n){if(t.popups.isVisible(a)&&t.opts.toolbarInline)return e.stopPropagation(),t.popups.isVisible(a)&&(s.findVisible(".fr-back").length?(t.button.exec(s.findVisible(".fr-back").first()),t.accessibility.focusPopupButton(s)):s.findVisible(".fr-dismiss").length?t.button.exec(s.findVisible(".fr-dismiss").first()):(t.popups.hide(a),t.toolbar.showInline(null,!0),t.accessibility.focusPopupButton(s))),!1;if(t.popups.isVisible(a))return s.findVisible(".fr-back").length?(t.button.exec(s.findVisible(".fr-back").first),t.accessibility.focusPopupButton(s)):s.findVisible(".fr-dismiss").length?t.button.exec(s.findVisible(".fr-dismiss").first()):(t.popups.hide(a),t.accessibility.focusPopupButton(s)),!1}},_repositionPopup:function(){if(!u.opts.height&&!u.opts.heightMax||u.opts.toolbarInline)return!0;if(u.$wp&&m(a)&&s.parent().get(0)===u.$sc.get(0)){var e=s.offset().top-u.$wp.offset().top,t=u.$wp.outerHeight();u.node.hasClass(s.get(0),"fr-above")&&(e+=s.outerHeight()),t<e||e<0?s.addClass("fr-hidden"):s.removeClass("fr-hidden")}},handleWindowClick:function(e){if(!u.core.sameInstance(s))return!0;var t=s.data("instance")||u;s.isVisible()&&e.target&&(0<d(e.target).find("body").length||"BODY"===d(e.target)[0].tagName)&&(e.stopPropagation(),t.popups.hide(a))}}}function f(e,t){u.events.on("mouseup",e._editorMouseup,!0),u.$wp&&u.events.on("keydown",e._editorKeydown),u.events.on("focus",function(){g[t].removeClass("focused")}),u.events.on("blur",function(){v()&&u.markers.remove(),u.helpers.isMobile()?g[t].hasClass("focused")?(b(),g[t].removeClass("focused")):g[t].addClass("focused"):g[t].find("iframe").length||b()}),u.$wp&&!u.helpers.isMobile()&&u.events.$on(u.$wp,"scroll.popup".concat(t),e._repositionPopup),u.events.on("window.mouseup",e._windowMouseup,!0),u.events.on("window.keydown",e._windowKeydown,!0),u.opts.iframe&&window.addEventListener("click",e.handleWindowClick),g[t].data("inst".concat(u.id),!0),u.events.on("destroy",function(){u.core.sameInstance(g[t])&&(d("body").first().append(g[t]),g[t].removeClass("fr-active"))},!0)}function p(){var e=d(this).prev().children().first();e.attr("checked",!e.attr("checked"))}function e(){for(var e in g)if(Object.prototype.hasOwnProperty.call(g,e)){var t=g[e];t&&(t.html("").removeData().remove(),g[e]=null)}g=[]}return u.shared.exit_flag=!1,{_init:function y(){r=window.innerHeight,u.events.on("shared.destroy",e,!0),u.events.on("window.mousedown",t),u.events.on("window.touchmove",L),u.events.$on(d(u.o_win),"scroll",L),u.events.on("mousedown",function(e){v()&&(e.stopPropagation(),u.$el.find(".fr-marker").remove(),t(),u.events.disableBlur())})},create:function S(e,t){var n=c(e,t),r=E(e);f(r,e),u.events.$on(n,"mousedown mouseup touchstart touchend touch","*",r._preventFocus,!0),u.events.$on(n,"focus","input, textarea, button, select",r._inputFocus,!0),u.events.$on(n,"blur","input, textarea, button, select",r._inputBlur,!0);var o=n.find("input, textarea");return function i(e){for(var t=0;t<e.length;t++){var n=e[t],r=d(n);0===r.next().length&&r.attr("placeholder")&&(r.after('<label for="'.concat(r.attr("id"),'">').concat(r.attr("placeholder"),"</label>")),r.attr("placeholder",""))}}(o),u.events.$on(o,"focus",a),u.events.$on(o,"blur change",s),u.events.$on(n,"click",".fr-checkbox + label",p),u.accessibility.registerPopup(e),u.helpers.isIOS()&&u.events.$on(n,"touchend","label",function(){d("#".concat(d(this).attr("for"))).prop("checked",function(e,t){return!t})},!0),u.events.$on(d(u.o_win),"resize",r._windowResize,!0),"filesManager.insert"===e&&g["filesManager.insert"].css("zIndex",2147483641),n},get:function N(e){var t=g[e];return t&&!t.data("inst".concat(u.id))&&f(E(e),e),t},show:function T(e,t,n,r,o){if(m(e)||(v()&&0<u.$el.find(".fr-marker").length?(u.events.disableBlur(),u.selection.restore()):v()||(u.events.disableBlur(),u.events.focus(),u.events.enableBlur())),b([e]),!g[e])return!1;var i=u.button.getButtons(".fr-dropdown.fr-active");i.removeClass("fr-active").attr("aria-expanded",!1).parents(".fr-toolbar").css("zIndex","").find("> .fr-dropdown-wrapper").css("height",""),i.next().attr("aria-hidden",!0).css("overflow","").find("> .fr-dropdown-wrapper").css("height",""),g[e].data("instance",u),u.$tb&&u.$tb.data("instance",u);var a=m(e);g[e].addClass("fr-active").removeClass("fr-hidden").find("input, textarea").removeAttr("disabled");var s=g[e].data("container");if(function p(e,t){t.isVisible()||(t=u.$sc),t.contains([g[e].get(0)])||t.append(g[e])}(e,s),u.opts.toolbarInline&&s&&u.$tb&&s.get(0)===u.$tb.get(0)&&(C(e,u.$sc),n=u.$tb.offset().top-u.helpers.getPX(u.$tb.css("margin-top")),t=u.$tb.offset().left+u.$tb.outerWidth()/2,u.node.hasClass(u.$tb.get(0),"fr-above")&&n&&(n+=u.$tb.outerHeight()),r=0),s=g[e].data("container"),u.opts.iframe&&!r&&!a){var l=u.helpers.getPX(u.$wp.find(".fr-iframe").css("padding-top")),c=u.helpers.getPX(u.$wp.find(".fr-iframe").css("padding-left"));t&&(t-=u.$iframe.offset().left+c),n&&(n-=u.$iframe.offset().top+l)}s.is(u.$tb)?u.$tb.css("zIndex",(u.opts.zIndex||1)+4):g[e].css("zIndex",(u.opts.zIndex||1)+3),u.opts.toolbarBottom&&s&&u.$tb&&s.get(0)===u.$tb.get(0)&&(g[e].addClass("fr-above"),n&&(n-=g[e].outerHeight())),o&&(t-=g[e].width()/2),t+g[e].outerWidth()>u.$sc.offset().left+u.$sc.width()&&(t-=t+g[e].outerWidth()-u.$sc.offset().left-u.$sc.width()),t<u.$sc.offset().left&&"rtl"===u.opts.direction&&(t=u.$sc.offset().left),g[e].removeClass("fr-active"),u.position.at(t,n,g[e],r||0);var d=u.node.blockParent(u.selection.blocks()[0]);if(d&&"false"===d.getAttribute("contenteditable"))g[e].removeClass("fr-active");else{var f=u.selection.element().parentElement.getAttribute("contenteditable");f&&"false"===f?g[e].removeClass("fr-active"):g[e].addClass("fr-active")}a||u.accessibility.focusPopup(g[e]),u.opts.toolbarInline&&u.toolbar.hide(),u.$tb&&(h=u.$tb.find(".fr-btn-active-popup")),u.events.trigger("popups.show.".concat(e)),E(e)._repositionPopup(),L()},hide:n,onHide:function M(e,t){u.events.on("popups.hide.".concat(e),t)},hideAll:b,setContainer:C,refresh:function A(e){g[e].data("instance",u),u.events.trigger("popups.refresh.".concat(e));for(var t=g[e].find(".fr-command"),n=0;n<t.length;n++){var r=d(t[n]);0===r.parents(".fr-dropdown-menu").length&&u.button.refresh(r)}},onRefresh:function x(e,t){u.events.on("popups.refresh.".concat(e),t)},onShow:function w(e,t){u.events.on("popups.show.".concat(e),t)},isVisible:m,setFileListHeight:o,areVisible:v,setPopupDimensions:function O(e,t){t&&e.find(".fr-upload-progress-layer").get(0).clientHeight<i&&(e.find(".fr-upload-progress").addClass("fr-height-auto"),u.popups.get("filesManager.insert").addClass("fr-height-auto"),e.find(".fr-upload-progress").removeClass("fr-height-set"),i=2e3),e.get(0).clientHeight>window.innerHeight/2&&(window.innerWidth<500?e.get(0).clientHeight>.6*r&&o(e):400<e.get(0).clientHeight&&o(e),i=e.find(".fr-upload-progress-layer").get(0).clientHeight);var n=window.innerWidth;switch(!0){case n<=320:e.width(200);break;case n<=420:e.width(250);break;case n<=520:e.width(300);break;case n<=720:e.width(400);break;case 720<n:e.width(530)}}}},H.MODULES.accessibility=function(f){var l,p=f.$,i=!0;function c(t){for(var e=f.$el.find('[contenteditable="true"]'),n=!1,r=0;e.get(r);)p(e.get(r)).is(":focus")&&(n=!0),r++;if(t&&t.length&&!n){t.data("blur-event-set")||t.parents(".fr-popup").length||(f.events.$on(t,"blur",function(){var e=t.parents(".fr-toolbar, .fr-popup").data("instance")||f;e.events.blurActive()&&!f.core.hasFocus()&&e.events.trigger("blur"),setTimeout(function(){e.events.enableBlur()},100)},!0),t.data("blur-event-set",!0));var o=t.parents(".fr-toolbar, .fr-popup").data("instance")||f;!f.browser.safari||l&&null!=f.shared.safariSelection||(f.shared.safariSelection=f.selection.get().getRangeAt(0).cloneRange()),o.events.disableBlur(),t.get(0).focus(),f.shared.$f_el=t}}function u(e,t){var n=t?"last":"first",r=s(C(e))[n]();if(r.length)return c(r),!0}function a(e){return e.is("input, textarea, select")&&t(),f.events.disableBlur(),e.get(0).focus(),!0}function h(e,t){var n=e.find("input, textarea, button, select, span").filter(function(){return p(this).isVisible()}).not(":disabled"),r=n.first();if((n=r.parents(".fr-color-set").get(0)&&r.parents(".fr-popup").get(0)?n.filter("input"):t?n.last():n.first()).length)return a(n);if(f.shared.with_kb){var o=e.findVisible(".fr-active-item").first();if(o.length)return a(o);var i=e.findVisible("[tabIndex]").first();if(i.length)return a(i)}}function t(){0===f.$el.find(".fr-marker").length&&f.core.hasFocus()&&f.selection.save()}function d(){var e=f.popups.areVisible();if(e){var t=e.find(".fr-buttons");return t.find("button:focus, .fr-group span:focus").length?!u(e.data("instance").$tb):!u(t)}return!u(f.$tb)}function g(){var e=null;return f.shared.$f_el.is(".fr-dropdown.fr-active")?e=f.shared.$f_el:f.shared.$f_el.closest(".fr-dropdown-menu").prev().is(".fr-dropdown.fr-active")&&(e=f.shared.$f_el.closest(".fr-dropdown-menu").prev()),e}function s(e){for(var t=-1,n=0;n<e.length;n++)p(e[n]).hasClass("fr-open")&&(t=n);var r=e.index(f.$tb.find(".fr-more-toolbar.fr-expanded > button.fr-command").first());if(0<r&&-1!==t){var o=e.slice(r,e.length),i=(e=e.slice(0,r)).slice(0,t+1),a=e.slice(t+1,e.length);e=i;for(var s=0;s<o.length;s++)e.push(o[s]);for(var l=0;l<a.length;l++)e.push(a[l])}return e}function C(e){return e.findVisible("button:not(.fr-disabled), .fr-group span.fr-command").filter(function(e){var t=p(e).parents(".fr-more-toolbar");return 0===t.length||0<t.length&&t.hasClass("fr-expanded")})}function n(e,t,n){if(f.shared.$f_el){var r=g();r&&(f.button.click(r),f.shared.$f_el=r);var o=s(C(e)),i=o.index(f.shared.$f_el);if(0===i&&!n||i===o.length-1&&n){var a;if(t){if(e.parent().is(".fr-popup"))a=!h(e.parent().children().not(".fr-buttons"),!n);!1===a&&(f.shared.$f_el=null)}t&&!1===a||u(e,!n)}else c(p(o.get(i+(n?1:-1))));return!1}}function m(e,t){return n(e,t,!0)}function v(e,t){return n(e,t)}function b(e){if(f.shared.$f_el){var t;if(f.shared.$f_el.is(".fr-dropdown.fr-active"))return c(t=e?f.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").first():f.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").last()),!1;if(f.shared.$f_el.is("a.fr-command"))return(t=e?f.shared.$f_el.closest("li").nextAllVisible().first().find(".fr-command:not(.fr-disabled)").first():f.shared.$f_el.closest("li").prevAllVisible().first().find(".fr-command:not(.fr-disabled)").first()).length||(t=e?f.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").first():f.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").last()),c(t),!1}}function L(){if(f.shared.$f_el){if(f.shared.$f_el.hasClass("fr-dropdown"))f.button.click(f.shared.$f_el);else if(f.shared.$f_el.is("button.fr-back")){f.opts.toolbarInline&&(f.events.disableBlur(),f.events.focus());var e=f.popups.areVisible(f);e&&(f.shared.with_kb=!1),f.button.click(f.shared.$f_el),y(e)}else{if(f.events.disableBlur(),f.button.click(f.shared.$f_el),f.shared.$f_el.attr("data-group-name")){var t=f.$tb.find('.fr-more-toolbar[data-name="'.concat(f.shared.$f_el.attr("data-group-name"),'"]')),n=f.shared.$f_el;t.hasClass("fr-expanded")&&(n=t.findVisible("button:not(.fr-disabled)").first()),n&&c(n)}else if(f.shared.$f_el.attr("data-popup")){var r=f.popups.areVisible(f);r&&r.data("popup-button",f.shared.$f_el)}else if(f.shared.$f_el.attr("data-modal")){var o=f.modals.areVisible(f);o&&o.data("modal-button",f.shared.$f_el)}f.shared.$f_el=null}return!1}}function E(){if(f.shared.$f_el&&(f.events.disableBlur(),f.shared.$f_el.blur(),f.shared.$f_el=null),!1!==f.events.trigger("toolbar.focusEditor")&&(f.events.disableBlur(),f.$el.get(0).focus(),f.events.focus(),f.browser.safari&&f.shared.safariSelection)){var e=f.shared.safariSelection,t=e.startContainer,n=e.endContainer,r=e.startOffset,o=e.endOffset,i=f.doc.createRange();i.setStart(t,r),i.setEnd(n,o),f.selection.get().removeAllRanges(),f.selection.get().addRange(i),f.shared.safariSelection=null}}function o(r){r&&r.length&&(f.events.$on(r,"keydown",function(e){if(!p(e.target).is("a.fr-command, button.fr-command, .fr-group span.fr-command"))return!0;var t=r.parents(".fr-popup").data("instance")||r.data("instance")||f;f.shared.with_kb=!0;var n=t.accessibility.exec(e,r);return f.shared.with_kb=!1,n},!0),f.events.$on(r,"mouseenter","[tabIndex]",function(e){var t=r.parents(".fr-popup").data("instance")||r.data("instance")||f;if(!i)return e.stopPropagation(),void e.preventDefault();var n=p(e.currentTarget);t.shared.$f_el&&t.shared.$f_el.not(n)&&t.accessibility.focusEditor()},!0),f.$tb&&f.events.$on(f.$tb,"transitionend",".fr-more-toolbar",function(){f.shared.$f_el=p(document.activeElement)}))}function y(e){var t=e.data("popup-button");t&&setTimeout(function(){c(t),e.data("popup-button",null)},0)}function S(e){var t=f.popups.areVisible(e);t&&t.data("popup-button",null)}function e(e){var t=-1!==navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey;if(e.which!==H.KEYCODE.F10||t||e.shiftKey||!e.altKey)return!0;f.shared.with_kb=!0;var n=f.popups.areVisible(f),r=!1;return n&&(r=h(n.children().not(".fr-buttons"))),r||d(),f.shared.with_kb=!1,e.preventDefault(),e.stopPropagation(),!1}return{_init:function r(){f.$wp?f.events.on("keydown",e,!0):f.events.$on(f.$win,"keydown",e,!0),f.events.on("mousedown",function(e){S(f),f.shared.$f_el&&f.el.isSameNode(f.shared.$f_el[0])&&(f.accessibility.restoreSelection(),e.stopPropagation(),f.events.disableBlur(),f.shared.$f_el=null)},!0),f.events.on("blur",function(){f.shared.$f_el=null,S(f)},!0)},registerPopup:function N(e){var t=f.popups.get(e),n=function r(c){var d=f.popups.get(c);return{_tiKeydown:function(e){var t=d.data("instance")||f;if(!1===t.events.trigger("popup.tab",[e]))return!1;var n=e.which,r=d.find(":focus").first();if(H.KEYCODE.TAB===n){e.preventDefault();var o=d.children().not(".fr-buttons"),i=o.findVisible("input, textarea, button, select").not(".fr-no-touch input, .fr-no-touch textarea, .fr-no-touch button, .fr-no-touch select, :disabled").toArray(),a=i.indexOf(this)+(e.shiftKey?-1:1);if(0<=a&&a<i.length)return t.events.disableBlur(),p(i[a]).focus(),e.stopPropagation(),!1;var s=d.find(".fr-buttons");if(s.length&&u(s,Boolean(e.shiftKey)))return e.stopPropagation(),!1;if(h(o))return e.stopPropagation(),!1}else{if(H.KEYCODE.ENTER!==n||!e.target||"TEXTAREA"===e.target.tagName)return H.KEYCODE.ESC===n?(e.preventDefault(),e.stopPropagation(),t.accessibility.restoreSelection(),t.popups.isVisible(c)&&d.findVisible(".fr-back").length?(t.opts.toolbarInline&&(t.events.disableBlur(),t.events.focus()),t.button.exec(d.findVisible(".fr-back").first()),y(d)):t.popups.isVisible(c)&&d.findVisible(".fr-dismiss").length?t.button.exec(d.findVisible(".fr-dismiss").first()):(t.popups.hide(c),t.opts.toolbarInline&&t.toolbar.showInline(null,!0),y(d)),!1):H.KEYCODE.SPACE===n&&(r.is(".fr-submit")||r.is(".fr-dismiss"))?(e.preventDefault(),e.stopPropagation(),t.events.disableBlur(),t.button.exec(r),!0):t.keys.isBrowserAction(e)?void e.stopPropagation():r.is("input[type=text], textarea")?void e.stopPropagation():H.KEYCODE.SPACE===n&&(r.is(".fr-link-attr")||r.is("input[type=file]"))?void e.stopPropagation():(e.stopPropagation(),e.preventDefault(),!1);var l=null;0<d.findVisible(".fr-submit").length?l=d.findVisible(".fr-submit").first():d.findVisible(".fr-dismiss").length&&(l=d.findVisible(".fr-dismiss").first()),l&&(e.preventDefault(),e.stopPropagation(),t.events.disableBlur(),t.button.exec(l))}},_tiMouseenter:function(){var e=d.data("instance")||f;S(e)}}}(e);o(t.find(".fr-buttons")),f.events.$on(t,"mouseenter","tabIndex",n._tiMouseenter,!0),f.events.$on(t.children().not(".fr-buttons"),"keydown","[tabIndex]",n._tiKeydown,!0),f.popups.onHide(e,function(){(t.data("instance")||f).accessibility.restoreSelection()}),f.popups.onShow(e,function(){i=!1,setTimeout(function(){i=!0},0)})},registerToolbar:o,focusToolbarElement:c,focusToolbar:u,focusContent:h,focusPopup:function T(r){var o=r.children().not(".fr-buttons");o.data("mouseenter-event-set")||(f.events.$on(o,"mouseenter","[tabIndex]",function(e){var t=r.data("instance")||f;if(!i)return e.stopPropagation(),void e.preventDefault();var n=o.find(":focus").first();n.length&&!n.is("input, button, textarea, select")&&(t.events.disableBlur(),n.blur(),t.events.disableBlur(),t.events.focus())}),o.data("mouseenter-event-set",!0)),!h(o)&&f.shared.with_kb&&u(r.find(".fr-buttons"))},focusModal:function M(e){f.core.hasFocus()||(f.events.disableBlur(),f.events.focus()),f.accessibility.saveSelection(),f.events.disableBlur(),f.el.blur(),f.selection.clear(),f.events.disableBlur(),f.shared.with_kb?e.find(".fr-command[tabIndex], [tabIndex]").first().focus():e.find("[tabIndex]").first().focus()},focusEditor:E,focusPopupButton:y,focusModalButton:function A(e){var t=e.data("modal-button");t&&setTimeout(function(){c(t),e.data("modal-button",null)},0)},hasFocus:function x(){return null!==f.shared.$f_el},exec:function w(e,t){var n=-1!==navigator.userAgent.indexOf("Mac OS X")?e.metaKey:e.ctrlKey,r=e.which,o=!1;return r!==H.KEYCODE.TAB||n||e.shiftKey||e.altKey?r!==H.KEYCODE.ARROW_RIGHT||n||e.shiftKey||e.altKey?r!==H.KEYCODE.TAB||n||!e.shiftKey||e.altKey?r!==H.KEYCODE.ARROW_LEFT||n||e.shiftKey||e.altKey?r!==H.KEYCODE.ARROW_UP||n||e.shiftKey||e.altKey?r!==H.KEYCODE.ARROW_DOWN||n||e.shiftKey||e.altKey?r!==H.KEYCODE.ENTER&&r!==H.KEYCODE.SPACE||n||e.shiftKey||e.altKey?r!==H.KEYCODE.ESC||n||e.shiftKey||e.altKey?r!==H.KEYCODE.F10||n||e.shiftKey||!e.altKey||(o=d()):o=function i(e){if(f.shared.$f_el){var t=g();return t?(f.button.click(t),c(t)):e.parent().findVisible(".fr-back").length?(f.shared.with_kb=!1,f.opts.toolbarInline&&(f.events.disableBlur(),f.events.focus()),f.button.exec(e.parent().findVisible(".fr-back")).first(),y(e.parent())):f.shared.$f_el.is("button, .fr-group span")&&(e.parent().is(".fr-popup")?(f.accessibility.restoreSelection(),f.shared.$f_el=null,!1!==f.events.trigger("toolbar.esc")&&(f.popups.hide(e.parent()),f.opts.toolbarInline&&f.toolbar.showInline(null,!0),y(e.parent()))):E()),!1}}(t):o=L():o=function a(){return f.shared.$f_el&&f.shared.$f_el.is(".fr-dropdown:not(.fr-active)")?L():b(!0)}():o=function s(){return b()}():o=v(t):o=v(t,!0):o=m(t):(l=r,o=m(t,!0)),f.shared.$f_el||void 0!==o||(o=!0),!o&&f.keys.isBrowserAction(e)&&(o=!0),!!o||(e.preventDefault(),e.stopPropagation(),!1)},saveSelection:t,restoreSelection:function O(){f.$el.find(".fr-marker").length&&(f.events.disableBlur(),f.selection.restore(),f.events.enableBlur())}}},Object.assign(H.DEFAULTS,{tooltips:!0}),H.MODULES.tooltip=function(p){var u=p.$;function r(){p.helpers.isMobile()||p.$tooltip&&p.$tooltip.removeClass("fr-visible").css("left","-3000px").css("position","fixed")}function o(e,t){if(!p.helpers.isMobile()){var n=e.attr("id")&&e.attr("id").split("-")[0],r=e.attr("title"),o=p.opts.trackChangesEnabled,i=p.opts.showChangesEnabled;if(p.opts.toolbarContainer){for(var a=!1,s=0;s<H.INSTANCES.length;s++)if(H.INSTANCES[s].core.hasFocus()){o=H.INSTANCES[s].opts.trackChangesEnabled,i=H.INSTANCES[s].opts.showChangesEnabled,a=!0;break}a||(i=o=e.hasClass("fr-active"))}if("trackChanges"===n)r=o?"Disable Track Changes":"Enable Track Changes";else if("showChanges"===n)r=i?"Hide Changes":"Show Changes";else if(("applyAll"===n||"removeAll"===n||"applyLast"===n||"removeLast"===n)&&0===p.track_changes.getPendingChanges().length)return;if(e.data("title",r),e.data("title")){p.$tooltip||function f(){if(p.opts.tooltips&&!p.helpers.isMobile()){if(p.shared.$tooltip)p.$tooltip=p.shared.$tooltip;else{p.shared.$tooltip=u(p.doc.createElement("DIV")).addClass("fr-tooltip"),p.$tooltip=p.shared.$tooltip,p.opts.theme&&p.$tooltip.addClass("".concat(p.opts.theme,"-theme"));var e={};if(p.$wp&&0<p.$wp.length&&(e=p.$wp.closest("dialog")),0<e.length)e.first().append(p.$tooltip);else if(p.$box&&0<p.$box.length&&p.$box[0]){var t=p.$box[0].getRootNode();t instanceof ShadowRoot?u(t).append(p.$tooltip):u(p.o_doc).find("body").first().append(p.$tooltip)}else u(p.o_doc).find("body").first().append(p.$tooltip)}p.events.on("shared.destroy",function(){p.$tooltip.html("").removeData().remove(),p.$tooltip=null},!0)}}(),e.removeAttr("title"),p.$tooltip.text(p.language.translate(e.data("title"))),p.$tooltip.addClass("fr-visible");var l=e.offset().left+(e.outerWidth()-p.$tooltip.outerWidth())/2;l<0&&(l=0),l+p.$tooltip.outerWidth()>u(p.o_win).width()&&(l=u(p.o_win).width()-p.$tooltip.outerWidth()),void 0===t&&(t=p.opts.toolbarBottom),e.offset().top-u(window).scrollTop()+e.outerHeight()+10>=u(window).height()&&(t=!0);var c=t?e.offset().top-p.$tooltip.height():e.offset().top+e.outerHeight();p.$tooltip.css("position",""),p.$tooltip.css("left",l),p.$tooltip.css("top",Math.ceil(c));var d={};p.$wp&&0<p.$wp.length&&(d=p.$wp.closest("dialog")),0<d.length?(p.$tooltip.css("margin-left",-d.first().offset().left),p.$tooltip.css("margin-top",-d.first().offset().top)):"static"!==u(p.o_doc).find("body").first().css("position")?(p.$tooltip.css("margin-left",-u(p.o_doc).find("body").first().offset().left),p.$tooltip.css("margin-top",-u(p.o_doc).find("body").first().offset().top)):(p.$tooltip.css("margin-left",""),p.$tooltip.css("margin-top",""))}}}return{hide:r,to:o,bind:function i(e,t,n){p.opts.tooltips&&!p.helpers.isMobile()&&(p.events.$on(e,"mouseover",t,function(e){p.node.hasClass(e.currentTarget,"fr-disabled")||p.edit.isDisabled()||o(u(e.currentTarget),n)},!0),p.events.$on(e,"mouseout ".concat(p._mousedown," ").concat(p._mouseup),t,function(){r()},!0))}}},H.TOOLBAR_VISIBLE_BUTTONS=3,H.MODULES.button=function(g){var h=g.$,a=[];(g.opts.toolbarInline||g.opts.toolbarContainer)&&(g.shared.buttons||(g.shared.buttons=[]),a=g.shared.buttons);var s=[];function l(e,t,n){for(var r=h(),o=0;o<e.length;o++){var i=h(e[o]);if(i.is(t)&&(r=r.add(i)),n&&i.is(".fr-dropdown")){var a=i.next().find(t);r=r.add(a)}}return r}function C(e,t){var n,r=h();if(!e)return r;for(n in r=(r=r.add(l(a,e,t))).add(l(s,e,t)),g.shared.popups)if(Object.prototype.hasOwnProperty.call(g.shared.popups,n)){var o=g.shared.popups[n].children().find(e);r=r.add(o)}for(n in g.shared.modals)if(Object.prototype.hasOwnProperty.call(g.shared.modals,n)){var i=g.shared.modals[n].$modal.find(e);r=r.add(i)}return r}function i(e){var t=e.next(),n=g.node.hasClass(e.get(0),"fr-active"),r=C(".fr-dropdown.fr-active").not(e),o=e.parents(".fr-toolbar, .fr-popup").data("instance")||g;o.helpers.isIOS()&&!o.el.querySelector(".fr-marker")&&(o.selection.save(),o.selection.clear(),o.selection.restore()),t.parents(".fr-more-toolbar").addClass("fr-overflow-visible");var i=0,a=0,s=t.find("> .fr-dropdown-wrapper");if(!n){var l=e.data("cmd");t.find(".fr-command").removeClass("fr-active").attr("aria-selected",!1),H.COMMANDS[l]&&H.COMMANDS[l].refreshOnShow&&H.COMMANDS[l].refreshOnShow.apply(o,[e,t]),t.css("left",e.offset().left-e.parents(".fr-btn-wrap, .fr-toolbar, .fr-buttons").offset().left-("rtl"===g.opts.direction?t.width()-e.outerWidth():0)),t.addClass("test-height"),i=t.outerHeight(),a=g.helpers.getPX(s.css("max-height")),t.removeClass("test-height"),t.css("top","").css("bottom","");var c=e.outerHeight()/10;if(!g.opts.toolbarBottom&&t.offset().top+e.outerHeight()+i<h(g.o_doc).height())t.css("top",e.position().top+e.outerHeight()-c);else{var d=0,f=e.parents(".fr-more-toolbar");0<f.length&&(d=f.first().height()),t.css("bottom",e.parents(".fr-popup, .fr-toolbar").first().height()-d-e.position().top)}}(e.addClass("fr-blink").toggleClass("fr-active"),e.hasClass("fr-options"))&&e.prev().toggleClass("fr-expanded");e.hasClass("fr-active")?(t.attr("aria-hidden",!1),e.attr("aria-expanded",!0),function u(e,t,n){n<=t&&(e.parent().css("overflow","auto"),e.parent().css("overflow-x","hidden")),e.css("height",Math.min(t,n))}(s,i,a)):(t.attr("aria-hidden",!0).css("overflow",""),e.attr("aria-expanded",!1),s.css("height","")),setTimeout(function(){e.removeClass("fr-blink")},300),t.css("margin-left",""),t.offset().left+t.outerWidth()>g.$sc.offset().left+g.$sc.width()&&t.css("margin-left",-(t.offset().left+t.outerWidth()-g.$sc.offset().left-g.$sc.width())),t.offset().left<g.$sc.offset().left&&"rtl"===g.opts.direction&&t.css("margin-left",g.$sc.offset().left),r.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0).css("overflow","").find("> .fr-dropdown-wrapper").css("height",""),r.prev(".fr-expanded").removeClass("fr-expanded"),r.parents(".fr-toolbar:not(.fr-inline)").css("zIndex",""),0!==e.parents(".fr-popup").length||g.opts.toolbarInline||(g.node.hasClass(e.get(0),"fr-active")?g.$tb.css("zIndex",(g.opts.zIndex||1)+4):g.$tb.css("zIndex",""));var p=t.find("a.fr-command.fr-active").first();g.helpers.isMobile()||(p.length?(g.accessibility.focusToolbarElement(p),s.scrollTop(Math.abs(p.parents(".fr-dropdown-content").offset().top-p.offset().top)-p.offset().top)):(g.accessibility.focusToolbarElement(e),s.scrollTop(0)))}function c(e){e.addClass("fr-blink"),setTimeout(function(){e.removeClass("fr-blink")},500);for(var t=e.data("cmd"),n=[];void 0!==e.data("param".concat(n.length+1));)n.push(e.data("param".concat(n.length+1)));var r=C(".fr-dropdown.fr-active");r.length&&(r.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0).css("overflow","").find("> .fr-dropdown-wrapper").css("height",""),r.prev(".fr-expanded").removeClass("fr-expanded"),r.parents(".fr-toolbar:not(.fr-inline)").css("zIndex","")),e.parents(".fr-popup, .fr-toolbar").data("instance").commands.exec(t,n)}function t(e){var t=e.parents(".fr-popup, .fr-toolbar").data("instance"),n=g.popups.get("link.insert");if(0===e.parents(".fr-popup").length&&e.data("popup")&&!e.hasClass("fr-btn-active-popup")&&(e.attr("id")==="insertLink-".concat(g.id)&&n&&n.hasClass("fr-active")||e.addClass("fr-btn-active-popup")),0!==e.parents(".fr-popup").length||e.data("popup")||t.popups.hideAll(),t.popups.areVisible()&&!t.popups.areVisible(t)){for(var r=0;r<H.INSTANCES.length;r++)H.INSTANCES[r]!==t&&H.INSTANCES[r].popups&&H.INSTANCES[r].popups.areVisible()&&H.INSTANCES[r].$el.find(".fr-marker").remove();t.popups.hideAll()}g.node.hasClass(e.get(0),"fr-dropdown")?i(e):(!function o(e){c(e)}(e),H.COMMANDS[e.data("cmd")]&&!1!==H.COMMANDS[e.data("cmd")].refreshAfterCallback&&t.button.bulkRefresh())}function d(e){t(h(e.currentTarget))}function f(e){var t=e.find(".fr-dropdown.fr-active");t.length&&(t.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0).css("overflow","").find("> .fr-dropdown-wrapper").css("height",""),t.parents(".fr-toolbar:not(.fr-inline)").css("zIndex",""),t.prev().removeClass("fr-expanded"))}function p(e){e.preventDefault(),e.stopPropagation()}function u(e){if(e.stopPropagation(),!g.helpers.isMobile())return!1}function m(e){var t=1<arguments.length&&arguments[1]!==undefined?arguments[1]:{},n=2<arguments.length?arguments[2]:undefined;if(g.helpers.isMobile()&&!1===t.showOnMobile)return"";var r=t.displaySelection;"function"==typeof r&&(r=r(g));var o="";if("options"!==t.type)if(r){var i="function"==typeof t.defaultSelection?t.defaultSelection(g):t.defaultSelection;o='<span style="width:'.concat(t.displaySelectionWidth||100,'px">').concat(g.language.translate(i||t.title),"</span>")}else o=g.icon.create(t.icon||e),o+='<span class="fr-sr-only">'.concat(g.language.translate(t.title)||"","</span>");var a=t.popup?' data-popup="true"':"",s=t.modal?' data-modal="true"':"",l=g.shortcuts.get("".concat(e,"."));l=l?" (".concat(l,")"):"";var c="".concat(e,"-").concat(g.id),d="dropdown-menu-".concat(c),f='<button id="'.concat(c,'"').concat(t.more_btn?' data-group-name="'.concat(c,'" '):"",'type="button" tabIndex="-1" role="button"').concat(t.toggle?' aria-pressed="false"':"").concat("dropdown"===t.type||"options"===t.type?' aria-controls="'.concat(d,'" aria-expanded="false" aria-haspopup="true"'):"").concat(t.disabled?' aria-disabled="true"':"",' title="').concat(g.language.translate(t.title)||"").concat(l,'" class="fr-command fr-btn').concat("dropdown"===t.type||"options"==t.type?" fr-dropdown":"").concat("options"==t.type?" fr-options":"").concat("more"==t.type?" fr-more":"").concat(t.displaySelection?" fr-selection":"").concat(t.back?" fr-back":"").concat(t.disabled?" fr-disabled":"").concat(n?"":" fr-hidden",'" data-cmd="').concat(e,'"').concat(a).concat(s,">").concat(o,"</button>");if("dropdown"===t.type||"options"===t.type){var p='<div id="'.concat(d,'" class="fr-dropdown-menu" role="listbox" aria-labelledby="').concat(c,'" aria-hidden="true"><div class="fr-dropdown-wrapper" role="presentation"><div class="fr-dropdown-content" role="presentation">');p+=function u(e,t){var n="";if(t.html)"function"==typeof t.html?n+=t.html.call(g):n+=t.html;else{var r=t.options;for(var o in"function"==typeof r&&(r=r()),n+='<ul class="fr-dropdown-list" role="presentation">',r)if(Object.prototype.hasOwnProperty.call(r,o)){var i=g.shortcuts.get("".concat(e,".").concat(o));i=i?'<span class="fr-shortcut">'.concat(i,"</span>"):"",n+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="'.concat("options"===t.type?e.replace(/Options/g,""):e,'" data-param1="').concat(o,'" title="').concat(r[o],'">').concat(g.language.translate(r[o]),"</a></li>")}n+="</ul>"}return n}(e,t),f+=p+="</div></div></div>"}return t.hasOptions&&t.hasOptions.apply(g)&&(f='<div class="fr-btn-wrap">'.concat(f," ").concat(m(e+"Options",Object.assign({},t,{type:"options",hasOptions:!1}),n),"  </div>")),f}function e(o){var i=g.$tb&&g.$tb.data("instance")||g;if(!1===g.events.trigger("buttons.refresh"))return!0;setTimeout(function(){for(var e=i.selection.inEditor()&&i.core.hasFocus(),t=0;t<o.length;t++){var n=h(o[t]),r=n.data("cmd");0===n.parents(".fr-popup").length?e||H.COMMANDS[r]&&H.COMMANDS[r].forcedRefresh?i.button.refresh(n):g.node.hasClass(n.get(0),"fr-dropdown")||(n.removeClass("fr-active"),n.attr("aria-pressed")&&n.attr("aria-pressed",!1)):n.parents(".fr-popup").isVisible()&&i.button.refresh(n)}},0)}function n(){e(a),e(s)}function r(){a=[],s=[]}g.shared.popup_buttons||(g.shared.popup_buttons=[]),s=g.shared.popup_buttons;var o=null;function v(){clearTimeout(o),o=setTimeout(n,50)}return{_init:function b(){g.opts.toolbarInline?g.events.on("toolbar.show",n):(g.events.on("mouseup",v),g.events.on("keyup",v),g.events.on("blur",v),g.events.on("focus",v),g.events.on("contentChanged",v),g.helpers.isMobile()&&g.events.$on(g.$doc,"selectionchange",n)),g.events.on("shared.destroy",r)},build:m,buildList:function L(e,t){for(var n="",r=0;r<e.length;r++){var o=e[r],i=H.COMMANDS[o];i&&"undefined"!=typeof i.plugin&&g.opts.pluginsEnabled.indexOf(i.plugin)<0||(i?n+=m(o,i,void 0===t||0<=t.indexOf(o)):"|"===o?n+='<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>':"-"===o&&(n+='<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>'))}return n},buildGroup:function E(e){var t="",n="";for(var r in e){var o=e[r];if(o.buttons){for(var i="",a="",s=0,l="left",c=H.TOOLBAR_VISIBLE_BUTTONS,d=0;d<o.buttons.length;d++){var f=o.buttons[d],p=H.COMMANDS[f];p||("|"==f?i+='<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>':"-"==f&&(i+='<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>')),!p||p&&"undefined"!=typeof p.plugin&&g.opts.pluginsEnabled.indexOf(p.plugin)<0||(e[r].align!==undefined&&(l=e[r].align),e[r].buttonsVisible!==undefined&&(c=e[r].buttonsVisible),e.showMoreButtons&&c<=s?a+=m(f,p,!0):i+=m(f,p,!0),s++)}if(e.showMoreButtons&&c<s){var u=r,h=H.COMMANDS[u];h.more_btn=!0,i+=m(u,h,!0)}"trackChanges"!==r&&(t+='<div class="fr-btn-grp fr-float-'.concat(l,'">').concat(i,"</div>")),e.showMoreButtons&&0<a.length&&(n+='<div class="fr-more-toolbar" data-name="'.concat(r+"-"+g.id,'">').concat(a,"</div>"))}}return g.opts.toolbarBottom?g.helpers.isMobile()?'<div class="fr-bottom-extended">'.concat(n,"</div><div>").concat(t,"</div>"):"".concat(n,'<div class="fr-newline"></div>').concat(t):"".concat(t,'<div class="fr-newline"></div>').concat(n)},bindCommands:function y(t,e){g.events.bindClick(t,".fr-command:not(.fr-disabled)",d),g.events.$on(t,"".concat(g._mousedown," ").concat(g._mouseup," ").concat(g._move),".fr-dropdown-menu",p,!0),g.events.$on(t,"".concat(g._mousedown," ").concat(g._mouseup," ").concat(g._move),".fr-dropdown-menu .fr-dropdown-wrapper",u,!0);var n=t.get(0).ownerDocument,r="defaultView"in n?n.defaultView:n.parentWindow;function o(e){(!e||e.type===g._mouseup&&e.target!==h("html").get(0)||"keydown"===e.type&&(g.keys.isCharacter(e.which)&&!g.keys.ctrlKey(e)||e.which===H.KEYCODE.ESC))&&(f(t),g.opts.iframe&&function r(e){var t=e.find(".fr-popup.fr-active");if(t.length){t.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0).css("overflow","").find("> .fr-dropdown-wrapper").css("height",""),t.parents(".fr-toolbar:not(.fr-inline)").css("zIndex",""),t.prev().removeClass("fr-expanded");var n=g.$tb.find(".fr-btn-active-popup");h(n[0]).removeClass("fr-btn-active-popup")}}(t))}g.events.$on(h(r),"".concat(g._mouseup," resize keydown"),o,!0),g.opts.iframe&&g.events.$on(g.$win,g._mouseup,o,!0),g.node.hasClass(t.get(0),"fr-popup")?h.merge(s,t.find(".fr-btn").toArray()):h.merge(a,t.find(".fr-btn").toArray()),g.tooltip.bind(t,".fr-btn, .fr-title",e)},refresh:function S(e){var t,n=e.parents(".fr-popup, .fr-toolbar").data("instance")||g,r=e.data("cmd");g.node.hasClass(e.get(0),"fr-dropdown")?t=e.next():(e.removeClass("fr-active"),e.attr("aria-pressed")&&e.attr("aria-pressed",!1)),H.COMMANDS[r]&&H.COMMANDS[r].refresh?H.COMMANDS[r].refresh.apply(n,[e,t]):g.refresh[r]&&n.refresh[r](e,t)},bulkRefresh:n,exec:c,click:t,hideActiveDropdowns:f,addButtons:function N(e){for(var t=0;t<e.length;t++)a.push(e[t])},getButtons:C,getPosition:function T(e){var t=e.offset().left,n=g.opts.toolbarBottom?10:e.outerHeight()-10;return{left:t,top:e.offset().top+n}}}},H.ICON_TEMPLATES={font_awesome:'<i class="fa fa-[NAME]" aria-hidden="true"></i>',font_awesome_5:'<i class="fas fa-[FA5NAME]" aria-hidden="true"></i>',font_awesome_5r:'<i class="far fa-[FA5NAME]" aria-hidden="true"></i>',font_awesome_5l:'<i class="fal fa-[FA5NAME]" aria-hidden="true"></i>',font_awesome_5b:'<i class="fab fa-[FA5NAME]" aria-hidden="true"></i>',text:'<span style="text-align: center;">[NAME]</span>',image:"<img src=[SRC] alt=[ALT] />",svg:'<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="[PATH]"/></svg>',svgMultiplePath:'<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">[PATHS]</svg>',empty:" "},H.ICONS={bold:{NAME:"bold",SVG_KEY:"bold"},italic:{NAME:"italic",SVG_KEY:"italic"},underline:{NAME:"underline",SVG_KEY:"underline"},strikeThrough:{NAME:"strikethrough",SVG_KEY:"strikeThrough"},subscript:{NAME:"subscript",SVG_KEY:"subscript"},superscript:{NAME:"superscript",SVG_KEY:"superscript"},cancel:{NAME:"cancel",SVG_KEY:"cancel"},color:{NAME:"tint",SVG_KEY:"textColor"},outdent:{NAME:"outdent",SVG_KEY:"outdent"},indent:{NAME:"indent",SVG_KEY:"indent"},undo:{NAME:"rotate-left",FA5NAME:"undo",SVG_KEY:"undo"},redo:{NAME:"rotate-right",FA5NAME:"redo",SVG_KEY:"redo"},insert:{NAME:"insert",SVG_KEY:"insert"},insertAll:{NAME:"insertAll",SVG_KEY:"insertAll"},insertHR:{NAME:"minus",SVG_KEY:"horizontalLine"},clearFormatting:{NAME:"eraser",SVG_KEY:"clearFormatting"},selectAll:{NAME:"mouse-pointer",SVG_KEY:"selectAll"},minimize:{NAME:"minimize",SVG_KEY:"minimize"},moreText:{NAME:"ellipsis-v",SVG_KEY:"textMore"},moreParagraph:{NAME:"ellipsis-v",SVG_KEY:"paragraphMore"},moreRich:{NAME:"ellipsis-v",SVG_KEY:"insertMore"},moreMisc:{NAME:"ellipsis-v",SVG_KEY:"more"}},H.DefineIconTemplate=function(e,t){H.ICON_TEMPLATES[e]=t},H.DefineIcon=function(e,t){H.ICONS[e]=t},Object.assign(H.DEFAULTS,{iconsTemplate:"svg"}),H.MODULES.icon=function(o){return{create:function i(n){var e=null,r=H.ICONS[n];if(void 0!==r){var t=r.template||H.ICON_DEFAULT_TEMPLATE||o.opts.iconsTemplate;t&&t.apply&&(t=t.apply(o)),r.FA5NAME||(r.FA5NAME=r.NAME),"svg"!==t||r.PATH||(r.PATH=H.SVG[r.SVG_KEY]||""),t&&(t=H.ICON_TEMPLATES[t])&&(e=t.replace(/\[([a-zA-Z0-9]*)\]/g,function(e,t){return"NAME"===t?r[t]||n:r[t]}))}return e||n},getTemplate:function r(e){var t=H.ICONS[e],n=o.opts.iconsTemplate;return void 0!==t?n=t.template||H.ICON_DEFAULT_TEMPLATE||o.opts.iconsTemplate:n},getFileIcon:function n(e){var t=H.FILEICONS[e];return void 0!==t?t:e}}},H.SVG={imageTransformations:"M3 5.8h2.8V3H3v2.8Zm0 7.6h2.8v-2.8H3v2.8Zm15.2 0H21v-2.8h-2.8v2.8Zm-7.6-7.6h2.8V3h-2.8v2.8Zm0 14.2h2.8v-2.8h-2.8V20ZM3 20h2.8v-2.8H3V20ZM18.2 5.8H21V3h-2.8v2.8Zm0 14.2H21v-2.8h-2.8V20ZM6.8 4.9h2.8V4H6.8v.9Zm0 14.2h2.8v-.9H6.8v.9Zm7.6-14.2h2.8V4h-2.8v.9Zm0 14.2h2.8v-.9h-2.8v.9ZM3.9 9.6h.9V6.8h-.9v2.8Zm15.2 0h.9V6.8h-.9v2.8ZM3.9 16.2h.9v-1.9h-.9v1.9Zm15.2 0h.9v-1.9h-.9v1.9ZM15.8 14l-2.2 2.3V14h2.2Zm0-6.8v6.2H15V8H9v7.3h4.1v.9H8.2v-9h7.6Zm-4.3 5.3v.8h-.8v-.8h.8Zm1.3-1.4v.8h-2.2v-.8h2.2Zm.6-1.5v.8h-2.7v-.8h2.7Z",filestackIcon:"M19 16.5 15 21v-4.5h4Zm0-1.125h-1.5V4.687h-11v14.625l7.5.001V21H5V3h14v12.375Zm-8-1.687v1.687H9.5v-1.687H11Zm2.5-2.813v1.687h-4v-1.687h4Zm1-2.813v1.687h-5V8.062h5Z",add:"M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z",advancedImageEditor:"M3,17v2h6v-2H3z M3,5v2h10V5H3z M13,21v-2h8v-2h-8v-2h-2v6H13z M7,9v2H3v2h4v2h2V9H7z M21,13v-2H11v2H21z M15,9h2V7h4V5h-4  V3h-2V9z",alignCenter:"M9,18h6v-2H9V18z M6,11v2h12v-2H6z M3,6v2h18V6H3z",alignJustify:"M3,18h18v-2H3V18z M3,11v2h18v-2H3z M3,6v2h18V6H3z",alignLeft:"M3,18h6v-2H3V18z M3,11v2h12v-2H3z M3,6v2h18V6H3z",alignRight:"M15,18h6v-2h-6V18z M9,11v2h12v-2H9z M3,6v2h18V6H3z",anchors:"M16,4h-4H8C6.9,4,6,4.9,6,6v4v10l6-2.6l6,2.6V10V6C18,4.9,17.1,4,16,4z M16,17l-4-1.8L8,17v-7V6h4h4v4V17z",autoplay:"M 7.570312 0.292969 C 7.542969 0.292969 7.515625 0.292969 7.488281 0.296875 C 7.203125 0.324219 6.984375 0.539062 6.980469 0.792969 L 6.925781 3.535156 C 2.796875 3.808594 -0.0078125 6.425781 -0.0859375 10.09375 C -0.121094 11.96875 0.710938 13.6875 2.265625 14.921875 C 3.769531 16.117188 5.839844 16.796875 8.097656 16.828125 C 8.140625 16.828125 12.835938 16.898438 13.035156 16.886719 C 15.171875 16.796875 17.136719 16.128906 18.558594 15.003906 C 20.066406 13.816406 20.882812 12.226562 20.917969 10.40625 C 20.960938 8.410156 20.023438 6.605469 18.289062 5.335938 C 18.214844 5.277344 18.128906 5.230469 18.035156 5.203125 C 17.636719 5.074219 17.222656 5.199219 17 5.476562 L 15.546875 7.308594 C 15.304688 7.609375 15.363281 8.007812 15.664062 8.265625 C 16.351562 8.851562 16.707031 9.625 16.6875 10.5 C 16.652344 12.25 15.070312 13.390625 12.757812 13.535156 C 12.59375 13.539062 8.527344 13.472656 8.164062 13.464844 C 5.703125 13.429688 4.101562 12.191406 4.140625 10.3125 C 4.175781 8.570312 5.132812 7.46875 6.847656 7.199219 L 6.796875 9.738281 C 6.792969 9.992188 7 10.214844 7.285156 10.253906 C 7.3125 10.257812 7.339844 10.257812 7.367188 10.257812 C 7.503906 10.261719 7.632812 10.222656 7.738281 10.148438 L 14.039062 5.785156 C 14.171875 5.691406 14.253906 5.558594 14.253906 5.410156 C 14.257812 5.261719 14.1875 5.125 14.058594 5.027344 L 7.941406 0.414062 C 7.835938 0.335938 7.707031 0.292969 7.570312 0.292969 ",back:"M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z",backgroundColor:"M9.91752,12.24082l7.74791-5.39017,1.17942,1.29591-6.094,7.20747L9.91752,12.24082M7.58741,12.652l4.53533,4.98327a.93412.93412,0,0,0,1.39531-.0909L20.96943,8.7314A.90827.90827,0,0,0,20.99075,7.533l-2.513-2.76116a.90827.90827,0,0,0-1.19509-.09132L7.809,11.27135A.93412.93412,0,0,0,7.58741,12.652ZM2.7939,18.52772,8.41126,19.5l1.47913-1.34617-3.02889-3.328Z",blockquote:"M10.31788,5l.93817,1.3226A12.88271,12.88271,0,0,0,8.1653,9.40125a5.54242,5.54242,0,0,0-.998,3.07866v.33733q.36089-.04773.66067-.084a4.75723,4.75723,0,0,1,.56519-.03691,2.87044,2.87044,0,0,1,2.11693.8427,2.8416,2.8416,0,0,1,.8427,2.09274,3.37183,3.37183,0,0,1-.8898,2.453A3.143,3.143,0,0,1,8.10547,19,3.40532,3.40532,0,0,1,5.375,17.7245,4.91156,4.91156,0,0,1,4.30442,14.453,9.3672,9.3672,0,0,1,5.82051,9.32933,14.75716,14.75716,0,0,1,10.31788,5Zm8.39243,0,.9369,1.3226a12.88289,12.88289,0,0,0-3.09075,3.07865,5.54241,5.54241,0,0,0-.998,3.07866v.33733q.33606-.04773.63775-.084a4.91773,4.91773,0,0,1,.58938-.03691,2.8043,2.8043,0,0,1,2.1042.83,2.89952,2.89952,0,0,1,.80578,2.10547,3.42336,3.42336,0,0,1-.86561,2.453A3.06291,3.06291,0,0,1,16.49664,19,3.47924,3.47924,0,0,1,13.742,17.7245,4.846,4.846,0,0,1,12.64721,14.453,9.25867,9.25867,0,0,1,14.17476,9.3898,15.26076,15.26076,0,0,1,18.71031,5Z",bold:"M15.25,11.8h0A3.68,3.68,0,0,0,17,9a3.93,3.93,0,0,0-3.86-4H6.65V19h7a3.74,3.74,0,0,0,3.7-3.78V15.1A3.64,3.64,0,0,0,15.25,11.8ZM8.65,7h4.2a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61,2.23,2.23,0,0,1-.63.09H8.65Zm4.6,10H8.65V13h4.6a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61A2.23,2.23,0,0,1,13.25,17Z",cancel:"M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z",cellBackground:"M16.6,12.4L7.6,3.5L6.2,4.9l2.4,2.4l-5.2,5.2c-0.6,0.6-0.6,1.5,0,2.1l5.5,5.5c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4  l5.5-5.5C17.2,14,17.2,13,16.6,12.4z M5.2,13.5L10,8.7l4.8,4.8H5.2z M19,15c0,0-2,2.2-2,3.5c0,1.1,0.9,2,2,2s2-0.9,2-2  C21,17.2,19,15,19,15z",cellBorderColor:"M22,22H2v2h20V22z",cellOptions:"M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M9.5,6.5h5V9h-5V6.5z M8,17.5H4  c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z   M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4  c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0V9z",cellStyle:"M20,19.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L12.3,17h3.8l1.7-3.5l1.4,3.5H23L20,19.9z M20,5H4C2.9,5,2,5.9,2,7v10  c0,1.1,0.9,2,2,2h7.5l-0.6-0.6L10,17.5H9.5V15h5.4l1.1-2.3v-2.2h4.5v3H20l0.6,1.5H22V7C22,5.9,21.1,5,20,5z M3.5,7  c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0.1,0h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M4,17.5c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0-0.1v-2H8v2.5H4  z M14.5,9h-5V6.5h5V9z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1V9z",clearFormatting:"M11.48,10.09l-1.2-1.21L8.8,7.41,6.43,5,5.37,6.1,8.25,9,4.66,19h2l1.43-4h5.14l1.43,4h2l-.89-2.51L18.27,19l1.07-1.06L14.59,13.2ZM8.8,13l.92-2.56L12.27,13Zm.56-7.15L9.66,5h2l1.75,4.9Z",close:"M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z",codeView:"M9.4,16.6,4.8,12,9.4,7.4,8,6,2,12l6,6Zm5.2,0L19.2,12,14.6,7.4,16,6l6,6-6,6Z",cogs:"M18.877 12.907a6.459 6.459 0 0 0 0 -1.814l1.952 -1.526a0.468 0.468 0 0 0 0.111 -0.593l-1.851 -3.2a0.461 0.461 0 0 0 -0.407 -0.231 0.421 0.421 0 0 0 -0.157 0.028l-2.3 0.925a6.755 6.755 0 0 0 -1.563 -0.907l-0.352 -2.452a0.451 0.451 0 0 0 -0.453 -0.388h-3.7a0.451 0.451 0 0 0 -0.454 0.388L9.347 5.588A7.077 7.077 0 0 0 7.783 6.5l-2.3 -0.925a0.508 0.508 0 0 0 -0.166 -0.028 0.457 0.457 0 0 0 -0.4 0.231l-1.851 3.2a0.457 0.457 0 0 0 0.111 0.593l1.952 1.526A7.348 7.348 0 0 0 5.063 12a7.348 7.348 0 0 0 0.064 0.907L3.175 14.433a0.468 0.468 0 0 0 -0.111 0.593l1.851 3.2a0.461 0.461 0 0 0 0.407 0.231 0.421 0.421 0 0 0 0.157 -0.028l2.3 -0.925a6.74 6.74 0 0 0 1.564 0.907L9.7 20.864a0.451 0.451 0 0 0 0.454 0.388h3.7a0.451 0.451 0 0 0 0.453 -0.388l0.352 -2.452a7.093 7.093 0 0 0 1.563 -0.907l2.3 0.925a0.513 0.513 0 0 0 0.167 0.028 0.457 0.457 0 0 0 0.4 -0.231l1.851 -3.2a0.468 0.468 0 0 0 -0.111 -0.593Zm-0.09 2.029l-0.854 1.476 -2.117 -0.852 -0.673 0.508a5.426 5.426 0 0 1 -1.164 0.679l-0.795 0.323 -0.33 2.269h-1.7l-0.32 -2.269 -0.793 -0.322a5.3 5.3 0 0 1 -1.147 -0.662L8.2 15.56l-2.133 0.86 -0.854 -1.475 1.806 -1.411 -0.1 -0.847c-0.028 -0.292 -0.046 -0.5 -0.046 -0.687s0.018 -0.4 0.045 -0.672l0.106 -0.854L5.217 9.064l0.854 -1.475 2.117 0.851 0.673 -0.508a5.426 5.426 0 0 1 1.164 -0.679l0.8 -0.323 0.331 -2.269h1.7l0.321 2.269 0.792 0.322a5.3 5.3 0 0 1 1.148 0.661l0.684 0.526 2.133 -0.859 0.853 1.473 -1.8 1.421 0.1 0.847a5 5 0 0 1 0.046 0.679c0 0.193 -0.018 0.4 -0.045 0.672l-0.106 0.853ZM12 14.544A2.544 2.544 0 1 1 14.546 12 2.552 2.552 0 0 1 12 14.544Z",columns:"M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z M20.5,17  c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0  V9z",edit:"M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z",exitFullscreen:"M5,16H8v3h2V14H5ZM8,8H5v2h5V5H8Zm6,11h2V16h3V14H14ZM16,8V5H14v5h5V8Z",fileInsert:"M 8.09375 12.75 L 5.90625 12.75 C 5.542969 12.75 5.25 12.394531 5.25 11.953125 L 5.25 6.375 L 2.851562 6.375 C 2.367188 6.375 2.121094 5.660156 2.464844 5.242188 L 6.625 0.1875 C 6.832031 -0.0585938 7.167969 -0.0585938 7.371094 0.1875 L 11.535156 5.242188 C 11.878906 5.660156 11.632812 6.375 11.148438 6.375 L 8.75 6.375 L 8.75 11.953125 C 8.75 12.394531 8.457031 12.75 8.09375 12.75 Z M 14 12.484375 L 14 16.203125 C 14 16.644531 13.707031 17 13.34375 17 L 0.65625 17 C 0.292969 17 0 16.644531 0 16.203125 L 0 12.484375 C 0 12.042969 0.292969 11.6875 0.65625 11.6875 L 4.375 11.6875 L 4.375 11.953125 C 4.375 12.980469 5.0625 13.8125 5.90625 13.8125 L 8.09375 13.8125 C 8.9375 13.8125 9.625 12.980469 9.625 11.953125 L 9.625 11.6875 L 13.34375 11.6875 C 13.707031 11.6875 14 12.042969 14 12.484375 Z M 10.609375 15.40625 C 10.609375 15.039062 10.363281 14.742188 10.0625 14.742188 C 9.761719 14.742188 9.515625 15.039062 9.515625 15.40625 C 9.515625 15.773438 9.761719 16.070312 10.0625 16.070312 C 10.363281 16.070312 10.609375 15.773438 10.609375 15.40625 Z M 12.359375 15.40625 C 12.359375 15.039062 12.113281 14.742188 11.8125 14.742188 C 11.511719 14.742188 11.265625 15.039062 11.265625 15.40625 C 11.265625 15.773438 11.511719 16.070312 11.8125 16.070312 C 12.113281 16.070312 12.359375 15.773438 12.359375 15.40625 Z M 12.359375 15.40625 ",fileManager:"M 0 5.625 L 20.996094 5.625 L 21 15.75 C 21 16.371094 20.410156 16.875 19.6875 16.875 L 1.3125 16.875 C 0.585938 16.875 0 16.371094 0 15.75 Z M 0 5.625 M 21 4.5 L 0 4.5 L 0 2.25 C 0 1.628906 0.585938 1.125 1.3125 1.125 L 6.921875 1.125 C 7.480469 1.125 8.015625 1.316406 8.40625 1.652344 L 9.800781 2.847656 C 10.195312 3.183594 10.730469 3.375 11.289062 3.375 L 19.6875 3.375 C 20.414062 3.375 21 3.878906 21 4.5 Z M 21 4.5",markdown:"M5.55006 17.75V7.35L8.96006 16.89H10.7101L14.2301 7.37V14.0729C14.3951 14.1551 14.5499 14.265 14.6875 14.4026L14.7001 14.4151V11.64C14.7001 10.8583 15.2127 10.1963 15.9201 9.97171V5H13.6801L10.0401 14.86L6.51006 5H4.00006V17.75H5.55006ZM17.2001 11.64C17.2001 11.2258 16.8643 10.89 16.4501 10.89C16.0359 10.89 15.7001 11.2258 15.7001 11.64V16.8294L13.9804 15.1097C13.6875 14.8168 13.2126 14.8168 12.9197 15.1097C12.6269 15.4026 12.6269 15.8775 12.9197 16.1703L15.9197 19.1703C16.2126 19.4632 16.6875 19.4632 16.9804 19.1703L19.9804 16.1703C20.2733 15.8775 20.2733 15.4026 19.9804 15.1097C19.6875 14.8168 19.2126 14.8168 18.9197 15.1097L17.2001 16.8294V11.64Z",fontAwesome:"M18.99018,13.98212V7.52679c-.08038-1.21875-1.33929-.683-1.33929-.683-2.933,1.39282-4.36274.61938-5.85938.15625a6.23272,6.23272,0,0,0-2.79376-.20062l-.00946.004A1.98777,1.98777,0,0,0,7.62189,5.106a.984.984,0,0,0-.17517-.05432c-.02447-.0055-.04882-.01032-.0736-.0149A.9565.9565,0,0,0,7.1908,5H6.82539a.9565.9565,0,0,0-.18232.0368c-.02472.00458-.04907.0094-.07348.01484a.985.985,0,0,0-.17523.05438,1.98585,1.98585,0,0,0-.573,3.49585v9.394A1.004,1.004,0,0,0,6.82539,19H7.1908a1.00406,1.00406,0,0,0,1.00409-1.00409V15.52234c3.64221-1.09827,5.19709.64282,7.09888.57587a5.57291,5.57291,0,0,0,3.25446-1.05805A1.2458,1.2458,0,0,0,18.99018,13.98212Z",fontFamily:"M16,19h2L13,5H11L6,19H8l1.43-4h5.14Zm-5.86-6L12,7.8,13.86,13Z",fontSize:"M20.75,19h1.5l-3-10h-1.5l-3,10h1.5L17,16.5h3Zm-3.3-4,1.05-3.5L19.55,15Zm-5.7,4h2l-5-14h-2l-5,14h2l1.43-4h5.14ZM5.89,13,7.75,7.8,9.61,13Z",fullscreen:"M7,14H5v5h5V17H7ZM5,10H7V7h3V5H5Zm12,7H14v2h5V14H17ZM14,5V7h3v3h2V5Z",help:"M11,17h2v2h-2V17z M12,5C9.8,5,8,6.8,8,9h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.7-3,5v1h2v-1c0-2.2,3-2.5,3-5  C16,6.8,14.2,5,12,5z",horizontalLine:"M5,12h14 M19,11H5v2h14V11z",imageAltText:"M19,7h-6v12h-2V7H5V5h6h2h6V7z",imageCaption:"M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z M22,22H2v2h20V22z",imageClass:"M9.5,13.4l-2.9-2.9h3.8L12.2,7l1.4,3.5h3.8l-3,2.9l0.9,3.6L12,15.1L8.8,17L9.5,13.4z M22,6v12c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,6H4v12h16V8.8V6z",imageDisplay:"M3,5h18v2H3V5z M13,9h8v2h-8V9z M13,13h8v2h-8V13z M3,17h18v2H3V17z M3,9h8v6H3V9z",imageManager:"M20,6h-7l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18H4V6h6.2l2,2H20V18z   M18,16l-3.8-5H14l-2.9,3.8L9,12.1L6,16H18z M10,9.5C10,8.7,9.3,8,8.5,8S7,8.7,7,9.5S7.7,11,8.5,11S10,10.3,10,9.5z",imageSize:"M16.9,4c-0.3,0-0.5,0.2-0.8,0.3L3.3,13c-0.9,0.6-1.1,1.9-0.5,2.8l2.2,3.3c0.4,0.7,1.2,1,2,0.8c0.3,0,0.5-0.2,0.8-0.3  L20.7,11c0.9-0.6,1.1-1.9,0.5-2.8l-2.2-3.3C18.5,4.2,17.7,3.9,16.9,4L16.9,4z M16.9,9.9L18.1,9l-2-2.9L17,5.6c0.1,0,0.1-0.1,0.2-0.1  c0.2,0,0.4,0,0.5,0.2L19.9,9c0.2,0.2,0.1,0.5-0.1,0.7L7,18.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.4,0-0.5-0.2L4.1,15  c-0.2-0.2-0.1-0.5,0.1-0.7L5,13.7l2,2.9l1.2-0.8l-2-2.9L7.5,12l1.1,1.7l1.2-0.8l-1.1-1.7l1.2-0.8l2,2.9l1.2-0.8l-2-2.9l1.2-0.8  l1.1,1.7l1.2-0.8l-1.1-1.7L14.9,7L16.9,9.9z",indent:"M3,9v6l3-3L3,9z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z",inlineClass:"M9.9,13.313A1.2,1.2,0,0,1,9.968,13H6.277l1.86-5.2,1.841,5.148A1.291,1.291,0,0,1,11.212,12h.426l-2.5-7h-2l-5,14h2l1.43-4H9.9Zm2.651,6.727a2.884,2.884,0,0,1-.655-2.018v-2.71A1.309,1.309,0,0,1,13.208,14h3.113a3.039,3.039,0,0,1,2,1.092s1.728,1.818,2.964,2.928a1.383,1.383,0,0,1,.318,1.931,1.44,1.44,0,0,1-.19.215l-3.347,3.31a1.309,1.309,0,0,1-1.832.258h0a1.282,1.282,0,0,1-.258-.257l-1.71-1.728Zm2.48-3.96a.773.773,0,1,0,.008,0Z",inlineStyle:"M11.88,15h.7l.7-1.7-3-8.3h-2l-5,14h2l1.4-4Zm-4.4-2,1.9-5.2,1.9,5.2ZM15.4,21.545l3.246,1.949-.909-3.637L20.72,17H16.954l-1.429-3.506L13.837,17H10.071l2.857,2.857-.779,3.637Z",insert:"M13.889,11.611c-0.17,0.17-0.443,0.17-0.612,0l-3.189-3.187l-3.363,3.36c-0.171,0.171-0.441,0.171-0.612,0c-0.172-0.169-0.172-0.443,0-0.611l3.667-3.669c0.17-0.17,0.445-0.172,0.614,0l3.496,3.493C14.058,11.167,14.061,11.443,13.889,11.611 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.692-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.383,10c0-4.07-3.312-7.382-7.383-7.382S2.618,5.93,2.618,10S5.93,17.381,10,17.381S17.383,14.07,17.383,10",insertEmbed:"M20.73889,15.45929a3.4768,3.4768,0,0,0-5.45965-.28662L9.5661,12.50861a3.49811,3.49811,0,0,0-.00873-1.01331l5.72174-2.66809a3.55783,3.55783,0,1,0-.84527-1.81262L8.70966,9.6839a3.50851,3.50851,0,1,0,.0111,4.63727l5.7132,2.66412a3.49763,3.49763,0,1,0,6.30493-1.526ZM18.00745,5.01056A1.49993,1.49993,0,1,1,16.39551,6.3894,1.49994,1.49994,0,0,1,18.00745,5.01056ZM5.99237,13.49536a1.49989,1.49989,0,1,1,1.61194-1.37878A1.49982,1.49982,0,0,1,5.99237,13.49536Zm11.78211,5.494a1.49993,1.49993,0,1,1,1.61193-1.37885A1.49987,1.49987,0,0,1,17.77448,18.98932Z",insertFile:"M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z",insertImage:"M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z",insertLink:"M11,17H7A5,5,0,0,1,7,7h4V9H7a3,3,0,0,0,0,6h4ZM17,7H13V9h4a3,3,0,0,1,0,6H13v2h4A5,5,0,0,0,17,7Zm-1,4H8v2h8Z",insertMore:"M16.5,13h-6v6h-2V13h-6V11h6V5h2v6h6Zm5,4.5A1.5,1.5,0,1,1,20,16,1.5,1.5,0,0,1,21.5,17.5Zm0-4A1.5,1.5,0,1,1,20,12,1.5,1.5,0,0,1,21.5,13.5Zm0-4A1.5,1.5,0,1,1,20,8,1.5,1.5,0,0,1,21.5,9.5Z",insertTable:"M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M9.5,13.5v-3  h5v3H9.5z M14.5,15v2.5h-5V15H14.5z M9.5,9V6.5h5V9H9.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M3.5,17  v-2H8v2.5H4C3.7,17.5,3.5,17.3,3.5,17z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M16,9V6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16z",insertVideo:"M15,8v8H5V8H15m2,2.5V7a1,1,0,0,0-1-1H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l2.29,2.29A1,1,0,0,0,21,15.08V8.91a1,1,0,0,0-1.71-.71Z",upload:"M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z",uploadFiles:"M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z",italic:"M11.76,9h2l-2.2,10h-2Zm1.68-4a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",search:"M15.5 14h-0.79l-0.28 -0.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09 -0.59 4.23 -1.57l0.27 0.28v0.79l5 4.99L20.49 19l-4.99 -5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",lineHeight:"M6.25,7h2.5L5.25,3.5,1.75,7h2.5V17H1.75l3.5,3.5L8.75,17H6.25Zm4-2V7h12V5Zm0,14h12V17h-12Zm0-6h12V11h-12Z",linkStyles:"M19,17.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L11.3,15h3.8l1.7-3.5l1.4,3.5H22L19,17.9z M20,12c0,0.3-0.1,0.7-0.2,1h2.1  c0.1-0.3,0.1-0.6,0.1-1c0-2.8-2.2-5-5-5h-4v2h4C18.7,9,20,10.3,20,12z M14.8,11H8v2h3.3h2.5L14.8,11z M9.9,16.4L8.5,15H7  c-1.7,0-3-1.3-3-3s1.3-3,3-3h4V7H7c-2.8,0-5,2.2-5,5s2.2,5,5,5h3.5L9.9,16.4z",mention:"M12.4,5c-4.1,0-7.5,3.4-7.5,7.5S8.3,20,12.4,20h3.8v-1.5h-3.8c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6v1.1  c0,0.6-0.5,1.2-1.1,1.2s-1.1-0.6-1.1-1.2v-1.1c0-2.1-1.7-3.8-3.8-3.8s-3.7,1.7-3.7,3.8s1.7,3.8,3.8,3.8c1,0,2-0.4,2.7-1.1  c0.5,0.7,1.3,1.1,2.2,1.1c1.5,0,2.6-1.2,2.6-2.7v-1.1C19.9,8.4,16.6,5,12.4,5z M12.4,14.7c-1.2,0-2.3-1-2.3-2.2s1-2.3,2.3-2.3  s2.3,1,2.3,2.3S13.6,14.7,12.4,14.7z",minimize:"M5,12h14 M19,11H5v2h14V11z",more:"M13.5,17c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,16.2,13.5,17z M13.5,12c0,0.8-0.7,1.5-1.5,1.5 s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,11.2,13.5,12z M13.5,7c0,0.8-0.7,1.5-1.5,1.5S10.5,7.8,10.5,7s0.7-1.5,1.5-1.5 S13.5,6.2,13.5,7z",openLink:"M17,17H7V7h3V5H7C6,5,5,6,5,7v10c0,1,1,2,2,2h10c1,0,2-1,2-2v-3h-2V17z M14,5v2h1.6l-5.8,5.8l1.4,1.4L17,8.4V10h2V5H14z",orderedList:"M2.5,16h2v.5h-1v1h1V18h-2v1h3V15h-3Zm1-7h1V5h-2V6h1Zm-1,2H4.3L2.5,13.1V14h3V13H3.7l1.8-2.1V10h-3Zm5-5V8h14V6Zm0,12h14V16H7.5Zm0-5h14V11H7.5Z",outdent:"M3,12l3,3V9L3,12z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z",pageBreaker:"M3,9v6l3-3L3,9z M21,9H8V4h2v3h9V4h2V9z M21,20h-2v-3h-9v3H8v-5h13V20z M11,13H8v-2h3V13z M16,13h-3v-2h3V13z M21,13h-3v-2  h3V13z",paragraphFormat:"M10.15,5A4.11,4.11,0,0,0,6.08,8.18,4,4,0,0,0,10,13v6h2V7h2V19h2V7h2V5ZM8,9a2,2,0,0,1,2-2v4A2,2,0,0,1,8,9Z",paragraphMore:"M7.682,5a4.11,4.11,0,0,0-4.07,3.18,4,4,0,0,0,3.11,4.725h0l.027.005a3.766,3.766,0,0,0,.82.09v6h2V7h2V19h2V7h2V5ZM5.532,9a2,2,0,0,1,2-2v4A2,2,0,0,1,5.532,9Zm14.94,8.491a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,17.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,13.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,9.491Z",paragraphStyle:"M4,9c0-1.1,0.9-2,2-2v4C4.9,11,4,10.1,4,9z M16.7,20.5l3.2,1.9L19,18.8l3-2.9h-3.7l-1.4-3.5L15.3,16h-3.8l2.9,2.9l-0.9,3.6  L16.7,20.5z M10,17.4V19h1.6L10,17.4z M6.1,5c-1.9,0-3.6,1.3-4,3.2c-0.5,2.1,0.8,4.2,2.9,4.7c0,0,0,0,0,0h0.2C5.5,13,5.8,13,6,13v6  h2V7h2v7h2V7h2V5H6.1z",pdfExport:"M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z M16.3,13.5  c-0.2-0.6-1.1-0.8-2.6-0.8c-0.1,0-0.1,0-0.2,0c-0.3-0.3-0.8-0.9-1-1.2c-0.2-0.2-0.3-0.3-0.4-0.6c0.2-0.7,0.2-1,0.3-1.5  c0.1-0.9,0-1.6-0.2-1.8c-0.4-0.2-0.7-0.2-0.9-0.2c-0.1,0-0.3,0.2-0.7,0.7c-0.2,0.7-0.1,1.8,0.6,2.8c-0.2,0.8-0.7,1.6-1,2.4  c-0.8,0.2-1.5,0.7-1.9,1.1c-0.7,0.7-0.9,1.1-0.7,1.6c0,0.3,0.2,0.6,0.7,0.6c0.3-0.1,0.3-0.2,0.7-0.3c0.6-0.3,1.2-1.7,1.7-2.4  c0.8-0.2,1.7-0.3,2-0.3c0.1,0,0.3,0,0.6,0c0.8,0.8,1.2,1.1,1.8,1.2c0.1,0,0.2,0,0.3,0c0.3,0,0.8-0.1,1-0.6  C16.4,14.1,16.4,13.9,16.3,13.5z M8.3,15.7c-0.1,0.1-0.2,0.1-0.2,0.1c0-0.1,0-0.3,0.6-0.8c0.2-0.2,0.6-0.3,0.9-0.7  C9,15,8.6,15.5,8.3,15.7z M11.3,9c0-0.1,0.1-0.2,0.1-0.2S11.6,9,11.5,10c0,0.1,0,0.3-0.1,0.7C11.3,10.1,11,9.5,11.3,9z M10.9,13.1  c0.2-0.6,0.6-1,0.7-1.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.3,0.7,0.7,0.9C12.2,12.8,11.6,13,10.9,13.1z M15.2,14.1  c-0.1,0-0.1,0-0.2,0c-0.2,0-0.7-0.2-1-0.7c1.1,0,1.6,0.2,1.6,0.6C15.5,14.1,15.4,14.1,15.2,14.1z",print:"M16.1,17c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1s-0.4,1-1,1C16.5,18,16.1,17.6,16.1,17z M22,15v4c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h1V5c0-1.1,0.9-2,2-2h7.4L19,7.6V13h1C21.1,13,22,13.9,22,15z M7,13h10V9h-4V5H7V13z M20,15H4  v4h16V15z",redo:"M13.6,9.4c1.7,0.3,3.2,0.9,4.6,2L21,8.5v7h-7l2.7-2.7C13,10.1,7.9,11,5.3,14.7c-0.2,0.3-0.4,0.5-0.5,0.8L3,14.6  C5.1,10.8,9.3,8.7,13.6,9.4z",removeTable:"M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z",insertAll:"M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 ",remove:"M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z",replaceImage:"M16,5v3H4v2h12v3l4-4L16,5z M8,19v-3h12v-2H8v-3l-4,4L8,19z",row:"M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M16,6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16V6.5z M9.5,6.5h5V9h-5V6.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.5  v-2H8V17.5z M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z",selectAll:"M5,7h2V5C5.9,5,5,5.9,5,7z M5,11h2V9H5V11z M9,19h2v-2H9V19z M5,11h2V9H5V11z M15,5h-2v2h2V5z M17,5v2h2C19,5.9,18.1,5,17,5  z M7,19v-2H5C5,18.1,5.9,19,7,19z M5,15h2v-2H5V15z M11,5H9v2h2V5z M13,19h2v-2h-2V19z M17,11h2V9h-2V11z M17,19c1.1,0,2-0.9,2-2h-2  V19z M17,11h2V9h-2V11z M17,15h2v-2h-2V15z M13,19h2v-2h-2V19z M13,7h2V5h-2V7z M9,15h6V9H9V15z M11,11h2v2h-2V11z",smile:"M11.991,3A9,9,0,1,0,21,12,8.99557,8.99557,0,0,0,11.991,3ZM12,19a7,7,0,1,1,7-7A6.99808,6.99808,0,0,1,12,19Zm3.105-5.2h1.503a4.94542,4.94542,0,0,1-9.216,0H8.895a3.57808,3.57808,0,0,0,6.21,0ZM7.5,9.75A1.35,1.35,0,1,1,8.85,11.1,1.35,1.35,0,0,1,7.5,9.75Zm6.3,0a1.35,1.35,0,1,1,1.35,1.35A1.35,1.35,0,0,1,13.8,9.75Z",spellcheck:"M19.1,13.6l-5.6,5.6l-2.7-2.7l-1.4,1.4l4.1,4.1l7-7L19.1,13.6z M10.8,13.7l2.7,2.7l0.8-0.8L10.5,5h-2l-5,14h2l1.4-4h2.6  L10.8,13.7z M9.5,7.8l1.9,5.2H7.6L9.5,7.8z",star:"M12.1,7.7l1,2.5l0.4,0.9h1h2.4l-2.1,2l-0.6,0.6l0.2,0.9l0.6,2.3l-2.2-1.3L12,15.2l-0.8,0.5L9,17l0.5-2.5l0.1-0.8L9,13.1  l-2-2h2.5h0.9l0.4-0.8L12.1,7.7 M12.2,4L9.5,9.6H3.4L8,14.2L6.9,20l5.1-3.1l5.3,3.1l-1.5-5.8l4.8-4.6h-6.1L12.2,4L12.2,4z",strikeThrough:"M3,12.20294H21v1.5H16.63422a3.59782,3.59782,0,0,1,.34942,1.5929,3.252,3.252,0,0,1-1.31427,2.6997A5.55082,5.55082,0,0,1,12.20251,19a6.4421,6.4421,0,0,1-2.62335-.539,4.46335,4.46335,0,0,1-1.89264-1.48816,3.668,3.668,0,0,1-.67016-2.15546V14.704h.28723v-.0011h.34149v.0011H9.02v.11334a2.18275,2.18275,0,0,0,.85413,1.83069,3.69,3.69,0,0,0,2.32836.67926,3.38778,3.38778,0,0,0,2.07666-.5462,1.73346,1.73346,0,0,0,.7013-1.46655,1.69749,1.69749,0,0,0-.647-1.43439,3.00525,3.00525,0,0,0-.27491-.17725H3ZM16.34473,7.05981A4.18163,4.18163,0,0,0,14.6236,5.5462,5.627,5.627,0,0,0,12.11072,5,5.16083,5.16083,0,0,0,8.74719,6.06213,3.36315,3.36315,0,0,0,7.44006,8.76855a3.22923,3.22923,0,0,0,.3216,1.42786h2.59668c-.08338-.05365-.18537-.10577-.25269-.16064a1.60652,1.60652,0,0,1-.65283-1.30036,1.79843,1.79843,0,0,1,.68842-1.5108,3.12971,3.12971,0,0,1,1.96948-.55243,3.04779,3.04779,0,0,1,2.106.6687,2.35066,2.35066,0,0,1,.736,1.83258v.11341h2.00317V9.17346A3.90013,3.90013,0,0,0,16.34473,7.05981Z",subscript:"M10.4,12l3.6,3.6L12.6,17L9,13.4L5.4,17L4,15.6L7.6,12L4,8.4L5.4,7L9,10.6L12.6,7L14,8.4L10.4,12z M18.31234,19.674  l1.06812-1.1465c0.196-0.20141,0.37093-0.40739,0.5368-0.6088c0.15975-0.19418,0.30419-0.40046,0.432-0.617  c0.11969-0.20017,0.21776-0.41249,0.29255-0.6334c0.07103-0.21492,0.10703-0.43986,0.10662-0.66621  c0.00297-0.28137-0.04904-0.56062-0.1531-0.82206c-0.09855-0.24575-0.25264-0.46534-0.45022-0.6416  c-0.20984-0.18355-0.45523-0.32191-0.72089-0.40646c-0.63808-0.19005-1.3198-0.17443-1.94851,0.04465  c-0.28703,0.10845-0.54746,0.2772-0.76372,0.49487c-0.20881,0.20858-0.37069,0.45932-0.47483,0.73548  c-0.10002,0.26648-0.15276,0.54838-0.15585,0.833l-0.00364,0.237H17.617l0.00638-0.22692  c0.00158-0.12667,0.01966-0.25258,0.05377-0.37458c0.03337-0.10708,0.08655-0.20693,0.15679-0.29437  c0.07105-0.08037,0.15959-0.14335,0.25882-0.1841c0.22459-0.08899,0.47371-0.09417,0.7018-0.01458  c0.0822,0.03608,0.15559,0.08957,0.21509,0.15679c0.06076,0.07174,0.10745,0.15429,0.13761,0.24333  c0.03567,0.10824,0.05412,0.22141,0.05469,0.33538c-0.00111,0.08959-0.0118,0.17881-0.0319,0.26612  c-0.02913,0.10428-0.07076,0.20465-0.124,0.29893c-0.07733,0.13621-0.1654,0.26603-0.26338,0.38823  c-0.13438,0.17465-0.27767,0.34226-0.42929,0.50217l-2.15634,2.35315V21H21v-1.326H18.31234z",superscript:"M10.4,12,14,15.6,12.6,17,9,13.4,5.4,17,4,15.6,7.6,12,4,8.4,5.4,7,9,10.6,12.6,7,14,8.4Zm8.91234-3.326,1.06812-1.1465c.196-.20141.37093-.40739.5368-.6088a4.85745,4.85745,0,0,0,.432-.617,3.29,3.29,0,0,0,.29255-.6334,2.11079,2.11079,0,0,0,.10662-.66621,2.16127,2.16127,0,0,0-.1531-.82206,1.7154,1.7154,0,0,0-.45022-.6416,2.03,2.03,0,0,0-.72089-.40646,3.17085,3.17085,0,0,0-1.94851.04465,2.14555,2.14555,0,0,0-.76372.49487,2.07379,2.07379,0,0,0-.47483.73548,2.446,2.446,0,0,0-.15585.833l-.00364.237H18.617L18.62338,5.25a1.45865,1.45865,0,0,1,.05377-.37458.89552.89552,0,0,1,.15679-.29437.70083.70083,0,0,1,.25882-.1841,1.00569,1.00569,0,0,1,.7018-.01458.62014.62014,0,0,1,.21509.15679.74752.74752,0,0,1,.13761.24333,1.08893,1.08893,0,0,1,.05469.33538,1.25556,1.25556,0,0,1-.0319.26612,1.34227,1.34227,0,0,1-.124.29893,2.94367,2.94367,0,0,1-.26338.38823,6.41629,6.41629,0,0,1-.42929.50217L17.19709,8.92642V10H22V8.674Z",symbols:"M15.77493,16.98885a8.21343,8.21343,0,0,0,1.96753-2.57651,7.34824,7.34824,0,0,0,.6034-3.07618A6.09092,6.09092,0,0,0,11.99515,5a6.13347,6.13347,0,0,0-4.585,1.79187,6.417,6.417,0,0,0-1.756,4.69207,6.93955,6.93955,0,0,0,.622,2.97415,8.06587,8.06587,0,0,0,1.949,2.53076H5.41452V19h5.54114v-.04331h-.00147V16.84107a5.82825,5.82825,0,0,1-2.2052-2.2352A6.40513,6.40513,0,0,1,7.97672,11.447,4.68548,4.68548,0,0,1,9.07785,8.19191a3.73232,3.73232,0,0,1,2.9173-1.22462,3.76839,3.76839,0,0,1,2.91241,1.21489,4.482,4.482,0,0,1,1.11572,3.154,6.71141,6.71141,0,0,1-.75384,3.24732,5.83562,5.83562,0,0,1-2.22357,2.25759v2.11562H13.0444V19h5.54108V16.98885Z",tags:"M8.9749 7.47489a1.5 1.5 0 1 1 -1.5 1.5A1.5 1.5 0 0 1 8.9749 7.47489Zm3.78866 -3.12713L16.5362 8.12041l0.33565 0.33564 2.77038 2.77038a2.01988 2.01988 0 0 1 0.59 1.42 1.95518 1.95518 0 0 1 -0.5854 1.40455l0.00044 0.00043 -5.59583 5.59583 -0.00043 -0.00044a1.95518 1.95518 0 0 1 -1.40455 0.5854 1.98762 1.98762 0 0 1 -1.41 -0.58L8.45605 16.87185l-0.33564 -0.33565L4.35777 12.77357a1.99576 1.99576 0 0 1 -0.59 -1.42V9.36358l0 -3.59582a2.00579 2.00579 0 0 1 2 -2l3.59582 0h1.98995A1.98762 1.98762 0 0 1 12.76356 4.34776ZM15.46186 9.866l-0.33564 -0.33564L11.36359 5.76776H5.76776v5.59583L9.866 15.46186l2.7794 2.7794 5.5878 -5.60385 -0.001 -0.001Z",tableHeader:"M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  l0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M14.5,17.5h-5V15h5V17.5z M14.5,13.5h-5v-3h5V13.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5l0,0  H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9h-4.4H16h-1.5h-5H8H7.9H3.5V7c0-0.3,0.2-0.5,0.4-0.5l0,0h4l0,0h8.2l0,0H20  c0.3,0,0.5,0.2,0.5,0.4l0,0V9z",tableFooter:"M20,19H4a2.006,2.006,0,0,1-2-2V7A2.006,2.006,0,0,1,4,5H20a2.006,2.006,0,0,1,2,2V17A2.006,2.006,0,0,1,20,19ZM8,6.5H4a.458.458,0,0,0-.5.4h0V9H8Zm0,4H3.5v3H8Zm6.5-4h-5V9h5Zm0,4h-5v3h5Zm6-3.5a.458.458,0,0,0-.4-.5H16V9h4.5Zm0,3.5H16v3h4.5Zm0,4.5H3.5v2a.458.458,0,0,0,.4.5H20a.458.458,0,0,0,.5-.4h0Z",tableStyle:"M20.0171,19.89752l.9,3.6-3.2-1.9-3.3,1.9.8-3.6-2.9-2.9h3.8l1.7-3.5,1.4,3.5h3.8ZM20,5H4A2.00591,2.00591,0,0,0,2,7V17a2.00591,2.00591,0,0,0,2,2h7.49115l-.58826-.58826L9.99115,17.5H9.5V14.9975h5.36511L16,12.66089V10.5h4.5v3h-.52783l.599,1.4975H22V7A2.00591,2.00591,0,0,0,20,5ZM3.5,7A.4724.4724,0,0,1,4,6.5H8V9H3.5Zm0,3.5H8v3H3.5Zm.5,7a.4724.4724,0,0,1-.5-.5V15H8v2.5Zm10.5-4h-5v-3h5Zm0-4.5h-5V6.5h5Zm6,0H16V6.5h4a.4724.4724,0,0,1,.5.5Z",textColor:"M15.2,13.494s-3.6,3.9-3.6,6.3a3.65,3.65,0,0,0,7.3.1v-.1C18.9,17.394,15.2,13.494,15.2,13.494Zm-1.47-1.357.669-.724L12.1,5h-2l-5,14h2l1.43-4h2.943A24.426,24.426,0,0,1,13.726,12.137ZM11.1,7.8l1.86,5.2H9.244Z",textMore:"M13.55,19h2l-5-14h-2l-5,14h2l1.4-4h5.1Zm-5.9-6,1.9-5.2,1.9,5.2Zm12.8,4.5a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,17.5Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,13.5Zm0-4A1.5,1.5,0,1,1,18.95,8,1.5,1.5,0,0,1,20.45,9.5Z",underline:"M19,20v2H5V20Zm-3-6.785a4,4,0,0,1-5.74,3.4A3.75,3.75,0,0,1,8,13.085V5.005H6v8.21a6,6,0,0,0,8,5.44,5.851,5.851,0,0,0,4-5.65v-8H16ZM16,5v0h2V5ZM8,5H6v0H8Z",undo:"M10.4,9.4c-1.7,0.3-3.2,0.9-4.6,2L3,8.5v7h7l-2.7-2.7c3.7-2.6,8.8-1.8,11.5,1.9c0.2,0.3,0.4,0.5,0.5,0.8l1.8-0.9  C18.9,10.8,14.7,8.7,10.4,9.4z",unlink:"M14.4,11l1.6,1.6V11H14.4z M17,7h-4v1.9h4c1.7,0,3.1,1.4,3.1,3.1c0,1.3-0.8,2.4-1.9,2.8l1.4,1.4C21,15.4,22,13.8,22,12  C22,9.2,19.8,7,17,7z M2,4.3l3.1,3.1C3.3,8.1,2,9.9,2,12c0,2.8,2.2,5,5,5h4v-1.9H7c-1.7,0-3.1-1.4-3.1-3.1c0-1.6,1.2-2.9,2.8-3.1  L8.7,11H8v2h2.7l2.3,2.3V17h1.7l4,4l1.4-1.4L3.4,2.9L2,4.3z",unorderedList:"M4,10.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,10.5,4,10.5z M4,5.5C3.2,5.5,2.5,6.2,2.5,7  S3.2,8.5,4,8.5S5.5,7.8,5.5,7S4.8,5.5,4,5.5z M4,15.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,15.5,4,15.5z   M7.5,6v2h14V6H7.5z M7.5,18h14v-2h-14V18z M7.5,13h14v-2h-14V13z",verticalAlignBottom:"M16,13h-3V3h-2v10H8l4,4L16,13z M3,19v2h18v-2H3z",verticalAlignMiddle:"M3,11v2h18v-2H3z M8,18h3v3h2v-3h3l-4-4L8,18z M16,6h-3V3h-2v3H8l4,4L16,6z",verticalAlignTop:"M8,11h3v10h2V11h3l-4-4L8,11z M21,5V3H3v2H21z",filestackIconAdd:"M21 16.75 16.985 21v-4.25H21ZM7.154 12.5c2.294 0 4.154 1.902 4.154 4.25S9.448 21 7.154 21C4.86 21 3 19.097 3 16.75s1.86-4.25 4.154-4.25Zm8.862 6.8V21H10.24a5.283 5.283 0 0 0 1.441-1.7h4.334ZM7.46 14.093h-.614a.215.215 0 0 0-.212.218v1.907H4.77a.215.215 0 0 0-.212.218v.628c0 .12.094.217.212.217h1.865v1.908c0 .12.095.217.212.217h.614a.214.214 0 0 0 .212-.217V17.28h1.865a.214.214 0 0 0 .212-.217v-.628a.215.215 0 0 0-.212-.218H7.673v-1.907a.215.215 0 0 0-.212-.218Zm5.647-.035v1.558h-.886a5.324 5.324 0 0 0-.615-1.558h1.501ZM21 4v11.616h-1.522V5.559H8.538v6.094a5.018 5.018 0 0 0-1.384-.216V4H21Zm-5.4 7.366v1.559h-4.015v-1.559h4.016Zm.97-2.691v1.559h-4.985v-1.56h4.985Z",trackChanges:"M17.2 20H12.4599L13.9938 19.2076L14.0305 19.1886L14.0616 19.1612C14.1036 19.1242 14.1373 19.0786 14.1603 19.0275C14.1806 18.9825 14.1923 18.9342 14.1948 18.885H14.2H14.3384L14.4364 18.7874L14.7049 18.52H15.45C15.5747 18.52 15.6942 18.4705 15.7823 18.3823C15.8705 18.2942 15.92 18.1746 15.92 18.05C15.92 17.9253 15.8705 17.8058 15.7823 17.7176C15.7351 17.6704 15.6789 17.6343 15.6177 17.6109L17.33 15.9056V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H11.2508C11.2396 19.9629 11.2337 19.9242 11.2337 19.885C11.2337 19.8133 11.2533 19.7431 11.29 19.6819L11.2739 19.6734L11.8838 18.52H5C4.87535 18.52 4.7558 18.4705 4.66766 18.3823C4.57952 18.2942 4.53 18.1746 4.53 18.05C4.53 17.9253 4.57952 17.8058 4.66766 17.7176C4.7558 17.6295 4.87535 17.58 5 17.58H12.3809L12.3925 17.5582L12.4187 17.5284C12.4558 17.4864 12.5014 17.4527 12.5525 17.4297C12.5836 17.4156 12.6163 17.4057 12.6498 17.4001C12.6522 17.3065 12.6877 17.2166 12.7503 17.1467L13 17.37C12.9902 17.381 12.9847 17.3952 12.9847 17.41C12.9847 17.4247 12.9902 17.439 13 17.45L14.13 18.55H14.2L19.09 13.68V13.6L17.99 12.5C17.979 12.4902 17.9647 12.4847 17.95 12.4847C17.9352 12.4847 17.921 12.4902 17.91 12.5L13 17.37L12.7641 17.1322L15.1759 14.74H5C4.87535 14.74 4.7558 14.6905 4.66766 14.6023C4.57952 14.5142 4.53 14.3946 4.53 14.27C4.53 14.1453 4.57952 14.0258 4.66766 13.9376C4.7558 13.8495 4.87535 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9376C15.8169 13.9722 15.8454 14.0115 15.8675 14.0541L17.33 12.6034V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM11.7889 20H11.8785C11.8902 19.9746 11.898 19.9475 11.9015 19.9197L11.8661 19.9866L11.8117 19.9578L13.84 18.91C13.8464 18.9044 13.8515 18.8974 13.855 18.8897C13.8585 18.8819 13.8603 18.8735 13.8603 18.865C13.8603 18.8565 13.8585 18.8481 13.855 18.8403C13.8515 18.8325 13.8464 18.8256 13.84 18.82L12.76 17.75C12.7544 17.7436 12.7474 17.7385 12.7397 17.735C12.7319 17.7315 12.7235 17.7297 12.715 17.7297C12.7065 17.7297 12.6981 17.7315 12.6903 17.735C12.6825 17.7385 12.6756 17.7436 12.67 17.75L11.57 19.83L11.5023 19.7942L11.58 19.85C11.5727 19.8602 11.5687 19.8724 11.5687 19.885C11.5687 19.8975 11.5727 19.9098 11.58 19.92L11.67 20H11.73L11.7642 19.9823L11.7889 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60183 10.9735 6.54621C10.9534 6.49058 10.9224 6.43948 10.8825 6.39582C10.8425 6.35216 10.7944 6.31681 10.7408 6.29179C10.6871 6.26677 10.6291 6.25257 10.57 6.25H5C4.88239 6.25773 4.77251 6.3113 4.69397 6.39918C4.61543 6.48707 4.57451 6.60226 4.58 6.72C4.57451 6.83774 4.61543 6.95293 4.69397 7.04082C4.77251 7.12871 4.88239 7.18227 5 7.19H10.6C10.714 7.1774 10.8189 7.12173 10.8933 7.03438C10.9676 6.94702 11.0058 6.83457 11 6.72ZM11.1 8.14001H5C4.87535 8.14001 4.7558 8.18953 4.66766 8.27767C4.57952 8.36582 4.53 8.48536 4.53 8.61001C4.53 8.73467 4.57952 8.85421 4.66766 8.94236C4.7558 9.0305 4.87535 9.08001 5 9.08001H11.1C11.2247 9.08001 11.3442 9.0305 11.4323 8.94236C11.5205 8.85421 11.57 8.73467 11.57 8.61001C11.57 8.48536 11.5205 8.36582 11.4323 8.27767C11.3442 8.18953 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8536C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1464C15.7098 10.0527 15.5826 10 15.45 10H5C4.86739 10 4.74021 10.0527 4.64645 10.1464C4.55268 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55268 10.7598 4.64645 10.8536C4.74021 10.9473 4.86739 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3337 11.9673 11.2202 11.9152 11.1 11.91H5C4.94089 11.9126 4.88286 11.9268 4.82924 11.9518C4.77562 11.9768 4.72746 12.0122 4.68752 12.0558C4.64758 12.0995 4.61664 12.1506 4.59648 12.2062C4.57631 12.2618 4.56731 12.3209 4.57 12.38C4.56451 12.5004 4.60649 12.6181 4.6869 12.7079C4.76731 12.7976 4.87974 12.8523 5 12.86ZM11.1 16.63H5C4.87535 16.63 4.7558 16.5805 4.66766 16.4923C4.57952 16.4042 4.53 16.2846 4.53 16.16C4.53 16.0353 4.57952 15.9158 4.66766 15.8276C4.7558 15.7395 4.87535 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4323 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4323 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.8503 11.592C18.7991 11.6175 18.7545 11.6544 18.72 11.7L18.26 12.14C18.2501 12.151 18.2447 12.1652 18.2447 12.18C18.2447 12.1947 18.2501 12.209 18.26 12.22L19.37 13.32C19.381 13.3298 19.3952 13.3353 19.41 13.3353C19.4247 13.3353 19.439 13.3298 19.45 13.32L19.86 12.91C19.9057 12.867 19.9421 12.8151 19.967 12.7575C19.9919 12.6998 20.0047 12.6377 20.0047 12.575C20.0047 12.5122 19.9919 12.4501 19.967 12.3925C19.9421 12.3349 19.9057 12.283 19.86 12.24L19.31 11.7C19.2755 11.6544 19.2309 11.6175 19.1797 11.592C19.1285 11.5666 19.0721 11.5533 19.015 11.5533C18.9578 11.5533 18.9014 11.5666 18.8503 11.592Z",showTrackChanges:"M17.2421 13.6048C17.2631 13.6136 17.2841 13.6226 17.305 13.6317V9.29505H13.2626C13.1897 9.30481 13.1159 9.30481 13.043 9.29505C12.7532 9.21632 12.4953 9.04872 12.3056 8.81577C12.1158 8.58283 12.0037 8.29625 11.985 7.99627V4H4.12976C4.09534 4 4.06234 4.01368 4.038 4.03804C4.01367 4.0624 4 4.09543 4 4.12988V19.8552C4 19.8896 4.01367 19.9227 4.038 19.947C4.06234 19.9714 4.09534 19.9851 4.12976 19.9851H13.4875C13.0501 19.8216 12.6281 19.6155 12.2277 19.3686C11.8529 19.1551 11.4911 18.9196 11.1442 18.6632C11.0697 18.6152 10.9982 18.5628 10.9302 18.5065H4.99812C4.87371 18.5065 4.75438 18.457 4.66641 18.3689C4.57843 18.2809 4.529 18.1614 4.529 18.0369C4.529 17.9124 4.57843 17.7929 4.66641 17.7049C4.75438 17.6168 4.87371 17.5673 4.99812 17.5673H10.4396C10.4472 17.4488 10.4756 17.3324 10.5235 17.2235C10.5939 17.017 10.6761 16.8149 10.7694 16.6182H4.99812C4.87371 16.6182 4.75438 16.5687 4.66641 16.4807C4.57843 16.3926 4.529 16.2732 4.529 16.1487C4.529 16.0241 4.57843 15.9047 4.66641 15.8166C4.75438 15.7286 4.87371 15.6791 4.99812 15.6791H11.0867C11.1576 15.6791 11.2268 15.6952 11.2895 15.7253C11.5204 15.361 11.7938 15.027 12.1033 14.73H4.99812C4.87371 14.73 4.75438 14.6805 4.66641 14.5924C4.57843 14.5044 4.529 14.385 4.529 14.2604C4.529 14.1359 4.57843 14.0164 4.66641 13.9284C4.75438 13.8403 4.87371 13.7909 4.99812 13.7909H13.4434C13.9833 13.525 14.5656 13.3516 15.166 13.2795L15.1923 13.2763H15.2189H15.4925C16.0923 13.2609 16.6886 13.3728 17.2421 13.6048ZM13.0829 4.64939L16.5764 8.14613C16.5975 8.16843 16.6118 8.19636 16.6174 8.22657C16.6231 8.25677 16.62 8.28798 16.6084 8.31645C16.5968 8.34492 16.5773 8.36944 16.5521 8.38707C16.527 8.40471 16.4973 8.41471 16.4666 8.41587H13.043L12.8134 8.18609V4.75929C12.8146 4.72857 12.8246 4.69884 12.8422 4.67366C12.8598 4.64849 12.8843 4.62893 12.9128 4.61733C12.9412 4.60573 12.9724 4.60259 13.0026 4.60827C13.0328 4.61396 13.0607 4.62824 13.0829 4.64939ZM10.9869 6.71746C10.9896 6.65841 10.9806 6.59941 10.9604 6.54383C10.9403 6.48825 10.9094 6.4372 10.8696 6.39358C10.8297 6.34997 10.7816 6.31465 10.7281 6.28965C10.6746 6.26466 10.6167 6.25047 10.5577 6.2479H4.99813C4.88074 6.25562 4.77106 6.30914 4.69267 6.39694C4.61428 6.48475 4.57343 6.59983 4.57891 6.71746C4.57343 6.83509 4.61428 6.95017 4.69267 7.03798C4.77106 7.12579 4.88074 7.1793 4.99813 7.18702H10.5876C10.7014 7.17444 10.8061 7.11882 10.8803 7.03154C10.9545 6.94427 10.9927 6.83192 10.9869 6.71746ZM11.0867 8.13614H4.99812C4.87371 8.13614 4.75438 8.18561 4.66641 8.27367C4.57843 8.36173 4.529 8.48116 4.529 8.6057C4.529 8.73023 4.57843 8.84967 4.66641 8.93773C4.75438 9.02579 4.87371 9.07526 4.99812 9.07526H11.0867C11.2111 9.07526 11.3304 9.02579 11.4184 8.93773C11.5064 8.84967 11.5558 8.73023 11.5558 8.6057C11.5558 8.48116 11.5064 8.36173 11.4184 8.27367C11.3304 8.18561 11.2111 8.13614 11.0867 8.13614ZM4.99812 10.9935H15.4285C15.5609 10.9935 15.6878 10.9408 15.7814 10.8472C15.875 10.7535 15.9276 10.6264 15.9276 10.4939C15.9276 10.3614 15.875 10.2344 15.7814 10.1407C15.6878 10.047 15.5609 9.9944 15.4285 9.9944H4.99812C4.86576 9.9944 4.73883 10.047 4.64523 10.1407C4.55164 10.2344 4.49906 10.3614 4.49906 10.4939C4.49906 10.6264 4.55164 10.7535 4.64523 10.8472C4.73883 10.9408 4.86576 10.9935 4.99812 10.9935ZM4.99812 12.8517H11.0867C11.2076 12.844 11.3208 12.7898 11.4027 12.7004C11.4845 12.611 11.5287 12.4934 11.5259 12.3722C11.5286 12.252 11.4841 12.1355 11.402 12.0477C11.3199 11.9599 11.2067 11.9078 11.0867 11.9026H4.99812C4.93912 11.9052 4.8812 11.9194 4.82769 11.9444C4.77417 11.9694 4.7261 12.0047 4.68623 12.0483C4.64637 12.0919 4.61549 12.143 4.59536 12.1985C4.57523 12.2541 4.56625 12.3131 4.56893 12.3722C4.56345 12.4925 4.60535 12.6101 4.68561 12.6998C4.76587 12.7894 4.87809 12.844 4.99812 12.8517ZM19.97 17.4974C19.5787 16.5636 19.0431 15.6971 18.383 14.9298C18.0152 14.5351 17.5679 14.2233 17.0706 14.0148C16.5732 13.8064 16.0373 13.7062 15.4984 13.7209H15.2189C14.4787 13.8098 13.7684 14.0666 13.1423 14.4717C12.5162 14.8769 11.9906 15.4196 11.6057 16.0587C11.3211 16.4677 11.0959 16.9151 10.937 17.3875C10.9006 17.464 10.8817 17.5476 10.8817 17.6323C10.8817 17.717 10.9006 17.8006 10.937 17.877C11.0642 18.0428 11.2196 18.1849 11.3961 18.2967C11.7346 18.5476 12.0879 18.7778 12.4541 18.986C13.4096 19.5767 14.497 19.92 15.6182 19.9851C16.4392 20.0504 17.2632 19.9005 18.0088 19.5501C18.7544 19.1998 19.3959 18.661 19.8702 17.9869C19.9311 17.923 19.9729 17.8432 19.9905 17.7566C20.0082 17.67 20.0011 17.5801 19.97 17.4974ZM15.9775 19.1758C14.3849 19.068 12.8507 18.5331 11.5358 17.6273C11.5788 17.5678 11.6255 17.5111 11.6756 17.4574C12.3061 16.569 13.1295 15.8359 14.0832 15.3126C13.8003 15.7406 13.6785 16.2566 13.7417 16.7681C13.7676 17.0339 13.8465 17.2918 13.9737 17.5265C14.1009 17.7613 14.2739 17.9681 14.4823 18.1348C14.6907 18.3016 14.9304 18.4248 15.1872 18.4972C15.4441 18.5696 15.7128 18.5897 15.9775 18.5564C16.305 18.4971 16.6137 18.3609 16.8785 18.159C17.1432 17.9572 17.3564 17.6954 17.5005 17.3951C17.6446 17.0949 17.7156 16.7647 17.7077 16.4317C17.6997 16.0987 17.613 15.7723 17.4547 15.4793C17.2614 15.3391 17.0533 15.2235 16.8351 15.1339C17.0715 15.226 17.2966 15.3485 17.5046 15.4993C18.0049 15.8976 18.4424 16.3691 18.8022 16.898L18.8927 17.0137L18.8927 17.0137C19.0823 17.2564 19.2729 17.5004 19.4709 17.7072C18.5404 18.6311 17.288 19.1576 15.9775 19.1758ZM16.3168 15.769C16.2085 15.8106 16.1171 15.8873 16.0574 15.9869C15.9977 16.0865 15.9731 16.2032 15.9875 16.3185C15.9949 16.3856 16.0156 16.4505 16.0483 16.5096C16.081 16.5686 16.1251 16.6206 16.178 16.6624C16.2309 16.7042 16.2916 16.7351 16.3566 16.7532C16.4216 16.7714 16.4895 16.7764 16.5564 16.7681H16.6063C16.5618 16.9495 16.4637 17.1132 16.3248 17.238C16.186 17.3627 16.0127 17.4427 15.8278 17.4674H15.6481C15.4335 17.4396 15.2337 17.3427 15.0789 17.1913C14.924 17.04 14.8226 16.8423 14.7897 16.6282C14.7628 16.3782 14.8311 16.1271 14.981 15.9253C15.1305 15.7238 15.3504 15.5861 15.5968 15.5395C15.3446 15.5862 15.12 15.7284 14.9697 15.9364C14.8191 16.1448 14.7547 16.4034 14.7897 16.6582C14.8226 16.8723 14.924 17.0699 15.0789 17.2213C15.2337 17.3727 15.4335 17.4696 15.6481 17.4974H15.8377C16.0209 17.4708 16.1919 17.39 16.3289 17.2654C16.4658 17.1408 16.5625 16.978 16.6063 16.7981C16.7293 16.7633 16.8359 16.686 16.9072 16.5799C16.9785 16.4737 17.0098 16.3457 16.9956 16.2186C16.9882 16.1515 16.9675 16.0865 16.9348 16.0275C16.9021 15.9685 16.858 15.9165 16.805 15.8747C16.7521 15.8329 16.6914 15.802 16.6264 15.7838C16.5615 15.7657 16.4936 15.7607 16.4266 15.769H16.3168Z",acceptAllChanges:"M9.36499 16.7348C9.38499 16.7547 9.41212 16.7659 9.44041 16.7659H10.9881C10.9028 16.6008 10.9289 16.3933 11.0663 16.2541L11.7266 15.585H10.1444C10.0549 15.5701 9.97363 15.5238 9.91498 15.4547C9.85639 15.3856 9.82422 15.298 9.82422 15.2074C9.82422 15.1169 9.85639 15.0292 9.91498 14.9601C9.97363 14.891 10.0549 14.8448 10.1444 14.8298H12.4879C12.5584 14.785 12.6407 14.7607 12.7257 14.7607C12.8106 14.7607 12.893 14.785 12.9635 14.8298H16.5295L18.3303 13.0091C18.4135 12.925 18.5271 12.8776 18.6456 12.8777C18.7642 12.8777 18.8777 12.9252 18.9609 13.0094L20 14.0621V8.25532H16.8001C16.7301 8.27288 16.6568 8.27288 16.5868 8.25532C16.3485 8.1935 16.1367 8.0565 15.9829 7.86478C15.8292 7.67306 15.7416 7.43688 15.7335 7.19149V4H9.44041C9.41293 4.0024 9.38718 4.01437 9.36767 4.03383C9.34816 4.05329 9.33615 4.07897 9.33375 4.10638V16.6596C9.33375 16.6878 9.34499 16.7148 9.36499 16.7348ZM10.0744 17.2979H11.4803L12.259 18.0957H5.06727C5.01734 18.0957 4.96838 18.1057 4.9232 18.1246C4.8788 18.1431 4.83798 18.1702 4.80335 18.2048C4.7333 18.2746 4.69398 18.3693 4.69398 18.468C4.69398 18.5668 4.7333 18.6615 4.80335 18.7313C4.87333 18.8011 4.96832 18.8404 5.06727 18.8404H12.9857L13.7947 19.6693L14.0836 19.9574H4.10733C4.09291 19.9591 4.07829 19.9576 4.06457 19.9528C4.05085 19.9481 4.03838 19.9403 4.02812 19.9301C4.01785 19.9198 4.01004 19.9074 4.00529 19.8937C4.00054 19.88 3.99896 19.8654 4.00067 19.8511V7.29787C4.00067 7.26966 4.01191 7.2426 4.03191 7.22265C4.05192 7.2027 4.07905 7.19149 4.10733 7.19149H8.70447V9.05319H5.06727C4.97294 9.05867 4.88453 9.10069 4.8208 9.17019C4.757 9.23973 4.72302 9.33135 4.72594 9.42553C4.72289 9.52082 4.75654 9.61364 4.82002 9.6849C4.88356 9.75613 4.97203 9.80038 5.06727 9.8085H8.70447V10.5638H5.06727C5.01968 10.5652 4.97274 10.5759 4.92932 10.5954C4.88583 10.6148 4.84664 10.6426 4.8139 10.6772C4.78122 10.7118 4.7557 10.7525 4.73877 10.7969C4.72184 10.8413 4.7139 10.8887 4.71527 10.9361C4.7139 10.9837 4.72184 11.031 4.73877 11.0754C4.74424 11.0897 4.75055 11.1037 4.75778 11.1171C4.76162 11.1243 4.76566 11.1313 4.76995 11.1382C4.78265 11.1585 4.79736 11.1776 4.8139 11.1951C4.84664 11.2297 4.88583 11.2575 4.92932 11.2769C4.95491 11.2884 4.98173 11.2968 5.0092 11.3021C5.02834 11.3058 5.04774 11.3079 5.06727 11.3085H8.70447V12.0638H5.06734C4.97782 12.0789 4.89651 12.1251 4.83792 12.1942C4.77926 12.2633 4.7471 12.351 4.7471 12.4415C4.7471 12.5321 4.77926 12.6197 4.83792 12.6888C4.89651 12.758 4.97782 12.8041 5.06734 12.8192H8.70447V13.5745H5.06734C4.97782 13.5895 4.89651 13.6357 4.83792 13.7048C4.81383 13.7332 4.79424 13.7647 4.77946 13.7983C4.7583 13.8465 4.7471 13.8988 4.7471 13.9522C4.7471 14.0427 4.77926 14.1303 4.83792 14.1994C4.89651 14.2686 4.97782 14.3147 5.06734 14.3298H8.70447V15.0744H5.06727C4.97776 15.0895 4.89651 15.1357 4.83785 15.2048C4.77926 15.2739 4.7471 15.3616 4.7471 15.4521C4.7471 15.5043 4.75778 15.5556 4.77809 15.6029C4.793 15.6376 4.81305 15.6701 4.83785 15.6994C4.89651 15.7685 4.97776 15.8147 5.06727 15.8298H8.70447V16.5851H5.06727C4.97776 16.6001 4.89651 16.6463 4.83785 16.7154C4.79489 16.7661 4.76618 16.8267 4.75387 16.8912C4.74938 16.9146 4.7471 16.9386 4.7471 16.9628C4.7471 17.0533 4.77926 17.1409 4.83785 17.21C4.89651 17.2792 4.97776 17.3253 5.06727 17.3404H9.95241C9.99552 17.3331 10.0367 17.3187 10.0744 17.2979ZM20 15.3204L18.5709 16.7659H19.8933C19.9216 16.7659 19.9487 16.7547 19.9687 16.7348C19.9887 16.7148 20 16.6878 20 16.6596V15.3204ZM14.7526 16.6264L13.7248 15.585H15.7825L14.7526 16.6264ZM14.9498 6.08721C14.9465 6.06854 14.9416 6.05023 14.9353 6.03244C14.9202 5.98939 14.897 5.94929 14.8665 5.91442C14.8145 5.85488 14.7444 5.81394 14.6669 5.79787H10.1337C10.0348 5.79787 9.93978 5.83709 9.8698 5.90693C9.79975 5.97676 9.76043 6.07146 9.76043 6.17022C9.76043 6.19463 9.76283 6.21879 9.76752 6.24239C9.77462 6.2782 9.78692 6.31268 9.80398 6.34479C9.82123 6.37716 9.8433 6.40709 9.8698 6.43348C9.93978 6.50332 10.0348 6.54257 10.1337 6.54257H14.6669C14.6811 6.54023 14.6951 6.53702 14.7088 6.53299C14.7206 6.52955 14.7322 6.52549 14.7436 6.52082C14.7624 6.51309 14.7806 6.50371 14.7979 6.4928C14.8378 6.46764 14.8722 6.43468 14.8991 6.39599C14.9259 6.35729 14.9447 6.31359 14.9543 6.26749C14.9554 6.26232 14.9563 6.25716 14.9571 6.25197C14.9579 6.24739 14.9586 6.24281 14.9591 6.23824C14.9612 6.22129 14.962 6.20424 14.9616 6.18723C14.961 6.16727 14.9588 6.14733 14.9549 6.12766C14.9539 6.11406 14.9523 6.10055 14.9498 6.08721ZM15.0189 7.29788H10.1445C10.0549 7.31291 9.97363 7.35911 9.91504 7.42823C9.85639 7.49738 9.82422 7.585 9.82422 7.67555C9.82422 7.76609 9.85639 7.85369 9.91504 7.92284C9.97363 7.99196 10.0549 8.03815 10.1445 8.05319H15.0189C15.0321 8.05241 15.0451 8.05095 15.058 8.04877C15.0745 8.04601 15.0906 8.04212 15.1064 8.03718C15.1669 8.01822 15.2219 7.98361 15.2654 7.93618C15.3291 7.86664 15.3632 7.77502 15.3602 7.68084C15.3606 7.67392 15.3608 7.66701 15.3608 7.66009C15.3609 7.65087 15.3606 7.64165 15.3599 7.63247C15.3592 7.62263 15.358 7.61279 15.3565 7.60302C15.3532 7.58188 15.3479 7.56104 15.3409 7.54072C15.3254 7.49575 15.301 7.45426 15.2693 7.41868C15.2492 7.39621 15.2265 7.37638 15.2017 7.35959C15.1872 7.34979 15.172 7.34102 15.1562 7.33339C15.1132 7.31265 15.0665 7.3006 15.0189 7.29788ZM10.1445 9.56381H18.496C18.5856 9.54877 18.6669 9.50258 18.7255 9.43346C18.7841 9.3643 18.8163 9.27671 18.8163 9.18617C18.8163 9.09562 18.7841 9.008 18.7255 8.93884C18.6669 8.86973 18.5856 8.82353 18.496 8.8085H10.1445C10.0549 8.82353 9.97363 8.86973 9.91504 8.93884C9.85639 9.008 9.82422 9.09562 9.82422 9.18617C9.82422 9.24412 9.83738 9.30087 9.86224 9.35236C9.87624 9.38132 9.89395 9.40859 9.91504 9.43346C9.97363 9.50258 10.0549 9.54877 10.1445 9.56381ZM10.1445 11.0638H15.0189C15.1084 11.0488 15.1897 11.0026 15.2483 10.9335C15.2854 10.8898 15.3118 10.8387 15.3263 10.7842C15.3347 10.7525 15.3391 10.7195 15.3391 10.6861C15.3391 10.5956 15.3069 10.508 15.2483 10.4389C15.1897 10.3697 15.1084 10.3235 15.0189 10.3085H10.1445C10.0549 10.3235 9.97363 10.3697 9.91504 10.4389C9.85639 10.508 9.82422 10.5956 9.82422 10.6861C9.82422 10.7424 9.83666 10.7976 9.8601 10.8478C9.87442 10.8785 9.89284 10.9073 9.91504 10.9335C9.97363 11.0026 10.0549 11.0488 10.1445 11.0638ZM18.496 12.5745H10.1444C10.0549 12.5594 9.97363 12.5132 9.91498 12.4441C9.85639 12.3749 9.82422 12.2873 9.82422 12.1968C9.82422 12.1062 9.85639 12.0186 9.91498 11.9495C9.97363 11.8803 10.0549 11.8342 10.1444 11.8191H18.496C18.5856 11.8342 18.6669 11.8803 18.7255 11.9495C18.7841 12.0186 18.8163 12.1062 18.8163 12.1968C18.8163 12.2873 18.7841 12.3749 18.7255 12.4441C18.6971 12.4776 18.6633 12.5058 18.6259 12.5276C18.5861 12.5507 18.5421 12.5667 18.496 12.5745ZM15.0189 14.0744H10.1444C10.0968 14.0731 10.0499 14.0624 10.0064 14.0429C9.96296 14.0234 9.92376 13.9956 9.89102 13.961C9.85834 13.9265 9.83282 13.8857 9.81589 13.8413C9.79897 13.7969 9.79102 13.7496 9.79239 13.7021C9.79102 13.6546 9.79897 13.6073 9.81589 13.5628C9.83282 13.5184 9.85834 13.4778 9.89102 13.4432C9.92376 13.4086 9.96296 13.3808 10.0064 13.3613C10.0499 13.3419 10.0968 13.3311 10.1444 13.3297H15.0189C15.0661 13.3311 15.1125 13.3419 15.1554 13.3615C15.1983 13.381 15.2368 13.4091 15.2686 13.4438C15.3005 13.4785 15.325 13.5193 15.3407 13.5637C15.3564 13.608 15.363 13.6551 15.3602 13.7021C15.3631 13.7963 15.3291 13.8879 15.2653 13.9574C15.2016 14.027 15.1132 14.0689 15.0189 14.0744ZM16.6188 4.52128L19.4133 7.30852C19.4293 7.32624 19.4401 7.34808 19.4443 7.37157C19.4485 7.39506 19.446 7.41925 19.4371 7.4414C19.4282 7.46356 19.4133 7.48278 19.394 7.4969C19.3747 7.51102 19.3518 7.51947 19.328 7.52128H16.5868L16.4054 7.34043V4.60639C16.4073 4.5826 16.4157 4.55979 16.4299 4.54056C16.444 4.52133 16.4633 4.50644 16.4855 4.49757C16.5077 4.48871 16.532 4.48624 16.5556 4.49043C16.5791 4.49462 16.601 4.50531 16.6188 4.52128ZM18.6454 13.3192L20 14.6915L14.7522 20L14.7416 19.9894L14.1123 19.3617L13.3976 18.6277L11.3817 16.5638L12.7257 15.2021L14.7522 17.2553L18.6454 13.3192Z",rejectAllChanges:"M9.54637 16.5847H8.96997V15.8295H12.786C12.8024 15.8265 12.8186 15.8223 12.8343 15.817C12.8535 15.8105 12.8719 15.8023 12.8897 15.7926C12.9315 15.7697 12.969 15.738 12.9997 15.6991C13.0268 15.6649 13.0478 15.6261 13.0621 15.5847H13.571V16.7656H9.79386C9.78396 16.7479 9.77269 16.731 9.76011 16.7151C9.70552 16.6459 9.62976 16.5998 9.54637 16.5847ZM13.4717 12.9573V13.3295H9.72523C9.6809 13.3309 9.63716 13.3416 9.59671 13.361C9.57578 13.3711 9.55595 13.3834 9.53745 13.3977C9.5201 13.411 9.50391 13.4262 9.48917 13.4429C9.45872 13.4775 9.43494 13.5182 9.41917 13.5626C9.41778 13.5664 9.41644 13.5703 9.41523 13.5742H8.96997V12.8189H12.786C12.8694 12.8039 12.9452 12.7577 12.9997 12.6886C13.0078 12.6784 13.0153 12.6677 13.0223 12.6568L13.029 12.6458L13.033 12.6389L13.0397 12.6266C13.0452 12.6157 13.0503 12.6046 13.055 12.5931C13.0576 12.5869 13.0599 12.5806 13.0621 12.5742H13.6872C13.6453 12.5965 13.607 12.6269 13.5746 12.6644C13.5059 12.7439 13.469 12.849 13.4717 12.9573ZM9.82598 14.0742H13.4758C13.4809 14.0932 13.4904 14.1108 13.5037 14.1251C13.5242 14.147 13.552 14.1593 13.581 14.1593H13.6008L13.571 14.1912V14.8295H9.72523C9.64183 14.8445 9.56614 14.8907 9.51149 14.9598C9.4845 14.994 9.46351 15.0328 9.4492 15.0741H8.96997V14.3295H9.54637C9.62976 14.3145 9.70552 14.2683 9.76011 14.1992C9.78947 14.162 9.81166 14.1195 9.82598 14.0742ZM18.9075 8.2552V12.5317H17.7846V12.323C17.7978 12.2827 17.8047 12.2399 17.8047 12.1965C17.8047 12.106 17.7747 12.0184 17.7201 11.9493C17.6655 11.8801 17.5897 11.834 17.5063 11.8189H9.72523C9.64183 11.834 9.56614 11.8801 9.51149 11.9493C9.48444 11.9835 9.46351 12.0222 9.4492 12.0636H8.96997V11.3083H9.54637C9.63425 11.3028 9.71662 11.2608 9.776 11.1913C9.80687 11.1551 9.83029 11.113 9.84527 11.0676L9.84654 11.0637H14.2667C14.3501 11.0486 14.4258 11.0024 14.4805 10.9333C14.5231 10.8794 14.5507 10.8142 14.5607 10.7452C14.5636 10.7258 14.565 10.706 14.565 10.686C14.565 10.6658 14.5635 10.6458 14.5606 10.626C14.5572 10.6026 14.5516 10.5796 14.5442 10.5573C14.5299 10.5144 14.5084 10.4741 14.4805 10.4387C14.4258 10.3696 14.3501 10.3234 14.2667 10.3083H9.72529C9.6832 10.3159 9.64299 10.3314 9.60653 10.3538C9.57081 10.3759 9.5386 10.4045 9.51155 10.4387C9.49639 10.4579 9.4831 10.4785 9.47182 10.5002C9.46133 10.5205 9.45259 10.5417 9.44568 10.5636H8.96997V9.80838H9.16873C9.25656 9.80286 9.33899 9.76085 9.39837 9.69131C9.45775 9.62177 9.48947 9.53022 9.48674 9.43601C9.48711 9.42951 9.48735 9.42302 9.48741 9.41653C9.48741 9.41049 9.48729 9.40445 9.48705 9.39848C9.49457 9.41055 9.50269 9.42218 9.51155 9.43334C9.56614 9.50249 9.64189 9.54866 9.72529 9.56372H17.5063C17.5897 9.54866 17.6655 9.50249 17.7201 9.43334C17.7747 9.36419 17.8047 9.2766 17.8047 9.18603C17.8047 9.09552 17.7747 9.00786 17.7201 8.93878C17.6655 8.86963 17.5897 8.82346 17.5063 8.8084H9.72529C9.64189 8.82346 9.56614 8.86963 9.51155 8.93878C9.4569 9.00786 9.42694 9.09552 9.42694 9.18603L9.427 9.19707L9.42754 9.20875C9.41972 9.19661 9.41123 9.18499 9.40201 9.17389C9.38478 9.15311 9.36537 9.1346 9.34427 9.11863C9.33735 9.11344 9.33026 9.1085 9.32298 9.10383C9.31855 9.10097 9.31406 9.09824 9.30951 9.09565L9.30424 9.09266L9.29659 9.08857C9.28792 9.08402 9.27906 9.07993 9.27009 9.07623C9.2616 9.07279 9.25298 9.06974 9.24431 9.06701C9.21974 9.05935 9.19439 9.05461 9.16873 9.05305H8.96997V4.10638C8.97221 4.07897 8.9834 4.05328 9.00157 4.03383C9.01975 4.01437 9.04374 4.0024 9.06935 4H14.9325V7.1914C14.9401 7.43679 15.0216 7.67296 15.1649 7.86468C15.3082 8.0564 15.5055 8.19338 15.7275 8.2552C15.7927 8.27277 15.861 8.27277 15.9262 8.2552H18.9075ZM13.571 17.2975V19.4251L13.5722 19.4615C13.5835 19.6376 13.6323 19.8068 13.7133 19.957H4.10061C4.08718 19.9587 4.07355 19.9571 4.06077 19.9524C4.04799 19.9477 4.03637 19.9399 4.02681 19.9296C4.01724 19.9194 4.00997 19.907 4.00554 19.8933C4.00111 19.8796 3.99964 19.865 4.00124 19.8506V7.29778C4.00124 7.26957 4.01171 7.24251 4.03034 7.22256C4.04898 7.20261 4.07426 7.1914 4.10061 7.1914H8.38368V9.05305H4.99497C4.90708 9.05857 4.82471 9.10052 4.76533 9.17006C4.70589 9.2396 4.67423 9.33121 4.67696 9.42536C4.67411 9.52067 4.70547 9.61346 4.76461 9.68475C4.8238 9.75598 4.90623 9.80026 4.99497 9.80838H8.38368V10.5636H4.99497C4.96682 10.5645 4.93898 10.5692 4.91199 10.5774C4.89647 10.5821 4.88124 10.588 4.86644 10.5952C4.8494 10.6034 4.83308 10.613 4.81762 10.6241C4.79627 10.6393 4.77655 10.657 4.7589 10.6771C4.72846 10.7116 4.70468 10.7523 4.68891 10.7967C4.67314 10.8411 4.66574 10.8885 4.66701 10.9359C4.66641 10.9597 4.66792 10.9834 4.67156 11.0067C4.6752 11.03 4.68102 11.053 4.68891 11.0752C4.70468 11.1196 4.72846 11.1603 4.7589 11.1949C4.7731 11.211 4.78862 11.2256 4.80524 11.2386C4.81452 11.2459 4.82417 11.2527 4.83417 11.259C4.84461 11.2655 4.85534 11.2714 4.86644 11.2767C4.9069 11.2962 4.95063 11.3069 4.99497 11.3083H8.38368V12.0636H4.99503C4.91163 12.0787 4.83587 12.1249 4.78128 12.194C4.7526 12.2303 4.7307 12.2717 4.71639 12.3159C4.70347 12.3559 4.69667 12.3983 4.69667 12.4413C4.69667 12.5318 4.72664 12.6194 4.78128 12.6886C4.809 12.7237 4.84218 12.7529 4.87906 12.7751C4.89416 12.7842 4.90993 12.7921 4.92619 12.7988C4.94833 12.8079 4.97137 12.8147 4.99503 12.8189H8.38368V13.5742H4.99503C4.95275 13.5819 4.91242 13.5975 4.87584 13.62C4.8403 13.642 4.80822 13.6705 4.78128 13.7046C4.72664 13.7737 4.69667 13.8613 4.69667 13.9519C4.69667 14.0424 4.72664 14.13 4.78128 14.1992C4.83587 14.2683 4.91163 14.3145 4.99503 14.3295H8.38368V15.0741H4.99497C4.94644 15.0829 4.90047 15.1022 4.85977 15.1304C4.83878 15.145 4.81919 15.162 4.80136 15.1811C4.79439 15.1885 4.78765 15.1964 4.78122 15.2045C4.77188 15.2163 4.76327 15.2287 4.75539 15.2416C4.74441 15.2594 4.73495 15.2781 4.727 15.2975C4.71924 15.3163 4.71293 15.3358 4.70808 15.3558C4.70407 15.3723 4.7011 15.389 4.69922 15.4061C4.69752 15.4212 4.69667 15.4364 4.69667 15.4518C4.69667 15.5423 4.72664 15.6299 4.78122 15.6991C4.83587 15.7682 4.91157 15.8144 4.99497 15.8295H8.38368V16.5847H4.99497C4.91157 16.5998 4.83587 16.6459 4.78122 16.7151C4.72664 16.7842 4.69667 16.8718 4.69667 16.9624C4.69667 17.0529 4.72664 17.1405 4.78122 17.2097C4.83587 17.2788 4.91157 17.325 4.99497 17.34H9.54637C9.58655 17.3328 9.62496 17.3183 9.66008 17.2975H13.571ZM15.7573 4.52124L18.3609 7.30839C18.3758 7.32612 18.3858 7.34796 18.3897 7.37145C18.3937 7.39493 18.3914 7.41913 18.3831 7.44128C18.3748 7.46343 18.3609 7.48266 18.3429 7.49678C18.325 7.51089 18.3036 7.51934 18.2814 7.52115H15.7275L15.5585 7.34031V4.60634C15.5602 4.58255 15.5681 4.55975 15.5813 4.54051C15.5945 4.52128 15.6125 4.50639 15.6332 4.49753C15.6539 4.48867 15.6765 4.48619 15.6984 4.49038C15.7203 4.49457 15.7407 4.50526 15.7573 4.52124ZM14.1248 5.91437C14.1732 5.97391 14.2021 6.04884 14.2071 6.1276C14.2157 6.17377 14.2155 6.22129 14.2065 6.26739C14.2045 6.27778 14.2021 6.28804 14.1992 6.29817L14.1944 6.31388C14.1847 6.34291 14.1715 6.3705 14.1551 6.39595C14.13 6.43465 14.098 6.46757 14.0608 6.49276C14.0354 6.5099 14.008 6.52328 13.9794 6.53244C13.9661 6.53672 13.9525 6.5401 13.9387 6.5425H9.71529C9.62309 6.5425 9.5346 6.50328 9.4694 6.43342C9.40413 6.36362 9.3675 6.26889 9.3675 6.17013C9.3675 6.07144 9.40413 5.97671 9.4694 5.90691C9.5346 5.83704 9.62309 5.79783 9.71529 5.79783H13.9387C13.9718 5.80516 14.0034 5.81769 14.0326 5.83484C14.0672 5.85522 14.0984 5.88204 14.1248 5.91437ZM14.2667 7.29776H9.72529C9.69606 7.30302 9.66773 7.31211 9.64092 7.3247C9.62612 7.33171 9.61175 7.33977 9.59798 7.34879C9.56565 7.36996 9.53642 7.39664 9.51155 7.42813C9.4569 7.49722 9.42694 7.58487 9.42694 7.67538C9.42694 7.70155 9.42942 7.72752 9.43434 7.75285C9.44635 7.81505 9.47273 7.87355 9.51155 7.9227C9.55292 7.9751 9.60647 8.01432 9.66628 8.03678C9.67762 8.04107 9.6892 8.04477 9.70097 8.04775C9.70898 8.04983 9.71711 8.05158 9.72529 8.05308H14.2667C14.3546 8.04756 14.437 8.00555 14.4964 7.93601C14.5558 7.86647 14.5875 7.77492 14.5847 7.68071C14.5874 7.63318 14.5813 7.58559 14.5667 7.54059C14.5522 7.4956 14.5296 7.45417 14.5 7.41859C14.4704 7.38301 14.4346 7.35398 14.3946 7.33327C14.3546 7.31256 14.3111 7.30048 14.2667 7.29776ZM4.99497 18.84H12.786C12.8783 18.84 12.9667 18.8008 13.032 18.731C13.0972 18.6611 13.1338 18.5664 13.1338 18.4677C13.1338 18.3689 13.0972 18.2742 13.032 18.2044C12.9667 18.1346 12.8783 18.0954 12.786 18.0954H4.99497C4.90277 18.0954 4.81428 18.1346 4.74908 18.2044C4.68381 18.2742 4.64718 18.3689 4.64718 18.4677C4.64718 18.5664 4.68381 18.6611 4.74908 18.731C4.81428 18.8008 4.90277 18.84 4.99497 18.84ZM17.5858 12.7444H19.5733H19.623C19.7249 12.7499 19.821 12.7971 19.8913 12.8764C19.9616 12.9556 20.0007 13.0607 20.0006 13.17V13.8295C20.0007 13.8458 19.9976 13.862 19.9914 13.8769C19.9853 13.8918 19.9764 13.9052 19.9652 13.9163C19.9539 13.9273 19.9407 13.9357 19.9262 13.9409C19.9118 13.9461 19.8965 13.948 19.8814 13.9465H13.7797C13.7507 13.9465 13.7229 13.9342 13.7024 13.9123C13.6819 13.8903 13.6704 13.8606 13.6704 13.8295V13.17C13.6677 13.0617 13.7046 12.9566 13.7733 12.8771C13.842 12.7976 13.9371 12.75 14.0381 12.7444H16.0256V12.5104C16.0352 12.439 16.0687 12.3737 16.1199 12.3268C16.1711 12.2798 16.2365 12.2544 16.3039 12.2551H17.2976C17.3667 12.2517 17.4345 12.276 17.4878 12.3232C17.541 12.3704 17.576 12.4371 17.5858 12.5104V12.7444ZM14.0679 19.4251V14.1912H19.5037V19.4251C19.4935 19.585 19.4256 19.7344 19.3143 19.8416C19.203 19.9488 19.0571 20.0055 18.9075 19.9996H14.6642C14.5146 20.0055 14.3687 19.9488 14.2574 19.8416C14.1461 19.7344 14.0781 19.585 14.0679 19.4251ZM15.5983 15.1593H15.2505C15.0969 15.1593 14.9723 15.2926 14.9723 15.4572V18.7336C14.9723 18.8981 15.0969 19.0315 15.2505 19.0315H15.5983C15.752 19.0315 15.8766 18.8981 15.8766 18.7336V15.4572C15.8766 15.2926 15.752 15.1593 15.5983 15.1593ZM16.9598 15.1593H16.612C16.4583 15.1593 16.3337 15.2926 16.3337 15.4572V18.7336C16.3337 18.8981 16.4583 19.0315 16.612 19.0315H16.9598C17.1135 19.0315 17.238 18.8981 17.238 18.7336V15.4572C17.238 15.2926 17.1135 15.1593 16.9598 15.1593ZM17.9635 15.1593H18.3113C18.465 15.1593 18.5895 15.2926 18.5895 15.4572V18.7336C18.5895 18.8981 18.465 19.0315 18.3113 19.0315H17.9635C17.8098 19.0315 17.6852 18.8981 17.6852 18.7336V15.4572C17.6852 15.2926 17.8098 15.1593 17.9635 15.1593Z",acceptSingleChange:"M17.2 20H15.6628L17.33 18.3091V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H14.4978L14.1823 19.6791L13.5135 18.9904L13.5123 18.9891L13.0529 18.52H5C4.87537 18.52 4.75586 18.4705 4.66766 18.3823C4.57953 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 17.9253 4.57953 17.8058 4.66766 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H12.1323L11.6235 17.0604L11.6231 16.48L12.8831 15.19L13.4765 15.1896L15.0807 16.8276L17.33 14.5413V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5208 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9534 6.49057 10.9224 6.43948 10.8825 6.39581C10.8425 6.35217 10.7944 6.3168 10.7408 6.29178C10.6871 6.26678 10.6292 6.25256 10.57 6.25H5C4.88239 6.25772 4.77252 6.31131 4.69397 6.39917C4.61542 6.48706 4.57452 6.60226 4.58002 6.72C4.57452 6.83774 4.61542 6.95294 4.69397 7.04083C4.77252 7.12869 4.88239 7.18228 5 7.19H10.6C10.7141 7.1774 10.8189 7.12173 10.8933 7.03436C10.9677 6.94702 11.0058 6.83456 11 6.72ZM11.1 8.14001H5C4.87537 8.14001 4.75586 8.18954 4.66766 8.27768C4.57953 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57953 8.85422 4.66766 8.94235C4.71558 8.99023 4.77277 9.02673 4.83496 9.05008C4.86932 9.06296 4.90521 9.07184 4.94189 9.07642C4.96106 9.0788 4.98047 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.5205 8.85422 11.57 8.73468 11.57 8.61002C11.57 8.48535 11.5205 8.36581 11.4324 8.27768C11.3442 8.18954 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8035 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8035 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86737 10 4.74023 10.0527 4.64642 10.1465C4.55267 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55267 10.7598 4.64642 10.8535C4.74023 10.9473 4.86737 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.416 12.0552C11.3337 11.9673 11.2203 11.9152 11.1 11.91H5C4.94086 11.9126 4.88287 11.9268 4.82922 11.9518C4.77563 11.9768 4.72748 12.0122 4.6875 12.0558C4.65833 12.0878 4.63391 12.1237 4.61505 12.1624C4.60809 12.1767 4.60193 12.1913 4.5965 12.2062C4.58264 12.2443 4.5741 12.2841 4.57092 12.3243C4.56946 12.3428 4.56915 12.3614 4.57001 12.38C4.56451 12.5004 4.60651 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM15.45 14.74H5C4.87537 14.74 4.75586 14.6905 4.66766 14.6023C4.57953 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57953 14.0258 4.66766 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9377C15.8705 14.0258 15.92 14.1453 15.92 14.27C15.92 14.3947 15.8705 14.5142 15.7823 14.6023C15.6942 14.6905 15.5747 14.74 15.45 14.74ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66766 16.4923C4.57953 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57953 15.9158 4.66766 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.73 13.71L20 15.01L15.08 20L15.07 19.99L14.48 19.39L13.81 18.7L11.92 16.77L13.18 15.48L15.08 17.42L18.73 13.71Z",rejectSingleChange:"M17.0495 11.5C17.1461 11.5 17.241 11.5173 17.33 11.5501V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20H13.2305C13.1075 19.8287 13.0338 19.6249 13.0205 19.4112L13.0195 19.3956V18.52H5C4.87537 18.52 4.75586 18.4705 4.66772 18.3823C4.57959 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 18.0119 4.53467 17.9742 4.54358 17.9378C4.56396 17.8552 4.60657 17.7788 4.66772 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H13.0195V14.74H5C4.87537 14.74 4.75586 14.6905 4.66772 14.6023C4.57959 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57959 14.0258 4.66772 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H12.8393C12.6229 13.6377 12.4998 13.3897 12.4998 13.1032C12.4997 12.8414 12.6008 12.5847 12.7513 12.3911C12.9 12.1998 13.1561 12 13.4994 12L15.2519 12C15.2928 11.8972 15.3589 11.7915 15.4649 11.6992C15.6135 11.5698 15.8041 11.499 16.0011 11.5H17.0495ZM13.1 4.65L16.6 8.15C16.6211 8.17232 16.6354 8.20028 16.6411 8.23051C16.6468 8.26075 16.6437 8.29199 16.6321 8.32048C16.6204 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8311 4.72925 12.8411 4.6995 12.8588 4.67429C12.8764 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9892 4.60315 13.0194 4.60884C13.0497 4.61453 13.0776 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9716 6.5408 10.9695 6.53543 10.9673 6.53012C10.9626 6.51852 10.9575 6.50717 10.9518 6.49603C10.9406 6.47391 10.9275 6.45273 10.9127 6.43274C10.9033 6.41992 10.8932 6.40759 10.8824 6.39581C10.8425 6.35217 10.7943 6.3168 10.7407 6.29178C10.6871 6.26678 10.629 6.25256 10.5699 6.25H5C4.88232 6.25772 4.77246 6.31131 4.69397 6.39917C4.61536 6.48706 4.57446 6.60226 4.57996 6.72C4.57715 6.7811 4.58679 6.84152 4.60767 6.8978C4.61523 6.91803 4.62415 6.93771 4.63452 6.9567C4.65088 6.98669 4.67078 7.01495 4.69397 7.04083C4.77246 7.12869 4.88232 7.18228 5 7.19H10.6C10.714 7.1774 10.8188 7.12173 10.8932 7.03436C10.922 7.00049 10.9454 6.96283 10.9629 6.92273C10.9725 6.9006 10.9805 6.87775 10.9865 6.8544C10.9933 6.82791 10.9977 6.80075 10.9995 6.77325C11.0001 6.76453 11.0004 6.75574 11.0005 6.74695C11.0006 6.73798 11.0005 6.729 11 6.72ZM11.1 8.14001H5C4.97534 8.14001 4.95081 8.14194 4.92676 8.14575C4.89587 8.15063 4.8656 8.15857 4.83643 8.1694C4.77368 8.19272 4.71606 8.2294 4.66772 8.27768C4.57959 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57959 8.85422 4.66772 8.94235C4.75586 9.03049 4.87537 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.4617 8.91306 11.4867 8.88028 11.5071 8.845C11.5349 8.79691 11.554 8.74414 11.5634 8.68915C11.5677 8.66318 11.5701 8.63672 11.5701 8.61002C11.5701 8.48535 11.5205 8.36581 11.4324 8.27768C11.3929 8.23831 11.3474 8.20663 11.2979 8.18365C11.2365 8.15518 11.1689 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86743 10 4.74023 10.0527 4.64648 10.1465C4.55273 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55273 10.7598 4.64648 10.8535C4.74023 10.9473 4.86743 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4987 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3336 11.9673 11.2202 11.9152 11.1 11.91H5C4.94092 11.9126 4.88281 11.9268 4.82922 11.9518C4.77563 11.9768 4.72742 12.0122 4.6875 12.0558C4.64758 12.0995 4.6167 12.1506 4.59644 12.2062C4.58899 12.2266 4.58313 12.2475 4.57874 12.2687C4.57129 12.3052 4.56824 12.3426 4.56995 12.38C4.56445 12.5004 4.60645 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66772 16.4923C4.57959 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57959 15.9158 4.66772 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.5701 16.0353 11.5701 16.16C11.5701 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM19.59 12.53H17.36V12.3C17.3574 12.2195 17.3236 12.1432 17.2657 12.0872C17.2078 12.0313 17.1305 12 17.05 12H16C15.9242 11.9994 15.8509 12.0265 15.7938 12.0762C15.7367 12.126 15.6997 12.1949 15.69 12.27V12.5H13.44C13.3768 12.4994 13.3142 12.5125 13.2565 12.5382C13.1988 12.564 13.1473 12.6019 13.1055 12.6493C13.0638 12.6968 13.0327 12.7526 13.0145 12.8132C12.9963 12.8737 12.9913 12.9374 13 13V13.67C13 13.6871 13.0033 13.704 13.0099 13.7198C13.0164 13.7355 13.026 13.7499 13.038 13.7619C13.0501 13.774 13.0644 13.7836 13.0802 13.7901C13.096 13.7966 13.1129 13.8 13.13 13.8H19.84C19.8611 13.8054 19.8834 13.8054 19.9045 13.8C19.9257 13.7946 19.9452 13.7839 19.9611 13.7689C19.9771 13.754 19.989 13.7352 19.9958 13.7144C20.0026 13.6937 20.004 13.6715 20 13.65V13C20.0028 12.8866 19.9617 12.7765 19.8853 12.6927C19.809 12.6088 19.7031 12.5577 19.59 12.55V12.53ZM13.52 14V19.38C13.5303 19.5454 13.6054 19.7 13.7289 19.8105C13.8525 19.9209 14.0145 19.9782 14.18 19.97H18.84C19.0055 19.9782 19.1676 19.9209 19.2911 19.8105C19.4146 19.7 19.4897 19.5454 19.5 19.38V14H13.52ZM15.52 18.67C15.52 18.7522 15.4874 18.8311 15.4292 18.8892C15.3711 18.9473 15.2922 18.98 15.21 18.98H14.83C14.7478 18.98 14.669 18.9473 14.6108 18.8892C14.5527 18.8311 14.52 18.7522 14.52 18.67V15.33C14.52 15.2893 14.528 15.249 14.5436 15.2114C14.5592 15.1738 14.582 15.1396 14.6108 15.1108C14.6396 15.082 14.6738 15.0592 14.7114 15.0436C14.749 15.028 14.7893 15.02 14.83 15.02H15.21C15.2507 15.02 15.291 15.028 15.3287 15.0436C15.3663 15.0592 15.4004 15.082 15.4292 15.1108C15.458 15.1396 15.4808 15.1738 15.4964 15.2114C15.512 15.249 15.52 15.2893 15.52 15.33V18.67ZM17.01 18.67C17.01 18.7522 16.9774 18.8311 16.9192 18.8892C16.8611 18.9473 16.7822 18.98 16.7 18.98H16.32C16.2798 18.98 16.2399 18.9719 16.2029 18.9562C16.1658 18.9405 16.1323 18.9176 16.1043 18.8886C16.0763 18.8597 16.0544 18.8254 16.0399 18.7879C16.0254 18.7503 16.0187 18.7102 16.02 18.67V15.33C16.0187 15.2898 16.0254 15.2497 16.0399 15.2121C16.0544 15.1746 16.0763 15.1403 16.1043 15.1114C16.1323 15.0824 16.1658 15.0595 16.2029 15.0438C16.2399 15.0281 16.2798 15.02 16.32 15.02H16.7C16.7407 15.02 16.781 15.028 16.8187 15.0436C16.8563 15.0592 16.8904 15.082 16.9192 15.1108C16.948 15.1396 16.9708 15.1738 16.9864 15.2114C17.002 15.249 17.01 15.2893 17.01 15.33V18.67ZM18.51 18.67C18.51 18.7107 18.502 18.751 18.4864 18.7886C18.4708 18.8262 18.448 18.8604 18.4192 18.8892C18.3904 18.918 18.3563 18.9408 18.3187 18.9564C18.281 18.972 18.2407 18.98 18.2 18.98H17.82C17.7378 18.98 17.659 18.9473 17.6008 18.8892C17.5427 18.8311 17.51 18.7522 17.51 18.67V15.33C17.51 15.2893 17.518 15.249 17.5336 15.2114C17.5492 15.1738 17.572 15.1396 17.6008 15.1108C17.6296 15.082 17.6638 15.0592 17.7014 15.0436C17.739 15.028 17.7793 15.02 17.82 15.02H18.2C18.2407 15.02 18.281 15.028 18.3187 15.0436C18.3563 15.0592 18.3904 15.082 18.4192 15.1108C18.448 15.1396 18.4708 15.1738 18.4864 15.2114C18.502 15.249 18.51 15.2893 18.51 15.33V18.67Z",tableSelectorIcon:"M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 96-96 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-32 96 0 0 96-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0 0-96 96 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 32-96 0 0-96 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"},H.FILEICONS={docIcon:{extension:".doc",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9.617188 46.875 C 13.234375 46.875 16.160156 43.929688 16.160156 40.292969 C 16.160156 36.695312 13.234375 33.75 9.617188 33.75 L 7.402344 33.75 C 6.820312 33.75 6.371094 34.199219 6.371094 34.78125 L 6.371094 45.84375 C 6.371094 46.335938 6.714844 46.757812 7.191406 46.855469 L 7.402344 46.875 Z M 9.617188 44.792969 L 8.453125 44.792969 L 8.453125 35.832031 L 9.617188 35.832031 C 12.089844 35.832031 14.078125 37.835938 14.078125 40.292969 C 14.078125 42.789062 12.089844 44.773438 9.617188 44.792969 Z M 24.816406 46.875 C 26.539062 46.875 28.191406 46.085938 29.296875 44.867188 C 30.460938 43.648438 31.191406 41.980469 31.191406 40.125 C 31.191406 38.269531 30.460938 36.617188 29.296875 35.382812 C 28.191406 34.144531 26.539062 33.375 24.816406 33.375 C 23.015625 33.375 21.367188 34.144531 20.222656 35.382812 C 19.058594 36.617188 18.367188 38.269531 18.367188 40.125 C 18.367188 41.980469 19.058594 43.648438 20.222656 44.867188 C 21.367188 46.085938 23.015625 46.875 24.816406 46.875 Z M 24.816406 44.738281 C 23.617188 44.738281 22.566406 44.230469 21.777344 43.386719 C 20.992188 42.582031 20.503906 41.398438 20.503906 40.125 C 20.503906 38.851562 20.992188 37.667969 21.777344 36.84375 C 22.566406 36 23.617188 35.511719 24.816406 35.511719 C 25.941406 35.511719 26.992188 36 27.777344 36.84375 C 28.546875 37.667969 29.054688 38.851562 29.054688 40.125 C 29.054688 41.398438 28.546875 42.582031 27.777344 43.386719 C 26.992188 44.230469 25.941406 44.738281 24.816406 44.738281 Z M 39.996094 46.875 C 41.648438 46.875 43.148438 46.332031 44.328125 45.414062 C 44.777344 45.054688 44.851562 44.382812 44.515625 43.914062 C 44.140625 43.460938 43.445312 43.386719 43.015625 43.707031 C 42.171875 44.382812 41.160156 44.738281 39.996094 44.738281 C 38.703125 44.738281 37.503906 44.210938 36.621094 43.386719 C 35.777344 42.5625 35.253906 41.398438 35.253906 40.125 C 35.253906 38.851562 35.777344 37.726562 36.621094 36.863281 C 37.503906 36.039062 38.703125 35.511719 39.996094 35.511719 C 41.160156 35.511719 42.191406 35.867188 43.015625 36.542969 C 43.445312 36.882812 44.140625 36.804688 44.515625 36.335938 C 44.851562 35.867188 44.777344 35.210938 44.328125 34.835938 C 43.148438 33.917969 41.648438 33.375 39.996094 33.375 C 36.246094 33.394531 33.132812 36.414062 33.117188 40.125 C 33.132812 43.855469 36.246094 46.875 39.996094 46.875 Z M 39.996094 46.875 "/>\n      </g>'},gifIcon:{extension:".gif",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 17.394531 46.875 C 18.988281 46.875 20.46875 46.332031 21.648438 45.414062 C 21.835938 45.28125 21.949219 45.132812 22.003906 44.960938 L 22.003906 44.945312 C 22.023438 44.90625 22.023438 44.886719 22.042969 44.851562 C 22.0625 44.738281 22.097656 44.664062 22.097656 44.53125 L 22.097656 40.386719 C 22.097656 39.789062 21.613281 39.335938 21.011719 39.335938 L 17.28125 39.335938 C 16.699219 39.335938 16.210938 39.789062 16.210938 40.386719 C 16.210938 40.96875 16.699219 41.457031 17.28125 41.457031 L 19.960938 41.457031 L 19.960938 44.023438 C 19.210938 44.457031 18.332031 44.738281 17.394531 44.738281 C 16.042969 44.738281 14.863281 44.230469 14.019531 43.367188 C 13.136719 42.523438 12.613281 41.382812 12.613281 40.144531 C 12.613281 38.867188 13.136719 37.726562 14.019531 36.882812 C 14.863281 36.019531 16.042969 35.511719 17.394531 35.511719 C 18.519531 35.511719 19.550781 35.90625 20.355469 36.523438 C 20.824219 36.898438 21.519531 36.804688 21.875 36.355469 C 22.230469 35.886719 22.15625 35.195312 21.667969 34.835938 C 20.503906 33.917969 18.988281 33.375 17.394531 33.375 C 13.585938 33.375 10.472656 36.375 10.472656 40.144531 C 10.472656 43.894531 13.585938 46.875 17.394531 46.875 Z M 26.945312 46.875 C 27.507812 46.875 27.996094 46.425781 27.996094 45.84375 L 27.996094 34.78125 C 27.996094 34.199219 27.507812 33.75 26.945312 33.75 C 26.363281 33.75 25.914062 34.199219 25.914062 34.78125 L 25.914062 45.84375 C 25.914062 46.425781 26.363281 46.875 26.945312 46.875 Z M 33.066406 46.875 C 33.648438 46.875 34.117188 46.40625 34.117188 45.84375 L 34.117188 41.34375 L 38.488281 41.34375 C 39.050781 41.34375 39.519531 40.875 39.519531 40.292969 C 39.519531 39.75 39.050781 39.261719 38.488281 39.261719 L 34.117188 39.261719 L 34.117188 35.832031 L 39.199219 35.832031 C 39.742188 35.832031 40.230469 35.363281 40.230469 34.78125 C 40.230469 34.21875 39.742188 33.75 39.199219 33.75 L 33.066406 33.75 C 32.488281 33.75 32.035156 34.21875 32.035156 34.78125 L 32.035156 45.84375 C 32.035156 46.40625 32.488281 46.875 33.066406 46.875 Z M 33.066406 46.875 "/>\n      </g>'},jpegIcon:{extension:".jpeg",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9 43.75 C 11.140625 43.75 12.890625 42.015625 12.890625 39.875 L 12.890625 33.671875 C 12.890625 33.1875 12.5 32.8125 12.03125 32.8125 C 11.546875 32.8125 11.15625 33.1875 11.15625 33.671875 L 11.15625 39.875 C 11.15625 41.046875 10.1875 42.015625 9 42.015625 C 8.046875 42.015625 7.234375 41.390625 6.953125 40.53125 C 6.8125 40.078125 6.328125 39.828125 5.859375 39.984375 C 5.421875 40.109375 5.15625 40.59375 5.3125 41.0625 C 5.8125 42.625 7.28125 43.75 9 43.75 Z M 15.640625 43.75 C 16.125 43.75 16.515625 43.359375 16.515625 42.890625 L 16.515625 39.5 L 18.4375 39.5 C 20.296875 39.5 21.796875 38 21.796875 36.171875 C 21.796875 34.3125 20.296875 32.8125 18.4375 32.8125 L 15.640625 32.8125 C 15.171875 32.8125 14.78125 33.1875 14.78125 33.671875 L 14.78125 42.890625 C 14.78125 43.359375 15.171875 43.75 15.640625 43.75 Z M 18.4375 37.765625 L 16.515625 37.765625 L 16.515625 34.546875 L 18.4375 34.546875 C 19.34375 34.546875 20.046875 35.265625 20.0625 36.171875 C 20.046875 37.046875 19.34375 37.765625 18.4375 37.765625 Z M 29.234375 43.75 C 29.6875 43.75 30.09375 43.359375 30.09375 42.890625 C 30.09375 42.40625 29.6875 42.015625 29.234375 42.015625 L 25 42.015625 L 25 39.140625 L 28.640625 39.140625 C 29.109375 39.140625 29.5 38.75 29.5 38.265625 C 29.5 37.8125 29.109375 37.40625 28.640625 37.40625 L 25 37.40625 L 25 34.546875 L 29.234375 34.546875 C 29.6875 34.546875 30.09375 34.15625 30.09375 33.671875 C 30.09375 33.1875 29.6875 32.8125 29.234375 32.8125 L 24.125 32.8125 C 23.640625 32.8125 23.265625 33.1875 23.265625 33.671875 L 23.265625 42.890625 C 23.265625 43.359375 23.640625 43.75 24.125 43.75 C 24.125 43.75 24.140625 43.734375 24.140625 43.734375 C 24.140625 43.734375 24.140625 43.75 24.171875 43.75 Z M 37.1875 43.75 C 38.515625 43.75 39.75 43.296875 40.734375 42.53125 C 40.890625 42.421875 40.984375 42.296875 41.03125 42.15625 L 41.03125 42.140625 C 41.046875 42.109375 41.046875 42.09375 41.0625 42.0625 C 41.078125 41.96875 41.109375 41.90625 41.109375 41.796875 L 41.109375 38.34375 C 41.109375 37.914062 40.8125 37.578125 40.410156 37.492188 L 40.203125 37.46875 L 37.09375 37.46875 C 36.609375 37.46875 36.203125 37.84375 36.203125 38.34375 C 36.203125 38.828125 36.609375 39.234375 37.09375 39.234375 L 39.328125 39.234375 L 39.328125 41.375 C 38.703125 41.734375 37.96875 41.96875 37.1875 41.96875 C 36.0625 41.96875 35.078125 41.546875 34.375 40.828125 C 33.640625 40.125 33.203125 39.171875 33.203125 38.140625 C 33.203125 37.078125 33.640625 36.125 34.375 35.421875 C 35.078125 34.703125 36.0625 34.28125 37.1875 34.28125 C 38.125 34.28125 38.984375 34.609375 39.65625 35.125 C 40.046875 35.4375 40.625 35.359375 40.921875 34.984375 C 41.21875 34.59375 41.15625 34.015625 40.75 33.71875 C 39.78125 32.953125 38.515625 32.5 37.1875 32.5 C 34.015625 32.5 31.421875 35 31.421875 38.140625 C 31.421875 41.265625 34.015625 43.75 37.1875 43.75 Z M 37.1875 43.75 "/>\n      </g>'},logIcon:{extension:".log",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 13.542969 46.875 C 14.085938 46.875 14.574219 46.40625 14.574219 45.84375 C 14.574219 45.261719 14.085938 44.792969 13.542969 44.792969 L 8.460938 44.792969 L 8.460938 34.78125 C 8.460938 34.21875 7.992188 33.75 7.410156 33.75 C 6.828125 33.75 6.378906 34.21875 6.378906 34.78125 L 6.378906 45.84375 C 6.378906 46.40625 6.828125 46.875 7.410156 46.875 Z M 21.742188 46.875 C 23.46875 46.875 25.117188 46.085938 26.222656 44.867188 C 27.386719 43.648438 28.117188 41.980469 28.117188 40.125 C 28.117188 38.269531 27.386719 36.617188 26.222656 35.382812 C 25.117188 34.144531 23.46875 33.375 21.742188 33.375 C 19.941406 33.375 18.292969 34.144531 17.148438 35.382812 C 15.984375 36.617188 15.292969 38.269531 15.292969 40.125 C 15.292969 41.980469 15.984375 43.648438 17.148438 44.867188 C 18.292969 46.085938 19.941406 46.875 21.742188 46.875 Z M 21.742188 44.738281 C 20.542969 44.738281 19.492188 44.230469 18.703125 43.386719 C 17.917969 42.582031 17.429688 41.398438 17.429688 40.125 C 17.429688 38.851562 17.917969 37.667969 18.703125 36.84375 C 19.492188 36 20.542969 35.511719 21.742188 35.511719 C 22.867188 35.511719 23.917969 36 24.703125 36.84375 C 25.472656 37.667969 25.980469 38.851562 25.980469 40.125 C 25.980469 41.398438 25.472656 42.582031 24.703125 43.386719 C 23.917969 44.230469 22.867188 44.738281 21.742188 44.738281 Z M 37.300781 46.875 C 38.894531 46.875 40.375 46.332031 41.558594 45.414062 C 41.746094 45.28125 41.855469 45.132812 41.914062 44.960938 L 41.914062 44.945312 L 41.949219 44.851562 C 41.96875 44.738281 42.007812 44.664062 42.007812 44.53125 L 42.007812 40.386719 C 42.007812 39.789062 41.519531 39.335938 40.917969 39.335938 L 37.1875 39.335938 C 36.605469 39.335938 36.121094 39.789062 36.121094 40.386719 C 36.121094 40.96875 36.605469 41.457031 37.1875 41.457031 L 39.871094 41.457031 L 39.871094 44.023438 C 39.121094 44.457031 38.238281 44.738281 37.300781 44.738281 C 35.949219 44.738281 34.769531 44.230469 33.925781 43.367188 C 33.042969 42.523438 32.519531 41.382812 32.519531 40.144531 C 32.519531 38.867188 33.042969 37.726562 33.925781 36.882812 C 34.769531 36.019531 35.949219 35.511719 37.300781 35.511719 C 38.425781 35.511719 39.457031 35.90625 40.261719 36.523438 C 40.730469 36.898438 41.425781 36.804688 41.78125 36.355469 C 42.136719 35.886719 42.0625 35.195312 41.574219 34.835938 C 40.414062 33.917969 38.894531 33.375 37.300781 33.375 C 33.496094 33.375 30.382812 36.375 30.382812 40.144531 C 30.382812 43.894531 33.496094 46.875 37.300781 46.875 Z M 37.300781 46.875 "/>\n      </g>'},movIcon:{extension:".mov",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 15.472656 46.875 C 16.035156 46.875 16.523438 46.40625 16.523438 45.84375 L 16.523438 34.78125 C 16.523438 34.289062 16.152344 33.882812 15.679688 33.777344 L 15.472656 33.75 L 15.453125 33.75 C 15.117188 33.75 14.816406 33.898438 14.609375 34.179688 L 10.878906 39.355469 L 7.148438 34.179688 C 6.960938 33.898438 6.625 33.75 6.324219 33.75 L 6.265625 33.75 C 5.703125 33.75 5.234375 34.21875 5.234375 34.78125 L 5.234375 45.84375 C 5.234375 46.40625 5.703125 46.875 6.265625 46.875 C 6.847656 46.875 7.316406 46.40625 7.316406 45.84375 L 7.316406 37.949219 L 10 41.699219 C 10.203125 41.980469 10.523438 42.132812 10.859375 42.132812 L 10.898438 42.132812 C 11.234375 42.132812 11.535156 41.980469 11.742188 41.699219 L 14.441406 37.949219 L 14.441406 45.84375 C 14.441406 46.40625 14.890625 46.875 15.472656 46.875 Z M 25.460938 46.875 C 27.1875 46.875 28.835938 46.085938 29.941406 44.867188 C 31.105469 43.648438 31.835938 41.980469 31.835938 40.125 C 31.835938 38.269531 31.105469 36.617188 29.941406 35.382812 C 28.835938 34.144531 27.1875 33.375 25.460938 33.375 C 23.660156 33.375 22.011719 34.144531 20.867188 35.382812 C 19.703125 36.617188 19.011719 38.269531 19.011719 40.125 C 19.011719 41.980469 19.703125 43.648438 20.867188 44.867188 C 22.011719 46.085938 23.660156 46.875 25.460938 46.875 Z M 25.460938 44.738281 C 24.261719 44.738281 23.210938 44.230469 22.421875 43.386719 C 21.636719 42.582031 21.148438 41.398438 21.148438 40.125 C 21.148438 38.851562 21.636719 37.667969 22.421875 36.84375 C 23.210938 36 24.261719 35.511719 25.460938 35.511719 C 26.585938 35.511719 27.636719 36 28.421875 36.84375 C 29.191406 37.667969 29.699219 38.851562 29.699219 40.125 C 29.699219 41.398438 29.191406 42.582031 28.421875 43.386719 C 27.636719 44.230469 26.585938 44.738281 25.460938 44.738281 Z M 38.683594 46.855469 L 38.71875 46.855469 C 38.777344 46.835938 38.8125 46.820312 38.871094 46.820312 C 38.886719 46.800781 38.886719 46.800781 38.90625 46.800781 C 38.964844 46.78125 39.019531 46.726562 39.058594 46.707031 L 39.09375 46.6875 L 39.207031 46.59375 C 39.226562 46.574219 39.226562 46.574219 39.246094 46.539062 L 39.339844 46.425781 C 39.355469 46.425781 39.355469 46.425781 39.355469 46.40625 C 39.394531 46.367188 39.414062 46.292969 39.433594 46.257812 L 44.0625 35.304688 C 44.269531 34.800781 44.027344 34.179688 43.5 33.976562 C 42.996094 33.75 42.375 33.992188 42.152344 34.519531 L 38.496094 43.199219 L 34.839844 34.519531 C 34.613281 33.992188 34.011719 33.75 33.507812 33.976562 C 32.964844 34.179688 32.71875 34.800781 32.945312 35.304688 L 37.539062 46.257812 C 37.574219 46.292969 37.613281 46.367188 37.632812 46.40625 C 37.632812 46.425781 37.652344 46.425781 37.652344 46.425781 C 37.667969 46.460938 37.707031 46.5 37.746094 46.539062 C 37.746094 46.574219 37.761719 46.574219 37.761719 46.59375 C 37.820312 46.632812 37.855469 46.648438 37.894531 46.6875 L 37.914062 46.6875 C 37.96875 46.726562 38.042969 46.78125 38.082031 46.800781 L 38.101562 46.800781 C 38.101562 46.800781 38.121094 46.800781 38.121094 46.820312 C 38.15625 46.820312 38.230469 46.835938 38.269531 46.855469 L 38.308594 46.855469 L 38.402344 46.871094 L 38.496094 46.875 C 38.550781 46.875 38.605469 46.875 38.683594 46.855469 Z M 38.683594 46.855469 "/>\n      </g>'},ogvIcon:{extension:".ogv",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 11.511719 46.875 C 13.238281 46.875 14.886719 46.085938 15.996094 44.867188 C 17.15625 43.648438 17.886719 41.980469 17.886719 40.125 C 17.886719 38.269531 17.15625 36.617188 15.996094 35.382812 C 14.886719 34.144531 13.238281 33.375 11.511719 33.375 C 9.714844 33.375 8.0625 34.144531 6.917969 35.382812 C 5.757812 36.617188 5.0625 38.269531 5.0625 40.125 C 5.0625 41.980469 5.757812 43.648438 6.917969 44.867188 C 8.0625 46.085938 9.714844 46.875 11.511719 46.875 Z M 11.511719 44.738281 C 10.3125 44.738281 9.261719 44.230469 8.476562 43.386719 C 7.6875 42.582031 7.199219 41.398438 7.199219 40.125 C 7.199219 38.851562 7.6875 37.667969 8.476562 36.84375 C 9.261719 36 10.3125 35.511719 11.511719 35.511719 C 12.636719 35.511719 13.6875 36 14.476562 36.84375 C 15.246094 37.667969 15.75 38.851562 15.75 40.125 C 15.75 41.398438 15.246094 42.582031 14.476562 43.386719 C 13.6875 44.230469 12.636719 44.738281 11.511719 44.738281 Z M 27.25 46.875 C 28.84375 46.875 30.324219 46.332031 31.507812 45.414062 C 31.695312 45.28125 31.804688 45.132812 31.863281 44.960938 L 31.863281 44.945312 C 31.882812 44.90625 31.882812 44.886719 31.898438 44.851562 C 31.917969 44.738281 31.957031 44.664062 31.957031 44.53125 L 31.957031 40.386719 C 31.957031 39.789062 31.46875 39.335938 30.867188 39.335938 L 27.136719 39.335938 C 26.554688 39.335938 26.070312 39.789062 26.070312 40.386719 C 26.070312 40.96875 26.554688 41.457031 27.136719 41.457031 L 29.820312 41.457031 L 29.820312 44.023438 C 29.070312 44.457031 28.1875 44.738281 27.25 44.738281 C 25.898438 44.738281 24.71875 44.230469 23.875 43.367188 C 22.992188 42.523438 22.46875 41.382812 22.46875 40.144531 C 22.46875 38.867188 22.992188 37.726562 23.875 36.882812 C 24.71875 36.019531 25.898438 35.511719 27.25 35.511719 C 28.375 35.511719 29.40625 35.90625 30.210938 36.523438 C 30.679688 36.898438 31.375 36.804688 31.730469 36.355469 C 32.085938 35.886719 32.011719 35.195312 31.523438 34.835938 C 30.363281 33.917969 28.84375 33.375 27.25 33.375 C 23.445312 33.375 20.332031 36.375 20.332031 40.144531 C 20.332031 43.894531 23.445312 46.875 27.25 46.875 Z M 40.191406 46.855469 L 40.230469 46.855469 C 40.285156 46.835938 40.324219 46.820312 40.378906 46.820312 C 40.398438 46.800781 40.398438 46.800781 40.417969 46.800781 C 40.472656 46.78125 40.53125 46.726562 40.566406 46.707031 C 40.605469 46.6875 40.605469 46.6875 40.605469 46.6875 L 40.71875 46.59375 C 40.738281 46.574219 40.738281 46.574219 40.753906 46.539062 L 40.847656 46.425781 C 40.867188 46.425781 40.867188 46.425781 40.867188 46.40625 C 40.90625 46.367188 40.925781 46.292969 40.941406 46.257812 L 45.574219 35.304688 C 45.78125 34.800781 45.535156 34.179688 45.011719 33.976562 C 44.503906 33.75 43.886719 33.992188 43.660156 34.519531 L 40.003906 43.199219 L 36.347656 34.519531 C 36.125 33.992188 35.523438 33.75 35.019531 33.976562 C 34.472656 34.179688 34.230469 34.800781 34.457031 35.304688 L 39.050781 46.257812 C 39.085938 46.292969 39.125 46.367188 39.144531 46.40625 C 39.144531 46.425781 39.160156 46.425781 39.160156 46.425781 C 39.179688 46.460938 39.21875 46.5 39.253906 46.539062 C 39.253906 46.574219 39.273438 46.574219 39.273438 46.59375 C 39.332031 46.632812 39.367188 46.648438 39.40625 46.6875 L 39.425781 46.6875 C 39.480469 46.726562 39.554688 46.78125 39.59375 46.800781 L 39.613281 46.800781 C 39.613281 46.800781 39.628906 46.800781 39.628906 46.820312 C 39.667969 46.820312 39.742188 46.835938 39.78125 46.855469 L 39.816406 46.855469 L 39.910156 46.871094 L 40.003906 46.875 C 40.0625 46.875 40.117188 46.875 40.191406 46.855469 Z M 40.191406 46.855469 "/>\n      </g>'},pngIcon:{extension:".png",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.523438 46.875 C 8.105469 46.875 8.574219 46.40625 8.574219 45.84375 L 8.574219 41.773438 L 10.878906 41.773438 C 13.109375 41.773438 14.910156 39.976562 14.910156 37.78125 C 14.910156 35.550781 13.109375 33.75 10.878906 33.75 L 7.523438 33.75 C 6.960938 33.75 6.492188 34.199219 6.492188 34.78125 L 6.492188 45.84375 C 6.492188 46.40625 6.960938 46.875 7.523438 46.875 Z M 10.878906 39.695312 L 8.574219 39.695312 L 8.574219 35.832031 L 10.878906 35.832031 C 11.964844 35.832031 12.808594 36.695312 12.828125 37.78125 C 12.808594 38.832031 11.964844 39.695312 10.878906 39.695312 Z M 26.75 46.875 C 27.3125 46.875 27.78125 46.40625 27.78125 45.84375 L 27.78125 34.949219 C 27.78125 34.40625 27.3125 33.9375 26.75 33.9375 C 26.1875 33.9375 25.738281 34.40625 25.738281 34.949219 L 25.738281 42.675781 L 19.679688 34.292969 C 19.363281 33.84375 18.722656 33.75 18.253906 34.070312 C 17.972656 34.273438 17.824219 34.613281 17.84375 34.929688 L 17.84375 45.84375 C 17.84375 46.40625 18.292969 46.875 18.875 46.875 C 19.417969 46.875 19.886719 46.40625 19.886719 45.84375 L 19.886719 38.0625 L 25.886719 46.386719 C 25.90625 46.425781 25.941406 46.460938 25.980469 46.5 C 26.167969 46.726562 26.449219 46.875 26.75 46.875 Z M 38.082031 46.875 C 39.675781 46.875 41.15625 46.332031 42.339844 45.414062 C 42.527344 45.28125 42.636719 45.132812 42.695312 44.960938 L 42.695312 44.945312 C 42.714844 44.90625 42.714844 44.886719 42.730469 44.851562 C 42.75 44.738281 42.789062 44.664062 42.789062 44.53125 L 42.789062 40.386719 C 42.789062 39.789062 42.300781 39.335938 41.699219 39.335938 L 37.96875 39.335938 C 37.386719 39.335938 36.902344 39.789062 36.902344 40.386719 C 36.902344 40.96875 37.386719 41.457031 37.96875 41.457031 L 40.652344 41.457031 L 40.652344 44.023438 C 39.902344 44.457031 39.019531 44.738281 38.082031 44.738281 C 36.730469 44.738281 35.550781 44.230469 34.707031 43.367188 C 33.824219 42.523438 33.300781 41.382812 33.300781 40.144531 C 33.300781 38.867188 33.824219 37.726562 34.707031 36.882812 C 35.550781 36.019531 36.730469 35.511719 38.082031 35.511719 C 39.207031 35.511719 40.238281 35.90625 41.042969 36.523438 C 41.511719 36.898438 42.207031 36.804688 42.5625 36.355469 C 42.917969 35.886719 42.84375 35.195312 42.355469 34.835938 C 41.195312 33.917969 39.675781 33.375 38.082031 33.375 C 34.277344 33.375 31.164062 36.375 31.164062 40.144531 C 31.164062 43.894531 34.277344 46.875 38.082031 46.875 Z M 38.082031 46.875 "/>\n      </g>'},txtIcon:{extension:".txt",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 12.847656 46.875 C 13.429688 46.875 13.878906 46.425781 13.878906 45.84375 L 13.878906 35.832031 L 16.859375 35.832031 C 17.421875 35.832031 17.890625 35.34375 17.890625 34.78125 C 17.890625 34.199219 17.421875 33.75 16.859375 33.75 L 8.855469 33.75 C 8.273438 33.75 7.824219 34.199219 7.824219 34.78125 C 7.824219 35.34375 8.273438 35.832031 8.855469 35.832031 L 11.816406 35.832031 L 11.816406 45.84375 C 11.816406 46.425781 12.285156 46.875 12.847656 46.875 Z M 29.019531 46.875 C 29.222656 46.875 29.429688 46.800781 29.617188 46.667969 C 30.085938 46.351562 30.160156 45.695312 29.84375 45.242188 L 26.28125 40.367188 L 29.84375 35.53125 C 30.160156 35.0625 30.085938 34.425781 29.617188 34.105469 C 29.148438 33.75 28.53125 33.84375 28.175781 34.332031 L 25.023438 38.644531 L 21.855469 34.332031 C 21.535156 33.84375 20.878906 33.75 20.429688 34.105469 C 19.960938 34.425781 19.867188 35.0625 20.1875 35.53125 L 23.75 40.367188 L 20.1875 45.242188 C 19.867188 45.695312 19.960938 46.351562 20.429688 46.667969 C 20.597656 46.800781 20.804688 46.875 21.03125 46.875 C 21.347656 46.875 21.648438 46.707031 21.855469 46.445312 L 25.023438 42.113281 L 28.175781 46.445312 C 28.378906 46.707031 28.679688 46.875 29.019531 46.875 Z M 37.464844 46.875 C 38.042969 46.875 38.496094 46.425781 38.496094 45.84375 L 38.496094 35.832031 L 41.476562 35.832031 C 42.039062 35.832031 42.507812 35.34375 42.507812 34.78125 C 42.507812 34.199219 42.039062 33.75 41.476562 33.75 L 33.46875 33.75 C 32.886719 33.75 32.4375 34.199219 32.4375 34.78125 C 32.4375 35.34375 32.886719 35.832031 33.46875 35.832031 L 36.433594 35.832031 L 36.433594 45.84375 C 36.433594 46.425781 36.902344 46.875 37.464844 46.875 Z M 37.464844 46.875 "/>\n      </g>'},webmIcon:{extension:".webm",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.195312 43.734375 L 7.242188 43.734375 C 7.273438 43.71875 7.304688 43.703125 7.367188 43.703125 C 7.367188 43.6875 7.382812 43.6875 7.382812 43.6875 L 7.398438 43.6875 C 7.429688 43.671875 7.476562 43.625 7.523438 43.59375 L 7.554688 43.59375 C 7.585938 43.5625 7.617188 43.53125 7.648438 43.515625 C 7.648438 43.5 7.664062 43.5 7.664062 43.46875 L 7.757812 43.375 C 7.757812 43.375 7.757812 43.359375 7.773438 43.359375 C 7.789062 43.328125 7.820312 43.265625 7.835938 43.21875 L 9.882812 38.375 L 11.929688 43.21875 C 11.945312 43.265625 11.960938 43.328125 11.992188 43.359375 C 11.992188 43.359375 11.992188 43.375 12.023438 43.375 L 12.085938 43.46875 C 12.101562 43.5 12.101562 43.5 12.117188 43.515625 C 12.148438 43.53125 12.179688 43.5625 12.226562 43.59375 L 12.242188 43.59375 C 12.273438 43.625 12.320312 43.671875 12.382812 43.6875 C 12.398438 43.6875 12.398438 43.6875 12.414062 43.703125 C 12.445312 43.703125 12.476562 43.71875 12.523438 43.734375 L 12.570312 43.734375 L 12.640625 43.746094 L 12.710938 43.75 C 12.773438 43.75 12.820312 43.75 12.867188 43.734375 L 12.898438 43.734375 C 12.945312 43.71875 12.992188 43.703125 13.023438 43.703125 C 13.023438 43.6875 13.039062 43.6875 13.039062 43.6875 L 13.054688 43.6875 C 13.117188 43.671875 13.148438 43.625 13.195312 43.59375 L 13.210938 43.59375 C 13.242188 43.5625 13.289062 43.53125 13.320312 43.515625 C 13.320312 43.5 13.335938 43.5 13.335938 43.46875 C 13.367188 43.4375 13.398438 43.40625 13.414062 43.375 C 13.414062 43.375 13.429688 43.359375 13.429688 43.359375 C 13.460938 43.328125 13.492188 43.265625 13.507812 43.21875 L 17.335938 34.109375 C 17.523438 33.6875 17.320312 33.171875 16.898438 33 C 16.445312 32.8125 15.945312 33.015625 15.757812 33.453125 L 12.710938 40.6875 L 10.695312 35.890625 C 10.539062 35.546875 10.210938 35.359375 9.882812 35.359375 C 9.539062 35.359375 9.210938 35.546875 9.070312 35.890625 L 7.054688 40.6875 L 3.992188 33.453125 C 3.820312 33.015625 3.304688 32.8125 2.882812 33 C 2.429688 33.171875 2.242188 33.6875 2.414062 34.109375 L 6.257812 43.21875 C 6.289062 43.265625 6.304688 43.328125 6.335938 43.359375 L 6.335938 43.375 C 6.367188 43.40625 6.382812 43.4375 6.414062 43.46875 C 6.429688 43.5 6.429688 43.5 6.445312 43.515625 C 6.492188 43.53125 6.507812 43.5625 6.554688 43.59375 L 6.570312 43.59375 C 6.601562 43.625 6.664062 43.671875 6.710938 43.6875 C 6.726562 43.6875 6.726562 43.6875 6.742188 43.703125 C 6.773438 43.703125 6.804688 43.71875 6.851562 43.734375 L 6.898438 43.734375 L 6.976562 43.746094 L 7.054688 43.75 C 7.101562 43.75 7.148438 43.75 7.195312 43.734375 Z M 25.179688 43.75 C 25.632812 43.75 26.039062 43.359375 26.039062 42.890625 C 26.039062 42.40625 25.632812 42.015625 25.179688 42.015625 L 20.945312 42.015625 L 20.945312 39.140625 L 24.585938 39.140625 C 25.054688 39.140625 25.445312 38.75 25.445312 38.265625 C 25.445312 37.8125 25.054688 37.40625 24.585938 37.40625 L 20.945312 37.40625 L 20.945312 34.546875 L 25.179688 34.546875 C 25.632812 34.546875 26.039062 34.15625 26.039062 33.671875 C 26.039062 33.1875 25.632812 32.8125 25.179688 32.8125 L 20.070312 32.8125 C 19.585938 32.8125 19.210938 33.1875 19.210938 33.671875 L 19.210938 42.890625 C 19.210938 43.359375 19.585938 43.75 20.070312 43.75 C 20.070312 43.75 20.085938 43.734375 20.085938 43.734375 C 20.085938 43.734375 20.085938 43.75 20.117188 43.75 Z M 31.539062 43.75 C 33.382812 43.75 34.882812 42.25 34.882812 40.390625 C 34.882812 39.203125 34.242188 38.15625 33.304688 37.5625 C 33.679688 37.0625 33.898438 36.453125 33.898438 35.78125 C 33.898438 34.140625 32.570312 32.8125 30.929688 32.8125 L 28.710938 32.8125 C 28.242188 32.8125 27.851562 33.1875 27.851562 33.671875 L 27.851562 42.890625 C 27.851562 43.359375 28.242188 43.75 28.710938 43.75 L 28.757812 43.734375 C 28.757812 43.734375 28.757812 43.75 28.773438 43.75 Z M 30.929688 37.046875 L 29.585938 37.046875 L 29.585938 34.546875 L 30.929688 34.546875 C 31.617188 34.546875 32.164062 35.09375 32.164062 35.78125 C 32.164062 36.46875 31.617188 37.046875 30.929688 37.046875 Z M 31.539062 42.015625 L 29.585938 42.015625 L 29.585938 38.78125 L 31.539062 38.78125 C 32.429688 38.796875 33.148438 39.5 33.148438 40.390625 C 33.148438 41.296875 32.429688 42 31.539062 42.015625 Z M 45.664062 43.75 C 46.132812 43.75 46.539062 43.359375 46.539062 42.890625 L 46.539062 33.671875 C 46.539062 33.269531 46.242188 32.9375 45.859375 32.839844 L 45.664062 32.8125 L 45.648438 32.8125 C 45.367188 32.8125 45.117188 32.9375 44.945312 33.171875 L 41.835938 37.484375 L 38.726562 33.171875 C 38.570312 32.9375 38.289062 32.8125 38.039062 32.8125 L 37.992188 32.8125 C 37.523438 32.8125 37.132812 33.203125 37.132812 33.671875 L 37.132812 42.890625 C 37.132812 43.359375 37.523438 43.75 37.992188 43.75 C 38.476562 43.75 38.867188 43.359375 38.867188 42.890625 L 38.867188 36.3125 L 41.101562 39.4375 C 41.273438 39.671875 41.539062 39.796875 41.820312 39.796875 L 41.851562 39.796875 C 42.132812 39.796875 42.382812 39.671875 42.554688 39.4375 L 44.804688 36.3125 L 44.804688 42.890625 C 44.804688 43.359375 45.179688 43.75 45.664062 43.75 Z M 45.664062 43.75 "/>\n      </g>'},webpIcon:{extension:".webp",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9.234375 43.734375 L 9.28125 43.734375 C 9.3125 43.71875 9.34375 43.703125 9.40625 43.703125 L 9.414062 43.6875 C 9.421875 43.6875 9.421875 43.6875 9.4375 43.6875 C 9.46875 43.671875 9.515625 43.625 9.5625 43.59375 L 9.59375 43.59375 C 9.625 43.5625 9.65625 43.53125 9.6875 43.515625 C 9.6875 43.5 9.703125 43.5 9.703125 43.46875 L 9.796875 43.375 C 9.796875 43.375 9.796875 43.359375 9.8125 43.359375 C 9.828125 43.328125 9.859375 43.265625 9.875 43.21875 L 11.921875 38.375 L 13.96875 43.21875 C 13.984375 43.265625 14 43.328125 14.03125 43.359375 C 14.03125 43.359375 14.03125 43.375 14.0625 43.375 L 14.125 43.46875 C 14.140625 43.5 14.140625 43.5 14.15625 43.515625 L 14.203125 43.546875 L 14.265625 43.59375 C 14.265625 43.59375 14.265625 43.59375 14.28125 43.59375 C 14.3125 43.625 14.359375 43.671875 14.421875 43.6875 C 14.4375 43.6875 14.4375 43.6875 14.453125 43.703125 C 14.484375 43.703125 14.515625 43.71875 14.5625 43.734375 L 14.609375 43.734375 L 14.679688 43.746094 L 14.75 43.75 C 14.8125 43.75 14.859375 43.75 14.90625 43.734375 L 14.9375 43.734375 C 14.984375 43.71875 15.03125 43.703125 15.0625 43.703125 C 15.0625 43.6875 15.078125 43.6875 15.078125 43.6875 L 15.09375 43.6875 C 15.15625 43.671875 15.1875 43.625 15.234375 43.59375 L 15.25 43.59375 C 15.28125 43.5625 15.328125 43.53125 15.359375 43.515625 C 15.359375 43.5 15.375 43.5 15.375 43.46875 C 15.40625 43.4375 15.4375 43.40625 15.453125 43.375 L 15.46875 43.359375 C 15.5 43.328125 15.53125 43.265625 15.546875 43.21875 L 19.375 34.109375 C 19.5625 33.6875 19.359375 33.171875 18.9375 33 C 18.484375 32.8125 17.984375 33.015625 17.796875 33.453125 L 14.75 40.6875 L 12.734375 35.890625 C 12.578125 35.546875 12.25 35.359375 11.921875 35.359375 C 11.578125 35.359375 11.25 35.546875 11.109375 35.890625 L 9.09375 40.6875 L 6.03125 33.453125 C 5.859375 33.015625 5.34375 32.8125 4.921875 33 C 4.46875 33.171875 4.28125 33.6875 4.453125 34.109375 L 8.296875 43.21875 C 8.328125 43.265625 8.34375 43.328125 8.375 43.359375 L 8.375 43.375 C 8.40625 43.40625 8.421875 43.4375 8.453125 43.46875 C 8.46875 43.5 8.46875 43.5 8.484375 43.515625 L 8.539062 43.546875 L 8.59375 43.59375 C 8.59375 43.59375 8.59375 43.59375 8.609375 43.59375 C 8.640625 43.625 8.703125 43.671875 8.75 43.6875 C 8.765625 43.6875 8.765625 43.6875 8.78125 43.703125 C 8.8125 43.703125 8.84375 43.71875 8.890625 43.734375 L 8.9375 43.734375 L 9.015625 43.746094 L 9.09375 43.75 C 9.140625 43.75 9.1875 43.75 9.234375 43.734375 Z M 27.21875 43.75 C 27.671875 43.75 28.078125 43.359375 28.078125 42.890625 C 28.078125 42.40625 27.671875 42.015625 27.21875 42.015625 L 22.984375 42.015625 L 22.984375 39.140625 L 26.625 39.140625 C 27.09375 39.140625 27.484375 38.75 27.484375 38.265625 C 27.484375 37.8125 27.09375 37.40625 26.625 37.40625 L 22.984375 37.40625 L 22.984375 34.546875 L 27.21875 34.546875 C 27.671875 34.546875 28.078125 34.15625 28.078125 33.671875 C 28.078125 33.1875 27.671875 32.8125 27.21875 32.8125 L 22.109375 32.8125 C 21.625 32.8125 21.25 33.1875 21.25 33.671875 L 21.25 42.890625 C 21.25 43.359375 21.625 43.75 22.109375 43.75 L 22.125 43.734375 C 22.125 43.734375 22.125 43.75 22.15625 43.75 Z M 33.578125 43.75 C 35.421875 43.75 36.921875 42.25 36.921875 40.390625 C 36.921875 39.203125 36.28125 38.15625 35.34375 37.5625 C 35.71875 37.0625 35.9375 36.453125 35.9375 35.78125 C 35.9375 34.140625 34.609375 32.8125 32.96875 32.8125 L 30.75 32.8125 C 30.28125 32.8125 29.890625 33.1875 29.890625 33.671875 L 29.890625 42.890625 C 29.890625 43.359375 30.28125 43.75 30.75 43.75 C 30.765625 43.75 30.765625 43.734375 30.796875 43.734375 C 30.796875 43.734375 30.796875 43.75 30.8125 43.75 Z M 32.96875 37.046875 L 31.625 37.046875 L 31.625 34.546875 L 32.96875 34.546875 C 33.65625 34.546875 34.203125 35.09375 34.203125 35.78125 C 34.203125 36.46875 33.65625 37.046875 32.96875 37.046875 Z M 33.578125 42.015625 L 31.625 42.015625 L 31.625 38.78125 L 33.578125 38.78125 C 34.46875 38.796875 35.1875 39.5 35.1875 40.390625 C 35.1875 41.296875 34.46875 42 33.578125 42.015625 Z M 40.03125 43.75 C 40.515625 43.75 40.90625 43.359375 40.90625 42.890625 L 40.90625 39.5 L 42.828125 39.5 C 44.6875 39.5 46.1875 38 46.1875 36.171875 C 46.1875 34.3125 44.6875 32.8125 42.828125 32.8125 L 40.03125 32.8125 C 39.5625 32.8125 39.171875 33.1875 39.171875 33.671875 L 39.171875 42.890625 C 39.171875 43.359375 39.5625 43.75 40.03125 43.75 Z M 42.828125 37.765625 L 40.90625 37.765625 L 40.90625 34.546875 L 42.828125 34.546875 C 43.734375 34.546875 44.4375 35.265625 44.453125 36.171875 C 44.4375 37.046875 43.734375 37.765625 42.828125 37.765625 Z M 42.828125 37.765625 "/>\n      </g>'},wmvIcon:{extension:".wmv",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.484375 43.734375 L 8.53125 43.734375 C 8.5625 43.71875 8.59375 43.703125 8.65625 43.703125 L 8.664062 43.6875 C 8.671875 43.6875 8.671875 43.6875 8.6875 43.6875 C 8.71875 43.671875 8.765625 43.625 8.8125 43.59375 L 8.84375 43.59375 C 8.875 43.5625 8.90625 43.53125 8.9375 43.515625 C 8.9375 43.5 8.953125 43.5 8.953125 43.46875 L 9.046875 43.375 C 9.046875 43.375 9.046875 43.359375 9.0625 43.359375 C 9.078125 43.328125 9.109375 43.265625 9.125 43.21875 L 11.171875 38.375 L 13.21875 43.21875 C 13.234375 43.265625 13.25 43.328125 13.28125 43.359375 C 13.28125 43.359375 13.28125 43.375 13.3125 43.375 L 13.375 43.46875 C 13.390625 43.5 13.390625 43.5 13.40625 43.515625 L 13.453125 43.546875 L 13.515625 43.59375 C 13.515625 43.59375 13.515625 43.59375 13.53125 43.59375 C 13.5625 43.625 13.609375 43.671875 13.671875 43.6875 C 13.6875 43.6875 13.6875 43.6875 13.703125 43.703125 C 13.734375 43.703125 13.765625 43.71875 13.8125 43.734375 L 13.859375 43.734375 L 13.929688 43.746094 L 14 43.75 C 14.0625 43.75 14.109375 43.75 14.15625 43.734375 L 14.1875 43.734375 C 14.234375 43.71875 14.28125 43.703125 14.3125 43.703125 C 14.3125 43.6875 14.328125 43.6875 14.328125 43.6875 L 14.34375 43.6875 C 14.40625 43.671875 14.4375 43.625 14.484375 43.59375 L 14.5 43.59375 C 14.53125 43.5625 14.578125 43.53125 14.609375 43.515625 C 14.609375 43.5 14.625 43.5 14.625 43.46875 C 14.65625 43.4375 14.6875 43.40625 14.703125 43.375 L 14.71875 43.359375 C 14.75 43.328125 14.78125 43.265625 14.796875 43.21875 L 18.625 34.109375 C 18.8125 33.6875 18.609375 33.171875 18.1875 33 C 17.734375 32.8125 17.234375 33.015625 17.046875 33.453125 L 14 40.6875 L 11.984375 35.890625 C 11.828125 35.546875 11.5 35.359375 11.171875 35.359375 C 10.828125 35.359375 10.5 35.546875 10.359375 35.890625 L 8.34375 40.6875 L 5.28125 33.453125 C 5.109375 33.015625 4.59375 32.8125 4.171875 33 C 3.71875 33.171875 3.53125 33.6875 3.703125 34.109375 L 7.546875 43.21875 C 7.578125 43.265625 7.59375 43.328125 7.625 43.359375 L 7.625 43.375 C 7.65625 43.40625 7.671875 43.4375 7.703125 43.46875 C 7.71875 43.5 7.71875 43.5 7.734375 43.515625 L 7.789062 43.546875 L 7.84375 43.59375 C 7.84375 43.59375 7.84375 43.59375 7.859375 43.59375 C 7.890625 43.625 7.953125 43.671875 8 43.6875 C 8.015625 43.6875 8.015625 43.6875 8.03125 43.703125 C 8.0625 43.703125 8.09375 43.71875 8.140625 43.734375 L 8.1875 43.734375 L 8.265625 43.746094 L 8.34375 43.75 C 8.390625 43.75 8.4375 43.75 8.484375 43.734375 Z M 29.03125 43.75 C 29.5 43.75 29.90625 43.359375 29.90625 42.890625 L 29.90625 33.671875 C 29.90625 33.269531 29.609375 32.9375 29.226562 32.839844 L 29.03125 32.8125 L 29.015625 32.8125 C 28.734375 32.8125 28.484375 32.9375 28.3125 33.171875 L 25.203125 37.484375 L 22.09375 33.171875 C 21.9375 32.9375 21.65625 32.8125 21.40625 32.8125 L 21.359375 32.8125 C 20.890625 32.8125 20.5 33.203125 20.5 33.671875 L 20.5 42.890625 C 20.5 43.359375 20.890625 43.75 21.359375 43.75 C 21.84375 43.75 22.234375 43.359375 22.234375 42.890625 L 22.234375 36.3125 L 24.46875 39.4375 C 24.640625 39.671875 24.90625 39.796875 25.1875 39.796875 L 25.21875 39.796875 C 25.5 39.796875 25.75 39.671875 25.921875 39.4375 L 28.171875 36.3125 L 28.171875 42.890625 C 28.171875 43.359375 28.546875 43.75 29.03125 43.75 Z M 37.015625 43.734375 L 37.0625 43.734375 C 37.09375 43.71875 37.125 43.703125 37.1875 43.703125 L 37.195312 43.6875 C 37.203125 43.6875 37.203125 43.6875 37.21875 43.6875 C 37.25 43.671875 37.296875 43.625 37.34375 43.59375 L 37.375 43.59375 C 37.40625 43.5625 37.4375 43.53125 37.46875 43.515625 C 37.46875 43.5 37.484375 43.5 37.484375 43.46875 L 37.578125 43.375 C 37.578125 43.375 37.578125 43.359375 37.59375 43.359375 C 37.609375 43.328125 37.640625 43.265625 37.65625 43.21875 L 39.703125 38.375 L 41.75 43.21875 C 41.765625 43.265625 41.78125 43.328125 41.8125 43.359375 C 41.8125 43.359375 41.8125 43.375 41.84375 43.375 L 41.90625 43.46875 C 41.921875 43.5 41.921875 43.5 41.9375 43.515625 L 41.984375 43.546875 L 42.046875 43.59375 C 42.046875 43.59375 42.046875 43.59375 42.0625 43.59375 C 42.09375 43.625 42.140625 43.671875 42.203125 43.6875 C 42.21875 43.6875 42.21875 43.6875 42.234375 43.703125 C 42.265625 43.703125 42.296875 43.71875 42.34375 43.734375 L 42.390625 43.734375 L 42.460938 43.746094 L 42.53125 43.75 C 42.59375 43.75 42.640625 43.75 42.6875 43.734375 L 42.71875 43.734375 C 42.765625 43.71875 42.8125 43.703125 42.84375 43.703125 C 42.84375 43.6875 42.859375 43.6875 42.859375 43.6875 L 42.875 43.6875 C 42.9375 43.671875 42.96875 43.625 43.015625 43.59375 L 43.03125 43.59375 C 43.0625 43.5625 43.109375 43.53125 43.140625 43.515625 C 43.140625 43.5 43.15625 43.5 43.15625 43.46875 C 43.1875 43.4375 43.21875 43.40625 43.234375 43.375 L 43.25 43.359375 C 43.28125 43.328125 43.3125 43.265625 43.328125 43.21875 L 47.15625 34.109375 C 47.34375 33.6875 47.140625 33.171875 46.71875 33 C 46.265625 32.8125 45.765625 33.015625 45.578125 33.453125 L 42.53125 40.6875 L 40.515625 35.890625 C 40.359375 35.546875 40.03125 35.359375 39.703125 35.359375 C 39.359375 35.359375 39.03125 35.546875 38.890625 35.890625 L 36.875 40.6875 L 33.8125 33.453125 C 33.640625 33.015625 33.125 32.8125 32.703125 33 C 32.25 33.171875 32.0625 33.6875 32.234375 34.109375 L 36.078125 43.21875 C 36.109375 43.265625 36.125 43.328125 36.15625 43.359375 L 36.15625 43.375 C 36.1875 43.40625 36.203125 43.4375 36.234375 43.46875 C 36.25 43.5 36.25 43.5 36.265625 43.515625 L 36.320312 43.546875 L 36.375 43.59375 C 36.375 43.59375 36.375 43.59375 36.390625 43.59375 C 36.421875 43.625 36.484375 43.671875 36.53125 43.6875 C 36.546875 43.6875 36.546875 43.6875 36.5625 43.703125 C 36.59375 43.703125 36.625 43.71875 36.671875 43.734375 L 36.71875 43.734375 L 36.796875 43.746094 L 36.875 43.75 C 36.921875 43.75 36.96875 43.75 37.015625 43.734375 Z M 37.015625 43.734375 "/>\n      </g>'},xlsIcon:{extension:".xls",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 17.21875 46.875 C 17.425781 46.875 17.632812 46.800781 17.820312 46.667969 C 18.289062 46.351562 18.363281 45.695312 18.042969 45.242188 L 14.480469 40.367188 L 18.042969 35.53125 C 18.363281 35.0625 18.289062 34.425781 17.820312 34.105469 C 17.351562 33.75 16.730469 33.84375 16.375 34.332031 L 13.226562 38.644531 L 10.054688 34.332031 C 9.738281 33.84375 9.082031 33.75 8.632812 34.105469 C 8.164062 34.425781 8.070312 35.0625 8.386719 35.53125 L 11.949219 40.367188 L 8.386719 45.242188 C 8.070312 45.695312 8.164062 46.351562 8.632812 46.667969 C 8.800781 46.800781 9.007812 46.875 9.230469 46.875 C 9.550781 46.875 9.851562 46.707031 10.054688 46.445312 L 13.226562 42.113281 L 16.375 46.445312 C 16.582031 46.707031 16.882812 46.875 17.21875 46.875 Z M 29.351562 46.875 C 29.894531 46.875 30.382812 46.40625 30.382812 45.84375 C 30.382812 45.261719 29.894531 44.792969 29.351562 44.792969 L 24.269531 44.792969 L 24.269531 34.78125 C 24.269531 34.21875 23.800781 33.75 23.21875 33.75 C 22.636719 33.75 22.1875 34.21875 22.1875 34.78125 L 22.1875 45.84375 C 22.1875 46.335938 22.53125 46.757812 23.007812 46.855469 L 23.222656 46.875 Z M 37.28125 46.855469 C 38.613281 46.855469 39.832031 46.460938 40.75 45.789062 C 41.6875 45.113281 42.363281 44.082031 42.363281 42.882812 C 42.363281 42.300781 42.195312 41.738281 41.914062 41.289062 C 41.480469 40.59375 40.804688 40.105469 40.039062 39.730469 C 39.289062 39.375 38.40625 39.132812 37.449219 38.945312 L 37.414062 38.945312 C 36.398438 38.757812 35.554688 38.457031 35.070312 38.117188 C 34.824219 37.949219 34.65625 37.78125 34.5625 37.632812 C 34.46875 37.480469 34.429688 37.332031 34.429688 37.105469 C 34.429688 36.710938 34.636719 36.300781 35.144531 35.925781 C 35.648438 35.550781 36.398438 35.289062 37.242188 35.289062 C 38.386719 35.289062 39.304688 35.851562 40.261719 36.488281 C 40.710938 36.789062 41.3125 36.65625 41.59375 36.207031 C 41.894531 35.773438 41.761719 35.175781 41.332031 34.875 C 40.375 34.257812 39.042969 33.375 37.242188 33.375 C 36.023438 33.375 34.882812 33.730469 34 34.367188 C 33.136719 35.007812 32.5 35.980469 32.5 37.105469 C 32.5 37.667969 32.648438 38.195312 32.929688 38.644531 C 33.34375 39.300781 33.960938 39.769531 34.675781 40.105469 C 35.386719 40.445312 36.210938 40.667969 37.09375 40.835938 L 37.132812 40.835938 C 38.238281 41.042969 39.15625 41.363281 39.699219 41.71875 C 39.980469 41.90625 40.148438 42.09375 40.261719 42.28125 C 40.375 42.46875 40.429688 42.636719 40.429688 42.882812 C 40.429688 43.351562 40.1875 43.820312 39.625 44.230469 C 39.0625 44.644531 38.21875 44.925781 37.28125 44.925781 C 35.949219 44.945312 34.523438 44.15625 33.699219 43.480469 C 33.289062 43.144531 32.667969 43.199219 32.332031 43.613281 C 32.011719 44.023438 32.070312 44.644531 32.480469 44.980469 C 33.550781 45.824219 35.257812 46.835938 37.28125 46.855469 Z M 37.28125 46.855469 "/>\n      </g>'},xlsxIcon:{extension:".xlsx",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 13.070312 43.75 C 13.242188 43.75 13.414062 43.6875 13.570312 43.578125 C 13.960938 43.3125 14.023438 42.765625 13.757812 42.390625 L 10.789062 38.328125 L 13.757812 34.296875 C 14.023438 33.90625 13.960938 33.375 13.570312 33.109375 C 13.179688 32.8125 12.664062 32.890625 12.367188 33.296875 L 9.742188 36.890625 L 7.101562 33.296875 C 6.835938 32.890625 6.289062 32.8125 5.914062 33.109375 C 5.523438 33.375 5.445312 33.90625 5.710938 34.296875 L 8.679688 38.328125 L 5.710938 42.390625 C 5.445312 42.765625 5.523438 43.3125 5.914062 43.578125 C 6.054688 43.6875 6.226562 43.75 6.414062 43.75 C 6.679688 43.75 6.929688 43.609375 7.101562 43.390625 L 9.742188 39.78125 L 12.367188 43.390625 C 12.539062 43.609375 12.789062 43.75 13.070312 43.75 Z M 23.179688 43.75 C 23.632812 43.75 24.039062 43.359375 24.039062 42.890625 C 24.039062 42.40625 23.632812 42.015625 23.179688 42.015625 L 18.945312 42.015625 L 18.945312 33.671875 C 18.945312 33.203125 18.554688 32.8125 18.070312 32.8125 C 17.585938 32.8125 17.210938 33.203125 17.210938 33.671875 L 17.210938 42.890625 C 17.210938 43.359375 17.585938 43.75 18.070312 43.75 Z M 29.789062 43.734375 C 30.898438 43.734375 31.914062 43.40625 32.679688 42.84375 C 33.460938 42.28125 34.023438 41.421875 34.023438 40.421875 C 34.023438 39.9375 33.882812 39.46875 33.648438 39.09375 C 33.289062 38.515625 32.726562 38.109375 32.085938 37.796875 C 31.460938 37.5 30.726562 37.296875 29.929688 37.140625 L 29.898438 37.140625 C 29.054688 36.984375 28.351562 36.734375 27.945312 36.453125 C 27.742188 36.3125 27.601562 36.171875 27.523438 36.046875 C 27.445312 35.921875 27.414062 35.796875 27.414062 35.609375 C 27.414062 35.28125 27.585938 34.9375 28.007812 34.625 C 28.429688 34.3125 29.054688 34.09375 29.757812 34.09375 C 30.710938 34.09375 31.476562 34.5625 32.273438 35.09375 C 32.648438 35.34375 33.148438 35.234375 33.382812 34.859375 C 33.632812 34.5 33.523438 34 33.164062 33.75 C 32.367188 33.234375 31.257812 32.5 29.757812 32.5 C 28.742188 32.5 27.789062 32.796875 27.054688 33.328125 C 26.335938 33.859375 25.804688 34.671875 25.804688 35.609375 C 25.804688 36.078125 25.929688 36.515625 26.164062 36.890625 C 26.507812 37.4375 27.023438 37.828125 27.617188 38.109375 C 28.210938 38.390625 28.898438 38.578125 29.632812 38.71875 L 29.664062 38.71875 C 30.585938 38.890625 31.351562 39.15625 31.804688 39.453125 C 32.039062 39.609375 32.179688 39.765625 32.273438 39.921875 C 32.367188 40.078125 32.414062 40.21875 32.414062 40.421875 C 32.414062 40.8125 32.210938 41.203125 31.742188 41.546875 C 31.273438 41.890625 30.570312 42.125 29.789062 42.125 C 28.679688 42.140625 27.492188 41.484375 26.804688 40.921875 C 26.460938 40.640625 25.945312 40.6875 25.664062 41.03125 C 25.398438 41.375 25.445312 41.890625 25.789062 42.171875 C 26.679688 42.875 28.101562 43.71875 29.789062 43.734375 Z M 43.179688 43.75 C 43.351562 43.75 43.523438 43.6875 43.679688 43.578125 C 44.070312 43.3125 44.132812 42.765625 43.867188 42.390625 L 40.898438 38.328125 L 43.867188 34.296875 C 44.132812 33.90625 44.070312 33.375 43.679688 33.109375 C 43.289062 32.8125 42.773438 32.890625 42.476562 33.296875 L 39.851562 36.890625 L 37.210938 33.296875 C 36.945312 32.890625 36.398438 32.8125 36.023438 33.109375 C 35.632812 33.375 35.554688 33.90625 35.820312 34.296875 L 38.789062 38.328125 L 35.820312 42.390625 C 35.554688 42.765625 35.632812 43.3125 36.023438 43.578125 C 36.164062 43.6875 36.335938 43.75 36.523438 43.75 C 36.789062 43.75 37.039062 43.609375 37.210938 43.390625 L 39.851562 39.78125 L 42.476562 43.390625 C 42.648438 43.609375 42.898438 43.75 43.179688 43.75 Z M 43.179688 43.75 "/>\n      </g>'},zipIcon:{extension:".zip",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 20.175781 46.875 C 20.855469 46.875 21.402344 46.351562 21.402344 45.671875 C 21.402344 44.992188 20.855469 44.445312 20.175781 44.445312 L 13.132812 44.445312 L 21.183594 33.488281 L 21.183594 33.445312 C 21.203125 33.421875 21.226562 33.378906 21.25 33.335938 C 21.269531 33.3125 21.269531 33.289062 21.292969 33.269531 C 21.3125 33.203125 21.3125 33.179688 21.335938 33.136719 C 21.335938 33.09375 21.378906 33.070312 21.378906 33.007812 C 21.378906 32.984375 21.378906 32.960938 21.402344 32.917969 L 21.402344 32.679688 C 21.402344 32.632812 21.402344 32.613281 21.378906 32.546875 C 21.378906 32.503906 21.378906 32.480469 21.335938 32.4375 C 21.335938 32.414062 21.3125 32.371094 21.3125 32.304688 C 21.292969 32.285156 21.269531 32.242188 21.269531 32.21875 C 21.25 32.195312 21.226562 32.152344 21.203125 32.109375 C 21.183594 32.066406 21.160156 32.042969 21.117188 32.023438 C 21.09375 32 21.074219 31.957031 21.050781 31.933594 C 21.03125 31.914062 21.007812 31.867188 20.964844 31.847656 C 20.941406 31.824219 20.941406 31.804688 20.898438 31.78125 L 20.875 31.78125 C 20.832031 31.757812 20.8125 31.738281 20.765625 31.714844 C 20.746094 31.695312 20.722656 31.648438 20.65625 31.648438 L 20.570312 31.605469 L 20.4375 31.585938 C 20.417969 31.585938 20.375 31.5625 20.351562 31.5625 L 10.75 31.5625 C 10.070312 31.5625 9.546875 32.085938 9.546875 32.765625 C 9.546875 33.421875 10.070312 33.992188 10.75 33.992188 L 17.8125 33.992188 L 9.785156 44.972656 L 9.765625 44.972656 C 9.742188 45.015625 9.71875 45.058594 9.699219 45.082031 C 9.699219 45.101562 9.675781 45.148438 9.632812 45.167969 C 9.632812 45.210938 9.609375 45.257812 9.609375 45.277344 C 9.589844 45.320312 9.589844 45.367188 9.566406 45.386719 L 9.566406 45.496094 C 9.546875 45.539062 9.546875 45.585938 9.546875 45.648438 L 9.546875 45.738281 C 9.546875 45.78125 9.566406 45.824219 9.566406 45.890625 C 9.566406 45.933594 9.589844 45.957031 9.589844 45.976562 L 9.632812 46.109375 C 9.632812 46.152344 9.675781 46.175781 9.699219 46.21875 C 9.699219 46.242188 9.71875 46.261719 9.742188 46.328125 C 9.765625 46.351562 9.785156 46.394531 9.808594 46.414062 C 9.828125 46.4375 9.851562 46.460938 9.894531 46.480469 L 9.9375 46.542969 L 9.984375 46.589844 C 10.003906 46.613281 10.027344 46.632812 10.046875 46.632812 L 10.046875 46.65625 C 10.070312 46.679688 10.09375 46.679688 10.136719 46.699219 C 10.179688 46.722656 10.222656 46.742188 10.246094 46.742188 C 10.265625 46.789062 10.289062 46.789062 10.3125 46.808594 C 10.375 46.808594 10.421875 46.832031 10.464844 46.832031 C 10.484375 46.851562 10.507812 46.851562 10.53125 46.851562 L 10.648438 46.871094 Z M 26.214844 46.875 C 26.871094 46.875 27.4375 46.351562 27.4375 45.671875 L 27.4375 32.765625 C 27.4375 32.085938 26.871094 31.5625 26.214844 31.5625 C 25.535156 31.5625 25.011719 32.085938 25.011719 32.765625 L 25.011719 45.671875 C 25.011719 46.351562 25.535156 46.875 26.214844 46.875 Z M 32.734375 46.875 C 33.410156 46.875 33.957031 46.328125 33.957031 45.671875 L 33.957031 40.925781 L 36.648438 40.925781 C 39.25 40.925781 41.351562 38.824219 41.351562 36.265625 C 41.351562 33.664062 39.25 31.5625 36.648438 31.5625 L 32.734375 31.5625 C 32.078125 31.5625 31.53125 32.085938 31.53125 32.765625 L 31.53125 45.671875 C 31.53125 46.328125 32.078125 46.875 32.734375 46.875 Z M 36.648438 38.496094 L 33.957031 38.496094 L 33.957031 33.992188 L 36.648438 33.992188 C 37.917969 33.992188 38.902344 34.996094 38.921875 36.265625 C 38.902344 37.492188 37.917969 38.496094 36.648438 38.496094 Z M 36.648438 38.496094 "/>\n      </g>'},docxIcon:{extension:".docx",path:'<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.789062 43.75 C 9.589844 43.75 10.988281 43.269531 11.984375 42.304688 C 12.980469 41.339844 13.476562 39.984375 13.476562 38.234375 C 13.476562 36.496094 12.980469 35.144531 11.984375 34.179688 C 10.988281 33.214844 9.589844 32.734375 7.789062 32.734375 L 4.695312 32.734375 C 4.394531 32.734375 4.15625 32.816406 3.984375 32.984375 C 3.8125 33.152344 3.726562 33.386719 3.726562 33.6875 L 3.726562 42.796875 C 3.726562 43.097656 3.8125 43.332031 3.984375 43.5 C 4.15625 43.667969 4.394531 43.75 4.695312 43.75 Z M 7.664062 42.109375 L 5.742188 42.109375 L 5.742188 34.375 L 7.664062 34.375 C 10.195312 34.375 11.460938 35.660156 11.460938 38.234375 C 11.460938 40.816406 10.195312 42.109375 7.664062 42.109375 Z M 20.414062 43.890625 C 21.476562 43.890625 22.402344 43.660156 23.1875 43.203125 C 23.972656 42.746094 24.582031 42.089844 25.007812 41.234375 C 25.433594 40.378906 25.648438 39.378906 25.648438 38.234375 C 25.648438 37.089844 25.4375 36.089844 25.015625 35.242188 C 24.59375 34.394531 23.988281 33.738281 23.203125 33.28125 C 22.417969 32.824219 21.488281 32.59375 20.414062 32.59375 C 19.339844 32.59375 18.410156 32.824219 17.617188 33.28125 C 16.824219 33.738281 16.21875 34.394531 15.796875 35.242188 C 15.375 36.089844 15.164062 37.089844 15.164062 38.234375 C 15.164062 39.378906 15.378906 40.378906 15.804688 41.234375 C 16.230469 42.089844 16.839844 42.746094 17.625 43.203125 C 18.410156 43.660156 19.339844 43.890625 20.414062 43.890625 Z M 20.414062 42.28125 C 19.394531 42.28125 18.597656 41.933594 18.03125 41.234375 C 17.464844 40.535156 17.179688 39.535156 17.179688 38.234375 C 17.179688 36.933594 17.464844 35.933594 18.03125 35.242188 C 18.597656 34.550781 19.394531 34.203125 20.414062 34.203125 C 21.425781 34.203125 22.214844 34.550781 22.78125 35.242188 C 23.347656 35.933594 23.632812 36.933594 23.632812 38.234375 C 23.632812 39.535156 23.347656 40.535156 22.78125 41.234375 C 22.214844 41.933594 21.425781 42.28125 20.414062 42.28125 Z M 32.601562 43.890625 C 33.289062 43.890625 33.933594 43.789062 34.539062 43.585938 C 35.144531 43.382812 35.679688 43.089844 36.148438 42.703125 C 36.285156 42.597656 36.378906 42.488281 36.429688 42.367188 C 36.480469 42.246094 36.507812 42.109375 36.507812 41.953125 C 36.507812 41.722656 36.445312 41.53125 36.320312 41.375 C 36.195312 41.21875 36.042969 41.140625 35.867188 41.140625 C 35.753906 41.140625 35.644531 41.160156 35.539062 41.203125 C 35.433594 41.246094 35.332031 41.296875 35.226562 41.359375 C 34.746094 41.683594 34.316406 41.910156 33.9375 42.046875 C 33.558594 42.183594 33.144531 42.25 32.695312 42.25 C 31.613281 42.25 30.792969 41.910156 30.234375 41.234375 C 29.675781 40.558594 29.398438 39.558594 29.398438 38.234375 C 29.398438 36.921875 29.675781 35.925781 30.234375 35.25 C 30.792969 34.574219 31.613281 34.234375 32.695312 34.234375 C 33.164062 34.234375 33.589844 34.300781 33.976562 34.429688 C 34.363281 34.558594 34.777344 34.792969 35.226562 35.125 C 35.445312 35.269531 35.660156 35.34375 35.867188 35.34375 C 36.042969 35.34375 36.195312 35.265625 36.320312 35.109375 C 36.445312 34.953125 36.507812 34.761719 36.507812 34.53125 C 36.507812 34.363281 36.480469 34.222656 36.429688 34.109375 C 36.378906 33.996094 36.285156 33.886719 36.148438 33.78125 C 35.679688 33.394531 35.144531 33.101562 34.539062 32.898438 C 33.933594 32.695312 33.289062 32.59375 32.601562 32.59375 C 31.539062 32.59375 30.609375 32.824219 29.8125 33.28125 C 29.015625 33.738281 28.402344 34.394531 27.976562 35.242188 C 27.550781 36.089844 27.335938 37.089844 27.335938 38.234375 C 27.335938 39.378906 27.550781 40.378906 27.976562 41.234375 C 28.402344 42.089844 29.015625 42.746094 29.8125 43.203125 C 30.609375 43.660156 31.539062 43.890625 32.601562 43.890625 Z M 46.132812 43.84375 C 46.382812 43.84375 46.605469 43.75 46.796875 43.5625 C 46.988281 43.375 47.085938 43.15625 47.085938 42.90625 C 47.085938 42.707031 47.003906 42.511719 46.835938 42.3125 L 43.445312 38.15625 L 46.710938 34.171875 C 46.867188 34.003906 46.945312 33.808594 46.945312 33.578125 C 46.945312 33.328125 46.847656 33.113281 46.65625 32.929688 C 46.464844 32.746094 46.242188 32.65625 45.992188 32.65625 C 45.730469 32.65625 45.507812 32.769531 45.320312 33 L 42.273438 36.765625 L 39.226562 33 C 39.027344 32.769531 38.800781 32.65625 38.539062 32.65625 C 38.289062 32.65625 38.070312 32.746094 37.882812 32.929688 C 37.695312 33.113281 37.601562 33.328125 37.601562 33.578125 C 37.601562 33.808594 37.679688 34.003906 37.835938 34.171875 L 41.101562 38.15625 L 37.695312 42.3125 C 37.539062 42.5 37.460938 42.699219 37.460938 42.90625 C 37.460938 43.15625 37.558594 43.371094 37.75 43.554688 C 37.941406 43.738281 38.164062 43.828125 38.414062 43.828125 C 38.675781 43.828125 38.898438 43.71875 39.085938 43.5 L 42.273438 39.5625 L 45.445312 43.5 C 45.644531 43.730469 45.871094 43.84375 46.132812 43.84375 Z M 46.132812 43.84375 "/>\n      </g>'},jpgIcon:{extension:".jpg",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.789062 47.007812 L 9.488281 46.960938 C 12.214844 46.757812 13.578125 45.277344 13.578125 42.523438 L 13.578125 32.742188 C 13.578125 32.320312 13.453125 31.980469 13.195312 31.726562 C 12.941406 31.472656 12.59375 31.34375 12.15625 31.34375 C 11.734375 31.34375 11.394531 31.472656 11.140625 31.726562 C 10.886719 31.980469 10.757812 32.320312 10.757812 32.742188 L 10.757812 42.523438 C 10.757812 43.238281 10.605469 43.769531 10.296875 44.117188 C 9.992188 44.46875 9.539062 44.660156 8.941406 44.6875 L 8.242188 44.730469 C 7.847656 44.761719 7.558594 44.867188 7.378906 45.046875 C 7.195312 45.230469 7.105469 45.496094 7.105469 45.847656 C 7.105469 46.664062 7.667969 47.050781 8.789062 47.007812 Z M 18.304688 47.007812 C 18.742188 47.007812 19.089844 46.878906 19.34375 46.625 C 19.597656 46.367188 19.726562 46.023438 19.726562 45.585938 L 19.726562 40.882812 L 23.640625 40.882812 C 25.289062 40.882812 26.574219 40.464844 27.492188 39.632812 C 28.410156 38.804688 28.871094 37.644531 28.871094 36.15625 C 28.871094 34.667969 28.410156 33.511719 27.492188 32.6875 C 26.574219 31.863281 25.289062 31.453125 23.640625 31.453125 L 18.261719 31.453125 C 17.839844 31.453125 17.507812 31.570312 17.265625 31.804688 C 17.023438 32.035156 16.90625 32.363281 16.90625 32.789062 L 16.90625 45.585938 C 16.90625 46.023438 17.03125 46.367188 17.289062 46.625 C 17.542969 46.878906 17.882812 47.007812 18.304688 47.007812 Z M 23.292969 38.714844 L 19.726562 38.714844 L 19.726562 33.640625 L 23.292969 33.640625 C 25.230469 33.640625 26.203125 34.488281 26.203125 36.179688 C 26.203125 37.871094 25.230469 38.714844 23.292969 38.714844 Z M 38.605469 47.070312 C 39.320312 47.070312 40.0625 47.011719 40.835938 46.898438 C 41.609375 46.78125 42.285156 46.621094 42.871094 46.414062 C 43.410156 46.242188 43.765625 46.015625 43.941406 45.738281 C 44.117188 45.460938 44.203125 44.988281 44.203125 44.316406 L 44.203125 39.613281 C 44.203125 39.292969 44.101562 39.03125 43.898438 38.835938 C 43.695312 38.640625 43.425781 38.539062 43.089844 38.539062 L 39.21875 38.539062 C 38.867188 38.539062 38.59375 38.628906 38.398438 38.804688 C 38.199219 38.976562 38.101562 39.226562 38.101562 39.546875 C 38.101562 39.867188 38.199219 40.117188 38.398438 40.289062 C 38.59375 40.464844 38.867188 40.554688 39.21875 40.554688 L 41.6875 40.554688 L 41.6875 44.425781 C 40.699219 44.703125 39.707031 44.839844 38.714844 44.839844 C 35.390625 44.839844 33.726562 42.945312 33.726562 39.152344 C 33.726562 37.300781 34.132812 35.90625 34.941406 34.964844 C 35.75 34.023438 36.949219 33.554688 38.539062 33.554688 C 39.238281 33.554688 39.867188 33.644531 40.421875 33.828125 C 40.972656 34.007812 41.574219 34.324219 42.214844 34.777344 C 42.390625 34.894531 42.542969 34.980469 42.671875 35.03125 C 42.804688 35.082031 42.949219 35.105469 43.109375 35.105469 C 43.359375 35.105469 43.570312 34.996094 43.746094 34.777344 C 43.921875 34.558594 44.007812 34.289062 44.007812 33.96875 C 44.007812 33.75 43.96875 33.558594 43.886719 33.398438 C 43.808594 33.238281 43.679688 33.078125 43.503906 32.917969 C 42.191406 31.808594 40.507812 31.257812 38.453125 31.257812 C 36.90625 31.257812 35.5625 31.574219 34.425781 32.207031 C 33.289062 32.84375 32.410156 33.753906 31.789062 34.941406 C 31.171875 36.128906 30.859375 37.535156 30.859375 39.152344 C 30.859375 40.800781 31.171875 42.21875 31.789062 43.40625 C 32.410156 44.597656 33.304688 45.503906 34.46875 46.132812 C 35.636719 46.757812 37.015625 47.070312 38.605469 47.070312 Z M 38.605469 47.070312 "/>\n      </g>'},mp3Icon:{extension:".mp3",path:'<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 43.828125 43.710938 C 43.605469 44.28125 43.273438 44.804688 42.84375 45.265625 C 42.40625 45.730469 41.867188 46.113281 41.242188 46.398438 C 40.597656 46.699219 39.851562 46.855469 39.027344 46.855469 C 38.328125 46.855469 37.703125 46.757812 37.160156 46.570312 C 36.609375 46.378906 36.160156 46.136719 35.769531 45.839844 C 35.386719 45.550781 35.050781 45.210938 34.796875 44.832031 C 34.570312 44.507812 34.394531 44.195312 34.265625 43.890625 C 34.140625 43.59375 34.054688 43.335938 33.996094 43.101562 C 33.792969 42.261719 34.304688 41.417969 35.140625 41.210938 C 35.980469 41.007812 36.828125 41.519531 37.03125 42.355469 C 37.039062 42.390625 37.066406 42.488281 37.144531 42.671875 C 37.191406 42.777344 37.265625 42.914062 37.371094 43.0625 C 37.4375 43.160156 37.53125 43.257812 37.65625 43.351562 C 37.792969 43.453125 37.972656 43.542969 38.195312 43.625 C 38.332031 43.667969 38.59375 43.730469 39.027344 43.730469 C 39.390625 43.730469 39.695312 43.675781 39.925781 43.566406 C 40.1875 43.445312 40.398438 43.300781 40.558594 43.132812 C 40.71875 42.957031 40.839844 42.773438 40.914062 42.578125 C 40.996094 42.371094 41.03125 42.195312 41.03125 42.023438 C 41.03125 41.789062 41 41.585938 40.921875 41.398438 C 40.871094 41.257812 40.785156 41.148438 40.660156 41.039062 C 40.515625 40.910156 40.296875 40.792969 40.011719 40.699219 C 39.6875 40.59375 39.253906 40.539062 38.738281 40.535156 C 37.882812 40.527344 37.1875 39.832031 37.1875 38.972656 L 37.1875 38.832031 C 37.1875 37.984375 37.859375 37.292969 38.699219 37.265625 C 39.070312 37.257812 39.398438 37.195312 39.679688 37.101562 C 39.921875 37.011719 40.121094 36.902344 40.273438 36.773438 C 40.40625 36.652344 40.507812 36.519531 40.582031 36.359375 C 40.652344 36.210938 40.6875 36.027344 40.6875 35.8125 C 40.6875 35.523438 40.644531 35.289062 40.574219 35.125 C 40.5 34.96875 40.414062 34.847656 40.304688 34.757812 C 40.1875 34.660156 40.042969 34.582031 39.867188 34.53125 C 39.402344 34.386719 38.878906 34.398438 38.480469 34.542969 C 38.289062 34.617188 38.121094 34.714844 37.976562 34.84375 C 37.820312 34.984375 37.695312 35.148438 37.59375 35.339844 C 37.484375 35.550781 37.40625 35.773438 37.367188 36.039062 C 37.230469 36.890625 36.429688 37.472656 35.574219 37.335938 C 34.722656 37.195312 34.140625 36.398438 34.28125 35.542969 C 34.378906 34.9375 34.5625 34.378906 34.835938 33.871094 C 35.109375 33.355469 35.464844 32.898438 35.890625 32.519531 C 36.320312 32.132812 36.824219 31.828125 37.382812 31.617188 C 38.433594 31.226562 39.667969 31.199219 40.78125 31.539062 C 41.351562 31.714844 41.863281 31.992188 42.308594 32.355469 C 42.777344 32.753906 43.148438 33.242188 43.414062 33.824219 C 43.679688 34.402344 43.8125 35.070312 43.8125 35.8125 C 43.8125 36.476562 43.679688 37.097656 43.421875 37.660156 C 43.25 38.046875 43.023438 38.394531 42.746094 38.707031 C 43.242188 39.148438 43.609375 39.671875 43.835938 40.261719 C 44.046875 40.804688 44.15625 41.398438 44.15625 42.023438 C 44.15625 42.578125 44.046875 43.148438 43.828125 43.710938 Z M 31.445312 38.492188 C 31.148438 39.140625 30.734375 39.703125 30.199219 40.164062 C 29.6875 40.605469 29.078125 40.957031 28.390625 41.199219 C 27.71875 41.4375 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.859375 24.296875 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.859375 21.875 45 L 21.875 32.8125 C 21.875 31.945312 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.667969 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.03125 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.28125 L 14.015625 43.140625 C 14.007812 43.164062 13.996094 43.191406 13.984375 43.214844 C 13.71875 43.777344 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.9375 44.117188 11.375 43.777344 11.109375 43.214844 L 11.082031 43.160156 L 9.339844 39.101562 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.1875 L 12.527344 39.09375 L 15.59375 32.207031 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.167969 31.261719 C 18.03125 31.261719 18.730469 31.960938 18.730469 32.824219 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.136719 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.136719 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 28.257812 34.902344 C 27.835938 34.550781 27.140625 34.375 26.191406 34.375 L 25 34.375 L 25 38.4375 L 26.191406 38.4375 C 26.621094 38.4375 27.007812 38.375 27.34375 38.253906 C 27.667969 38.140625 27.929688 37.992188 28.148438 37.804688 C 28.34375 37.632812 28.492188 37.4375 28.601562 37.195312 C 28.710938 36.964844 28.757812 36.703125 28.757812 36.40625 C 28.757812 35.324219 28.382812 35.003906 28.257812 34.902344 "/>\n      <path style="fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;" d="M 11.34125 13.57875 C 11.345 13.5925 11.3525 13.62375 11.36375 13.67375 C 11.3775 13.7225 11.3975 13.78125 11.42625 13.85 C 11.45375 13.9175 11.49375 13.9875 11.54625 14.0625 C 11.5975 14.13875 11.66625 14.20875 11.75 14.27125 C 11.83375 14.33625 11.9375 14.38875 12.0575 14.43125 C 12.1775 14.4725 12.32 14.49375 12.4875 14.49375 C 12.67875 14.49375 12.845 14.46125 12.9875 14.39375 C 13.13 14.32875 13.24875 14.245 13.34375 14.1425 C 13.43875 14.0425 13.51125 13.93 13.55875 13.8075 C 13.6075 13.6825 13.63125 13.56375 13.63125 13.4475 C 13.63125 13.31125 13.6075 13.1825 13.5625 13.065 C 13.515 12.9475 13.4425 12.845 13.3425 12.7575 C 13.2425 12.67 13.115 12.6 12.96 12.55 C 12.805 12.49875 12.6175 12.4725 12.4 12.4725 L 12.4 12.42625 C 12.57 12.42 12.72375 12.3925 12.8625 12.34375 C 13.0025 12.29625 13.11875 12.2275 13.21625 12.14375 C 13.31375 12.05875 13.3875 11.96 13.44125 11.845 C 13.4925 11.7275 13.52 11.60125 13.52 11.46 C 13.52 11.29375 13.4925 11.1525 13.43875 11.0325 C 13.38375 10.91375 13.31125 10.81625 13.21875 10.74 C 13.1275 10.66375 13.0225 10.6075 12.90375 10.5725 C 12.78625 10.535 12.66375 10.5175 12.5375 10.5175 C 12.395 10.5175 12.26125 10.54 12.14 10.58625 C 12.0175 10.6325 11.91 10.69625 11.81875 10.77875 C 11.72625 10.8625 11.64875 10.96 11.5875 11.07375 C 11.5275 11.18875 11.48625 11.315 11.4625 11.45375 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.475 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 " transform="matrix(3.125,0,0,3.125,0,0)"/>\n      </g>'},mp4Icon:{extension:".mp4",path:'<g id="surface6" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 36.898438 40.625 L 40.625 35.480469 L 40.625 40.625 Z M 28.761719 36.40625 C 28.761719 36.703125 28.707031 36.964844 28.605469 37.195312 C 28.496094 37.433594 28.347656 37.632812 28.148438 37.804688 C 27.929688 37.992188 27.667969 38.144531 27.34375 38.257812 C 27.003906 38.375 26.621094 38.4375 26.191406 38.4375 L 25 38.4375 L 25 34.375 L 26.191406 34.375 C 27.140625 34.375 27.835938 34.554688 28.253906 34.902344 C 28.378906 35.007812 28.761719 35.324219 28.761719 36.40625 Z M 44.6875 43.75 L 43.75 43.75 L 43.75 45.3125 C 43.75 46.175781 43.050781 46.875 42.1875 46.875 C 41.324219 46.875 40.625 46.175781 40.625 45.3125 L 40.625 43.75 L 34.066406 43.75 C 33.199219 43.75 32.503906 43.050781 32.503906 42.1875 L 32.503906 41.875 C 32.503906 41.546875 32.605469 41.226562 32.800781 40.957031 L 39.363281 31.898438 C 39.660156 31.492188 40.128906 31.25 40.628906 31.25 L 42.1875 31.25 C 43.050781 31.25 43.75 31.949219 43.75 32.8125 L 43.75 40.625 L 44.6875 40.625 C 45.550781 40.625 46.25 41.324219 46.25 42.1875 C 46.25 43.050781 45.550781 43.75 44.6875 43.75 Z M 31.445312 38.492188 C 31.148438 39.140625 30.730469 39.703125 30.195312 40.167969 C 29.6875 40.605469 29.082031 40.957031 28.390625 41.203125 C 27.71875 41.441406 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.863281 24.300781 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.863281 21.875 45 L 21.875 32.8125 C 21.875 31.949219 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.671875 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.027344 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.6875 L 14.035156 43.105469 C 14.019531 43.144531 14.003906 43.179688 13.984375 43.214844 C 13.71875 43.78125 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.941406 44.117188 11.378906 43.78125 11.113281 43.214844 C 11.097656 43.183594 11.078125 43.152344 11.066406 43.125 L 9.339844 39.484375 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.191406 L 9.355469 32.226562 L 12.523438 38.90625 L 15.578125 32.242188 C 15.585938 32.226562 15.597656 32.210938 15.605469 32.191406 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.164062 31.261719 C 18.027344 31.261719 18.726562 31.960938 18.726562 32.824219 L 18.726562 45.210938 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface6" mask="url(#mask0)"/>\n      <path style="fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;" d="M 14.3 13.5 L 10.90125 13.5 L 10.90125 13.4 L 13.00125 10.5 L 13.5 10.5 L 13.5 14.5 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.47625 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 " transform="matrix(3.125,0,0,3.125,0,0)"/>\n      </g>'},oggIcon:{extension:".ogg",path:'<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.976562 47.070312 C 10.464844 47.070312 11.757812 46.75 12.859375 46.109375 C 13.960938 45.46875 14.808594 44.550781 15.40625 43.351562 C 16.003906 42.15625 16.304688 40.757812 16.304688 39.152344 C 16.304688 37.550781 16.007812 36.152344 15.417969 34.964844 C 14.828125 33.777344 13.980469 32.859375 12.882812 32.21875 C 11.78125 31.578125 10.480469 31.257812 8.976562 31.257812 C 7.472656 31.257812 6.167969 31.578125 5.0625 32.21875 C 3.953125 32.859375 3.101562 33.777344 2.511719 34.964844 C 1.921875 36.152344 1.625 37.550781 1.625 39.152344 C 1.625 40.757812 1.925781 42.15625 2.523438 43.351562 C 3.121094 44.550781 3.972656 45.46875 5.070312 46.109375 C 6.171875 46.75 7.472656 47.070312 8.976562 47.070312 Z M 8.976562 44.820312 C 7.546875 44.820312 6.433594 44.332031 5.640625 43.351562 C 4.847656 42.375 4.449219 40.976562 4.449219 39.152344 C 4.449219 37.332031 4.847656 35.933594 5.640625 34.964844 C 6.433594 33.996094 7.546875 33.507812 8.976562 33.507812 C 10.390625 33.507812 11.496094 33.996094 12.289062 34.964844 C 13.085938 35.933594 13.484375 37.332031 13.484375 39.152344 C 13.484375 40.976562 13.085938 42.375 12.289062 43.351562 C 11.496094 44.332031 10.390625 44.820312 8.976562 44.820312 Z M 26.410156 47.070312 C 27.125 47.070312 27.871094 47.011719 28.640625 46.898438 C 29.414062 46.78125 30.09375 46.621094 30.675781 46.414062 C 31.214844 46.242188 31.574219 46.015625 31.75 45.738281 C 31.921875 45.460938 32.011719 44.988281 32.011719 44.316406 L 32.011719 39.613281 C 32.011719 39.292969 31.910156 39.03125 31.703125 38.835938 C 31.5 38.640625 31.230469 38.539062 30.894531 38.539062 L 27.023438 38.539062 C 26.671875 38.539062 26.398438 38.628906 26.203125 38.804688 C 26.007812 38.976562 25.90625 39.226562 25.90625 39.546875 C 25.90625 39.867188 26.007812 40.117188 26.203125 40.289062 C 26.398438 40.464844 26.671875 40.554688 27.023438 40.554688 L 29.496094 40.554688 L 29.496094 44.425781 C 28.503906 44.703125 27.511719 44.839844 26.519531 44.839844 C 23.195312 44.839844 21.53125 42.945312 21.53125 39.152344 C 21.53125 37.300781 21.9375 35.90625 22.746094 34.964844 C 23.554688 34.023438 24.753906 33.554688 26.34375 33.554688 C 27.046875 33.554688 27.671875 33.644531 28.226562 33.828125 C 28.78125 34.007812 29.378906 34.324219 30.019531 34.777344 C 30.195312 34.894531 30.347656 34.980469 30.480469 35.03125 C 30.609375 35.082031 30.757812 35.105469 30.917969 35.105469 C 31.164062 35.105469 31.375 34.996094 31.550781 34.777344 C 31.726562 34.558594 31.8125 34.289062 31.8125 33.96875 C 31.8125 33.75 31.773438 33.558594 31.695312 33.398438 C 31.613281 33.238281 31.484375 33.078125 31.3125 32.917969 C 30 31.808594 28.3125 31.257812 26.257812 31.257812 C 24.710938 31.257812 23.371094 31.574219 22.234375 32.207031 C 21.09375 32.84375 20.214844 33.753906 19.597656 34.941406 C 18.976562 36.128906 18.667969 37.535156 18.667969 39.152344 C 18.667969 40.800781 18.976562 42.21875 19.597656 43.40625 C 20.214844 44.597656 21.109375 45.503906 22.277344 46.132812 C 23.441406 46.757812 24.820312 47.070312 26.410156 47.070312 Z M 42.445312 47.070312 C 43.160156 47.070312 43.902344 47.011719 44.675781 46.898438 C 45.449219 46.78125 46.128906 46.621094 46.710938 46.414062 C 47.25 46.242188 47.609375 46.015625 47.78125 45.738281 C 47.957031 45.460938 48.046875 44.988281 48.046875 44.316406 L 48.046875 39.613281 C 48.046875 39.292969 47.941406 39.03125 47.738281 38.835938 C 47.535156 38.640625 47.265625 38.539062 46.929688 38.539062 L 43.058594 38.539062 C 42.707031 38.539062 42.433594 38.628906 42.238281 38.804688 C 42.039062 38.976562 41.941406 39.226562 41.941406 39.546875 C 41.941406 39.867188 42.039062 40.117188 42.238281 40.289062 C 42.433594 40.464844 42.707031 40.554688 43.058594 40.554688 L 45.53125 40.554688 L 45.53125 44.425781 C 44.539062 44.703125 43.546875 44.839844 42.554688 44.839844 C 39.230469 44.839844 37.566406 42.945312 37.566406 39.152344 C 37.566406 37.300781 37.972656 35.90625 38.78125 34.964844 C 39.589844 34.023438 40.789062 33.554688 42.378906 33.554688 C 43.078125 33.554688 43.707031 33.644531 44.261719 33.828125 C 44.816406 34.007812 45.414062 34.324219 46.054688 34.777344 C 46.230469 34.894531 46.382812 34.980469 46.515625 35.03125 C 46.644531 35.082031 46.792969 35.105469 46.953125 35.105469 C 47.199219 35.105469 47.410156 34.996094 47.585938 34.777344 C 47.761719 34.558594 47.847656 34.289062 47.847656 33.96875 C 47.847656 33.75 47.808594 33.558594 47.726562 33.398438 C 47.648438 33.238281 47.519531 33.078125 47.34375 32.917969 C 46.03125 31.808594 44.347656 31.257812 42.292969 31.257812 C 40.746094 31.257812 39.40625 31.574219 38.265625 32.207031 C 37.128906 32.84375 36.25 33.753906 35.632812 34.941406 C 35.011719 36.128906 34.703125 37.535156 34.703125 39.152344 C 34.703125 40.800781 35.011719 42.21875 35.632812 43.40625 C 36.25 44.597656 37.144531 45.503906 38.3125 46.132812 C 39.476562 46.757812 40.855469 47.070312 42.445312 47.070312 Z M 42.445312 47.070312 "/>\n      </g>'},pdfIcon:{extension:".pdf",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.59375 25 L 39.4375 25 C 41.476562 25.003906 43.484375 25.472656 45.3125 26.375 L 45.3125 15.375 C 45.347656 14.191406 44.867188 13.054688 44 12.25 L 34.625 2.875 C 33.875 2.003906 32.773438 1.523438 31.625 1.5625 L 6.625 1.5625 C 5.589844 1.5625 4.75 2.402344 4.75 3.4375 L 4.75 26.375 C 6.566406 25.480469 8.566406 25.007812 10.59375 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.71875 L 42.15625 12.5 L 34.53125 12.5 C 34.480469 12.511719 34.425781 12.511719 34.375 12.5 Z M 6.25 25.71875 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.300781 13.980469 32.316406 15.253906 33.75 15.625 C 33.957031 15.675781 34.167969 15.675781 34.375 15.625 L 43.75 15.625 L 43.75 25.71875 C 44.859375 26.09375 45.910156 26.621094 46.875 27.28125 L 46.875 15.375 C 46.964844 13.722656 46.3125 12.117188 45.09375 11 L 35.71875 1.625 C 34.648438 0.523438 33.160156 -0.0664062 31.625 0 L 6.625 0 C 5.703125 -0.015625 4.8125 0.339844 4.152344 0.984375 C 3.496094 1.632812 3.125 2.515625 3.125 3.4375 L 3.125 27.28125 C 4.09375 26.625 5.144531 26.101562 6.25 25.71875 Z M 6.25 25.71875 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.625 28.125 C 6.335938 28.117188 4.136719 29.023438 2.515625 30.640625 C 0.898438 32.261719 -0.0078125 34.460938 0 36.75 L 0 41.375 C 0 46.136719 3.863281 50 8.625 50 L 41.375 50 C 46.132812 49.984375 49.984375 46.132812 50 41.375 L 50 36.75 C 50 31.988281 46.136719 28.125 41.375 28.125 Z M 8.625 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 14.40625 41.78125 L 12.09375 41.78125 L 12.09375 45.84375 C 12.003906 46.351562 11.5625 46.726562 11.046875 46.726562 C 10.53125 46.726562 10.089844 46.351562 10 45.84375 L 10 34.78125 C 10 34.210938 10.460938 33.75 11.03125 33.75 L 14.40625 33.75 C 15.925781 33.617188 17.390625 34.351562 18.191406 35.648438 C 18.992188 36.945312 18.992188 38.585938 18.191406 39.882812 C 17.390625 41.179688 15.925781 41.914062 14.40625 41.78125 Z M 12.09375 39.6875 L 14.40625 39.6875 C 15.152344 39.78125 15.882812 39.4375 16.289062 38.804688 C 16.691406 38.171875 16.691406 37.359375 16.289062 36.726562 C 15.882812 36.09375 15.152344 35.75 14.40625 35.84375 L 12.09375 35.84375 Z M 12.09375 39.6875 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 20.3125 45.84375 L 20.3125 34.78125 C 20.3125 34.210938 20.773438 33.75 21.34375 33.75 L 23.5625 33.75 C 27.1875 33.75 30.125 36.6875 30.125 40.3125 C 30.125 43.9375 27.1875 46.875 23.5625 46.875 L 21.34375 46.875 C 20.773438 46.875 20.3125 46.414062 20.3125 45.84375 Z M 22.40625 44.78125 L 23.5625 44.78125 C 26.03125 44.78125 28.03125 42.78125 28.03125 40.3125 C 28.03125 37.84375 26.03125 35.84375 23.5625 35.84375 L 22.40625 35.84375 Z M 22.40625 44.78125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 33.1875 45.84375 L 33.1875 34.78125 C 33.183594 34.476562 33.3125 34.1875 33.542969 33.992188 C 33.769531 33.792969 34.074219 33.703125 34.375 33.75 L 40.625 33.75 C 41.132812 33.839844 41.507812 34.28125 41.507812 34.796875 C 41.507812 35.3125 41.132812 35.753906 40.625 35.84375 L 35.25 35.84375 L 35.25 39.28125 L 39.625 39.28125 C 40.195312 39.28125 40.65625 39.742188 40.65625 40.3125 C 40.65625 40.882812 40.195312 41.34375 39.625 41.34375 L 35.25 41.34375 L 35.25 45.84375 C 35.257812 46.359375 34.882812 46.796875 34.375 46.875 C 34.074219 46.921875 33.769531 46.832031 33.542969 46.632812 C 33.3125 46.4375 33.183594 46.148438 33.1875 45.84375 Z M 33.1875 45.84375 "/>\n      </g>'},defaultIcon:{extension:".default",path:'<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 3.117188 44.777344 C 1.394531 44.777344 0 43.386719 0 41.671875 L 0 3.484375 C 0 1.769531 1.394531 0.378906 3.117188 0.378906 L 25.792969 0.378906 C 27.164062 0.304688 28.5 0.808594 29.480469 1.765625 L 37.980469 10.230469 C 39.144531 11.242188 39.769531 12.730469 39.683594 14.265625 L 39.683594 41.671875 C 39.683594 43.386719 38.289062 44.777344 36.5625 44.777344 Z M 25.511719 3.203125 L 3.117188 3.203125 C 2.960938 3.203125 2.832031 3.328125 2.832031 3.484375 L 2.832031 41.671875 C 2.832031 41.828125 2.960938 41.957031 3.117188 41.957031 L 36.5625 41.957031 C 36.679688 41.949219 36.785156 41.867188 36.820312 41.757812 L 36.820312 14.492188 L 28.34375 14.492188 C 28.160156 14.539062 27.964844 14.539062 27.777344 14.492188 C 26.480469 14.15625 25.554688 13.007812 25.511719 11.671875 Z M 28.34375 4.640625 L 28.34375 11.671875 C 28.390625 11.683594 28.441406 11.683594 28.488281 11.671875 L 35.402344 11.671875 Z M 28.34375 4.640625 "/>\n      </g>'}},H.MODULES.modals=function(l){var a=l.$;l.shared.modals||(l.shared.modals={});var o,c=l.shared.modals;function e(){for(var e in c)if(Object.prototype.hasOwnProperty.call(c,e)){var t=c[e];t&&t.$modal&&t.$modal.removeData().remove()}o&&o.removeData().remove(),c={}}function s(e,t){if(c[e]){var n=c[e].$modal,r=n.data("instance")||l;r.events.enableBlur(),n.hide(),o.hide(),a(r.o_doc).find("body").first().removeClass("fr-prevent-scroll fr-mobile"),n.removeClass("fr-active"),t||(r.accessibility.restoreSelection(),r.events.trigger("modals.hide"))}}function n(e){var t;if("string"==typeof e){if(!c[e])return;t=c[e].$modal}else t=e;return t&&l.node.hasClass(t,"fr-active")&&l.core.sameInstance(t)||!1}return{_init:function t(){l.events.on("shared.destroy",e,!0)},get:function r(e){return c[e]},create:function d(n,e,t){if(e='<div class="fr-modal-head-line">'.concat(e,"</div>"),l.shared.$overlay||(l.shared.$overlay=a(l.doc.createElement("DIV")).addClass("fr-overlay"),a("body").first().append(l.shared.$overlay)),o=l.shared.$overlay,l.opts.theme&&o.addClass("".concat(l.opts.theme,"-theme")),!c[n]){var r=function i(e,t){var n='<div tabIndex="-1" class="fr-modal'.concat(l.opts.theme?" ".concat(l.opts.theme,"-theme"):"",'"><div class="fr-modal-wrapper">'),r='<button title="'.concat(l.language.translate("Cancel"),'" class="fr-command fr-btn fr-modal-close"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24"><path d="').concat(H.SVG.close,'"/></svg></button>');n+='<div class="fr-modal-head">'.concat(e).concat(r,"</div>"),n+='<div tabIndex="-1" class="fr-modal-body">'.concat(t,"</div>"),n+="</div></div>";var o=a(l.doc.createElement("DIV"));return o.html(n),o.find("> .fr-modal")}(e,t);c[n]={$modal:r,$head:r.find(".fr-modal-head"),$body:r.find(".fr-modal-body")},l.helpers.isMobile()||r.addClass("fr-desktop"),a("body").first().append(r),l.events.$on(r,"click",".fr-modal-close",function(){s(n)},!0),c[n].$body.css("margin-top",c[n].$head.outerHeight()),l.events.$on(r,"keydown",function(e){var t=e.which;return t===H.KEYCODE.ESC?(s(n),l.accessibility.focusModalButton(r),!1):!(!a(e.currentTarget).is("input[type=text], textarea")&&t!==H.KEYCODE.ARROW_UP&&t!==H.KEYCODE.ARROW_DOWN&&!l.keys.isBrowserAction(e)&&(e.preventDefault(),e.stopPropagation(),1))},!0),s(n,!0)}return c[n]},show:function i(e){if(c[e]){var t=c[e].$modal;t.data("instance",l),t.show(),o.show(),a(l.o_doc).find("body").first().addClass("fr-prevent-scroll"),l.helpers.isMobile()&&a(l.o_doc).find("body").first().addClass("fr-mobile"),t.addClass("fr-active"),l.accessibility.focusModal(t)}},hide:s,resize:function f(e){if(c[e]){var t=c[e],n=t.$modal,r=t.$body,o=l.o_win.innerHeight,i=n.find(".fr-modal-wrapper"),a=o-i.outerHeight(!0)+(i.height()-(r.outerHeight(!0)-r.height())),s="auto";a<r.get(0).scrollHeight&&(s=a),r.height(s)}},isVisible:n,areVisible:function p(e){for(var t in c)if(Object.prototype.hasOwnProperty.call(c,t)&&n(t)&&(void 0===e||c[t].$modal.data("instance")===e))return c[t].$modal;return!1}}},H.MODULES.position=function(y){var S=y.$;function o(){var e=y.selection.ranges(0),t=e.getBoundingClientRect();if(0===t.top&&0===t.left&&0===t.width||0===t.height){var n=!1,r=y.opts.toolbarInline&&e.startContainer&&e.startContainer.firstChild&&"BR"===e.startContainer.firstChild.tagName;0===y.$el.find(".fr-marker").length&&(r?S(e.startContainer.firstChild).after(H.MARKERS):y.selection.save(),n=!0);var o=y.$el.find(".fr-marker").first();o.css("display","inline"),o.css("line-height","");var i=o.offset(),a=o.outerHeight();o.css("display","none"),o.css("line-height",0),(t={}).left=i&&i.left,t.width=0,t.height=a,t.top=i&&i.top-(y.helpers.isMobile()&&!y.helpers.isIOS()||y.opts.iframe?0:y.helpers.scrollTop()),t.right=1,t.bottom=1,t.ok=!0,n&&(r?y.$el.find(".fr-marker").remove():y.selection.restore())}return t}function i(e,t,n,r){var o=n.data("container");if(!o||"BODY"===o.get(0).tagName&&"static"===o.css("position")||(e&&(e-=o.offset().left),t&&(t-=o.offset().top),"BODY"!==o.get(0).tagName?(e&&(e+=o.get(0).scrollLeft),t&&(t+=o.get(0).scrollTop)):"absolute"===o.css("position")&&(e&&(e+=o.position().left),t&&(t+=o.position().top))),y.opts.iframe&&o&&y.$tb&&o.get(0)!==y.$tb.get(0)){var i=y.helpers.getPX(y.$wp.find(".fr-iframe").css("padding-top")),a=y.helpers.getPX(y.$wp.find(".fr-iframe").css("padding-left"));e&&(e+=y.$iframe.offset().left+a),t&&(t+=y.$iframe.offset().top+i)}var s=function l(e,t){var n=e.outerWidth(!0);return t+n>y.$sc.get(0).clientWidth-10&&(t=y.$sc.get(0).clientWidth-n-10),t<0&&(t=10),t}(n,e);e&&n.css("left",s),t&&n.css("top",function c(e,t,n){var r=e.outerHeight(!0);if(!y.helpers.isMobile()&&y.$tb&&e.parent().get(0)!==y.$tb.get(0)){var o=e.parent().offset().top,i=t-r-(n||0);e.parent().get(0)===y.$sc.get(0)&&(o-=e.parent().position().top);var a=y.$sc.get(0).clientHeight;o+t+r>y.$sc.offset().top+a&&0<e.parent().offset().top+i&&0<i?i>y.$wp.scrollTop()&&(t=i,e.addClass("fr-above")):e.removeClass("fr-above")}return t}(n,t,r))}function a(e){var n=S(e),t=n.is(".fr-sticky-on"),r=n.data("sticky-top"),o=n.data("sticky-scheduled");if(void 0===r){n.data("sticky-top",0);var i=S('<div class="fr-sticky-dummy" style="height: '.concat(n.outerHeight(),'px;"></div>'));y.$box.prepend(i)}else y.$box.find(".fr-sticky-dummy").css("height",n.outerHeight());if(y.core.hasFocus()||0<y.$tb.findVisible("input:focus").length){var a=y.helpers.scrollTop(),s=Math.min(Math.max(a-y.$tb.parent().offset().top,0),y.$tb.parent().outerHeight()-n.outerHeight());if(s!==r&&s!==o&&(clearTimeout(n.data("sticky-timeout")),n.data("sticky-scheduled",s),n.outerHeight()<a-y.$tb.parent().offset().top&&n.addClass("fr-opacity-0"),n.data("sticky-timeout",setTimeout(function(){var e=y.helpers.scrollTop(),t=Math.min(Math.max(e-y.$tb.parent().offset().top,0),y.$tb.parent().outerHeight()-n.outerHeight());0<t&&"BODY"===y.$tb.parent().get(0).tagName&&(t+=y.$tb.parent().position().top),t!==r&&(n.css("top",Math.max(t,0)),n.data("sticky-top",t),n.data("sticky-scheduled",t)),n.removeClass("fr-opacity-0")},100))),!t){var l=y.$tb.parent(),c=l.get(0).offsetWidth-l.get(0).clientWidth;n.css("top","0"),n.width(l.width()-c),n.addClass("fr-sticky-on"),y.$box.addClass("fr-sticky-box")}}else clearTimeout(S(e).css("sticky-timeout")),n.css("top","0"),n.css("position",""),n.css("width",""),n.data("sticky-top",0),n.removeClass("fr-sticky-on"),y.$box.removeClass("fr-sticky-box")}function t(e){if(e.offsetWidth){var t=S(e),n=t.outerHeight(),r=t.data("sticky-position"),o=S("body"===y.opts.scrollableContainer?y.o_win:y.opts.scrollableContainer).outerHeight(),i=0,a=0;"body"!==y.opts.scrollableContainer&&(i=y.$sc.offset().top,a=S(y.o_win).outerHeight()-i-o);var s="body"===y.opts.scrollableContainer?y.helpers.scrollTop():i,l=t.is(".fr-sticky-on");t.data("sticky-parent")||t.data("sticky-parent",t.parent());var c=t.data("sticky-parent"),d=c.offset().top,f=c.outerHeight();if(t.data("sticky-offset")?y.$box.find(".fr-sticky-dummy").css("height","".concat(n,"px")):(t.data("sticky-offset",!0),t.after('<div class="fr-sticky-dummy" style="height: '.concat(n,'px;"></div>'))),!r){var p="auto"!==t.css("top")||"auto"!==t.css("bottom");p||t.css("position","fixed"),r={top:y.node.hasClass(t.get(0),"fr-top"),bottom:y.node.hasClass(t.get(0),"fr-bottom")},p||t.css("position",""),t.data("sticky-position",r),t.data("top",y.node.hasClass(t.get(0),"fr-top")?t.css("top"):"auto"),t.data("bottom",y.node.hasClass(t.get(0),"fr-bottom")?t.css("bottom"):"auto")}var u=y.helpers.getPX(t.data("top")),h=y.helpers.getPX(t.data("bottom")),g=r.top&&function L(){return d<s+u&&s+u<=d+f-n}(),C=r.bottom&&function E(){return d+n<s+o-h&&s+o-h<d+f}();if(g||C){var m=c.get(0).offsetWidth-c.get(0).clientWidth;if(t.css("width","".concat(c.get(0).getBoundingClientRect().width-m,"px")),l)"body"!==y.opts.scrollableContainer&&(t.css("top")&&"auto"!==t.data("top")&&t.css("top",y.helpers.getPX(t.data("top"))+i-window.scrollY),t.css("bottom")&&"auto"!==t.data("bottom")&&t.css("bottom",y.helpers.getPX(t.data("bottom"))+a+window.scrollY));else{if(t.addClass("fr-sticky-on"),t.removeClass("fr-sticky-off"),t.css("top"))if("auto"!==t.data("top")){var v="body"===y.opts.scrollableContainer?i:i-window.scrollY;t.css("top",y.helpers.getPX(t.data("top"))+v)}else t.data("top","auto");if(t.css("bottom"))if("auto"!==t.data("bottom")){var b="body"===y.opts.scrollableContainer?a:a+window.scrollY;t.css("bottom",y.helpers.getPX(t.data("bottom"))+b)}else t.css("bottom","auto")}}else y.node.hasClass(t.get(0),"fr-sticky-off")||(t.css("width",""),t.removeClass("fr-sticky-on"),t.addClass("fr-sticky-off"),t.css("top")&&"auto"!==t.data("top")&&r.top&&t.css("top",0),t.css("bottom")&&"auto"!==t.data("bottom")&&r.bottom&&t.css("bottom",0))}}function s(){if(y.helpers.requestAnimationFrame()(s),!1!==y.events.trigger("position.refresh"))for(var e=0;e<y._stickyElements.length;e++)if(y.opts.toolbarBottom){var t=y.$tb.parent(),n=t.get(0).offsetWidth-t.get(0).clientWidth,r=S(y._stickyElements[e]);r.width(t.width()-n),r.addClass("fr-sticky-on"),y.$box.addClass("fr-sticky-box")}else a(y._stickyElements[e])}function n(){if(y._stickyElements)for(var e=0;e<y._stickyElements.length;e++)t(y._stickyElements[e])}return{_init:function e(){!function t(){if(y._stickyElements=[],y.helpers.getIOSVersion()<=8)s(),y.events.$on(S(y.o_win),"scroll",function(){if(y.core.hasFocus())for(var e=0;e<y._stickyElements.length;e++){var t=S(y._stickyElements[e]),n=t.parent(),r=y.helpers.scrollTop();t.outerHeight()<r-n.offset().top&&(y.opts.toolbarBottom&&y.helpers.isIOS()||(t.addClass("fr-opacity-0"),t.data("sticky-top",-1),t.data("sticky-scheduled",-1)))}},!0);else{"body"!==y.opts.scrollableContainer&&y.events.$on(S(y.opts.scrollableContainer),"scroll",n,!0),y.events.$on(S(y.o_win),"scroll",n,!0),y.events.$on(S(y.o_win),"resize",n,!0),y.events.on("initialized",n),y.events.on("focus",n),y.events.$on(S(y.o_win),"resize","textarea",n,!0);var e=S(y.el).parents(".modal");e.get(0)&&y.events.$on(e,"scroll",n,!0)}y.events.on("destroy",function(){y._stickyElements=[]})}()},forSelection:function l(e){var t=o();if(t.top!=undefined){e.css({top:0,left:0});var n=t.top+t.height,r=t.left+t.width/2-e.get(0).offsetWidth/2+y.helpers.scrollLeft();y.opts.iframe||(n+=y.helpers.scrollTop()),i(r,n,e,t.height)}},addSticky:function r(e){e.addClass("fr-sticky"),y.helpers.isIOS()&&!y.opts.toolbarBottom&&e.addClass("fr-sticky-ios"),e.removeClass("fr-sticky"),y._stickyElements.push(e.get(0))},refresh:n,at:i,getBoundingRect:o}},H.MODULES.refresh=function(l){var c=l.$;function i(e,t){e.toggleClass("fr-disabled",t).attr("aria-disabled",t)}function e(e){var t=l.$tb.find('.fr-more-toolbar[data-name="'.concat(e.attr("data-group-name"),'"]')),n=function s(e,t){var n=0,r=t.find("> .fr-command, > .fr-btn-wrap");r.each(function(e,t){n+=c(t).outerWidth()});var o,i=l.helpers.getPX(c(r[0]).css("margin-left")),a=l.helpers.getPX(c(r[0]).css("margin-right"));o="rtl"===l.opts.direction?l.$tb.outerWidth()-e.offset().left+l.$tb.offset().left-(n+e.outerWidth()+r.length*(i+a))/2:e.offset().left-l.$tb.offset().left-(n-e.outerWidth()+r.length*(i+a))/2;o+n+r.length*(i+a)>l.$tb.outerWidth()&&(o-=(n+r.length*(i+a)-e.outerWidth())/2);o<0&&(o=0);return o}(e,t);"rtl"===l.opts.direction?t.css("padding-right",n):t.css("padding-left",n)}return{undo:function t(e){i(e,!l.undo.canDo())},redo:function n(e){i(e,!l.undo.canRedo())},outdent:function a(e){if(l.node.hasClass(e.get(0),"fr-no-refresh"))return!1;if(c("button#markdown-".concat(l.id,".fr-active")).length)return!1;for(var t=l.selection.blocks(),n=0;n<t.length;n++){var r="rtl"===l.opts.direction||"rtl"===c(t[n]).css("direction")?"margin-right":"margin-left",o=t[0].parentElement;if(["HTML","P","DIV","UL","OL","LI","TR","BLOCKQUOTE","BODY"].indexOf(o.parentNode.tagName)<0)return i(e,!0),!0;if(t[0].previousSibling&&"none"==o.parentNode.style.listStyleType)return i(e,!0),!0;if("LI"===t[n].tagName||"LI"===t[n].parentNode.tagName)return i(e,!1),!0;if(0<l.helpers.getPX(c(t[n]).css(r))+l.helpers.getPX(c(t[n]).css("text-indent")))return i(e,!1),!0}i(e,!0)},indent:function o(e){if(l.node.hasClass(e.get(0),"fr-no-refresh"))return!1;if(c("button#markdown-".concat(l.id,".fr-active")).length)return!1;for(var t=l.selection.blocks(),n=0;n<t.length;n++){for(var r=t[n].previousSibling;r&&r.nodeType===Node.TEXT_NODE&&0===r.textContent.length;)r=r.previousSibling;if("LI"!==t[n].tagName||r)return i(e,!1),!0;i(e,!0)}},moreText:e,moreParagraph:e,moreMisc:e,moreRich:e}},Object.assign(H.DEFAULTS,{attribution:!0,toolbarBottom:!1,toolbarButtons:null,toolbarButtonsXS:null,toolbarButtonsSM:null,toolbarButtonsMD:null,toolbarContainer:null,toolbarInline:!1,toolbarSticky:!0,toolbarStickyOffset:0,toolbarVisibleWithoutSelection:!1,toolbarResponsiveToEditor:!1}),H.TOOLBAR_BUTTONS={moreText:{buttons:["bold","italic","underline","strikeThrough","subscript","superscript","fontFamily","fontSize","textColor","backgroundColor","inlineClass","inlineStyle","clearFormatting"]},moreParagraph:{buttons:["alignLeft","alignCenter","formatOLSimple","alignRight","alignJustify","formatOL","formatUL","paragraphFormat","paragraphStyle","lineHeight","outdent","indent","quote"]},moreRich:{buttons:["trackChanges","markdown","insertLink","insertFiles","insertImage","insertVideo","insertTable","emoticons","fontAwesome","specialCharacters","embedly","insertFile","insertHR","openFilePicker"],buttonsVisible:4},moreMisc:{buttons:["undo","redo","fullscreen","print","getPDF","spellChecker","selectAll","html","help","findReplaceButton"],align:"right",buttonsVisible:2},trackChanges:{buttons:["showChanges","applyAll","removeAll","applyLast","removeLast"],buttonsVisible:0}},H.TOOLBAR_BUTTONS_MD=null,(H.TOOLBAR_BUTTONS_SM={}).moreText=Object.assign({},H.TOOLBAR_BUTTONS.moreText,{buttonsVisible:2}),H.TOOLBAR_BUTTONS_SM.moreParagraph=Object.assign({},H.TOOLBAR_BUTTONS.moreParagraph,{buttonsVisible:2}),H.TOOLBAR_BUTTONS_SM.moreRich=Object.assign({},H.TOOLBAR_BUTTONS.moreRich,{buttonsVisible:2}),H.TOOLBAR_BUTTONS_SM.moreMisc=Object.assign({},H.TOOLBAR_BUTTONS.moreMisc,{buttonsVisible:2}),H.TOOLBAR_BUTTONS_SM.trackChanges=Object.assign({},H.TOOLBAR_BUTTONS.trackChanges,{buttonsVisible:0}),(H.TOOLBAR_BUTTONS_XS={}).moreText=Object.assign({},H.TOOLBAR_BUTTONS.moreText,{buttonsVisible:0}),H.TOOLBAR_BUTTONS_XS.moreParagraph=Object.assign({},H.TOOLBAR_BUTTONS.moreParagraph,{buttonsVisible:0}),H.TOOLBAR_BUTTONS_XS.moreRich=Object.assign({},H.TOOLBAR_BUTTONS.moreRich,{buttonsVisible:0}),H.TOOLBAR_BUTTONS_XS.moreMisc=Object.assign({},H.TOOLBAR_BUTTONS.moreMisc,{buttonsVisible:2}),H.TOOLBAR_BUTTONS_XS.trackChanges=Object.assign({},H.TOOLBAR_BUTTONS.trackChanges,{buttonsVisible:0}),H.POWERED_BY='<a id="fr-logo" href="https://froala.com/wysiwyg-editor" target="_blank" title="Froala WYSIWYG HTML Editor"><span>Powered by</span><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 822.8 355.33"><defs><style>.fr-logo{fill:#b1b2b7;}</style></defs><title>Froala</title><path class="fr-logo" d="M123.58,78.65A16.16,16.16,0,0,0,111.13,73H16.6C7.6,73,0,80.78,0,89.94V128.3a16.45,16.45,0,0,0,32.9,0V104.14h78.5A15.63,15.63,0,0,0,126.87,91.2,15.14,15.14,0,0,0,123.58,78.65Z"/><path class="fr-logo" d="M103.54,170a16.05,16.05,0,0,0-11.44-4.85H15.79A15.81,15.81,0,0,0,0,180.93v88.69a16.88,16.88,0,0,0,5,11.92,16,16,0,0,0,11.35,4.7h.17a16.45,16.45,0,0,0,16.41-16.6v-73.4H92.2A15.61,15.61,0,0,0,107.89,181,15.1,15.1,0,0,0,103.54,170Z"/><path class="fr-logo" d="M233,144.17c-5.29-6.22-16-7.52-24.14-7.52-16.68,0-28.72,7.71-36.5,23.47v-5.67a16.15,16.15,0,1,0-32.3,0v115.5a16.15,16.15,0,1,0,32.3,0v-38.7c0-19.09,3.5-63.5,35.9-63.5a44.73,44.73,0,0,1,5.95.27h.12c12.79,1.2,20.06-2.73,21.6-11.69C236.76,151.48,235.78,147.39,233,144.17Z"/><path class="fr-logo" d="M371.83,157c-13.93-13.11-32.9-20.33-53.43-20.33S279,143.86,265.12,157c-14.67,13.88-22.42,32.82-22.42,54.77,0,21.68,8,41.28,22.4,55.2,13.92,13.41,32.85,20.8,53.3,20.8s39.44-7.38,53.44-20.79c14.55-13.94,22.56-33.54,22.56-55.21S386.39,170.67,371.83,157Zm-9.73,54.77c0,25.84-18.38,44.6-43.7,44.6s-43.7-18.76-43.7-44.6c0-25.15,18.38-43.4,43.7-43.4S362.1,186.59,362.1,211.74Z"/><path class="fr-logo" d="M552.7,138.14a16.17,16.17,0,0,0-16,16.3v1C526.41,143.85,509,136.64,490,136.64c-19.83,0-38.19,7.24-51.69,20.4C424,171,416.4,190,416.4,212c0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,552.7,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C513.73,168.34,536.4,183.55,536.4,211.74Z"/><path class="fr-logo" d="M623.5,61.94a16.17,16.17,0,0,0-16,16.3v191.7a16.15,16.15,0,1,0,32.3,0V78.24A16.32,16.32,0,0,0,623.5,61.94Z"/><path class="fr-logo" d="M806.5,138.14a16.17,16.17,0,0,0-16,16.3v1c-10.29-11.63-27.74-18.84-46.7-18.84-19.83,0-38.19,7.24-51.69,20.4-14.33,14-21.91,33-21.91,55,0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,806.5,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C767.53,168.34,790.2,183.55,790.2,211.74Z"/></svg></a>',H.MODULES.toolbar=function(E){var y=E.$;function e(e){if(-1<E.opts.pluginsEnabled.indexOf("filestack")&&E.opts.filestackOptions&&E.opts.filestackOptions.uploadToFilestackOnly){var t,n=JSON.parse(JSON.stringify(e)),r=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.includes("openFilePicker"),o=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.includes("insertFile"),i=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.includes("insertFiles");r?(-1!==(t=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.findIndex(function(e){return"insertFile"===e}))&&n.moreRich.buttons.splice(t,1),-1!==(t=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.findIndex(function(e){return"insertFiles"===e}))&&n.moreRich.buttons.splice(t,1)):o&&i&&-1!==(t=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.findIndex(function(e){return"insertFiles"===e}))&&n.moreRich.buttons.splice(t,1);var a=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.findIndex(function(e){return"insertImage"===e});-1<a&&null!==a&&(n.moreRich.buttons[a]="openFilePickerImageOnly");var s=n.moreRich&&n.moreRich.buttons&&n.moreRich.buttons.findIndex(function(e){return"insertVideo"===e});return-1<s&&null!==s&&(n.moreRich.buttons[s]="openFilePickerVideoOnly"),n}return e}var S,t=[];function n(e){var n={};if(Array.isArray(e)){if(!Array.isArray(e[0])){for(var t=[],r=[],o=0;o<e.length;o++)"|"===e[o]||"-"===e[o]?(0<r.length&&t.push(r),r=[]):r.push(e[o]);0<r.length&&t.push(r),e=t}e.forEach(function(e,t){n["group".concat(t+1)]={buttons:e}}),n.showMoreButtons=!1}else"object"!==x(e)||Array.isArray(e)||((n=e).showMoreButtons=!0);return n}function N(){var e=E.helpers.screenSize(E.opts.toolbarResponsiveToEditor);return t[S=e]}function T(){for(var d=E.$tb.find(".fr-more-toolbar"),f=function f(){var e=y(d[p]);if(e.hasClass("fr-expanded")){var n=E.helpers.getPX(e.css("padding-left")),t=e.find("> .fr-command, > .fr-btn-wrap"),r=y(t[0]),o=E.helpers.getPX(r.css("margin-left")),i=E.helpers.getPX(r.css("margin-right")),a=E.helpers.getPX(r.css("margin-top")),s=E.helpers.getPX(r.css("margin-bottom"));if(t.each(function(e,t){n+=y(t).outerWidth()+o+i}),E.$tb.outerWidth()<n){var l=Math.floor(n/E.$tb.outerWidth());n+=l*(n/e[0].childElementCount),l=Math.ceil(n/E.$tb.outerWidth());var c=(E.helpers.getPX(r.css("height"))+a+s)*l;e.css("height",c)}}else e.css("height","")},p=0;p<d.length;p++)f();!E.helpers.isMobile()&&E.opts.toolbarBottom?E.$tb.find(".fr-toolbar .fr-more-toolbar").removeClass("position-relative"):E.$tb.find(".fr-toolbar .fr-more-toolbar").addClass("position-relative")}function o(){if(0==E.$tb.find("[data-name='trackChanges-".concat(E.id,"']")).length&&-1<E.opts.pluginsEnabled.indexOf("track_changes")){E.$tb.append(y('<div class="fr-more-toolbar"></div>').data("name","trackChanges-".concat(E.id)));for(var e=0,t=["showChanges","applyAll","removeAll","applyLast","removeLast"];e<t.length;e++){var n=t[e],r=H.COMMANDS[n];if(r){r.more_btn=!0;var o=y(E.button.build(n,r,!0));E.button.addButtons(o),E.$tb.find("[data-name='trackChanges-".concat(E.id,"']")).append(o)}}}if(S!==E.helpers.screenSize(E.opts.toolbarResponsiveToEditor)){var i=N(),a=y(),s=y();for(var l in E.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").addClass("fr-hidden"),function L(){for(var e=E.$tb.find(".fr-btn-grp, .fr-more-toolbar"),t=function t(){var n=y(e[r]);n.children().each(function(e,t){n.before(t)}),n.remove()},r=0;r<e.length;r++)t()}(),E.$tb.find(".fr-separator.fr-vs, .fr-separator.fr-hs").remove(),i){var c=i[l];if(c.buttons&&("trackChanges"!==l||-1!==E.opts.pluginsEnabled.indexOf("track_changes"))){var d=void 0,f=0,p=3,u=void 0;"trackChanges"!==l&&(u=y('<div class="fr-btn-grp fr-float-'.concat(i[l].align?i[l].align:"left",'"></div>'))),i.showMoreButtons&&(d=y('<div class="fr-more-toolbar"></div>').data("name","".concat(l,"-").concat(E.id)),"trackChanges"!==l&&"moreRich"!==l||!E.opts.trackChangesEnabled||d.addClass("fr-expanded"));for(var h=0;h<c.buttons.length;h++){c.buttonsVisible!==undefined&&(p=c.buttonsVisible);var g=E.$tb.find('> .fr-command[data-cmd="'+c.buttons[h]+'"], > div.fr-btn-wrap > .fr-command[data-cmd="'+c.buttons[h]+'"]'),C=null;E.node.hasClass(g.next().get(0),"fr-dropdown-menu")&&(C=g.next()),E.node.hasClass(g.next().get(0),"fr-options")&&(g.removeClass("fr-hidden"),g.next().removeClass("fr-hidden"),g=g.parent()),g.removeClass("fr-hidden"),i.showMoreButtons&&p<=f?(d.append(g),C&&d.append(C)):(u.append(g),"|"===c.buttons[h]?u.append(y('<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>')):"-"===c.buttons[h]&&u.append(y('<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>')),C&&u.append(C)),f++}if(i.showMoreButtons&&p<f){var m=E.$tb.find('.fr-command[data-cmd="'.concat(l,'"]'));if(0<m.length)m.removeClass("fr-hidden fr-open");else{var v=l,b=H.COMMANDS[v];b&&(b.more_btn=!0,m=y(E.button.build(v,b,!0)),E.button.addButtons(m))}u&&u.append(m)}u&&a.push(u),i.showMoreButtons&&s.push(d)}}E.opts.toolbarBottom?(E.$tb.append(s),E.$tb.find(".fr-newline").remove(),E.$tb.append('<div class="fr-newline"></div>'),E.$tb.append(a)):(E.$tb.append(a),E.$tb.find(".fr-newline").remove(),E.$tb.append('<div class="fr-newline"></div>'),E.$tb.append(s)),E.$tb.removeClass("fr-toolbar-open"),E.$box.removeClass("fr-toolbar-open"),E.events.trigger("codeView.toggle")}T()}function r(t,n){setTimeout(function(){var e;E.opts.iframe?e=E.$iframe.get(0).contentWindow.document.activeElement:e=document.activeElement;if((!t||t.which!=H.KEYCODE.ESC)&&E.selection.inEditor()&&E.core.hasFocus()&&!E.popups.areVisible()&&"false"!=y(E.selection.blocks()[0]).closest("table").attr("contenteditable")&&"INPUT"!==e.tagName&&"TEXTAREA"!==e.tagName&&(E.opts.toolbarVisibleWithoutSelection||!E.selection.isCollapsed()&&!E.keys.isIME()||n)){if(E.$tb.data("instance",E),!1===E.events.trigger("toolbar.show",[t]))return;if(t&&E.helpers.isMobile()&&!function r(e,t){var n=e.target;for(;n;){if(n===t)return!0;n=n.parentElement}return!1}(t,E.$box))return;E.$tb.show(),E.opts.toolbarContainer||E.position.forSelection(E.$tb),1<E.opts.zIndex?E.$tb.css("z-index",E.opts.zIndex+1):E.$tb.css("z-index",null)}},0)}function i(e){return(!e||"blur"!==e.type||document.activeElement!==E.el)&&((!e||"blur"!==e.type||!E.helpers.isMobile())&&(!(!e||"keydown"!==e.type||!E.keys.ctrlKey(e))||(!!E.button.getButtons(".fr-dropdown.fr-active").next().find(E.o_doc.activeElement).length||(E.helpers.isMobile()&&E.opts.toolbarInline&&(E.$tb.find(".fr-expanded").toggleClass("fr-expanded"),E.$tb.find(".fr-open").removeClass("fr-open"),E.$tb.removeClass("fr-toolbar-open"),T()),void(!1!==E.events.trigger("toolbar.hide")&&E.$tb.hide())))))}t[H.XS]=n(e(E.opts.toolbarButtonsXS||E.opts.toolbarButtons||H.TOOLBAR_BUTTONS_XS||H.TOOLBAR_BUTTONS||[])),t[H.SM]=n(e(E.opts.toolbarButtonsSM||E.opts.toolbarButtons||H.TOOLBAR_BUTTONS_SM||H.TOOLBAR_BUTTONS||[])),t[H.MD]=n(e(E.opts.toolbarButtonsMD||E.opts.toolbarButtons||H.TOOLBAR_BUTTONS_MD||H.TOOLBAR_BUTTONS||[])),t[H.LG]=n(e(E.opts.toolbarButtons||H.TOOLBAR_BUTTONS||[]));var a=null;function s(e){clearTimeout(a),e&&e.which===H.KEYCODE.ESC||(a=setTimeout(r,E.opts.typingTimer))}function l(){E.events.on("window.mousedown",i),E.events.on("keydown",i),E.events.on("blur",i),E.events.$on(E.$tb,"transitionend",".fr-more-toolbar",function(){E.position.forSelection(E.$tb)}),E.helpers.isMobile()||E.events.on("window.mouseup",r),E.helpers.isMobile()?E.helpers.isIOS()||(E.events.on("window.touchend",r),E.browser.mozilla&&setInterval(r,200)):E.events.on("window.keyup",s),E.events.on("keydown",function(e){e&&e.which===H.KEYCODE.ESC&&E.events.trigger("toolbar.esc")}),E.events.on("keydown",function(e){if(e.which===H.KEYCODE.ALT)return e.stopPropagation(),!1},!0),E.events.$on(E.$wp,"scroll.toolbar",r),E.events.on("commands.after",r),E.helpers.isMobile()&&(E.events.$on(E.$doc,"selectionchange",s),E.events.$on(E.$doc,"orientationchange",r))}function c(){E.$tb&&(E.$tb.html("").removeData().remove(),E.$tb=null),E.$second_tb&&(E.$second_tb.html("").removeData().remove(),E.$second_tb=null)}function d(){E.$box.removeClass("fr-top fr-bottom fr-inline fr-basic"),E.$box.find(".fr-sticky-dummy").remove()}function f(){E.opts.theme&&E.$tb.addClass("".concat(E.opts.theme,"-theme")),1<E.opts.zIndex&&E.$tb.css("z-index",E.opts.zIndex+1),"auto"!==E.opts.direction&&E.$tb.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(E.opts.direction)),E.helpers.isMobile()?E.$tb.addClass("fr-mobile"):E.$tb.addClass("fr-desktop"),E.opts.toolbarContainer?(E.opts.toolbarInline&&(l(),i()),E.opts.toolbarBottom?E.$tb.addClass("fr-bottom"):E.$tb.addClass("fr-top")):function e(){E.opts.toolbarInline?(E.$sc.append(E.$tb),E.$tb.data("container",E.$sc),E.$tb.addClass("fr-inline"),l(),E.opts.toolbarBottom=!1):(E.opts.toolbarBottom?(E.$box.append(E.$tb),E.$tb.addClass("fr-bottom"),E.$box.addClass("fr-bottom")):(E.opts.toolbarBottom=!1,E.$box.prepend(E.$tb),E.$tb.addClass("fr-top"),E.$box.addClass("fr-top")),E.$tb.addClass("fr-basic"),E.opts.toolbarSticky&&(E.opts.toolbarStickyOffset&&(E.opts.toolbarBottom?E.$tb.css("bottom",E.opts.toolbarStickyOffset):E.$tb.css("top",E.opts.toolbarStickyOffset)),E.position.addSticky(E.$tb)))}(),function t(){var e=E.button.buildGroup(N());E.$tb.append(e),T(),E.button.bindCommands(E.$tb)}(),function r(){E.events.$on(y(E.o_win),"resize",o),E.events.$on(y(E.o_win),"orientationchange",o),E.opts.toolbarButtons&&-1<JSON.stringify(E.opts.toolbarButtons).indexOf("trackChanges")&&o();var e=E.$tb.find(".fr-more-toolbar[data-name=trackChanges-".concat(E.id,"]")),t=0!==e.length&&e.hasClass("fr-expanded");if(E.opts.trackChangesEnabled&&!t){var n=E.$tb.find(".fr-command.fr-btn[data-cmd=trackChanges");e.addClass("fr-expanded"),n.toggleClass("fr-open"),E.toolbar.enable()}}(),E.accessibility.registerToolbar(E.$tb),E.events.$on(E.$tb,"".concat(E._mousedown," ").concat(E._mouseup),function(e){var t=e.originalEvent?e.originalEvent.target||e.originalEvent.originalTarget:null;if(t&&"INPUT"!==t.tagName&&!E.edit.isDisabled())return e.stopPropagation(),e.preventDefault(),!1},!0),E.helpers.isMobile()&&E.events.$on(E.$tb,"click",function(){E.popups.areVisible().length||E.id!==E.shared.selected_editor&&E.shared.selected_editor||E.$el.focus()}),E.events.$on(E.$tb,"transitionend",".fr-more-toolbar",function(){E.$box.hasClass("fr-fullscreen")&&(E.opts.height=E.o_win.innerHeight-(E.opts.toolbarInline?0:E.$tb.outerHeight()+(E.$second_tb?E.$second_tb.outerHeight():0)),E.size.refresh())})}var p=!1;return{_init:function u(){if(E.$sc=y(E.opts.scrollableContainer).first(),!E.$wp)return!1;E.opts.toolbarInline||E.opts.toolbarBottom||(E.$second_tb=y(E.doc.createElement("div")).attr("class","fr-second-toolbar"),E.$box.append(E.$second_tb),(!1!==E.ul||E.opts.attribution)&&E.$second_tb.prepend(H.POWERED_BY)),E.opts.toolbarContainer?(E.shared.$tb?(E.$tb=E.shared.$tb,E.opts.toolbarInline&&l()):(E.shared.$tb=y(E.doc.createElement("DIV")),E.shared.$tb.addClass("fr-toolbar"),E.$tb=E.shared.$tb,y(E.opts.toolbarContainer).append(E.$tb),f(),E.$tb.data("instance",E)),E.opts.toolbarInline?E.$box.addClass("fr-inline"):E.$box.addClass("fr-basic"),E.events.on("focus",function(){E.$tb.data("instance",E)},!0),E.opts.toolbarInline=!1):E.opts.toolbarInline?(E.$box.addClass("fr-inline"),E.shared.$tb?(E.$tb=E.shared.$tb,l()):(E.shared.$tb=y(E.doc.createElement("DIV")),E.shared.$tb.addClass("fr-toolbar"),E.$tb=E.shared.$tb,f())):(E.$box.addClass("fr-basic"),E.$tb=y(E.doc.createElement("DIV")),E.$tb.addClass("fr-toolbar"),f(),E.$tb.data("instance",E)),E.events.on("destroy",d,!0),E.events.on(E.opts.toolbarInline||E.opts.toolbarContainer?"shared.destroy":"destroy",c,!0),E.events.on("edit.on",function(){E.$tb.removeClass("fr-disabled").removeAttr("aria-disabled")}),E.events.on("edit.off",function(){E.$tb.addClass("fr-disabled").attr("aria-disabled",!0)}),function e(){E.events.on("shortcut",function(e,t,n){var r;if(t&&!n?r=E.$tb.find('.fr-command[data-cmd="'.concat(t,'"]')):t&&n&&(r=E.$tb.find('.fr-command[data-cmd="'.concat(t,'"][data-param1="').concat(n,'"]'))),r.length&&(e.preventDefault(),e.stopPropagation(),r.parents(".fr-toolbar").data("instance",E),"keydown"===e.type))return E.button.exec(r),!1})}()},hide:i,show:function h(){if(!1===E.events.trigger("toolbar.show"))return!1;E.$tb.show()},showInline:r,disable:function g(){!p&&E.$tb&&(E.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-wrap > .fr-command").addClass("fr-disabled fr-no-refresh").attr("aria-disabled",!0),p=!0)},enable:function C(){p&&E.$tb&&(E.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-wrap > .fr-command").removeClass("fr-disabled fr-no-refresh").attr("aria-disabled",!1),p=!1),E.button.bulkRefresh()},setMoreToolbarsHeight:T}};var c=["scroll","wheel","touchmove","touchstart","touchend"],d=["webkit","moz","ms","o"],f=["transitionend"],i=document.createElement("div").style,a=["Webkit","Moz","ms","O","css","style"],s={visibility:"hidden",display:"block"},r=["focus","blur","click"],p={},u=function u(e,t){return{altKey:e.altKey,bubbles:e.bubbles,cancelable:e.cancelable,changedTouches:e.changedTouches,ctrlKey:e.ctrlKey,detail:e.detail,eventPhase:e.eventPhase,metaKey:e.metaKey,pageX:e.pageX,pageY:e.pageY,shiftKey:e.shiftKey,view:e.view,"char":e["char"],key:e.key,keyCode:e.keyCode,button:e.button,buttons:e.buttons,clientX:e.clientX,clientY:e.clientY,offsetX:e.offsetX,offsetY:e.offsetY,pointerId:e.pointerId,pointerType:e.pointerType,screenX:e.screenX,screenY:e.screenY,targetTouches:e.targetTouches,toElement:e.toElement,touches:e.touches,type:e.type,which:e.which,target:e.target,currentTarget:t,originalEvent:e,stopPropagation:function(){e.stopPropagation()},stopImmediatePropagation:function(){e.stopImmediatePropagation()},preventDefault:function(){(/Android/i.test(navigator.userAgent)&&"touchend"===e.type||-1===c.indexOf(e.type))&&e.preventDefault()}}},h=function h(e){if(e.ownerDocument&&e.ownerDocument.body&&e.ownerDocument.body.contains(e)||"#document"===e.nodeName||"HTML"===e.nodeName||e===window)return!0;if("function"!=typeof e.getRootNode)return!1;var t=e.getRootNode();return t&&t.host&&h(t.host)},g=function g(n,r){return function(e){var t=e.target;if(r)for(r=m(r);t&&t!==this;)Element.prototype.matches.call(t,m(r))&&n.call(t,u(e,t)),t=t.parentNode;else h(t)&&n.call(t,u(e,t))}},C=function C(e,t){return new L(e,t)},m=function m(e){return e&&"string"==typeof e?e.replace(/^\s*>/g,":scope >").replace(/,\s*>/g,", :scope >"):e},v=function v(e){return"function"==typeof e&&"number"!=typeof e.nodeType},b=C;C.fn=C.prototype={constructor:C,length:0,contains:function(e){if(!e)return!1;if(Array.isArray(e)){for(var t=0;t<e.length;t++)if(this.contains(e[t])&&this!=e[t])return!0;return!1}for(var n=0;n<this.length;n++)for(var r=e;r;){if(r==this[n]||r[0]&&r[0].isEqualNode(this[n]))return!0;r=r.parentNode}return!1},findVisible:function(e){for(var t=this.find(e),n=t.length-1;0<=n;n--)b(t[n]).isVisible()||t.splice(n,1);return t},formatParams:function(t){var e="".concat(Object.keys(t).map(function(e){return"".concat(e,"=").concat(encodeURIComponent(t[e]))}).join("&"));return e||""},ajax:function(t){var n=new XMLHttpRequest,e=this.formatParams(t.data);for(var r in"GET"===t.method.toUpperCase()&&(t.url=e?t.url+"?"+e:t.url),n.open(t.method,t.url,!0),t.withCredentials&&(n.withCredentials=!0),t.crossDomain&&n.setRequestHeader("Access-Control-Allow-Origin","*"),t.headers)Object.prototype.hasOwnProperty.call(t.headers,r)&&n.setRequestHeader(r,t.headers[r]);Object.prototype.hasOwnProperty.call(t.headers,"Content-Type")||("json"===t.dataType?n.setRequestHeader("Content-Type","application/json"):n.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=UTF-8")),n.onload=function(){if(200==n.status){var e=n.responseText;"json"===t.dataType&&(e=JSON.parse(e)),t.done(e,n.status,n)}else t.fail(n)},n.send(e)},prevAll:function(){var e=b();if(!this[0])return e;for(var t=this[0];t&&t.previousSibling;)t=t.previousSibling,e.push(t);return e},index:function(e){return e?"string"==typeof e?[].indexOf.call(b(e),this[0]):[].indexOf.call(this,e.length?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},isVisible:function(){return!!this[0]&&!!(this[0].offsetWidth||this[0].offsetHeight||this[0].getClientRects().length)},toArray:function(){return[].slice.call(this)},get:function(e){return null==e?[].slice.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=C.merge(this.constructor(),e);return t.prevObject=this,t},wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=C(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){for(var e=this;e.firstElementChild;)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(e){if("string"==typeof e){for(var t=e.split(" "),n=0;n<t.length&&0===t[n].trim().length;)n++;if(n<t.length&&(b(e).length&&t[n].trim()===b(e)[0].tagName&&(e=document.createElement(t[n].trim())),n++),"string"!=typeof e)for(var r=b(e);n<t.length;n++){t[n]=t[n].trim();var o=t[n].split("=");r.attr(o[0],o[1].replace('"',""))}}for(;this[0].firstChild&&this[0].firstChild!==e&&"string"!=typeof e;)e.appendChild(this[0].firstChild)},wrapContent:function(e){for(var t=document.createElement(e.tagName),n=0;n<e.attributes.length;n++)b(t).attr(e.attributes[n].nodeName,e.attributes[n].value);b(this[0]).contents().wrapAll(t)},wrap:function(t){var n=v(t);return this.each(function(e){b(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(){return this.parent().each(function(){this.nodeName&&this.nodeName.toLowerCase()===name.toLowerCase()||C(this).replaceWith(this.childNodes)})},grep:function(e,t,n){for(var r=[],o=0,i=e.length,a=!n;o<i;o++)!t(e[o],o)!==a&&r.push(e[o]);return r},map:function(n){return this.pushStack(C.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack([].slice.apply(this,arguments))},each:function(e){if(this.length)for(var t=0;t<this.length&&!1!==e.call(this[t],t,this[t]);t++);return this},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},empty:function(){for(var e=0;e<this.length;e++)this[e].innerHTML=""},contents:function(){for(var e=b(),t=0;t<this.length;t++)for(var n=this[t].childNodes,r=0;r<n.length;r++)e.push(n[r]);return e},attr:function(e,t){if("object"===x(e)){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&null!==e[n]&&this.attr(n,e[n]);return this}if(void 0===t)return 0===this.length||!this[0].getAttribute&&"checked"!==e?undefined:"checked"===e?this[0].checked:"tagName"===e?this[0].tagName:this[0].getAttribute(e);if("checked"===e)for(var r=0;r<this.length;r++)this[r].checked=t;else if("tagName"===e)for(var o=0;o<this.length;o++)this[o].tagName=t;else for(var i=0;i<this.length;i++)this[i].setAttribute(e,t);return this},removeAttr:function(e){for(var t=0;t<this.length;t++)this[t].removeAttribute&&this[t].removeAttribute(e);return this},hide:function(){return this.css("display","none"),this},show:function(){return this.css("display","block"),this},focus:function(){return this.length&&this[0].focus(),this},blur:function(){return this.length&&this[0].blur(),this},data:function(e,t){if(void 0!==t){for(var n=0;n<this.length;n++)"object"!==x(this[n]["data-"+e]=t)&&"function"!=typeof t&&this[n].setAttribute&&this[n].setAttribute("data-"+e,t);return this}if(void 0!==t)return this.attr("data-"+e,t);if(0===this.length)return undefined;for(var r=0;r<this.length;r++){var o=this[r]["data-"+e];if(null==o&&this[r].getAttribute&&(o=this[r].getAttribute("data-"+e)),void 0!==o&&null!=o)return o}return undefined},removeData:function(e){for(var t=0;t<this.length;t++)this[t].removeAttribute&&this[t].removeAttribute("data-"+e),this[t]["data-"+e]=null;return this},getCorrectStyleName:function(e){if(!p[e]){var t;e in i&&(t=e);for(var n=e[0].toUpperCase()+e.slice(1),r=a.length;r--;)(e=a[r]+n)in i&&(t=e);p[e]=t}return p[e]},css:function(e,t){if(void 0!==t){if(0===this.length)return this;("string"!=typeof t||""===t.trim()||isNaN(t))&&"number"!=typeof t||!/(margin)|(padding)|(height)|(width)|(top)|(left)|(right)|(bottom)/gi.test(e)||/(line-height)/gi.test(e)||(t+="px");for(var n=0;n<this.length;n++)e=b(this).getCorrectStyleName(e),this[n].style[e]=t;return this}if("string"==typeof e){if(0===this.length)return undefined;var r=this[0].ownerDocument||document,o=r.defaultView||r.parentWindow;return e=b(this).getCorrectStyleName(e),o.getComputedStyle(this[0])[e]}for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&this.css(i,e[i]);return this},toggleClass:function(e,t){if(1<e.split(" ").length){for(var n=e.split(" "),r=0;r<n.length;r++)this.toggleClass(n[r],t);return this}for(var o=0;o<this.length;o++)void 0===t?this[o].classList.contains(e)?this[o].classList.remove(e):this[o].classList.add(e):t?this[o].classList.contains(e)||this[o].classList.add(e):this[o].classList.contains(e)&&this[o].classList.remove(e);return this},addClass:function(e){if(0===e.length)return this;if(1<e.split(" ").length){for(var t=e.split(" "),n=0;n<t.length;n++)this.addClass(t[n]);return this}for(var r=0;r<this.length;r++)this[r].classList.add(e);return this},removeClass:function(e){if(1<e.split(" ").length){for(var t=e.split(" "),n=0;n<t.length;n++)t[n]=t[n].trim(),t[n].length&&this.removeClass(t[n]);return this}for(var r=0;r<this.length;r++)e.length&&this[r].classList.remove(e);return this},getClass:function(e){return e.getAttribute&&e.getAttribute("class")||""},stripAndCollapse:function(e){return(e.match(/[^\x20\t\r\n\f]+/g)||[]).join(" ")},hasClass:function(e){var t,n,r=0;for(t=" "+e+" ";n=this[r++];)if(1===n.nodeType&&-1<(" "+b(this).stripAndCollapse(b(this).getClass(n))+" ").indexOf(t))return!0;return!1},scrollTop:function(e){if(void 0===e)return 0===this.length?undefined:this[0]===document?document.documentElement.scrollTop:this[0].scrollTop;for(var t=0;t<this.length;t++)this[t]===document?window.scrollTo(document.documentElement.scrollLeft,e):this[t].scrollTop=e},scrollLeft:function(e){if(void 0===e)return 0===this.length?undefined:this[0]===document?document.documentElement.scrollLeft:this[0].scrollLeft;for(var t=0;t<this.length;t++)this[t]===document?window.scrollTo(e,document.documentElement.scrollTop):this[t].scrollLeft=e},on:function(e,t,n){if(1<e.split(" ").length){for(var r=e.split(" "),o=0;o<r.length;o++)if(-1!==f.indexOf(e))for(var i=0;i<d.length;i++)this.on(d[i]+e[0].toUpperCase()+e.slice(1),t,n);else this.on(r[o],t,n);return this}n="function"==typeof t?g(t,null):g(n,t);for(var a=0;a<this.length;a++){var s=b(this[a]);s.data("events")||s.data("events",[]),s.data("events").push([e,n]);var l=e.split(".");l=l[0],/Android/i.test(navigator.userAgent)&&e.includes("touchend")||!(0<=c.indexOf(l))?s.get(0).addEventListener(l,n):s.get(0).addEventListener(l,n,{passive:!0})}},off:function(e){if(1<e.split(" ").length){for(var t=e.split(" "),n=0;n<t.length;n++)this.off(t[n]);return this}for(var r=0;r<this.length;r++){var o=b(this[r]);if(o.data("events")){var i=e.split(".");i=i[0];for(var a=o.data("events")||[],s=a.length-1;0<=s;s--){var l=a[s];l[0]==e&&(o.get(0).removeEventListener(i,l[1]),a.splice(s,1))}}}},trigger:function(e){for(var t=0;t<this.length;t++){var n=void 0;"function"==typeof Event?n=0<=e.search(/^mouse/g)?new MouseEvent(e,{view:window,cancelable:!0,bubbles:!0}):new Event(e):0<=e.search(/^mouse/g)?(n=document.createEvent("MouseEvents")).initMouseEvent(e,!0,!0,window,0,0,0,0,0,!1,!1,!1,!1,0,null):(n=document.createEvent("Event")).initEvent(e,!0,!0),0<=r.indexOf(e)&&"function"==typeof this[t][e]?this[t][e]():this[t].dispatchEvent(n)}},triggerHandler:function(){},val:function(e){if(void 0===e)return this[0].value;for(var t=0;t<this.length;t++)this[t].value=e;return this},siblings:function(){return b(this[0]).parent().children().not(this)},find:function(e){var t=b();if("string"!=typeof e){for(var n=0;n<e.length;n++)for(var r=0;r<this.length;r++)if(this[r]!==e[n]&&b(this[r]).contains(e[n])){t.push(e[n]);break}return t}var o=function o(e){return"object"===("undefined"==typeof HTMLElement?"undefined":x(HTMLElement))?e instanceof HTMLElement:e&&"object"===x(e)&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName};e=m(e);for(var i=0;i<this.length;i++)if(this[i].querySelectorAll){var a=[];if(e&&"string"==typeof e)try{a=this[i].querySelectorAll(e)}catch(l){a=this[i].children}else o(e)&&(a=[e]);for(var s=0;s<a.length;s++)t.push(a[s])}return t},children:function(){for(var e=b(),t=0;t<this.length;t++)for(var n=this[t].children,r=0;r<n.length;r++)e.push(n[r]);return e},not:function(e){if("string"==typeof e)for(var t=this.length-1;0<=t;t--)Element.prototype.matches.call(this[t],e)&&this.splice(t,1);else if(e instanceof C){for(var n=this.length-1;0<=n;n--)for(var r=0;r<e.length;r++)if(this[n]===e[r]){this.splice(n,1);break}}else for(var o=this.length-1;0<=o;o--)this[o]===e[0]&&this.splice(o,1);return this},add:function(e){for(var t=0;t<e.length;t++)this.push(e[t]);return this},closest:function(e){for(var t=0;t<this.length;t++){var n=Element.prototype.closest.call(this[t],e);if(n)return b(n)}return b()},html:function(e){if(void 0===e)return 0===this.length?undefined:this[0].innerHTML;if("string"==typeof e)for(var t=0;t<this.length;t++){this[t].innerHTML=e;for(var n=this[t].children,r=this[t].ownerDocument||document,o=0;o<n.length;o++)if("SCRIPT"===n[o].tagName){var i=r.createElement("script");i.innerHTML=n[o].innerHTML,n[o].hasAttribute("async")&&i.setAttribute("async",""),i.src=n[o].src,n[o].hasAttribute("defer")&&i.setAttribute("defer",""),r.head.appendChild(i).parentNode.removeChild(i)}}else{this[0].innerHTML="",this.append(e[0]);var a=this[0].ownerDocument||document;if("SCRIPT"===e[0].tagName){var s=a.createElement("script");s.innerHTML=e[0].innerHTML,a.head.appendChild(s).parentNode.removeChild(s)}}return this},text:function(e){if(!e)return this.length?this[0].textContent:"";for(var t=0;t<this.length;t++)this[t].textContent=e},after:function e(t){if(t)if("string"==typeof t)for(var n=0;n<this.length;n++){var e=this[n];if(e.nodeType!=Node.ELEMENT_NODE){var r=e.ownerDocument.createElement("SPAN");b(e).after(r),b(r).after(t).remove()}else e.insertAdjacentHTML("afterend",t)}else{var o=this[0];if(o.nextSibling)if(t instanceof C)for(var i=0;i<t.length;i++)o.nextSibling.parentNode.insertBefore(t[i],o.nextSibling);else o.nextSibling.parentNode.insertBefore(t,o.nextSibling);else b(o.parentNode).append(t)}return this},clone:function(e){for(var t=b(),n=0;n<this.length;n++)t.push(this[n].cloneNode(e));return t},replaceWith:function(e){if("string"==typeof e)for(var t=0;t<this.length;t++)this[t].parentNode&&(this[t].outerHTML=e);else if(e&&e.length)for(var n=0;n<this.length;n++)this.replaceWith(e[n]);else this.after(e).remove()},insertBefore:function(e){return b(e).before(this[0]),this},before:function e(t){if(t instanceof C){for(var n=0;n<t.length;n++)this.before(t[n]);return this}if(t)if("string"==typeof t)for(var r=0;r<this.length;r++){var e=this[r];if(e.nodeType!=Node.ELEMENT_NODE){var o=e.ownerDocument.createElement("SPAN");b(e).before(o),b(o).before(t).remove()}else e.parentNode&&e.insertAdjacentHTML("beforebegin",t)}else{var i=this[0];if(i.parentNode)if(t instanceof C)for(var a=0;a<t.length;a++)i.parentNode.insertBefore(t[a],i);else i.parentNode.insertBefore(t,i)}return this},append:function(e){if(0==this.length)return this;if("string"==typeof e)for(var t=0;t<this.length;t++){var n=this[t],r=n.ownerDocument.createElement("SPAN");b(n).append(r),b(r).after(e).remove()}else if(e instanceof C||Array.isArray(e))for(var o=0;o<e.length;o++)this.append(e[o]);else"function"!=typeof e&&this[0].appendChild(e);return this},prepend:function(e){if(0==this.length)return this;if("string"==typeof e)for(var t=0;t<this.length;t++){var n=this[t],r=n.ownerDocument.createElement("SPAN");b(n).prepend(r),b(r).before(e).remove()}else if(e instanceof C)for(var o=0;o<e.length;o++)this.prepend(e[o]);else{var i=this[0];i.firstChild?i.firstChild?i.insertBefore(e,i.firstChild):i.appendChild(e):b(i).append(e)}return this},remove:function(){for(var e=0;e<this.length;e++)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this},prev:function(){return this.length&&this[0].previousElementSibling?b(this[0].previousElementSibling):b()},next:function(){return this.length&&this[0].nextElementSibling?b(this[0].nextElementSibling):b()},nextAllVisible:function(){return this.next()},prevAllVisible:function(){return this.prev()},outerHeight:function(e){if(0===this.length)return undefined;var t=this[0];if(t===t.window)return t.innerHeight;var n={},r=this.isVisible();if(!r)for(var o in s)n[o]=t.style[o],t.style[o]=s[o];var i=t.offsetHeight;if(e&&(i+=parseInt(b(t).css("marginTop"))+parseInt(b(t).css("marginBottom"))),!r)for(var a in s)t.style[a]=n[a];return i},outerWidth:function(e){if(0===this.length)return undefined;var t=this[0];if(t===t.window)return t.outerWidth;var n={},r=this.isVisible();if(!r)for(var o in s)n[o]=t.style[o],t.style[o]=s[o];var i=t.offsetWidth;if(e&&(i+=parseInt(b(t).css("marginLeft"))+parseInt(b(t).css("marginRight"))),!r)for(var a in s)t.style[a]=n[a];return i},width:function(e){if(e===undefined){if(this[0]instanceof HTMLDocument)return this[0].body.offsetWidth;if(this[0])return this[0].offsetWidth}else this[0].style.width=e+"px"},height:function(e){var t=this[0];if(e===undefined){if(t instanceof HTMLDocument){var n=t.documentElement;return Math.max(t.body.scrollHeight,n.scrollHeight,t.body.offsetHeight,n.offsetHeight,n.clientHeight)}return t.offsetHeight}t.style.height=e+"px"},is:function(e){return 0!==this.length&&("string"==typeof e&&this[0].matches?this[0].matches(e):e instanceof C?this[0]==e[0]:this[0]==e)},parent:function(){return 0===this.length?b():b(this[0].parentNode)},_matches:function(e,t){var n=e.matches||e.matchesSelector||e.msMatchesSelector||e.mozMatchesSelector||e.webkitMatchesSelector||e.oMatchesSelector;return e&&!t?n:n.call(e,t)},parents:function(e){for(var t=b(),n=0;n<this.length;n++)for(var r=this[n].parentNode;r&&r!=document&&this._matches(r);)e?this._matches(r,e)&&t.push(r):t.push(r),r=r.parentNode;return t},parentsUntil:function(e,t){var n=b();e instanceof C&&0<e.length&&(e=e[0]);for(var r=0;r<this.length;r++)for(var o=this[r].parentNode;o&&o!=document&&o!=e&&this[r]!=e&&("string"!=typeof e||!Element.prototype.matches.call(o,e));)t?Element.prototype.matches.call(o,t)&&n.push(o):n.push(o),o=o.parentNode;return n},insertAfter:function(e){var t=e.parent()[0];t&&t.insertBefore(this[0],e[0].nextElementSibling)},filter:function(e){var t=b();if("function"==typeof e)for(var n=0;n<this.length;n++)e.call(this[n],this[n])&&t.push(this[n]);else if("string"==typeof e)for(var r=0;r<this.length;r++)this[r].matches(e)&&t.push(this[r]);return t},offset:function(){if(0===this.length)return undefined;var e=this[0].getBoundingClientRect(),t=this[0].ownerDocument.defaultView;return{top:e.top+t.pageYOffset,left:e.left+t.pageXOffset}},position:function(){return{left:this[0].offsetLeft,top:this[0].offsetTop}},push:[].push,splice:[].splice},C.extend=function(e){e=e||{};for(var t=1;t<arguments.length;t++)if(arguments[t])for(var n in arguments[t])Object.prototype.hasOwnProperty.call(arguments[t],n)&&(e[n]=arguments[t][n]);return e},C.merge=function(e,t){for(var n=+t.length,r=0,o=e.length;r<n;r++)e[o++]=t[r];return e.length=o,e},C.map=function(e,t,n){var r,o,i=0,a=[];if(Array.isArray(e))for(r=e.length;i<r;i++)null!=(o=t(e[i],i,n))&&a.push(o);else for(i in e)null!=(o=t(e[i],i,n))&&a.push(o);return[].concat.apply([],a)};var L=function L(e,t){if(!e)return this;if("string"==typeof e&&"<"===e[0]){var n=document.createElement("DIV");return n.innerHTML=e,b(n.firstElementChild)}if(t=t instanceof C?t[0]:t,"string"!=typeof e)return e instanceof C?e:(this[0]=e,this.length=1,this);e=m(e);for(var r=(t||document).querySelectorAll(e),o=0;o<r.length;o++)this[o]=r[o];return this.length=r.length,this};L.prototype=C.prototype;var T=H;function M(){var t=this;this.doc=this.$el.get(0).ownerDocument,this.win="defaultView"in this.doc?this.doc.defaultView:this.doc.parentWindow,this.$doc=C(this.doc),this.$win=C(this.win),this.opts.pluginsEnabled||(this.opts.pluginsEnabled=Object.keys(T.PLUGINS)),this.opts.pluginsDisabled&&(this.opts.pluginsDisabled=Array.isArray(this.opts.pluginsDisabled)?this.opts.pluginsDisabled:[this.opts.pluginsDisabled],this.opts.pluginsEnabled=this.opts.pluginsEnabled.filter(function(e){return!t.opts.pluginsDisabled.includes(e)})),this.opts.initOnClick?(this.load(T.MODULES),this.$el.on("touchstart.init",function(){C(this).data("touched",!0)}),this.$el.on("touchmove.init",function(){C(this).removeData("touched")}),this.$el.on("mousedown.init touchend.init dragenter.init focus.init",function r(e){if("false"!==this.$el.attr("contentEditable")||!this.opts.initOnClick){if("touchend"===e.type&&!this.$el.data("touched"))return!0;if(1===e.which||!e.which){this.$el.off("mousedown.init touchstart.init touchmove.init touchend.init dragenter.init focus.init"),this.load(T.MODULES),this.load(T.PLUGINS);var t=e.originalEvent&&e.originalEvent.originalTarget;if(t&&"IMG"===t.tagName&&C(t).trigger("mousedown"),"undefined"==typeof this.ul&&this.destroy(),"touchend"===e.type&&this.image&&e.originalEvent&&e.originalEvent.target&&C(e.originalEvent.target).is("img")){var n=this;setTimeout(function(){n.image.edit(C(e.originalEvent.target))},100)}this.ready=!0,this.events.trigger("initialized")}}}.bind(this)),this.events.trigger("initializationDelayed")):(this.load(T.MODULES),this.load(T.PLUGINS),C(this.o_win).scrollTop(this.c_scroll),"undefined"==typeof this.ul&&this.destroy(),this.ready=!0,this.events.trigger("initialized"))}return T.Bootstrap=function(e,t,n){this.id=++T.ID,this.$=C;var r={};"function"==typeof t&&(n=t,t={}),n&&(t.events||(t.events={}),t.events.initialized=n),t&&t.documentReady&&(r.toolbarButtons=[["fullscreen","undo","redo","getPDF","print"],["bold","italic","underline","textColor","backgroundColor","clearFormatting"],["alignLeft","alignCenter","alignRight","alignJustify"],["formatOL","formatUL","indent","outdent"],["paragraphFormat"],["fontFamily"],["fontSize"],["insertLink","insertImage","quote"]],r.paragraphFormatSelection=!0,r.fontFamilySelection=!0,r.fontSizeSelection=!0,r.placeholderText="",r.quickInsertEnabled=!1,r.charCounterCount=!1),this.opts=Object.assign({},Object.assign({},T.DEFAULTS,r,"object"===x(t)&&t));var o=JSON.stringify(this.opts);T.OPTS_MAPPING[o]=T.OPTS_MAPPING[o]||this.id,this.sid=T.OPTS_MAPPING[o],T.SHARED[this.sid]=T.SHARED[this.sid]||{},this.shared=T.SHARED[this.sid],this.shared.count=(this.shared.count||0)+1,this.$oel=C(e),this.$oel.data("froala.editor",this),this.o_doc=e.ownerDocument,this.o_win="defaultView"in this.o_doc?this.o_doc.defaultView:this.o_doc.parentWindow,this.c_scroll=C(this.o_win).scrollTop(),this._init()},T.Bootstrap.prototype._init=function(){var e=this.$oel.get(0).tagName;this.$oel.closest("label").length;var t=function(){"TEXTAREA"!==e&&(this._original_html=this._original_html||this.$oel.html()),this.$box=this.$box||this.$oel,this.opts.fullPage&&(this.opts.iframe=!0),this.opts.iframe?(this.$iframe=C('<iframe src="about:blank" frameBorder="0">'),this.$wp=C("<div></div>"),this.$box.html(this.$wp),this.$wp.append(this.$iframe),this.$iframe.get(0).contentWindow.document.open(),this.$iframe.get(0).contentWindow.document.write("<!DOCTYPE html>"),this.$iframe.get(0).contentWindow.document.write("<html><head></head><body></body></html>"),this.$iframe.get(0).contentWindow.document.close(),this.iframe_document=this.$iframe.get(0).contentWindow.document,this.$el=C(this.iframe_document.querySelector("body")),this.el=this.$el.get(0),this.$head=C(this.iframe_document.querySelector("head")),this.$html=C(this.iframe_document.querySelector("html"))):(this.$el=C(this.o_doc.createElement("DIV")),this.el=this.$el.get(0),this.$wp=C(this.o_doc.createElement("DIV")).append(this.$el),this.$box.html(this.$wp)),setTimeout(M.bind(this),0)}.bind(this),n=function(){this.$box=C("<div>"),this.$oel.before(this.$box).hide(),this._original_html=this.$oel.val();var e=this;this.$oel.parents("form").on("submit.".concat(this.id),function(){e.events.trigger("form.submit")}),this.$oel.parents("form").on("reset.".concat(this.id),function(){e.events.trigger("form.reset")}),t()}.bind(this),r=function(){this.$el=this.$oel,this.el=this.$el.get(0),this.$el.attr("contenteditable",!0).css("outline","none").css("display","inline-block"),this.opts.multiLine=!1,this.opts.toolbarInline=!1,setTimeout(M.bind(this),0)}.bind(this),o=function(){this.$el=this.$oel,this.el=this.$el.get(0),this.opts.toolbarInline=!1,setTimeout(M.bind(this),0)}.bind(this),i=function(){this.$el=this.$oel,this.el=this.$el.get(0),this.opts.toolbarInline=!1,this.$oel.on("click.popup",function(e){e.preventDefault()}),setTimeout(M.bind(this),0)}.bind(this);this.opts.editInPopup?i():"TEXTAREA"===e?n():"A"===e?r():"IMG"===e?o():"BUTTON"===e||"INPUT"===e?(this.opts.editInPopup=!0,this.opts.toolbarInline=!1,i()):t()},T.Bootstrap.prototype.load=function(e){for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)){if(this[t])continue;if(T.PLUGINS[t]&&this.opts.pluginsEnabled.indexOf(t)<0)continue;if(this[t]=new e[t](this),this[t]._init&&(this[t]._init(),this.opts.initOnClick&&"core"===t))return!1}},T.Bootstrap.prototype.destroy=function(){this.destrying=!0,this.shared.count--,this.events&&this.events.$off();var e=this.html&&this.html.get();if(this.opts.iframe&&(this.events.disableBlur(),this.win.focus(),this.events.enableBlur()),this.events&&(this.events.trigger("destroy",[],!0),this.events.trigger("shared.destroy",[],!0)),0===this.shared.count){for(var t in this.shared)Object.prototype.hasOwnProperty.call(this.shared,t)&&(this.shared[t]=null,T.SHARED[this.sid][t]=null);delete T.SHARED[this.sid]}this.$oel.parents("form").off(".".concat(this.id)),this.$oel.off("click.popup"),this.$oel.removeData("froala.editor"),this.$oel.off("froalaEditor"),this.core&&this.core.destroy(e),T.INSTANCES.splice(T.INSTANCES.indexOf(this),1)},H});

/***/ }),

/***/ 3040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1549),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 3222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(7556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 3335:
/***/ (function(module) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),

/***/ 3345:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 3385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GU: function() { return /* binding */ needFetchPlanification; },
/* harmony export */   Jp: function() { return /* binding */ planificationRelations; },
/* harmony export */   i_: function() { return /* binding */ fetchPlanification; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var planificationRelations = [
    'construction', 'construction.contents', 'technicians', 'contents', 'customFields', 'customer', 'contact', 'country', 'signatures'
];
var needFetchPlanification = function (model) {
    return !planificationRelations.every(function (relation) { return relation in model; });
};
var fetchPlanification = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwConstructions.axios.get('/construction/planification/' + id, {
                    params: {
                        include: planificationRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4394);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),

/***/ 3605:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3040),
    mapCacheDelete = __webpack_require__(7670),
    mapCacheGet = __webpack_require__(289),
    mapCacheHas = __webpack_require__(4509),
    mapCacheSet = __webpack_require__(2949);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1799),
    getMatchData = __webpack_require__(776),
    matchesStrictComparable = __webpack_require__(7197);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 3702:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 3785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ PlanificationForm_PlanificationForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PlanificationForm/PlanificationForm.vue?vue&type=template&id=699d75b8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('FormModal',{attrs:{"size":"xxl","scrollable":"","modal-class":"construction-planification-form-modal","title":_vm.modalTitle},on:{"hidden":_vm.modalHidden,"shown":_vm.modalShown},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):_vm._e(),_c('k-form',{staticClass:"construction-planification-form",attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c(_vm.computedConstruction ? 'div' : 'b-row',{tag:"component"},[_c(_vm.computedConstruction ? 'div' : 'b-col',{tag:"component"},[_c('b-row',{attrs:{"align-v":!_vm.planification.all_contents ? 'end' : 'center'}},[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.uppercaseFirst(_vm.termText('planification.tabTitle', 'technician', true))}},[_c('k-form-select',{attrs:{"options":_vm.allTechnicals,"label":"name","validationName":"technicians","multiple":"","getOptionKey":val => val.type + val.id},model:{value:(_vm.planification.technicians),callback:function ($$v) {_vm.$set(_vm.planification, "technicians", $$v)},expression:"planification.technicians"}})],1),(_vm.computedConstruction)?[_c('b-form-group',{attrs:{"label":"Prestations à planifier"}},[_c('b-form-radio-group',{attrs:{"name":"all_contents","options":[
                  { value: true, text: 'Toutes' },
                  { value: false, text: 'Personnalisée' }
                ]},model:{value:(_vm.planification.all_contents),callback:function ($$v) {_vm.$set(_vm.planification, "all_contents", $$v)},expression:"planification.all_contents"}})],1),(!_vm.planification.all_contents)?_c('table',{staticClass:"table table-sm border"},[_c('thead',[_c('tr',{staticClass:"small"},[_c('th',{staticStyle:{"width":"30px"}}),(_vm.hasQuantity)?_c('th',{staticStyle:{"width":"90px"}},[_vm._v(" Quantité ")]):_vm._e(),_c('th',[_vm._v("Désignation")])])]),_c('tbody',_vm._l((_vm.contents),function(content,i){return _c('tr',{key:i},[_c('td',{staticClass:"pt-2"},[_c('k-form-checkbox',{staticClass:"mt-1",attrs:{"noLabel":""},model:{value:(_vm.contents[i].include),callback:function ($$v) {_vm.$set(_vm.contents[i], "include", $$v)},expression:"contents[i].include"}})],1),(_vm.hasQuantity)?_c('td',[(content.quantity > 1)?_c('k-form-spinner',{staticClass:"mt-1",staticStyle:{"max-width":"60px"},attrs:{"size":"sm","max":content.quantity,"min":0,"disabled":!content.include},model:{value:(_vm.contents[i].include_quantity),callback:function ($$v) {_vm.$set(_vm.contents[i], "include_quantity", $$v)},expression:"contents[i].include_quantity"}}):_vm._e()],1):_vm._e(),_c('td',[_c('FroalaView',{attrs:{"value":content.designation}}),(content.total_duration_hour > 0 || content.number_people_needed > 0)?_c('p',{staticClass:"small mb-0 mt-3"},[(content.total_duration_hour > 0)?_c('span',[_c('strong',[_vm._v("Durée totale :")]),_vm._v(" "+_vm._s(_vm.duration(content.total_duration_hour))+" ")]):_vm._e(),(content.total_duration_hour > 0 && content.number_people_needed > 0)?_c('span',[_vm._v(" | ")]):_vm._e(),(content.number_people_needed > 0)?_c('span',[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fas', 'user']}}),_c('strong',[_vm._v(_vm._s(content.number_people_needed)+" techniciens")])],1):_vm._e()]):_vm._e()],1)])}),0)]):_vm._e()]:_vm._e()],2),_c('b-col',{attrs:{"cols":"auto"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Début"}},[_c('k-form-datetime',{staticClass:"planification-dates",attrs:{"max":_vm.planification.end,"size":"sm","name":"begin"},model:{value:(_vm.planification.begin),callback:function ($$v) {_vm.$set(_vm.planification, "begin", $$v)},expression:"planification.begin"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{attrs:{"label":"Fin"}},[_c('k-form-datetime',{staticClass:"planification-dates",attrs:{"min":_vm.planification.begin,"size":"sm","name":"end"},model:{value:(_vm.planification.end),callback:function ($$v) {_vm.$set(_vm.planification, "end", $$v)},expression:"planification.end"}})],1)],1),(_vm.computedConstruction)?_c('b-col',{attrs:{"cols":"auto"}},[_c('div',{staticClass:"p-2 font-weight-bold alert-secondary border"},[_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.uppercaseFirst(_vm.termText('planification.duration', 'planning', true)))+" : "+_vm._s(_vm.duration(_vm.planificationDuration))+" ")]),_vm._v(" "+_vm._s(_vm.uppercaseFirst(_vm.termText('planification.nbTechncianRequired', 'technician', true)))+" : "+_vm._s(_vm.planificationNbPeople)+" ")])]):_vm._e()],1),(!_vm.planification.construction && !_vm.construction)?_c('b-form-group',{attrs:{"label":"Description"}},[_c('k-form-textarea',{attrs:{"required":""},model:{value:(_vm.planification.description),callback:function ($$v) {_vm.$set(_vm.planification, "description", $$v)},expression:"planification.description"}})],1):_vm._e(),_c('CustomFieldsForm',{attrs:{"type":"planification"},model:{value:(_vm.planification.custom_fields),callback:function ($$v) {_vm.$set(_vm.planification, "custom_fields", $$v)},expression:"planification.custom_fields"}})],1),(!_vm.computedConstruction)?_c('b-col',[_c('b-row',[_c('b-col',[_c('CustomerSelect',{attrs:{"required":"","include":['address_invoice', 'address_delivery', 'addresses'],"validationName":"customer","type":"prospect_or_customer"},on:{"input":_vm.selectCustomer},model:{value:(_vm.planification.customer),callback:function ($$v) {_vm.$set(_vm.planification, "customer", $$v)},expression:"planification.customer"}})],1),_c('b-col',[_c('ContactSelect',{attrs:{"customer":_vm.planification.customer,"disabled":!_vm.planification.customer},model:{value:(_vm.planification.contact),callback:function ($$v) {_vm.$set(_vm.planification, "contact", $$v)},expression:"planification.contact"}})],1)],1),_c('b-form-group',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.termText('construction.form.address', 'chantier'))+" ")]),_c('b-col',[_c('CustomerAddressSelect',{attrs:{"customer":_vm.planification.customer},on:{"selected":_vm.selectAddress}})],1)],1)]},proxy:true}],null,false,2853769255)},[_c('k-form-address',{attrs:{"size":"sm","with-road3":_vm.withRoad3,"countries-list":_vm.countries},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1)],1):_vm._e()],1),_c('hr'),(!_vm.loading && _vm.modalShowed)?_c('TechniciansCalendar',{ref:"calendar",attrs:{"onSelect":_vm.dateSelect,"events":_vm.events,"excludeEvent":_vm.planification?.id ?? null}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: ./node_modules/lodash/maxBy.js
var maxBy = __webpack_require__(7551);
var maxBy_default = /*#__PURE__*/__webpack_require__.n(maxBy);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@fullcalendar/vue"
var vue_ = __webpack_require__(5206);
var vue_default = /*#__PURE__*/__webpack_require__.n(vue_);
// EXTERNAL MODULE: ./node_modules/v-calendar/lib/components/date-picker.umd.js
var date_picker_umd = __webpack_require__(7642);
var date_picker_umd_default = /*#__PURE__*/__webpack_require__.n(date_picker_umd);
// EXTERNAL MODULE: ./src/fetchDatas/planification.ts
var planification = __webpack_require__(3385);
// EXTERNAL MODULE: ./src/utils/text.ts
var utils_text = __webpack_require__(2579);
// EXTERNAL MODULE: ./src/mixins/DurationMixin.ts
var DurationMixin = __webpack_require__(3790);
// EXTERNAL MODULE: ./src/components/TechniciansCalendar/TechniciansCalendar.vue + 7 modules
var TechniciansCalendar = __webpack_require__(8994);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/sales-vue"
var sales_vue_ = __webpack_require__(2779);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PlanificationForm/PlanificationForm.ts?vue&type=script&lang=ts&external


















var PlanificationForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationForm, _super);
    function PlanificationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.contents = [];
        _this.address = {};
        _this.planification = {
            technicians: [],
            custom_fields: []
        };
        _this.modalShowed = false;
        return _this;
    }
    PlanificationForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTechnicals()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 2:
                        _a.sent();
                        this.$nextTick(function () {
                            _this.loading = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PlanificationForm.prototype, "formDatas", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            var planification = this.planification;
            var address = this.address;
            var datas = {
                technicians: planification.technicians.map(function (technician) { return ({
                    type: technician.type,
                    id: technician.id
                }); }),
                all_contents: planification.all_contents,
                begin: planification.begin,
                end: planification.end,
                custom_fields: (_b = (_a = planification.custom_fields) === null || _a === void 0 ? void 0 : _a.map(function (customField) {
                    var _a;
                    var value = (_a = customField.value) !== null && _a !== void 0 ? _a : null;
                    if (value && Array.isArray(value)) {
                        value = value.filter(function (val) { return val !== undefined; })
                            .map(function (value) {
                            if (value && typeof value === 'object') {
                                return value.label;
                            }
                            return value;
                        });
                    }
                    else if (value && typeof value === 'object') {
                        value = value.label;
                    }
                    return {
                        id: customField.id,
                        value: value
                    };
                })) !== null && _b !== void 0 ? _b : []
            };
            if (!planification.construction && !this.construction) {
                datas.customer = (_d = (_c = planification.customer) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null;
                datas.contact = (_f = (_e = planification.contact) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null;
                datas.description = (_g = planification.description) !== null && _g !== void 0 ? _g : null;
                datas.road1 = (_h = address.road1) !== null && _h !== void 0 ? _h : null;
                datas.road2 = (_j = address.road2) !== null && _j !== void 0 ? _j : null;
                datas.road3 = (_k = address.road3) !== null && _k !== void 0 ? _k : null;
                datas.town = (_l = address.town) !== null && _l !== void 0 ? _l : null;
                datas.postal_code = (_m = address.postal_code) !== null && _m !== void 0 ? _m : null;
                datas.country = (_p = (_o = address.country) === null || _o === void 0 ? void 0 : _o.code) !== null && _p !== void 0 ? _p : null;
            }
            if ((planification.construction || this.construction) && !planification.all_contents) {
                datas.contents = this.contents
                    .filter(function (content) { return content.include; })
                    .map(function (content) { return ({
                    content: content.id,
                    quantity: content.include_quantity
                }); });
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "withRoad3", {
        get: function () {
            return this.address.road1 !== null && this.address.road1 !== '' && this.address.road1 !== undefined
                && this.address.road2 !== null && this.address.road2 !== '' && this.address.road2 !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            return (0,utils_text/* termText */.a)('planification.' + (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'editTitle' : 'newTitle'), 'planning');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "computedConstruction", {
        get: function () {
            var _a, _b;
            return (_a = this.construction) !== null && _a !== void 0 ? _a : (_b = this.planification) === null || _b === void 0 ? void 0 : _b.construction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "events", {
        get: function () {
            var events = [];
            if (this.planification.begin && this.planification.end) {
                events.push({
                    start: this.planification.begin,
                    end: this.planification.end,
                    allDay: false,
                    resourceIds: this.planification.technicians.map(function (technicians) {
                        return technicians.type + '-' + technicians.id;
                    }),
                    className: 'placeholder-event'
                });
            }
            return events;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "planificationDuration", {
        get: function () {
            var _this = this;
            var _a, _b;
            if (this.planification.all_contents) {
                return (_b = (_a = this.computedConstruction) === null || _a === void 0 ? void 0 : _a.total_duration_hour) !== null && _b !== void 0 ? _b : 0;
            }
            return sumBy_default()(this.contents, function (content) {
                if (!content.include) {
                    return 0;
                }
                var duration = content.duration_type === 'minute' ? _this.roundNumber(_this.number(content.duration) / 60, 2) : content.duration;
                return _this.roundNumber(_this.number(content.include_quantity) * _this.number(duration), 2);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "planificationNbPeople", {
        get: function () {
            var _this = this;
            var _a, _b, _c, _d;
            if (this.planification.all_contents) {
                return (_b = (_a = this.computedConstruction) === null || _a === void 0 ? void 0 : _a.nb_people_needed) !== null && _b !== void 0 ? _b : 0;
            }
            return (_d = (_c = maxBy_default()(this.contents, function (content) {
                if (!content.include) {
                    return 0;
                }
                return _this.number(content.number_people_needed);
            })) === null || _c === void 0 ? void 0 : _c.number_people_needed) !== null && _d !== void 0 ? _d : 0;
        },
        enumerable: false,
        configurable: true
    });
    // Select a date or a period in calendar
    PlanificationForm.prototype.dateSelect = function (info) {
        var _a;
        this.planification.begin = (0,interface_vue_.moment)(info.start).format('YYYY-MM-DD HH:mm:ss');
        var end = (0,interface_vue_.moment)(info.end);
        if (end.format('HH:mm:ss') === '00:00:00') {
            this.planification.end = (0,interface_vue_.moment)(info.end).subtract(1, 'day').format('YYYY-MM-DD') + ' 23:59:00';
        }
        else {
            this.planification.end = (0,interface_vue_.moment)(info.end).format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.planification.technicians.length === 0 && ((_a = info.resource) === null || _a === void 0 ? void 0 : _a.id)) {
            var technician = this.allTechnicals.find(function (technician) { var _a; return technician.type + '-' + technician.id === ((_a = info.resource) === null || _a === void 0 ? void 0 : _a.id); });
            if (technician) {
                this.planification.technicians.push(technician);
            }
        }
    };
    Object.defineProperty(PlanificationForm.prototype, "formAction", {
        get: function () {
            var _a, _b;
            if ((_a = this.planification) === null || _a === void 0 ? void 0 : _a.id) {
                return '/construction/planification/' + ((_b = this.planification) === null || _b === void 0 ? void 0 : _b.id);
            }
            else if (!this.computedConstruction) {
                return '/construction/planification';
            }
            else {
                return '/construction/' + this.computedConstruction.id + '/planification';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.planification) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationForm.prototype, "hasQuantity", {
        get: function () {
            var _a, _b, _c;
            return ((_c = (_b = (_a = this.computedConstruction) === null || _a === void 0 ? void 0 : _a.contents) === null || _b === void 0 ? void 0 : _b.filter(function (content) { return content.quantity > 1; })) !== null && _c !== void 0 ? _c : []).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    PlanificationForm.prototype.watchModal = function () {
        this.modalState = this.modal;
    };
    PlanificationForm.prototype.watchValue = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var value, technicians, begin, momentFormat, end, minute;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        value = this.value;
                        if (!((value === null || value === void 0 ? void 0 : value.id) && (0,planification/* needFetchPlanification */.GU)(value))) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, (0,planification/* fetchPlanification */.i_)(value.id)];
                    case 1:
                        value = _l.sent();
                        this.loading = false;
                        _l.label = 2;
                    case 2:
                        technicians = [];
                        if (!this.computedConstruction) {
                            if ((_a = this.teamUser.roles) === null || _a === void 0 ? void 0 : _a.includes('technical')) {
                                technicians.push({
                                    type: 'teamUser',
                                    id: this.teamUser.id,
                                    name: this.teamUser.fullname
                                });
                            }
                        }
                        begin = null;
                        momentFormat = 'YYYY-MM-DD';
                        end = null;
                        if (this.teamConfigs.construction_planification_auto_date) {
                            begin = (0,interface_vue_.moment)();
                            if (this.teamConfigs.construction_planification_auto_begin) {
                                momentFormat = 'YYYY-MM-DD HH:mm:ss';
                                if (this.teamConfigs.construction_planification_auto_begin_number) {
                                    begin.add(this.teamConfigs.construction_planification_auto_begin_number, 'minutes');
                                }
                                if (this.teamConfigs.construction_planification_auto_begin_round) {
                                    minute = Number(begin.format('mm'));
                                    begin.set('minute', Math.floor(minute / 10) * 10).set('second', 0);
                                }
                                if (this.teamConfigs.construction_planification_auto_end) {
                                    end = begin.clone().add(this.teamConfigs.construction_planification_auto_end_count, 'minutes');
                                }
                            }
                        }
                        this.planification = Object.assign({
                            technicians: technicians,
                            all_contents: true,
                            begin: begin === null || begin === void 0 ? void 0 : begin.format(momentFormat),
                            end: end === null || end === void 0 ? void 0 : end.format(momentFormat),
                            custom_fields: []
                        }, JSON.parse(JSON.stringify(value !== null && value !== void 0 ? value : {})));
                        this.address = {
                            road1: (_b = this.planification) === null || _b === void 0 ? void 0 : _b.road1,
                            road2: (_c = this.planification) === null || _c === void 0 ? void 0 : _c.road2,
                            road3: (_d = this.planification) === null || _d === void 0 ? void 0 : _d.road3,
                            postal_code: (_e = this.planification) === null || _e === void 0 ? void 0 : _e.postal_code,
                            town: (_f = this.planification) === null || _f === void 0 ? void 0 : _f.town,
                            country: (_h = (_g = this.planification) === null || _g === void 0 ? void 0 : _g.country) !== null && _h !== void 0 ? _h : null
                        };
                        this.contents = [];
                        (_k = (_j = this.computedConstruction) === null || _j === void 0 ? void 0 : _j.contents) === null || _k === void 0 ? void 0 : _k.forEach(function (constructionContent) {
                            var _a;
                            var content = JSON.parse(JSON.stringify(constructionContent));
                            var include = !(value === null || value === void 0 ? void 0 : value.id) && content.stay_to_planify > 0;
                            var include_quantity = content.stay_to_planify;
                            var existContent = (_a = value === null || value === void 0 ? void 0 : value.contents) === null || _a === void 0 ? void 0 : _a.find(function (val) { return val.content_id === constructionContent.id; });
                            if (!(value === null || value === void 0 ? void 0 : value.all_contents) && existContent) {
                                include = true;
                                include_quantity = existContent.quantity;
                            }
                            content.include = include;
                            content.include_quantity = include_quantity;
                            _this.contents.push(content);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanificationForm.prototype.modalHidden = function () {
        this.modalShowed = false;
        this.$emit('hidden');
    };
    PlanificationForm.prototype.modalShown = function () {
        this.modalShowed = true;
    };
    PlanificationForm.prototype.submitComplete = function (response) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var planification;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                planification = response.data;
                if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                    interface_vue_.emitter.emit('planificationUpdated', planification);
                    this.$emit('updated', planification);
                }
                else if (this.$route.name === 'construction-item') {
                    interface_vue_.emitter.emit('planificationCreated', planification);
                    this.$emit('created', planification);
                }
                return [2 /*return*/];
            });
        });
    };
    PlanificationForm.prototype.selectCustomer = function (customer) {
        var _this = this;
        var _a;
        this.$nextTick(function () {
            _this.planification.contact = null;
        });
        if (!customer || (!customer.address_delivery && !customer.address_invoice)) {
            return;
        }
        this.selectAddress((_a = customer.address_delivery) !== null && _a !== void 0 ? _a : customer.address_invoice);
    };
    PlanificationForm.prototype.selectAddress = function (address) {
        this.address.road1 = address.road1;
        this.address.road2 = address.road2;
        this.address.road3 = address.road3;
        this.address.postal_code = address.postal_code;
        this.address.town = address.town;
        this.address.country = address.country;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], PlanificationForm.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationForm.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationForm.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationForm.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationForm.prototype, "construction", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PlanificationForm.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true }),
        (0,lib/* Watch */.ox)('construction')
    ], PlanificationForm.prototype, "watchValue", null);
    PlanificationForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TechniciansCalendar: TechniciansCalendar/* default */.A,
                BModal: external_bootstrap_vue_.BModal,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, FroalaView: form_vue_.FroalaView, KFormCheckbox: form_vue_.KFormCheckbox, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormSpinner: form_vue_.KFormSpinner, KFormDatetime: form_vue_.KFormDatetime, KFormAddress: form_vue_.KFormAddress, KFormTextarea: form_vue_.KFormTextarea,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BButtonGroup: external_bootstrap_vue_.BButtonGroup,
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                FullCalendar: (vue_default()),
                datepicker: (date_picker_umd_default()),
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                CustomerAddressSelect: sales_vue_.CustomerAddressSelect
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('constructions', ['loadTechnicals'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])), (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])), { termText: utils_text/* termText */.a, uppercaseFirst: utils_text/* uppercaseFirst */.t }),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('constructions', ['allTechnicals'])), (0,external_vuex_.mapGetters)('user', ['teamUser', 'teamConfigs'])), (0,external_vuex_.mapState)('globalDatas', ['countries']))
        })
    ], PlanificationForm);
    return PlanificationForm;
}((0,lib/* Mixins */.Xe)(DurationMixin/* default */.A, interface_vue_.NumberMixin)));
/* harmony default export */ var PlanificationFormvue_type_script_lang_ts_external = (PlanificationForm);

;// ./src/components/PlanificationForm/PlanificationForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationForm_PlanificationFormvue_type_script_lang_ts_external = (PlanificationFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PlanificationForm/PlanificationForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PlanificationForm_PlanificationFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationForm_PlanificationForm = (component.exports);

/***/ }),

/***/ 3790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);


var DurationMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .C6)(DurationMixin, _super);
    function DurationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DurationMixin.prototype, "duration", {
        get: function () {
            return function (duration) {
                var hours = Math.floor(duration);
                var minutes = Math.round((duration - hours) * 60);
                return (hours < 10 ? '0' : '') + hours + 'h' + (minutes < 10 ? '0' : '') + minutes;
            };
        },
        enumerable: false,
        configurable: true
    });
    DurationMixin.prototype.parseDuration = function (duration) {
        var hours = Math.floor(duration);
        var minutes = Math.round((duration - hours) * 60);
        var value = hours + 'h';
        if (minutes > 0) {
            value += ' ' + (minutes < 10 ? '0' : '') + minutes + 'mn';
        }
        return value;
    };
    DurationMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], DurationMixin);
    return DurationMixin;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (DurationMixin);


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3862:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 3912:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1074),
    hasUnicode = __webpack_require__(9698),
    unicodeToArray = __webpack_require__(2054);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 4218:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 4247:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 4248:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 4509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 4528:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(9770),
    stubArray = __webpack_require__(3345);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4696:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/custom-fields-vue");

/***/ }),

/***/ 4739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 5083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isMasked = __webpack_require__(7296),
    isObject = __webpack_require__(3805),
    toSource = __webpack_require__(7473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 5160:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 5206:
/***/ (function(module) {

"use strict";
module.exports = require("@fullcalendar/vue");

/***/ }),

/***/ 5288:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 5389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3663),
    baseMatchesProperty = __webpack_require__(7978),
    identity = __webpack_require__(3488),
    isArray = __webpack_require__(6449),
    property = __webpack_require__(583);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 5481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 5749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5808:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(2507);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 5858:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/customers-vue");

/***/ }),

/***/ 5861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(5580),
    Map = __webpack_require__(8223),
    Promise = __webpack_require__(2804),
    Set = __webpack_require__(6545),
    WeakMap = __webpack_require__(8303),
    baseGetTag = __webpack_require__(2552),
    toSource = __webpack_require__(7473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 5911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arraySome = __webpack_require__(4248),
    cacheHas = __webpack_require__(9219);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 5936:
/***/ (function(module) {

"use strict";
module.exports = require("@fullcalendar/bootstrap");

/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 6110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(5083),
    getValue = __webpack_require__(392);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 6229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ PlanificationStatus_PlanificationStatus; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PlanificationStatus/PlanificationStatus.vue?vue&type=template&id=7986630c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'edit')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.hidden},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_c('p',[_vm._v(" Êtes-vous sûr de marque la planification comme "+_vm._s(_vm.value.status === 1 ? 'Terminée' : 'À faire')+" ? ")])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PlanificationStatus/PlanificationStatus.ts?vue&type=script&lang=ts&external




var PlanificationStatus = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationStatus, _super);
    function PlanificationStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(PlanificationStatus.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationStatus.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : (this.value.status === 1 ? 'Marquer comme terminée' : 'Marquer comme à faire');
        },
        enumerable: false,
        configurable: true
    });
    PlanificationStatus.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    PlanificationStatus.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    PlanificationStatus.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.hidden();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put('/construction/planification/' + this.value.id + '/status', {
            status: this.value.status === 1 ? 2 : 1
        })
            .then(function (response) {
            interface_vue_.emitter.emit('planificationUpdated', response.data);
            _this.$emit('updated', response.data);
            _this.hidden();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    PlanificationStatus.prototype.hidden = function () {
        this.errorMsg = null;
        this.modalState = false;
        this.$emit('hidden');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PlanificationStatus.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], PlanificationStatus.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationStatus.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationStatus.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationStatus.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationStatus.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationStatus.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PlanificationStatus.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], PlanificationStatus.prototype, "watchModalState", null);
    PlanificationStatus = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], PlanificationStatus);
    return PlanificationStatus;
}(lib/* Vue */.lD));
/* harmony default export */ var PlanificationStatusvue_type_script_lang_ts_external = (PlanificationStatus);

;// ./src/components/PlanificationStatus/PlanificationStatus.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationStatus_PlanificationStatusvue_type_script_lang_ts_external = (PlanificationStatusvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/PlanificationStatus/PlanificationStatus.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  PlanificationStatus_PlanificationStatusvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationStatus_PlanificationStatus = (component.exports);

/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6500:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var fr = {
  code: "fr",
  week: {
    dow: 1,
    doy: 4
  },
  buttonText: {
    prev: "Pr\xE9c\xE9dent",
    next: "Suivant",
    today: "Aujourd'hui",
    year: "Ann\xE9e",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    list: "Planning"
  },
  weekText: "Sem.",
  allDayText: "Toute la journ\xE9e",
  moreLinkText: "en plus",
  noEventsText: "Aucun \xE9v\xE9nement \xE0 afficher"
};

exports.A = fr;


/***/ }),

/***/ 6545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 6721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 7068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    equalArrays = __webpack_require__(5911),
    equalByTag = __webpack_require__(1986),
    equalObjects = __webpack_require__(689),
    getTag = __webpack_require__(5861),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isTypedArray = __webpack_require__(7167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7197:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 7217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(1420),
    stackDelete = __webpack_require__(938),
    stackGet = __webpack_require__(3605),
    stackHas = __webpack_require__(9817),
    stackSet = __webpack_require__(945);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 7237:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 7255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 7296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(5481);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 7473:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 7551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseExtremum = __webpack_require__(3599),
    baseGt = __webpack_require__(3335),
    baseIteratee = __webpack_require__(5389);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),

/***/ 7556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    arrayMap = __webpack_require__(4932),
    isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(622));
	else // removed by dead control flow
{}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_656__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_656__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_656__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_656__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_656__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_656__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_656__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_656__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_656__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_656__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_656__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_656__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_656__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_656__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_656__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_656__(__nested_webpack_require_656__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00fd":
/***/ (function(module, exports, __nested_webpack_require_4132__) {

var Symbol = __nested_webpack_require_4132__("9e69");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "03dd":
/***/ (function(module, exports, __nested_webpack_require_5362__) {

var isPrototype = __nested_webpack_require_5362__("eac5"),
    nativeKeys = __nested_webpack_require_5362__("57a5");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "0621":
/***/ (function(module, exports, __nested_webpack_require_6227__) {

var Symbol = __nested_webpack_require_6227__("9e69"),
    isArguments = __nested_webpack_require_6227__("d370"),
    isArray = __nested_webpack_require_6227__("6747");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __nested_webpack_require_6936__) {

var DESCRIPTORS = __nested_webpack_require_6936__("83ab");
var propertyIsEnumerableModule = __nested_webpack_require_6936__("d1e7");
var createPropertyDescriptor = __nested_webpack_require_6936__("5c6c");
var toIndexedObject = __nested_webpack_require_6936__("fc6a");
var toPrimitive = __nested_webpack_require_6936__("c04e");
var has = __nested_webpack_require_6936__("5135");
var IE8_DOM_DEFINE = __nested_webpack_require_6936__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07c7":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "087d":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "08cc":
/***/ (function(module, exports, __nested_webpack_require_8825__) {

var isObject = __nested_webpack_require_8825__("1a8c");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "0b07":
/***/ (function(module, exports, __nested_webpack_require_9329__) {

var baseIsNative = __nested_webpack_require_9329__("34ac"),
    getValue = __nested_webpack_require_9329__("3698");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __nested_webpack_require_9902__) {

var toObject = __nested_webpack_require_9902__("7b0b");

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __nested_webpack_require_11372__) {

var DESCRIPTORS = __nested_webpack_require_11372__("83ab");
var fails = __nested_webpack_require_11372__("d039");
var createElement = __nested_webpack_require_11372__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d24":
/***/ (function(module, exports, __nested_webpack_require_11885__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __nested_webpack_require_11885__("2b3e"),
    stubFalse = __nested_webpack_require_11885__("07c7");

/** Detect free variable `exports`. */
var freeExports =   true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_11885__("62e4")(module)))

/***/ }),

/***/ "0da5":
/***/ (function(module, exports, __nested_webpack_require_13200__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_13200__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-nav-header{display:flex;justify-content:space-between}.vc-nav-arrow{display:flex;justify-content:center;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none;line-height:var(--leading-snug);border-width:2px;border-style:solid;border-color:transparent;border-radius:var(--rounded)}.vc-nav-arrow.is-left{margin-right:auto}.vc-nav-arrow.is-right{margin-left:auto}.vc-nav-arrow.is-disabled{opacity:.25;pointer-events:none;cursor:not-allowed}.vc-nav-arrow:hover{background-color:var(--gray-900)}.vc-nav-arrow:focus{border-color:var(--accent-600)}.vc-nav-title{color:var(--accent-100);font-weight:var(--font-bold);line-height:var(--leading-snug);padding:4px 8px;border-radius:var(--rounded);border-width:2px;border-style:solid;border-color:transparent;-webkit-user-select:none;user-select:none}.vc-nav-title:hover{background-color:var(--gray-900)}.vc-nav-title:focus{border-color:var(--accent-600)}.vc-nav-items{display:grid;grid-template-columns:repeat(3,1fr);grid-row-gap:2px;grid-column-gap:5px}.vc-nav-item{width:48px;text-align:center;line-height:var(--leading-snug);font-weight:var(--font-semibold);padding:4px 0;cursor:pointer;border-color:transparent;border-width:2px;border-style:solid;border-radius:var(--rounded);-webkit-user-select:none;user-select:none}.vc-nav-item:hover{color:var(--white);background-color:var(--gray-900);box-shadow:var(--shadow-inner)}.vc-nav-item.is-active{color:var(--accent-900);background:var(--accent-100);font-weight:var(--font-bold);box-shadow:var(--shadow)}.vc-nav-item.is-current{color:var(--accent-100);font-weight:var(--bold);border-color:var(--accent-100)}.vc-nav-item:focus{border-color:var(--accent-600)}.vc-nav-item.is-disabled{opacity:.25;pointer-events:none}.vc-is-dark .vc-nav-title{color:var(--gray-900)}.vc-is-dark .vc-nav-title:hover{background-color:var(--gray-200)}.vc-is-dark .vc-nav-title:focus{border-color:var(--accent-400)}.vc-is-dark .vc-nav-arrow:hover{background-color:var(--gray-200)}.vc-is-dark .vc-nav-arrow:focus{border-color:var(--accent-400)}.vc-is-dark .vc-nav-item:hover{color:var(--gray-900);background-color:var(--gray-200);box-shadow:none}.vc-is-dark .vc-nav-item.is-active{color:var(--white);background:var(--accent-500)}.vc-is-dark .vc-nav-item.is-current{color:var(--accent-600);border-color:var(--accent-500)}.vc-is-dark .vc-nav-item:focus{border-color:var(--accent-400)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0f0f":
/***/ (function(module, exports, __nested_webpack_require_15855__) {

var copyObject = __nested_webpack_require_15855__("8eeb"),
    keysIn = __nested_webpack_require_15855__("9934");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "0f5c":
/***/ (function(module, exports, __nested_webpack_require_16432__) {

var baseSet = __nested_webpack_require_16432__("159a");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ "0fb2":
/***/ (function(module, exports, __nested_webpack_require_17482__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_17482__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-popover-content-wrapper[data-v-39b30300]{--popover-horizontal-content-offset:8px;--popover-vertical-content-offset:10px;--popover-slide-translation:15px;--popover-transition-time:0.14s ease-in-out;--popover-caret-horizontal-offset:18px;--popover-caret-vertical-offset:8px;position:absolute;display:block;outline:none;z-index:10}.vc-popover-content-wrapper[data-v-39b30300]:not(.is-interactive){pointer-events:none}.vc-popover-content[data-v-39b30300]{position:relative;outline:none;z-index:10;box-shadow:var(--shadow-lg)}.vc-popover-content.direction-bottom[data-v-39b30300]{margin-top:var(--popover-vertical-content-offset)}.vc-popover-content.direction-top[data-v-39b30300]{margin-bottom:var(--popover-vertical-content-offset)}.vc-popover-content.direction-left[data-v-39b30300]{margin-right:var(--popover-horizontal-content-offset)}.vc-popover-content.direction-right[data-v-39b30300]{margin-left:var(--popover-horizontal-content-offset)}.vc-popover-caret[data-v-39b30300]{content:\"\";position:absolute;display:block;width:12px;height:12px;border-top:inherit;border-left:inherit;background-color:inherit;-webkit-user-select:none;user-select:none;z-index:-1}.vc-popover-caret.direction-bottom[data-v-39b30300]{top:0}.vc-popover-caret.direction-bottom.align-left[data-v-39b30300]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-center[data-v-39b30300]{transform:translateX(-50%) translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-right[data-v-39b30300]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-top[data-v-39b30300]{top:100%}.vc-popover-caret.direction-top.align-left[data-v-39b30300]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-center[data-v-39b30300]{transform:translateX(-50%) translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-right[data-v-39b30300]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-left[data-v-39b30300]{left:100%}.vc-popover-caret.direction-left.align-top[data-v-39b30300]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-middle[data-v-39b30300]{transform:translateY(-50%) translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-bottom[data-v-39b30300]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-right[data-v-39b30300]{left:0}.vc-popover-caret.direction-right.align-top[data-v-39b30300]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-middle[data-v-39b30300]{transform:translateY(-50%) translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-bottom[data-v-39b30300]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.align-left[data-v-39b30300]{left:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-center[data-v-39b30300]{left:50%}.vc-popover-caret.align-right[data-v-39b30300]{right:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-top[data-v-39b30300]{top:var(--popover-caret-vertical-offset)}.vc-popover-caret.align-middle[data-v-39b30300]{top:50%}.vc-popover-caret.align-bottom[data-v-39b30300]{bottom:var(--popover-caret-vertical-offset)}.fade-enter-active[data-v-39b30300],.fade-leave-active[data-v-39b30300],.slide-fade-enter-active[data-v-39b30300],.slide-fade-leave-active[data-v-39b30300]{transition:all var(--popover-transition-time);pointer-events:none}.fade-enter[data-v-39b30300],.fade-leave-to[data-v-39b30300],.slide-fade-enter[data-v-39b30300],.slide-fade-leave-to[data-v-39b30300]{opacity:0}.slide-fade-enter.direction-bottom[data-v-39b30300],.slide-fade-leave-to.direction-bottom[data-v-39b30300]{transform:translateY(calc(var(--popover-slide-translation)*-1))}.slide-fade-enter.direction-top[data-v-39b30300],.slide-fade-leave-to.direction-top[data-v-39b30300]{transform:translateY(var(--popover-slide-translation))}.slide-fade-enter.direction-left[data-v-39b30300],.slide-fade-leave-to.direction-left[data-v-39b30300]{transform:translateX(var(--popover-slide-translation))}.slide-fade-enter.direction-right[data-v-39b30300],.slide-fade-leave-to.direction-right[data-v-39b30300]{transform:translateX(calc(var(--popover-slide-translation)*-1))}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "100e":
/***/ (function(module, exports, __nested_webpack_require_21981__) {

var identity = __nested_webpack_require_21981__("cd9d"),
    overRest = __nested_webpack_require_21981__("2286"),
    setToString = __nested_webpack_require_21981__("c1c9");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "1041":
/***/ (function(module, exports, __nested_webpack_require_22637__) {

var copyObject = __nested_webpack_require_22637__("8eeb"),
    getSymbolsIn = __nested_webpack_require_22637__("a029");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __nested_webpack_require_23195__) {

var fails = __nested_webpack_require_23195__("d039");

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
  var re = RegExp('(?<a>b)', (typeof '').charAt(5));
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "1290":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "1310":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "1368":
/***/ (function(module, exports, __nested_webpack_require_24746__) {

var coreJsData = __nested_webpack_require_24746__("da03");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __nested_webpack_require_25397__) {

var classof = __nested_webpack_require_25397__("c6b6");
var regexpExec = __nested_webpack_require_25397__("9263");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159a":
/***/ (function(module, exports, __nested_webpack_require_26078__) {

var assignValue = __nested_webpack_require_26078__("32b3"),
    castPath = __nested_webpack_require_26078__("e2e4"),
    isIndex = __nested_webpack_require_26078__("c098"),
    isObject = __nested_webpack_require_26078__("1a8c"),
    toKey = __nested_webpack_require_26078__("f4d6");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ "15f3":
/***/ (function(module, exports, __nested_webpack_require_27574__) {

var basePickBy = __nested_webpack_require_27574__("89d9"),
    hasIn = __nested_webpack_require_27574__("8604");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ "1838":
/***/ (function(module, exports, __nested_webpack_require_28171__) {

var baseIsEqual = __nested_webpack_require_28171__("c05f"),
    get = __nested_webpack_require_28171__("9b02"),
    hasIn = __nested_webpack_require_28171__("8604"),
    isKey = __nested_webpack_require_28171__("f608"),
    isStrictComparable = __nested_webpack_require_28171__("08cc"),
    matchesStrictComparable = __nested_webpack_require_28171__("20ec"),
    toKey = __nested_webpack_require_28171__("f4d6");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "18d8":
/***/ (function(module, exports, __nested_webpack_require_29407__) {

var memoizeCapped = __nested_webpack_require_29407__("234d");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __nested_webpack_require_30331__) {

var getTag = __nested_webpack_require_30331__("42a2"),
    isObjectLike = __nested_webpack_require_30331__("1310");

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ "1a8c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "1bac":
/***/ (function(module, exports, __nested_webpack_require_31698__) {

var baseGetAllKeys = __nested_webpack_require_31698__("7d1f"),
    getSymbolsIn = __nested_webpack_require_31698__("a029"),
    keysIn = __nested_webpack_require_31698__("9934");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __nested_webpack_require_32278__) {

var getBuiltIn = __nested_webpack_require_32278__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c3c":
/***/ (function(module, exports, __nested_webpack_require_32469__) {

var Symbol = __nested_webpack_require_32469__("9e69"),
    Uint8Array = __nested_webpack_require_32469__("2474"),
    eq = __nested_webpack_require_32469__("9638"),
    equalArrays = __nested_webpack_require_32469__("a2be"),
    mapToArray = __nested_webpack_require_32469__("edfa"),
    setToArray = __nested_webpack_require_32469__("ac41");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "1cec":
/***/ (function(module, exports, __nested_webpack_require_36329__) {

var getNative = __nested_webpack_require_36329__("0b07"),
    root = __nested_webpack_require_36329__("2b3e");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1efc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "1f64":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_37437__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarDay_vue_vue_type_style_index_0_id_4420d078_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_37437__("6a43");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarDay_vue_vue_type_style_index_0_id_4420d078_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_37437__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarDay_vue_vue_type_style_index_0_id_4420d078_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarDay_vue_vue_type_style_index_0_id_4420d078_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1fc8":
/***/ (function(module, exports, __nested_webpack_require_39722__) {

var getMapData = __nested_webpack_require_39722__("4245");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "20ec":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "2202":
/***/ (function(module, exports, __nested_webpack_require_40935__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_40935__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-select[data-v-7b2eaf0a]{position:relative}.vc-select select[data-v-7b2eaf0a]{flex-grow:1;display:block;-webkit-appearance:none;appearance:none;width:52px;height:30px;font-size:var(--text-base);font-weight:var(--font-medium);text-align:left;background-color:var(--gray-200);border:2px solid;border-color:var(--gray-200);color:var(--gray-900);padding:0 20px 0 8px;border-radius:var(--rounded);line-height:var(--leading-tight);text-indent:0;cursor:pointer;-moz-padding-start:3px;background-image:none}.vc-select select[data-v-7b2eaf0a]:hover{color:var(--gray-600)}.vc-select select[data-v-7b2eaf0a]:focus{outline:0;border-color:var(--accent-400);background-color:var(--white)}.vc-select-arrow[data-v-7b2eaf0a]{display:flex;align-items:center;pointer-events:none;position:absolute;top:0;bottom:0;right:0;padding:0 4px 0 0;color:var(--gray-500)}.vc-select-arrow svg[data-v-7b2eaf0a]{width:16px;height:16px;fill:currentColor}.vc-is-dark select[data-v-7b2eaf0a]{background:var(--gray-700);color:var(--gray-100);border-color:var(--gray-700)}.vc-is-dark select[data-v-7b2eaf0a]:hover{color:var(--gray-400)}.vc-is-dark select[data-v-7b2eaf0a]:focus{border-color:var(--accent-500);background-color:var(--gray-800)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2285":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_42439__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomTransition_vue_vue_type_style_index_0_id_5be4b00c_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_42439__("2a4d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomTransition_vue_vue_type_style_index_0_id_5be4b00c_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_42439__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomTransition_vue_vue_type_style_index_0_id_5be4b00c_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CustomTransition_vue_vue_type_style_index_0_id_5be4b00c_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2286":
/***/ (function(module, exports, __nested_webpack_require_44744__) {

var apply = __nested_webpack_require_44744__("85e3");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "234d":
/***/ (function(module, exports, __nested_webpack_require_45932__) {

var memoize = __nested_webpack_require_45932__("e380");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "23a5":
/***/ (function(module) {

module.exports = JSON.parse("{\"maxSwipeTime\":300,\"minHorizontalSwipeDistance\":60,\"maxVerticalSwipeDistance\":80}");

/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __nested_webpack_require_46830__) {

var toInteger = __nested_webpack_require_46830__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __nested_webpack_require_47346__) {

var global = __nested_webpack_require_47346__("da84");
var getOwnPropertyDescriptor = __nested_webpack_require_47346__("06cf").f;
var createNonEnumerableProperty = __nested_webpack_require_47346__("9112");
var redefine = __nested_webpack_require_47346__("6eeb");
var setGlobal = __nested_webpack_require_47346__("ce4e");
var copyConstructorProperties = __nested_webpack_require_47346__("e893");
var isForced = __nested_webpack_require_47346__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "2411":
/***/ (function(module, exports, __nested_webpack_require_49846__) {

var baseMerge = __nested_webpack_require_49846__("f909"),
    createAssigner = __nested_webpack_require_49846__("2ec1");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __nested_webpack_require_51180__) {

var internalObjectKeys = __nested_webpack_require_51180__("ca84");
var enumBugKeys = __nested_webpack_require_51180__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "242e":
/***/ (function(module, exports, __nested_webpack_require_51717__) {

var baseFor = __nested_webpack_require_51717__("72af"),
    keys = __nested_webpack_require_51717__("ec69");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "2474":
/***/ (function(module, exports, __nested_webpack_require_52273__) {

var root = __nested_webpack_require_52273__("2b3e");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "2478":
/***/ (function(module, exports, __nested_webpack_require_52496__) {

var getMapData = __nested_webpack_require_52496__("4245");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2524":
/***/ (function(module, exports, __nested_webpack_require_55515__) {

var nativeCreate = __nested_webpack_require_55515__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "253c":
/***/ (function(module, exports, __nested_webpack_require_56198__) {

var baseGetTag = __nested_webpack_require_56198__("3729"),
    isObjectLike = __nested_webpack_require_56198__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "2593":
/***/ (function(module, exports, __nested_webpack_require_56775__) {

var basePick = __nested_webpack_require_56775__("15f3"),
    flatRest = __nested_webpack_require_56775__("c6cf");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ "26e8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "27e3":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_57947__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimePicker_vue_vue_type_style_index_0_id_f4e11af8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_57947__("8a64");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimePicker_vue_vue_type_style_index_0_id_f4e11af8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_57947__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimePicker_vue_vue_type_style_index_0_id_f4e11af8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimePicker_vue_vue_type_style_index_0_id_f4e11af8_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "28c9":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "29f3":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "2a4d":
/***/ (function(module, exports, __nested_webpack_require_61137__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_61137__("7dfe");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_61137__("499e").default
var update = add("99a6e87a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2b10":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ "2b3e":
/***/ (function(module, exports, __nested_webpack_require_62449__) {

var freeGlobal = __nested_webpack_require_62449__("585a");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __nested_webpack_require_62836__) {

var global = __nested_webpack_require_62836__("da84");
var userAgent = __nested_webpack_require_62836__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "2d7c":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "2dcb":
/***/ (function(module, exports, __nested_webpack_require_64145__) {

var overArg = __nested_webpack_require_64145__("91e9");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "2ec1":
/***/ (function(module, exports, __nested_webpack_require_64398__) {

var baseRest = __nested_webpack_require_64398__("100e"),
    isIterateeCall = __nested_webpack_require_64398__("9aff");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "2fcc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "3092":
/***/ (function(module, exports, __nested_webpack_require_65996__) {

var arraySome = __nested_webpack_require_65996__("4284"),
    baseIteratee = __nested_webpack_require_65996__("badf"),
    baseSome = __nested_webpack_require_65996__("361d"),
    isArray = __nested_webpack_require_65996__("6747"),
    isIterateeCall = __nested_webpack_require_65996__("9aff");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "30c9":
/***/ (function(module, exports, __nested_webpack_require_67704__) {

var isFunction = __nested_webpack_require_67704__("9520"),
    isLength = __nested_webpack_require_67704__("b218");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "32b3":
/***/ (function(module, exports, __nested_webpack_require_68628__) {

var baseAssignValue = __nested_webpack_require_68628__("872a"),
    eq = __nested_webpack_require_68628__("9638");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "32f4":
/***/ (function(module, exports, __nested_webpack_require_69621__) {

var arrayFilter = __nested_webpack_require_69621__("2d7c"),
    stubArray = __nested_webpack_require_69621__("d327");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __nested_webpack_require_70598__) {

var getBuiltIn = __nested_webpack_require_70598__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "34ac":
/***/ (function(module, exports, __nested_webpack_require_70790__) {

var isFunction = __nested_webpack_require_70790__("9520"),
    isMasked = __nested_webpack_require_70790__("1368"),
    isObject = __nested_webpack_require_70790__("1a8c"),
    toSource = __nested_webpack_require_70790__("dc57");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "361d":
/***/ (function(module, exports, __nested_webpack_require_72311__) {

var baseEach = __nested_webpack_require_72311__("48a0");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "3698":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "3729":
/***/ (function(module, exports, __nested_webpack_require_73407__) {

var Symbol = __nested_webpack_require_73407__("9e69"),
    getRawTag = __nested_webpack_require_73407__("00fd"),
    objectToString = __nested_webpack_require_73407__("29f3");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __nested_webpack_require_74293__) {

var DESCRIPTORS = __nested_webpack_require_74293__("83ab");
var definePropertyModule = __nested_webpack_require_74293__("9bf2");
var anObject = __nested_webpack_require_74293__("825a");
var objectKeys = __nested_webpack_require_74293__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3818":
/***/ (function(module, exports, __nested_webpack_require_75042__) {

var Stack = __nested_webpack_require_75042__("7e64"),
    arrayEach = __nested_webpack_require_75042__("8057"),
    assignValue = __nested_webpack_require_75042__("32b3"),
    baseAssign = __nested_webpack_require_75042__("5b01"),
    baseAssignIn = __nested_webpack_require_75042__("0f0f"),
    cloneBuffer = __nested_webpack_require_75042__("e538"),
    copyArray = __nested_webpack_require_75042__("4359"),
    copySymbols = __nested_webpack_require_75042__("54eb"),
    copySymbolsIn = __nested_webpack_require_75042__("1041"),
    getAllKeys = __nested_webpack_require_75042__("a994"),
    getAllKeysIn = __nested_webpack_require_75042__("1bac"),
    getTag = __nested_webpack_require_75042__("42a2"),
    initCloneArray = __nested_webpack_require_75042__("c87c"),
    initCloneByTag = __nested_webpack_require_75042__("c2b6"),
    initCloneObject = __nested_webpack_require_75042__("fa21"),
    isArray = __nested_webpack_require_75042__("6747"),
    isBuffer = __nested_webpack_require_75042__("0d24"),
    isMap = __nested_webpack_require_75042__("cc45"),
    isObject = __nested_webpack_require_75042__("1a8c"),
    isSet = __nested_webpack_require_75042__("d7ee"),
    keys = __nested_webpack_require_75042__("ec69"),
    keysIn = __nested_webpack_require_75042__("9934");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "3852":
/***/ (function(module, exports, __nested_webpack_require_80823__) {

var baseHas = __nested_webpack_require_80823__("96f3"),
    hasPath = __nested_webpack_require_80823__("e2c0");

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),

/***/ "39ff":
/***/ (function(module, exports, __nested_webpack_require_81676__) {

var getNative = __nested_webpack_require_81676__("0b07"),
    root = __nested_webpack_require_81676__("2b3e");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "3b4a":
/***/ (function(module, exports, __nested_webpack_require_81980__) {

var getNative = __nested_webpack_require_81980__("0b07");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "3bb4":
/***/ (function(module, exports, __nested_webpack_require_82301__) {

var isStrictComparable = __nested_webpack_require_82301__("08cc"),
    keys = __nested_webpack_require_82301__("ec69");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __nested_webpack_require_82963__) {

var isObject = __nested_webpack_require_82963__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3c55":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_83261__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarNav_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_83261__("e969");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarNav_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_83261__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarNav_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarNav_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3db9":
/***/ (function(module, exports, __nested_webpack_require_85450__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_85450__("adc8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_85450__("499e").default
var update = add("2b7f9a9d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3ee2":
/***/ (function(module, exports, __nested_webpack_require_85943__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_85943__("dc8c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_85943__("499e").default
var update = add("13d41af5", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3eea":
/***/ (function(module, exports, __nested_webpack_require_86436__) {

var arrayMap = __nested_webpack_require_86436__("7948"),
    baseClone = __nested_webpack_require_86436__("3818"),
    baseUnset = __nested_webpack_require_86436__("4bb5"),
    castPath = __nested_webpack_require_86436__("e2e4"),
    copyObject = __nested_webpack_require_86436__("8eeb"),
    customOmitClone = __nested_webpack_require_86436__("e0e7"),
    flatRest = __nested_webpack_require_86436__("c6cf"),
    getAllKeysIn = __nested_webpack_require_86436__("1bac");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ "3f84":
/***/ (function(module, exports, __nested_webpack_require_88174__) {

var apply = __nested_webpack_require_88174__("85e3"),
    baseRest = __nested_webpack_require_88174__("100e"),
    customDefaultsMerge = __nested_webpack_require_88174__("e031"),
    mergeWith = __nested_webpack_require_88174__("2411");

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "41c3":
/***/ (function(module, exports, __nested_webpack_require_89193__) {

var isObject = __nested_webpack_require_89193__("1a8c"),
    isPrototype = __nested_webpack_require_89193__("eac5"),
    nativeKeysIn = __nested_webpack_require_89193__("ec8c");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "4245":
/***/ (function(module, exports, __nested_webpack_require_90156__) {

var isKeyable = __nested_webpack_require_90156__("1290");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "4284":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __nested_webpack_require_91301__) {

var global = __nested_webpack_require_91301__("da84");

module.exports = global;


/***/ }),

/***/ "42a2":
/***/ (function(module, exports, __nested_webpack_require_91453__) {

var DataView = __nested_webpack_require_91453__("b5a7"),
    Map = __nested_webpack_require_91453__("79bc"),
    Promise = __nested_webpack_require_91453__("1cec"),
    Set = __nested_webpack_require_91453__("c869"),
    WeakMap = __nested_webpack_require_91453__("39ff"),
    baseGetTag = __nested_webpack_require_91453__("3729"),
    toSource = __nested_webpack_require_91453__("dc57");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "4359":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "4416":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __nested_webpack_require_94401__) {

var fails = __nested_webpack_require_94401__("d039");
var classof = __nested_webpack_require_94401__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __nested_webpack_require_94986__) {

var wellKnownSymbol = __nested_webpack_require_94986__("b622");
var create = __nested_webpack_require_94986__("7c73");
var definePropertyModule = __nested_webpack_require_94986__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "4889":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_95705__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_95705__("df9e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_95705__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "48a0":
/***/ (function(module, exports, __nested_webpack_require_97882__) {

var baseForOwn = __nested_webpack_require_97882__("242e"),
    createBaseEach = __nested_webpack_require_97882__("950a");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __nested_webpack_require_98423__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __nested_webpack_require_98423__("2d00");
var fails = __nested_webpack_require_98423__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "495a":
/***/ (function(module, exports, __nested_webpack_require_99200__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_99200__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-pane[data-v-74ad501d]{min-width:250px}.vc-header[data-v-74ad501d]{display:flex;justify-content:center;align-items:center;padding:10px 18px 0 18px}.vc-header.align-left[data-v-74ad501d]{justify-content:flex-start}.vc-header.align-right[data-v-74ad501d]{justify-content:flex-end}.vc-title[data-v-74ad501d]{font-size:var(--text-lg);color:var(--gray-800);font-weight:var(--font-semibold);line-height:28px;cursor:pointer;-webkit-user-select:none;user-select:none;white-space:nowrap}.vc-title[data-v-74ad501d]:hover{opacity:.75}.vc-weeknumber[data-v-74ad501d]{position:relative}.vc-weeknumber[data-v-74ad501d],.vc-weeknumber-content[data-v-74ad501d]{display:flex;justify-content:center;align-items:center}.vc-weeknumber-content[data-v-74ad501d]{font-size:var(--text-xs);font-weight:var(--font-medium);font-style:italic;width:28px;height:28px;margin-top:2px;color:var(--gray-500);-webkit-user-select:none;user-select:none}.vc-weeknumber-content.is-left-outside[data-v-74ad501d]{position:absolute;left:var(--weeknumber-offset)}.vc-weeknumber-content.is-right-outside[data-v-74ad501d]{position:absolute;right:var(--weeknumber-offset)}.vc-weeks[data-v-74ad501d]{display:grid;grid-template-columns:repeat(7,1fr);position:relative;-webkit-overflow-scrolling:touch;padding:5px;min-width:250px}.vc-weeks.vc-show-weeknumbers[data-v-74ad501d]{grid-template-columns:auto repeat(7,1fr)}.vc-weeks.vc-show-weeknumbers.is-right[data-v-74ad501d]{grid-template-columns:repeat(7,1fr) auto}.vc-weekday[data-v-74ad501d]{text-align:center;color:var(--gray-500);font-size:var(--text-sm);font-weight:var(--font-bold);line-height:14px;padding-top:4px;padding-bottom:8px;cursor:default;-webkit-user-select:none;user-select:none}.vc-is-dark .vc-header[data-v-74ad501d]{color:var(--gray-200)}.vc-is-dark .vc-title[data-v-74ad501d]{color:var(--gray-100)}.vc-is-dark .vc-weekday[data-v-74ad501d]{color:var(--accent-200)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "499e":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_101386__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_101386__.r(__nested_webpack_exports__);

// EXPORTS
__nested_webpack_require_101386__.d(__nested_webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "49f4":
/***/ (function(module, exports, __nested_webpack_require_108623__) {

var nativeCreate = __nested_webpack_require_108623__("6044");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "4bb5":
/***/ (function(module, exports, __nested_webpack_require_108989__) {

var castPath = __nested_webpack_require_108989__("e2e4"),
    last = __nested_webpack_require_108989__("4416"),
    parent = __nested_webpack_require_108989__("8296"),
    toKey = __nested_webpack_require_108989__("f4d6");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ "4cef":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "4cfe":
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __nested_webpack_require_110740__) {

var toIndexedObject = __nested_webpack_require_110740__("fc6a");
var toLength = __nested_webpack_require_110740__("50c4");
var toAbsoluteIndex = __nested_webpack_require_110740__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4d8c":
/***/ (function(module, exports, __nested_webpack_require_112085__) {

var baseFlatten = __nested_webpack_require_112085__("5c69");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ "4f50":
/***/ (function(module, exports, __nested_webpack_require_112660__) {

var assignMergeValue = __nested_webpack_require_112660__("b760"),
    cloneBuffer = __nested_webpack_require_112660__("e538"),
    cloneTypedArray = __nested_webpack_require_112660__("c8fe"),
    copyArray = __nested_webpack_require_112660__("4359"),
    initCloneObject = __nested_webpack_require_112660__("fa21"),
    isArguments = __nested_webpack_require_112660__("d370"),
    isArray = __nested_webpack_require_112660__("6747"),
    isArrayLikeObject = __nested_webpack_require_112660__("dcbe"),
    isBuffer = __nested_webpack_require_112660__("0d24"),
    isFunction = __nested_webpack_require_112660__("9520"),
    isObject = __nested_webpack_require_112660__("1a8c"),
    isPlainObject = __nested_webpack_require_112660__("60ed"),
    isTypedArray = __nested_webpack_require_112660__("73ac"),
    safeGet = __nested_webpack_require_112660__("8adb"),
    toPlainObject = __nested_webpack_require_112660__("8de2");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "501e":
/***/ (function(module, exports, __nested_webpack_require_115845__) {

var baseGetTag = __nested_webpack_require_115845__("3729"),
    isObjectLike = __nested_webpack_require_115845__("1310");

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __nested_webpack_require_116820__) {

var toInteger = __nested_webpack_require_116820__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "50d8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "5135":
/***/ (function(module, exports, __nested_webpack_require_117761__) {

var toObject = __nested_webpack_require_117761__("7b0b");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __nested_webpack_require_118044__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __nested_webpack_require_118044__("d784");
var fails = __nested_webpack_require_118044__("d039");
var anObject = __nested_webpack_require_118044__("825a");
var toLength = __nested_webpack_require_118044__("50c4");
var toInteger = __nested_webpack_require_118044__("a691");
var requireObjectCoercible = __nested_webpack_require_118044__("1d80");
var advanceStringIndex = __nested_webpack_require_118044__("8aa5");
var getSubstitution = __nested_webpack_require_118044__("0cb2");
var regExpExec = __nested_webpack_require_118044__("14c3");
var wellKnownSymbol = __nested_webpack_require_118044__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, this, string, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(this);
      var S = String(string);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "53b1":
/***/ (function(module, exports, __nested_webpack_require_122907__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_122907__("495a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_122907__("499e").default
var update = add("2a6e04f4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "54eb":
/***/ (function(module, exports, __nested_webpack_require_123400__) {

var copyObject = __nested_webpack_require_123400__("8eeb"),
    getSymbols = __nested_webpack_require_123400__("32f4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "55a3":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __nested_webpack_require_124322__) {

var IS_PURE = __nested_webpack_require_124322__("c430");
var store = __nested_webpack_require_124322__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __nested_webpack_require_124745__) {

var getBuiltIn = __nested_webpack_require_124745__("d066");
var getOwnPropertyNamesModule = __nested_webpack_require_124745__("241c");
var getOwnPropertySymbolsModule = __nested_webpack_require_124745__("7418");
var anObject = __nested_webpack_require_124745__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "57a5":
/***/ (function(module, exports, __nested_webpack_require_125376__) {

var overArg = __nested_webpack_require_125376__("91e9");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "585a":
/***/ (function(module, exports, __nested_webpack_require_125670__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_125670__("c8ba")))

/***/ }),

/***/ "5b01":
/***/ (function(module, exports, __nested_webpack_require_126043__) {

var copyObject = __nested_webpack_require_126043__("8eeb"),
    keys = __nested_webpack_require_126043__("ec69");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "5c69":
/***/ (function(module, exports, __nested_webpack_require_126610__) {

var arrayPush = __nested_webpack_require_126610__("087d"),
    isFlattenable = __nested_webpack_require_126610__("0621");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5d89":
/***/ (function(module, exports, __nested_webpack_require_128135__) {

var cloneArrayBuffer = __nested_webpack_require_128135__("f8af");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "5e2e":
/***/ (function(module, exports, __nested_webpack_require_128723__) {

var listCacheClear = __nested_webpack_require_128723__("28c9"),
    listCacheDelete = __nested_webpack_require_128723__("69d5"),
    listCacheGet = __nested_webpack_require_128723__("b4c0"),
    listCacheHas = __nested_webpack_require_128723__("fba5"),
    listCacheSet = __nested_webpack_require_128723__("67ca");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "6044":
/***/ (function(module, exports, __nested_webpack_require_129676__) {

var getNative = __nested_webpack_require_129676__("0b07");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "60ed":
/***/ (function(module, exports, __nested_webpack_require_129951__) {

var baseGetTag = __nested_webpack_require_129951__("3729"),
    getPrototype = __nested_webpack_require_129951__("2dcb"),
    isObjectLike = __nested_webpack_require_129951__("1310");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "6220":
/***/ (function(module, exports, __nested_webpack_require_131691__) {

var baseIsDate = __nested_webpack_require_131691__("b1d2"),
    baseUnary = __nested_webpack_require_131691__("b047"),
    nodeUtil = __nested_webpack_require_131691__("99d3");

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "642a":
/***/ (function(module, exports, __nested_webpack_require_132989__) {

var baseIsMatch = __nested_webpack_require_132989__("966f"),
    getMatchData = __nested_webpack_require_132989__("3bb4"),
    matchesStrictComparable = __nested_webpack_require_132989__("20ec");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __nested_webpack_require_133776__) {

var toInteger = __nested_webpack_require_133776__("a691");
var requireObjectCoercible = __nested_webpack_require_133776__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "656b":
/***/ (function(module, exports, __nested_webpack_require_134975__) {

var castPath = __nested_webpack_require_134975__("e2e4"),
    toKey = __nested_webpack_require_134975__("f4d6");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "6679":
/***/ (function(module, exports, __nested_webpack_require_135688__) {

var baseGetTag = __nested_webpack_require_135688__("3729"),
    isObjectLike = __nested_webpack_require_135688__("1310");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ "6747":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "67ca":
/***/ (function(module, exports, __nested_webpack_require_137009__) {

var assocIndexOf = __nested_webpack_require_137009__("cb5a");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "69d5":
/***/ (function(module, exports, __nested_webpack_require_137647__) {

var assocIndexOf = __nested_webpack_require_137647__("cb5a");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __nested_webpack_require_138507__) {

var NATIVE_WEAK_MAP = __nested_webpack_require_138507__("7f9a");
var global = __nested_webpack_require_138507__("da84");
var isObject = __nested_webpack_require_138507__("861d");
var createNonEnumerableProperty = __nested_webpack_require_138507__("9112");
var objectHas = __nested_webpack_require_138507__("5135");
var shared = __nested_webpack_require_138507__("c6cd");
var sharedKey = __nested_webpack_require_138507__("f772");
var hiddenKeys = __nested_webpack_require_138507__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6a43":
/***/ (function(module, exports, __nested_webpack_require_140439__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_140439__("a10d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_140439__("499e").default
var update = add("79e769b1", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __nested_webpack_require_140932__) {

var global = __nested_webpack_require_140932__("da84");
var createNonEnumerableProperty = __nested_webpack_require_140932__("9112");
var has = __nested_webpack_require_140932__("5135");
var setGlobal = __nested_webpack_require_140932__("ce4e");
var inspectSource = __nested_webpack_require_140932__("8925");
var InternalStateModule = __nested_webpack_require_140932__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f6c":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "6fcd":
/***/ (function(module, exports, __nested_webpack_require_143048__) {

var baseTimes = __nested_webpack_require_143048__("50d8"),
    isArguments = __nested_webpack_require_143048__("d370"),
    isArray = __nested_webpack_require_143048__("6747"),
    isBuffer = __nested_webpack_require_143048__("0d24"),
    isIndex = __nested_webpack_require_143048__("c098"),
    isTypedArray = __nested_webpack_require_143048__("73ac");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "70b8":
/***/ (function(module, exports, __nested_webpack_require_144938__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_144938__("fcff");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_144938__("499e").default
var update = add("407d10db", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "72af":
/***/ (function(module, exports, __nested_webpack_require_145431__) {

var createBaseFor = __nested_webpack_require_145431__("99cd");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "72f0":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "72f5":
/***/ (function(module, exports, __nested_webpack_require_146699__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_146699__("9e2e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_146699__("499e").default
var update = add("2997fbdf", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "73ac":
/***/ (function(module, exports, __nested_webpack_require_147192__) {

var baseIsTypedArray = __nested_webpack_require_147192__("743f"),
    baseUnary = __nested_webpack_require_147192__("b047"),
    nodeUtil = __nested_webpack_require_147192__("99d3");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "743f":
/***/ (function(module, exports, __nested_webpack_require_148153__) {

var baseGetTag = __nested_webpack_require_148153__("3729"),
    isLength = __nested_webpack_require_148153__("b218"),
    isObjectLike = __nested_webpack_require_148153__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "7530":
/***/ (function(module, exports, __nested_webpack_require_150470__) {

var isObject = __nested_webpack_require_150470__("1a8c");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "76dd":
/***/ (function(module, exports, __nested_webpack_require_151246__) {

var baseToString = __nested_webpack_require_151246__("ce86");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7948":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "79bc":
/***/ (function(module, exports, __nested_webpack_require_152771__) {

var getNative = __nested_webpack_require_152771__("0b07"),
    root = __nested_webpack_require_152771__("2b3e");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "7a48":
/***/ (function(module, exports, __nested_webpack_require_153063__) {

var nativeCreate = __nested_webpack_require_153063__("6044");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __nested_webpack_require_153774__) {

var requireObjectCoercible = __nested_webpack_require_153774__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7b83":
/***/ (function(module, exports, __nested_webpack_require_154084__) {

var mapCacheClear = __nested_webpack_require_154084__("7c64"),
    mapCacheDelete = __nested_webpack_require_154084__("93ed"),
    mapCacheGet = __nested_webpack_require_154084__("2478"),
    mapCacheHas = __nested_webpack_require_154084__("a524"),
    mapCacheSet = __nested_webpack_require_154084__("1fc8");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "7b97":
/***/ (function(module, exports, __nested_webpack_require_155042__) {

var Stack = __nested_webpack_require_155042__("7e64"),
    equalArrays = __nested_webpack_require_155042__("a2be"),
    equalByTag = __nested_webpack_require_155042__("1c3c"),
    equalObjects = __nested_webpack_require_155042__("b1e5"),
    getTag = __nested_webpack_require_155042__("42a2"),
    isArray = __nested_webpack_require_155042__("6747"),
    isBuffer = __nested_webpack_require_155042__("0d24"),
    isTypedArray = __nested_webpack_require_155042__("73ac");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "7c64":
/***/ (function(module, exports, __nested_webpack_require_158172__) {

var Hash = __nested_webpack_require_158172__("e24b"),
    ListCache = __nested_webpack_require_158172__("5e2e"),
    Map = __nested_webpack_require_158172__("79bc");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __nested_webpack_require_158672__) {

var anObject = __nested_webpack_require_158672__("825a");
var defineProperties = __nested_webpack_require_158672__("37e8");
var enumBugKeys = __nested_webpack_require_158672__("7839");
var hiddenKeys = __nested_webpack_require_158672__("d012");
var html = __nested_webpack_require_158672__("1be4");
var documentCreateElement = __nested_webpack_require_158672__("cc12");
var sharedKey = __nested_webpack_require_158672__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7d1f":
/***/ (function(module, exports, __nested_webpack_require_161568__) {

var arrayPush = __nested_webpack_require_161568__("087d"),
    isArray = __nested_webpack_require_161568__("6747");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __nested_webpack_require_162402__) {

"use strict";

var $ = __nested_webpack_require_162402__("23e7");
var createIteratorConstructor = __nested_webpack_require_162402__("9ed3");
var getPrototypeOf = __nested_webpack_require_162402__("e163");
var setPrototypeOf = __nested_webpack_require_162402__("d2bb");
var setToStringTag = __nested_webpack_require_162402__("d44e");
var createNonEnumerableProperty = __nested_webpack_require_162402__("9112");
var redefine = __nested_webpack_require_162402__("6eeb");
var wellKnownSymbol = __nested_webpack_require_162402__("b622");
var IS_PURE = __nested_webpack_require_162402__("c430");
var Iterators = __nested_webpack_require_162402__("3f8c");
var IteratorsCore = __nested_webpack_require_162402__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7dfe":
/***/ (function(module, exports, __nested_webpack_require_166393__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_166393__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".none-enter-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c]{transition-duration:0s}.fade-enter-active[data-v-5be4b00c],.fade-leave-active[data-v-5be4b00c],.slide-down-enter-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-enter-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-enter-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-enter-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{transition:transform var(--slide-duration) var(--slide-timing),opacity var(--slide-duration) var(--slide-timing);-webkit-backface-visibility:hidden;backface-visibility:hidden}.fade-leave-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{position:absolute;width:100%}.fade-enter[data-v-5be4b00c],.fade-leave-to[data-v-5be4b00c],.none-enter[data-v-5be4b00c],.none-leave-to[data-v-5be4b00c],.slide-down-enter[data-v-5be4b00c],.slide-down-leave-to[data-v-5be4b00c],.slide-left-enter[data-v-5be4b00c],.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{opacity:0}.slide-left-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c]{transform:translateX(var(--slide-translate))}.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c]{transform:translateX(calc(var(--slide-translate)*-1))}.slide-down-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c]{transform:translateY(var(--slide-translate))}.slide-down-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{transform:translateY(calc(var(--slide-translate)*-1))}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7e64":
/***/ (function(module, exports, __nested_webpack_require_168532__) {

var ListCache = __nested_webpack_require_168532__("5e2e"),
    stackClear = __nested_webpack_require_168532__("efb6"),
    stackDelete = __nested_webpack_require_168532__("2fcc"),
    stackGet = __nested_webpack_require_168532__("802a"),
    stackHas = __nested_webpack_require_168532__("55a3"),
    stackSet = __nested_webpack_require_168532__("d02c");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "7ed2":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "7efe":
/***/ (function(module) {

module.exports = JSON.parse("{\"title\":\"MMMM YYYY\",\"weekdays\":\"W\",\"navMonths\":\"MMM\",\"input\":[\"L\",\"YYYY-MM-DD\",\"YYYY/MM/DD\"],\"inputDateTime\":[\"L h:mm A\",\"YYYY-MM-DD h:mm A\",\"YYYY/MM/DD h:mm A\"],\"inputDateTime24hr\":[\"L HH:mm\",\"YYYY-MM-DD HH:mm\",\"YYYY/MM/DD HH:mm\"],\"inputTime\":[\"h:mm A\"],\"inputTime24hr\":[\"HH:mm\"],\"dayPopover\":\"WWW, MMM D, YYYY\",\"data\":[\"L\",\"YYYY-MM-DD\",\"YYYY/MM/DD\"],\"iso\":\"YYYY-MM-DDTHH:mm:ss.SSSZ\"}");

/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __nested_webpack_require_170393__) {

var global = __nested_webpack_require_170393__("da84");
var inspectSource = __nested_webpack_require_170393__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "802a":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "8057":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __nested_webpack_require_171628__) {

var isObject = __nested_webpack_require_171628__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "8296":
/***/ (function(module, exports, __nested_webpack_require_171886__) {

var baseGet = __nested_webpack_require_171886__("656b"),
    baseSlice = __nested_webpack_require_171886__("2b10");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ "8384":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __nested_webpack_require_173050__) {

var fails = __nested_webpack_require_173050__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "85a9":
/***/ (function(module) {

module.exports = JSON.parse("{\"sm\":\"640px\",\"md\":\"768px\",\"lg\":\"1024px\",\"xl\":\"1280px\"}");

/***/ }),

/***/ "85e3":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "8604":
/***/ (function(module, exports, __nested_webpack_require_174374__) {

var baseHasIn = __nested_webpack_require_174374__("26e8"),
    hasPath = __nested_webpack_require_174374__("e2c0");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "872a":
/***/ (function(module, exports, __nested_webpack_require_175394__) {

var defineProperty = __nested_webpack_require_175394__("3b4a");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "87a9":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_176114__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeSelect_vue_vue_type_style_index_0_id_7b2eaf0a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_176114__("cecd");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeSelect_vue_vue_type_style_index_0_id_7b2eaf0a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_176114__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeSelect_vue_vue_type_style_index_0_id_7b2eaf0a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeSelect_vue_vue_type_style_index_0_id_7b2eaf0a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "8925":
/***/ (function(module, exports, __nested_webpack_require_178395__) {

var store = __nested_webpack_require_178395__("c6cd");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "89d9":
/***/ (function(module, exports, __nested_webpack_require_178816__) {

var baseGet = __nested_webpack_require_178816__("656b"),
    baseSet = __nested_webpack_require_178816__("159a"),
    castPath = __nested_webpack_require_178816__("e2e4");

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ "8a64":
/***/ (function(module, exports, __nested_webpack_require_179708__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_179708__("ad82");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_179708__("499e").default
var update = add("5fdd58c2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __nested_webpack_require_180201__) {

"use strict";

var charAt = __nested_webpack_require_180201__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8adb":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8d74":
/***/ (function(module, exports, __nested_webpack_require_181186__) {

var trimmedEndIndex = __nested_webpack_require_181186__("4cef");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "8de2":
/***/ (function(module, exports, __nested_webpack_require_181712__) {

var copyObject = __nested_webpack_require_181712__("8eeb"),
    keysIn = __nested_webpack_require_181712__("9934");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "8eeb":
/***/ (function(module, exports, __nested_webpack_require_182551__) {

var assignValue = __nested_webpack_require_182551__("32b3"),
    baseAssignValue = __nested_webpack_require_182551__("872a");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "9010":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_183691__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgIcon_vue_vue_type_style_index_0_id_63f7b5ec_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_183691__("70b8");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgIcon_vue_vue_type_style_index_0_id_63f7b5ec_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_183691__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgIcon_vue_vue_type_style_index_0_id_63f7b5ec_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SvgIcon_vue_vue_type_style_index_0_id_63f7b5ec_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __nested_webpack_require_186200__) {

var DESCRIPTORS = __nested_webpack_require_186200__("83ab");
var definePropertyModule = __nested_webpack_require_186200__("9bf2");
var createPropertyDescriptor = __nested_webpack_require_186200__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "91e9":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __nested_webpack_require_187117__) {

"use strict";

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = __nested_webpack_require_187117__("ad6d");
var stickyHelpers = __nested_webpack_require_187117__("9f7f");
var shared = __nested_webpack_require_187117__("5692");
var create = __nested_webpack_require_187117__("7c73");
var getInternalState = __nested_webpack_require_187117__("69f3").get;
var UNSUPPORTED_DOT_ALL = __nested_webpack_require_187117__("fce3");
var UNSUPPORTED_NCG = __nested_webpack_require_187117__("107c");

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(str) {
    var re = this;
    var state = getInternalState(re);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "93ed":
/***/ (function(module, exports, __nested_webpack_require_190847__) {

var getMapData = __nested_webpack_require_190847__("4245");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __nested_webpack_require_191384__) {

var fails = __nested_webpack_require_191384__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "950a":
/***/ (function(module, exports, __nested_webpack_require_192039__) {

var isArrayLike = __nested_webpack_require_192039__("30c9");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "9520":
/***/ (function(module, exports, __nested_webpack_require_193012__) {

var baseGetTag = __nested_webpack_require_193012__("3729"),
    isObject = __nested_webpack_require_193012__("1a8c");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "95ae":
/***/ (function(module, exports, __nested_webpack_require_194098__) {

var baseRest = __nested_webpack_require_194098__("100e"),
    eq = __nested_webpack_require_194098__("9638"),
    isIterateeCall = __nested_webpack_require_194098__("9aff"),
    keysIn = __nested_webpack_require_194098__("9934");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),

/***/ "9638":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "966f":
/***/ (function(module, exports, __nested_webpack_require_196822__) {

var Stack = __nested_webpack_require_196822__("7e64"),
    baseIsEqual = __nested_webpack_require_196822__("c05f");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "96f3":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),

/***/ "97d3":
/***/ (function(module, exports, __nested_webpack_require_199303__) {

var baseEach = __nested_webpack_require_199303__("48a0"),
    isArrayLike = __nested_webpack_require_199303__("30c9");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "9934":
/***/ (function(module, exports, __nested_webpack_require_200063__) {

var arrayLikeKeys = __nested_webpack_require_200063__("6fcd"),
    baseKeysIn = __nested_webpack_require_200063__("41c3"),
    isArrayLike = __nested_webpack_require_200063__("30c9");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "99cd":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "99d3":
/***/ (function(module, exports, __nested_webpack_require_201642__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __nested_webpack_require_201642__("585a");

/** Detect free variable `exports`. */
var freeExports =   true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_201642__("62e4")(module)))

/***/ }),

/***/ "9aff":
/***/ (function(module, exports, __nested_webpack_require_202827__) {

var eq = __nested_webpack_require_202827__("9638"),
    isArrayLike = __nested_webpack_require_202827__("30c9"),
    isIndex = __nested_webpack_require_202827__("c098"),
    isObject = __nested_webpack_require_202827__("1a8c");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "9b02":
/***/ (function(module, exports, __nested_webpack_require_203815__) {

var baseGet = __nested_webpack_require_203815__("656b");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __nested_webpack_require_204789__) {

var DESCRIPTORS = __nested_webpack_require_204789__("83ab");
var IE8_DOM_DEFINE = __nested_webpack_require_204789__("0cfb");
var anObject = __nested_webpack_require_204789__("825a");
var toPrimitive = __nested_webpack_require_204789__("c04e");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9e2e":
/***/ (function(module, exports, __nested_webpack_require_205686__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_205686__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-pane-container{width:100%;position:relative}.vc-pane-container.in-transition{overflow:hidden}.vc-pane-layout{display:grid}.vc-arrow{display:flex;justify-content:center;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none;pointer-events:auto;color:var(--gray-600);border-width:2px;border-style:solid;border-radius:var(--rounded);border-color:transparent}.vc-arrow:hover{background:var(--gray-200)}.vc-arrow:focus{border-color:var(--gray-300)}.vc-arrow.is-disabled{opacity:.25;pointer-events:none;cursor:not-allowed}.vc-day-popover-container{color:var(--white);background-color:var(--gray-800);border:1px solid;border-color:var(--gray-700);border-radius:var(--rounded);font-size:var(--text-xs);font-weight:var(--font-medium);padding:4px 8px;box-shadow:var(--shadow)}.vc-day-popover-header{font-size:var(--text-xs);color:var(--gray-300);font-weight:var(--font-semibold);text-align:center}.vc-arrows-container{width:100%;position:absolute;top:0;display:flex;justify-content:space-between;padding:8px 10px;pointer-events:none}.vc-arrows-container.title-left{justify-content:flex-end}.vc-arrows-container.title-right{justify-content:flex-start}.vc-is-dark .vc-arrow{color:var(--white)}.vc-is-dark .vc-arrow:hover{background:var(--gray-800)}.vc-is-dark .vc-arrow:focus{border-color:var(--gray-700)}.vc-is-dark .vc-day-popover-container{color:var(--gray-800);background-color:var(--white);border-color:var(--gray-100)}.vc-is-dark .vc-day-popover-header{color:var(--gray-700)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9e69":
/***/ (function(module, exports, __nested_webpack_require_207465__) {

var root = __nested_webpack_require_207465__("2b3e");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "9e83":
/***/ (function(module, exports, __nested_webpack_require_207676__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_207676__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-nav-popover-container{color:var(--white);font-size:var(--text-sm);font-weight:var(--font-semibold);background-color:var(--gray-800);border:1px solid;border-color:var(--gray-700);border-radius:var(--rounded-lg);padding:4px;box-shadow:var(--shadow)}.vc-is-dark .vc-nav-popover-container{color:var(--gray-800);background-color:var(--white);border-color:var(--gray-100)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9e86":
/***/ (function(module, exports, __nested_webpack_require_208331__) {

var baseAssignValue = __nested_webpack_require_208331__("872a"),
    baseForOwn = __nested_webpack_require_208331__("242e"),
    baseIteratee = __nested_webpack_require_208331__("badf");

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __nested_webpack_require_209755__) {

"use strict";

var IteratorPrototype = __nested_webpack_require_209755__("ae93").IteratorPrototype;
var create = __nested_webpack_require_209755__("7c73");
var createPropertyDescriptor = __nested_webpack_require_209755__("5c6c");
var setToStringTag = __nested_webpack_require_209755__("d44e");
var Iterators = __nested_webpack_require_209755__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __nested_webpack_require_210522__) {

var fails = __nested_webpack_require_210522__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
var RE = function (s, f) {
  return RegExp(s, f);
};

exports.UNSUPPORTED_Y = fails(function () {
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a029":
/***/ (function(module, exports, __nested_webpack_require_211093__) {

var arrayPush = __nested_webpack_require_211093__("087d"),
    getPrototype = __nested_webpack_require_211093__("2dcb"),
    getSymbols = __nested_webpack_require_211093__("32f4"),
    stubArray = __nested_webpack_require_211093__("d327");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "a10d":
/***/ (function(module, exports, __nested_webpack_require_211944__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_211944__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-day[data-v-4420d078]{position:relative;min-height:32px;z-index:1}.vc-day.is-not-in-month *[data-v-4420d078]{opacity:0;pointer-events:none}.vc-day-layer[data-v-4420d078]{position:absolute;left:0;right:0;top:0;bottom:0;pointer-events:none}.vc-day-box-center-center[data-v-4420d078]{display:flex;justify-content:center;align-items:center;transform-origin:50% 50%}.vc-day-box-left-center[data-v-4420d078]{display:flex;justify-content:flex-start;align-items:center;transform-origin:0 50%}.vc-day-box-right-center[data-v-4420d078]{display:flex;justify-content:flex-end;align-items:center;transform-origin:100% 50%}.vc-day-box-center-bottom[data-v-4420d078]{display:flex;justify-content:center;align-items:flex-end}.vc-day-content[data-v-4420d078]{display:flex;justify-content:center;align-items:center;font-size:var(--text-sm);font-weight:var(--font-medium);width:28px;height:28px;line-height:28px;border-radius:var(--rounded-full);-webkit-user-select:none;user-select:none;cursor:pointer}.vc-day-content[data-v-4420d078]:hover{background-color:rgba(204,214,224,.3)}.vc-day-content[data-v-4420d078]:focus{font-weight:var(--font-bold);background-color:rgba(204,214,224,.4)}.vc-day-content.is-disabled[data-v-4420d078]{color:var(--gray-400)}.vc-is-dark .vc-day-content[data-v-4420d078]:hover{background-color:rgba(114,129,151,.3)}.vc-is-dark .vc-day-content[data-v-4420d078]:focus{background-color:rgba(114,129,151,.4)}.vc-is-dark .vc-day-content.is-disabled[data-v-4420d078]{color:var(--gray-600)}.vc-highlights[data-v-4420d078]{overflow:hidden;pointer-events:none;z-index:-1}.vc-highlight[data-v-4420d078]{width:28px;height:28px}.vc-highlight.vc-highlight-base-start[data-v-4420d078]{width:50%!important;border-radius:0!important;border-right-width:0!important}.vc-highlight.vc-highlight-base-end[data-v-4420d078]{width:50%!important;border-radius:0!important;border-left-width:0!important}.vc-highlight.vc-highlight-base-middle[data-v-4420d078]{width:100%;border-radius:0!important;border-left-width:0!important;border-right-width:0!important;margin:0 -1px}.vc-dots[data-v-4420d078]{display:flex;justify-content:center;align-items:center}.vc-dot[data-v-4420d078]{width:5px;height:5px;border-radius:50%;transition:all var(--day-content-transition-time)}.vc-dot[data-v-4420d078]:not(:last-child){margin-right:3px}.vc-bars[data-v-4420d078]{display:flex;justify-content:flex-start;align-items:center;width:75%}.vc-bar[data-v-4420d078]{flex-grow:1;height:3px;transition:all var(--day-content-transition-time)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a2be":
/***/ (function(module, exports, __nested_webpack_require_214732__) {

var SetCache = __nested_webpack_require_214732__("d612"),
    arraySome = __nested_webpack_require_214732__("4284"),
    cacheHas = __nested_webpack_require_214732__("c584");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "a2db":
/***/ (function(module, exports, __nested_webpack_require_217492__) {

var Symbol = __nested_webpack_require_217492__("9e69");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "a3fd":
/***/ (function(module, exports, __nested_webpack_require_218107__) {

var arrayMap = __nested_webpack_require_218107__("7948");

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),

/***/ "a454":
/***/ (function(module, exports, __nested_webpack_require_218733__) {

var constant = __nested_webpack_require_218733__("72f0"),
    defineProperty = __nested_webpack_require_218733__("3b4a"),
    identity = __nested_webpack_require_218733__("cd9d");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "a524":
/***/ (function(module, exports, __nested_webpack_require_219469__) {

var getMapData = __nested_webpack_require_219469__("4245");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "a59b":
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a994":
/***/ (function(module, exports, __nested_webpack_require_220728__) {

var baseGetAllKeys = __nested_webpack_require_220728__("7d1f"),
    getSymbols = __nested_webpack_require_220728__("32f4"),
    keys = __nested_webpack_require_220728__("ec69");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __nested_webpack_require_221279__) {

"use strict";

var $ = __nested_webpack_require_221279__("23e7");
var exec = __nested_webpack_require_221279__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ac41":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __nested_webpack_require_222035__) {

"use strict";

var anObject = __nested_webpack_require_222035__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ad82":
/***/ (function(module, exports, __nested_webpack_require_222599__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_222599__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-time-picker[data-v-f4e11af8]{display:flex;align-items:center;padding:8px}.vc-time-picker.vc-invalid[data-v-f4e11af8]{pointer-events:none;opacity:.5}.vc-time-picker.vc-bordered[data-v-f4e11af8]{border-top:1px solid var(--gray-400)}.vc-date-time[data-v-f4e11af8]{margin-left:8px}.vc-disabled[data-v-f4e11af8]{pointer-events:none;opacity:.5}.vc-time-icon[data-v-f4e11af8]{width:16px;height:16px;color:var(--gray-600)}.vc-date[data-v-f4e11af8]{display:flex;align-items:center;font-size:var(--text-sm);font-weight:var(--font-semibold);text-transform:uppercase;padding:0 0 4px 4px;margin-top:-4px}.vc-date .vc-weekday[data-v-f4e11af8]{color:var(--gray-700);letter-spacing:var(--tracking-wide)}.vc-date .vc-month[data-v-f4e11af8]{color:var(--accent-600);margin-left:8px}.vc-date .vc-day[data-v-f4e11af8]{color:var(--accent-600);margin-left:4px}.vc-date .vc-year[data-v-f4e11af8]{color:var(--gray-500);margin-left:8px}.vc-am-pm[data-v-f4e11af8],.vc-time[data-v-f4e11af8]{display:flex;align-items:center}.vc-am-pm[data-v-f4e11af8]{background:var(--gray-200);margin-left:8px;padding:4px;border-radius:var(--rounded);height:30px}.vc-am-pm button[data-v-f4e11af8]{color:var(--gray-900);font-size:var(--text-sm);font-weight:var(--font-medium);padding:0 4px;background:transparent;border:2px solid transparent;border-radius:var(--rounded);line-height:var(--leading-snug)}.vc-am-pm button[data-v-f4e11af8]:hover{color:var(--gray-600)}.vc-am-pm button[data-v-f4e11af8]:focus{border-color:var(--accent-400)}.vc-am-pm button.active[data-v-f4e11af8]{background:var(--accent-600);color:var(--white)}.vc-am-pm button.active[data-v-f4e11af8]:hover{background:var(--accent-500)}.vc-am-pm button.active[data-v-f4e11af8]:focus{border-color:var(--accent-400)}.vc-is-dark .vc-time-picker[data-v-f4e11af8]{border-color:var(--gray-700)}.vc-is-dark .vc-time-icon[data-v-f4e11af8],.vc-is-dark .vc-weekday[data-v-f4e11af8]{color:var(--gray-400)}.vc-is-dark .vc-day[data-v-f4e11af8],.vc-is-dark .vc-month[data-v-f4e11af8]{color:var(--accent-400)}.vc-is-dark .vc-year[data-v-f4e11af8]{color:var(--gray-500)}.vc-is-dark .vc-am-pm[data-v-f4e11af8]{background:var(--gray-700)}.vc-is-dark .vc-am-pm[data-v-f4e11af8]:focus{border-color:var(--accent-500)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]{color:var(--gray-100)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]:hover{color:var(--gray-400)}.vc-is-dark .vc-am-pm button[data-v-f4e11af8]:focus{border-color:var(--accent-500)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]{background:var(--accent-500);color:var(--white)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]:hover{background:var(--accent-600)}.vc-is-dark .vc-am-pm button.active[data-v-f4e11af8]:focus{border-color:var(--accent-500)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "adc8":
/***/ (function(module, exports, __nested_webpack_require_225607__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_225607__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-day-popover-row[data-v-eb5afd1a]{--day-content-transition-time:0.13s ease-in;display:flex;align-items:center;transition:all var(--day-content-transition-time)}.vc-day-popover-row[data-v-eb5afd1a]:not(:first-child){margin-top:3px}.vc-day-popover-row-indicator[data-v-eb5afd1a]{display:flex;justify-content:center;align-items:center;flex-grow:0;width:15px;margin-right:3px}.vc-day-popover-row-indicator span[data-v-eb5afd1a]{transition:all var(--day-content-transition-time)}.vc-day-popover-row-content[data-v-eb5afd1a]{display:flex;align-items:center;flex-wrap:none;flex-grow:1;width:max-content}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __nested_webpack_require_226491__) {

"use strict";

var fails = __nested_webpack_require_226491__("d039");
var getPrototypeOf = __nested_webpack_require_226491__("e163");
var createNonEnumerableProperty = __nested_webpack_require_226491__("9112");
var has = __nested_webpack_require_226491__("5135");
var wellKnownSymbol = __nested_webpack_require_226491__("b622");
var IS_PURE = __nested_webpack_require_226491__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b047":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "b1d2":
/***/ (function(module, exports, __nested_webpack_require_228624__) {

var baseGetTag = __nested_webpack_require_228624__("3729"),
    isObjectLike = __nested_webpack_require_228624__("1310");

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),

/***/ "b1e5":
/***/ (function(module, exports, __nested_webpack_require_229217__) {

var getAllKeys = __nested_webpack_require_229217__("a994");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "b218":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "b4b0":
/***/ (function(module, exports, __nested_webpack_require_233140__) {

var baseTrim = __nested_webpack_require_233140__("8d74"),
    isObject = __nested_webpack_require_233140__("1a8c"),
    isSymbol = __nested_webpack_require_233140__("ffd6");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "b4c0":
/***/ (function(module, exports, __nested_webpack_require_234760__) {

var assocIndexOf = __nested_webpack_require_234760__("cb5a");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "b5a7":
/***/ (function(module, exports, __nested_webpack_require_235265__) {

var getNative = __nested_webpack_require_235265__("0b07"),
    root = __nested_webpack_require_235265__("2b3e");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __nested_webpack_require_235572__) {

var global = __nested_webpack_require_235572__("da84");
var shared = __nested_webpack_require_235572__("5692");
var has = __nested_webpack_require_235572__("5135");
var uid = __nested_webpack_require_235572__("90e3");
var NATIVE_SYMBOL = __nested_webpack_require_235572__("4930");
var USE_SYMBOL_AS_UID = __nested_webpack_require_235572__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b760":
/***/ (function(module, exports, __nested_webpack_require_236472__) {

var baseAssignValue = __nested_webpack_require_236472__("872a"),
    eq = __nested_webpack_require_236472__("9638");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "badf":
/***/ (function(module, exports, __nested_webpack_require_237148__) {

var baseMatches = __nested_webpack_require_237148__("642a"),
    baseMatchesProperty = __nested_webpack_require_237148__("1838"),
    identity = __nested_webpack_require_237148__("cd9d"),
    isArray = __nested_webpack_require_237148__("6747"),
    property = __nested_webpack_require_237148__("f9ce");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "bbc0":
/***/ (function(module, exports, __nested_webpack_require_238142__) {

var nativeCreate = __nested_webpack_require_238142__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "bdb3":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_239011__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popover_vue_vue_type_style_index_0_id_39b30300_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_239011__("e052");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popover_vue_vue_type_style_index_0_id_39b30300_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_239011__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popover_vue_vue_type_style_index_0_id_39b30300_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Popover_vue_vue_type_style_index_0_id_39b30300_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __nested_webpack_require_241280__) {

var isObject = __nested_webpack_require_241280__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c05f":
/***/ (function(module, exports, __nested_webpack_require_242130__) {

var baseIsEqualDeep = __nested_webpack_require_242130__("7b97"),
    isObjectLike = __nested_webpack_require_242130__("1310");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "c098":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "c1c9":
/***/ (function(module, exports, __nested_webpack_require_244055__) {

var baseSetToString = __nested_webpack_require_244055__("a454"),
    shortOut = __nested_webpack_require_244055__("f3c1");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "c2b6":
/***/ (function(module, exports, __nested_webpack_require_244534__) {

var cloneArrayBuffer = __nested_webpack_require_244534__("f8af"),
    cloneDataView = __nested_webpack_require_244534__("5d89"),
    cloneRegExp = __nested_webpack_require_244534__("6f6c"),
    cloneSymbol = __nested_webpack_require_244534__("a2db"),
    cloneTypedArray = __nested_webpack_require_244534__("c8fe");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "c3fc":
/***/ (function(module, exports, __nested_webpack_require_246878__) {

var getTag = __nested_webpack_require_246878__("42a2"),
    isObjectLike = __nested_webpack_require_246878__("1310");

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c584":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __nested_webpack_require_248105__) {

var global = __nested_webpack_require_248105__("da84");
var setGlobal = __nested_webpack_require_248105__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6cf":
/***/ (function(module, exports, __nested_webpack_require_248390__) {

var flatten = __nested_webpack_require_248390__("4d8c"),
    overRest = __nested_webpack_require_248390__("2286"),
    setToString = __nested_webpack_require_248390__("c1c9");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ "c869":
/***/ (function(module, exports, __nested_webpack_require_248945__) {

var getNative = __nested_webpack_require_248945__("0b07"),
    root = __nested_webpack_require_248945__("2b3e");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "c87c":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8fe":
/***/ (function(module, exports, __nested_webpack_require_250527__) {

var cloneArrayBuffer = __nested_webpack_require_250527__("f8af");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __nested_webpack_require_251135__) {

var has = __nested_webpack_require_251135__("5135");
var toIndexedObject = __nested_webpack_require_251135__("fc6a");
var indexOf = __nested_webpack_require_251135__("4d64").indexOf;
var hiddenKeys = __nested_webpack_require_251135__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cb5a":
/***/ (function(module, exports, __nested_webpack_require_251768__) {

var eq = __nested_webpack_require_251768__("9638");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __nested_webpack_require_252351__) {

var global = __nested_webpack_require_252351__("da84");
var isObject = __nested_webpack_require_252351__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc45":
/***/ (function(module, exports, __nested_webpack_require_252766__) {

var baseIsMap = __nested_webpack_require_252766__("1a2d"),
    baseUnary = __nested_webpack_require_252766__("b047"),
    nodeUtil = __nested_webpack_require_252766__("99d3");

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ "cd9d":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __nested_webpack_require_253909__) {

var global = __nested_webpack_require_253909__("da84");
var createNonEnumerableProperty = __nested_webpack_require_253909__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ce86":
/***/ (function(module, exports, __nested_webpack_require_254267__) {

var Symbol = __nested_webpack_require_254267__("9e69"),
    arrayMap = __nested_webpack_require_254267__("7948"),
    isArray = __nested_webpack_require_254267__("6747"),
    isSymbol = __nested_webpack_require_254267__("ffd6");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "cebd":
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),

/***/ "cecd":
/***/ (function(module, exports, __nested_webpack_require_255957__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_255957__("2202");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_255957__("499e").default
var update = add("8c0a5c0c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d02c":
/***/ (function(module, exports, __nested_webpack_require_256534__) {

var ListCache = __nested_webpack_require_256534__("5e2e"),
    Map = __nested_webpack_require_256534__("79bc"),
    MapCache = __nested_webpack_require_256534__("7b83");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __nested_webpack_require_257661__) {

var path = __nested_webpack_require_257661__("428f");
var global = __nested_webpack_require_257661__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __nested_webpack_require_258902__) {

/* eslint-disable no-proto -- safe */
var anObject = __nested_webpack_require_258902__("825a");
var aPossiblePrototype = __nested_webpack_require_258902__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d327":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "d370":
/***/ (function(module, exports, __nested_webpack_require_260418__) {

var baseIsArguments = __nested_webpack_require_260418__("253c"),
    isObjectLike = __nested_webpack_require_260418__("1310");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "d438":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_261540__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PopoverRow_vue_vue_type_style_index_0_id_eb5afd1a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_261540__("3db9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PopoverRow_vue_vue_type_style_index_0_id_eb5afd1a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_261540__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PopoverRow_vue_vue_type_style_index_0_id_eb5afd1a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PopoverRow_vue_vue_type_style_index_0_id_eb5afd1a_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __nested_webpack_require_263821__) {

var defineProperty = __nested_webpack_require_263821__("9bf2").f;
var has = __nested_webpack_require_263821__("5135");
var wellKnownSymbol = __nested_webpack_require_263821__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d612":
/***/ (function(module, exports, __nested_webpack_require_264297__) {

var MapCache = __nested_webpack_require_264297__("7b83"),
    setCacheAdd = __nested_webpack_require_264297__("7ed2"),
    setCacheHas = __nested_webpack_require_264297__("dc0f");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __nested_webpack_require_265022__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__nested_webpack_require_265022__("ac1f");
var redefine = __nested_webpack_require_265022__("6eeb");
var regexpExec = __nested_webpack_require_265022__("9263");
var fails = __nested_webpack_require_265022__("d039");
var wellKnownSymbol = __nested_webpack_require_265022__("b622");
var createNonEnumerableProperty = __nested_webpack_require_265022__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d7ee":
/***/ (function(module, exports, __nested_webpack_require_267639__) {

var baseIsSet = __nested_webpack_require_267639__("c3fc"),
    baseUnary = __nested_webpack_require_267639__("b047"),
    nodeUtil = __nested_webpack_require_267639__("99d3");

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ "da03":
/***/ (function(module, exports, __nested_webpack_require_268349__) {

var root = __nested_webpack_require_268349__("2b3e");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __nested_webpack_require_268599__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_268599__("c8ba")))

/***/ }),

/***/ "dc0f":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "dc57":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "dc8c":
/***/ (function(module, exports, __nested_webpack_require_270387__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_270387__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-container{--white:#fff;--black:#000;--gray-100:#f7fafc;--gray-200:#edf2f7;--gray-300:#e2e8f0;--gray-400:#cbd5e0;--gray-500:#a0aec0;--gray-600:#718096;--gray-700:#4a5568;--gray-800:#2d3748;--gray-900:#1a202c;--red-100:#fff5f5;--red-200:#fed7d7;--red-300:#feb2b2;--red-400:#fc8181;--red-500:#f56565;--red-600:#e53e3e;--red-700:#c53030;--red-800:#9b2c2c;--red-900:#742a2a;--orange-100:#fffaf0;--orange-200:#feebc8;--orange-300:#fbd38d;--orange-400:#f6ad55;--orange-500:#ed8936;--orange-600:#dd6b20;--orange-700:#c05621;--orange-800:#9c4221;--orange-900:#7b341e;--yellow-100:ivory;--yellow-200:#fefcbf;--yellow-300:#faf089;--yellow-400:#f6e05e;--yellow-500:#ecc94b;--yellow-600:#d69e2e;--yellow-700:#b7791f;--yellow-800:#975a16;--yellow-900:#744210;--green-100:#f0fff4;--green-200:#c6f6d5;--green-300:#9ae6b4;--green-400:#68d391;--green-500:#48bb78;--green-600:#38a169;--green-700:#2f855a;--green-800:#276749;--green-900:#22543d;--teal-100:#e6fffa;--teal-200:#b2f5ea;--teal-300:#81e6d9;--teal-400:#4fd1c5;--teal-500:#38b2ac;--teal-600:#319795;--teal-700:#2c7a7b;--teal-800:#285e61;--teal-900:#234e52;--blue-100:#ebf8ff;--blue-200:#bee3f8;--blue-300:#90cdf4;--blue-400:#63b3ed;--blue-500:#4299e1;--blue-600:#3182ce;--blue-700:#2b6cb0;--blue-800:#2c5282;--blue-900:#2a4365;--indigo-100:#ebf4ff;--indigo-200:#c3dafe;--indigo-300:#a3bffa;--indigo-400:#7f9cf5;--indigo-500:#667eea;--indigo-600:#5a67d8;--indigo-700:#4c51bf;--indigo-800:#434190;--indigo-900:#3c366b;--purple-100:#faf5ff;--purple-200:#e9d8fd;--purple-300:#d6bcfa;--purple-400:#b794f4;--purple-500:#9f7aea;--purple-600:#805ad5;--purple-700:#6b46c1;--purple-800:#553c9a;--purple-900:#44337a;--pink-100:#fff5f7;--pink-200:#fed7e2;--pink-300:#fbb6ce;--pink-400:#f687b3;--pink-500:#ed64a6;--pink-600:#d53f8c;--pink-700:#b83280;--pink-800:#97266d;--pink-900:#702459}.vc-container.vc-red{--accent-100:var(--red-100);--accent-200:var(--red-200);--accent-300:var(--red-300);--accent-400:var(--red-400);--accent-500:var(--red-500);--accent-600:var(--red-600);--accent-700:var(--red-700);--accent-800:var(--red-800);--accent-900:var(--red-900)}.vc-container.vc-orange{--accent-100:var(--orange-100);--accent-200:var(--orange-200);--accent-300:var(--orange-300);--accent-400:var(--orange-400);--accent-500:var(--orange-500);--accent-600:var(--orange-600);--accent-700:var(--orange-700);--accent-800:var(--orange-800);--accent-900:var(--orange-900)}.vc-container.vc-yellow{--accent-100:var(--yellow-100);--accent-200:var(--yellow-200);--accent-300:var(--yellow-300);--accent-400:var(--yellow-400);--accent-500:var(--yellow-500);--accent-600:var(--yellow-600);--accent-700:var(--yellow-700);--accent-800:var(--yellow-800);--accent-900:var(--yellow-900)}.vc-container.vc-green{--accent-100:var(--green-100);--accent-200:var(--green-200);--accent-300:var(--green-300);--accent-400:var(--green-400);--accent-500:var(--green-500);--accent-600:var(--green-600);--accent-700:var(--green-700);--accent-800:var(--green-800);--accent-900:var(--green-900)}.vc-container.vc-teal{--accent-100:var(--teal-100);--accent-200:var(--teal-200);--accent-300:var(--teal-300);--accent-400:var(--teal-400);--accent-500:var(--teal-500);--accent-600:var(--teal-600);--accent-700:var(--teal-700);--accent-800:var(--teal-800);--accent-900:var(--teal-900)}.vc-container.vc-blue{--accent-100:var(--blue-100);--accent-200:var(--blue-200);--accent-300:var(--blue-300);--accent-400:var(--blue-400);--accent-500:var(--blue-500);--accent-600:var(--blue-600);--accent-700:var(--blue-700);--accent-800:var(--blue-800);--accent-900:var(--blue-900)}.vc-container.vc-indigo{--accent-100:var(--indigo-100);--accent-200:var(--indigo-200);--accent-300:var(--indigo-300);--accent-400:var(--indigo-400);--accent-500:var(--indigo-500);--accent-600:var(--indigo-600);--accent-700:var(--indigo-700);--accent-800:var(--indigo-800);--accent-900:var(--indigo-900)}.vc-container.vc-purple{--accent-100:var(--purple-100);--accent-200:var(--purple-200);--accent-300:var(--purple-300);--accent-400:var(--purple-400);--accent-500:var(--purple-500);--accent-600:var(--purple-600);--accent-700:var(--purple-700);--accent-800:var(--purple-800);--accent-900:var(--purple-900)}.vc-container.vc-pink{--accent-100:var(--pink-100);--accent-200:var(--pink-200);--accent-300:var(--pink-300);--accent-400:var(--pink-400);--accent-500:var(--pink-500);--accent-600:var(--pink-600);--accent-700:var(--pink-700);--accent-800:var(--pink-800);--accent-900:var(--pink-900)}.vc-container{--font-normal:400;--font-medium:500;--font-semibold:600;--font-bold:700;--text-xs:12px;--text-sm:14px;--text-base:16px;--text-lg:18px;--leading-snug:1.375;--rounded:0.25rem;--rounded-lg:0.5rem;--rounded-full:9999px;--shadow:0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06);--shadow-lg:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);--shadow-inner:inset 0 2px 4px 0 rgba(0,0,0,0.06);--slide-translate:22px;--slide-duration:0.15s;--slide-timing:ease;--day-content-transition-time:0.13s ease-in;--weeknumber-offset:-34px;position:relative;display:inline-flex;width:max-content;height:max-content;font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;color:var(--gray-900);background-color:var(--white);border:1px solid;border-color:var(--gray-400);border-radius:var(--rounded-lg);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent}.vc-container,.vc-container *{box-sizing:border-box}.vc-container:focus,.vc-container :focus{outline:none}.vc-container [role=button],.vc-container button{cursor:pointer}.vc-container.vc-is-expanded{min-width:100%}.vc-container .vc-container{border:none}.vc-container.vc-is-dark{color:var(--gray-100);background-color:var(--gray-900);border-color:var(--gray-700)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "dcbe":
/***/ (function(module, exports, __nested_webpack_require_276502__) {

var isArrayLike = __nested_webpack_require_276502__("30c9"),
    isObjectLike = __nested_webpack_require_276502__("1310");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "dd61":
/***/ (function(module, exports, __nested_webpack_require_277333__) {

var arrayMap = __nested_webpack_require_277333__("7948"),
    baseIteratee = __nested_webpack_require_277333__("badf"),
    baseMap = __nested_webpack_require_277333__("97d3"),
    isArray = __nested_webpack_require_277333__("6747");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __nested_webpack_require_279057__) {

var global = __nested_webpack_require_279057__("da84");
var DOMIterables = __nested_webpack_require_279057__("fdbc");
var ArrayIteratorMethods = __nested_webpack_require_279057__("e260");
var createNonEnumerableProperty = __nested_webpack_require_279057__("9112");
var wellKnownSymbol = __nested_webpack_require_279057__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "de5e":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_280652__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendar_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_280652__("72f5");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendar_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_280652__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendar_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendar_vue_vue_type_style_index_0_lang_postcss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __nested_webpack_require_282829__) {

var internalObjectKeys = __nested_webpack_require_282829__("ca84");
var enumBugKeys = __nested_webpack_require_282829__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df9e":
/***/ (function(module, exports, __nested_webpack_require_283236__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_283236__("9e83");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_283236__("499e").default
var update = add("29f48e5f", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e031":
/***/ (function(module, exports, __nested_webpack_require_283729__) {

var baseMerge = __nested_webpack_require_283729__("f909"),
    isObject = __nested_webpack_require_283729__("1a8c");

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),

/***/ "e052":
/***/ (function(module, exports, __nested_webpack_require_284872__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_284872__("0fb2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_284872__("499e").default
var update = add("54fe3190", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e0e7":
/***/ (function(module, exports, __nested_webpack_require_285365__) {

var isPlainObject = __nested_webpack_require_285365__("60ed");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __nested_webpack_require_285925__) {

var has = __nested_webpack_require_285925__("5135");
var toObject = __nested_webpack_require_285925__("7b0b");
var sharedKey = __nested_webpack_require_285925__("f772");
var CORRECT_PROTOTYPE_GETTER = __nested_webpack_require_285925__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __nested_webpack_require_286745__) {

var fails = __nested_webpack_require_286745__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e24b":
/***/ (function(module, exports, __nested_webpack_require_287117__) {

var hashClear = __nested_webpack_require_287117__("49f4"),
    hashDelete = __nested_webpack_require_287117__("1efc"),
    hashGet = __nested_webpack_require_287117__("bbc0"),
    hashHas = __nested_webpack_require_287117__("7a48"),
    hashSet = __nested_webpack_require_287117__("2524");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __nested_webpack_require_287973__) {

"use strict";

var toIndexedObject = __nested_webpack_require_287973__("fc6a");
var addToUnscopables = __nested_webpack_require_287973__("44d2");
var Iterators = __nested_webpack_require_287973__("3f8c");
var InternalStateModule = __nested_webpack_require_287973__("69f3");
var defineIterator = __nested_webpack_require_287973__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2a0":
/***/ (function(module, exports, __nested_webpack_require_290153__) {

var baseGetTag = __nested_webpack_require_290153__("3729"),
    isArray = __nested_webpack_require_290153__("6747"),
    isObjectLike = __nested_webpack_require_290153__("1310");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "e2c0":
/***/ (function(module, exports, __nested_webpack_require_290972__) {

var castPath = __nested_webpack_require_290972__("e2e4"),
    isArguments = __nested_webpack_require_290972__("d370"),
    isArray = __nested_webpack_require_290972__("6747"),
    isIndex = __nested_webpack_require_290972__("c098"),
    isLength = __nested_webpack_require_290972__("b218"),
    toKey = __nested_webpack_require_290972__("f4d6");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "e2e4":
/***/ (function(module, exports, __nested_webpack_require_292176__) {

var isArray = __nested_webpack_require_292176__("6747"),
    isKey = __nested_webpack_require_292176__("f608"),
    stringToPath = __nested_webpack_require_292176__("18d8"),
    toString = __nested_webpack_require_292176__("76dd");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "e380":
/***/ (function(module, exports, __nested_webpack_require_292851__) {

var MapCache = __nested_webpack_require_292851__("7b83");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "e3f8":
/***/ (function(module, exports, __nested_webpack_require_295164__) {

var baseGet = __nested_webpack_require_295164__("656b");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __nested_webpack_require_295645__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __nested_webpack_require_295645__("2b3e");

/** Detect free variable `exports`. */
var freeExports =   true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_295645__("62e4")(module)))

/***/ }),

/***/ "e893":
/***/ (function(module, exports, __nested_webpack_require_296897__) {

var has = __nested_webpack_require_296897__("5135");
var ownKeys = __nested_webpack_require_296897__("56ef");
var getOwnPropertyDescriptorModule = __nested_webpack_require_296897__("06cf");
var definePropertyModule = __nested_webpack_require_296897__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e969":
/***/ (function(module, exports, __nested_webpack_require_297542__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __nested_webpack_require_297542__("0da5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __nested_webpack_require_297542__("499e").default
var update = add("61c2bd5e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "eac5":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "ec47":
/***/ (function(module, exports, __nested_webpack_require_298578__) {

var baseToPairs = __nested_webpack_require_298578__("a3fd"),
    getTag = __nested_webpack_require_298578__("42a2"),
    mapToArray = __nested_webpack_require_298578__("edfa"),
    setToPairs = __nested_webpack_require_298578__("cebd");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),

/***/ "ec69":
/***/ (function(module, exports, __nested_webpack_require_299466__) {

var arrayLikeKeys = __nested_webpack_require_299466__("6fcd"),
    baseKeys = __nested_webpack_require_299466__("03dd"),
    isArrayLike = __nested_webpack_require_299466__("30c9");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "ec8c":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "edfa":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "ef5d":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "efb6":
/***/ (function(module, exports, __nested_webpack_require_301844__) {

var ListCache = __nested_webpack_require_301844__("5e2e");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "f3c1":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "f4d6":
/***/ (function(module, exports, __nested_webpack_require_303190__) {

var isSymbol = __nested_webpack_require_303190__("ffd6");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "f542":
/***/ (function(module, exports, __nested_webpack_require_303803__) {

var createToPairs = __nested_webpack_require_303803__("ec47"),
    keys = __nested_webpack_require_303803__("ec69");

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),

/***/ "f608":
/***/ (function(module, exports, __nested_webpack_require_304596__) {

var isArray = __nested_webpack_require_304596__("6747"),
    isSymbol = __nested_webpack_require_304596__("ffd6");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "f678":
/***/ (function(module, exports, __nested_webpack_require_305573__) {

var baseClamp = __nested_webpack_require_305573__("8384"),
    toNumber = __nested_webpack_require_305573__("b4b0");

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __nested_webpack_require_306557__) {

var shared = __nested_webpack_require_306557__("5692");
var uid = __nested_webpack_require_306557__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f8af":
/***/ (function(module, exports, __nested_webpack_require_306834__) {

var Uint8Array = __nested_webpack_require_306834__("2474");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "f909":
/***/ (function(module, exports, __nested_webpack_require_307370__) {

var Stack = __nested_webpack_require_307370__("7e64"),
    assignMergeValue = __nested_webpack_require_307370__("b760"),
    baseFor = __nested_webpack_require_307370__("72af"),
    baseMergeDeep = __nested_webpack_require_307370__("4f50"),
    isObject = __nested_webpack_require_307370__("1a8c"),
    keysIn = __nested_webpack_require_307370__("9934"),
    safeGet = __nested_webpack_require_307370__("8adb");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "f9ce":
/***/ (function(module, exports, __nested_webpack_require_308813__) {

var baseProperty = __nested_webpack_require_308813__("ef5d"),
    basePropertyDeep = __nested_webpack_require_308813__("e3f8"),
    isKey = __nested_webpack_require_308813__("f608"),
    toKey = __nested_webpack_require_308813__("f4d6");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "fa21":
/***/ (function(module, exports, __nested_webpack_require_309704__) {

var baseCreate = __nested_webpack_require_309704__("7530"),
    getPrototype = __nested_webpack_require_309704__("2dcb"),
    isPrototype = __nested_webpack_require_309704__("eac5");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "fb15":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_310292__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_310292__.r(__nested_webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __nested_webpack_require_310292__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __nested_webpack_require_310292__("ddb0");

// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/toDate/index.js

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/addDays/index.js



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/addYears/index.js



/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
/*:: import type { Window } from '../types'; */

/*:: declare function getWindow(node: Node | Window): Window; */
function getWindow(node) {
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js

/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */


function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
  ShadowRoot); */


function isShadowRoot(node) {
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe: assume body is always available
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js






 // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function getLayoutRect(element) {
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js


function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// $FlowFixMe: this is a quicker (but less type safe) way to save quite some bytes from the bundle
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js





/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the 
reference element's position.
*/

function listScrollParents(element, list) {
  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = getNodeName(scrollParent) === 'body';
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  var offsetParent = element.offsetParent;

  if (offsetParent) {
    var html = getDocumentElement(offsetParent);

    if (getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static' && getComputedStyle(html).position !== 'static') {
      return html;
    }
  }

  return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.

    if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static') {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var enums_auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var enums_start = 'start';
var enums_end = 'end';
var enums_clippingParents = 'clippingParents';
var viewport = 'viewport';
var enums_popper = 'popper';
var enums_reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + enums_start, placement + "-" + enums_end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [enums_auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + enums_start, placement + "-" + enums_end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function orderModifiers_order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = orderModifiers_order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
      options: Object.assign(Object.assign({}, existing.options), current.options),
      data: Object.assign(Object.assign({}, existing.data), current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign(Object.assign({}, DEFAULT_OPTIONS), defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) // removed by dead control flow
{ var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) // removed by dead control flow
{}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) // removed by dead control flow
{}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) // removed by dead control flow
{}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper_createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules


// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case enums_start:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
        break;

      case enums_end:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets_popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets_popperOffsets,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js





 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsets(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Math.round(x * dpr) / dpr || 0,
    y: Math.round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive;

  var _roundOffsets = roundOffsets(offsets),
      x = _roundOffsets.x,
      y = _roundOffsets.y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
    } // $FlowFixMe: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    /*:: offsetParent = (offsetParent: Element); */


    if (placement === enums_top) {
      sideY = bottom;
      y -= offsetParent.clientHeight - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right;
      x -= offsetParent.clientWidth - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref3) {
  var state = _ref3.state,
      options = _ref3.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive;

  if (false) // removed by dead control flow
{ var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false
    })));
  }

  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js


function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset_offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset_offset
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js



function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js



 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = element.ownerDocument.body;
  var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign(Object.assign({}, rect), {}, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js














function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Math.max(rect.top, accRect.top);
    accRect.right = Math.min(rect.right, accRect.right);
    accRect.bottom = Math.min(rect.bottom, accRect.bottom);
    accRect.left = Math.max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? enums_clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? enums_popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === enums_popper ? enums_reference : enums_popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign(Object.assign({}, popperRect), popperOffsets));
  var elementClientRect = elementContext === enums_popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === enums_popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js





/*:: type OverflowsMap = { [ComputedPlacement]: number }; */

/*;; type OverflowsMap = { [key in ComputedPlacement]: number }; */
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements; // $FlowFixMe

  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) // removed by dead control flow
{}
  } // $FlowFixMe: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === enums_auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === enums_auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === enums_start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js
function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js











function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = popperOffsets[mainAxis] + overflow[mainSide];
    var max = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === enums_start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === enums_start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var _preventedOffset = within(_min, _offset, _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = state.modifiersData[name + "#persistent"].padding;
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element,
      _options$padding = options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) // removed by dead control flow
{}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) // removed by dead control flow
{}

    return;
  }

  state.elements.arrow = arrowElement;
  state.modifiersData[name + "#persistent"] = {
    padding: mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements))
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide_hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide_hide
});
// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var popper_defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: popper_defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


// EXTERNAL MODULE: ./node_modules/lodash/isBoolean.js
var isBoolean = __nested_webpack_require_310292__("6679");
var isBoolean_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isBoolean);

// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var isNumber = __nested_webpack_require_310292__("501e");
var isNumber_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isNumber);

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __nested_webpack_require_310292__("e2a0");
var isString_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isString);

// EXTERNAL MODULE: ./node_modules/lodash/isArrayLikeObject.js
var isArrayLikeObject = __nested_webpack_require_310292__("dcbe");
var isArrayLikeObject_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isArrayLikeObject);

// EXTERNAL MODULE: ./node_modules/lodash/isFunction.js
var isFunction = __nested_webpack_require_310292__("9520");
var isFunction_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isFunction);

// EXTERNAL MODULE: ./node_modules/lodash/isUndefined.js
var isUndefined = __nested_webpack_require_310292__("4cfe");
var isUndefined_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isUndefined);

// EXTERNAL MODULE: ./node_modules/lodash/isDate.js
var isDate = __nested_webpack_require_310292__("6220");
var isDate_default = /*#__PURE__*/__nested_webpack_require_310292__.n(isDate);

// EXTERNAL MODULE: ./node_modules/lodash/clamp.js
var clamp = __nested_webpack_require_310292__("f678");
var clamp_default = /*#__PURE__*/__nested_webpack_require_310292__.n(clamp);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __nested_webpack_require_310292__("9b02");
var get_default = /*#__PURE__*/__nested_webpack_require_310292__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __nested_webpack_require_310292__("0f5c");
var set_default = /*#__PURE__*/__nested_webpack_require_310292__.n(set);

// EXTERNAL MODULE: ./node_modules/lodash/mapValues.js
var mapValues = __nested_webpack_require_310292__("9e86");
var mapValues_default = /*#__PURE__*/__nested_webpack_require_310292__.n(mapValues);

// EXTERNAL MODULE: ./node_modules/lodash/toPairs.js
var toPairs = __nested_webpack_require_310292__("f542");
var toPairs_default = /*#__PURE__*/__nested_webpack_require_310292__.n(toPairs);

// EXTERNAL MODULE: ./node_modules/lodash/defaults.js
var defaults = __nested_webpack_require_310292__("95ae");
var defaults_default = /*#__PURE__*/__nested_webpack_require_310292__.n(defaults);

// EXTERNAL MODULE: ./node_modules/lodash/defaultsDeep.js
var defaultsDeep = __nested_webpack_require_310292__("3f84");
var defaultsDeep_default = /*#__PURE__*/__nested_webpack_require_310292__.n(defaultsDeep);

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __nested_webpack_require_310292__("2593");
var pick_default = /*#__PURE__*/__nested_webpack_require_310292__.n(pick);

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __nested_webpack_require_310292__("3eea");
var omit_default = /*#__PURE__*/__nested_webpack_require_310292__.n(omit);

// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __nested_webpack_require_310292__("3852");
var has_default = /*#__PURE__*/__nested_webpack_require_310292__.n(has);

// EXTERNAL MODULE: ./node_modules/lodash/map.js
var lodash_map = __nested_webpack_require_310292__("dd61");
var map_default = /*#__PURE__*/__nested_webpack_require_310292__.n(lodash_map);

// EXTERNAL MODULE: ./node_modules/lodash/head.js
var head = __nested_webpack_require_310292__("a59b");
var head_default = /*#__PURE__*/__nested_webpack_require_310292__.n(head);

// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __nested_webpack_require_310292__("4416");
var last_default = /*#__PURE__*/__nested_webpack_require_310292__.n(last);

// EXTERNAL MODULE: ./node_modules/lodash/some.js
var some = __nested_webpack_require_310292__("3092");
var some_default = /*#__PURE__*/__nested_webpack_require_310292__.n(some);

// CONCATENATED MODULE: ./src/utils/_.js
// Type utils






 // Number utils

 // Object utils









 // Collection utils




 // Type checkers

const getType = function (value) {
  return Object.prototype.toString.call(value).slice(8, -1);
};
const _isDate = function (value) {
  return isDate_default()(value) && !isNaN(value.getTime());
};
const isObject = function (value) {
  return getType(value) === 'Object';
}; // Object utils

const _has = has_default.a;
const hasAny = function (obj, props) {
  return some_default()(props, function (p) {
    return has_default()(obj, p);
  });
}; // Collection utils

const _some = some_default.a;
// CONCATENATED MODULE: ./src/utils/helpers.js


const pad = function (val, len, char = '0') {
  val = val !== null && val !== undefined ? String(val) : '';
  len = len || 2;

  while (val.length < len) {
    val = `${char}${val}`;
  }

  return val;
};
const evalFn = function (fn, args) {
  return isFunction_default()(fn) ? fn(args) : fn;
};
const mergeEvents = function (...args) {
  const result = {};
  args.forEach(function (e) {
    return Object.entries(e).forEach(function ([key, value]) {
      if (!result[key]) {
        result[key] = value;
      } else if (isArrayLikeObject_default()(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    });
  });
  return result;
};
const pageIsValid = function (page) {
  return !!(page && page.month && page.year);
};
const pageIsBeforePage = function (page, comparePage) {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) return false;
  if (page.year === comparePage.year) return page.month < comparePage.month;
  return page.year < comparePage.year;
};
const pageIsAfterPage = function (page, comparePage) {
  if (!pageIsValid(page) || !pageIsValid(comparePage)) return false;
  if (page.year === comparePage.year) return page.month > comparePage.month;
  return page.year > comparePage.year;
};
const pageIsBetweenPages = function (page, fromPage, toPage) {
  return (page || false) && !pageIsBeforePage(page, fromPage) && !pageIsAfterPage(page, toPage);
};
const pageIsEqualToPage = function (aPage, bPage) {
  if (!aPage && bPage) return false;
  if (aPage && !bPage) return false;
  if (!aPage && !bPage) return true;
  return aPage.month === bPage.month && aPage.year === bPage.year;
};
const addPages = function ({
  month,
  year
}, count) {
  const incr = count > 0 ? 1 : -1;

  for (let i = 0; i < Math.abs(count); i++) {
    month += incr;

    if (month > 12) {
      month = 1;
      year++;
    } else if (month < 1) {
      month = 12;
      year--;
    }
  }

  return {
    month,
    year
  };
};
const pageRangeToArray = function (from, to) {
  if (!pageIsValid(from) || !pageIsValid(to)) return [];
  const result = [];

  while (!pageIsAfterPage(from, to)) {
    result.push(from);
    from = addPages(from, 1);
  }

  return result;
};
function datesAreEqual(a, b) {
  const aIsDate = _isDate(a);
  const bIsDate = _isDate(b);
  if (!aIsDate && !bIsDate) return true;
  if (aIsDate !== bIsDate) return false;
  return a.getTime() === b.getTime();
}
const arrayHasItems = function (array) {
  return isArrayLikeObject_default()(array) && array.length;
};
const mixinOptionalProps = function (source, target, props) {
  const assigned = [];
  props.forEach(function (p) {
    const name = p.name || p.toString();
    const mixin = p.mixin;
    const validate = p.validate;

    if (Object.prototype.hasOwnProperty.call(source, name)) {
      const value = validate ? validate(source[name]) : source[name];
      target[name] = mixin && isObject(value) ? { ...mixin,
        ...value
      } : value;
      assigned.push(name);
    }
  });
  return {
    target,
    assigned: assigned.length ? assigned : null
  };
};
const on = function (element, event, handler, opts) {
  if (element && event && handler) {
    element.addEventListener(event, handler, opts);
  }
};
const off = function (element, event, handler, opts) {
  if (element && event) {
    element.removeEventListener(event, handler, opts);
  }
};
const elementContains = function (element, child) {
  return !!element && !!child && (element === child || element.contains(child));
};
const onSpaceOrEnter = function (event, handler) {
  if (event.key === ' ' || event.key === 'Enter') {
    handler(event);
    event.preventDefault();
  }
};
/* eslint-disable no-bitwise */

const createGuid = function () {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }

  return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
};
function helpers_hash(str) {
  let hashcode = 0;
  let i = 0;
  let chr;
  if (str.length === 0) return hashcode;

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hashcode = (hashcode << 5) - hashcode + chr;
    hashcode |= 0; // Convert to 32bit integer
  }

  return hashcode;
}
/* eslint-enable no-bitwise */
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Popover.vue?vue&type=script&lang=js&




/* harmony default export */ var Popovervue_type_script_lang_js_ = ({
  name: 'Popover',

  render(h) {
    return h('div', {
      class: ['vc-popover-content-wrapper', {
        'is-interactive': this.isInteractive
      }],
      ref: 'popover'
    }, [h('transition', {
      props: {
        name: this.transition,
        appear: true
      },
      on: {
        beforeEnter: this.beforeEnter,
        afterEnter: this.afterEnter,
        beforeLeave: this.beforeLeave,
        afterLeave: this.afterLeave
      }
    }, [this.isVisible && h('div', {
      attrs: {
        tabindex: -1
      },
      class: ['vc-popover-content', `direction-${this.direction}`, this.contentClass]
    }, [this.content, h('span', {
      class: ['vc-popover-caret', `direction-${this.direction}`, `align-${this.alignment}`]
    })])])]);
  },

  props: {
    id: {
      type: String,
      required: true
    },
    contentClass: String
  },

  data() {
    return {
      ref: null,
      opts: null,
      data: null,
      transition: 'slide-fade',
      placement: 'bottom',
      positionFixed: false,
      modifiers: [],
      isInteractive: false,
      isHovered: false,
      isFocused: false,
      showDelay: 0,
      hideDelay: 110,
      autoHide: false,
      popperEl: null
    };
  },

  computed: {
    content() {
      var _this = this;

      return isFunction_default()(this.$scopedSlots.default) && this.$scopedSlots.default({
        direction: this.direction,
        alignment: this.alignment,
        data: this.data,
        updateLayout: this.setupPopper,
        hide: function (opts) {
          return _this.hide(opts);
        }
      }) || this.$slots.default;
    },

    popperOptions() {
      return {
        placement: this.placement,
        strategy: this.positionFixed ? 'fixed' : 'absolute',
        modifiers: [{
          name: 'onUpdate',
          enabled: true,
          phase: 'afterWrite',
          fn: this.onPopperUpdate
        }, ...(this.modifiers || [])],
        onFirstUpdate: this.onPopperUpdate
      };
    },

    isVisible() {
      return !!(this.ref && this.content);
    },

    direction() {
      return this.placement && this.placement.split('-')[0] || 'bottom';
    },

    alignment() {
      const isLeftRight = this.direction === 'left' || this.direction === 'right';
      let alignment = this.placement.split('-');
      alignment = alignment.length > 1 ? alignment[1] : '';

      if (['start', 'top', 'left'].includes(alignment)) {
        return isLeftRight ? 'top' : 'left';
      }

      if (['end', 'bottom', 'right'].includes(alignment)) {
        return isLeftRight ? 'bottom' : 'right';
      }

      return isLeftRight ? 'middle' : 'center';
    },

    state() {
      return this.$popovers[this.id];
    }

  },
  watch: {
    opts(val, oldVal) {
      if (oldVal && oldVal.callback) {
        oldVal.callback({ ...oldVal,
          completed: !val,
          reason: val ? 'Overridden by action' : null
        });
      }
    }

  },

  mounted() {
    this.popoverEl = this.$refs.popover;
    this.addEvents();
  },

  beforeDestroy() {
    this.destroyPopper();
    this.removeEvents();
    this.popoverEl = null;
  },

  methods: {
    addEvents() {
      on(this.popoverEl, 'click', this.onClick);
      on(this.popoverEl, 'mouseover', this.onMouseOver);
      on(this.popoverEl, 'mouseleave', this.onMouseLeave);
      on(this.popoverEl, 'focusin', this.onFocusIn);
      on(this.popoverEl, 'focusout', this.onFocusOut);
      on(document, 'keydown', this.onDocumentKeydown);
      on(document, 'click', this.onDocumentClick);
      on(document, 'show-popover', this.onDocumentShowPopover);
      on(document, 'hide-popover', this.onDocumentHidePopover);
      on(document, 'toggle-popover', this.onDocumentTogglePopover);
      on(document, 'update-popover', this.onDocumentUpdatePopover);
    },

    removeEvents() {
      off(this.popoverEl, 'click', this.onClick);
      off(this.popoverEl, 'mouseover', this.onMouseOver);
      off(this.popoverEl, 'mouseleave', this.onMouseLeave);
      off(this.popoverEl, 'focusin', this.onFocusIn);
      off(this.popoverEl, 'focusout', this.onFocusOut);
      off(document, 'keydown', this.onDocumentKeydown);
      off(document, 'click', this.onDocumentClick);
      off(document, 'show-popover', this.onDocumentShowPopover);
      off(document, 'hide-popover', this.onDocumentHidePopover);
      off(document, 'toggle-popover', this.onDocumentTogglePopover);
      off(document, 'update-popover', this.onDocumentUpdatePopover);
    },

    onClick(e) {
      e.stopPropagation();
    },

    onMouseOver() {
      this.isHovered = true;
      if (this.isInteractive) this.show();
    },

    onMouseLeave() {
      this.isHovered = false;

      if (this.autoHide && !this.isFocused && (!this.ref || this.ref !== document.activeElement)) {
        this.hide();
      }
    },

    onFocusIn() {
      this.isFocused = true;
      if (this.isInteractive) this.show();
    },

    onFocusOut(e) {
      if (!e.relatedTarget || !elementContains(this.popoverEl, e.relatedTarget)) {
        this.isFocused = false;
        if (!this.isHovered && this.autoHide) this.hide();
      }
    },

    onDocumentClick(e) {
      if (!this.$refs.popover || !this.ref) {
        return;
      } // Don't hide if target element is contained within popover ref or content


      if (elementContains(this.popoverEl, e.target) || elementContains(this.ref, e.target)) {
        return;
      } // Hide the popover


      this.hide();
    },

    onDocumentKeydown(e) {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.hide();
      }
    },

    onDocumentShowPopover({
      detail
    }) {
      if (!detail.id || detail.id !== this.id) return;
      this.show(detail);
    },

    onDocumentHidePopover({
      detail
    }) {
      if (!detail.id || detail.id !== this.id) return;
      this.hide(detail);
    },

    onDocumentTogglePopover({
      detail
    }) {
      if (!detail.id || detail.id !== this.id) return;
      this.toggle(detail);
    },

    onDocumentUpdatePopover({
      detail
    }) {
      if (!detail.id || detail.id !== this.id) return;
      this.update(detail);
    },

    show(opts = {}) {
      var _this2 = this;

      opts.action = 'show';
      const ref = opts.ref || this.ref;
      const delay = opts.showDelay >= 0 ? opts.showDelay : this.showDelay; // Validate options

      if (!ref) {
        if (opts.callback) {
          opts.callback({
            completed: false,
            reason: 'Invalid reference element provided'
          });
        }

        return;
      }

      clearTimeout(this.timeout);
      this.opts = opts;

      const fn = function () {
        Object.assign(_this2, opts);

        _this2.setupPopper();

        _this2.opts = null;
      };

      if (delay > 0) {
        this.timeout = setTimeout(function () {
          return fn();
        }, delay);
      } else {
        fn();
      }
    },

    hide(opts = {}) {
      var _this3 = this;

      opts.action = 'hide';
      const ref = opts.ref || this.ref;
      const delay = opts.hideDelay >= 0 ? opts.hideDelay : this.hideDelay;

      if (!this.ref || ref !== this.ref) {
        if (opts.callback) {
          opts.callback({ ...opts,
            completed: false,
            reason: this.ref ? 'Invalid reference element provided' : 'Popover already hidden'
          });
        }

        return;
      }

      const fn = function () {
        _this3.ref = null;
        _this3.opts = null;
      };

      clearTimeout(this.timeout);
      this.opts = opts;

      if (delay > 0) {
        this.timeout = setTimeout(fn, delay);
      } else {
        fn();
      }
    },

    toggle(opts = {}) {
      if (this.isVisible && opts.ref === this.ref) {
        this.hide(opts);
      } else {
        this.show(opts);
      }
    },

    update(opts = {}) {
      Object.assign(this, opts);
      this.setupPopper();
    },

    setupPopper() {
      var _this4 = this;

      this.$nextTick(function () {
        if (!_this4.ref || !_this4.$refs.popover) return;

        if (_this4.popper && _this4.popper.reference !== _this4.ref) {
          _this4.destroyPopper();
        }

        if (!_this4.popper) {
          _this4.popper = popper_createPopper(_this4.ref, _this4.popoverEl, _this4.popperOptions);
        } else {
          _this4.popper.update();
        }
      });
    },

    onPopperUpdate(args) {
      if (args.placement) {
        this.placement = args.placement;
      } else if (args.state) {
        this.placement = args.state.placement;
      }
    },

    beforeEnter(e) {
      this.$emit('beforeShow', e);
    },

    afterEnter(e) {
      this.$emit('afterShow', e);
    },

    beforeLeave(e) {
      this.$emit('beforeHide', e);
    },

    afterLeave(e) {
      this.destroyPopper();
      this.$emit('afterHide', e);
    },

    destroyPopper() {
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/Popover.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Popovervue_type_script_lang_js_ = (Popovervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/Popover.vue?vue&type=style&index=0&id=39b30300&lang=postcss&scoped=true&
var Popovervue_type_style_index_0_id_39b30300_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("bdb3");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/Popover.vue
var render, staticRenderFns





/* normalize component */

var component = normalizeComponent(
  components_Popovervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "39b30300",
  null
  
)

/* harmony default export */ var Popover = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1901b52e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PopoverRow.vue?vue&type=template&id=eb5afd1a&scoped=true&
var PopoverRowvue_type_template_id_eb5afd1a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-day-popover-row"},[(_vm.indicator)?_c('div',{staticClass:"vc-day-popover-row-indicator"},[_c('span',{class:_vm.indicator.class,style:(_vm.indicator.style)})]):_vm._e(),_c('div',{staticClass:"vc-day-popover-row-content"},[_vm._t("default",[_vm._v(_vm._s(_vm.attribute.popover ? _vm.attribute.popover.label : 'No content provided'))])],2)])}
var PopoverRowvue_type_template_id_eb5afd1a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/PopoverRow.vue?vue&type=template&id=eb5afd1a&scoped=true&

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __nested_webpack_require_310292__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__nested_webpack_require_310292__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// EXTERNAL MODULE: ./src/utils/defaults/touch.json
var touch = __nested_webpack_require_310292__("23a5");

// EXTERNAL MODULE: ./src/utils/defaults/masks.json
var defaults_masks = __nested_webpack_require_310292__("7efe");

// EXTERNAL MODULE: ./src/utils/defaults/screens.json
var defaults_screens = __nested_webpack_require_310292__("85a9");

// CONCATENATED MODULE: ./src/utils/defaults/locales.js


const locales_locales = {
  // Arabic
  ar: {
    dow: 7,
    L: 'D/\u200FM/\u200FYYYY'
  },
  // Bulgarian
  bg: {
    dow: 2,
    L: 'D.MM.YYYY'
  },
  // Catalan
  ca: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // Chinese (China)
  'zh-CN': {
    dow: 2,
    L: 'YYYY/MM/DD'
  },
  // Chinese (Taiwan)
  'zh-TW': {
    dow: 1,
    L: 'YYYY/MM/DD'
  },
  // Croatian
  hr: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Czech
  cs: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Danish
  da: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Dutch
  nl: {
    dow: 2,
    L: 'DD-MM-YYYY'
  },
  // English (US)
  'en-US': {
    dow: 1,
    L: 'MM/DD/YYYY'
  },
  // English (Australia)
  'en-AU': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // English (Canada)
  'en-CA': {
    dow: 1,
    L: 'YYYY-MM-DD'
  },
  // English (Great Britain)
  'en-GB': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // English (Ireland)
  'en-IE': {
    dow: 2,
    L: 'DD-MM-YYYY'
  },
  // English (New Zealand)
  'en-NZ': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // English (South Africa)
  'en-ZA': {
    dow: 1,
    L: 'YYYY/MM/DD'
  },
  // Esperanto
  eo: {
    dow: 2,
    L: 'YYYY-MM-DD'
  },
  // Estonian
  et: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Finnish
  fi: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // French
  fr: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // French (Canada)
  'fr-CA': {
    dow: 1,
    L: 'YYYY-MM-DD'
  },
  // French (Switzerland)
  'fr-CH': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // German
  de: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Hebrew
  he: {
    dow: 1,
    L: 'DD.MM.YYYY'
  },
  // Indonesian
  id: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // Italian
  it: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // Japanese
  ja: {
    dow: 1,
    L: 'YYYY年M月D日'
  },
  // Korean
  ko: {
    dow: 1,
    L: 'YYYY.MM.DD'
  },
  // Latvian
  lv: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Lithuanian
  lt: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Macedonian
  mk: {
    dow: 2,
    L: 'D.MM.YYYY'
  },
  // Norwegian
  nb: {
    dow: 2,
    L: 'D. MMMM YYYY'
  },
  nn: {
    dow: 2,
    L: 'D. MMMM YYYY'
  },
  // Polish
  pl: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Portuguese
  pt: {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // Romanian
  ro: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Russian
  ru: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Slovak
  sk: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Spanish (Spain)
  'es-ES': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // Spanish (Mexico)
  'es-MX': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  // Swedish
  sv: {
    dow: 2,
    L: 'YYYY-MM-DD'
  },
  // Thai
  th: {
    dow: 1,
    L: 'DD/MM/YYYY'
  },
  // Turkish
  tr: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Ukrainian
  uk: {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  // Vietnam
  vi: {
    dow: 2,
    L: 'DD/MM/YYYY'
  }
};
locales_locales.en = locales_locales['en-US'];
locales_locales.es = locales_locales['es-ES'];
locales_locales.no = locales_locales.nb;
locales_locales.zh = locales_locales['zh-CN']; // Remap from abbr. to intuitive property names

toPairs_default()(locales_locales).forEach(function ([id, {
  dow,
  L
}]) {
  locales_locales[id] = {
    id,
    firstDayOfWeek: dow,
    masks: {
      L
    }
  };
});
/* harmony default export */ var defaults_locales = (locales_locales);
// CONCATENATED MODULE: ./src/utils/defaults/index.js
// Vue won't get included in bundle as it is externalized
// https://cli.vuejs.org/guide/build-targets.html#library






const pluginDefaults = {
  componentPrefix: 'v',
  navVisibility: 'click',
  titlePosition: 'center',
  transition: 'slide-h',
  touch: touch,
  masks: defaults_masks,
  screens: defaults_screens,
  locales: defaults_locales,
  datePicker: {
    updateOnInput: true,
    inputDebounce: 1000,
    popover: {
      visibility: 'hover-focus',
      placement: 'bottom-start',
      keepVisibleOnInput: false,
      isInteractive: true
    }
  }
};
let defaults_ = null;
const setupDefaults = function (opts) {
  if (!defaults_) {
    defaults_ = new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
      data() {
        return {
          defaults: defaultsDeep_default()(opts, pluginDefaults)
        };
      },

      computed: {
        locales() {
          var _this = this;

          return mapValues_default()(this.defaults.locales, function (v) {
            v.masks = defaultsDeep_default()(v.masks, _this.defaults.masks);
            return v;
          });
        }

      }
    });
  }

  return defaults_.defaults;
};
const defaultsMixin = {
  beforeCreate() {
    setupDefaults();
  },

  computed: {
    $defaults() {
      return defaults_.defaults;
    },

    $locales() {
      return defaults_.locales;
    }

  },
  methods: {
    propOrDefault(prop, defaultPath, strategy) {
      return this.passedProp(prop, get_default()(this.$defaults, defaultPath), strategy);
    },

    passedProp(prop, fallback, strategy) {
      if (_has(this.$options.propsData, prop)) {
        const propValue = this[prop];

        if (isObject(propValue) && strategy === 'merge') {
          return defaultsDeep_default()(propValue, fallback);
        }

        return propValue;
      }

      return fallback;
    }

  }
};
// CONCATENATED MODULE: ./src/utils/mixins/child.js

const childMixin = {
  inject: ['sharedState'],
  mixins: [defaultsMixin],
  computed: {
    masks() {
      return this.sharedState.masks;
    },

    theme() {
      return this.sharedState.theme;
    },

    locale() {
      return this.sharedState.locale;
    },

    dayPopoverId() {
      return this.sharedState.dayPopoverId;
    }

  },
  methods: {
    format(date, mask) {
      return this.locale.format(date, mask);
    },

    pageForDate(date) {
      return this.locale.getDateParts(this.locale.normalizeDate(date));
    }

  }
};
// CONCATENATED MODULE: ./src/utils/theme.js


const targetProps = ['base', 'start', 'end', 'startEnd'];
const displayProps = ['class', 'contentClass', 'style', 'contentStyle', 'color', 'fillMode'];
const defConfig = {
  color: 'blue',
  isDark: false,
  highlight: {
    base: {
      fillMode: 'light'
    },
    start: {
      fillMode: 'solid'
    },
    end: {
      fillMode: 'solid'
    }
  },
  dot: {
    base: {
      fillMode: 'solid'
    },
    start: {
      fillMode: 'solid'
    },
    end: {
      fillMode: 'solid'
    }
  },
  bar: {
    base: {
      fillMode: 'solid'
    },
    start: {
      fillMode: 'solid'
    },
    end: {
      fillMode: 'solid'
    }
  },
  content: {
    base: {},
    start: {},
    end: {}
  }
};
class theme_Theme {
  constructor(config) {
    Object.assign(this, defConfig, config);
  } // Normalizes attribute config to the structure defined by the properties


  normalizeAttr({
    config,
    type
  }) {
    let rootColor = this.color;
    let root = {}; // Get the normalized root config

    const normAttr = this[type];

    if (config === true || isString_default()(config)) {
      // Assign default color for booleans or strings
      rootColor = isString_default()(config) ? config : rootColor; // Set the default root

      root = { ...normAttr
      };
    } else if (isObject(config)) {
      if (hasAny(config, targetProps)) {
        // Mixin target configs
        root = { ...config
        };
      } else {
        // Mixin display configs
        root = {
          base: { ...config
          },
          start: { ...config
          },
          end: { ...config
          }
        };
      }
    } else {
      return null;
    } // Fill in missing targets


    defaults_default()(root, {
      start: root.startEnd,
      end: root.startEnd
    }, normAttr); // Normalize each target

    toPairs_default()(root).forEach(function ([targetType, targetConfig]) {
      let targetColor = rootColor;

      if (targetConfig === true || isString_default()(targetConfig)) {
        targetColor = isString_default()(targetConfig) ? targetConfig : targetColor;
        root[targetType] = {
          color: targetColor
        };
      } else if (isObject(targetConfig)) {
        if (hasAny(targetConfig, displayProps)) {
          root[targetType] = { ...targetConfig
          };
        } else {
          root[targetType] = {};
        }
      } // Set the theme color if it is missing


      if (!_has(root, `${targetType}.color`)) {
        set_default()(root, `${targetType}.color`, targetColor);
      }
    });
    return root;
  }

  normalizeHighlight(config) {
    var _this = this;

    const highlight = this.normalizeAttr({
      config,
      type: 'highlight'
    });
    toPairs_default()(highlight).forEach(function ([_, targetConfig]) {
      const c = defaults_default()(targetConfig, {
        isDark: _this.isDark,
        color: _this.color
      });
      targetConfig.style = { ..._this.getHighlightBgStyle(c),
        ...targetConfig.style
      };
      targetConfig.contentStyle = { ..._this.getHighlightContentStyle(c),
        ...targetConfig.contentStyle
      };
    });
    return highlight;
  }

  getHighlightBgStyle({
    fillMode,
    color,
    isDark
  }) {
    switch (fillMode) {
      case 'outline':
      case 'none':
        return {
          backgroundColor: isDark ? 'var(--gray-900)' : 'var(--white)',
          border: '2px solid',
          borderColor: isDark ? `var(--${color}-200)` : `var(--${color}-700)`,
          borderRadius: 'var(--rounded-full)'
        };

      case 'light':
        return {
          backgroundColor: isDark ? `var(--${color}-800)` : `var(--${color}-200)`,
          opacity: isDark ? 0.75 : 1,
          borderRadius: 'var(--rounded-full)'
        };

      case 'solid':
        return {
          backgroundColor: isDark ? `var(--${color}-500)` : `var(--${color}-600)`,
          borderRadius: 'var(--rounded-full)'
        };

      default:
        return {
          borderRadius: 'var(--rounded-full)'
        };
    }
  }

  getHighlightContentStyle({
    fillMode,
    color,
    isDark
  }) {
    switch (fillMode) {
      case 'outline':
      case 'none':
        return {
          fontWeight: 'var(--font-bold)',
          color: isDark ? `var(--${color}-100)` : `var(--${color}-900)`
        };

      case 'light':
        return {
          fontWeight: 'var(--font-bold)',
          color: isDark ? `var(--${color}-100)` : `var(--${color}-900)`
        };

      case 'solid':
        return {
          fontWeight: 'var(--font-bold)',
          color: 'var(--white)'
        };

      default:
        return '';
    }
  }

  bgAccentHigh({
    color,
    isDark
  }) {
    return {
      backgroundColor: isDark ? `var(--${color}-500)` : `var(--${color}-600)`
    };
  }

  contentAccent({
    color,
    isDark
  }) {
    if (!color) return null;
    return {
      fontWeight: 'var(--font-bold)',
      color: isDark ? `var(--${color}-100)` : `var(--${color}-900)`
    };
  }

  normalizeDot(config) {
    return this.normalizeNonHighlight('dot', config, this.bgAccentHigh);
  }

  normalizeBar(config) {
    return this.normalizeNonHighlight('bar', config, this.bgAccentHigh);
  }

  normalizeContent(config) {
    return this.normalizeNonHighlight('content', config, this.contentAccent);
  }

  normalizeNonHighlight(type, config, styleFn) {
    var _this2 = this;

    const attr = this.normalizeAttr({
      type,
      config
    });
    toPairs_default()(attr).forEach(function ([_, targetConfig]) {
      defaults_default()(targetConfig, {
        isDark: _this2.isDark,
        color: _this2.color
      });
      targetConfig.style = { ...styleFn(targetConfig),
        ...targetConfig.style
      };
    });
    return attr;
  }

}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __nested_webpack_require_310292__("5319");

// CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/tzTokenizeDate/index.js
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone)
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date)
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5,
}

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date)
  var filled = []
  for (var i = 0; i < formatted.length; i++) {
    var pos = typeToPos[formatted[i].type]

    if (pos >= 0) {
      filled[pos] = parseInt(formatted[i].value, 10)
    }
  }
  return filled
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '')
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted)
  // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]]
}

// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {}
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date('2014-06-25T04:00:00.123Z'))
    var hourCycleSupported =
      testDateFormatted === '06/25/2014, 00:00:00' ||
      testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00'

    dtfCache[timeZone] = hourCycleSupported
      ? new Intl.DateTimeFormat('en-US', {
          hour12: false,
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      : new Intl.DateTimeFormat('en-US', {
          hourCycle: 'h23',
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
  }
  return dtfCache[timeZone]
}

// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/_lib/tzParseTimezone/index.js


var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000

var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-])(\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
  timezoneIANA: /(UTC|(?:[a-zA-Z]+\/[a-zA-Z_-]+(?:\/[a-zA-Z_]+)?))$/,
}

// Parse various time zone offset formats to an offset in milliseconds
function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token
  var absoluteOffset

  // Z
  token = patterns.timezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  var hours

  // ±hh
  token = patterns.timezoneHH.exec(timezoneString)
  if (token) {
    hours = parseInt(token[2], 10)

    if (!validateTimezone(hours)) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR
    return token[1] === '+' ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = patterns.timezoneHHMM.exec(timezoneString)
  if (token) {
    hours = parseInt(token[2], 10)
    var minutes = parseInt(token[3], 10)

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE
    return token[1] === '+' ? -absoluteOffset : absoluteOffset
  }

  // IANA time zone
  token = patterns.timezoneIANA.exec(timezoneString)
  if (token) {
    date = new Date(date || Date.now())
    var utcDate = isUtcDate ? date : toUtcDate(date)

    var offset = calcOffset(utcDate, timezoneString)

    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString)

    return -fixedOffset
  }

  return 0
}

function toUtcDate(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    )
  )
}

function calcOffset(date, timezoneString) {
  var tokens = tzTokenizeDate(date, timezoneString)

  var asUTC = Date.UTC(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5])

  var asTS = date.getTime()
  var over = asTS % 1000
  asTS -= over >= 0 ? over : 1000 + over
  return asUTC - asTS
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime()

  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - offset

  // Test whether the zone matches the offset for this ts
  var o2 = calcOffset(new Date(utcGuess), timezoneString)

  // If so, offset didn't change and we're done
  if (offset === o2) {
    return offset
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= o2 - offset

  // If that gives us the local time we want, we're done
  var o3 = calcOffset(new Date(utcGuess), timezoneString)
  if (o2 === o3) {
    return o2
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return Math.max(o2, o3)
}

function validateTimezone(hours, minutes) {
  if (minutes != null && (minutes < 0 || minutes > 59)) {
    return false
  }

  return true
}

// CONCATENATED MODULE: ./node_modules/date-fns-tz/esm/toDate/index.js




var toDate_MILLISECONDS_IN_HOUR = 3600000
var toDate_MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var toDate_patterns = {
  dateTimeDelimeter: /[T ]/,
  plainTime: /:/,
  timeZoneDelimeter: /[Z ]/i,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/, // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/, // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // timezone tokens (to identify the presence of a tz)
  timezone: /([Z+-].*| UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/,
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate_toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {}

  var additionalDigits =
    options.additionalDigits == null
      ? DEFAULT_ADDITIONAL_DIGITS
      : toInteger(options.additionalDigits)
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (
    typeof argument === 'number' ||
    Object.prototype.toString.call(argument) === '[object Number]'
  ) {
    return new Date(argument)
  } else if (
    !(
      typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]'
    )
  ) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timezone || options.timeZone) {
      offset = tzParseTimezone(dateStrings.timezone || options.timeZone, new Date(timestamp + time))
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time))
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset))
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString(dateString) {
  var dateStrings = {}
  var array = dateString.split(toDate_patterns.dateTimeDelimeter)
  var timeString

  if (toDate_patterns.plainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
    dateStrings.timezone = array[2]
    if (toDate_patterns.timeZoneDelimeter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(toDate_patterns.timeZoneDelimeter)[0]
      timeString = dateString.substr(dateStrings.date.length, dateString.length)
    }
  }

  if (timeString) {
    var token = toDate_patterns.timezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = toDate_patterns.YYY[additionalDigits]
  var patternYYYYY = toDate_patterns.YYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = toDate_patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length),
    }
  }

  // YY or ±YYY
  token = toDate_patterns.YY.exec(dateString) || patternYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length),
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null,
  }
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = toDate_patterns.MM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = toDate_patterns.DDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // yyyy-MM-dd or YYYYMMDD
  token = toDate_patterns.MMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = toDate_patterns.Www.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = toDate_patterns.WwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime(timeString) {
  var token
  var hours
  var minutes

  // hh
  token = toDate_patterns.HH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * toDate_MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = toDate_patterns.HHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * toDate_MILLISECONDS_IN_HOUR + minutes * toDate_MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = toDate_patterns.HHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * toDate_MILLISECONDS_IN_HOUR + minutes * toDate_MILLISECONDS_IN_MINUTE + seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoWeekYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year)
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year)
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfWeek/index.js



/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeek/index.js


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeekYear/index.js



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
 *   This change makes the name consistent with
 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */

function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfISOWeekYear/index.js



/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */

function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeekYear/index.js





/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the local week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(dirtyDate, options) {
  var _options$locale, _options$locale$optio;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var localeFirstWeekContainsDate = options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = (options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfWeekYear/index.js




/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Date} the start of a week-numbering year
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * var result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * var result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */

function startOfWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, dirtyOptions);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeek/index.js




var getWeek_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @returns {Number} the week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getISOWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / getWeek_MILLISECONDS_IN_WEEK) + 1;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/differenceInCalendarWeeks/index.js



var differenceInCalendarWeeks_MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  requiredArgs(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / differenceInCalendarWeeks_MILLISECONDS_IN_WEEK);
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/lastDayOfMonth/index.js


/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */

function lastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js


/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
// CONCATENATED MODULE: ./node_modules/date-fns/esm/getWeeksInMonth/index.js





/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  requiredArgs(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date), startOfMonth(date), options) + 1;
}
// CONCATENATED MODULE: ./src/utils/dateInfo.js
/* eslint-disable import/no-cycle */




const millisecondsPerDay = 24 * 60 * 60 * 1000;
class dateInfo_DateInfo {
  constructor(config, {
    order = 0,
    locale,
    isFullDay
  } = {}) {
    this.isDateInfo = true;
    this.order = order;
    this.locale = locale instanceof locale_Locale ? locale : new locale_Locale(locale);
    this.firstDayOfWeek = this.locale.firstDayOfWeek; // Adjust config for simple dates

    if (!isObject(config)) {
      const date = this.locale.normalizeDate(config);

      if (isFullDay) {
        config = {
          start: date,
          end: date
        };
      } else {
        config = {
          startOn: date,
          endOn: date
        };
      }
    }

    let start = null;
    let end = null;

    if (config.start) {
      start = this.locale.normalizeDate(config.start, { ...this.opts,
        time: '00:00:00'
      });
    } else if (config.startOn) {
      start = this.locale.normalizeDate(config.startOn, this.opts);
    }

    if (config.end) {
      end = this.locale.normalizeDate(config.end, { ...this.opts,
        time: '23:59:59'
      });
    } else if (config.endOn) {
      end = this.locale.normalizeDate(config.endOn, this.opts);
    } // Reconfigure start and end dates if needed


    if (start && end && start > end) {
      const temp = start;
      start = end;
      end = temp;
    } else if (start && config.span >= 1) {
      end = addDays(start, config.span - 1);
    } // Assign start and end dates


    this.start = start;
    this.startTime = start ? start.getTime() : NaN;
    this.end = end;
    this.endTime = end ? end.getTime() : NaN;
    this.isDate = this.startTime && this.startTime === this.endTime;
    this.isRange = !this.isDate; // Assign 'and' condition

    const andOpt = mixinOptionalProps(config, {}, dateInfo_DateInfo.patternProps);

    if (andOpt.assigned) {
      this.on = {
        and: andOpt.target
      };
    } // Assign 'or' conditions


    if (config.on) {
      const or = (isArrayLikeObject_default()(config.on) ? config.on : [config.on]).map(function (o) {
        if (isFunction_default()(o)) return o;
        const opt = mixinOptionalProps(o, {}, dateInfo_DateInfo.patternProps);
        return opt.assigned ? opt.target : null;
      }).filter(function (o) {
        return o;
      });
      if (or.length) this.on = { ...this.on,
        or
      };
    } // Assign flag if date is complex


    this.isComplex = !!this.on;
  }

  get opts() {
    return {
      order: this.order,
      locale: this.locale
    };
  }

  toDateInfo(date) {
    return date.isDateInfo ? date : new dateInfo_DateInfo(date, this.opts);
  }

  startOfWeek(date) {
    const day = date.getDay() + 1;
    const daysToAdd = day >= this.firstDayOfWeek ? this.firstDayOfWeek - day : -(7 - (this.firstDayOfWeek - day));
    return addDays(date, daysToAdd);
  }

  diffInDays(d1, d2) {
    return Math.round((d2 - d1) / millisecondsPerDay);
  }

  diffInWeeks(d1, d2) {
    return this.diffInDays(this.startOfWeek(d1), this.startOfWeek(d2));
  }

  diffInYears(d1, d2) {
    return d2.getUTCFullYear() - d1.getUTCFullYear();
  }

  diffInMonths(d1, d2) {
    return this.diffInYears(d1, d2) * 12 + (d2.getMonth() - d1.getMonth());
  }

  static get patterns() {
    return {
      dailyInterval: {
        test: function (day, interval, di) {
          return di.diffInDays(di.start || new Date(), day.date) % interval === 0;
        }
      },
      weeklyInterval: {
        test: function (day, interval, di) {
          return di.diffInWeeks(di.start || new Date(), day.date) % interval === 0;
        }
      },
      monthlyInterval: {
        test: function (day, interval, di) {
          return di.diffInMonths(di.start || new Date(), day.date) % interval === 0;
        }
      },
      yearlyInterval: {
        test: function () {
          return function (day, interval, di) {
            return di.diffInYears(di.start || new Date(), day.date) % interval === 0;
          };
        }
      },
      days: {
        validate: function (days) {
          return isArrayLikeObject_default()(days) ? days : [parseInt(days, 10)];
        },
        test: function (day, days) {
          return days.includes(day.day) || days.includes(-day.dayFromEnd);
        }
      },
      weekdays: {
        validate: function (weekdays) {
          return isArrayLikeObject_default()(weekdays) ? weekdays : [parseInt(weekdays, 10)];
        },
        test: function (day, weekdays) {
          return weekdays.includes(day.weekday);
        }
      },
      ordinalWeekdays: {
        validate: function (ordinalWeekdays) {
          return Object.keys(ordinalWeekdays).reduce(function (obj, ck) {
            const weekdays = ordinalWeekdays[ck];
            if (!weekdays) return obj;
            obj[ck] = isArrayLikeObject_default()(weekdays) ? weekdays : [parseInt(weekdays, 10)];
            return obj;
          }, {});
        },
        test: function (day, ordinalWeekdays) {
          return Object.keys(ordinalWeekdays).map(function (k) {
            return parseInt(k, 10);
          }).find(function (k) {
            return ordinalWeekdays[k].includes(day.weekday) && (k === day.weekdayOrdinal || k === -day.weekdayOrdinalFromEnd);
          });
        }
      },
      weekends: {
        validate: function (config) {
          return config;
        },
        test: function (day) {
          return day.weekday === 1 || day.weekday === 7;
        }
      },
      workweek: {
        validate: function (config) {
          return config;
        },
        test: function (day) {
          return day.weekday >= 2 && day.weekday <= 6;
        }
      },
      weeks: {
        validate: function (weeks) {
          return isArrayLikeObject_default()(weeks) ? weeks : [parseInt(weeks, 10)];
        },
        test: function (day, weeks) {
          return weeks.includes(day.week) || weeks.includes(-day.weekFromEnd);
        }
      },
      months: {
        validate: function (months) {
          return isArrayLikeObject_default()(months) ? months : [parseInt(months, 10)];
        },
        test: function (day, months) {
          return months.includes(day.month);
        }
      },
      years: {
        validate: function (years) {
          return isArrayLikeObject_default()(years) ? years : [parseInt(years, 10)];
        },
        test: function (day, years) {
          return years.includes(day.year);
        }
      }
    };
  }

  static get patternProps() {
    return Object.keys(dateInfo_DateInfo.patterns).map(function (k) {
      return {
        name: k,
        validate: dateInfo_DateInfo.patterns[k].validate
      };
    });
  }

  static testConfig(config, day, dateInfo) {
    if (isFunction_default()(config)) return config(day);

    if (isObject(config)) {
      return Object.keys(config).every(function (k) {
        return dateInfo_DateInfo.patterns[k].test(day, config[k], dateInfo);
      });
    }

    return null;
  }

  iterateDatesInRange({
    start,
    end
  }, fn) {
    if (!start || !end || !isFunction_default()(fn)) return null;
    start = this.locale.normalizeDate(start, { ...this.opts,
      time: '00:00:00'
    });
    const state = {
      i: 0,
      date: start,
      day: this.locale.getDateParts(start),
      finished: false
    };
    let result = null;

    for (; !state.finished && state.date <= end; state.i++) {
      result = fn(state);
      state.date = addDays(state.date, 1);
      state.day = this.locale.getDateParts(state.date);
    }

    return result;
  }

  shallowIntersectingRange(other) {
    return this.rangeShallowIntersectingRange(this, this.toDateInfo(other));
  } // Returns a date range that intersects two DateInfo objects
  // NOTE: This is a shallow calculation (does not take patterns into account),
  //   so this method should only really be called for special conditions
  //   where absolute accuracy is not necessarily needed


  rangeShallowIntersectingRange(date1, date2) {
    if (!this.dateShallowIntersectsDate(date1, date2)) {
      return null;
    }

    const thisRange = date1.toRange();
    const otherRange = date2.toRange(); // Start with infinite start and end dates

    let start = null;
    let end = null; // This start date exists

    if (thisRange.start) {
      // Use this definite start date if other start date is infinite
      if (!otherRange.start) {
        start = thisRange.start;
      } else {
        // Otherwise, use the latest start date
        start = thisRange.start > otherRange.start ? thisRange.start : otherRange.start;
      } // Other start date exists

    } else if (otherRange.start) {
      // Use other definite start date as this one is infinite
      start = otherRange.start;
    } // This end date exists


    if (thisRange.end) {
      // Use this definite end date if other end date is infinite
      if (!otherRange.end) {
        end = thisRange.end;
      } else {
        // Otherwise, use the earliest end date
        end = thisRange.end < otherRange.end ? thisRange.end : otherRange.end;
      } // Other end date exists

    } else if (otherRange.end) {
      // Use other definite end date as this one is infinite
      end = otherRange.end;
    } // Return calculated range


    return {
      start,
      end
    };
  } // ========================================================
  // Determines if this date partially intersects another date
  // NOTE: This is a deep test (patterns tested)


  intersectsDate(other) {
    var _this = this;

    const date = this.toDateInfo(other);
    if (!this.shallowIntersectsDate(date)) return null;
    if (!this.on) return this;
    const range = this.rangeShallowIntersectingRange(this, date);
    let result = false;
    this.iterateDatesInRange(range, function (state) {
      if (_this.matchesDay(state.day)) {
        result = result || date.matchesDay(state.day);
        state.finished = result;
      }
    });
    return result;
  } // ========================================================
  // Determines if this date partially intersects another date
  // NOTE: This is a shallow test (no patterns tested)


  shallowIntersectsDate(other) {
    return this.dateShallowIntersectsDate(this, this.toDateInfo(other));
  } // ========================================================
  // Determines if first date partially intersects second date
  // NOTE: This is a shallow test (no patterns tested)


  dateShallowIntersectsDate(date1, date2) {
    if (date1.isDate) {
      return date2.isDate ? date1.startTime === date2.startTime : this.dateShallowIncludesDate(date2, date1);
    }

    if (date2.isDate) {
      return this.dateShallowIncludesDate(date1, date2);
    } // Both ranges


    if (date1.start && date2.end && date1.start > date2.end) {
      return false;
    }

    if (date1.end && date2.start && date1.end < date2.start) {
      return false;
    }

    return true;
  } // ========================================================
  // Determines if this date completely includes another date
  // NOTE: This is a deep test (patterns tested)


  includesDate(other) {
    var _this2 = this;

    const date = this.toDateInfo(other);

    if (!this.shallowIncludesDate(date)) {
      return false;
    }

    if (!this.on) {
      return true;
    }

    const range = this.rangeShallowIntersectingRange(this, date);
    let result = true;
    this.iterateDatesInRange(range, function (state) {
      if (_this2.matchesDay(state.day)) {
        result = result && date.matchesDay(state.day);
        state.finished = !result;
      }
    });
    return result;
  } // ========================================================
  // Determines if this date completely includes another date
  // NOTE: This is a shallow test (no patterns tested)


  shallowIncludesDate(other) {
    return this.dateShallowIncludesDate(this, other.isDate ? other : new dateInfo_DateInfo(other, this.opts));
  } // ========================================================
  // Determines if first date completely includes second date
  // NOTE: This is a shallow test (no patterns tested)


  dateShallowIncludesDate(date1, date2) {
    // First date is simple date
    if (date1.isDate) {
      if (date2.isDate) {
        return date1.startTime === date2.startTime;
      }

      if (!date2.startTime || !date2.endTime) {
        return false;
      }

      return date1.startTime === date2.startTime && date1.startTime === date2.endTime;
    } // Second date is simple date and first is date range


    if (date2.isDate) {
      if (date1.start && date2.start < date1.start) {
        return false;
      }

      if (date1.end && date2.start > date1.end) {
        return false;
      }

      return true;
    } // Both dates are date ranges


    if (date1.start && (!date2.start || date2.start < date1.start)) {
      return false;
    }

    if (date1.end && (!date2.end || date2.end > date1.end)) {
      return false;
    }

    return true;
  }

  intersectsDay(day) {
    // Date is outside general range - return null
    if (!this.shallowIntersectsDate(day.range)) return null; // Return this date if patterns match

    return this.matchesDay(day) ? this : null;
  }

  matchesDay(day) {
    var _this3 = this;

    // No patterns to test
    if (!this.on) return true; // Fail if 'and' condition fails

    if (this.on.and && !dateInfo_DateInfo.testConfig(this.on.and, day, this)) {
      return false;
    } // Fail if every 'or' condition fails


    if (this.on.or && !this.on.or.some(function (or) {
      return dateInfo_DateInfo.testConfig(or, day, _this3);
    })) {
      return false;
    } // Patterns match


    return true;
  }

  toRange() {
    return new dateInfo_DateInfo({
      start: this.start,
      end: this.end
    }, this.opts);
  } // Build the 'compare to other' function


  compare(other) {
    if (this.order !== other.order) return this.order - other.order;
    if (this.isDate !== other.isDate) return this.isDate ? 1 : -1;
    if (this.isDate) return 0;
    const diff = this.start - other.start;
    return diff !== 0 ? diff : this.end - other.end;
  }

}
// CONCATENATED MODULE: ./src/utils/locale.js


/* eslint-disable no-bitwise, no-multi-assign, import/no-cycle */









const PATCH = {
  DATE_TIME: 1,
  DATE: 2,
  TIME: 3
};
const PATCH_KEYS = {
  1: ['year', 'month', 'day', 'hours', 'minutes', 'seconds', 'milliseconds'],
  2: ['year', 'month', 'day'],
  3: ['hours', 'minutes', 'seconds', 'milliseconds']
};
const token = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
const twoDigits = /\d\d?/;
const threeDigits = /\d{3}/;
const fourDigits = /\d{4}/;
const word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
const literal = /\[([^]*?)\]/gm;

const noop = function () {};

const monthUpdate = function (arrName) {
  return function (d, v, l) {
    const index = l[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());

    if (~index) {
      d.month = index;
    }
  };
};

const maskMacros = ['L', 'iso'];
const locale_daysInWeek = 7;
const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const locale_hourOptions = [{
  value: 0,
  label: '00'
}, {
  value: 1,
  label: '01'
}, {
  value: 2,
  label: '02'
}, {
  value: 3,
  label: '03'
}, {
  value: 4,
  label: '04'
}, {
  value: 5,
  label: '05'
}, {
  value: 6,
  label: '06'
}, {
  value: 7,
  label: '07'
}, {
  value: 8,
  label: '08'
}, {
  value: 9,
  label: '09'
}, {
  value: 10,
  label: '10'
}, {
  value: 11,
  label: '11'
}, {
  value: 12,
  label: '12'
}, {
  value: 13,
  label: '13'
}, {
  value: 14,
  label: '14'
}, {
  value: 15,
  label: '15'
}, {
  value: 16,
  label: '16'
}, {
  value: 17,
  label: '17'
}, {
  value: 18,
  label: '18'
}, {
  value: 19,
  label: '19'
}, {
  value: 20,
  label: '20'
}, {
  value: 21,
  label: '21'
}, {
  value: 22,
  label: '22'
}, {
  value: 23,
  label: '23'
}];
const formatFlags = {
  D(d) {
    return d.day;
  },

  DD(d) {
    return pad(d.day);
  },

  Do(d, l) {
    return l.DoFn(d.day);
  },

  d(d) {
    return d.weekday - 1;
  },

  dd(d) {
    return pad(d.weekday - 1);
  },

  W(d, l) {
    return l.dayNamesNarrow[d.weekday - 1];
  },

  WW(d, l) {
    return l.dayNamesShorter[d.weekday - 1];
  },

  WWW(d, l) {
    return l.dayNamesShort[d.weekday - 1];
  },

  WWWW(d, l) {
    return l.dayNames[d.weekday - 1];
  },

  M(d) {
    return d.month;
  },

  MM(d) {
    return pad(d.month);
  },

  MMM(d, l) {
    return l.monthNamesShort[d.month - 1];
  },

  MMMM(d, l) {
    return l.monthNames[d.month - 1];
  },

  YY(d) {
    return String(d.year).substr(2);
  },

  YYYY(d) {
    return pad(d.year, 4);
  },

  h(d) {
    return d.hours % 12 || 12;
  },

  hh(d) {
    return pad(d.hours % 12 || 12);
  },

  H(d) {
    return d.hours;
  },

  HH(d) {
    return pad(d.hours);
  },

  m(d) {
    return d.minutes;
  },

  mm(d) {
    return pad(d.minutes);
  },

  s(d) {
    return d.seconds;
  },

  ss(d) {
    return pad(d.seconds);
  },

  S(d) {
    return Math.round(d.milliseconds / 100);
  },

  SS(d) {
    return pad(Math.round(d.milliseconds / 10), 2);
  },

  SSS(d) {
    return pad(d.milliseconds, 3);
  },

  a(d, l) {
    return d.hours < 12 ? l.amPm[0] : l.amPm[1];
  },

  A(d, l) {
    return d.hours < 12 ? l.amPm[0].toUpperCase() : l.amPm[1].toUpperCase();
  },

  Z() {
    return 'Z';
  },

  ZZ(d) {
    const o = d.timezoneOffset;
    return `${o > 0 ? '-' : '+'}${pad(Math.floor(Math.abs(o) / 60), 2)}`;
  },

  ZZZ(d) {
    const o = d.timezoneOffset;
    return `${o > 0 ? '-' : '+'}${pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4)}`;
  },

  ZZZZ(d) {
    const o = d.timezoneOffset;
    return `${o > 0 ? '-' : '+'}${pad(Math.floor(Math.abs(o) / 60), 2)}:${pad(Math.abs(o) % 60, 2)}`;
  }

};
const parseFlags = {
  D: [twoDigits, function (d, v) {
    d.day = v;
  }],
  Do: [new RegExp(twoDigits.source + word.source), function (d, v) {
    d.day = parseInt(v, 10);
  }],
  d: [twoDigits, noop],
  W: [word, noop],
  M: [twoDigits, function (d, v) {
    d.month = v - 1;
  }],
  MMM: [word, monthUpdate('monthNamesShort')],
  MMMM: [word, monthUpdate('monthNames')],
  YY: [twoDigits, function (d, v) {
    const da = new Date();
    const cent = +da.getFullYear().toString().substr(0, 2);
    d.year = `${v > 68 ? cent - 1 : cent}${v}`;
  }],
  YYYY: [fourDigits, function (d, v) {
    d.year = v;
  }],
  S: [/\d/, function (d, v) {
    d.millisecond = v * 100;
  }],
  SS: [/\d{2}/, function (d, v) {
    d.millisecond = v * 10;
  }],
  SSS: [threeDigits, function (d, v) {
    d.millisecond = v;
  }],
  h: [twoDigits, function (d, v) {
    d.hour = v;
  }],
  m: [twoDigits, function (d, v) {
    d.minute = v;
  }],
  s: [twoDigits, function (d, v) {
    d.second = v;
  }],
  a: [word, function (d, v, l) {
    const val = v.toLowerCase();

    if (val === l.amPm[0]) {
      d.isPm = false;
    } else if (val === l.amPm[1]) {
      d.isPm = true;
    }
  }],
  Z: [/[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/, function (d, v) {
    if (v === 'Z') v = '+00:00';
    const parts = `${v}`.match(/([+-]|\d\d)/gi);

    if (parts) {
      const minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
      d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
    }
  }]
};
parseFlags.DD = parseFlags.D;
parseFlags.dd = parseFlags.d;
parseFlags.WWWW = parseFlags.WWW = parseFlags.WW = parseFlags.W;
parseFlags.MM = parseFlags.M;
parseFlags.mm = parseFlags.m;
parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
parseFlags.ss = parseFlags.s;
parseFlags.A = parseFlags.a;
parseFlags.ZZZZ = parseFlags.ZZZ = parseFlags.ZZ = parseFlags.Z;
function resolveConfig(config, locales) {
  // Get the detected locale string
  const detLocale = new Intl.DateTimeFormat().resolvedOptions().locale; // Resolve the locale id

  let id;

  if (isString_default()(config)) {
    id = config;
  } else if (_has(config, 'id')) {
    id = config.id;
  }

  id = (id || detLocale).toLowerCase();
  const localeKeys = Object.keys(locales);

  const validKey = function (k) {
    return localeKeys.find(function (lk) {
      return lk.toLowerCase() === k;
    });
  };

  id = validKey(id) || validKey(id.substring(0, 2)) || detLocale; // Add fallback and spread default locale to prevent repetitive update loops

  const defLocale = { ...locales['en-IE'],
    ...locales[id],
    id
  }; // Assign or merge defaults with provided config

  config = isObject(config) ? defaultsDeep_default()(config, defLocale) : defLocale; // Return resolved config

  return config;
}
class locale_Locale {
  constructor(config, {
    locales = defaults_locales,
    timezone
  } = {}) {
    const {
      id,
      firstDayOfWeek,
      masks
    } = resolveConfig(config, locales);
    this.id = id;
    this.daysInWeek = locale_daysInWeek;
    this.firstDayOfWeek = clamp_default()(firstDayOfWeek, 1, locale_daysInWeek);
    this.masks = masks;
    this.timezone = timezone || undefined;
    this.dayNames = this.getDayNames('long');
    this.dayNamesShort = this.getDayNames('short');
    this.dayNamesShorter = this.dayNamesShort.map(function (s) {
      return s.substring(0, 2);
    });
    this.dayNamesNarrow = this.getDayNames('narrow');
    this.monthNames = this.getMonthNames('long');
    this.monthNamesShort = this.getMonthNames('short');
    this.amPm = ['am', 'pm'];
    this.monthData = {}; // Bind methods

    this.getMonthComps = this.getMonthComps.bind(this);
    this.parse = this.parse.bind(this);
    this.format = this.format.bind(this);
    this.toPage = this.toPage.bind(this);
  }

  format(date, mask) {
    var _this = this;

    date = this.normalizeDate(date);
    if (!date) return '';
    mask = this.normalizeMasks(mask)[0];
    const literals = []; // Make literals inactive by replacing them with ??

    mask = mask.replace(literal, function ($0, $1) {
      literals.push($1);
      return '??';
    });
    const timezone = /Z$/.test(mask) ? 'utc' : this.timezone;
    const dateParts = this.getDateParts(date, timezone); // Apply formatting rules

    mask = mask.replace(token, function ($0) {
      return $0 in formatFlags ? formatFlags[$0](dateParts, _this) : $0.slice(1, $0.length - 1);
    }); // Inline literal values back into the formatted value

    return mask.replace(/\?\?/g, function () {
      return literals.shift();
    });
  }

  parse(dateString, mask) {
    var _this2 = this;

    const masks = this.normalizeMasks(mask);
    return masks.map(function (m) {
      if (typeof m !== 'string') {
        throw new Error('Invalid mask in fecha.parse');
      } // Reset string value


      let str = dateString; // Avoid regular expression denial of service, fail early for really long strings
      // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS

      if (str.length > 1000) {
        return false;
      }

      let isValid = true;
      const dateInfo = {};
      m.replace(token, function ($0) {
        if (parseFlags[$0]) {
          const info = parseFlags[$0];
          const index = str.search(info[0]);

          if (!~index) {
            isValid = false;
          } else {
            str.replace(info[0], function (result) {
              info[1](dateInfo, result, _this2);
              str = str.substr(index + result.length);
              return result;
            });
          }
        }

        return parseFlags[$0] ? '' : $0.slice(1, $0.length - 1);
      });

      if (!isValid) {
        return false;
      }

      const today = new Date();

      if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
      } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
      }

      let date;

      if (dateInfo.timezoneOffset != null) {
        dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
        date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
      } else {
        date = _this2.getDateFromParts({
          year: dateInfo.year || today.getFullYear(),
          month: (dateInfo.month || 0) + 1,
          day: dateInfo.day || 1,
          hours: dateInfo.hour || 0,
          minutes: dateInfo.minute || 0,
          seconds: dateInfo.second || 0,
          milliseconds: dateInfo.millisecond || 0
        });
      }

      return date;
    }).find(function (d) {
      return d;
    }) || new Date(dateString);
  } // Normalizes mask(s) as an array with replaced mask macros


  normalizeMasks(masks) {
    var _this3 = this;

    return (arrayHasItems(masks) && masks || [isString_default()(masks) && masks || 'YYYY-MM-DD']).map(function (m) {
      return maskMacros.reduce(function (prev, curr) {
        return prev.replace(curr, _this3.masks[curr] || '');
      }, m);
    });
  }

  normalizeDate(d, config = {}) {
    let result = null;
    let {
      type,
      fillDate
    } = config;
    const {
      mask,
      patch,
      time
    } = config;
    const auto = type === 'auto' || !type;

    if (isNumber_default()(d)) {
      type = 'number';
      result = new Date(+d);
    } else if (isString_default()(d)) {
      type = 'string';
      result = d ? this.parse(d, mask || 'iso') : null;
    } else if (isObject(d)) {
      type = 'object';
      result = this.getDateFromParts(d);
    } else {
      type = 'date';
      result = _isDate(d) ? new Date(d.getTime()) : null;
    }

    if (result && patch) {
      fillDate = fillDate == null ? new Date() : this.normalizeDate(fillDate);
      const parts = { ...this.getDateParts(fillDate),
        ...pick_default()(this.getDateParts(result), PATCH_KEYS[patch])
      };
      result = this.getDateFromParts(parts);
    }

    if (auto) config.type = type;

    if (result && !isNaN(result.getTime())) {
      if (time) {
        result = this.adjustTimeForDate(result, {
          timeAdjust: time
        });
      }

      return result;
    }

    return null;
  }

  denormalizeDate(date, {
    type,
    mask
  } = {}) {
    switch (type) {
      case 'number':
        return date ? date.getTime() : NaN;

      case 'string':
        return date ? this.format(date, mask || 'iso') : '';

      default:
        return date ? new Date(date) : null;
    }
  }

  hourIsValid(hour, validHours, dateParts) {
    if (!validHours) return true;
    if (isArrayLikeObject_default()(validHours)) return validHours.includes(hour);

    if (isObject(validHours)) {
      const min = validHours.min || 0;
      const max = validHours.max || 24;
      return min <= hour && max >= hour;
    }

    return validHours(hour, dateParts);
  }

  getHourOptions(validHours, dateParts) {
    var _this4 = this;

    return locale_hourOptions.filter(function (opt) {
      return _this4.hourIsValid(opt.value, validHours, dateParts);
    });
  }

  getMinuteOptions(minuteIncrement) {
    const options = [];
    minuteIncrement = minuteIncrement > 0 ? minuteIncrement : 1;

    for (let i = 0; i <= 59; i += minuteIncrement) {
      options.push({
        value: i,
        label: pad(i, 2)
      });
    }

    return options;
  }

  nearestOptionValue(value, options) {
    if (value == null) return value;
    const result = options.reduce(function (prev, opt) {
      if (opt.disabled) return prev;
      if (isNaN(prev)) return opt.value;
      const diffPrev = Math.abs(prev - value);
      const diffCurr = Math.abs(opt.value - value);
      return diffCurr < diffPrev ? opt.value : prev;
    }, NaN);
    return isNaN(result) ? value : result;
  }

  adjustTimeForDate(date, {
    timeAdjust,
    validHours,
    minuteIncrement
  }) {
    if (!timeAdjust && !validHours && !minuteIncrement) return date;
    const dateParts = this.getDateParts(date);

    if (timeAdjust) {
      if (timeAdjust === 'now') {
        const timeParts = this.getDateParts(new Date());
        dateParts.hours = timeParts.hours;
        dateParts.minutes = timeParts.minutes;
        dateParts.seconds = timeParts.seconds;
        dateParts.milliseconds = timeParts.milliseconds;
      } else {
        const d = new Date(`2000-01-01T${timeAdjust}Z`);
        dateParts.hours = d.getUTCHours();
        dateParts.minutes = d.getUTCMinutes();
        dateParts.seconds = d.getUTCSeconds();
        dateParts.milliseconds = d.getUTCMilliseconds();
      }
    }

    if (validHours) {
      const options = this.getHourOptions(validHours, dateParts);
      dateParts.hours = this.nearestOptionValue(dateParts.hours, options);
    }

    if (minuteIncrement) {
      const options = this.getMinuteOptions(minuteIncrement);
      dateParts.minutes = this.nearestOptionValue(dateParts.minutes, options);
    }

    date = this.getDateFromParts(dateParts);
    return date;
  }

  normalizeDates(dates, opts) {
    opts = opts || {};
    opts.locale = this; // Assign dates

    return (isArrayLikeObject_default()(dates) ? dates : [dates]).map(function (d) {
      return d && (d instanceof dateInfo_DateInfo ? d : new dateInfo_DateInfo(d, opts));
    }).filter(function (d) {
      return d;
    });
  }

  getDateParts(date, timezone = this.timezone) {
    if (!date) return null;
    let tzDate = date;

    if (timezone) {
      const normDate = new Date(date.toLocaleString('en-US', {
        timeZone: timezone
      }));
      normDate.setMilliseconds(date.getMilliseconds());
      const diff = normDate.getTime() - date.getTime();
      tzDate = new Date(date.getTime() + diff);
    }

    const milliseconds = tzDate.getMilliseconds();
    const seconds = tzDate.getSeconds();
    const minutes = tzDate.getMinutes();
    const hours = tzDate.getHours();
    const month = tzDate.getMonth() + 1;
    const year = tzDate.getFullYear();
    const comps = this.getMonthComps(month, year);
    const day = tzDate.getDate();
    const dayFromEnd = comps.days - day + 1;
    const weekday = tzDate.getDay() + 1;
    const weekdayOrdinal = Math.floor((day - 1) / 7 + 1);
    const weekdayOrdinalFromEnd = Math.floor((comps.days - day) / 7 + 1);
    const week = Math.ceil((day + Math.abs(comps.firstWeekday - comps.firstDayOfWeek)) / 7);
    const weekFromEnd = comps.weeks - week + 1;
    const parts = {
      milliseconds,
      seconds,
      minutes,
      hours,
      day,
      dayFromEnd,
      weekday,
      weekdayOrdinal,
      weekdayOrdinalFromEnd,
      week,
      weekFromEnd,
      month,
      year,
      date,
      isValid: true
    };
    parts.timezoneOffset = this.getTimezoneOffset(parts);
    return parts;
  }

  getDateFromParts(parts) {
    if (!parts) return null;
    const d = new Date();
    const {
      year = d.getFullYear(),
      month = d.getMonth() + 1,
      day = d.getDate(),
      hours: hrs = 0,
      minutes: min = 0,
      seconds: sec = 0,
      milliseconds: ms = 0
    } = parts;

    if (this.timezone) {
      const dateString = `${pad(year, 4)}-${pad(month, 2)}-${pad(day, 2)}T${pad(hrs, 2)}:${pad(min, 2)}:${pad(sec, 2)}.${pad(ms, 3)}`;
      return toDate_toDate(dateString, {
        timeZone: this.timezone
      });
    }

    return new Date(year, month - 1, day, hrs, min, sec, ms);
  }

  getTimezoneOffset(parts) {
    const {
      year: y,
      month: m,
      day: d,
      hours: hrs = 0,
      minutes: min = 0,
      seconds: sec = 0,
      milliseconds: ms = 0
    } = parts;
    let date;
    const utcDate = new Date(Date.UTC(y, m - 1, d, hrs, min, sec, ms));

    if (this.timezone) {
      const dateString = `${pad(y, 4)}-${pad(m, 2)}-${pad(d, 2)}T${pad(hrs, 2)}:${pad(min, 2)}:${pad(sec, 2)}.${pad(ms, 3)}`;
      date = toDate_toDate(dateString, {
        timeZone: this.timezone
      });
    } else {
      date = new Date(y, m - 1, d, hrs, min, sec, ms);
    }

    return (date - utcDate) / 60000;
  }

  toPage(arg, fromPage) {
    if (isNumber_default()(arg)) {
      return addPages(fromPage, arg);
    }

    if (isString_default()(arg)) {
      return this.getDateParts(this.normalizeDate(arg));
    }

    if (_isDate(arg)) {
      return this.getDateParts(arg);
    }

    if (isObject(arg)) {
      return arg;
    }

    return null;
  }

  getMonthDates(year = 2000) {
    const dates = [];

    for (let i = 0; i < 12; i++) {
      dates.push(new Date(year, i, 15));
    }

    return dates;
  }

  getMonthNames(length) {
    const dtf = new Intl.DateTimeFormat(this.id, {
      month: length,
      timezome: 'UTC'
    });
    return this.getMonthDates().map(function (d) {
      return dtf.format(d);
    });
  }

  getWeekdayDates(firstDayOfWeek = this.firstDayOfWeek) {
    const dates = [];
    const year = 2020;
    const month = 1;
    const day = 5 + firstDayOfWeek - 1;

    for (let i = 0; i < locale_daysInWeek; i++) {
      dates.push(this.getDateFromParts({
        year,
        month,
        day: day + i,
        hours: 12
      }));
    }

    return dates;
  }

  getDayNames(length) {
    const dtf = new Intl.DateTimeFormat(this.id, {
      weekday: length,
      timeZone: this.timezone
    });
    return this.getWeekdayDates(1).map(function (d) {
      return dtf.format(d);
    });
  } // Days/month/year components for a given month and year


  getMonthComps(month, year) {
    const key = `${month}-${year}`;
    let comps = this.monthData[key];

    if (!comps) {
      const inLeapYear = year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      const firstDayOfMonth = new Date(year, month - 1, 1);
      const firstWeekday = firstDayOfMonth.getDay() + 1;
      const days = month === 2 && inLeapYear ? 29 : daysInMonths[month - 1];
      const weekStartsOn = this.firstDayOfWeek - 1;
      const weeks = getWeeksInMonth(firstDayOfMonth, {
        weekStartsOn
      });
      const weeknumbers = [];
      const isoWeeknumbers = [];

      for (let i = 0; i < weeks; i++) {
        const date = addDays(firstDayOfMonth, i * 7);
        weeknumbers.push(getWeek(date, {
          weekStartsOn
        }));
        isoWeeknumbers.push(getISOWeek(date));
      }

      comps = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear,
        firstWeekday,
        days,
        weeks,
        month,
        year,
        weeknumbers,
        isoWeeknumbers
      };
      this.monthData[key] = comps;
    }

    return comps;
  } // Days/month/year components for today's month


  getThisMonthComps() {
    const {
      month,
      year
    } = this.getDateParts(new Date());
    return this.getMonthComps(month, year);
  } // Day/month/year components for previous month


  getPrevMonthComps(month, year) {
    if (month === 1) return this.getMonthComps(12, year - 1);
    return this.getMonthComps(month - 1, year);
  } // Day/month/year components for next month


  getNextMonthComps(month, year) {
    if (month === 12) return this.getMonthComps(1, year + 1);
    return this.getMonthComps(month + 1, year);
  }

  getDayId(date) {
    return this.format(date, 'YYYY-MM-DD');
  } // Builds day components for a given page


  getCalendarDays({
    weeks,
    monthComps,
    prevMonthComps,
    nextMonthComps
  }) {
    var _this5 = this;

    const days = [];
    const {
      firstDayOfWeek,
      firstWeekday,
      isoWeeknumbers,
      weeknumbers
    } = monthComps;
    const prevMonthDaysToShow = firstWeekday + (firstWeekday < firstDayOfWeek ? locale_daysInWeek : 0) - firstDayOfWeek;
    let prevMonth = true;
    let thisMonth = false;
    let nextMonth = false; // Formatter for aria labels

    const formatter = new Intl.DateTimeFormat(this.id, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }); // Init counters with previous month's data

    let day = prevMonthComps.days - prevMonthDaysToShow + 1;
    let dayFromEnd = prevMonthComps.days - day + 1;
    let weekdayOrdinal = Math.floor((day - 1) / locale_daysInWeek + 1);
    let weekdayOrdinalFromEnd = 1;
    let week = prevMonthComps.weeks;
    let weekFromEnd = 1;
    let month = prevMonthComps.month;
    let year = prevMonthComps.year; // Store todays comps

    const today = new Date();
    const todayDay = today.getDate();
    const todayMonth = today.getMonth() + 1;
    const todayYear = today.getFullYear();

    const dft = function (y, m, d) {
      return function (hours, minutes, seconds, milliseconds) {
        return _this5.normalizeDate({
          year: y,
          month: m,
          day: d,
          hours,
          minutes,
          seconds,
          milliseconds
        });
      };
    }; // Cycle through 6 weeks (max in month)


    for (let w = 1; w <= weeks; w++) {
      // Cycle through days in week
      for (let i = 1, weekday = firstDayOfWeek; i <= locale_daysInWeek; i++, weekday += weekday === locale_daysInWeek ? 1 - locale_daysInWeek : 1) {
        // We need to know when to start counting actual month days
        if (prevMonth && weekday === firstWeekday) {
          // Reset counters for current month
          day = 1;
          dayFromEnd = monthComps.days;
          weekdayOrdinal = Math.floor((day - 1) / locale_daysInWeek + 1);
          weekdayOrdinalFromEnd = Math.floor((monthComps.days - day) / locale_daysInWeek + 1);
          week = 1;
          weekFromEnd = monthComps.weeks;
          month = monthComps.month;
          year = monthComps.year; // ...and flag we're tracking actual month days

          prevMonth = false;
          thisMonth = true;
        } // Append day info for the current week
        // Note: this might or might not be an actual month day
        //  We don't know how the UI wants to display various days,
        //  so we'll supply all the data we can


        const dateFromTime = dft(year, month, day);
        const range = {
          start: dateFromTime(0, 0, 0),
          end: dateFromTime(23, 59, 59, 999)
        };
        const date = range.start;
        const id = `${pad(year, 4)}-${pad(month, 2)}-${pad(day, 2)}`;
        const weekdayPosition = i;
        const weekdayPositionFromEnd = locale_daysInWeek - i;
        const weeknumber = weeknumbers[w - 1];
        const isoWeeknumber = isoWeeknumbers[w - 1];
        const isToday = day === todayDay && month === todayMonth && year === todayYear;
        const isFirstDay = thisMonth && day === 1;
        const isLastDay = thisMonth && day === monthComps.days;
        const onTop = w === 1;
        const onBottom = w === weeks;
        const onLeft = i === 1;
        const onRight = i === locale_daysInWeek;
        days.push({
          id,
          label: day.toString(),
          ariaLabel: formatter.format(new Date(year, month - 1, day)),
          day,
          dayFromEnd,
          weekday,
          weekdayPosition,
          weekdayPositionFromEnd,
          weekdayOrdinal,
          weekdayOrdinalFromEnd,
          week,
          weekFromEnd,
          weeknumber,
          isoWeeknumber,
          month,
          year,
          dateFromTime,
          date,
          range,
          isToday,
          isFirstDay,
          isLastDay,
          inMonth: thisMonth,
          inPrevMonth: prevMonth,
          inNextMonth: nextMonth,
          onTop,
          onBottom,
          onLeft,
          onRight,
          classes: [`id-${id}`, `day-${day}`, `day-from-end-${dayFromEnd}`, `weekday-${weekday}`, `weekday-position-${weekdayPosition}`, `weekday-ordinal-${weekdayOrdinal}`, `weekday-ordinal-from-end-${weekdayOrdinalFromEnd}`, `week-${week}`, `week-from-end-${weekFromEnd}`, {
            'is-today': isToday,
            'is-first-day': isFirstDay,
            'is-last-day': isLastDay,
            'in-month': thisMonth,
            'in-prev-month': prevMonth,
            'in-next-month': nextMonth,
            'on-top': onTop,
            'on-bottom': onBottom,
            'on-left': onLeft,
            'on-right': onRight
          }]
        }); // See if we've hit the last day of the month

        if (thisMonth && isLastDay) {
          thisMonth = false;
          nextMonth = true; // Reset counters to next month's data

          day = 1;
          dayFromEnd = nextMonthComps.days;
          weekdayOrdinal = 1;
          weekdayOrdinalFromEnd = Math.floor((nextMonthComps.days - day) / locale_daysInWeek + 1);
          week = 1;
          weekFromEnd = nextMonthComps.weeks;
          month = nextMonthComps.month;
          year = nextMonthComps.year; // Still in the middle of the month (hasn't ended yet)
        } else {
          day++;
          dayFromEnd--;
          weekdayOrdinal = Math.floor((day - 1) / locale_daysInWeek + 1);
          weekdayOrdinalFromEnd = Math.floor((monthComps.days - day) / locale_daysInWeek + 1);
        }
      } // Append week days


      week++;
      weekFromEnd--;
    }

    return days;
  }

}
// CONCATENATED MODULE: ./src/utils/buildMediaQuery.js
 // This function gratuitously borrowed from TailwindCSS
// https://github.com/tailwindcss/tailwindcss/blob/master/src/util/buildMediaQuery.js

function buildMediaQuery(screens) {
  // Default min width
  if (isString_default()(screens)) {
    screens = {
      min: screens
    };
  } // Wrap in array


  if (!isArrayLikeObject_default()(screens)) {
    screens = [screens];
  }

  return screens.map(function (screen) {
    if (_has(screen, 'raw')) {
      return screen.raw;
    }

    return map_default()(screen, function (value, feature) {
      feature = get_default()({
        min: 'min-width',
        max: 'max-width'
      }, feature, feature);
      return `(${feature}: ${value})`;
    }).join(' and ');
  }).join(', ');
}
// CONCATENATED MODULE: ./src/utils/screens.js
// Vue won't get included in bundle as it is externalized
// https://cli.vuejs.org/guide/build-targets.html#library




let isSettingUp = false;
let shouldRefreshQueries = false;
let screensComp = null;
function setupScreens(screens = defaults_screens, forceSetup) {
  if (screensComp && !forceSetup || isSettingUp) {
    return;
  }

  isSettingUp = true;
  shouldRefreshQueries = true; // Use a private Vue component to store reactive screen matches

  screensComp = new external_commonjs_vue_commonjs2_vue_root_Vue_default.a({
    data() {
      return {
        matches: [],
        queries: []
      };
    },

    methods: {
      refreshQueries() {
        var _this = this;

        if (!window || !window.matchMedia) return;
        this.queries = mapValues_default()(screens, function (v) {
          const query = window.matchMedia(buildMediaQuery(v));

          if (isFunction_default()(query.addEventListener)) {
            query.addEventListener('change', _this.refreshMatches);
          } else {
            // Deprecated 'MediaQueryList' API, <Safari 14, <Edge 16
            query.addListener(_this.refreshMatches);
          }

          return query;
        });
        this.refreshMatches();
      },

      refreshMatches() {
        this.matches = toPairs_default()(this.queries).filter(function (p) {
          return p[1].matches;
        }).map(function (p) {
          return p[0];
        });
      }

    }
  });
  isSettingUp = false;
} // Global mixin that provides responsive '$screens' utility method
// that refreshes any time the screen matches update

external_commonjs_vue_commonjs2_vue_root_Vue_default.a.mixin({
  beforeCreate() {
    if (!isSettingUp) {
      setupScreens();
    }
  },

  mounted() {
    if (shouldRefreshQueries && screensComp) {
      screensComp.refreshQueries();
      shouldRefreshQueries = false;
    }
  },

  computed: {
    $screens() {
      return function (config, def) {
        return screensComp.matches.reduce(function (prev, curr) {
          return _has(config, curr) ? config[curr] : prev;
        }, isUndefined_default()(def) ? config.default : def);
      };
    }

  }
});
// CONCATENATED MODULE: ./src/utils/attribute.js



class attribute_Attribute {
  constructor({
    key,
    hashcode,
    highlight,
    content,
    dot,
    bar,
    popover,
    dates,
    excludeDates,
    excludeMode,
    customData,
    order,
    pinPage
  }, theme, locale) {
    this.key = isUndefined_default()(key) ? createGuid() : key;
    this.hashcode = hashcode;
    this.customData = customData;
    this.order = order || 0;
    this.dateOpts = {
      order,
      locale
    };
    this.pinPage = pinPage; // Normalize attribute types

    if (highlight) {
      this.highlight = theme.normalizeHighlight(highlight);
    }

    if (content) {
      this.content = theme.normalizeContent(content);
    }

    if (dot) {
      this.dot = theme.normalizeDot(dot);
    }

    if (bar) {
      this.bar = theme.normalizeBar(bar);
    }

    if (popover) {
      this.popover = popover;
    } // Assign dates


    this.dates = locale.normalizeDates(dates, this.dateOpts);
    this.hasDates = !!arrayHasItems(this.dates); // Assign exclude dates

    this.excludeDates = locale.normalizeDates(excludeDates, this.dateOpts);
    this.hasExcludeDates = !!arrayHasItems(this.excludeDates);
    this.excludeMode = excludeMode || 'intersects'; // Add infinite date range if excluded dates exist

    if (this.hasExcludeDates && !this.hasDates) {
      this.dates.push(new dateInfo_DateInfo({}, this.dateOpts));
      this.hasDates = true;
    }

    this.isComplex = _some(this.dates, function (d) {
      return d.isComplex;
    });
  } // Accepts: Date or date range object
  // Returns: First date that partially intersects the given date


  intersectsDate(date) {
    date = date instanceof dateInfo_DateInfo ? date : new dateInfo_DateInfo(date, this.dateOpts);
    return !this.excludesDate(date) && (this.dates.find(function (d) {
      return d.intersectsDate(date);
    }) || false);
  } // Accepts: Date or date range object
  // Returns: First date that completely includes the given date


  includesDate(date) {
    date = date instanceof dateInfo_DateInfo ? date : new dateInfo_DateInfo(date, this.dateOpts);
    return !this.excludesDate(date) && (this.dates.find(function (d) {
      return d.includesDate(date);
    }) || false);
  }

  excludesDate(date) {
    var _this = this;

    date = date instanceof dateInfo_DateInfo ? date : new dateInfo_DateInfo(date, this.dateOpts);
    return this.hasExcludeDates && this.excludeDates.find(function (ed) {
      return _this.excludeMode === 'intersects' && ed.intersectsDate(date) || _this.excludeMode === 'includes' && ed.includesDate(date);
    });
  } // Accepts: Day object
  // Returns: First attribute date info that occurs on given day.


  intersectsDay(day) {
    return !this.excludesDay(day) && (this.dates.find(function (d) {
      return d.intersectsDay(day);
    }) || false);
  }

  excludesDay(day) {
    return this.hasExcludeDates && this.excludeDates.find(function (ed) {
      return ed.intersectsDay(day);
    });
  }

}
// CONCATENATED MODULE: ./src/utils/mixins/root.js






const rootMixin = {
  mixins: [defaultsMixin],
  props: {
    color: String,
    isDark: Boolean,
    firstDayOfWeek: Number,
    masks: Object,
    locale: [String, Object],
    timezone: String,
    minDate: null,
    maxDate: null,
    minDateExact: null,
    maxDateExact: null,
    disabledDates: null,
    availableDates: null,
    theme: null
  },
  computed: {
    $theme() {
      // Return the theme prop if it is an instance of the Theme class
      if (this.theme instanceof theme_Theme) return this.theme; // Create the theme

      return new theme_Theme({
        color: this.passedProp('color', 'blue'),
        isDark: this.passedProp('isDark', false)
      });
    },

    $locale() {
      // Return the locale prop if it is an instance of the Locale class
      if (this.locale instanceof locale_Locale) return this.locale; // Build up a base config from component props

      const config = isObject(this.locale) ? this.locale : {
        id: this.locale,
        firstDayOfWeek: this.firstDayOfWeek,
        masks: this.masks
      }; // Return new locale

      return new locale_Locale(config, {
        locales: this.$locales,
        timezone: this.timezone
      });
    },

    disabledDates_() {
      const dates = this.normalizeDates(this.disabledDates);
      const {
        minDate,
        minDateExact,
        maxDate,
        maxDateExact
      } = this; // Add disabled range for min date

      if (minDateExact || minDate) {
        const end = minDateExact ? this.normalizeDate(minDateExact) : this.normalizeDate(minDate, {
          time: '00:00:00'
        });
        dates.push({
          start: null,
          end: new Date(end.getTime() - 1000)
        });
      } // Add disabled range for min date


      if (maxDateExact || maxDate) {
        const start = maxDateExact ? this.normalizeDate(maxDateExact) : this.normalizeDate(maxDate, {
          time: '23:59:59'
        });
        dates.push({
          start: new Date(start.getTime() + 1000),
          end: null
        });
      }

      return dates;
    },

    availableDates_() {
      return this.normalizeDates(this.availableDates);
    },

    disabledAttribute() {
      return new attribute_Attribute({
        key: 'disabled',
        dates: this.disabledDates_,
        excludeDates: this.availableDates_,
        excludeMode: 'includes',
        order: 100
      }, this.$theme, this.$locale);
    }

  },

  created() {
    setupScreens(this.$defaults.screens);
  },

  methods: {
    formatDate(date, mask) {
      return this.$locale ? this.$locale.format(date, mask) : '';
    },

    parseDate(text, mask) {
      if (!this.$locale) return null;
      const value = this.$locale.parse(text, mask);
      return _isDate(value) ? value : null;
    },

    normalizeDate(date, config) {
      return this.$locale ? this.$locale.normalizeDate(date, config) : date;
    },

    normalizeDates(dates) {
      return this.$locale.normalizeDates(dates, {
        isFullDay: true
      });
    },

    pageForDate(date) {
      return this.$locale.getDateParts(this.normalizeDate(date));
    },

    pageForThisMonth() {
      return this.pageForDate(new Date());
    }

  }
};
// CONCATENATED MODULE: ./src/utils/mixins/safeScopedSlot.js

const safeScopedSlotMixin = {
  methods: {
    safeScopedSlot(name, args, def = null) {
      return isFunction_default()(this.$scopedSlots[name]) ? this.$scopedSlots[name](args) : def;
    }

  }
};
// CONCATENATED MODULE: ./src/utils/mixins/index.js



const mixins_childMixin = childMixin;
const mixins_rootMixin = rootMixin;
const mixins_safeScopedSlotMixin = safeScopedSlotMixin;
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PopoverRow.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PopoverRowvue_type_script_lang_js_ = ({
  name: 'PopoverRow',
  mixins: [mixins_childMixin],
  props: {
    attribute: Object
  },
  computed: {
    indicator() {
      const {
        highlight,
        dot,
        bar,
        popover
      } = this.attribute;
      if (popover && popover.hideIndicator) return null;

      if (highlight) {
        const {
          color,
          isDark
        } = highlight.start;
        return {
          style: { ...this.theme.bgAccentHigh({
              color,
              isDark: !isDark
            }),
            width: '10px',
            height: '5px',
            borderRadius: '3px'
          }
        };
      }

      if (dot) {
        const {
          color,
          isDark
        } = dot.start;
        return {
          style: { ...this.theme.bgAccentHigh({
              color,
              isDark: !isDark
            }),
            width: '5px',
            height: '5px',
            borderRadius: '50%'
          }
        };
      }

      if (bar) {
        const {
          color,
          isDark
        } = bar.start;
        return {
          style: { ...this.theme.bgAccentHigh({
              color,
              isDark: !isDark
            }),
            width: '10px',
            height: '3px'
          }
        };
      }

      return null;
    }

  }
});
// CONCATENATED MODULE: ./src/components/PopoverRow.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PopoverRowvue_type_script_lang_js_ = (PopoverRowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/PopoverRow.vue?vue&type=style&index=0&id=eb5afd1a&lang=postcss&scoped=true&
var PopoverRowvue_type_style_index_0_id_eb5afd1a_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("d438");

// CONCATENATED MODULE: ./src/components/PopoverRow.vue






/* normalize component */

var PopoverRow_component = normalizeComponent(
  components_PopoverRowvue_type_script_lang_js_,
  PopoverRowvue_type_template_id_eb5afd1a_scoped_true_render,
  PopoverRowvue_type_template_id_eb5afd1a_scoped_true_staticRenderFns,
  false,
  null,
  "eb5afd1a",
  null
  
)

/* harmony default export */ var PopoverRow = (PopoverRow_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1901b52e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarNav.vue?vue&type=template&id=9686ba66&
var CalendarNavvue_type_template_id_9686ba66_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-nav-container"},[_c('div',{staticClass:"vc-nav-header"},[_c('span',{staticClass:"vc-nav-arrow is-left",class:{ 'is-disabled': !_vm.prevItemsEnabled },attrs:{"role":"button","tabindex":_vm.prevItemsEnabled ? 0 : undefined},on:{"click":_vm.movePrev,"keydown":function (e) { return _vm.onSpaceOrEnter(e, _vm.movePrev); }}},[_vm._t("nav-left-button",[_c('svg-icon',{attrs:{"name":"left-arrow","width":"20px","height":"24px"}})])],2),_c('span',{staticClass:"vc-nav-title vc-grid-focus",style:({ whiteSpace: 'nowrap' }),attrs:{"role":"button","tabindex":"0"},on:{"click":_vm.toggleMode,"keydown":function (e) { return _vm.onSpaceOrEnter(e, _vm.toggleMode); }}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"vc-nav-arrow is-right",class:{ 'is-disabled': !_vm.nextItemsEnabled },attrs:{"role":"button","tabindex":_vm.nextItemsEnabled ? 0 : undefined},on:{"click":_vm.moveNext,"keydown":function (e) { return _vm.onSpaceOrEnter(e, _vm.moveNext); }}},[_vm._t("nav-right-button",[_c('svg-icon',{attrs:{"name":"right-arrow","width":"20px","height":"24px"}})])],2)]),_c('div',{staticClass:"vc-nav-items"},_vm._l((_vm.activeItems),function(item){return _c('span',{key:item.label,class:_vm.getItemClasses(item),attrs:{"role":"button","data-id":item.id,"aria-label":item.ariaLabel,"tabindex":item.isDisabled ? undefined : 0},on:{"click":item.click,"keydown":function (e) { return _vm.onSpaceOrEnter(e, item.click); }}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])}
var CalendarNavvue_type_template_id_9686ba66_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/CalendarNav.vue?vue&type=template&id=9686ba66&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1901b52e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SvgIcon.vue?vue&type=template&id=63f7b5ec&scoped=true&
var SvgIconvue_type_template_id_63f7b5ec_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"vc-svg-icon",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox}},_vm.$listeners),[_c('path',{attrs:{"d":_vm.path}})])}
var SvgIconvue_type_template_id_63f7b5ec_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/SvgIcon.vue?vue&type=template&id=63f7b5ec&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/SvgIcon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
const _defSize = '26px';
const _defViewBox = '0 0 32 32';
const icons = {
  'left-arrow': {
    viewBox: '0 -1 16 34',
    path: 'M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z'
  },
  'right-arrow': {
    viewBox: '-5 -1 16 34',
    path: 'M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z'
  }
};
/* harmony default export */ var SvgIconvue_type_script_lang_js_ = ({
  props: ['name'],

  data() {
    return {
      width: _defSize,
      height: _defSize,
      viewBox: _defViewBox,
      path: '',
      isBaseline: false
    };
  },

  mounted() {
    this.updateIcon();
  },

  watch: {
    name() {
      this.updateIcon();
    }

  },
  methods: {
    updateIcon() {
      const icon = icons[this.name];

      if (icon) {
        this.width = icon.width || _defSize;
        this.height = icon.height || _defSize;
        this.viewBox = icon.viewBox;
        this.path = icon.path;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/SvgIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_SvgIconvue_type_script_lang_js_ = (SvgIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/SvgIcon.vue?vue&type=style&index=0&id=63f7b5ec&lang=postcss&scoped=true&
var SvgIconvue_type_style_index_0_id_63f7b5ec_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("9010");

// CONCATENATED MODULE: ./src/components/SvgIcon.vue






/* normalize component */

var SvgIcon_component = normalizeComponent(
  components_SvgIconvue_type_script_lang_js_,
  SvgIconvue_type_template_id_63f7b5ec_scoped_true_render,
  SvgIconvue_type_template_id_63f7b5ec_scoped_true_staticRenderFns,
  false,
  null,
  "63f7b5ec",
  null
  
)

/* harmony default export */ var SvgIcon = (SvgIcon_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarNav.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




const _yearGroupCount = 12;
/* harmony default export */ var CalendarNavvue_type_script_lang_js_ = ({
  name: 'CalendarNav',
  components: {
    SvgIcon: SvgIcon
  },
  mixins: [mixins_childMixin],
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          month: 0,
          year: 0
        };
      }
    },
    validator: {
      type: Function,
      default: function () {
        return function () {
          return true;
        };
      }
    }
  },

  data() {
    return {
      monthMode: true,
      yearIndex: 0,
      yearGroupIndex: 0,
      onSpaceOrEnter: onSpaceOrEnter
    };
  },

  computed: {
    month() {
      return this.value ? this.value.month || 0 : 0;
    },

    year() {
      return this.value ? this.value.year || 0 : 0;
    },

    title() {
      return this.monthMode ? this.yearIndex : `${this.firstYear} - ${this.lastYear}`;
    },

    monthItems() {
      return this.getMonthItems(this.yearIndex);
    },

    yearItems() {
      return this.getYearItems(this.yearGroupIndex);
    },

    prevItemsEnabled() {
      return this.monthMode ? this.prevMonthItemsEnabled : this.prevYearItemsEnabled;
    },

    nextItemsEnabled() {
      return this.monthMode ? this.nextMonthItemsEnabled : this.nextYearItemsEnabled;
    },

    prevMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex - 1).some(function (i) {
        return !i.isDisabled;
      });
    },

    nextMonthItemsEnabled() {
      return this.getMonthItems(this.yearIndex + 1).some(function (i) {
        return !i.isDisabled;
      });
    },

    prevYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex - 1).some(function (i) {
        return !i.isDisabled;
      });
    },

    nextYearItemsEnabled() {
      return this.getYearItems(this.yearGroupIndex + 1).some(function (i) {
        return !i.isDisabled;
      });
    },

    activeItems() {
      return this.monthMode ? this.monthItems : this.yearItems;
    },

    firstYear() {
      return head_default()(this.yearItems.map(function (i) {
        return i.year;
      }));
    },

    lastYear() {
      return last_default()(this.yearItems.map(function (i) {
        return i.year;
      }));
    }

  },
  watch: {
    year() {
      this.yearIndex = this.year;
    },

    yearIndex(val) {
      this.yearGroupIndex = this.getYearGroupIndex(val);
    },

    value() {
      this.focusFirstItem();
    }

  },

  created() {
    this.yearIndex = this.year;
  },

  mounted() {
    this.focusFirstItem();
  },

  methods: {
    focusFirstItem() {
      var _this = this;

      this.$nextTick(function () {
        // Set focus on the first enabled nav item
        const focusableEl = _this.$el.querySelector('.vc-nav-item:not(.is-disabled)');

        if (focusableEl) {
          focusableEl.focus();
        }
      });
    },

    getItemClasses({
      isActive,
      isCurrent,
      isDisabled
    }) {
      const classes = ['vc-nav-item'];

      if (isActive) {
        classes.push('is-active');
      } else if (isCurrent) {
        classes.push('is-current');
      }

      if (isDisabled) {
        classes.push('is-disabled');
      }

      return classes;
    },

    getYearGroupIndex(year) {
      return Math.floor(year / _yearGroupCount);
    },

    getMonthItems(year) {
      var _this2 = this;

      const {
        month: thisMonth,
        year: thisYear
      } = this.pageForDate(new Date());
      return this.locale.getMonthDates().map(function (d, i) {
        const month = i + 1;
        return {
          month,
          year,
          id: `${year}.${pad(month, 2)}`,
          label: _this2.locale.format(d, _this2.masks.navMonths),
          ariaLabel: _this2.locale.format(d, 'MMMM YYYY'),
          isActive: month === _this2.month && year === _this2.year,
          isCurrent: month === thisMonth && year === thisYear,
          isDisabled: !_this2.validator({
            month,
            year
          }),
          click: function () {
            return _this2.monthClick(month, year);
          }
        };
      });
    },

    getYearItems(yearGroupIndex) {
      var _this3 = this;

      const {
        _,
        year: thisYear
      } = this.pageForDate(new Date());
      const startYear = yearGroupIndex * _yearGroupCount;
      const endYear = startYear + _yearGroupCount;
      const items = [];

      for (let year = startYear; year < endYear; year += 1) {
        let enabled = false;

        for (let month = 1; month < 12; month++) {
          enabled = this.validator({
            month,
            year
          });
          if (enabled) break;
        }

        items.push({
          year,
          id: year,
          label: year,
          ariaLabel: year,
          isActive: year === this.year,
          isCurrent: year === thisYear,
          isDisabled: !enabled,
          click: function () {
            return _this3.yearClick(year);
          }
        });
      }

      return items;
    },

    monthClick(month, year) {
      if (this.validator({
        month,
        year
      })) {
        this.$emit('input', {
          month,
          year
        });
      }
    },

    yearClick(year) {
      this.yearIndex = year;
      this.monthMode = true;
      this.focusFirstItem();
    },

    toggleMode() {
      this.monthMode = !this.monthMode;
    },

    movePrev() {
      if (!this.prevItemsEnabled) return;

      if (this.monthMode) {
        this.movePrevYear();
      }

      this.movePrevYearGroup();
    },

    moveNext() {
      if (!this.nextItemsEnabled) return;

      if (this.monthMode) {
        this.moveNextYear();
      }

      this.moveNextYearGroup();
    },

    movePrevYear() {
      this.yearIndex--;
    },

    moveNextYear() {
      this.yearIndex++;
    },

    movePrevYearGroup() {
      this.yearGroupIndex--;
    },

    moveNextYearGroup() {
      this.yearGroupIndex++;
    }

  }
});
// CONCATENATED MODULE: ./src/components/CalendarNav.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarNavvue_type_script_lang_js_ = (CalendarNavvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarNav.vue?vue&type=style&index=0&lang=postcss&
var CalendarNavvue_type_style_index_0_lang_postcss_ = __nested_webpack_require_310292__("3c55");

// CONCATENATED MODULE: ./src/components/CalendarNav.vue






/* normalize component */

var CalendarNav_component = normalizeComponent(
  components_CalendarNavvue_type_script_lang_js_,
  CalendarNavvue_type_template_id_9686ba66_render,
  CalendarNavvue_type_template_id_9686ba66_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarNav = (CalendarNav_component.exports);
// CONCATENATED MODULE: ./src/utils/popovers.js

function popovers_showPopover(opts) {
  if (document) {
    document.dispatchEvent(new CustomEvent('show-popover', {
      detail: opts
    }));
  }
}
function popovers_hidePopover(opts) {
  if (document) {
    document.dispatchEvent(new CustomEvent('hide-popover', {
      detail: opts
    }));
  }
}
function popovers_togglePopover(opts) {
  if (document) {
    document.dispatchEvent(new CustomEvent('toggle-popover', {
      detail: opts
    }));
  }
}
function updatePopover(opts) {
  if (document) {
    document.dispatchEvent(new CustomEvent('update-popover', {
      detail: opts
    }));
  }
}
function getPopoverTriggerEvents(opts) {
  const {
    visibility
  } = opts;
  const click = visibility === 'click';
  const hover = visibility === 'hover';
  const hoverFocus = visibility === 'hover-focus';
  const focus = visibility === 'focus';
  opts.autoHide = !click;
  let hovered = false;
  let focused = false;
  return {
    click(e) {
      if (click) {
        opts.ref = e.target;
        popovers_togglePopover(opts);
        e.stopPropagation();
      }
    },

    mousemove(e) {
      opts.ref = e.currentTarget;

      if (!hovered) {
        hovered = true;

        if (hover || hoverFocus) {
          popovers_showPopover(opts);
        }
      }
    },

    mouseleave(e) {
      opts.ref = e.target;

      if (hovered) {
        hovered = false;

        if (hover || hoverFocus && !focused) {
          popovers_hidePopover(opts);
        }
      }
    },

    focusin(e) {
      opts.ref = e.currentTarget;

      if (!focused) {
        focused = true;

        if (focus || hoverFocus) {
          popovers_showPopover(opts);
        }
      }
    },

    focusout(e) {
      opts.ref = e.currentTarget;

      if (focused && !elementContains(opts.ref, e.relatedTarget)) {
        focused = false;

        if (focus || hoverFocus && !hovered) {
          popovers_hidePopover(opts);
        }
      }
    }

  };
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarDay.vue?vue&type=script&lang=js&





/* harmony default export */ var CalendarDayvue_type_script_lang_js_ = ({
  name: 'CalendarDay',
  mixins: [mixins_childMixin, mixins_safeScopedSlotMixin],

  render(h) {
    var _this = this;

    // Backgrounds layer
    const backgroundsLayer = function () {
      return _this.hasBackgrounds && h('div', {
        class: 'vc-highlights vc-day-layer'
      }, _this.backgrounds.map(function ({
        key,
        wrapperClass,
        class: bgClass,
        style
      }) {
        return h('div', {
          key,
          class: wrapperClass
        }, [h('div', {
          class: bgClass,
          style
        })]);
      }));
    }; // Content layer


    const contentLayer = function () {
      return _this.safeScopedSlot('day-content', {
        day: _this.day,
        attributes: _this.day.attributes,
        attributesMap: _this.day.attributesMap,
        dayProps: _this.dayContentProps,
        dayEvents: _this.dayContentEvents
      }) || h('span', {
        class: _this.dayContentClass,
        style: _this.dayContentStyle,
        attrs: { ..._this.dayContentProps
        },
        on: _this.dayContentEvents,
        ref: 'content'
      }, [_this.day.label]);
    }; // Dots layer


    const dotsLayer = function () {
      return _this.hasDots && h('div', {
        class: 'vc-day-layer vc-day-box-center-bottom'
      }, [h('div', {
        class: 'vc-dots'
      }, _this.dots.map(function ({
        key,
        class: bgClass,
        style
      }) {
        return h('span', {
          key,
          class: bgClass,
          style
        });
      }))]);
    }; // Bars layer


    const barsLayer = function () {
      return _this.hasBars && h('div', {
        class: 'vc-day-layer vc-day-box-center-bottom'
      }, [h('div', {
        class: 'vc-bars'
      }, _this.bars.map(function ({
        key,
        class: bgClass,
        style
      }) {
        return h('span', {
          key,
          class: bgClass,
          style
        });
      }))]);
    }; // Root layer


    return h('div', {
      class: ['vc-day', ...this.day.classes, {
        'vc-day-box-center-center': !this.$scopedSlots['day-content']
      }, {
        'is-not-in-month': !this.inMonth
      }]
    }, [backgroundsLayer(), contentLayer(), dotsLayer(), barsLayer()]);
  },

  inject: ['sharedState'],
  props: {
    day: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      glyphs: {},
      dayContentEvents: {}
    };
  },

  computed: {
    label() {
      return this.day.label;
    },

    startTime() {
      return this.day.range.start.getTime();
    },

    endTime() {
      return this.day.range.end.getTime();
    },

    inMonth() {
      return this.day.inMonth;
    },

    isDisabled() {
      return this.day.isDisabled;
    },

    backgrounds() {
      return this.glyphs.backgrounds;
    },

    hasBackgrounds() {
      return !!arrayHasItems(this.backgrounds);
    },

    content() {
      return this.glyphs.content;
    },

    dots() {
      return this.glyphs.dots;
    },

    hasDots() {
      return !!arrayHasItems(this.dots);
    },

    bars() {
      return this.glyphs.bars;
    },

    hasBars() {
      return !!arrayHasItems(this.bars);
    },

    popovers() {
      return this.glyphs.popovers;
    },

    hasPopovers() {
      return !!arrayHasItems(this.popovers);
    },

    dayContentClass() {
      return ['vc-day-content vc-focusable', {
        'is-disabled': this.isDisabled
      }, get_default()(last_default()(this.content), 'class') || ''];
    },

    dayContentStyle() {
      return get_default()(last_default()(this.content), 'style');
    },

    dayContentProps() {
      let tabindex;

      if (this.day.isFocusable) {
        tabindex = '0';
      } else if (this.day.inMonth) {
        tabindex = '-1';
      }

      return {
        tabindex,
        'aria-label': this.day.ariaLabel,
        'aria-disabled': this.day.isDisabled ? 'true' : 'false',
        role: 'button'
      };
    },

    dayEvent() {
      return { ...this.day,
        el: this.$refs.content,
        popovers: this.popovers
      };
    }

  },
  watch: {
    theme() {
      this.refresh();
    },

    popovers() {
      this.refreshPopovers();
    }

  },

  mounted() {
    this.refreshPopovers();
  },

  methods: {
    getDayEvent(origEvent) {
      return { ...this.dayEvent,
        event: origEvent
      };
    },

    click(e) {
      this.$emit('dayclick', this.getDayEvent(e));
    },

    mouseenter(e) {
      this.$emit('daymouseenter', this.getDayEvent(e));
    },

    mouseleave(e) {
      this.$emit('daymouseleave', this.getDayEvent(e));
    },

    focusin(e) {
      this.$emit('dayfocusin', this.getDayEvent(e));
    },

    focusout(e) {
      this.$emit('dayfocusout', this.getDayEvent(e));
    },

    keydown(e) {
      this.$emit('daykeydown', this.getDayEvent(e));
    },

    refresh() {
      var _this2 = this;

      if (!this.day.refresh) return;
      this.day.refresh = false;
      const glyphs = {
        backgrounds: [],
        dots: [],
        bars: [],
        popovers: [],
        content: []
      }; // Use $set to trigger reactivity in popovers, if needed

      this.$set(this.day, 'attributes', Object.values(this.day.attributesMap || {}).sort(function (a, b) {
        return a.order - b.order;
      }));
      this.day.attributes.forEach(function (attr) {
        // Add glyphs for each attribute
        const {
          targetDate
        } = attr;
        const {
          isDate,
          isComplex,
          startTime,
          endTime
        } = targetDate;
        const onStart = _this2.startTime <= startTime;
        const onEnd = _this2.endTime >= endTime;
        const onStartAndEnd = onStart && onEnd;
        const onStartOrEnd = onStart || onEnd;
        const dateInfo = {
          isDate,
          isComplex,
          onStart,
          onEnd,
          onStartAndEnd,
          onStartOrEnd
        };

        _this2.processHighlight(attr, dateInfo, glyphs);

        _this2.processNonHighlight(attr, 'content', dateInfo, glyphs.content);

        _this2.processNonHighlight(attr, 'dot', dateInfo, glyphs.dots);

        _this2.processNonHighlight(attr, 'bar', dateInfo, glyphs.bars);

        _this2.processPopover(attr, glyphs);
      });
      this.glyphs = glyphs;
    },

    processHighlight({
      key,
      highlight
    }, {
      isDate,
      isComplex,
      onStart,
      onEnd,
      onStartAndEnd
    }, {
      backgrounds,
      content
    }) {
      if (!highlight) return;
      const {
        base,
        start,
        end
      } = highlight;

      if (isDate || isComplex) {
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', start.class],
          style: start.style
        });
        content.push({
          key: `${key}-content`,
          class: start.contentClass,
          style: start.contentStyle
        });
      } else if (onStartAndEnd) {
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', start.class],
          style: start.style
        });
        content.push({
          key: `${key}-content`,
          class: start.contentClass,
          style: start.contentStyle
        });
      } else if (onStart) {
        backgrounds.push({
          key: `${key}-base`,
          wrapperClass: 'vc-day-layer vc-day-box-right-center',
          class: ['vc-highlight vc-highlight-base-start', base.class],
          style: base.style
        });
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', start.class],
          style: start.style
        });
        content.push({
          key: `${key}-content`,
          class: start.contentClass,
          style: start.contentStyle
        });
      } else if (onEnd) {
        backgrounds.push({
          key: `${key}-base`,
          wrapperClass: 'vc-day-layer vc-day-box-left-center',
          class: ['vc-highlight vc-highlight-base-end', base.class],
          style: base.style
        });
        backgrounds.push({
          key,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight', end.class],
          style: end.style
        });
        content.push({
          key: `${key}-content`,
          class: end.contentClass,
          style: end.contentStyle
        });
      } else {
        backgrounds.push({
          key: `${key}-middle`,
          wrapperClass: 'vc-day-layer vc-day-box-center-center',
          class: ['vc-highlight vc-highlight-base-middle', base.class],
          style: base.style
        });
        content.push({
          key: `${key}-content`,
          class: base.contentClass,
          style: base.contentStyle
        });
      }
    },

    processNonHighlight(attr, itemKey, {
      isDate,
      onStart,
      onEnd
    }, list) {
      if (!attr[itemKey]) return;
      const {
        key
      } = attr;
      const className = `vc-${itemKey}`;
      const {
        base,
        start,
        end
      } = attr[itemKey];

      if (isDate || onStart) {
        list.push({
          key,
          class: [className, start.class],
          style: start.style
        });
      } else if (onEnd) {
        list.push({
          key,
          class: [className, end.class],
          style: end.style
        });
      } else {
        list.push({
          key,
          class: [className, base.class],
          style: base.style
        });
      }
    },

    processPopover(attribute, {
      popovers
    }) {
      const {
        key,
        customData,
        popover
      } = attribute;
      if (!popover) return;
      const resolvedPopover = defaults_default()({
        key,
        customData,
        attribute
      }, { ...popover
      }, {
        visibility: popover.label ? 'hover' : 'click',
        placement: 'bottom',
        isInteractive: !popover.label
      });
      popovers.splice(0, 0, resolvedPopover);
    },

    refreshPopovers() {
      let popoverEvents = {};

      if (arrayHasItems(this.popovers)) {
        popoverEvents = getPopoverTriggerEvents(defaults_default()({
          id: this.dayPopoverId,
          data: this.day
        }, ...this.popovers));
      }

      this.dayContentEvents = mergeEvents({
        click: this.click,
        mouseenter: this.mouseenter,
        mouseleave: this.mouseleave,
        focusin: this.focusin,
        focusout: this.focusout,
        keydown: this.keydown
      }, popoverEvents);
      updatePopover({
        id: this.dayPopoverId,
        data: this.day
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/CalendarDay.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarDayvue_type_script_lang_js_ = (CalendarDayvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarDay.vue?vue&type=style&index=0&id=4420d078&lang=postcss&scoped=true&
var CalendarDayvue_type_style_index_0_id_4420d078_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("1f64");

// CONCATENATED MODULE: ./src/components/CalendarDay.vue
var CalendarDay_render, CalendarDay_staticRenderFns





/* normalize component */

var CalendarDay_component = normalizeComponent(
  components_CalendarDayvue_type_script_lang_js_,
  CalendarDay_render,
  CalendarDay_staticRenderFns,
  false,
  null,
  "4420d078",
  null
  
)

/* harmony default export */ var CalendarDay = (CalendarDay_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CalendarPane.vue?vue&type=script&lang=js&




/* harmony default export */ var CalendarPanevue_type_script_lang_js_ = ({
  name: 'CalendarPane',
  mixins: [mixins_childMixin, mixins_safeScopedSlotMixin],

  render(h) {
    var _this = this;

    // Header
    const header = this.safeScopedSlot('header', this.page) || // Default header
    h('div', {
      class: `vc-header align-${this.titlePosition}`
    }, [// Header title
    h('div', {
      class: 'vc-title',
      on: this.navPopoverEvents
    }, [this.safeScopedSlot('header-title', this.page, this.page.title)])]); // Weekday cells

    const weekdayCells = this.weekdayLabels.map(function (wl, i) {
      return h('div', {
        key: i + 1,
        class: 'vc-weekday'
      }, [wl]);
    });
    const showWeeknumbersLeft = this.showWeeknumbers_.startsWith('left');
    const showWeeknumbersRight = this.showWeeknumbers_.startsWith('right');

    if (showWeeknumbersLeft) {
      weekdayCells.unshift(h('div', {
        class: 'vc-weekday'
      }));
    } else if (showWeeknumbersRight) {
      weekdayCells.push(h('div', {
        class: 'vc-weekday'
      }));
    } // Weeknumber cell


    const getWeeknumberCell = function (weeknumber) {
      return h('div', {
        class: ['vc-weeknumber']
      }, [h('span', {
        class: ['vc-weeknumber-content', `is-${_this.showWeeknumbers_}`],
        on: {
          click: function (event) {
            _this.$emit('weeknumberclick', {
              weeknumber,
              days: _this.page.days.filter(function (d) {
                return d[_this.weeknumberKey] === weeknumber;
              }),
              event
            });
          }
        }
      }, [weeknumber])]);
    }; // Day cells


    const dayCells = [];
    const {
      daysInWeek
    } = this.locale;
    this.page.days.forEach(function (day, i) {
      const mod = i % daysInWeek; // Insert weeknumber cell on left side if needed

      if (showWeeknumbersLeft && mod === 0 || showWeeknumbersRight && mod === daysInWeek) {
        dayCells.push(getWeeknumberCell(day[_this.weeknumberKey]));
      }

      dayCells.push(h(CalendarDay, {
        attrs: {
          day
        },
        on: { ..._this.$listeners
        },
        scopedSlots: _this.$scopedSlots,
        key: day.id,
        ref: 'days',
        refInFor: true
      })); // Insert weeknumber cell on right side if needed

      if (showWeeknumbersRight && mod === daysInWeek - 1) {
        dayCells.push(getWeeknumberCell(day[_this.weeknumberKey]));
      }
    });
    const weeks = h('div', {
      class: {
        'vc-weeks': true,
        'vc-show-weeknumbers': this.showWeeknumbers_,
        'is-left': showWeeknumbersLeft,
        'is-right': showWeeknumbersRight
      }
    }, [weekdayCells, dayCells]);
    return h('div', {
      class: ['vc-pane', `row-from-end-${this.rowFromEnd}`, `column-from-end-${this.columnFromEnd}`],
      ref: 'pane'
    }, [header, weeks]);
  },

  inheritAttrs: false,
  props: {
    page: Object,
    position: Number,
    row: Number,
    rowFromEnd: Number,
    column: Number,
    columnFromEnd: Number,
    titlePosition: String,
    navVisibility: String,
    showWeeknumbers: [Boolean, String],
    showIsoWeeknumbers: [Boolean, String]
  },
  computed: {
    weeknumberKey() {
      return this.showWeeknumbers ? 'weeknumber' : 'isoWeeknumber';
    },

    showWeeknumbers_() {
      const showWeeknumbers = this.showWeeknumbers || this.showIsoWeeknumbers;
      if (showWeeknumbers == null) return '';

      if (isBoolean_default()(showWeeknumbers)) {
        return showWeeknumbers ? 'left' : '';
      }

      if (showWeeknumbers.startsWith('right')) {
        return this.columnFromEnd > 1 ? 'right' : showWeeknumbers;
      }

      return this.column > 1 ? 'left' : showWeeknumbers;
    },

    navVisibility_() {
      return this.propOrDefault('navVisibility', 'navVisibility');
    },

    navPlacement() {
      switch (this.titlePosition) {
        case 'left':
          return 'bottom-start';

        case 'right':
          return 'bottom-end';

        default:
          return 'bottom';
      }
    },

    navPopoverEvents() {
      const {
        sharedState,
        navVisibility_,
        navPlacement,
        page,
        position
      } = this;
      return getPopoverTriggerEvents({
        id: sharedState.navPopoverId,
        visibility: navVisibility_,
        placement: navPlacement,
        modifiers: [{
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom']
          }
        }],
        data: {
          page,
          position
        },
        isInteractive: true
      });
    },

    weekdayLabels() {
      var _this2 = this;

      return this.locale.getWeekdayDates().map(function (d) {
        return _this2.format(d, _this2.masks.weekdays);
      });
    }

  },
  methods: {
    refresh() {
      this.$refs.days.forEach(function (d) {
        return d.refresh();
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/CalendarPane.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CalendarPanevue_type_script_lang_js_ = (CalendarPanevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CalendarPane.vue?vue&type=style&index=0&id=74ad501d&lang=postcss&scoped=true&
var CalendarPanevue_type_style_index_0_id_74ad501d_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("fccf");

// EXTERNAL MODULE: ./src/components/CalendarPane.vue?vue&type=style&index=1&lang=css&
var CalendarPanevue_type_style_index_1_lang_css_ = __nested_webpack_require_310292__("4889");

// CONCATENATED MODULE: ./src/components/CalendarPane.vue
var CalendarPane_render, CalendarPane_staticRenderFns






/* normalize component */

var CalendarPane_component = normalizeComponent(
  components_CalendarPanevue_type_script_lang_js_,
  CalendarPane_render,
  CalendarPane_staticRenderFns,
  false,
  null,
  "74ad501d",
  null
  
)

/* harmony default export */ var CalendarPane = (CalendarPane_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CustomTransition.vue?vue&type=script&lang=js&
/* harmony default export */ var CustomTransitionvue_type_script_lang_js_ = ({
  name: 'CustomTransition',

  render(h) {
    return h('transition', {
      props: {
        name: this.name_,
        appear: this.appear
      },
      on: {
        beforeEnter: this.beforeEnter,
        afterEnter: this.afterEnter
      }
    }, [this.$slots.default]);
  },

  props: {
    name: String,
    appear: Boolean
  },
  computed: {
    name_() {
      return this.name || 'none';
    }

  },
  methods: {
    beforeEnter(el) {
      this.$emit('beforeEnter', el);
      this.$emit('beforeTransition', el);
    },

    afterEnter(el) {
      this.$emit('afterEnter', el);
      this.$emit('afterTransition', el);
    }

  }
});
// CONCATENATED MODULE: ./src/components/CustomTransition.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_CustomTransitionvue_type_script_lang_js_ = (CustomTransitionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/CustomTransition.vue?vue&type=style&index=0&id=5be4b00c&lang=postcss&scoped=true&
var CustomTransitionvue_type_style_index_0_id_5be4b00c_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("2285");

// CONCATENATED MODULE: ./src/components/CustomTransition.vue
var CustomTransition_render, CustomTransition_staticRenderFns





/* normalize component */

var CustomTransition_component = normalizeComponent(
  components_CustomTransitionvue_type_script_lang_js_,
  CustomTransition_render,
  CustomTransition_staticRenderFns,
  false,
  null,
  "5be4b00c",
  null
  
)

/* harmony default export */ var CustomTransition = (CustomTransition_component.exports);
// CONCATENATED MODULE: ./src/utils/attributeStore.js



class attributeStore_AttributeStore {
  constructor(theme, locale, attrs) {
    this.theme = theme;
    this.locale = locale;
    this.map = {};
    this.refresh(attrs, true);
  }

  destroy() {
    this.theme = null;
    this.locale = null;
    this.map = {};
    this.list = [];
    this.pinAttr = null;
  }

  refresh(attrs, reset) {
    var _this = this;

    const map = {};
    const list = [];
    let pinAttr = null; // Keep record of added and deleted attributes

    const adds = [];
    const deletes = reset ? new Set() : new Set(Object.keys(this.map));

    if (arrayHasItems(attrs)) {
      attrs.forEach(function (attr, i) {
        if (!attr || !attr.dates) return;
        const key = attr.key ? attr.key.toString() : i.toString();
        const order = attr.order || 0;
        const hashcode = helpers_hash(JSON.stringify(attr));
        let exAttr = _this.map[key]; // If just tracking delta changes and attribute hash hasn't changed

        if (!reset && exAttr && exAttr.hashcode === hashcode) {
          // ...don't need to replace the attribute
          deletes.delete(key);
        } else {
          // Otherwise, create attribute and add to the list of adds
          exAttr = new attribute_Attribute({
            key,
            order,
            hashcode,
            ...attr
          }, _this.theme, _this.locale);
          adds.push(exAttr);
        } // Keep track of attribute to pin for initial page


        if (exAttr && exAttr.pinPage) {
          pinAttr = exAttr;
        } // Add attribute to map and list


        map[key] = exAttr;
        list.push(exAttr);
      });
    }

    this.map = map;
    this.list = list;
    this.pinAttr = pinAttr;
    return {
      adds,
      deletes: Array.from(deletes)
    };
  }

}
// CONCATENATED MODULE: ./src/utils/touch.js


const addHorizontalSwipeHandler = function (element, handler, {
  maxSwipeTime,
  minHorizontalSwipeDistance,
  maxVerticalSwipeDistance
}) {
  if (!element || !element.addEventListener || !isFunction_default()(handler)) {
    return null;
  } // State variables


  let startX = 0;
  let startY = 0;
  let startTime = null;
  let isSwiping = false; // Touch start handler

  function touchStart(e) {
    const t = e.changedTouches[0];
    startX = t.screenX;
    startY = t.screenY;
    startTime = new Date().getTime();
    isSwiping = true;
  } // Touch end handler


  function touchEnd(e) {
    if (!isSwiping) return;
    isSwiping = false;
    const t = e.changedTouches[0];
    const deltaX = t.screenX - startX;
    const deltaY = t.screenY - startY;
    const deltaTime = new Date().getTime() - startTime;

    if (deltaTime < maxSwipeTime) {
      if (Math.abs(deltaX) >= minHorizontalSwipeDistance && Math.abs(deltaY) <= maxVerticalSwipeDistance) {
        const arg = {
          toLeft: false,
          toRight: false
        };

        if (deltaX < 0) {
          // Swipe to the left
          arg.toLeft = true;
        } else {
          // Swipe to the right
          arg.toRight = true;
        }

        handler(arg);
      }
    }
  } // Add event handlers


  on(element, 'touchstart', touchStart, {
    passive: true
  }); // on(element, 'touchmove', touchmove);

  on(element, 'touchend', touchEnd, {
    passive: true
  }); // Return function that removes event handlers

  return function () {
    off(element, 'touchstart', touchStart); // off(element, 'touchmove', touchmove);

    off(element, 'touchend', touchEnd);
  };
};
// EXTERNAL MODULE: ./src/styles/base.css
var base = __nested_webpack_require_310292__("3ee2");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Calendar.vue?vue&type=script&lang=js&
















/* harmony default export */ var Calendarvue_type_script_lang_js_ = ({
  name: 'Calendar',

  render(h) {
    var _this = this;

    // Renderer for calendar panes
    const panes = this.pages.map(function (page, i) {
      const position = i + 1;
      const row = Math.ceil((i + 1) / _this.columns);
      const rowFromEnd = _this.rows - row + 1;
      const column = position % _this.columns || _this.columns;
      const columnFromEnd = _this.columns - column + 1;
      return h(CalendarPane, {
        attrs: { ..._this.$attrs,
          attributes: _this.store
        },
        props: {
          page,
          position,
          row,
          rowFromEnd,
          column,
          columnFromEnd,
          titlePosition: _this.titlePosition_
        },
        on: { ..._this.$listeners,
          dayfocusin: function (e) {
            _this.lastFocusedDay = e;

            _this.$emit('dayfocusin', e);
          },
          dayfocusout: function (e) {
            _this.lastFocusedDay = null;

            _this.$emit('dayfocusout', e);
          }
        },
        scopedSlots: _this.$scopedSlots,
        key: page.key,
        ref: 'pages',
        refInFor: true
      });
    }); // Renderer for calendar arrows

    const getArrowButton = function (isPrev) {
      const click = function () {
        return _this.move(isPrev ? -_this.step_ : _this.step_);
      };

      const keydown = function (e) {
        return onSpaceOrEnter(e, click);
      };

      const isDisabled = isPrev ? !_this.canMovePrev : !_this.canMoveNext;
      return h('div', {
        class: ['vc-arrow', `is-${isPrev ? 'left' : 'right'}`, {
          'is-disabled': isDisabled
        }],
        attrs: {
          role: 'button'
        },
        on: {
          click,
          keydown
        }
      }, [(isPrev ? _this.safeScopedSlot('header-left-button', {
        click
      }) : _this.safeScopedSlot('header-right-button', {
        click
      })) || h(SvgIcon, {
        props: {
          name: isPrev ? 'left-arrow' : 'right-arrow'
        }
      })]);
    }; // Nav popover


    const getNavPopover = function () {
      return h(Popover, {
        props: {
          id: _this.sharedState.navPopoverId,
          contentClass: 'vc-nav-popover-container'
        },
        ref: 'navPopover',
        scopedSlots: {
          default: function ({
            data
          }) {
            const {
              position,
              page
            } = data;
            return h(CalendarNav, {
              props: {
                value: page,
                position,
                validator: function (e) {
                  return _this.canMove(e, {
                    position
                  });
                }
              },
              on: {
                input: function (e) {
                  return _this.move(e, {
                    position
                  });
                }
              },
              scopedSlots: _this.$scopedSlots
            });
          }
        }
      });
    }; // Day popover


    const getDayPopover = function () {
      return h(Popover, {
        props: {
          id: _this.sharedState.dayPopoverId,
          contentClass: 'vc-day-popover-container'
        },
        scopedSlots: {
          default: function ({
            data: day,
            updateLayout,
            hide
          }) {
            const attributes = Object.values(day.attributes).filter(function (a) {
              return a.popover;
            });
            const masks = _this.$locale.masks;
            const format = _this.formatDate;
            const dayTitle = format(day.date, masks.dayPopover);
            return _this.safeScopedSlot('day-popover', {
              day,
              attributes,
              masks,
              format,
              dayTitle,
              updateLayout,
              hide
            }) || h('div', [// Show popover header only if format is defined
            masks.dayPopover && h('div', {
              class: ['vc-day-popover-header']
            }, [dayTitle]), attributes.map(function (attribute) {
              return h(PopoverRow, {
                key: attribute.key,
                props: {
                  attribute
                }
              });
            })]);
          }
        }
      });
    }; // Renderer for calendar container


    return h('div', {
      attrs: {
        'data-helptext': 'Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year'
      },
      class: ['vc-container', `vc-${this.$theme.color}`, {
        'vc-is-expanded': this.isExpanded,
        'vc-is-dark': this.$theme.isDark
      }],
      on: {
        keydown: this.handleKeydown,
        mouseup: function (e) {
          return e.preventDefault();
        }
      },
      ref: 'container'
    }, [getNavPopover(), h('div', {
      class: ['vc-pane-container', {
        'in-transition': this.inTransition
      }]
    }, [h(CustomTransition, {
      props: {
        name: this.transitionName
      },
      on: {
        beforeEnter: function () {
          _this.inTransition = true;
        },
        afterEnter: function () {
          _this.inTransition = false;
        }
      }
    }, [h('div', {
      class: 'vc-pane-layout',
      style: {
        gridTemplateColumns: `repeat(${this.columns}, 1fr)`
      },
      attrs: { ...this.$attrs
      },
      key: arrayHasItems(this.pages) ? this.pages[0].key : ''
    }, panes)]), h('div', {
      class: [`vc-arrows-container title-${this.titlePosition_}`]
    }, [getArrowButton(true), getArrowButton(false)]), this.$scopedSlots.footer && this.$scopedSlots.footer()]), getDayPopover()]);
  },

  mixins: [mixins_rootMixin, mixins_safeScopedSlotMixin],

  provide() {
    return {
      sharedState: this.sharedState
    };
  },

  props: {
    rows: {
      type: Number,
      default: 1
    },
    columns: {
      type: Number,
      default: 1
    },
    step: Number,
    titlePosition: String,
    isExpanded: Boolean,
    fromDate: Date,
    toDate: Date,
    fromPage: Object,
    toPage: Object,
    minPage: Object,
    maxPage: Object,
    transition: String,
    attributes: [Object, Array],
    trimWeeks: Boolean,
    disablePageSwipe: Boolean
  },

  data() {
    return {
      pages: [],
      store: null,
      lastFocusedDay: null,
      focusableDay: new Date().getDate(),
      transitionName: '',
      inTransition: false,
      sharedState: {
        navPopoverId: createGuid(),
        dayPopoverId: createGuid(),
        theme: {},
        masks: {},
        locale: {}
      }
    };
  },

  computed: {
    titlePosition_() {
      return this.propOrDefault('titlePosition', 'titlePosition');
    },

    firstPage() {
      return head_default()(this.pages);
    },

    lastPage() {
      return last_default()(this.pages);
    },

    minPage_() {
      return this.minPage || this.pageForDate(this.minDate);
    },

    maxPage_() {
      return this.maxPage || this.pageForDate(this.maxDate);
    },

    count() {
      return this.rows * this.columns;
    },

    step_() {
      return this.step || this.count;
    },

    canMovePrev() {
      return this.canMove(-this.step_);
    },

    canMoveNext() {
      return this.canMove(this.step_);
    }

  },
  watch: {
    $locale() {
      this.refreshLocale();
      this.refreshPages({
        page: this.firstPage,
        ignoreCache: true
      });
      this.initStore();
    },

    $theme() {
      this.refreshTheme();
      this.initStore();
    },

    fromDate() {
      this.refreshPages();
    },

    fromPage(val) {
      const firstPage = this.pages && this.pages[0];
      if (pageIsEqualToPage(val, firstPage)) return;
      this.refreshPages();
    },

    toPage(val) {
      const lastPage = this.pages && this.pages[this.pages.length - 1];
      if (pageIsEqualToPage(val, lastPage)) return;
      this.refreshPages();
    },

    count() {
      this.refreshPages();
    },

    attributes: {
      handler(val) {
        const {
          adds,
          deletes
        } = this.store.refresh(val);
        this.refreshAttrs(this.pages, adds, deletes);
      },

      deep: true
    },

    pages(val) {
      this.refreshAttrs(val, this.store.list, null, true);
    },

    disabledAttribute() {
      this.refreshDisabledDays();
    },

    lastFocusedDay(val) {
      if (val) {
        this.focusableDay = val.day;
        this.refreshFocusableDays();
      }
    },

    inTransition(val) {
      if (val) {
        this.$emit('transition-start');
      } else {
        this.$emit('transition-end');

        if (this.transitionPromise) {
          this.transitionPromise.resolve(true);
          this.transitionPromise = null;
        }
      }
    }

  },

  created() {
    this.refreshLocale();
    this.refreshTheme();
    this.initStore();
    this.refreshPages();
  },

  mounted() {
    var _this2 = this;

    if (!this.disablePageSwipe) {
      // Add swipe handler to move to next and previous pages
      this.removeHandlers = addHorizontalSwipeHandler(this.$refs.container, function ({
        toLeft,
        toRight
      }) {
        if (toLeft) {
          _this2.moveNext();
        } else if (toRight) {
          _this2.movePrev();
        }
      }, this.$defaults.touch);
    }
  },

  destroyed() {
    this.pages = [];
    this.store.destroy();
    this.store = null;
    this.sharedState = null;
    if (this.removeHandlers) this.removeHandlers();
  },

  methods: {
    refreshLocale() {
      this.sharedState.locale = this.$locale;
      this.sharedState.masks = this.$locale.masks;
    },

    refreshTheme() {
      this.sharedState.theme = this.$theme;
    },

    canMove(arg, opts = {}) {
      var _this3 = this;

      const page = this.$locale.toPage(arg, this.firstPage);
      let {
        position
      } = opts; // Pin position if arg is number

      if (isNumber_default()(arg)) position = 1; // Reject unresolved pages

      if (!page) {
        return Promise.reject(new Error(`Invalid argument provided: ${arg}`));
      } // Set position if unspecified and out of current bounds


      if (!position) {
        if (pageIsBeforePage(page, this.firstPage)) {
          position = -1;
        } else if (pageIsAfterPage(page, this.lastPage)) {
          position = 1;
        } else {
          // Page already displayed with no specified position, so we're done
          return Promise.resolve(true);
        }
      } // Calculate new page range without adjusting to min/max


      Object.assign(opts, this.getTargetPageRange(page, {
        position,
        force: true
      })); // Verify we can to move to any pages in the target range

      return pageRangeToArray(opts.fromPage, opts.toPage).some(function (p) {
        return pageIsBetweenPages(p, _this3.minPage_, _this3.maxPage_);
      });
    },

    movePrev(opts) {
      return this.move(-this.step_, opts);
    },

    moveNext(opts) {
      return this.move(this.step_, opts);
    },

    move(arg, opts = {}) {
      // Reject if we can't move to this page
      const canMove = this.canMove(arg, opts);

      if (!opts.force && !canMove) {
        return Promise.reject(new Error(`Move target is disabled: ${JSON.stringify(opts)}`));
      } // Hide nav popover for good measure


      this.$refs.navPopover.hide({
        hideDelay: 0
      }); // Move to new `fromPage` if it's different from the current one

      if (opts.fromPage && !pageIsEqualToPage(opts.fromPage, this.firstPage)) {
        return this.refreshPages({ ...opts,
          page: opts.fromPage,
          position: 1,
          force: true
        });
      }

      return Promise.resolve(true);
    },

    focusDate(date, opts = {}) {
      var _this4 = this;

      // Move to the given date
      return this.move(date, opts).then(function () {
        // Set focus on the element for the date
        const focusableEl = _this4.$el.querySelector(`.id-${_this4.$locale.getDayId(date)}.in-month .vc-focusable`);

        if (focusableEl) {
          focusableEl.focus();
          return Promise.resolve(true);
        }

        return Promise.resolve(false);
      });
    },

    showPageRange(range, opts) {
      let fromPage;
      let toPage;

      if (_isDate(range)) {
        fromPage = this.pageForDate(range);
      } else if (isObject(range)) {
        const {
          month,
          year
        } = range;
        const {
          from,
          to
        } = range;

        if (isNumber_default()(month) && isNumber_default()(year)) {
          fromPage = range;
        } else if (from || to) {
          fromPage = _isDate(from) ? this.pageForDate(from) : from;
          toPage = _isDate(to) ? this.pageForDate(to) : to;
        }
      } else {
        return Promise.reject(new Error('Invalid page range provided.'));
      }

      const lastPage = this.lastPage;
      let page = fromPage; // Offset page from the desired `toPage`

      if (pageIsAfterPage(toPage, lastPage)) {
        page = addPages(toPage, -(this.pages.length - 1));
      } // But no earlier than the desired `fromPage`


      if (pageIsBeforePage(page, fromPage)) {
        page = fromPage;
      }

      return this.refreshPages({ ...opts,
        page
      });
    },

    getTargetPageRange(page, {
      position,
      force
    } = {}) {
      let fromPage = null;
      let toPage = null;

      if (pageIsValid(page)) {
        let pagesToAdd = 0;
        position = +position;

        if (!isNaN(position)) {
          pagesToAdd = position > 0 ? 1 - position : -(this.count + position);
        }

        fromPage = addPages(page, pagesToAdd);
      } else {
        fromPage = this.getDefaultInitialPage();
      }

      toPage = addPages(fromPage, this.count - 1); // Adjust range for min/max if not forced

      if (!force) {
        if (pageIsBeforePage(fromPage, this.minPage_)) {
          fromPage = this.minPage_;
        } else if (pageIsAfterPage(toPage, this.maxPage_)) {
          fromPage = addPages(this.maxPage_, 1 - this.count);
        }

        toPage = addPages(fromPage, this.count - 1);
      }

      return {
        fromPage,
        toPage
      };
    },

    getDefaultInitialPage() {
      // 1. Try the fromPage prop
      let page = this.fromPage || this.pageForDate(this.fromDate);

      if (!pageIsValid(page)) {
        // 2. Try the toPage prop
        const toPage = this.toPage || this.pageForDate(this.toPage);

        if (pageIsValid(toPage)) {
          page = addPages(toPage, 1 - this.count);
        }
      } // 3. Try the first attribute


      if (!pageIsValid(page)) {
        page = this.getPageForAttributes();
      } // 4. Use today's page


      if (!pageIsValid(page)) {
        page = this.pageForThisMonth();
      }

      return page;
    },

    refreshPages({
      page,
      position = 1,
      force,
      transition,
      ignoreCache
    } = {}) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        const {
          fromPage,
          toPage
        } = _this5.getTargetPageRange(page, {
          position,
          force
        }); // Create the new pages


        const pages = [];

        for (let i = 0; i < _this5.count; i++) {
          pages.push(_this5.buildPage(addPages(fromPage, i), ignoreCache));
        } // Refresh disabled days for new pages


        _this5.refreshDisabledDays(pages); // Refresh focusable days for new pages


        _this5.refreshFocusableDays(pages); // Assign the transition


        _this5.transitionName = _this5.getPageTransition(_this5.pages[0], pages[0], transition); // Assign the new pages

        _this5.pages = pages; // Emit page update events

        _this5.$emit('update:from-page', fromPage);

        _this5.$emit('update:to-page', toPage);

        if (_this5.transitionName && _this5.transitionName !== 'none') {
          _this5.transitionPromise = {
            resolve,
            reject
          };
        } else {
          resolve(true);
        }
      });
    },

    refreshDisabledDays(pages) {
      var _this6 = this;

      this.getPageDays(pages).forEach(function (d) {
        d.isDisabled = !!_this6.disabledAttribute && _this6.disabledAttribute.intersectsDay(d);
      });
    },

    refreshFocusableDays(pages) {
      var _this7 = this;

      this.getPageDays(pages).forEach(function (d) {
        d.isFocusable = d.inMonth && d.day === _this7.focusableDay;
      });
    },

    getPageDays(pages = this.pages) {
      return pages.reduce(function (prev, curr) {
        return prev.concat(curr.days);
      }, []);
    },

    getPageTransition(oldPage, newPage, transition = this.transition) {
      if (transition === 'none') return transition;

      if (transition === 'fade' || !transition && this.count > 1 || !pageIsValid(oldPage) || !pageIsValid(newPage)) {
        return 'fade';
      } // Moving to a previous page


      const movePrev = pageIsBeforePage(newPage, oldPage); // Vertical slide

      if (transition === 'slide-v') {
        return movePrev ? 'slide-down' : 'slide-up';
      } // Horizontal slide


      return movePrev ? 'slide-right' : 'slide-left';
    },

    getPageForAttributes() {
      let page = null;
      const attr = this.store.pinAttr;

      if (attr && attr.hasDates) {
        let [date] = attr.dates;
        date = date.start || date.date;
        page = this.pageForDate(date);
      }

      return page;
    },

    buildPage({
      month,
      year
    }, ignoreCache) {
      var _this8 = this;

      const key = `${year.toString()}-${month.toString()}`;
      let page = this.pages.find(function (p) {
        return p.key === key;
      });

      if (!page || ignoreCache) {
        const date = new Date(year, month - 1, 15);
        const monthComps = this.$locale.getMonthComps(month, year);
        const prevMonthComps = this.$locale.getPrevMonthComps(month, year);
        const nextMonthComps = this.$locale.getNextMonthComps(month, year);
        page = {
          key,
          month,
          year,
          weeks: this.trimWeeks ? monthComps.weeks : 6,
          title: this.$locale.format(date, this.$locale.masks.title),
          shortMonthLabel: this.$locale.format(date, 'MMM'),
          monthLabel: this.$locale.format(date, 'MMMM'),
          shortYearLabel: year.toString().substring(2),
          yearLabel: year.toString(),
          monthComps,
          prevMonthComps,
          nextMonthComps,
          canMove: function (pg) {
            return _this8.canMove(pg);
          },
          move: function (pg) {
            return _this8.move(pg);
          },
          moveThisMonth: function () {
            return _this8.moveThisMonth();
          },
          movePrevMonth: function () {
            return _this8.move(prevMonthComps);
          },
          moveNextMonth: function () {
            return _this8.move(nextMonthComps);
          },
          refresh: true
        }; // Assign day info

        page.days = this.$locale.getCalendarDays(page);
      }

      return page;
    },

    initStore() {
      // Create a new attribute store
      this.store = new attributeStore_AttributeStore(this.$theme, this.$locale, this.attributes); // Refresh attributes for existing pages

      this.refreshAttrs(this.pages, this.store.list, [], true);
    },

    refreshAttrs(pages = [], adds = [], deletes = [], reset) {
      var _this9 = this;

      if (!arrayHasItems(pages)) return; // For each page...

      pages.forEach(function (p) {
        // For each day...
        p.days.forEach(function (d) {
          let map = {}; // If resetting...

          if (reset) {
            d.refresh = true;
          } else if (hasAny(d.attributesMap, deletes)) {
            // Delete attributes from the delete list
            map = omit_default()(d.attributesMap, deletes); // Flag day for refresh

            d.refresh = true;
          } else {
            // Get the existing attributes
            map = d.attributesMap || {};
          } // For each attribute to add...


          adds.forEach(function (attr) {
            // Add it if it includes the current day
            const targetDate = attr.intersectsDay(d);

            if (targetDate) {
              const newAttr = { ...attr,
                targetDate
              };
              map[attr.key] = newAttr; // Flag day for refresh

              d.refresh = true;
            }
          }); // Reassign day attributes

          if (d.refresh) {
            d.attributesMap = map;
          }
        });
      }); // Refresh pages

      this.$nextTick(function () {
        _this9.$refs.pages.forEach(function (p) {
          return p.refresh();
        });
      });
    },

    handleKeydown(e) {
      const day = this.lastFocusedDay;

      if (day != null) {
        day.event = e;
        this.handleDayKeydown(day);
      }
    },

    handleDayKeydown(day) {
      const {
        dateFromTime,
        event
      } = day; // Set to noon to offset any daylight savings time offset

      const date = dateFromTime(12);
      let newDate = null;

      switch (event.key) {
        case 'ArrowLeft':
          {
            // Move to previous day
            newDate = addDays(date, -1);
            break;
          }

        case 'ArrowRight':
          {
            // Move to next day
            newDate = addDays(date, 1);
            break;
          }

        case 'ArrowUp':
          {
            // Move to previous week
            newDate = addDays(date, -7);
            break;
          }

        case 'ArrowDown':
          {
            // Move to next week
            newDate = addDays(date, 7);
            break;
          }

        case 'Home':
          {
            // Move to first weekday position
            newDate = addDays(date, -day.weekdayPosition + 1);
            break;
          }

        case 'End':
          {
            // Move to last weekday position
            newDate = addDays(date, day.weekdayPositionFromEnd);
            break;
          }

        case 'PageUp':
          {
            if (event.altKey) {
              // Move to previous year w/ Alt/Option key
              newDate = addYears(date, -1);
            } else {
              // Move to previous month
              newDate = addMonths(date, -1);
            }

            break;
          }

        case 'PageDown':
          {
            if (event.altKey) {
              // Move to next year w/ Alt/Option key
              newDate = addYears(date, 1);
            } else {
              // Move to next month
              newDate = addMonths(date, 1);
            }

            break;
          }
      }

      if (newDate) {
        event.preventDefault();
        this.focusDate(newDate).catch(function () {});
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/Calendar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Calendarvue_type_script_lang_js_ = (Calendarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/Calendar.vue?vue&type=style&index=0&lang=postcss&
var Calendarvue_type_style_index_0_lang_postcss_ = __nested_webpack_require_310292__("de5e");

// CONCATENATED MODULE: ./src/components/Calendar.vue
var Calendar_render, Calendar_staticRenderFns





/* normalize component */

var Calendar_component = normalizeComponent(
  components_Calendarvue_type_script_lang_js_,
  Calendar_render,
  Calendar_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Calendar = (Calendar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1901b52e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/TimePicker.vue?vue&type=template&id=f4e11af8&scoped=true&
var TimePickervue_type_template_id_f4e11af8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-time-picker",class:[{ 'vc-disabled': _vm.isDisabled, 'vc-bordered': _vm.showBorder }]},[_c('div',[_c('svg',{staticClass:"vc-time-icon",attrs:{"fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","viewBox":"0 0 24 24","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"}})])]),_c('div',{staticClass:"vc-date-time"},[(_vm.date)?_c('div',{staticClass:"vc-date"},[_c('span',{staticClass:"vc-weekday"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'WWW'))+" ")]),_c('span',{staticClass:"vc-month"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'MMM'))+" ")]),_c('span',{staticClass:"vc-day"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'D'))+" ")]),_c('span',{staticClass:"vc-year"},[_vm._v(" "+_vm._s(_vm.locale.format(_vm.date, 'YYYY'))+" ")])]):_vm._e(),_c('div',{staticClass:"vc-time"},[_c('time-select',{attrs:{"options":_vm.hourOptions_},model:{value:(_vm.hours),callback:function ($$v) {_vm.hours=_vm._n($$v)},expression:"hours"}}),_c('span',{staticStyle:{"margin":"0 4px"}},[_vm._v(":")]),_c('time-select',{attrs:{"options":_vm.minuteOptions},model:{value:(_vm.minutes),callback:function ($$v) {_vm.minutes=_vm._n($$v)},expression:"minutes"}}),(!_vm.is24hr)?_c('div',{staticClass:"vc-am-pm",class:{ 'vc-disabled': !(_vm.hours >= 0) }},[_c('button',{class:{ active: _vm.isAM, 'vc-disabled': _vm.amDisabled },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.isAM = true}}},[_vm._v(" AM ")]),_c('button',{class:{ active: !_vm.isAM, 'vc-disabled': _vm.pmDisabled },attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.isAM = false}}},[_vm._v(" PM ")])]):_vm._e()],1)])])}
var TimePickervue_type_template_id_f4e11af8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/TimePicker.vue?vue&type=template&id=f4e11af8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"1901b52e-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/TimeSelect.vue?vue&type=template&id=7b2eaf0a&scoped=true&
var TimeSelectvue_type_template_id_7b2eaf0a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-select"},[_c('select',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.model=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},'select',_vm.$attrs,false),_vm._l((_vm.options),function(option){return _c('option',{key:option.value,attrs:{"disabled":option.disabled},domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0),_c('div',{staticClass:"vc-select-arrow"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"}})])])])}
var TimeSelectvue_type_template_id_7b2eaf0a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/TimeSelect.vue?vue&type=template&id=7b2eaf0a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/TimeSelect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var TimeSelectvue_type_script_lang_js_ = ({
  inheritAttrs: false,
  props: {
    options: Array,
    value: Number
  },
  computed: {
    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      }

    }
  }
});
// CONCATENATED MODULE: ./src/components/TimeSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TimeSelectvue_type_script_lang_js_ = (TimeSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/TimeSelect.vue?vue&type=style&index=0&id=7b2eaf0a&lang=postcss&scoped=true&
var TimeSelectvue_type_style_index_0_id_7b2eaf0a_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("87a9");

// CONCATENATED MODULE: ./src/components/TimeSelect.vue






/* normalize component */

var TimeSelect_component = normalizeComponent(
  components_TimeSelectvue_type_script_lang_js_,
  TimeSelectvue_type_template_id_7b2eaf0a_scoped_true_render,
  TimeSelectvue_type_template_id_7b2eaf0a_scoped_true_staticRenderFns,
  false,
  null,
  "7b2eaf0a",
  null
  
)

/* harmony default export */ var TimeSelect = (TimeSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/TimePicker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const _amOptions = [{
  value: 0,
  label: '12'
}, {
  value: 1,
  label: '1'
}, {
  value: 2,
  label: '2'
}, {
  value: 3,
  label: '3'
}, {
  value: 4,
  label: '4'
}, {
  value: 5,
  label: '5'
}, {
  value: 6,
  label: '6'
}, {
  value: 7,
  label: '7'
}, {
  value: 8,
  label: '8'
}, {
  value: 9,
  label: '9'
}, {
  value: 10,
  label: '10'
}, {
  value: 11,
  label: '11'
}];
const _pmOptions = [{
  value: 12,
  label: '12'
}, {
  value: 13,
  label: '1'
}, {
  value: 14,
  label: '2'
}, {
  value: 15,
  label: '3'
}, {
  value: 16,
  label: '4'
}, {
  value: 17,
  label: '5'
}, {
  value: 18,
  label: '6'
}, {
  value: 19,
  label: '7'
}, {
  value: 20,
  label: '8'
}, {
  value: 21,
  label: '9'
}, {
  value: 22,
  label: '10'
}, {
  value: 23,
  label: '11'
}];
/* harmony default export */ var TimePickervue_type_script_lang_js_ = ({
  name: 'TimePicker',
  components: {
    TimeSelect: TimeSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    locale: {
      type: Object,
      required: true
    },
    theme: {
      type: Object,
      required: true
    },
    is24hr: {
      type: Boolean,
      default: true
    },
    showBorder: Boolean,
    isDisabled: Boolean,
    hourOptions: Array,
    minuteOptions: Array
  },
  computed: {
    date() {
      let date = this.locale.normalizeDate(this.value);

      if (this.value.hours === 24) {
        date = new Date(date.getTime() - 1);
      }

      return date;
    },

    hours: {
      get() {
        return this.value.hours;
      },

      set(value) {
        this.updateValue(value, this.minutes);
      }

    },
    minutes: {
      get() {
        return this.value.minutes;
      },

      set(value) {
        this.updateValue(this.hours, value);
      }

    },
    isAM: {
      get() {
        return this.value.hours < 12;
      },

      set(value) {
        let hours = this.hours;

        if (value && hours >= 12) {
          hours -= 12;
        } else if (!value && hours < 12) {
          hours += 12;
        }

        this.updateValue(hours, this.minutes);
      }

    },

    amHourOptions() {
      var _this = this;

      return _amOptions.filter(function (opt) {
        return _this.hourOptions.some(function (ho) {
          return ho.value === opt.value;
        });
      });
    },

    pmHourOptions() {
      var _this2 = this;

      return _pmOptions.filter(function (opt) {
        return _this2.hourOptions.some(function (ho) {
          return ho.value === opt.value;
        });
      });
    },

    hourOptions_() {
      if (this.is24hr) return this.hourOptions;
      if (this.isAM) return this.amHourOptions;
      return this.pmHourOptions;
    },

    amDisabled() {
      return !arrayHasItems(this.amHourOptions);
    },

    pmDisabled() {
      return !arrayHasItems(this.pmHourOptions);
    }

  },
  methods: {
    updateValue(hours, minutes) {
      if (hours !== this.hours || minutes !== this.minutes) {
        this.$emit('input', { ...this.value,
          hours,
          minutes,
          seconds: 0,
          milliseconds: 0
        });
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/TimePicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_TimePickervue_type_script_lang_js_ = (TimePickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/TimePicker.vue?vue&type=style&index=0&id=f4e11af8&lang=postcss&scoped=true&
var TimePickervue_type_style_index_0_id_f4e11af8_lang_postcss_scoped_true_ = __nested_webpack_require_310292__("27e3");

// CONCATENATED MODULE: ./src/components/TimePicker.vue






/* normalize component */

var TimePicker_component = normalizeComponent(
  components_TimePickervue_type_script_lang_js_,
  TimePickervue_type_template_id_f4e11af8_scoped_true_render,
  TimePickervue_type_template_id_f4e11af8_scoped_true_staticRenderFns,
  false,
  null,
  "f4e11af8",
  null
  
)

/* harmony default export */ var TimePicker = (TimePicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/DatePicker.vue?vue&type=script&lang=js&









const _baseConfig = {
  type: 'auto',
  mask: 'iso',
  // String mask when `type === 'string'`
  timeAdjust: '' // 'HH:MM:SS', 'now'

};
const _config = [_baseConfig, _baseConfig];
const MODE = {
  DATE: 'date',
  DATE_TIME: 'datetime',
  TIME: 'time'
};
const RANGE_PRIORITY = {
  NONE: 0,
  START: 1,
  END: 2,
  BOTH: 3
};
/* harmony default export */ var DatePickervue_type_script_lang_js_ = ({
  name: 'DatePicker',

  render(h) {
    var _this = this;

    // Timepicker renderer
    const timePicker = function () {
      if (!_this.dateParts) return null;
      const parts = _this.isRange ? _this.dateParts : [_this.dateParts[0]];
      return h('div', [...parts.map(function (dp, idx) {
        const hourOptions = _this.$locale.getHourOptions(_this.modelConfig_[idx].validHours, dp);

        const minuteOptions = _this.$locale.getMinuteOptions(_this.modelConfig_[idx].minuteIncrement, dp);

        return h(TimePicker, {
          props: {
            value: dp,
            locale: _this.$locale,
            theme: _this.$theme,
            is24hr: _this.is24hr,
            minuteIncrement: _this.minuteIncrement,
            showBorder: !_this.isTime,
            isDisabled: _this.isDateTime && !dp.isValid || _this.isDragging,
            hourOptions,
            minuteOptions
          },
          on: {
            input: function (p) {
              return _this.onTimeInput(p, idx === 0);
            }
          }
        });
      }), _this.$scopedSlots.footer && _this.$scopedSlots.footer()]);
    }; // Calendar renderer


    const calendar = function () {
      return h(Calendar, {
        attrs: { ..._this.$attrs,
          attributes: _this.attributes_,
          theme: _this.$theme,
          locale: _this.$locale
        },
        props: {
          minDate: _this.minDateExact || _this.minDate,
          maxDate: _this.maxDateExact || _this.maxDate,
          disabledDates: _this.disabledDates,
          availableDates: _this.availableDates
        },
        on: { ..._this.$listeners,
          dayclick: _this.onDayClick,
          daykeydown: _this.onDayKeydown,
          daymouseenter: _this.onDayMouseEnter
        },
        scopedSlots: { ..._this.$scopedSlots,
          footer: _this.isDateTime ? timePicker : _this.$scopedSlots.footer
        },
        ref: 'calendar'
      });
    }; // Content renderer


    const content = function () {
      if (_this.isTime) {
        return h('div', {
          class: ['vc-container', `vc-${_this.$theme.color}`, {
            'vc-is-dark': _this.$theme.isDark
          }]
        }, [timePicker()]);
      }

      return calendar();
    };

    return this.$scopedSlots.default && // Convert this span to a fragment when supported in Vue
    h('span', [// Slot content
    this.$scopedSlots.default(this.slotArgs), // Popover content
    h(Popover, {
      props: {
        id: this.datePickerPopoverId,
        placement: 'bottom-start',
        contentClass: `vc-container${this.isDark ? ' vc-is-dark' : ''}`
      },
      on: {
        beforeShow: function (e) {
          return _this.$emit('popoverWillShow', e);
        },
        afterShow: function (e) {
          return _this.$emit('popoverDidShow', e);
        },
        beforeHide: function (e) {
          return _this.$emit('popoverWillHide', e);
        },
        afterHide: function (e) {
          return _this.$emit('popoverDidHide', e);
        }
      },
      scopedSlots: {
        default() {
          return content();
        }

      },
      ref: 'popover'
    })]) || content();
  },

  mixins: [mixins_rootMixin],
  props: {
    mode: {
      type: String,
      default: MODE.DATE
    },
    value: {
      type: null,
      required: true
    },
    modelConfig: {
      type: Object,
      default: function () {
        return {};
      }
    },
    is24hr: Boolean,
    minuteIncrement: Number,
    isRequired: Boolean,
    isRange: Boolean,
    updateOnInput: Boolean,
    inputDebounce: Number,
    popover: {
      type: Object,
      default: function () {
        return {};
      }
    },
    dragAttribute: Object,
    selectAttribute: Object,
    attributes: Array,
    validHours: [Object, Array, Function]
  },

  data() {
    return {
      value_: null,
      dateParts: null,
      activeDate: '',
      dragValue: null,
      inputValues: ['', ''],
      updateTimeout: null,
      watchValue: true,
      datePickerPopoverId: createGuid()
    };
  },

  computed: {
    updateOnInput_() {
      return this.propOrDefault('updateOnInput', 'datePicker.updateOnInput');
    },

    inputDebounce_() {
      return this.propOrDefault('inputDebounce', 'datePicker.inputDebounce');
    },

    isDate() {
      return this.mode.toLowerCase() === MODE.DATE;
    },

    isDateTime() {
      return this.mode.toLowerCase() === MODE.DATE_TIME;
    },

    isTime() {
      return this.mode.toLowerCase() === MODE.TIME;
    },

    isDragging() {
      return !!this.dragValue && this.isRange;
    },

    modelConfig_() {
      return this.normalizeConfig(this.modelConfig, _config);
    },

    inputMask() {
      const masks = this.$locale.masks;

      if (this.isTime) {
        return this.is24hr ? masks.inputTime24hr : masks.inputTime;
      }

      if (this.isDateTime) {
        return this.is24hr ? masks.inputDateTime24hr : masks.inputDateTime;
      }

      return this.$locale.masks.input;
    },

    inputMaskHasTime() {
      return /[Hh]/g.test(this.inputMask);
    },

    inputMaskHasDate() {
      return /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(this.inputMask);
    },

    inputMaskPatch() {
      if (this.inputMaskHasTime && this.inputMaskHasDate) {
        return PATCH.DATE_TIME;
      }

      if (this.inputMaskHasDate) return PATCH.DATE;
      if (this.inputMaskHasTime) return PATCH.TIME;
      return undefined;
    },

    slotArgs() {
      var _this2 = this;

      const {
        isRange,
        isDragging,
        updateValue,
        showPopover,
        hidePopover,
        togglePopover
      } = this;
      const inputValue = isRange ? {
        start: this.inputValues[0],
        end: this.inputValues[1]
      } : this.inputValues[0];
      const events = [true, false].map(function (isStart) {
        return {
          input: _this2.onInputInput(isStart),
          change: _this2.onInputChange(isStart),
          keyup: _this2.onInputKeyup,
          ...getPopoverTriggerEvents({ ..._this2.popover_,
            id: _this2.datePickerPopoverId,
            callback: function (e) {
              if (e.action === 'show' && e.completed) {
                _this2.onInputShow(isStart);
              }
            }
          })
        };
      });
      const inputEvents = isRange ? {
        start: events[0],
        end: events[1]
      } : events[0];
      return {
        inputValue,
        inputEvents,
        isDragging,
        updateValue,
        showPopover,
        hidePopover,
        togglePopover,
        getPopoverTriggerEvents: getPopoverTriggerEvents
      };
    },

    popover_() {
      return this.propOrDefault('popover', 'datePicker.popover', 'merge');
    },

    selectAttribute_() {
      if (!this.hasValue(this.value_)) return null;
      const attribute = {
        key: 'select-drag',
        ...this.selectAttribute,
        dates: this.value_,
        pinPage: true
      };
      const {
        dot,
        bar,
        highlight,
        content
      } = attribute;

      if (!dot && !bar && !highlight && !content) {
        attribute.highlight = true;
      }

      return attribute;
    },

    dragAttribute_() {
      if (!this.isRange || !this.hasValue(this.dragValue)) {
        return null;
      }

      const attribute = {
        key: 'select-drag',
        ...this.dragAttribute,
        dates: this.dragValue
      };
      const {
        dot,
        bar,
        highlight,
        content
      } = attribute;

      if (!dot && !bar && !highlight && !content) {
        attribute.highlight = {
          startEnd: {
            fillMode: 'outline'
          }
        };
      }

      return attribute;
    },

    attributes_() {
      const attrs = isArrayLikeObject_default()(this.attributes) ? [...this.attributes] : [];

      if (this.dragAttribute_) {
        attrs.push(this.dragAttribute_);
      } else if (this.selectAttribute_) {
        attrs.push(this.selectAttribute_);
      }

      return attrs;
    }

  },
  watch: {
    inputMask() {
      this.formatInput();
    },

    value(newValue) {
      if (!this.watchValue) return;
      this.forceUpdateValue(newValue, {
        config: this.modelConfig_,
        notify: false,
        formatInput: true,
        hidePopover: false
      });
    },

    value_() {
      this.refreshDateParts();
    },

    dragValue() {
      this.refreshDateParts();
    },

    timezone() {
      this.refreshDateParts();
      this.forceUpdateValue(this.value_, {
        formatInput: true
      });
    }

  },

  created() {
    this.value_ = this.normalizeValue(this.value, this.modelConfig_, PATCH.DATE_TIME, RANGE_PRIORITY.BOTH);
    this.forceUpdateValue(this.value, {
      config: this.modelConfig_,
      formatInput: true,
      hidePopover: false
    });
    this.refreshDateParts();
  },

  mounted() {
    // Handle escape key presses
    on(document, 'keydown', this.onDocumentKeyDown); // Clear drag on background click

    on(document, 'click', this.onDocumentClick);
  },

  destroyed() {
    off(document, 'keydown', this.onDocumentKeyDown);
    off(document, 'click', this.onDocumentClick);
  },

  methods: {
    getDateParts(date) {
      return this.$locale.getDateParts(date);
    },

    getDateFromParts(parts) {
      return this.$locale.getDateFromParts(parts);
    },

    refreshDateParts() {
      var _this3 = this;

      const value = this.dragValue || this.value_;
      const dateParts = [];

      if (this.isRange) {
        if (value && value.start) {
          dateParts.push(this.getDateParts(value.start));
        } else {
          dateParts.push({});
        }

        if (value && value.end) {
          dateParts.push(this.getDateParts(value.end));
        } else {
          dateParts.push({});
        }
      } else if (value) {
        if (value && value.start) {
          dateParts.push(this.getDateParts(value.start));
        } else {
          dateParts.push(this.getDateParts(value));
        }
      } else {
        dateParts.push({});
      }

      this.$nextTick(function () {
        return _this3.dateParts = dateParts;
      });
    },

    onDocumentKeyDown(e) {
      // Clear drag on escape keydown
      if (this.dragValue && e.key === 'Escape') {
        this.dragValue = null;
      }
    },

    onDocumentClick(e) {
      if (document.body.contains(e.target) && !elementContains(this.$el, e.target)) {
        this.dragValue = null;
        this.formatInput();
      }
    },

    onDayClick(day) {
      this.handleDayClick(day); // Re-emit event

      this.$emit('dayclick', day);
    },

    onDayKeydown(day) {
      switch (day.event.key) {
        case ' ':
        case 'Enter':
          {
            this.handleDayClick(day);
            day.event.preventDefault();
            break;
          }

        case 'Escape':
          {
            this.hidePopover();
          }
      } // Re-emit event


      this.$emit('daykeydown', day);
    },

    handleDayClick(day) {
      const {
        keepVisibleOnInput,
        visibility
      } = this.popover_;
      const opts = {
        patch: PATCH.DATE,
        adjustTime: true,
        formatInput: true,
        hidePopover: this.isDate && !keepVisibleOnInput && visibility !== 'visible'
      };

      if (this.isRange) {
        if (!this.isDragging) {
          this.dragTrackingValue = { ...day.range
          };
        } else {
          this.dragTrackingValue.end = day.date;
        }

        opts.isDragging = !this.isDragging;
        opts.rangePriority = opts.isDragging ? RANGE_PRIORITY.NONE : RANGE_PRIORITY.BOTH;
        opts.hidePopover = opts.hidePopover && !opts.isDragging;
        this.updateValue(this.dragTrackingValue, opts);
      } else {
        opts.clearIfEqual = !this.isRequired;
        this.updateValue(day.date, opts);
      }
    },

    onDayMouseEnter(day) {
      if (!this.isDragging) return;
      this.dragTrackingValue.end = day.date;
      this.updateValue(this.dragTrackingValue, {
        patch: PATCH.DATE,
        adjustTime: true,
        formatInput: true,
        hidePopover: false,
        rangePriority: RANGE_PRIORITY.NONE
      });
    },

    onTimeInput(parts, isStart) {
      var _this4 = this;

      let value = null;

      if (this.isRange) {
        const start = isStart ? parts : this.dateParts[0];
        const end = isStart ? this.dateParts[1] : parts;
        value = {
          start,
          end
        };
      } else {
        value = parts;
      }

      this.updateValue(value, {
        patch: PATCH.TIME,
        rangePriority: isStart ? RANGE_PRIORITY.START : RANGE_PRIORITY.END
      }).then(function () {
        return _this4.adjustPageRange(isStart);
      });
    },

    onInputInput(isStart) {
      var _this5 = this;

      return function (e) {
        if (!_this5.updateOnInput_) return;

        _this5.onInputUpdate(e.target.value, isStart, {
          formatInput: false,
          hidePopover: false,
          debounce: _this5.inputDebounce_
        });
      };
    },

    onInputChange(isStart) {
      var _this6 = this;

      return function (e) {
        _this6.onInputUpdate(e.target.value, isStart, {
          formatInput: true,
          hidePopover: false
        });
      };
    },

    onInputUpdate(inputValue, isStart, opts) {
      var _this7 = this;

      this.inputValues.splice(isStart ? 0 : 1, 1, inputValue);
      const value = this.isRange ? {
        start: this.inputValues[0],
        end: this.inputValues[1] || this.inputValues[0]
      } : inputValue;
      const config = {
        type: 'string',
        mask: this.inputMask
      };
      this.updateValue(value, { ...opts,
        config,
        patch: this.inputMaskPatch,
        rangePriority: isStart ? RANGE_PRIORITY.START : RANGE_PRIORITY.END
      }).then(function () {
        return _this7.adjustPageRange(isStart);
      });
    },

    onInputShow(isStart) {
      this.adjustPageRange(isStart);
    },

    onInputKeyup(e) {
      // Escape key only
      if (e.key !== 'Escape') return;
      this.updateValue(this.value_, {
        formatInput: true,
        hidePopover: true
      });
    },

    normalizeConfig(config, baseConfig = this.modelConfig_) {
      var _this8 = this;

      config = isArrayLikeObject_default()(config) ? config : [config.start || config, config.end || config];
      return baseConfig.map(function (b, i) {
        return {
          validHours: _this8.validHours,
          minuteIncrement: _this8.minuteIncrement,
          ...b,
          ...config[i]
        };
      });
    },

    updateValue(value, opts = {}) {
      var _this9 = this;

      clearTimeout(this.updateTimeout);
      return new Promise(function (resolve) {
        const {
          debounce,
          ...args
        } = opts;

        if (debounce > 0) {
          _this9.updateTimeout = setTimeout(function () {
            _this9.forceUpdateValue(value, args);

            resolve(_this9.value_);
          }, debounce);
        } else {
          _this9.forceUpdateValue(value, args);

          resolve(_this9.value_);
        }
      });
    },

    forceUpdateValue(value, {
      config = this.modelConfig_,
      patch = PATCH.DATE_TIME,
      clearIfEqual = false,
      formatInput = true,
      hidePopover = false,
      isDragging = this.isDragging,
      rangePriority = RANGE_PRIORITY.BOTH
    } = {}) {
      var _this10 = this;

      // 1. Normalization
      config = this.normalizeConfig(config);
      let normalizedValue = this.normalizeValue(value, config, patch, rangePriority); // Reset to previous value if it was cleared but is required

      if (!normalizedValue && this.isRequired) {
        normalizedValue = this.value_;
      } // Time Adjustment


      normalizedValue = this.adjustTimeForValue(normalizedValue, config); // 2. Validation (date or range)

      const isDisabled = this.valueIsDisabled(normalizedValue);

      if (isDisabled) {
        if (isDragging) return;
        normalizedValue = this.value_; // Don't allow hiding popover

        hidePopover = false;
      } // 3. Assignment


      const valueKey = isDragging ? 'dragValue' : 'value_';
      let valueChanged = !this.valuesAreEqual(this[valueKey], normalizedValue); // Clear value if same value selected and clearIfEqual is set

      if (!isDisabled && !valueChanged && clearIfEqual) {
        normalizedValue = null;
        valueChanged = true;
      } // Assign value


      if (valueChanged) {
        this.$set(this, valueKey, normalizedValue); // Clear drag value if needed

        if (!isDragging) this.dragValue = null; // Denormalization

        const denormalizedValue = this.denormalizeValue(normalizedValue); // Notification

        const event = this.isDragging ? 'drag' : 'input';
        this.watchValue = false;
        this.$emit(event, denormalizedValue);
        this.$nextTick(function () {
          return _this10.watchValue = true;
        });
      } // 5. Hide popover if needed


      if (hidePopover) this.hidePopover(); // 6. Format inputs if needed

      if (formatInput) this.formatInput();
    },

    hasValue(value) {
      if (this.isRange) {
        return isObject(value) && !!value.start && !!value.end;
      }

      return !!value;
    },

    normalizeValue(value, config, patch, rangePriority) {
      if (!this.hasValue(value)) return null;

      if (this.isRange) {
        const result = {};
        const start = value.start > value.end ? value.end : value.start;
        result.start = this.normalizeDate(start, { ...config[0],
          fillDate: this.value_ && this.value_.start || config[0].fillDate,
          patch
        });
        const end = value.start > value.end ? value.start : value.end;
        result.end = this.normalizeDate(end, { ...config[1],
          fillDate: this.value_ && this.value_.end || config[1].fillDate,
          patch
        });
        return this.sortRange(result, rangePriority);
      }

      return this.normalizeDate(value, { ...config[0],
        fillDate: this.value_ || config[0].fillDate,
        patch
      });
    },

    adjustTimeForValue(value, config) {
      if (!this.hasValue(value)) return null;

      if (this.isRange) {
        return {
          start: this.$locale.adjustTimeForDate(value.start, config[0]),
          end: this.$locale.adjustTimeForDate(value.end, config[1])
        };
      }

      return this.$locale.adjustTimeForDate(value, config[0]);
    },

    sortRange(range, priority = RANGE_PRIORITY.NONE) {
      const {
        start,
        end
      } = range;

      if (start > end) {
        switch (priority) {
          case RANGE_PRIORITY.START:
            return {
              start,
              end: start
            };

          case RANGE_PRIORITY.END:
            return {
              start: end,
              end
            };

          case RANGE_PRIORITY.BOTH:
            return {
              start: end,
              end: start
            };
        }
      }

      return {
        start,
        end
      };
    },

    denormalizeValue(value, config = this.modelConfig_) {
      if (this.isRange) {
        if (!this.hasValue(value)) return null;
        return {
          start: this.$locale.denormalizeDate(value.start, config[0]),
          end: this.$locale.denormalizeDate(value.end, config[1])
        };
      }

      return this.$locale.denormalizeDate(value, config[0]);
    },

    valuesAreEqual(a, b) {
      if (this.isRange) {
        const aHasValue = this.hasValue(a);
        const bHasValue = this.hasValue(b);
        if (!aHasValue && !bHasValue) return true;
        if (aHasValue !== bHasValue) return false;
        return datesAreEqual(a.start, b.start) && datesAreEqual(a.end, b.end);
      }

      return datesAreEqual(a, b);
    },

    valueIsDisabled(value) {
      return this.hasValue(value) && this.disabledAttribute && this.disabledAttribute.intersectsDate(value);
    },

    formatInput() {
      var _this11 = this;

      this.$nextTick(function () {
        const config = _this11.normalizeConfig({
          type: 'string',
          mask: _this11.inputMask
        });

        const value = _this11.denormalizeValue(_this11.dragValue || _this11.value_, config);

        if (_this11.isRange) {
          _this11.inputValues = [value && value.start, value && value.end];
        } else {
          _this11.inputValues = [value, ''];
        }
      });
    },

    showPopover(opts = {}) {
      popovers_showPopover({
        ref: this.$el,
        ...this.popover_,
        ...opts,
        isInteractive: true,
        id: this.datePickerPopoverId
      });
    },

    hidePopover(opts = {}) {
      popovers_hidePopover({
        hideDelay: 10,
        ...this.popover_,
        ...opts,
        id: this.datePickerPopoverId
      });
    },

    togglePopover(opts) {
      popovers_togglePopover({
        ref: this.$el,
        ...this.popover_,
        ...opts,
        isInteractive: true,
        id: this.datePickerPopoverId
      });
    },

    adjustPageRange(isStart) {
      var _this12 = this;

      this.$nextTick(function () {
        const calendar = _this12.$refs.calendar;

        const page = _this12.getPageForValue(isStart);

        const position = isStart ? 1 : -1;

        if (page && calendar && !pageIsBetweenPages(page, calendar.firstPage, calendar.lastPage)) {
          calendar.move(page, {
            position,
            transition: 'fade'
          });
        }
      });
    },

    getPageForValue(isStart) {
      if (this.hasValue(this.value_)) {
        return this.pageForDate(this.isRange ? this.value_[isStart ? 'start' : 'end'] : this.value_);
      }

      return null;
    },

    move(args, opts) {
      if (this.$refs.calendar) {
        return this.$refs.calendar.move(args, opts);
      }

      return Promise.reject(new Error('Navigation disabled while calendar is not yet displayed'));
    },

    focusDate(date, opts) {
      if (this.$refs.calendar) {
        return this.$refs.calendar.focusDate(date, opts);
      }

      return Promise.reject(new Error('Navigation disabled while calendar is not yet displayed'));
    }

  }
});
// CONCATENATED MODULE: ./src/components/DatePicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_DatePickervue_type_script_lang_js_ = (DatePickervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/DatePicker.vue
var DatePicker_render, DatePicker_staticRenderFns




/* normalize component */

var DatePicker_component = normalizeComponent(
  components_DatePickervue_type_script_lang_js_,
  DatePicker_render,
  DatePicker_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DatePicker = (DatePicker_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __nested_webpack_exports__["default"] = (DatePicker);



/***/ }),

/***/ "fba5":
/***/ (function(module, exports, __nested_webpack_require_606008__) {

var assocIndexOf = __nested_webpack_require_606008__("cb5a");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __nested_webpack_require_606496__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __nested_webpack_require_606496__("44ad");
var requireObjectCoercible = __nested_webpack_require_606496__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fccf":
/***/ (function(module, __webpack_exports__, __nested_webpack_require_606845__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_0_id_74ad501d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_606845__("53b1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_0_id_74ad501d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_606845__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_0_id_74ad501d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarPane_vue_vue_type_style_index_0_id_74ad501d_lang_postcss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __nested_webpack_require_609134__) {

var fails = __nested_webpack_require_609134__("d039");

module.exports = fails(function () {
  // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
  var re = RegExp('.', (typeof '').charAt(0));
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fcff":
/***/ (function(module, exports, __nested_webpack_require_609488__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __nested_webpack_require_609488__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".vc-svg-icon[data-v-63f7b5ec]{display:inline-block;stroke:currentColor;stroke-width:0}.vc-svg-icon path[data-v-63f7b5ec]{fill:currentColor}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __nested_webpack_require_610728__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __nested_webpack_require_610728__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "ffd6":
/***/ (function(module, exports, __nested_webpack_require_611010__) {

var baseGetTag = __nested_webpack_require_611010__("3729"),
    isObjectLike = __nested_webpack_require_611010__("1310");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=date-picker.umd.js.map

/***/ }),

/***/ 7670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 7721:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 7797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 7828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 7978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(270),
    get = __webpack_require__(8156),
    hasIn = __webpack_require__(631),
    isKey = __webpack_require__(8586),
    isStrictComparable = __webpack_require__(756),
    matchesStrictComparable = __webpack_require__(7197),
    toKey = __webpack_require__(7797);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8077:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 8223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 8303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 8586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 8655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 8754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(5160);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 8859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661),
    setCacheAdd = __webpack_require__(1380),
    setCacheHas = __webpack_require__(1459);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 8994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TechniciansCalendar_TechniciansCalendar; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TechniciansCalendar/TechniciansCalendar.vue?vue&type=template&id=e9899790
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calendar-view"},[(_vm.loading)?_c('Spinner'):[_c('b-row',{staticClass:"mb-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('h1',{staticClass:"calendar-title d-block d-md-inline-block text-center mb-2 mb-md-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.loadEvents)?_c('Spinner',{staticClass:"d-inline-block p-0",attrs:{"size":"1"}}):_vm._e()],1),_c('b-col',{staticClass:"text-right",attrs:{"cols":"12","md":"auto"}},[_c('datepicker',{attrs:{"value":_vm.viewStart},on:{"input":_vm.goToDate},scopedSlots:_vm._u([{key:"default",fn:function({ togglePopover }){return [_c('b-button',{staticClass:"mr-3 btn-icon",attrs:{"size":"sm"},on:{"click":function($event){return togglePopover()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'calendar-alt']}})],1)]}}])}),_c('b-button-group',{staticClass:"mr-3",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"primary","disabled":_vm.currentView === 'resourceTimeGridDay'},on:{"click":function($event){return _vm.changeView('resourceTimeGridDay')}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.day'))+" ")]),_c('b-button',{attrs:{"disabled":_vm.currentView === 'resourceTimeGridThreeDay',"variant":"primary"},on:{"click":function($event){return _vm.changeView('resourceTimeGridThreeDay')}}},[_vm._v(" 3 jours ")]),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.currentView === 'resourceTimeGridWeek'},on:{"click":function($event){return _vm.changeView('resourceTimeGridWeek')}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.week'))+" ")]),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.currentView === 'resourceTimeLine'},on:{"click":function($event){return _vm.changeView('resourceTimeLine')}}},[_vm._v(" Timeline ")])],1),_c('div',{staticClass:"d-inline-block mt-2 mt-sm-0"},[_c('b-button',{staticClass:"mr-3",attrs:{"size":"sm","disabled":_vm.isToday},on:{"click":function($event){_vm.api?.today()}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.today'))+" ")]),_c('b-button-group',{staticClass:"mr-3",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.api?.prev()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-left']}})],1),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.api?.next()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-right']}})],1)],1)],1),_c('b-dropdown',{attrs:{"size":"sm","variant":"secondary","no-caret":"","toggle-class":"btn-icon"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":['fas', 'users']}})]},proxy:true}])},_vm._l((_vm.allTechnicals),function(technical){return _c('b-dropdown-item',{key:technical.type + '-' + technical.id,attrs:{"active":_vm.visibilityState(technical),"link-class":"p-0"}},[_c('div',{staticClass:"px-3 py-1",on:{"click":function($event){$event.stopPropagation();return _vm.changeVisibility(technical)}}},[_vm._v(" "+_vm._s(technical.name)+" ")])])}),1),_c('b-button',{staticClass:"btn-icon ml-3",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.showCalendarParams = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'cog']}})],1)],1)],1),(!_vm.loading)?_c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}}):_vm._e(),(_vm.showPlanification)?_c('PlanificationItem',{attrs:{"element":"modal","modal":true},on:{"hidden":function($event){_vm.showPlanification = null},"updated":_vm.reloadEvents,"deleted":_vm.reloadEvents},model:{value:(_vm.showPlanification),callback:function ($$v) {_vm.showPlanification=$$v},expression:"showPlanification"}}):_vm._e(),_c('CalendarParams',{attrs:{"modalState":_vm.showCalendarParams},on:{"hidden":function($event){_vm.showCalendarParams = false}}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// external "@fullcalendar/resource-timegrid"
var resource_timegrid_namespaceObject = require("@fullcalendar/resource-timegrid");
var resource_timegrid_default = /*#__PURE__*/__webpack_require__.n(resource_timegrid_namespaceObject);
;// external "@fullcalendar/resource-timeline"
var resource_timeline_namespaceObject = require("@fullcalendar/resource-timeline");
var resource_timeline_default = /*#__PURE__*/__webpack_require__.n(resource_timeline_namespaceObject);
;// external "@fullcalendar/resource-daygrid"
var resource_daygrid_namespaceObject = require("@fullcalendar/resource-daygrid");
var resource_daygrid_default = /*#__PURE__*/__webpack_require__.n(resource_daygrid_namespaceObject);
// EXTERNAL MODULE: external "@fullcalendar/bootstrap"
var bootstrap_ = __webpack_require__(5936);
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap_);
// EXTERNAL MODULE: external "@fullcalendar/scrollgrid"
var scrollgrid_ = __webpack_require__(2355);
var scrollgrid_default = /*#__PURE__*/__webpack_require__.n(scrollgrid_);
;// external "@fullcalendar/interaction"
var interaction_namespaceObject = require("@fullcalendar/interaction");
var interaction_default = /*#__PURE__*/__webpack_require__.n(interaction_namespaceObject);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/mixins/CalendarMixin.ts + 6 modules
var CalendarMixin = __webpack_require__(9534);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TechniciansCalendar/TechniciansCalendar.ts?vue&type=script&lang=ts&external











var TechniciansCalendar = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TechniciansCalendar, _super);
    function TechniciansCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.withResources = true;
        _this.sessionStorageKey = 'cechniciansCalendar';
        return _this;
    }
    TechniciansCalendar.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTechnicals()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadVisibilities()];
                    case 3:
                        _a.sent();
                        this.$nextTick(function () {
                            _this.loading = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TechniciansCalendar.prototype, "resources", {
        get: function () {
            var _this = this;
            return this.allTechnicals
                .filter(function (technical) { return _this.visibilityState(technical); })
                .map(function (technical) { return ({
                title: technical.name,
                id: technical.type + '-' + technical.id
            }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TechniciansCalendar.prototype, "visibilityState", {
        get: function () {
            var _this = this;
            return function (technical) {
                var visibility = _this.visibilities.find(function (visibility) { return visibility.element_id === technical.id && visibility.element_type === technical.type; });
                return !visibility || visibility.state;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TechniciansCalendar.prototype, "calendarOptions", {
        // Return options for fullcalendar
        get: function () {
            var _a;
            var resourceTimeLine = {
                type: 'resourceTimeline',
                resourceAreaWidth: '150px',
                duration: { weeks: 1 },
                stickyFooterScrollbar: false,
            };
            if (this.teamConfigs.construction_calendar_timeline_days) {
                resourceTimeLine.slotDuration = { days: 1 };
                resourceTimeLine.slotLabelFormat = {
                    weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true
                };
            }
            return Object.assign({}, this.baseCalendarOptions, {
                plugins: [(resource_timegrid_default()), (resource_daygrid_default()), (bootstrap_default()), (scrollgrid_default()), (interaction_default()), (resource_timeline_default())],
                initialView: (_a = this.getConfig()) !== null && _a !== void 0 ? _a : 'resourceTimeGridThreeDay',
                views: {
                    resourceTimeGridDay: {
                        slotEventOverlap: false
                    },
                    resourceTimeGridWeek: {
                        slotEventOverlap: false
                    },
                    resourceTimeGridThreeDay: {
                        type: 'resourceTimeGrid',
                        duration: { days: 3 },
                        slotEventOverlap: false
                    },
                    resourceTimeLine: resourceTimeLine
                },
                datesAboveResources: true,
                resources: this.resources,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                resourceOrder: 'title',
                selectable: this.onSelect !== null,
                select: this.onSelect,
                height: this.onSelect !== null ? 500 : '100%'
            });
        },
        enumerable: false,
        configurable: true
    });
    TechniciansCalendar.prototype.changeVisibility = function (technical) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var visibility;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        visibility = {
                            element_id: technical.id,
                            element_type: technical.type,
                            state: !this.visibilityState(technical),
                        };
                        this.updateVisibility(visibility);
                        return [4 /*yield*/, this.$kwConstructions.axios.post('/construction/technical/visibility', visibility)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TechniciansCalendar.prototype, "onSelect", void 0);
    TechniciansCalendar = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('constructions', ['loadTechnicals', 'loadVisibilities', 'updateVisibility'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('constructions', ['allTechnicals'])), (0,external_vuex_.mapState)('constructions', ['visibilities'])),
            components: {
                BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem
            }
        })
    ], TechniciansCalendar);
    return TechniciansCalendar;
}((0,lib/* Mixins */.Xe)(CalendarMixin/* default */.A)));
/* harmony default export */ var TechniciansCalendarvue_type_script_lang_ts_external = (TechniciansCalendar);

;// ./src/components/TechniciansCalendar/TechniciansCalendar.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TechniciansCalendar_TechniciansCalendarvue_type_script_lang_ts_external = (TechniciansCalendarvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TechniciansCalendar/TechniciansCalendar.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TechniciansCalendar_TechniciansCalendarvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TechniciansCalendar_TechniciansCalendar = (component.exports);

/***/ }),

/***/ 9219:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isIndex = __webpack_require__(361),
    isLength = __webpack_require__(294),
    toKey = __webpack_require__(7797);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ mixins_CalendarMixin; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@fullcalendar/common"
var common_ = __webpack_require__(2175);
;// external "moment"
var external_moment_namespaceObject = require("moment");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_namespaceObject);
// EXTERNAL MODULE: external "@fullcalendar/vue"
var vue_ = __webpack_require__(5206);
var vue_default = /*#__PURE__*/__webpack_require__.n(vue_);
// EXTERNAL MODULE: ./node_modules/@fullcalendar/core/locales/fr.js
var fr = __webpack_require__(6500);
// EXTERNAL MODULE: ./node_modules/v-calendar/lib/components/date-picker.umd.js
var date_picker_umd = __webpack_require__(7642);
var date_picker_umd_default = /*#__PURE__*/__webpack_require__.n(date_picker_umd);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: ./src/components/PlanificationItem/PlanificationItem.vue + 3 modules
var PlanificationItem = __webpack_require__(1475);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CalendarParams/CalendarParams.vue?vue&type=template&id=8a9b69c2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":"Paramètres d'affichage","size":"lg"},on:{"hidden":function($event){return _vm.$emit('hidden')},"cancel":_vm.cancel},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-form-group',{attrs:{"label":"Jours à afficher"}},[_c('k-form-checkbox-group',{attrs:{"name":"configs[construction_calendar_days][]"},model:{value:(_vm.localConfig.construction_calendar_days),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_days", $$v)},expression:"localConfig.construction_calendar_days"}},_vm._l((_vm.days),function(day){return _c('k-form-checkbox',{key:day.id,staticClass:"calendar-params-day",attrs:{"value":day.id}},[_vm._v(" "+_vm._s(day.label)+" ")])}),1)],1),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Heure de début"}},[_c('k-form-select',{attrs:{"name":"configs[construction_calendar_first_hour]","options":_vm.hours,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.localConfig.construction_calendar_first_hour),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_first_hour", $$v)},expression:"localConfig.construction_calendar_first_hour"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Heure de fin"}},[_c('k-form-select',{attrs:{"name":"configs[construction_calendar_last_hour]","options":_vm.hours,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.localConfig.construction_calendar_last_hour),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_last_hour", $$v)},expression:"localConfig.construction_calendar_last_hour"}})],1)],1)],1),_c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Largeur minimum d'un jour"}},[_c('k-form-spinner',{attrs:{"name":"configs[construction_calendar_day_width]","min":50,"max":500},model:{value:(_vm.localConfig.construction_calendar_day_width),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_day_width", $$v)},expression:"localConfig.construction_calendar_day_width"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Vue timeline"}},[_c('input',{attrs:{"type":"hidden","name":"configs[construction_calendar_timeline_days]"},domProps:{"value":_vm.localConfig.construction_calendar_timeline_days}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.construction_calendar_timeline_days),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_timeline_days", $$v)},expression:"localConfig.construction_calendar_timeline_days"}},[_vm._v(" Ne pas afficher les heures ")])],1)],1)],1),_c('b-form-group',{attrs:{"label":"Personnalisation de l'affichage des planifications en mode jours"}},[_c('k-form-editor',{attrs:{"size":"sm","name":"configs[construction_calendar_content_days]","config":_vm.editorConfig,"required":""},model:{value:(_vm.localConfig.construction_calendar_content_days),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_content_days", $$v)},expression:"localConfig.construction_calendar_content_days"}})],1),_c('b-form-group',{attrs:{"label":"Personnalisation de l'affichage des planifications en mode mois ou timeline"}},[_c('k-form-editor',{attrs:{"size":"sm","name":"configs[construction_calendar_content_month]","config":_vm.editorConfigMonth,"required":""},model:{value:(_vm.localConfig.construction_calendar_content_month),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_calendar_content_month", $$v)},expression:"localConfig.construction_calendar_content_month"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./src/components/CalendarParams/editorConfig.ts
var config = {
    zIndex: 9999999,
    heightMin: 40,
    toolbarButtons: {
        moreText: {
            buttons: [
                'insertDynamicVariables'
            ],
            buttonsVisible: 2
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedTags: ['br', 'strong'],
    htmlAllowedAttrs: ['class', 'contenteditable', 'data-.*', 'data'],
    tableEditButtons: [],
    dynamicVariables: {
        construction: {
            label: 'Informations sur le chantier',
            variables: [
                { value: 'REFERENCE', label: 'Référence du chantier ou de la planification si aucun chantier n\'est lié' },
                { value: 'CONSTRUCTION-REFERENCE', label: 'Référence du chantier' },
                { value: 'PLANIFICATION-REFERENCE', label: 'Référence de la planification' },
                { value: 'TITLE', label: 'Titre du chantier' },
                { value: 'ADDRESS', label: 'Adresse complète du chantier' },
                { value: 'ROAD1', label: 'Adresse - Rue 1' },
                { value: 'ROAD2', label: 'Adresse - Rue 2' },
                { value: 'ROAD3', label: 'Adresse - Rue 3' },
                { value: 'TOWN', label: 'Adresse - Ville' },
                { value: 'POSTAL_CODE', label: 'Adresse - Code postal' },
                { value: 'COUNTRY', label: 'Adresse - Pays' },
            ]
        },
        customer: {
            label: 'Informations sur le client',
            variables: [
                { value: 'TIERS-CODE', label: 'Code client' },
                { value: 'TIERS-NAME', label: 'Nom du client' },
                { value: 'TIERS-PHONE', label: 'Téléphone fixe' },
                { value: 'TIERS-MOBILE', label: 'Téléphone portable' },
                { value: 'TIERS-EMAIL', label: 'Email' }
            ]
        },
        contact: {
            label: 'Informations sur le contact',
            variables: [
                { value: 'CONTACT-FULLNAME', label: 'Nom complet' },
                { value: 'CONTACT-CIVILITY', label: 'Civilité' },
                { value: 'CONTACT-FIRSTNAME', label: 'Prénom' },
                { value: 'CONTACT-LASTNAME', label: 'Nom de famille' },
                { value: 'CONTACT-PHONE', label: 'Téléphone fixe' },
                { value: 'CONTACT-MOBILE', label: 'Téléphone portable' },
                { value: 'CONTACT-EMAIL', label: 'Email' }
            ]
        }
    }
};
/* harmony default export */ var editorConfig = (config);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CalendarParams/CalendarParams.ts?vue&type=script&lang=ts&external






var CalendarParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CalendarParams, _super);
    function CalendarParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.editorConfig = editorConfig;
        _this.days = [
            { id: 1, label: 'Lundi' },
            { id: 2, label: 'Mardi' },
            { id: 3, label: 'Mercredi' },
            { id: 4, label: 'Jeudi' },
            { id: 5, label: 'Vendredi' },
            { id: 6, label: 'Samedi' },
            { id: 0, label: 'Dimanche' }
        ];
        return _this;
    }
    Object.defineProperty(CalendarParams.prototype, "editorConfigMonth", {
        get: function () {
            return Object.assign({
                multiLine: false,
                htmlAllowedTags: []
            }, editorConfig);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarParams.prototype, "hours", {
        get: function () {
            return [
                { id: 0, label: this.$t('calendars.hours.0') },
                { id: 1, label: this.$t('calendars.hours.1') },
                { id: 2, label: this.$t('calendars.hours.2') },
                { id: 3, label: this.$t('calendars.hours.3') },
                { id: 4, label: this.$t('calendars.hours.4') },
                { id: 5, label: this.$t('calendars.hours.5') },
                { id: 6, label: this.$t('calendars.hours.6') },
                { id: 7, label: this.$t('calendars.hours.7') },
                { id: 8, label: this.$t('calendars.hours.8') },
                { id: 9, label: this.$t('calendars.hours.9') },
                { id: 10, label: this.$t('calendars.hours.10') },
                { id: 11, label: this.$t('calendars.hours.11') },
                { id: 12, label: this.$t('calendars.hours.12') },
                { id: 13, label: this.$t('calendars.hours.13') },
                { id: 14, label: this.$t('calendars.hours.14') },
                { id: 15, label: this.$t('calendars.hours.15') },
                { id: 16, label: this.$t('calendars.hours.16') },
                { id: 17, label: this.$t('calendars.hours.17') },
                { id: 18, label: this.$t('calendars.hours.18') },
                { id: 19, label: this.$t('calendars.hours.19') },
                { id: 20, label: this.$t('calendars.hours.20') },
                { id: 21, label: this.$t('calendars.hours.21') },
                { id: 22, label: this.$t('calendars.hours.22') },
                { id: 23, label: this.$t('calendars.hours.23') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CalendarParams.prototype.watchModalState = function () {
        this.modal = this.modalState;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CalendarParams.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CalendarParams.prototype, "watchModalState", null);
    CalendarParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormSpinner: form_vue_.KFormSpinner, KFormSelect: form_vue_.KFormSelect, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KFormCheckbox: form_vue_.KFormCheckbox, KFormEditor: form_vue_.KFormEditor,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FormModal: interface_vue_.FormModal
            }
        })
    ], CalendarParams);
    return CalendarParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CalendarParamsvue_type_script_lang_ts_external = (CalendarParams);

;// ./src/components/CalendarParams/CalendarParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CalendarParams_CalendarParamsvue_type_script_lang_ts_external = (CalendarParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CalendarParams/CalendarParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CalendarParams_CalendarParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarParams_CalendarParams = (component.exports);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./src/mixins/CalendarMixin.ts













var CalendarMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CalendarMixin, _super);
    function CalendarMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.withResources = false;
        _this.showPlanification = null;
        _this.currentView = null;
        _this.start = null;
        _this.end = null;
        _this.viewStart = null;
        _this.viewEnd = null;
        _this.title = '';
        _this.loadEvents = false;
        _this.showCalendarParams = false;
        _this.sessionStorageKey = '';
        _this.availableColors = [
            { background: '#4986e7', color: '#1d1d1d' },
            { background: '#16a765', color: '#1d1d1d' },
            { background: '#ff7537', color: '#1d1d1d' },
            { background: '#f83a22', color: '#1d1d1d' },
            { background: '#fad165', color: '#1d1d1d' },
            { background: '#d06b64', color: '#1d1d1d' },
            { background: '#fa573c', color: '#1d1d1d' },
            { background: '#ffad46', color: '#1d1d1d' },
            { background: '#42d692', color: '#1d1d1d' },
            { background: '#7bd148', color: '#1d1d1d' },
            { background: '#b3dc6c', color: '#1d1d1d' },
            { background: '#fbe983', color: '#1d1d1d' },
            { background: '#92e1c0', color: '#1d1d1d' },
            { background: '#9fe1e7', color: '#1d1d1d' },
            { background: '#ac725e', color: '#1d1d1d' },
            { background: '#9fc6e7', color: '#1d1d1d' },
            { background: '#9a9cff', color: '#1d1d1d' },
            { background: '#b99aff', color: '#1d1d1d' },
            { background: '#c2c2c2', color: '#1d1d1d' },
            { background: '#cabdbf', color: '#1d1d1d' },
            { background: '#cca6ac', color: '#1d1d1d' },
            { background: '#f691b2', color: '#1d1d1d' },
            { background: '#cd74e6', color: '#1d1d1d' },
            { background: '#a47ae2', color: '#1d1d1d' }
        ];
        _this.usedColors = {};
        _this.colorsMarker = 0;
        return _this;
    }
    Object.defineProperty(CalendarMixin.prototype, "api", {
        get: function () {
            var _a;
            return (_a = this.$refs.fullCalendar) === null || _a === void 0 ? void 0 : _a.getApi();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarMixin.prototype, "isToday", {
        // Check if today is present in fullcalendar view
        get: function () {
            var today = external_moment_default()();
            return today.isBetween(this.viewStart, this.viewEnd);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarMixin.prototype, "baseCalendarOptions", {
        get: function () {
            var _this = this;
            var _a;
            return {
                eventContent: this.eventContent,
                eventClassNames: this.eventClassNames,
                themeSystem: 'bootstrap',
                dayMinWidth: this.teamConfigs.construction_calendar_day_width,
                stickyFooterScrollbar: true,
                headerToolbar: false,
                locales: [fr/* default */.A],
                locale: this.$i18n.locale,
                allDaySlot: false,
                slotEventOverlap: false,
                datesSet: this.dateSet,
                scrollTime: (0,common_.createDuration)('07:00:00'),
                slotMinTime: (0,common_.createDuration)(this.teamConfigs.construction_calendar_first_hour + ':00:00'),
                slotMaxTime: (0,common_.createDuration)((this.teamConfigs.construction_calendar_last_hour + 1) + ':00:00'),
                hiddenDays: this.hiddenDays,
                height: '100%',
                eventSources: this.eventSources,
                initialDate: this.events && ((_a = this.events) === null || _a === void 0 ? void 0 : _a.length) > 0 ? external_moment_default()(this.events[0].start).format('YYYY-MM-DD') : external_moment_default()().format('YYYY-MM-DD'),
                eventClick: function (arg) {
                    _this.showPlanification = arg.event.extendedProps;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarMixin.prototype, "eventSources", {
        get: function () {
            var sources = [
                this.getEvents
            ];
            if (this.events) {
                sources.push(this.events);
            }
            return sources;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CalendarMixin.prototype, "hiddenDays", {
        get: function () {
            var _this = this;
            return [1, 2, 3, 4, 5, 6, 0].filter(function (day) { return !_this.teamConfigs.construction_calendar_days.includes(day); });
        },
        enumerable: false,
        configurable: true
    });
    CalendarMixin.prototype.eventContent = function (arg) {
        var _a;
        var construction = (_a = arg.event.extendedProps.construction) !== null && _a !== void 0 ? _a : arg.event.extendedProps;
        if (!construction) {
            return '';
        }
        if (this.currentView === 'dayGridMonth' || this.currentView === 'resourceTimeLine') {
            return {
                html: this.replaceVariables(this.teamConfigs.construction_calendar_content_month, arg.event.extendedProps)
            };
        }
        return {
            html: this.replaceVariables(this.teamConfigs.construction_calendar_content_days, arg.event.extendedProps)
        };
    };
    CalendarMixin.prototype.eventClassNames = function (arg) {
        if (arg.event.extendedProps.status === 2) {
            return ['past-event'];
        }
        return [];
    };
    // Callback when date change in fullcalendar
    CalendarMixin.prototype.dateSet = function (arg) {
        this.start = external_moment_default()(arg.start);
        this.end = external_moment_default()(arg.end);
        this.viewStart = arg.view.currentStart;
        this.viewEnd = arg.view.currentEnd;
        this.title = arg.view.title;
        this.currentView = arg.view.type;
    };
    // Go to a specific date in fullcalendar
    CalendarMixin.prototype.goToDate = function (date) {
        var _a;
        (_a = this.api) === null || _a === void 0 ? void 0 : _a.gotoDate(date);
    };
    // Change view in fullcalendar
    CalendarMixin.prototype.changeView = function (view) {
        var _a;
        (_a = this.api) === null || _a === void 0 ? void 0 : _a.changeView(view);
        if (view === 'resourceTimeLine') {
            this.reloadEvents();
        }
        this.saveConfig(view);
    };
    CalendarMixin.prototype.reloadEvents = function () {
        var _a;
        (_a = this.api) === null || _a === void 0 ? void 0 : _a.refetchEvents();
    };
    CalendarMixin.prototype.render = function () {
        var _a;
        (_a = this.api) === null || _a === void 0 ? void 0 : _a.render();
    };
    // Get events from json
    CalendarMixin.prototype.getEvents = function (info, successCallback, failureCallback) {
        var _this = this;
        var params = {
            include: ['construction', 'technicians', 'customer', 'contact', 'country'],
            per_page: 500,
            filter: {
                begin: info.start.toISOString().split('T')[0],
                end: info.end.toISOString().split('T')[0]
            }
        };
        if (this.teamUser) {
            params.filter.technician = {
                type: 'teamUser',
                id: this.teamUser.id
            };
        }
        this.loadEvents = true;
        this.$kwCalendars.axios.get('/construction/planification', {
            params: params
        })
            .then(function (response) {
            successCallback(response.data.data
                .filter(function (event) { return event.id !== _this.excludeEvent; })
                .map(function (event) { return _this.getEventObject(event); }));
        })
            .catch(function (error) { return failureCallback(error); })
            .finally(function () {
            _this.loadEvents = false;
        });
    };
    // Return an event formatted for fullcalendar
    CalendarMixin.prototype.getEventObject = function (event) {
        var input = {
            id: 'event-' + event.id,
            start: event.begin,
            end: event.end,
            allDay: false,
            className: ['event-id-' + event.id],
            extendedProps: event
        };
        if (this.withResources) {
            input.resourceIds = event.technicians.map(function (technician) { return technician.type + '-' + technician.id; });
        }
        var constructionId = event.construction_id;
        var color;
        if (constructionId && this.usedColors[constructionId]) {
            color = this.availableColors[this.usedColors[constructionId]];
        }
        else {
            if (constructionId) {
                this.usedColors[constructionId] = this.colorsMarker;
            }
            color = this.availableColors[this.colorsMarker];
            this.colorsMarker++;
            if (this.colorsMarker > 24) {
                this.colorsMarker = 0;
            }
        }
        if (color) {
            input.backgroundColor = color.background;
            input.borderColor = color.background;
            input.textColor = color.color;
        }
        return input;
    };
    CalendarMixin.prototype.replaceVariables = function (content, planification) {
        var _this = this;
        var _a;
        (_a = content.match(/<variable(.*?)<\/variable>/gs)) === null || _a === void 0 ? void 0 : _a.forEach(function (variable) {
            // Get variable identifier
            var findIdent = variable.match(/data-variable="(.*?)"/s);
            if (!findIdent) {
                return;
            }
            var ident = findIdent[1];
            var findConditionnal = variable.match(/data-conditional-show="(.*?)"/s);
            var conditionnal = findConditionnal ? findConditionnal[1] === 'true' : false;
            var previewValue = _this.previewValues(planification)[ident];
            if (previewValue === undefined || previewValue === null) {
                previewValue = '';
            }
            if (previewValue === '' && conditionnal) {
                content = content.replace(variable, '');
                return;
            }
            var replace = '';
            var findSpaceBeforePrefix = variable.match(/data-prefix-space-before="(.*?)"/s);
            var spaceBeforePrefix = findSpaceBeforePrefix ? findSpaceBeforePrefix[1] === 'true' : false;
            if (spaceBeforePrefix) {
                replace += '<br>';
            }
            var findPrefix = variable.match(/data-prefix="(.*?)"/s);
            if (findPrefix) {
                var prefixLabel = findPrefix[1];
                var findBoldPrefix = variable.match(/data-prefix-bold="(.*?)"/s);
                var boldPrefix = findBoldPrefix ? findBoldPrefix[1] === 'true' : false;
                if (boldPrefix) {
                    prefixLabel = '<strong>' + prefixLabel + '</strong>';
                }
                replace += prefixLabel;
            }
            var findSpaceAfterPrefix = variable.match(/data-prefix-space-after="(.*?)"/s);
            var spaceAfterPrefix = findSpaceAfterPrefix ? findSpaceAfterPrefix[1] === 'true' : false;
            if (spaceAfterPrefix) {
                replace += '<br>';
            }
            replace += previewValue;
            var findSpaceBeforeSuffix = variable.match(/data-suffix-space-before="(.*?)"/s);
            var spaceBeforeSuffix = findSpaceBeforeSuffix ? findSpaceBeforeSuffix[1] === 'true' : false;
            if (spaceBeforeSuffix) {
                replace += '<br>';
            }
            var findSuffix = variable.match(/data-suffix="(.*?)"/s);
            if (findSuffix) {
                replace += findSuffix[1];
            }
            var findSpaceAfterSuffix = variable.match(/data-suffix-space-after="(.*?)"/s);
            var spaceAfterSuffix = findSpaceAfterSuffix ? findSpaceAfterSuffix[1] === 'true' : false;
            if (spaceAfterSuffix) {
                replace += '<br>';
            }
            content = content.replace(variable, replace);
        });
        return content;
    };
    Object.defineProperty(CalendarMixin.prototype, "previewValues", {
        get: function () {
            return function (planification) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                var construction = planification.construction;
                var customer = (_a = construction === null || construction === void 0 ? void 0 : construction.customer) !== null && _a !== void 0 ? _a : planification.customer;
                var contact = (_b = construction === null || construction === void 0 ? void 0 : construction.contact) !== null && _b !== void 0 ? _b : planification.contact;
                return {
                    'REFERENCE': (_c = construction === null || construction === void 0 ? void 0 : construction.reference) !== null && _c !== void 0 ? _c : planification.reference,
                    'CONSTRUCTION-REFERENCE': construction === null || construction === void 0 ? void 0 : construction.reference,
                    'PLANIFICATION-REFERENCE': planification.reference,
                    'TITLE': construction === null || construction === void 0 ? void 0 : construction.title,
                    'ADDRESS': (_d = construction === null || construction === void 0 ? void 0 : construction.full_address) !== null && _d !== void 0 ? _d : planification.full_address,
                    'ROAD1': (_e = construction === null || construction === void 0 ? void 0 : construction.road1) !== null && _e !== void 0 ? _e : planification.road1,
                    'ROAD2': (_f = construction === null || construction === void 0 ? void 0 : construction.road2) !== null && _f !== void 0 ? _f : planification.road2,
                    'ROAD3': (_g = construction === null || construction === void 0 ? void 0 : construction.road3) !== null && _g !== void 0 ? _g : planification.road3,
                    'TOWN': (_h = construction === null || construction === void 0 ? void 0 : construction.town) !== null && _h !== void 0 ? _h : planification.town,
                    'POSTAL_CODE': (_j = construction === null || construction === void 0 ? void 0 : construction.postal_code) !== null && _j !== void 0 ? _j : planification.postal_code,
                    'COUNTRY': (_l = (_k = construction === null || construction === void 0 ? void 0 : construction.country) === null || _k === void 0 ? void 0 : _k.name) !== null && _l !== void 0 ? _l : (_m = planification.country) === null || _m === void 0 ? void 0 : _m.name,
                    'TIERS-CODE': (_o = customer === null || customer === void 0 ? void 0 : customer.reference) === null || _o === void 0 ? void 0 : _o.customer,
                    'TIERS-NAME': customer === null || customer === void 0 ? void 0 : customer.name,
                    'TIERS-PHONE': customer === null || customer === void 0 ? void 0 : customer.phone,
                    'TIERS-MOBILE': customer === null || customer === void 0 ? void 0 : customer.mobile,
                    'TIERS-EMAIL': customer === null || customer === void 0 ? void 0 : customer.email,
                    'CONTACT-FULLNAME': contact === null || contact === void 0 ? void 0 : contact.fullname,
                    'CONTACT-CIVILITY': (_p = contact === null || contact === void 0 ? void 0 : contact.civility) === null || _p === void 0 ? void 0 : _p.name,
                    'CONTACT-FIRSTNAME': contact === null || contact === void 0 ? void 0 : contact.firstname,
                    'CONTACT-LASTNAME': contact === null || contact === void 0 ? void 0 : contact.lastname,
                    'CONTACT-PHONE': contact === null || contact === void 0 ? void 0 : contact.phone,
                    'CONTACT-MOBILE': contact === null || contact === void 0 ? void 0 : contact.mobile,
                    'CONTACT-EMAIL': contact === null || contact === void 0 ? void 0 : contact.email
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    CalendarMixin.prototype.getConfig = function () {
        var _a;
        return (_a = window.localStorage.getItem(this.sessionStorageKey)) !== null && _a !== void 0 ? _a : null;
    };
    CalendarMixin.prototype.saveConfig = function (config) {
        window.localStorage.setItem(this.sessionStorageKey, config);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CalendarMixin.prototype, "events", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CalendarMixin.prototype, "excludeEvent", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CalendarMixin.prototype, "teamUser", void 0);
    CalendarMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                datepicker: (date_picker_umd_default()),
                BButtonGroup: external_bootstrap_vue_.BButtonGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                Spinner: interface_vue_.Spinner,
                FullCalendar: (vue_default()),
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                PlanificationItem: PlanificationItem/* default */.A,
                CalendarParams: CalendarParams_CalendarParams
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], CalendarMixin);
    return CalendarMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_CalendarMixin = (CalendarMixin);


/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Emit, Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) // removed by dead control flow
{}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) // removed by dead control flow
{}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9698:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 9770:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 9817:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AffairSearch: function() { return /* reexport */ AffairSearch_AffairSearch; },
  AffairsList: function() { return /* reexport */ AffairsList_AffairsList; },
  CalendarMixin: function() { return /* reexport */ CalendarMixin/* default */.A; },
  ConstructionCalendar: function() { return /* reexport */ ConstructionCalendar_ConstructionCalendar; },
  ConstructionCalendarView: function() { return /* reexport */ views_ConstructionCalendarView; },
  ConstructionDelete: function() { return /* reexport */ ConstructionDelete; },
  ConstructionForm: function() { return /* reexport */ ConstructionForm_ConstructionForm; },
  ConstructionFormView: function() { return /* reexport */ views_ConstructionFormView; },
  ConstructionItem: function() { return /* reexport */ ConstructionItem_ConstructionItem; },
  ConstructionItemView: function() { return /* reexport */ views_ConstructionItemView; },
  ConstructionList: function() { return /* reexport */ ConstructionList_ConstructionList; },
  ConstructionListView: function() { return /* reexport */ ConstructionListView_ConstructionListView; },
  ConstructionParams: function() { return /* reexport */ ConstructionParams_ConstructionParams; },
  ConstructionParamsView: function() { return /* reexport */ views_ConstructionParamsView; },
  DurationMixin: function() { return /* reexport */ DurationMixin/* default */.A; },
  LoadConstructionMixin: function() { return /* reexport */ mixins_LoadConstructionMixin; },
  Materials: function() { return /* reexport */ Materials_Materials; },
  MaterialsView: function() { return /* reexport */ views_MaterialsView; },
  PlanificationDelete: function() { return /* reexport */ PlanificationDelete_PlanificationDelete/* default */.A; },
  PlanificationForm: function() { return /* reexport */ PlanificationForm["default"]; },
  PlanificationItem: function() { return /* reexport */ PlanificationItem/* default */.A; },
  PlanificationList: function() { return /* reexport */ PlanificationList_PlanificationList; },
  PlanificationListView: function() { return /* reexport */ PlanificationListView_PlanificationListView; },
  PlanificationStatus: function() { return /* reexport */ PlanificationStatus/* default */.A; },
  StatusMixin: function() { return /* reexport */ mixins_StatusMixin; },
  Technicians: function() { return /* reexport */ Technicians_Technicians; },
  TechniciansCalendar: function() { return /* reexport */ TechniciansCalendar/* default */.A; },
  TechniciansCalendarView: function() { return /* reexport */ views_TechniciansCalendarView; },
  constructionRelations: function() { return /* reexport */ constructionRelations; },
  fetchConstruction: function() { return /* reexport */ fetchConstruction; },
  fetchPlanification: function() { return /* reexport */ planification/* fetchPlanification */.i_; },
  goToHome: function() { return /* reexport */ router_goToHome; },
  needFetchConstruction: function() { return /* reexport */ needFetchConstruction; },
  needFetchPlanification: function() { return /* reexport */ planification/* needFetchPlanification */.GU; },
  planificationRelations: function() { return /* reexport */ planification/* planificationRelations */.Jp; },
  showSidebar: function() { return /* reexport */ src_showSidebar; },
  termText: function() { return /* reexport */ utils_text/* termText */.a; },
  uppercaseFirst: function() { return /* reexport */ utils_text/* uppercaseFirst */.t; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AffairSearch/AffairSearch.vue?vue&type=template&id=b4a837a2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":"","size":"xl"},on:{"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{staticClass:"form-text",attrs:{"label":"Client"}},[_vm._v(" "+_vm._s(_vm.value.customer.name)+" ")])],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Type de document"}},[_c('k-form-select',{attrs:{"options":_vm.documentsTypes,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1)],1)],1),_c('b-alert',{staticClass:"mt-1 mb-4",attrs:{"show":"","variant":"warning"}},[_vm._v(" Lorsqu'un document est rattaché, tous ses documents liés seront automatiquement rattachés, incluant ceux qui seront créés ultérieurement. ")]),_c('k-table',{ref:"table",attrs:{"url":'/sales/' + _vm.selectedType,"ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"stateKey":"construction-attachments","rowActions":_vm.rowActions}})]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// external "@kwixeo/table-vue"
var table_vue_namespaceObject = require("@kwixeo/table-vue");
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AffairSearch/AffairSearch.ts?vue&type=script&lang=ts&external








var AffairSearch = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairSearch, _super);
    function AffairSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.selectedType = 'quotation';
        _this.loadingDocuments = true;
        _this.customer = null;
        _this.documentsTypes = [
            { value: 'quotation', label: 'Devis' },
            { value: 'command', label: 'Bon de commande' },
            { value: 'proforma', label: 'Facture proforma' },
            { value: 'delivery', label: 'Bon de livraison' },
            { value: 'invoice', label: 'Facture' },
            { value: 'credit', label: 'Avoir' }
        ];
        _this.documents = [];
        return _this;
    }
    Object.defineProperty(AffairSearch.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "ajaxDatas", {
        get: function () {
            var _a;
            return {
                include: this.selectedType === 'invoice' || this.selectedType === 'credit' ? 'affairs' : '',
                filter: {
                    customer: (_a = this.customer) === null || _a === void 0 ? void 0 : _a.id,
                    exclude: this.excludeIds
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "excludeIds", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var documents = [];
            switch (this.selectedType) {
                case 'quotation':
                    documents = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.quotations) !== null && _b !== void 0 ? _b : [];
                    break;
                case 'command':
                    documents = (_d = (_c = this.value) === null || _c === void 0 ? void 0 : _c.commands) !== null && _d !== void 0 ? _d : [];
                    break;
                case 'proforma':
                    documents = (_f = (_e = this.value) === null || _e === void 0 ? void 0 : _e.proformas) !== null && _f !== void 0 ? _f : [];
                    break;
                case 'delivery':
                    documents = (_h = (_g = this.value) === null || _g === void 0 ? void 0 : _g.deliveries) !== null && _h !== void 0 ? _h : [];
                    break;
                case 'invoice':
                    documents = (_k = (_j = this.value) === null || _j === void 0 ? void 0 : _j.invoices) !== null && _k !== void 0 ? _k : [];
                    break;
                case 'credit':
                    documents = (_m = (_l = this.value) === null || _l === void 0 ? void 0 : _l.credits) !== null && _m !== void 0 ? _m : [];
                    break;
            }
            return documents.map(function (quotation) { return quotation.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "columns", {
        get: function () {
            return [
                {
                    name: 'N° Document',
                    data: 'reference'
                },
                {
                    name: 'Date',
                    data: 'date',
                    render: 'date'
                },
                {
                    name: 'Titre',
                    data: 'title',
                    visible: false
                },
                {
                    name: 'Total HT',
                    data: 'total_ht',
                    render: 'currency'
                },
                {
                    name: 'Total TVA',
                    data: 'total_tva',
                    render: 'currency',
                    visible: false
                },
                {
                    name: 'Total TTC',
                    data: 'total_ttc',
                    render: 'currency',
                    visible: false
                },
                {
                    name: 'Statut',
                    data: 'status_label'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [{
                    label: 'Rattacher',
                    variant: 'secondary',
                    click: function (document) {
                        var affairs = [];
                        switch (_this.selectedType) {
                            case 'invoice':
                            case 'credit':
                                affairs = document.affairs.map(function (affair) { return affair.id; });
                                break;
                            default:
                                affairs.push(document.affair_id);
                        }
                        _this.process(affairs);
                    }
                }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : 'Rattacher un document';
        },
        enumerable: false,
        configurable: true
    });
    AffairSearch.prototype.watchValue = function () {
        var _a;
        this.customer = JSON.parse(JSON.stringify((_a = this.value) === null || _a === void 0 ? void 0 : _a.customer));
    };
    AffairSearch.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    AffairSearch.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    AffairSearch.prototype.watchSelectedType = function () {
        var _this = this;
        this.loading = true;
        this.$nextTick(function () { return _this.loading = false; });
    };
    AffairSearch.prototype.process = function (affairs) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwOpportunities.axios.put('/construction/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id), {
                                add_affairs: affairs
                            })
                                .then(function (response) {
                                _this.$emit('input', response.data);
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                _this.loading = false;
                                throw new Error(error);
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AffairSearch.prototype.closeModal = function () {
        this.modalState = false;
    };
    AffairSearch.prototype.deleted = function () {
        this.$emit('deleted');
    };
    AffairSearch.prototype.customerUpdated = function () {
        var table = this.$refs.table;
        table.refresh();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AffairSearch.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], AffairSearch.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AffairSearch.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'primary' })
    ], AffairSearch.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'sm' })
    ], AffairSearch.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AffairSearch.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AffairSearch.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], AffairSearch.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], AffairSearch.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], AffairSearch.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('selectedType')
    ], AffairSearch.prototype, "watchSelectedType", null);
    AffairSearch = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                Spinner: interface_vue_.Spinner,
                KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput,
                KTable: table_vue_namespaceObject.KTable,
                CustomerSelect: customers_vue_.CustomerSelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], AffairSearch);
    return AffairSearch;
}(lib/* Vue */.lD));
/* harmony default export */ var AffairSearchvue_type_script_lang_ts_external = (AffairSearch);

;// ./src/components/AffairSearch/AffairSearch.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AffairSearch_AffairSearchvue_type_script_lang_ts_external = (AffairSearchvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AffairSearch/AffairSearch.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AffairSearch_AffairSearchvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AffairSearch_AffairSearch = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AffairsList/AffairsList.vue?vue&type=template&id=a18365d4
var AffairsListvue_type_template_id_a18365d4_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('AffairSearch',{staticClass:"mb-2",attrs:{"value":_vm.value},on:{"input":doc => _vm.$emit('input', doc)}}),_vm._l((_vm.linkedDocuments),function(documents,i){return _c('div',{key:'affair' + i,staticClass:"border mb-2 px-2 pt-2 pb-0"},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:('Supprimer le rattachement des documents'),expression:"'Supprimer le rattachement des documents'"}],staticClass:"text-danger float-right",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();_vm.deleteAttachment = i}}}),(_vm.sameTitle(i))?_c('p',{key:'title-' + i,staticClass:"small mb-1"},[_vm._v(" "+_vm._s(documents[0].document.title)+" ")]):_vm._e(),_vm._l((documents),function(el,j){return _c('b-badge',{key:j,staticClass:"mr-2 mb-2 badge-md text-left font-weight-normal opportunity-linked-document",attrs:{"variant":"light","to":{ name: el.type + '-item', params: { id: el.document.id } }}},[_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" "+_vm._s(_vm.$t('sales.' + el.type + '.label'))+" "),(el.document.is_advance)?_c('span',[_vm._v("d'acompte")]):_vm._e(),_vm._v(" n°"+_vm._s(el.document.reference)+" ")]),(_vm.teamConfigs.opportunity_linked_document_title && !_vm.sameTitle(i))?_c('p',{staticClass:"mt-2 title mb-0"},[_vm._v(" "+_vm._s(el.document.title)+" ")]):_vm._e(),(_vm.teamConfigs.opportunity_linked_document_date_amount)?_c('p',{class:{
            'mb-0': true,
            'mt-2': true,
            'font-weight-bold': el.document.title && _vm.teamConfigs.opportunity_linked_document_title
          }},[_vm._v(" "+_vm._s(_vm.date(el.document.date))+" - "+_vm._s(_vm.formattedNumber(el.document.total_ht))+" ")]):_vm._e()])})],2)}),(_vm.deleteAttachment !== null)?_c('ConfirmModal',{attrs:{"message":"Êtes-vous sûr de vouloir supprimer ce rattachement ?"},on:{"confirmed":_vm.processDeleteAttachment,"hidden":function($event){_vm.deleteAttachment = null}}}):_vm._e()]],2)
}
var AffairsListvue_type_template_id_a18365d4_staticRenderFns = []


// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AffairsList/AffairsList.ts?vue&type=script&lang=ts&external







var AffairsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairsList, _super);
    function AffairsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.deleteAttachment = null;
        return _this;
    }
    Object.defineProperty(AffairsList.prototype, "sameTitle", {
        get: function () {
            var _this = this;
            return function (key) {
                var title = _this.linkedDocuments[key][0].document.title;
                return _this.linkedDocuments[key].every(function (val) { return val.document.title === title; });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairsList.prototype, "linkedDocuments", {
        get: function () {
            var linked = {};
            if (this.value.quotations) {
                this.value.quotations.forEach(function (quotation) {
                    if (!linked[quotation.affair_id]) {
                        linked[quotation.affair_id] = [];
                    }
                    linked[quotation.affair_id].push({
                        type: 'quotation',
                        document: quotation
                    });
                });
            }
            if (this.value.commands) {
                this.value.commands.forEach(function (command) {
                    if (!linked[command.affair_id]) {
                        linked[command.affair_id] = [];
                    }
                    linked[command.affair_id].push({
                        type: 'command',
                        document: command
                    });
                });
            }
            if (this.value.proformas) {
                this.value.proformas.forEach(function (proforma) {
                    if (!linked[proforma.affair_id]) {
                        linked[proforma.affair_id] = [];
                    }
                    linked[proforma.affair_id].push({
                        type: 'proforma',
                        document: proforma
                    });
                });
            }
            if (this.value.deliveries) {
                this.value.deliveries.forEach(function (delivery) {
                    if (!linked[delivery.affair_id]) {
                        linked[delivery.affair_id] = [];
                    }
                    linked[delivery.affair_id].push({
                        type: 'delivery',
                        document: delivery
                    });
                });
            }
            if (this.value.invoices) {
                this.value.invoices.forEach(function (invoice) {
                    var _a;
                    (_a = invoice.affairs) === null || _a === void 0 ? void 0 : _a.map(function (affair) {
                        if (!linked[affair.id]) {
                            linked[affair.id] = [];
                        }
                        linked[affair.id].push({
                            type: 'invoice',
                            document: invoice
                        });
                    });
                });
            }
            if (this.value.credits) {
                this.value.credits.forEach(function (credit) {
                    var _a;
                    (_a = credit.affairs) === null || _a === void 0 ? void 0 : _a.map(function (affair) {
                        if (!linked[affair.id]) {
                            linked[affair.id] = [];
                        }
                        linked[affair.id].push({
                            type: 'credit',
                            document: credit
                        });
                    });
                });
            }
            return linked;
        },
        enumerable: false,
        configurable: true
    });
    AffairsList.prototype.processDeleteAttachment = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loading = true;
                this.$kwOpportunities.axios.put('/construction/' + this.value.id, {
                    remove_affairs: [this.deleteAttachment]
                })
                    .then(function (response) {
                    _this.$emit('input', response.data);
                })
                    .catch(function (error) {
                    throw new Error(error);
                })
                    .finally(function () {
                    _this.loading = false;
                    _this.deleteAttachment = null;
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AffairsList.prototype, "value", void 0);
    AffairsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AffairSearch: AffairSearch_AffairSearch,
                BButton: external_bootstrap_vue_.BButton, BBadge: external_bootstrap_vue_.BBadge,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner,
                ConfirmModal: interface_vue_.ConfirmModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], AffairsList);
    return AffairsList;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var AffairsListvue_type_script_lang_ts_external = (AffairsList);

;// ./src/components/AffairsList/AffairsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AffairsList_AffairsListvue_type_script_lang_ts_external = (AffairsListvue_type_script_lang_ts_external); 
;// ./src/components/AffairsList/AffairsList.vue





/* normalize component */
;
var AffairsList_component = (0,componentNormalizer/* default */.A)(
  AffairsList_AffairsListvue_type_script_lang_ts_external,
  AffairsListvue_type_template_id_a18365d4_render,
  AffairsListvue_type_template_id_a18365d4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AffairsList_AffairsList = (AffairsList_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionCalendar/ConstructionCalendar.vue?vue&type=template&id=1fb4153c
var ConstructionCalendarvue_type_template_id_1fb4153c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-row',{staticClass:"mb-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('h1',{staticClass:"calendar-title d-block d-md-inline-block text-center mb-2 mb-md-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.loadEvents)?_c('Spinner',{staticClass:"d-inline-block p-0",attrs:{"size":"1"}}):_vm._e()],1),_c('b-col',{staticClass:"text-right",attrs:{"cols":"12","md":"auto"}},[_c('datepicker',{attrs:{"value":_vm.viewStart},on:{"input":_vm.goToDate},scopedSlots:_vm._u([{key:"default",fn:function({ togglePopover }){return [_c('b-button',{staticClass:"mr-3 btn-icon",attrs:{"size":"sm"},on:{"click":function($event){return togglePopover()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'calendar-alt']}})],1)]}}])}),_c('b-button-group',{staticClass:"mr-3",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"primary","disabled":_vm.currentView === 'timeGridDay'},on:{"click":function($event){return _vm.changeView('timeGridDay')}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.day'))+" ")]),_c('b-button',{attrs:{"disabled":_vm.currentView === 'timeGridThreeDay',"variant":"primary"},on:{"click":function($event){return _vm.changeView('timeGridThreeDay')}}},[_vm._v(" 3 jours ")]),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.currentView === 'timeGridWeek'},on:{"click":function($event){return _vm.changeView('timeGridWeek')}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.week'))+" ")]),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.currentView === 'dayGridMonth'},on:{"click":function($event){return _vm.changeView('dayGridMonth')}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.month'))+" ")])],1),_c('div',{staticClass:"d-inline-block mt-2 mt-sm-0"},[_c('b-button',{staticClass:"mr-3",attrs:{"size":"sm","disabled":_vm.isToday},on:{"click":function($event){_vm.api?.today()}}},[_vm._v(" "+_vm._s(_vm.$t('calendars.today'))+" ")]),_c('b-button-group',{staticClass:"mr-3",attrs:{"size":"sm"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.api?.prev()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-left']}})],1),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.api?.next()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-right']}})],1)],1),_c('b-button',{staticClass:"btn-icon",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();_vm.showCalendarParams = true}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'cog']}})],1)],1)],1)],1),_c('FullCalendar',{ref:"fullCalendar",staticClass:"planification-calendar",attrs:{"options":_vm.calendarOptions}}),(_vm.showPlanification)?_c('PlanificationItem',{attrs:{"element":"modal","modal":true},on:{"hidden":function($event){_vm.showPlanification = null},"updated":_vm.reloadEvents,"deleted":_vm.reloadEvents},model:{value:(_vm.showPlanification),callback:function ($$v) {_vm.showPlanification=$$v},expression:"showPlanification"}}):_vm._e(),_c('CalendarParams',{attrs:{"modalState":_vm.showCalendarParams},on:{"hidden":function($event){_vm.showCalendarParams = false}}})],1)
}
var ConstructionCalendarvue_type_template_id_1fb4153c_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/v-calendar/lib/components/date-picker.umd.js
var date_picker_umd = __webpack_require__(7642);
var date_picker_umd_default = /*#__PURE__*/__webpack_require__.n(date_picker_umd);
;// external "@fullcalendar/daygrid"
var daygrid_namespaceObject = require("@fullcalendar/daygrid");
var daygrid_default = /*#__PURE__*/__webpack_require__.n(daygrid_namespaceObject);
;// external "@fullcalendar/timegrid"
var timegrid_namespaceObject = require("@fullcalendar/timegrid");
var timegrid_default = /*#__PURE__*/__webpack_require__.n(timegrid_namespaceObject);
// EXTERNAL MODULE: external "@fullcalendar/bootstrap"
var bootstrap_ = __webpack_require__(5936);
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap_);
// EXTERNAL MODULE: external "@fullcalendar/scrollgrid"
var scrollgrid_ = __webpack_require__(2355);
var scrollgrid_default = /*#__PURE__*/__webpack_require__.n(scrollgrid_);
// EXTERNAL MODULE: ./node_modules/@fullcalendar/core/locales/fr.js
var fr = __webpack_require__(6500);
// EXTERNAL MODULE: external "@fullcalendar/common"
var common_ = __webpack_require__(2175);
// EXTERNAL MODULE: external "@fullcalendar/vue"
var vue_ = __webpack_require__(5206);
var vue_default = /*#__PURE__*/__webpack_require__.n(vue_);
// EXTERNAL MODULE: ./src/components/PlanificationItem/PlanificationItem.vue + 3 modules
var PlanificationItem = __webpack_require__(1475);
// EXTERNAL MODULE: ./src/mixins/CalendarMixin.ts + 6 modules
var CalendarMixin = __webpack_require__(9534);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionCalendar/ConstructionCalendar.ts?vue&type=script&lang=ts&external















var ConstructionCalendar = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionCalendar, _super);
    function ConstructionCalendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sessionStorageKey = 'constructionCalendar';
        return _this;
    }
    Object.defineProperty(ConstructionCalendar.prototype, "calendarOptions", {
        // Return options for fullcalendar
        get: function () {
            var _this = this;
            var _a;
            return {
                plugins: [(daygrid_default()), (timegrid_default()), (bootstrap_default()), (scrollgrid_default())],
                initialView: (_a = this.getConfig()) !== null && _a !== void 0 ? _a : 'timeGridWeek',
                views: {
                    timeGridDay: {
                        slotEventOverlap: false
                    },
                    timeGridWeek: {
                        slotEventOverlap: false
                    },
                    timeGridThreeDay: {
                        type: 'timeGridWeek',
                        duration: { days: 3 },
                        slotEventOverlap: false
                    }
                },
                eventDisplay: 'block',
                eventContent: this.eventContent,
                eventClassNames: this.eventClassNames,
                themeSystem: 'bootstrap',
                dayMinWidth: this.teamConfigs.construction_calendar_day_width,
                stickyFooterScrollbar: true,
                headerToolbar: false,
                locales: [fr/* default */.A],
                locale: this.$i18n.locale,
                allDaySlot: false,
                datesSet: this.dateSet,
                scrollTime: (0,common_.createDuration)('07:00:00'),
                slotMinTime: (0,common_.createDuration)(this.teamConfigs.construction_calendar_first_hour + ':00:00'),
                slotMaxTime: (0,common_.createDuration)((this.teamConfigs.construction_calendar_last_hour + 1) + ':00:00'),
                hiddenDays: this.hiddenDays,
                height: '100%',
                startParam: 'filter[begin]',
                endParam: 'filter[end]',
                eventSources: [this.getEvents],
                eventClick: function (arg) {
                    _this.showPlanification = arg.event.extendedProps;
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    ConstructionCalendar = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                datepicker: (date_picker_umd_default()),
                BButtonGroup: external_bootstrap_vue_.BButtonGroup, BButton: external_bootstrap_vue_.BButton, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                Spinner: interface_vue_.Spinner,
                FullCalendar: (vue_default()),
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                PlanificationItem: PlanificationItem/* default */.A
            }
        })
    ], ConstructionCalendar);
    return ConstructionCalendar;
}((0,lib/* Mixins */.Xe)(CalendarMixin/* default */.A)));
/* harmony default export */ var ConstructionCalendarvue_type_script_lang_ts_external = (ConstructionCalendar);

;// ./src/components/ConstructionCalendar/ConstructionCalendar.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionCalendar_ConstructionCalendarvue_type_script_lang_ts_external = (ConstructionCalendarvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionCalendar/ConstructionCalendar.vue





/* normalize component */
;
var ConstructionCalendar_component = (0,componentNormalizer/* default */.A)(
  ConstructionCalendar_ConstructionCalendarvue_type_script_lang_ts_external,
  ConstructionCalendarvue_type_template_id_1fb4153c_render,
  ConstructionCalendarvue_type_template_id_1fb4153c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionCalendar_ConstructionCalendar = (ConstructionCalendar_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionDelete/ConstructionDelete.vue?vue&type=template&id=13ecbad4
var ConstructionDeletevue_type_template_id_13ecbad4_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.' + (_vm.errorMsg ? 'close' : 'delete')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"ok-only":_vm.errorMsg !== null},on:{"ok":_vm.process,"hidden":_vm.hidden},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]:[_vm._v(" "+_vm._s(_vm.termText('construction.deleteMsg', 'chantier'))+" ")]],2)],1)
}
var ConstructionDeletevue_type_template_id_13ecbad4_staticRenderFns = []


// EXTERNAL MODULE: ./src/utils/text.ts
var utils_text = __webpack_require__(2579);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionDelete/ConstructionDelete.ts?vue&type=script&lang=ts&external





var PlanificationDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationDelete, _super);
    function PlanificationDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(PlanificationDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    PlanificationDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    PlanificationDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    PlanificationDelete.prototype.process = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            this.hidden();
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.delete('/construction/' + this.value.id)
            .then(function () {
            _this.deleted();
            _this.hidden();
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    PlanificationDelete.prototype.hidden = function () {
        this.errorMsg = null;
        this.modalState = false;
        this.$emit('hidden');
    };
    PlanificationDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('constructionDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], PlanificationDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], PlanificationDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Supprimer' })
    ], PlanificationDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], PlanificationDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], PlanificationDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], PlanificationDelete.prototype, "watchModalState", null);
    PlanificationDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            methods: {
                termText: utils_text/* termText */.a
            }
        })
    ], PlanificationDelete);
    return PlanificationDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ConstructionDeletevue_type_script_lang_ts_external = (PlanificationDelete);

;// ./src/components/ConstructionDelete/ConstructionDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionDelete_ConstructionDeletevue_type_script_lang_ts_external = (ConstructionDeletevue_type_script_lang_ts_external); 
;// ./src/components/ConstructionDelete/ConstructionDelete.vue





/* normalize component */
;
var ConstructionDelete_component = (0,componentNormalizer/* default */.A)(
  ConstructionDelete_ConstructionDeletevue_type_script_lang_ts_external,
  ConstructionDeletevue_type_template_id_13ecbad4_render,
  ConstructionDeletevue_type_template_id_13ecbad4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionDelete = (ConstructionDelete_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionForm/ConstructionForm.vue?vue&type=template&id=01c75091
var ConstructionFormvue_type_template_id_01c75091_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle}}),_c('AppMessages'),(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('h2',{staticClass:"form-title my-0 border-0"},[_vm._v(" "+_vm._s(_vm.termText('construction.form.infosTitle', 'chantier'))+" ")]),_c('b-card',[_c('b-row',[_c('b-col',[_c('k-form-input',{staticClass:"mb-3",attrs:{"placeholder":_vm.termText('construction.form.title', 'chantier'),"name":"title"},model:{value:(_vm.construction.title),callback:function ($$v) {_vm.$set(_vm.construction, "title", $$v)},expression:"construction.title"}})],1),_c('b-col',{staticStyle:{"min-width":"200px"},attrs:{"cols":"auto"}},[_vm._l((_vm.construction.tags),function(tag,i){return _c('input',{key:i,attrs:{"type":"hidden","name":"tags[]"},domProps:{"value":typeof tag === 'object' ? tag.name : tag}})}),(_vm.construction.tags && _vm.construction.tags.length === 0)?_c('input',{attrs:{"type":"hidden","name":"tags"},domProps:{"value":null}}):_vm._e(),_c('TagSelect',{attrs:{"placeholder":"Mots-clés"},model:{value:(_vm.construction.tags),callback:function ($$v) {_vm.$set(_vm.construction, "tags", $$v)},expression:"construction.tags"}})],2)],1),_c('b-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.construction.customer ? _vm.construction.customer.id : null}}),_c('CustomerSelect',{attrs:{"required":"","include":['address_invoice', 'address_delivery', 'addresses'],"validationName":"customer","type":"prospect_or_customer"},on:{"input":_vm.selectCustomer},model:{value:(_vm.construction.customer),callback:function ($$v) {_vm.$set(_vm.construction, "customer", $$v)},expression:"construction.customer"}}),_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.construction.contact ? _vm.construction.contact.id : null}}),_c('ContactSelect',{attrs:{"customer":_vm.construction.customer,"disabled":!_vm.construction.customer},model:{value:(_vm.construction.contact),callback:function ($$v) {_vm.$set(_vm.construction, "contact", $$v)},expression:"construction.contact"}}),_c('CustomFieldsForm',{attrs:{"type":"construction"},model:{value:(_vm.construction.custom_fields),callback:function ($$v) {_vm.$set(_vm.construction, "custom_fields", $$v)},expression:"construction.custom_fields"}})],1),_c('b-col',[_c('b-form-group',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.termText('construction.form.address', 'chantier'))+" ")]),_c('b-col',[_c('CustomerAddressSelect',{attrs:{"customer":_vm.construction.customer},on:{"selected":_vm.selectAddress}})],1)],1)]},proxy:true}])},[_c('k-form-address',{attrs:{"size":"sm","with-road3":_vm.withRoad3,"countries-list":_vm.countries},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}})],1)],1)],1)],1),_c('h2',{staticClass:"form-title pb-1 mb-0"},[_vm._v(" "+_vm._s(_vm.termText('construction.form.contents', 'chantier'))+" ")]),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"5","order":"2","order-md":"1"}},[_c('CatalogSearch',{staticStyle:{"flex":"1 1 auto"},attrs:{"size":"sm","filters":{ not_for_sale: 0 },"include":{
          product: ['unit', 'vat_rate', 'variation_levels', 'default_picture', 'custom_prices'],
          service: ['unit', 'vat_rate', 'default_picture', 'custom_prices']
        }},on:{"selected":element => _vm.addCatalogLine(element)}})],1),_c('b-col',{staticClass:"mb-2 mb-md-0",attrs:{"cols":"12","md":"7","order":"1","order-md":"2"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addEmptyLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.emptyLine'))+" ")])],1)],1),_c('table',{staticClass:"table table-sm table-bordered mt-1 table-document-content text-nowrap"},[_c('thead',{staticClass:"thead-dark small text-center"},[_c('tr',[_c('th',{staticStyle:{"width":"18px"}}),_c('th',{staticStyle:{"width":"100px"}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.columns.reference'))+" ")]),_c('th',{staticClass:"text-left"},[_vm._v("Désignation")]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Quantité")]),_c('th',{staticStyle:{"width":"21px"}})])]),(_vm.construction.contents.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"4"}},[_vm._v(" "+_vm._s(_vm.termText('construction.form.contentsEmpty', 'chantier'))+" ")])])]):_c('draggable',{ref:"draggable",attrs:{"list":_vm.construction.contents,"handle":".draggable-handle","tag":"tbody"},on:{"start":_vm.startDragging,"end":_vm.stopDragging}},_vm._l((_vm.construction.contents),function(content,i){return _c('tr',{key:i},[_c('td',[(_vm.construction.contents.length > 1)?_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}}):_vm._e(),(content.id)?_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][id]'},domProps:{"value":content.id}}):_vm._e()],1),_c('td',[_c('k-form-input',{attrs:{"name":'contents[' + i + '][reference]',"size":"sm"},model:{value:(_vm.construction.contents[i].reference),callback:function ($$v) {_vm.$set(_vm.construction.contents[i], "reference", $$v)},expression:"construction.contents[i].reference"}})],1),_c('td',{staticClass:"text-wrap"},[_c('k-form-editor',{attrs:{"name":'contents[' + i + '][designation]',"size":"sm","required":"","config":_vm.editorConfig},model:{value:(_vm.construction.contents[i].designation),callback:function ($$v) {_vm.$set(_vm.construction.contents[i], "designation", $$v)},expression:"construction.contents[i].designation"}}),_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.duration'),"label-size":"sm"}},[_c('b-input-group',{attrs:{"size":"sm"}},[_c('k-form-number',{staticStyle:{"width":"50px"},attrs:{"name":'contents[' + i + '][duration]',"min":0,"size":"sm"},model:{value:(_vm.construction.contents[i].duration),callback:function ($$v) {_vm.$set(_vm.construction.contents[i], "duration", $$v)},expression:"construction.contents[i].duration"}}),_c('b-input-group-append',[_c('k-form-select',{staticClass:"document-small-select",staticStyle:{"width":"70px"},attrs:{"name":'contents[' + i + '][duration_type]',"options":[
                        { id: 'minute', label: _vm.$t('sales.form.lines.durationMinute') },
                        { id: 'hour', label: _vm.$t('sales.form.lines.durationHour') },
                      ],"reduce":opt => opt.id,"clearable":false,"value":"Mn","size":"sm"},model:{value:(_vm.construction.contents[i].duration_type),callback:function ($$v) {_vm.$set(_vm.construction.contents[i], "duration_type", $$v)},expression:"construction.contents[i].duration_type"}})],1)],1)],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('sales.form.lines.technicalNumber'),"label-size":"sm"}},[_c('k-form-spinner',{attrs:{"name":'contents[' + i + '][number_people_needed]',"min":0,"size":"sm"},model:{value:(_vm.construction.contents[i].number_people_needed),callback:function ($$v) {_vm.$set(_vm.construction.contents[i], "number_people_needed", $$v)},expression:"construction.contents[i].number_people_needed"}})],1)],1)],1)],1),_c('td',[_c('k-form-spinner',{attrs:{"name":'contents[' + i + '][quantity]',"size":"sm"},model:{value:(_vm.construction.contents[i].quantity),callback:function ($$v) {_vm.$set(_vm.construction.contents[i], "quantity", $$v)},expression:"construction.contents[i].quantity"}})],1),_c('td',[(content.catalog)?_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][catalog][type]'},domProps:{"value":content.catalog.type}}):_vm._e(),(content.catalog)?_c('input',{attrs:{"type":"hidden","name":'contents[' + i + '][catalog][id]'},domProps:{"value":content.catalog.id}}):_vm._e(),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0",attrs:{"variant":"link","title":"Supprimer la ligne"}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){return _vm.deleteLine(i)}}})],1)],1)])}),0)],1),(_vm.construction.contents.length > 5)?_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"5","order":"2","order-md":"1"}},[_c('CatalogSearch',{staticStyle:{"flex":"1 1 auto"},attrs:{"size":"sm","filters":{ not_for_sale: 0 },"include":{
          product: ['unit', 'vat_rate', 'variation_levels', 'default_picture', 'custom_prices'],
          service: ['unit', 'vat_rate', 'default_picture', 'custom_prices']
        }},on:{"selected":element => _vm.addCatalogLine(element)}})],1),_c('b-col',{staticClass:"mb-2 mb-md-0",attrs:{"cols":"12","md":"7","order":"1","order-md":"2"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addEmptyLine()}}},[_vm._v(" "+_vm._s(_vm.$t('sales.form.emptyLine'))+" ")])],1)],1):_vm._e(),_c('p',{staticClass:"pb-5"},[_c('br')]),_c('div',{staticClass:"p-2",attrs:{"id":"construction-form-sidebar"}},[_c('b-row',{staticClass:"text-center icon-menu mb-3"},[(_vm.rightSidebar && _vm.windowWidth < 900)?_c('b-col'):_vm._e(),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('catalog.command.form.sidebar.sidebarPosition')},on:{"click":function($event){$event.preventDefault();return _vm.changeSidebarMode.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'window-alt']}})],1)],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ boundary: 'window' }),expression:"{ boundary: 'window' }"}],attrs:{"title":_vm.$t('catalog.command.form.sidebar.fullscreen')},on:{"click":function($event){$event.preventDefault();return _vm.setFullscreenMode(!_vm.fullscreenMode)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'expand-alt']}})],1)],1),(_vm.rightSidebar && _vm.windowWidth < 900)?_c('b-col'):_vm._e()],1),_c('table',{staticClass:"table-totals"},[_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" Durée totale ")]),_vm._v(" "+_vm._s(_vm.totalDuration)+" ")])]),_c('tr',[_c('td',[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" Personnes nécessaires ")]),_vm._v(" "+_vm._s(_vm.nbPeople)+" ")])])]),_c('div',{class:{ submit: true, 'text-center': _vm.rightSidebar && _vm.windowWidth < 900 }},[_c('b-button',{staticClass:"my-3 ml-3",attrs:{"type":"submit","variant":"primary"}},[(!_vm.construction.id)?[_vm._v(" Créer le chantier ")]:[_vm._v(" Modifier ")]],2)],1)],1)],1)],1)
}
var ConstructionFormvue_type_template_id_01c75091_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/maxBy.js
var maxBy = __webpack_require__(7551);
var maxBy_default = /*#__PURE__*/__webpack_require__.n(maxBy);
// EXTERNAL MODULE: ./node_modules/lodash/sumBy.js
var sumBy = __webpack_require__(1126);
var sumBy_default = /*#__PURE__*/__webpack_require__.n(sumBy);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
;// external "@kwixeo/catalog-vue"
var catalog_vue_namespaceObject = require("@kwixeo/catalog-vue");
;// external "vuedraggable"
var external_vuedraggable_namespaceObject = require("vuedraggable");
var external_vuedraggable_default = /*#__PURE__*/__webpack_require__.n(external_vuedraggable_namespaceObject);
// EXTERNAL MODULE: external "@kwixeo/sales-vue"
var sales_vue_ = __webpack_require__(2779);
// EXTERNAL MODULE: ./node_modules/froala-editor/js/froala_editor.min.js
var froala_editor_min = __webpack_require__(2993);
var froala_editor_min_default = /*#__PURE__*/__webpack_require__.n(froala_editor_min);
;// ./src/components/ConstructionForm/editorConfig.ts

var buttons = [
    'bold',
    'italic',
    'underline',
    '|',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    '|',
    'fontSize',
    '|',
    'textColor',
    'backgroundColor',
    '|',
    'formatUL',
    'formatOL'
];
var moreMisc = {
    buttons: ['undo', 'redo', 'html'],
    align: 'right',
    buttonsVisible: 0
};
var config = {
    enter: (froala_editor_min_default()).ENTER_BR,
    fontSizeUnit: 'pt',
    listAdvancedTypes: false,
    quickInsertEnabled: false,
    pasteDeniedAttrs: ['class', 'id'],
    pastePlain: false,
    htmlAllowedStyleProps: ['font-size', 'background', 'color', 'text-align', 'vertical-align', 'background-color'],
    toolbarButtonsXS: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 0,
        },
        moreMisc: moreMisc
    },
    toolbarButtonsSM: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 4,
        }
    },
    toolbarButtonsMD: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 5,
        }
    },
    toolbarButtons: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 12
        },
        moreMisc: moreMisc
    },
    events: {
        'paste.afterCleanup': function (content) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            var tbody = this.$el.closest('tbody');
            if (tbody.length > 0 && tbody[0].classList.contains('dragging')) {
                return '';
            }
            return content.replaceAll(/<br([^>])+?>/gi, '<br>')
                .replaceAll(/font-size: ?([\d.]+)px/gi, 'font-size: $1pt');
        }
    }
};
/* harmony default export */ var editorConfig = (config);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionForm/ConstructionForm.ts?vue&type=script&lang=ts&external
















var ConstructionForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionForm, _super);
    function ConstructionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.editorConfig = editorConfig;
        _this.loading = false;
        _this.construction = {
            contents: []
        };
        _this.address = {};
        _this.rightSidebar = true;
        return _this;
    }
    ConstructionForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadCountries()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        this.rightSidebar = !(localStorage.getItem('construction-form-right-sidebar') !== 'true');
                        this.setSidebarMode();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ConstructionForm.prototype, "formAction", {
        get: function () {
            var url = '/construction';
            if (this.construction.id) {
                url += '/' + this.construction.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionForm.prototype, "formMethod", {
        get: function () {
            return this.construction.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionForm.prototype, "totalDuration", {
        get: function () {
            var _this = this;
            var minutes = sumBy_default()(this.construction.contents, function (content) {
                var _a, _b;
                var unitDuration = 0;
                if (content.duration_type === 'hour') {
                    unitDuration = _this.number((_a = content.duration) !== null && _a !== void 0 ? _a : 0) * 60;
                }
                else {
                    unitDuration = (_b = content.duration) !== null && _b !== void 0 ? _b : 0;
                }
                return _this.roundNumber(_this.number(unitDuration) * _this.number(content.quantity), 2);
            });
            if (minutes < 60) {
                return minutes + 'mn';
            }
            var hour = Math.floor(minutes / 60);
            var staymn = minutes - (hour * 60);
            return hour.toString().padStart(2, '0') + 'h' + staymn.toString().padStart(2, '0');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionForm.prototype, "nbPeople", {
        get: function () {
            var _a, _b;
            return (_b = (_a = maxBy_default()(this.construction.contents, function (content) { var _a; return (_a = content.number_people_needed) !== null && _a !== void 0 ? _a : 0; })) === null || _a === void 0 ? void 0 : _a.number_people_needed) !== null && _b !== void 0 ? _b : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionForm.prototype, "pageTitle", {
        get: function () {
            var _a;
            return (0,utils_text/* termText */.a)('construction.' + (this.construction.id ? 'editTitle' : 'newTitle'), 'chantier', false, { reference: (_a = this.construction) === null || _a === void 0 ? void 0 : _a.reference });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionForm.prototype, "withRoad3", {
        get: function () {
            return this.address.road1 !== null && this.address.road1 !== '' && this.address.road1 !== undefined
                && this.address.road2 !== null && this.address.road2 !== '' && this.address.road2 !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    ConstructionForm.prototype.watchValue = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        this.construction = this.value ? JSON.parse(JSON.stringify(this.value)) : {
            contents: []
        };
        this.address = {
            road1: (_a = this.construction) === null || _a === void 0 ? void 0 : _a.road1,
            road2: (_b = this.construction) === null || _b === void 0 ? void 0 : _b.road2,
            road3: (_c = this.construction) === null || _c === void 0 ? void 0 : _c.road3,
            postal_code: (_d = this.construction) === null || _d === void 0 ? void 0 : _d.postal_code,
            town: (_e = this.construction) === null || _e === void 0 ? void 0 : _e.town,
            country: (_g = (_f = this.construction) === null || _f === void 0 ? void 0 : _f.country) !== null && _g !== void 0 ? _g : null
        };
    };
    ConstructionForm.prototype.addCatalogLine = function (element) {
        var product = element.data;
        this.construction.contents.push({
            catalog: {
                type: element.type,
                id: product.id,
                element: product
            },
            reference: product.reference,
            designation: product.designation,
            number_people_needed: 'number_people_needed' in product ? product.number_people_needed : 0,
            duration: 'duration' in product ? product.duration : 0,
            duration_type: 'duration_type' in product ? product.duration_type : 'minute',
            quantity: element.type === 'group' ? 1 : this.number(product.default_quantity)
        });
    };
    ConstructionForm.prototype.addEmptyLine = function () {
        this.construction.contents.push({
            duration: 0,
            duration_type: 'minute',
            quantity: 1
        });
    };
    ConstructionForm.prototype.deleteLine = function (index) {
        this.construction.contents.splice(index, 1);
    };
    ConstructionForm.prototype.startDragging = function () {
        var _a;
        ((_a = this.$refs.draggable) === null || _a === void 0 ? void 0 : _a.$el).classList.add('dragging');
    };
    ConstructionForm.prototype.stopDragging = function () {
        var _a;
        ((_a = this.$refs.draggable) === null || _a === void 0 ? void 0 : _a.$el).classList.remove('dragging');
    };
    ConstructionForm.prototype.changeSidebarMode = function () {
        this.rightSidebar = !this.rightSidebar;
        this.setSidebarMode();
    };
    ConstructionForm.prototype.watchWindowWidth = function () {
        this.setSidebarMode();
    };
    ConstructionForm.prototype.setSidebarMode = function () {
        localStorage.setItem('construction-form-right-sidebar', String(this.rightSidebar));
        this.setDynamicAppClass({
            'construction-form-sidebar': this.rightSidebar && this.windowWidth >= 900,
            'construction-form-bottombar': !this.rightSidebar || this.windowWidth < 900
        });
    };
    ConstructionForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({ name: 'construction-item', params: { id: String(response.data.id) } })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionForm.prototype.selectCustomer = function (customer) {
        var _this = this;
        var _a;
        this.$nextTick(function () {
            _this.construction.contact = null;
        });
        if (!customer || (!customer.address_delivery && !customer.address_invoice)) {
            return;
        }
        this.selectAddress((_a = customer.address_delivery) !== null && _a !== void 0 ? _a : customer.address_invoice);
    };
    ConstructionForm.prototype.selectAddress = function (address) {
        this.address.road1 = address.road1;
        this.address.road2 = address.road2;
        this.address.road3 = address.road3;
        this.address.postal_code = address.postal_code;
        this.address.town = address.town;
        this.address.country = address.country;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ConstructionForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('windowWidth')
    ], ConstructionForm.prototype, "watchWindowWidth", null);
    ConstructionForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BFormRow: external_bootstrap_vue_.BFormRow, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormAddress: form_vue_.KFormAddress, KFormEditor: form_vue_.KFormEditor, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormSpinner: form_vue_.KFormSpinner,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                CatalogSearch: catalog_vue_namespaceObject.CatalogSearch,
                CustomerAddressSelect: sales_vue_.CustomerAddressSelect,
                PageHeader: interface_vue_.PageHeader, TagSelect: interface_vue_.TagSelect, Spinner: interface_vue_.Spinner, AppMessages: interface_vue_.AppMessages,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                draggable: (external_vuedraggable_default()),
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['fullscreenMode', 'windowWidth'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])), (0,external_vuex_.mapState)('globalDatas', ['countries'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setFullscreenMode', 'setDynamicAppClass', 'setPageParams'])), (0,external_vuex_.mapActions)('globalDatas', ['loadCountries'])), { termText: utils_text/* termText */.a })
        })
    ], ConstructionForm);
    return ConstructionForm;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var ConstructionFormvue_type_script_lang_ts_external = (ConstructionForm);

;// ./src/components/ConstructionForm/ConstructionForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionForm_ConstructionFormvue_type_script_lang_ts_external = (ConstructionFormvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionForm/ConstructionForm.vue





/* normalize component */
;
var ConstructionForm_component = (0,componentNormalizer/* default */.A)(
  ConstructionForm_ConstructionFormvue_type_script_lang_ts_external,
  ConstructionFormvue_type_template_id_01c75091_render,
  ConstructionFormvue_type_template_id_01c75091_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionForm_ConstructionForm = (ConstructionForm_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionItem/ConstructionItem.vue?vue&type=template&id=68ea84af
var ConstructionItemvue_type_template_id_68ea84af_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"document-item"},[(_vm.loading)?_c('Spinner'):[_c('PageHeader',{attrs:{"page-title":_vm.pageTitle,"buttons":_vm.headerButtons}},[_c('b-col',{staticClass:"col text-md-right text-center mt-md-1 mt-2",attrs:{"cols":"12","md":""}},[_c('ul',{staticClass:"status-bar w-auto d-inline-block"},_vm._l((_vm.availableStatus),function(status){return _c('li',{key:status.value,class:{
              selected: status.value === _vm.value.status
            }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0),(_vm.value.quotations && _vm.value.quotations.length > 0 && !_vm.can('constructionInterface', 1))?_c('div',{staticClass:"text-right construction-invoice-status"},[_c('ul',{staticClass:"status-bar w-auto d-inline-block"},_vm._l((_vm.availableInvoiceStatus),function(status){return _c('li',{key:status.value,class:{
                selected: status.value === _vm.value.invoice_status
              }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0)]):_vm._e()])],1),_c('AppMessages'),_c('b-row',{staticClass:"mb-1",attrs:{"no-gutters":"","align-v":"center"}},[_c('b-col',[(_vm.value.title)?_c('h2',[_vm._v(" "+_vm._s(_vm.value.title)+" ")]):_vm._e()])],1),(_vm.app.electronic_sign_status && !_vm.signed && _vm.can('sales-signatures', 1) && _vm.can('construction', 2))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
        title: _vm.signSendTitle
      }),expression:"{\n        title: signSendTitle\n      }"}],staticClass:"d-inline-block mb-2"},[_c('SignSend',{staticClass:"mr-2",attrs:{"size":"sm","variant":"primary","value":{
          documents: [
            {
              document_type: 'construction',
              document_id: _vm.value.id,
              document: _vm.value,
              file: _vm.value.pdf,
              signable_document: _vm.value?.can_be_signed
            }
          ]
        },"disabled":_vm.signSendTitle !== null,"withDirectSign":""},on:{"sended":_vm.sended}})],1):_vm._e(),(_vm.app.electronic_sign_status && _vm.value?.signatures)?_c('SignState',{attrs:{"signatures":_vm.value.signatures},on:{"signed":state => _vm.signed = state,"waiting":state => _vm.waitingSign = state}}):_vm._e(),_c('b-row',{staticClass:"document-elements",attrs:{"align-v":"stretch"}},[_c('b-col',{attrs:{"lg":"4","xxl":"3"}},[_c('b-card',[(_vm.value.tags.length > 0)?_c('div',{staticClass:"mb-3"},_vm._l((_vm.value.tags),function(tag,i){return _c('b-badge',{key:i,class:{
                'px-2': true,
                'py-1': true,
                'mb-1': true,
                'ml-1': i > 0
              },attrs:{"variant":"tag"}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1):_vm._e(),_c('b-form-group',{attrs:{"label":"Client"}},[(_vm.value.customer)?_c('CustomerSpeedItem',{model:{value:(_vm.value.customer),callback:function ($$v) {_vm.$set(_vm.value, "customer", $$v)},expression:"value.customer"}}):_c('span',[_vm._v(" Client supprimé ")])],1),(_vm.value.contact)?_c('b-form-group',{attrs:{"label":"Contact"}},[_c('ContactSpeedItem',{model:{value:(_vm.value.contact),callback:function ($$v) {_vm.$set(_vm.value, "contact", $$v)},expression:"value.contact"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Date de création"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.created_at))+" ")]),(_vm.value.road1 || _vm.value.road2 || _vm.value.road3 || _vm.value.postal_code || _vm.value.town || _vm.value.country)?_c('b-form-group',{attrs:{"label":_vm.termText('construction.form.address', 'chantier')}},[(_vm.value.road1)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.road1))]):_vm._e(),(_vm.value.road2)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.road2))]):_vm._e(),(_vm.value.road3)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.road3))]):_vm._e(),_vm._v(" "+_vm._s(_vm.value.postal_code)+" "+_vm._s(_vm.value.town)+" "),(_vm.value.country)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.value.country.name))]):_vm._e()]):_vm._e(),_c('b-form-group',{attrs:{"label":"Durée planifiée"}},[_vm._v(" "+_vm._s(_vm.parseDuration(_vm.value.real_duration))+" ")]),(_vm.value.custom_fields && _vm.value.custom_fields.length > 0 && !_vm.team.configs['custom_field_construction_tab'])?_c('CustomFieldsDisplay',{attrs:{"type":"construction","value":_vm.value.custom_fields,"titleClass":"form-title-alt"}}):_vm._e()],1),_c('b-row',{staticClass:"text-center my-4 my-2 document-totals mx-0 font-weight-bold"},[_c('b-col',{attrs:{"cols":"5"}},[_c('small',[_vm._v("Durée totale")]),_c('br'),_vm._v(" "+_vm._s(_vm.duration(_vm.value.total_duration_hour))+" ")]),_c('b-col',{attrs:{"cols":"7"}},[_c('small',[_vm._v("Personnes nécessaires")]),_c('br'),_vm._v(" "+_vm._s(_vm.value.nb_people_needed)+" ")]),_c('b-col',{staticClass:"border-top text-danger",attrs:{"cols":"12"}},[_c('small',[_vm._v("Durée planifiée")]),_c('br'),_vm._v(" "+_vm._s(_vm.parseDuration(_vm.value.real_duration))+" ")])],1),(!_vm.can('constructionInterface', 1))?[_c('h3',{staticClass:"form-title-alt mb-0 border-bottom-0 mt-4"},[_vm._v("Documents liés")]),_c('b-card',[_c('AffairsList',{attrs:{"value":_vm.value},on:{"input":doc => _vm.$emit('input', doc)}})],1)]:_vm._e()],2),_c('b-col',{attrs:{"lg":"8","xxl":"9"}},[_c('h3',{staticClass:"form-title-alt mt-0 mb-0 border-0"},[_c('b-row',{attrs:{"align-v":"end"}},[_c('b-col',{staticClass:"pb-1",attrs:{"cols":"auto"}},[_vm._v(" "+_vm._s(_vm.uppercaseFirst(_vm.termText('planification.tabTitle', 'planning', true)))+" ")]),(_vm.can('construction', 3))?_c('b-col',[_c('PlanificationForm',{staticClass:"ml-3",attrs:{"size":"sm","variant":"primary","label":_vm.uppercaseFirst(_vm.termText('planification.newTitle', 'planning')),"construction":_vm.value}})],1):_vm._e()],1)],1),_c('b-card',[_c('PlanificationList',{attrs:{"construction":_vm.value}})],1),_c('tabs',{staticClass:"tabs-card mt-4"},[_c('tab',{attrs:{"title":_vm.termText('construction.form.contents', 'chantier')}},[_c('div',{staticClass:"table-md-responsive"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap"},[_c('thead',[_c('tr',{staticClass:"small"},[_c('th',{staticStyle:{"width":"100px"}},[_vm._v("Référence")]),_c('th',[_vm._v("Désignation")]),_c('th',{staticStyle:{"width":"75px"}},[_vm._v("Quantité")])])]),_c('tbody',_vm._l((_vm.value.contents),function(content,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-wrap"},[_vm._v(_vm._s(content.reference))]),_c('td',{staticClass:"text-wrap"},[_c('FroalaView',{attrs:{"value":content.designation}}),(content.total_duration_hour > 0 || content.number_people_needed > 0)?_c('p',{staticClass:"small mb-0 mt-2"},[(content.total_duration_hour > 0)?[_c('strong',[_vm._v("Durée :")]),_vm._v(" "+_vm._s(_vm.duration(content.total_duration_hour))+" ")]:_vm._e(),(content.total_duration_hour > 0 && content.number_people_needed > 0)?[_c('br')]:_vm._e(),(content.number_people_needed > 0)?[_c('strong',[_vm._v("Nb technicien :")]),_vm._v(" "+_vm._s(content.number_people_needed)+" ")]:_vm._e()],2):_vm._e()],1),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.showNumber(content.quantity))+" ")])])}),0)])])]),(_vm.teamConfigs.construction_active_contacts)?_c('tab',{attrs:{"title":"Contacts","lazy":""}},[_c('ConstructionContacts',{attrs:{"construction":_vm.value}})],1):_vm._e(),_c('tab',{attrs:{"title":"Éléments","lazy":""}},[_c('AgregateDatas',_vm._b({},'AgregateDatas',_vm.agregateProperties,false))],1),(_vm.value.custom_fields && _vm.value.custom_fields.length > 0 && _vm.team.configs['custom_field_construction_tab'])?_c('CustomFieldsDisplayTab',{attrs:{"type":"construction","value":_vm.value.custom_fields,"formUrl":'/construction/' + _vm.value.id,"component":"tab","canUpdate":_vm.can('construction', 3)},on:{"input":_vm.emitConstruction}}):_vm._e(),_c('tab',{attrs:{"title":"Produits"}},[_c('p',{staticClass:"text-center small"},[_vm._v(" Retrouvez ici, la liste des produits nécessaires à la réalisation des prestations du chantier ")]),(_vm.can('construction', 3))?_c('CatalogSearch',{staticClass:"mb-1",attrs:{"size":"sm","placeholder":"Rechercher un produit...","only":"product"},on:{"selected":_vm.addProduct}}):_vm._e(),_c('b-overlay',{attrs:{"show":_vm.productsLoading}},[_c('div',{staticClass:"table-responsive-sm"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap align-middle"},[_c('thead',[_c('tr',{staticClass:"small"},[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Nom du produit")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Qté")]),(_vm.can('construction', 3))?_c('th',{staticStyle:{"width":"26px"}}):_vm._e()])]),_c('tbody',[(_vm.products.length === 0)?_c('tr',[_c('td',{staticClass:"small p-3 text-center",attrs:{"colspan":"4"}},[_vm._v(" Aucun produit ")])]):_vm._l((_vm.products),function(product,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-wrap"},[_vm._v(_vm._s(product.product.reference))]),_c('td',{staticClass:"text-wrap"},[_vm._v(_vm._s(product.product.name))]),_c('td',{staticClass:"text-center"},[(_vm.can('construction', 3))?_c('k-form-spinner',{attrs:{"min":0,"size":"sm"},model:{value:(_vm.products[i].quantity),callback:function ($$v) {_vm.$set(_vm.products[i], "quantity", $$v)},expression:"products[i].quantity"}}):_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(_vm.products[i].quantity))+" ")])],1),(_vm.can('construction', 3))?_c('td',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Supprimer le produit' }),expression:"{ title: 'Supprimer le produit' }",modifiers:{"left":true}}],staticClass:"text-danger p-0",attrs:{"variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.deleteProduct(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1):_vm._e()])})],2)])])])],1),_c('tab',{attrs:{"title":"Matériels"}},[_c('p',{staticClass:"text-center small"},[_vm._v(" Retrouvez ici, la liste du matériel et des outils nécessaires à la réalisation du chantier ")]),(_vm.can('construction', 3))?_c('div',{staticClass:"catalog-search"},[_c('k-form-input',{staticClass:"mb-1",attrs:{"type":"search","placeholder":"Rechercher du matériel...","size":"sm"},on:{"input":_vm.searchMaterial},model:{value:(_vm.searchMaterialTerm),callback:function ($$v) {_vm.searchMaterialTerm=$$v},expression:"searchMaterialTerm"}}),_c('b-list-group',{ref:"list",staticClass:"position-absolute"},[(_vm.searchMaterialLoading)?_c('b-list-group-item',{staticClass:"text-center loading"},[_c('font-awesome-icon',{attrs:{"icon":['fad', 'spinner-third'],"spin":""}})],1):(_vm.searchMaterials)?[(_vm.searchMaterials.length === 0)?_c('b-list-group-item',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('catalog.catalogSearch.noResults'))+" ")]):_vm._e(),_vm._l((_vm.searchMaterials),function(result,i){return _c('b-list-group-item',{key:i,on:{"click":function($event){return _vm.addMaterial(result)}}},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(result.reference)+" -")]),_vm._v(" "+_vm._s(result.name)+" ")])})]:_vm._e()],2)],1):_vm._e(),_c('b-overlay',{attrs:{"show":_vm.materialsLoading}},[_c('div',{staticClass:"table-responsive-sm"},[_c('table',{staticClass:"table table-sm table-bordered text-nowrap align-middle"},[_c('thead',[_c('tr',{staticClass:"small"},[_c('th',[_vm._v("Référence")]),_c('th',[_vm._v("Nom du matériel")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"100px"}},[_vm._v("Qté")]),(_vm.can('construction', 3))?_c('th',{staticStyle:{"width":"26px"}}):_vm._e()])]),_c('tbody',[(_vm.materials.length === 0)?_c('tr',[_c('td',{staticClass:"small p-3 text-center",attrs:{"colspan":"4"}},[_vm._v(" Aucun matériel ")])]):_vm._l((_vm.materials),function(material,i){return _c('tr',{key:i},[_c('td',{staticClass:"text-wrap"},[_vm._v(_vm._s(material.material.reference))]),_c('td',{staticClass:"text-wrap"},[_vm._v(_vm._s(material.material.name))]),_c('td',{staticClass:"text-center"},[(_vm.can('construction', 3))?_c('k-form-spinner',{attrs:{"min":0,"size":"sm"},model:{value:(_vm.materials[i].quantity),callback:function ($$v) {_vm.$set(_vm.materials[i], "quantity", $$v)},expression:"materials[i].quantity"}}):_c('span',[_vm._v(" "+_vm._s(_vm.showNumber(_vm.materials[i].quantity))+" ")])],1),(_vm.can('construction', 3))?_c('td',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.left",value:({ title: 'Supprimer le matériel' }),expression:"{ title: 'Supprimer le matériel' }",modifiers:{"left":true}}],staticClass:"text-danger p-0",attrs:{"variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.deleteMaterial(i)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1):_vm._e()])})],2)])])])],1)],1)],1)],1)]],2)
}
var ConstructionItemvue_type_template_id_68ea84af_staticRenderFns = []


;// external "@kwixeo/communication-vue"
var communication_vue_namespaceObject = require("@kwixeo/communication-vue");
;// external "@kwixeo/calendars-vue"
var calendars_vue_namespaceObject = require("@kwixeo/calendars-vue");
// EXTERNAL MODULE: ./src/mixins/DurationMixin.ts
var DurationMixin = __webpack_require__(3790);
;// ./src/mixins/StatusMixin.ts


var StatusMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(StatusMixin, _super);
    function StatusMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.constructionStatus = [
            { label: 'À planifier', value: 1 },
            { label: 'Planifié partiellement', value: 2 },
            { label: 'Planifié', value: 3 },
            { label: 'Terminé', value: 4 }
        ];
        _this.planificationStatus = [
            { label: 'À faire', value: 1 },
            { label: 'Terminée', value: 2 }
        ];
        _this.invoiceStatus = [
            { label: 'À facturer', value: 1 },
            { label: 'Facturé partiellement', value: 2 },
            { label: 'Facturé', value: 3 },
        ];
        return _this;
    }
    StatusMixin = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], StatusMixin);
    return StatusMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_StatusMixin = (StatusMixin);

// EXTERNAL MODULE: ./src/components/PlanificationForm/PlanificationForm.vue + 3 modules
var PlanificationForm = __webpack_require__(3785);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PlanificationList/PlanificationList.vue?vue&type=template&id=44b7c1af
var PlanificationListvue_type_template_id_44b7c1af_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[(_vm.loading)?_c('Spinner'):[_c('k-table',{ref:"table",attrs:{"url":"/construction/planification","ajaxDatas":_vm.datas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowClick":_vm.rowClick,"stateKey":_vm.tableStateKey}}),(_vm.showModel)?_c('PlanificationItem',{on:{"hidden":function($event){_vm.showModel = null}},model:{value:(_vm.showModel),callback:function ($$v) {_vm.showModel=$$v},expression:"showModel"}}):_vm._e(),(_vm.updateModel)?_c('PlanificationForm',{attrs:{"element":"modal","modal":true},on:{"hidden":function($event){_vm.updateModel = null}},model:{value:(_vm.updateModel),callback:function ($$v) {_vm.updateModel=$$v},expression:"updateModel"}}):_vm._e(),(_vm.deleteModel)?_c('PlanificationDelete',{attrs:{"element":"modal","modal":true},on:{"hidden":function($event){_vm.deleteModel = null}},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}}):_vm._e(),(_vm.statusModel)?_c('PlanificationStatus',{attrs:{"element":"modal","modal":true},on:{"hidden":function($event){_vm.statusModel = null}},model:{value:(_vm.statusModel),callback:function ($$v) {_vm.statusModel=$$v},expression:"statusModel"}}):_vm._e(),(_vm.downloadModel)?_c('InterventionDownload',{attrs:{"type":"planification","element":"modal","modal":true},on:{"hidden":function($event){_vm.downloadModel = null}},model:{value:(_vm.downloadModel),callback:function ($$v) {_vm.downloadModel=$$v},expression:"downloadModel"}}):_vm._e()]],2)
}
var PlanificationListvue_type_template_id_44b7c1af_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/upperFirst.js
var upperFirst = __webpack_require__(5808);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: ./src/components/PlanificationDelete/PlanificationDelete.vue + 3 modules
var PlanificationDelete_PlanificationDelete = __webpack_require__(229);
// EXTERNAL MODULE: ./src/components/PlanificationStatus/PlanificationStatus.vue + 3 modules
var PlanificationStatus = __webpack_require__(6229);
// EXTERNAL MODULE: ./src/components/InterventionDownload/InterventionDownload.vue + 3 modules
var InterventionDownload = __webpack_require__(2172);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PlanificationList/PlanificationList.ts?vue&type=script&lang=ts&external















var PlanificationList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationList, _super);
    function PlanificationList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.showModel = null;
        _this.updateModel = null;
        _this.deleteModel = null;
        _this.statusModel = null;
        _this.downloadModel = null;
        return _this;
    }
    PlanificationList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.teamUser) return [3 /*break*/, 3];
                        this.loading = true;
                        return [4 /*yield*/, this.loadTechnicals()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        _a.label = 3;
                    case 3:
                        if (this.$route.query.planificationId) {
                            this.showModel = {
                                id: Number(this.$route.query.planificationId)
                            };
                            this.$router.replace({ query: {} });
                        }
                        interface_vue_.emitter.on('planificationCreated', this.planificationUpdated);
                        interface_vue_.emitter.on('planificationUpdated', this.planificationUpdated);
                        interface_vue_.emitter.on('planificationDeleted', this.planificationDeleted);
                        interface_vue_.emitter.on('planificationPdfGenerated', this.pdfGenerated);
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanificationList.prototype.destroyed = function () {
        interface_vue_.emitter.off('planificationCreated', this.planificationUpdated);
        interface_vue_.emitter.off('planificationUpdated', this.planificationUpdated);
        interface_vue_.emitter.off('planificationDeleted', this.planificationDeleted);
        interface_vue_.emitter.off('planificationPdfGenerated', this.pdfGenerated);
    };
    Object.defineProperty(PlanificationList.prototype, "datas", {
        get: function () {
            var filter = {};
            var include = ['construction', 'customFields', 'customer', 'contact', 'country'];
            if (this.customer) {
                filter.customer = this.customer.id;
            }
            if (this.contact) {
                filter.contact = this.contact.id;
            }
            if (this.construction) {
                filter.construction = this.construction.id;
            }
            if (this.teamUser) {
                filter.technician = {
                    type: 'teamUser',
                    id: this.teamUser.id
                };
            }
            else {
                include.push('technicians');
            }
            return {
                filter: filter,
                include: include
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [];
            if (!this.construction) {
                columns.push({
                    data: 'construction.reference',
                    name: (0,utils_text/* termText */.a)('construction.list.refererence', 'chantier')
                });
            }
            columns.push.apply(columns, [
                {
                    data: 'reference',
                    name: (0,utils_text/* termText */.a)('construction.list.refererence', 'planning'),
                    visible: false
                },
                {
                    data: 'begin',
                    name: 'Début',
                    render: 'datetime'
                },
                {
                    data: 'end',
                    name: 'Fin',
                    render: 'datetime'
                }
            ]);
            if (!this.customer && !this.construction) {
                columns.push({
                    data: 'construction.customer.name',
                    name: 'Client',
                    render: function (name, planification) {
                        var _a, _b;
                        if (!planification.construction) {
                            return (_b = (_a = planification.customer) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null;
                        }
                        return name;
                    }
                });
            }
            if (!this.contact && !this.construction) {
                columns.push({
                    data: 'construction.contact.fullname',
                    name: 'Contact',
                    render: function (name, planification) {
                        var _a, _b;
                        if (!planification.construction) {
                            return (_b = (_a = planification.contact) === null || _a === void 0 ? void 0 : _a.fullname) !== null && _b !== void 0 ? _b : null;
                        }
                        return name;
                    },
                    visible: false
                });
            }
            if (!this.construction) {
                columns.push.apply(columns, [
                    {
                        data: 'construction.title',
                        name: 'Titre'
                    },
                    {
                        data: 'construction.road1',
                        name: 'Rue',
                        render: function (road, planification) {
                            var _a;
                            if (!planification.construction) {
                                return (_a = planification.road1) !== null && _a !== void 0 ? _a : null;
                            }
                            return road;
                        },
                        visible: false
                    },
                    {
                        data: 'construction.road2',
                        name: 'Rue 2',
                        render: function (road, planification) {
                            var _a;
                            if (!planification.construction) {
                                return (_a = planification.road2) !== null && _a !== void 0 ? _a : null;
                            }
                            return road;
                        },
                        visible: false
                    },
                    {
                        data: 'construction.road3',
                        name: 'Rue 3',
                        render: function (road, planification) {
                            var _a;
                            if (!planification.construction) {
                                return (_a = planification.road3) !== null && _a !== void 0 ? _a : null;
                            }
                            return road;
                        },
                        visible: false
                    },
                    {
                        data: 'construction.postal_code',
                        name: 'Code postal',
                        render: function (road, planification) {
                            var _a;
                            if (!planification.construction) {
                                return (_a = planification.postal_code) !== null && _a !== void 0 ? _a : null;
                            }
                            return road;
                        }
                    },
                    {
                        data: 'construction.town',
                        name: 'Ville',
                        render: function (road, planification) {
                            var _a;
                            if (!planification.construction) {
                                return (_a = planification.town) !== null && _a !== void 0 ? _a : null;
                            }
                            return road;
                        }
                    }
                ]);
                if (!this.teamUser) {
                    columns.push({
                        data: 'technicians',
                        name: upperFirst_default()((0,utils_text/* termText */.a)('planification.tabTitle', 'technician', true)),
                        render: function (technicians) { return technicians.map(function (technician) { return technician.name; }).join(', '); },
                        sortable: false
                    });
                }
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'description',
                    name: 'Description',
                    render: 'textarea',
                    isHtml: true,
                    visible: false
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'status',
                    name: 'Statut',
                    render: function (val) { return _this.$t('constructions.planification.status.' + val); }
                },
                {
                    data: 'duration',
                    name: 'Durée',
                    render: function (duration) { return _this.parseDuration(duration); }
                }
            ], this.customFieldTableColumns('planification')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationList.prototype, "filters", {
        get: function () {
            var _this = this;
            var filters = [];
            if (!this.customer) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (!this.contact) {
                filters.push({
                    type: 'select',
                    label: 'Contact',
                    name: 'contact',
                    multiple: true,
                    ajax: '/customer/contact?sort=fullname',
                    optionLabel: 'fullname',
                    value: 'id'
                });
            }
            if (!this.construction) {
                filters.push({
                    type: 'text',
                    label: (0,utils_text/* termText */.a)('construction.list.refererence', 'chantier'),
                    name: 'construction_reference'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'text',
                    label: (0,utils_text/* termText */.a)('construction.list.refererence', 'planning'),
                    name: 'reference'
                },
                {
                    type: 'period',
                    label: 'Date',
                    name: 'begin',
                    name2: 'end'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: this.planificationStatus,
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'select',
                    label: upperFirst_default()((0,utils_text/* termText */.a)('planification.tabTitle', 'technician', true)),
                    name: 'technician',
                    options: this.allTechnicals,
                    optionLabel: 'name',
                    multiple: true,
                    params: {
                        getOptionKey: function (technician) { return technician.type + '-' + technician.id; }
                    },
                    value: function (technician) { return ({
                        id: technician.id,
                        type: technician.type
                    }); }
                }
            ], this.customFieldTableFilters('planification')).filter(function (filter) { return filter.name !== 'technician' || !_this.teamUser; }));
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationList.prototype, "tableStateKey", {
        get: function () {
            if (this.construction) {
                return 'constructions-planification-construction-list';
            }
            else if (this.customer) {
                return 'constructions-planification-customer-list';
            }
            else if (this.contact) {
                return 'constructions-planification-contact-list';
            }
            else if (this.teamUser) {
                return 'constructions-my-planification-list';
            }
            else {
                return 'contructions-planification-list';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('planificationStatus', 1)) {
                actions.push.apply(actions, [
                    {
                        icon: ['fas', 'check'],
                        title: 'Marquer comme terminée',
                        class: 'p-0',
                        condition: function (planification) { return planification.status === 1 && _this.can('construction', 3); },
                        click: function (planification) {
                            _this.statusModel = planification;
                        }
                    },
                    {
                        icon: ['fas', 'ban'],
                        title: 'Marquer comme à faire',
                        class: 'p-0',
                        condition: function (planification) { return planification.status === 2 && _this.can('construction', 3); },
                        click: function (planification) {
                            _this.statusModel = planification;
                        }
                    }
                ]);
            }
            if (!this.teamUser && this.can('construction', 3)) {
                actions.push.apply(actions, [
                    {
                        icon: ['fas', 'envelope'],
                        title: 'Envoyer une confirmation de planification',
                        class: 'p-0',
                        condition: function () { return _this.can('construction', 3); },
                        click: this.sendMail
                    }
                ]);
            }
            actions.push({
                icon: ['fas', 'file-invoice'],
                title: 'Fiche d\'intervention',
                class: 'p-0',
                condition: function (planification) {
                    return planification.document_status === 2;
                },
                click: function (planification) {
                    _this.downloadModel = planification;
                }
            });
            if (this.can('construction', 3)) {
                actions.push.apply(actions, [
                    {
                        icon: 'edit',
                        condition: function () { return _this.can('construction', 3); },
                        class: 'p-0',
                        click: function (planification) {
                            _this.updateModel = planification;
                        }
                    },
                    {
                        icon: 'delete',
                        condition: function () { return _this.can('construction', 4); },
                        class: 'p-0',
                        click: function (planification) {
                            _this.deleteModel = planification;
                        }
                    }
                ]);
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    PlanificationList.prototype.rowClick = function (row) {
        this.showModel = row;
    };
    PlanificationList.prototype.tableAccess = function (func) {
        var _this = this;
        var interval = setInterval(function () {
            if (_this.$refs.table) {
                func(_this.$refs.table);
                clearInterval(interval);
            }
        }, 50);
    };
    PlanificationList.prototype.planificationUpdated = function (planification) {
        this.tableAccess(function (table) {
            var index = table.getDatas().findIndex(function (data) { return data.id === planification.id; });
            if (index >= 0) {
                table.updateRow(index, planification);
            }
            else {
                table.addRow(planification);
            }
        });
    };
    PlanificationList.prototype.planificationDeleted = function (event) {
        this.tableAccess(function (table) {
            var index = table.getDatas().findIndex(function (data) { return data.id === event.planification.id; });
            if (index >= 0) {
                table.deleteRow(index);
            }
        });
    };
    PlanificationList.prototype.pdfGenerated = function (data) {
        this.tableAccess(function (table) {
            var datas = table.getDatas();
            var index = datas.findIndex(function (element) { return element.id === data.id; });
            if (index >= 0) {
                var planification = JSON.parse(JSON.stringify(datas[index]));
                planification.document_status = 2;
                table.updateRow(index, planification);
            }
        });
    };
    PlanificationList.prototype.sendMail = function (planification) {
        var construction = planification.construction;
        if (!construction) {
            return;
        }
        var elements = [
            {
                type: 'construction',
                id: construction.id,
                title: construction.reference,
                data: construction
            },
            {
                type: 'planification',
                id: planification.id,
                title: 'Planification du chantier n°' + construction.reference,
                data: planification
            }
        ];
        var customer = construction.customer;
        if (customer) {
            elements.push({
                type: 'customer',
                id: customer.id,
                title: customer.name,
                data: customer
            });
            var contact = construction.contact;
            if (contact) {
                elements.push({
                    type: 'contact',
                    id: contact.id,
                    title: contact.fullname,
                    data: contact
                });
            }
        }
        this.openMailForm({
            contact: construction === null || construction === void 0 ? void 0 : construction.contact,
            customer: construction === null || construction === void 0 ? void 0 : construction.customer,
            preload: 'planification_confirmation',
            mail: {
                elements: elements
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationList.prototype, "construction", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationList.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationList.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], PlanificationList.prototype, "teamUser", void 0);
    PlanificationList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_namespaceObject.KTable,
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner,
                PlanificationItem: PlanificationItem/* default */.A,
                PlanificationForm: PlanificationForm["default"],
                PlanificationDelete: PlanificationDelete_PlanificationDelete/* default */.A,
                PlanificationStatus: PlanificationStatus/* default */.A,
                InterventionDownload: InterventionDownload/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapGetters)('constructions', ['allTechnicals'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['openMailForm'])), (0,external_vuex_.mapActions)('constructions', ['loadTechnicals'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers']))
        })
    ], PlanificationList);
    return PlanificationList;
}((0,lib/* Mixins */.Xe)(mixins_StatusMixin, custom_fields_vue_.CustomFieldsTableMixin, DurationMixin/* default */.A)));
/* harmony default export */ var PlanificationListvue_type_script_lang_ts_external = (PlanificationList);

;// ./src/components/PlanificationList/PlanificationList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationList_PlanificationListvue_type_script_lang_ts_external = (PlanificationListvue_type_script_lang_ts_external); 
;// ./src/components/PlanificationList/PlanificationList.vue





/* normalize component */
;
var PlanificationList_component = (0,componentNormalizer/* default */.A)(
  PlanificationList_PlanificationListvue_type_script_lang_ts_external,
  PlanificationListvue_type_template_id_44b7c1af_render,
  PlanificationListvue_type_template_id_44b7c1af_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationList_PlanificationList = (PlanificationList_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionStatusSelector/ConstructionStatusSelector.vue?vue&type=template&id=4c7ac66e
var ConstructionStatusSelectorvue_type_template_id_4c7ac66e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"variant":_vm.variant},on:{"click":function($event){$event.preventDefault();return _vm.openModal.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.computedLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-only":_vm.errorMsg !== null,"ok-title":_vm.$t('interface.' + (_vm.errorMsg !== null ? 'close' : 'continue')),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.updateStatus},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):(_vm.errorMsg)?_c('div',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):[_c('div',{staticClass:"text-justify"},[_vm._v(" Modifier le "+_vm._s(_vm.termText('construction.statusEdit', 'chantier', false))+" à "),_c('k-form-select',{attrs:{"required":"","options":_vm.statusOptions,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1)]],2)],1)
}
var ConstructionStatusSelectorvue_type_template_id_4c7ac66e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionStatusSelector/ConstructionStatusSelector.ts?vue&type=script&lang=ts&external






var ConstructionStatusSelector = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionStatusSelector, _super);
    function ConstructionStatusSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.status = null;
        _this.modalState = false;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(ConstructionStatusSelector.prototype, "computedLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : (0,utils_text/* uppercaseFirst */.t)((0,utils_text/* termText */.a)('construction.statusEdit', 'chantier', false));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionStatusSelector.prototype, "statusOptions", {
        get: function () {
            var _this = this;
            return [
                { value: 1, label: 'À planifier' },
                { value: 3, label: 'Planifié' },
                { value: 4, label: 'Terminé' }
            ].filter(function (status) { return status.value !== _this.construction.status; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionStatusSelector.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionStatusSelector.prototype, "url", {
        // Return url for ajax query
        get: function () {
            return '/construction/' + this.construction.id;
        },
        enumerable: false,
        configurable: true
    });
    // Open modal
    ConstructionStatusSelector.prototype.openModal = function () {
        this.errorMsg = null;
        this.modalState = true;
        this.status = null;
        this.loading = false;
    };
    // Send ajax query
    ConstructionStatusSelector.prototype.updateStatus = function (bvModalEvt) {
        var _this = this;
        if (this.errorMsg) {
            return;
        }
        bvModalEvt.preventDefault();
        this.loading = true;
        this.$kwSales.axios.put(this.url, {
            status: this.status
        })
            .then(function (response) {
            _this.$emit('input', response.data);
            _this.modalState = false;
        })
            .catch(function (error) {
            _this.errorMsg = error.response.data.message;
            _this.loading = false;
            throw new Error(error);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ConstructionStatusSelector.prototype, "construction", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ConstructionStatusSelector.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionStatusSelector.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionStatusSelector.prototype, "variant", void 0);
    ConstructionStatusSelector = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: {
                termText: utils_text/* termText */.a
            },
            components: {
                Spinner: interface_vue_.Spinner,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], ConstructionStatusSelector);
    return ConstructionStatusSelector;
}(lib/* Vue */.lD));
/* harmony default export */ var ConstructionStatusSelectorvue_type_script_lang_ts_external = (ConstructionStatusSelector);

;// ./src/components/ConstructionStatusSelector/ConstructionStatusSelector.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionStatusSelector_ConstructionStatusSelectorvue_type_script_lang_ts_external = (ConstructionStatusSelectorvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionStatusSelector/ConstructionStatusSelector.vue





/* normalize component */
;
var ConstructionStatusSelector_component = (0,componentNormalizer/* default */.A)(
  ConstructionStatusSelector_ConstructionStatusSelectorvue_type_script_lang_ts_external,
  ConstructionStatusSelectorvue_type_template_id_4c7ac66e_render,
  ConstructionStatusSelectorvue_type_template_id_4c7ac66e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionStatusSelector_ConstructionStatusSelector = (ConstructionStatusSelector_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionContacts/ConstructionContacts.vue?vue&type=template&id=18cdc78c
var ConstructionContactsvue_type_template_id_18cdc78c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" Rattacher un contact ")]),_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('k-table',{ref:"table",attrs:{"url":_vm.url,"ajaxDatas":{ include: ['customer', 'contact'] },"columns":_vm.columns,"rowActions":_vm.rowActions,"stateKey":"construction-contact"}})],1),_c('FormModal',{attrs:{"title":"Rattacher un contact"},on:{"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":_vm.formUrl,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.contact.customer ? _vm.contact.customer.id : null}}),_c('CustomerSelect',{attrs:{"validationName":"customer","type":null},on:{"input":function($event){_vm.contact.contact = null}},model:{value:(_vm.contact.customer),callback:function ($$v) {_vm.$set(_vm.contact, "customer", $$v)},expression:"contact.customer"}}),_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.contact.contact ? _vm.contact.contact.id : null}}),_c('ContactSelect',{attrs:{"validationName":"contact","reduce":opt => opt.id,"customer":_vm.contact.customer,"include":['function', 'customers'],"selectLabel":opt => opt.fullname + (opt.function ? ' (' + opt.function.label + ')' : '')},on:{"input":_vm.onContactSelect},model:{value:(_vm.contact.contact),callback:function ($$v) {_vm.$set(_vm.contact, "contact", $$v)},expression:"contact.contact"}}),_c('b-form-group',{attrs:{"label":"Notes"}},[_c('k-form-textarea',{attrs:{"name":"comments"},model:{value:(_vm.contact.comments),callback:function ($$v) {_vm.$set(_vm.contact, "comments", $$v)},expression:"contact.comments"}})],1)],1)],1),(_vm.toDelete !== null)?_c('ConfirmModal',{attrs:{"message":"Êtes-vous sûr de vouloir délier le contact ?"},on:{"confirmed":_vm.deleteContact,"canceled":function($event){_vm.toDelete = null}}}):_vm._e()],1)
}
var ConstructionContactsvue_type_template_id_18cdc78c_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionContacts/ConstructionContacts.ts?vue&type=script&lang=ts&external









var ConstructionContacts = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionContacts, _super);
    function ConstructionContacts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.items = [];
        _this.toDelete = null;
        _this.contact = {
            customer: null,
            contact: null,
            comments: null
        };
        return _this;
    }
    Object.defineProperty(ConstructionContacts.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'customer',
                    name: 'Tiers',
                    sortableName: 'customer.name',
                    component: customers_vue_.CustomerSpeedItem,
                    attributes: {
                        class: 'kw-table-cell-value'
                    }
                },
                {
                    data: 'contact',
                    name: 'Contact',
                    sortableName: 'contact.fullname',
                    component: customers_vue_.ContactSpeedItem,
                    attributes: {
                        class: 'kw-table-cell-value'
                    }
                },
                {
                    data: 'contact.function.label',
                    name: 'Fonction'
                },
                {
                    data: 'contact.mobile',
                    name: 'Portable',
                    render: 'phone'
                },
                {
                    data: 'contact.phone',
                    name: 'Téléphone',
                    visible: false,
                    render: 'phone'
                },
                {
                    data: 'comments',
                    name: 'Notes',
                    visible: false,
                    render: 'textarea',
                    isHtml: true
                },
                {
                    data: 'contact.email',
                    name: 'Email',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionContacts.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    condition: function () { return _this.can('construction', 3); },
                    click: this.editElement
                },
                {
                    icon: 'delete',
                    condition: function () { return _this.can('construction', 4); },
                    click: function (contact) {
                        _this.toDelete = contact;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionContacts.prototype, "url", {
        get: function () {
            return '/construction/' + this.construction.id + '/contact';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionContacts.prototype, "formUrl", {
        get: function () {
            var _a;
            var url = this.url;
            if ((_a = this.contact) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.contact.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionContacts.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.contact) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionContacts.prototype, "table", {
        get: function () {
            return this.$refs.table;
        },
        enumerable: false,
        configurable: true
    });
    ConstructionContacts.prototype.onContactSelect = function (contact) {
        var _a;
        if (!this.contact.customer) {
            this.contact.customer = (_a = contact.customers[0]) !== null && _a !== void 0 ? _a : null;
        }
    };
    ConstructionContacts.prototype.submitComplete = function (response) {
        var contact = response.data;
        var index = this.table.getDatas().findIndex(function (field) { return field.id === contact.id; });
        if (index >= 0) {
            this.table.updateRow(index, contact);
        }
        else {
            this.table.addRow(contact);
        }
    };
    ConstructionContacts.prototype.editElement = function (contact) {
        this.contact = JSON.parse(JSON.stringify(contact));
        this.modalState = true;
    };
    ConstructionContacts.prototype.closeModal = function () {
        this.contact = {
            customer: null,
            contact: null,
            comments: null
        };
        this.modalState = false;
    };
    ConstructionContacts.prototype.deleteContact = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var id;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = (_a = this.toDelete) === null || _a === void 0 ? void 0 : _a.id;
                        this.loading = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.delete(this.formUrl + '/' + id).then(function () {
                                var index = _this.table.getDatas().findIndex(function (field) { return field.id === id; });
                                if (index >= 0) {
                                    _this.table.deleteRow(index);
                                }
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionContacts.prototype, "construction", void 0);
    ConstructionContacts = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BOverlay: external_bootstrap_vue_.BOverlay,
                FormModal: interface_vue_.FormModal, ConfirmModal: interface_vue_.ConfirmModal,
                KForm: form_vue_.KForm, KFormTextarea: form_vue_.KFormTextarea,
                KTable: table_vue_namespaceObject.KTable,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], ConstructionContacts);
    return ConstructionContacts;
}(lib/* Vue */.lD));
/* harmony default export */ var ConstructionContactsvue_type_script_lang_ts_external = (ConstructionContacts);

;// ./src/components/ConstructionContacts/ConstructionContacts.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionContacts_ConstructionContactsvue_type_script_lang_ts_external = (ConstructionContactsvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionContacts/ConstructionContacts.vue





/* normalize component */
;
var ConstructionContacts_component = (0,componentNormalizer/* default */.A)(
  ConstructionContacts_ConstructionContactsvue_type_script_lang_ts_external,
  ConstructionContactsvue_type_template_id_18cdc78c_render,
  ConstructionContactsvue_type_template_id_18cdc78c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionContacts_ConstructionContacts = (ConstructionContacts_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionItem/ConstructionItem.ts?vue&type=script&lang=ts&external























var ConstructionItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionItem, _super);
    function ConstructionItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.initialized = false;
        _this.products = [];
        _this.materials = [];
        _this.signed = false;
        _this.waitingSign = false;
        _this.productsTimeout = null;
        _this.productsLoading = false;
        _this.searchMaterialTimeout = null;
        _this.searchMaterialLoading = false;
        _this.searchMaterials = null;
        _this.searchMaterialTerm = null;
        _this.materialsTimeout = null;
        _this.materialsLoading = false;
        return _this;
    }
    ConstructionItem.prototype.mounted = function () {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.initialized = false;
                        this.loading = true;
                        return [4 /*yield*/, this.loadVatRates()];
                    case 1:
                        _c.sent();
                        this.loading = false;
                        this.products = Array.from((_a = this.value.products) !== null && _a !== void 0 ? _a : []);
                        this.materials = Array.from((_b = this.value.materials) !== null && _b !== void 0 ? _b : []);
                        this.$nextTick(function () {
                            _this.initialized = true;
                        });
                        interface_vue_.emitter.on('planificationCreated', this.planificationUpdated);
                        interface_vue_.emitter.on('planificationUpdated', this.planificationUpdated);
                        interface_vue_.emitter.on('planificationDeleted', this.planificationDeleted);
                        interface_vue_.emitter.on('constructionPdfGenerated', this.pdfGenerated);
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionItem.prototype.destroyed = function () {
        interface_vue_.emitter.off('planificationCreated', this.planificationUpdated);
        interface_vue_.emitter.off('planificationUpdated', this.planificationUpdated);
        interface_vue_.emitter.off('planificationDeleted', this.planificationDeleted);
        interface_vue_.emitter.off('constructionPdfGenerated', this.pdfGenerated);
    };
    ConstructionItem.prototype.pdfGenerated = function (data) {
        if (data.id === this.value.id) {
            var construction = JSON.parse(JSON.stringify(this.value));
            construction.document_status = 2;
            construction.can_be_signed = data.can_be_signed;
            this.emitConstruction(construction);
        }
    };
    Object.defineProperty(ConstructionItem.prototype, "quotation", {
        get: function () {
            var _a;
            if (((_a = this.value.quotations) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                return this.value.quotations[0];
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "availableInvoiceStatus", {
        get: function () {
            var _this = this;
            return this.invoiceStatus.filter(function (status) {
                return (_this.value.invoice_status === 2 && status.value === 2) || status.value !== 2;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "availableStatus", {
        get: function () {
            var _this = this;
            return this.constructionStatus.filter(function (status) {
                return (_this.value.status === 2 && status.value === 2) || status.value !== 2;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('construction', 3)) {
                actions.push({
                    label: this.$t('interface.edit'),
                    to: {
                        name: 'construction-form',
                        params: {
                            id: String(this.value.id)
                        }
                    }
                });
            }
            actions.push({
                component: InterventionDownload/* default */.A,
                attributes: {
                    value: this.value,
                    type: 'construction',
                    disabled: this.value.document_status !== 2
                }
            });
            if (this.hasModule('task') && this.can('task', 1)) {
                actions.push({
                    label: 'Tâche',
                    click: function () {
                        _this.openModal({
                            key: 'task-form',
                            value: {
                                elements: _this.linkedElements(true)
                            }
                        });
                    }
                });
            }
            var relations = [];
            if (this.can('send-mail', 1)) {
                relations.push(this.sendMailAction('dropdown'));
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_namespaceObject.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Compte-rendu',
                        customer: this.value.customer,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements()
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_namespaceObject.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Lettre',
                        customer: this.value.customer,
                        contact: this.value.contact,
                        linkedElements: this.linkedElements(),
                        preload: 'construction'
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_namespaceObject.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: 'Rendez-vous',
                        linkedElements: this.linkedElements(true)
                    }
                });
            }
            if (relations.length > 1) {
                actions.push.apply(actions, [
                    {
                        label: 'Relation',
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-mail', 1)) {
                actions.push(this.sendMailAction('button'));
            }
            var other = this.otherActions;
            if (other.length > 0) {
                actions.push({
                    label: 'Autres',
                    items: this.otherActions
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "sendMailAction", {
        get: function () {
            var _this = this;
            return function (btnType) {
                return {
                    component: communication_vue_namespaceObject.SendEmailButton,
                    attributes: {
                        linkedElements: _this.linkedElements(),
                        element: btnType,
                        preload: 'construction',
                        customer: _this.value.customer,
                        contact: _this.value.contact
                    }
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "otherActions", {
        get: function () {
            var _this = this;
            var actions = [];
            if (this.can('sales-quotation', 2)) {
                actions.push({
                    label: 'Créer un devis',
                    click: this.createQuotation
                });
            }
            if (this.can('construction', 3)) {
                actions.push({
                    component: ConstructionStatusSelector_ConstructionStatusSelector,
                    attributes: {
                        element: 'dropdown',
                        construction: this.value
                    },
                    events: {
                        input: this.emitConstruction
                    }
                });
            }
            if (this.can('sales-quotation', 2) && this.can('construction', 4)) {
                actions.push({ isSeparator: true });
            }
            if (this.can('construction', 2)) {
                actions.push({
                    label: 'Cloner',
                    click: this.cloneConstruction
                });
            }
            if (this.can('construction', 4)) {
                actions.push({
                    component: ConstructionDelete,
                    attributes: {
                        element: 'dropdown',
                        value: this.value
                    },
                    events: {
                        deleted: function () {
                            _this.$router.push({ name: 'construction-list' });
                        }
                    }
                });
            }
            return actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "pageTitle", {
        get: function () {
            return (0,utils_text/* uppercaseFirst */.t)((0,utils_text/* termText */.a)('construction.title', 'chantier', false, { reference: this.value.reference }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "linkedElements", {
        get: function () {
            var _this = this;
            return function (withCustomer) {
                if (withCustomer === void 0) { withCustomer = false; }
                var elements = [{
                        type: 'construction',
                        id: _this.value.id,
                        title: _this.pageTitle,
                        data: _this.value
                    }];
                var customer = _this.value.customer;
                if (withCustomer && customer) {
                    elements.push({
                        type: 'customer',
                        id: customer.id,
                        title: customer.name,
                        data: customer
                    });
                    var contact = _this.value.contact;
                    if (contact) {
                        elements.push({
                            type: 'contact',
                            id: contact.id,
                            title: contact.fullname,
                            data: contact
                        });
                    }
                }
                return elements;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "agregateProperties", {
        get: function () {
            return {
                type: 'construction',
                id: this.value.id,
                model: this.value,
                customer: this.value.customer,
                contact: this.value.contact,
                modelTitle: this.pageTitle,
                url: '/construction/' + this.value.id + '/aggregate-datas'
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionItem.prototype, "signSendTitle", {
        get: function () {
            if (this.waitingSign) {
                return 'Un demande de signature est déjà en attente';
            }
            switch (this.value.document_status) {
                case 0:
                case 1:
                    return 'Pdf en cours de génération';
                case 3:
                    return 'Erreur lors de la génération du PDF';
                default:
                    if (!this.value.can_be_signed) {
                        return 'Ce document ne peut pas être signé';
                    }
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    ConstructionItem.prototype.addProduct = function (entry) {
        var index = this.products.findIndex(function (product) { return product.product_id === entry.data.id; });
        if (index >= 0) {
            var product = this.products[index];
            product.quantity++;
        }
        else {
            this.products.push({
                product_id: entry.data.id,
                product: entry.data,
                quantity: 1
            });
        }
    };
    ConstructionItem.prototype.deleteProduct = function (index) {
        this.products.splice(index, 1);
    };
    ConstructionItem.prototype.productsUpdated = function () {
        if (!this.initialized) {
            return;
        }
        if (this.productsTimeout) {
            clearTimeout(this.productsTimeout);
            this.productsTimeout = null;
        }
        setTimeout(this.saveProducts, 1000);
    };
    ConstructionItem.prototype.saveProducts = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.productsLoading = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.put('/construction/' + this.value.id, {
                                products: this.products.map(function (product) { return ({
                                    product: product.product_id,
                                    quantity: product.quantity
                                }); })
                            })
                                .then(function (response) {
                                _this.productsLoading = false;
                                _this.emitConstruction(response.data);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionItem.prototype.emitConstruction = function (construction) {
        var _this = this;
        this.initialized = false;
        this.$emit('input', construction);
        this.$nextTick(function () {
            _this.initialized = true;
        });
    };
    ConstructionItem.prototype.searchMaterial = function () {
        if (this.searchMaterialTimeout) {
            clearTimeout(this.searchMaterialTimeout);
            this.searchMaterialTimeout = null;
        }
        if (!this.searchMaterialTerm) {
            this.searchMaterials = null;
            return;
        }
        setTimeout(this.processSearchMaterials, 500);
    };
    ConstructionItem.prototype.processSearchMaterials = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.searchMaterialLoading = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.get('/construction/material', {
                                params: {
                                    search: encodeURI('%' + this.searchMaterialTerm + '%'),
                                    sort: 'name:asc',
                                    per_page: 10
                                }
                            }).then(function (response) {
                                _this.searchMaterials = response.data.data;
                                _this.searchMaterialLoading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionItem.prototype.addMaterial = function (material) {
        var index = this.materials.findIndex(function (el) { return el.material_id === material.id; });
        if (index >= 0) {
            var el = this.materials[index];
            el.quantity++;
        }
        else {
            this.materials.push({
                material_id: material.id,
                material: material,
                quantity: 1
            });
        }
        this.searchMaterialTerm = null;
    };
    ConstructionItem.prototype.deleteMaterial = function (index) {
        this.materials.splice(index, 1);
    };
    ConstructionItem.prototype.materialsUpdated = function () {
        if (!this.initialized) {
            return;
        }
        if (this.materialsTimeout) {
            clearTimeout(this.materialsTimeout);
            this.materialsTimeout = null;
        }
        setTimeout(this.saveMaterials, 1000);
    };
    ConstructionItem.prototype.saveMaterials = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.materialsLoading = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.put('/construction/' + this.value.id, {
                                materials: this.materials.map(function (material) { return ({
                                    material: material.material_id,
                                    quantity: material.quantity
                                }); })
                            })
                                .then(function (response) {
                                _this.materialsLoading = false;
                                _this.emitConstruction(response.data);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionItem.prototype.planificationUpdated = function (planification) {
        if (planification.construction_id !== this.value.id) {
            return;
        }
        this.emitConstruction(planification.construction);
    };
    ConstructionItem.prototype.planificationDeleted = function (event) {
        if (event.construction.id !== this.value.id) {
            return;
        }
        this.emitConstruction(event.construction);
    };
    ConstructionItem.prototype.createQuotation = function () {
        var _a, _b, _c, _d, _e, _f;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var construction, delivery_address, billing_address, address;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        construction = this.value;
                        delivery_address = {
                            road: construction.road1,
                            road2: construction.road2,
                            road3: construction.road3,
                            city: construction.town,
                            postal_code: construction.postal_code,
                            country: construction.country
                        };
                        if (this.teamConfigs.construction_invoice_address && ((_a = construction.customer) === null || _a === void 0 ? void 0 : _a.address_invoice)) {
                            address = (_b = construction.customer) === null || _b === void 0 ? void 0 : _b.address_invoice;
                            billing_address = {
                                road: address.road1,
                                road2: address.road2,
                                road3: address.road3,
                                city: address.town,
                                postal_code: address.postal_code,
                                country: address.country
                            };
                        }
                        else {
                            billing_address = delivery_address;
                        }
                        this.setPageParams({
                            construction_id: construction.id,
                            customer: (_c = construction.customer) !== null && _c !== void 0 ? _c : null,
                            contact: (_d = construction.contact) !== null && _d !== void 0 ? _d : null,
                            title: construction.title,
                            tags: (_e = construction.tags) !== null && _e !== void 0 ? _e : [],
                            billing_address: billing_address,
                            delivery_address: delivery_address,
                            contents: ((_f = construction.contents) !== null && _f !== void 0 ? _f : []).map(function (content) {
                                var _a, _b, _c, _d;
                                var product = (_a = content.catalog) === null || _a === void 0 ? void 0 : _a.element;
                                var catalog_costs_u = 0;
                                var type = '';
                                switch ((_b = content.catalog) === null || _b === void 0 ? void 0 : _b.type) {
                                    case 'product':
                                    case 'group':
                                        catalog_costs_u = product && 'unit_buy_price_ht' in product ? _this.number(product.unit_buy_price_ht) : 0;
                                        type = 'product';
                                        break;
                                    case 'service':
                                        catalog_costs_u = product && 'products_costs' in product ? product.products_costs : 0;
                                        type = 'service';
                                        break;
                                }
                                return {
                                    is_comments: false,
                                    is_pagebreak: false,
                                    is_subtotal: false,
                                    catalog: product ? {
                                        type: type,
                                        id: product === null || product === void 0 ? void 0 : product.id,
                                        element: product
                                    } : null,
                                    picture: null,
                                    reference: content.reference,
                                    designation: content.designation,
                                    weight_unit: product && 'unit_weight' in product ? product.unit_weight : null,
                                    ean_code: product && 'ean_code' in product ? product.ean_code : null,
                                    unit_price_ht: ((_c = content.catalog) === null || _c === void 0 ? void 0 : _c.element) ? Number(content.catalog.element.unit_price_ht) : 0,
                                    unit_price_ttc: ((_d = content.catalog) === null || _d === void 0 ? void 0 : _d.element) ? Number(content.catalog.element.unit_price_ht) : 0,
                                    ecotax_u_ht: product && 'eco_tax_ht' in product ? _this.number(product.eco_tax_ht) : 0,
                                    ecotax_u_ttc: product && 'eco_tax_ttc' in product ? _this.number(product.eco_tax_ttc) : 0,
                                    catalog_costs_u: catalog_costs_u,
                                    various_costs_u: _this.number(product === null || product === void 0 ? void 0 : product.various_costs),
                                    hourly_person_cost: product && 'hourly_person_cost' in product ? product.hourly_person_cost : 0,
                                    number_people_needed: content.number_people_needed,
                                    duration: content.duration,
                                    duration_type: content.duration_type,
                                    quantity: content.quantity,
                                    unit: product === null || product === void 0 ? void 0 : product.unit,
                                    secondary_quantity: 1,
                                    vat_rate: (product === null || product === void 0 ? void 0 : product.vat_rate) ? product.vat_rate : _this.defaultVatRate,
                                    discount_value: 0,
                                    discount_type: 'pourcent',
                                    total_ht: 0,
                                    total_ttc: 0
                                };
                            })
                        });
                        return [4 /*yield*/, this.$router.push({ name: 'quotation-form' })];
                    case 1:
                        _g.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionItem.prototype.cloneConstruction = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams(this.value);
                        return [4 /*yield*/, this.$router.push({ name: 'construction-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionItem.prototype.sended = function (signature) {
        var planification = this.value;
        if (!planification.signatures) {
            planification.signatures = [];
        }
        planification.signatures.push(signature);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('products', { deep: true })
    ], ConstructionItem.prototype, "productsUpdated", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('materials', { deep: true })
    ], ConstructionItem.prototype, "materialsUpdated", null);
    ConstructionItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BBadge: external_bootstrap_vue_.BBadge, BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay, BListGroup: external_bootstrap_vue_.BListGroup, BListGroupItem: external_bootstrap_vue_.BListGroupItem,
                PageHeader: interface_vue_.PageHeader, Tabs: interface_vue_.Tabs, Tab: interface_vue_.Tab, AppMessages: interface_vue_.AppMessages,
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem, ContactSpeedItem: customers_vue_.ContactSpeedItem,
                FroalaView: form_vue_.FroalaView, KFormSpinner: form_vue_.KFormSpinner, KFormInput: form_vue_.KFormInput,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay, CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                AgregateDatas: communication_vue_namespaceObject.AgregateDatas,
                CatalogSearch: catalog_vue_namespaceObject.CatalogSearch,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                PlanificationForm: PlanificationForm["default"],
                PlanificationList: PlanificationList_PlanificationList,
                ConstructionDelete: ConstructionDelete,
                ConstructionContacts: ConstructionContacts_ConstructionContacts,
                AffairsList: AffairsList_AffairsList,
                SignSend: sales_vue_.SignSend, SignState: sales_vue_.SignState,
                Spinner: interface_vue_.Spinner
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('globalDatas', ['defaultVatRate'])), (0,external_vuex_.mapState)('app', ['app'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('app', ['setPageParams'])), (0,external_vuex_.mapActions)('globalDatas', ['loadVatRates'])), { termText: utils_text/* termText */.a, uppercaseFirst: utils_text/* uppercaseFirst */.t }),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], ConstructionItem);
    return ConstructionItem;
}((0,lib/* Mixins */.Xe)(mixins_StatusMixin, interface_vue_.NumberMixin, interface_vue_.DateMixin, DurationMixin/* default */.A)));
/* harmony default export */ var ConstructionItemvue_type_script_lang_ts_external = (ConstructionItem);

;// ./src/components/ConstructionItem/ConstructionItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionItem_ConstructionItemvue_type_script_lang_ts_external = (ConstructionItemvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionItem/ConstructionItem.vue





/* normalize component */
;
var ConstructionItem_component = (0,componentNormalizer/* default */.A)(
  ConstructionItem_ConstructionItemvue_type_script_lang_ts_external,
  ConstructionItemvue_type_template_id_68ea84af_render,
  ConstructionItemvue_type_template_id_68ea84af_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionItem_ConstructionItem = (ConstructionItem_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionList/ConstructionList.vue?vue&type=template&id=248ebcde
var ConstructionListvue_type_template_id_248ebcde_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[_c('k-table',{ref:"table",attrs:{"url":"/construction","ajaxDatas":_vm.datas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":_vm.tableStateKey}}),(_vm.deleteModel)?_c('ConstructionDelete',{attrs:{"element":"modal","modal":true},on:{"hidden":function($event){_vm.deleteModel = null}},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}}):_vm._e()],1)
}
var ConstructionListvue_type_template_id_248ebcde_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionList/ConstructionList.ts?vue&type=script&lang=ts&external










var ConstructionList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionList, _super);
    function ConstructionList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteModel = null;
        return _this;
    }
    ConstructionList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                interface_vue_.emitter.on('constructionDeleted', this.constructionDeleted);
                return [2 /*return*/];
            });
        });
    };
    ConstructionList.prototype.destroyed = function () {
        interface_vue_.emitter.off('constructionDeleted', this.constructionDeleted);
    };
    Object.defineProperty(ConstructionList.prototype, "datas", {
        get: function () {
            var filter = {};
            if (this.customer) {
                filter.customer = this.customer.id;
            }
            if (this.contact) {
                filter.contact = this.contact.id;
            }
            if (this.contactCustomerId) {
                filter.contact_customer = this.contactCustomerId;
            }
            if (this.contactContactId) {
                filter.contact_contact = this.contactContactId;
            }
            return {
                filter: filter,
                include: ['customer', 'contact', 'country', 'tags', 'customFields']
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionList.prototype, "columns", {
        get: function () {
            var _this = this;
            var columns = [
                {
                    data: 'reference',
                    name: (0,utils_text/* termText */.a)('construction.list.refererence', 'chantier')
                }
            ];
            if (!this.customer) {
                columns.push({
                    data: 'customer.name',
                    name: 'Client'
                });
            }
            if (!this.contact) {
                columns.push({
                    data: 'contact.name',
                    name: 'Contact'
                });
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'title',
                    name: 'Titre'
                },
                {
                    data: 'road1',
                    name: 'Rue'
                },
                {
                    data: 'road2',
                    name: 'Rue 2',
                    visible: false
                },
                {
                    data: 'road3',
                    name: 'Rue 3',
                    visible: false
                },
                {
                    data: 'postal_code',
                    name: 'Code postal'
                },
                {
                    data: 'town',
                    name: 'Ville'
                },
                {
                    data: 'real_duration',
                    name: 'Durée',
                    render: function (duration) { return _this.parseDuration(duration); }
                },
                {
                    data: 'created_at',
                    name: 'Date de création',
                    render: 'datetime'
                },
                {
                    data: 'status',
                    name: 'Statut',
                    render: function (status) { return _this.$t('constructions.construction.status.' + status); }
                },
                {
                    data: 'invoice_status',
                    name: 'Statut de facturation',
                    render: function (status) { return _this.$t('constructions.construction.invoiceStatus.' + status); }
                }
            ], this.customFieldTableColumns('construction')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionList.prototype, "filters", {
        get: function () {
            var filters = [];
            if (!this.customer) {
                filters.push({
                    type: 'select',
                    label: 'Client',
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (!this.contact) {
                filters.push({
                    type: 'select',
                    label: 'Contact',
                    name: 'contact',
                    multiple: true,
                    ajax: '/customer/contact?sort=fullname',
                    optionLabel: 'fullname',
                    value: 'id'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'period',
                    label: 'Date de création',
                    name: 'created_since',
                    name2: 'created_until'
                },
                {
                    type: 'select',
                    label: 'Statut',
                    name: 'status',
                    options: this.constructionStatus,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'text',
                    label: 'Référence',
                    name: 'reference'
                }
            ], this.customFieldTableFilters('construction')));
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionList.prototype, "tableStateKey", {
        get: function () {
            if (this.customer) {
                return 'constructions-customer-list';
            }
            else if (this.contact) {
                return 'constructions-contact-list';
            }
            else {
                return 'contructions-list';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    condition: function () { return _this.can('construction', 3); },
                    link: function (construction) { return ({
                        name: 'construction-form',
                        params: {
                            id: String(construction.id)
                        }
                    }); }
                },
                {
                    icon: 'delete',
                    condition: function () { return _this.can('construction', 4); },
                    click: function (construction) {
                        _this.deleteModel = construction;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ConstructionList.prototype.rowLink = function (row) {
        return {
            name: 'construction-item',
            params: {
                id: String(row.id)
            }
        };
    };
    ConstructionList.prototype.constructionDeleted = function (construction) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (val) { return val.id === construction.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionList.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionList.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionList.prototype, "contactCustomerId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ConstructionList.prototype, "contactContactId", void 0);
    ConstructionList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_namespaceObject.KTable,
                ConstructionDelete: ConstructionDelete
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], ConstructionList);
    return ConstructionList;
}((0,lib/* Mixins */.Xe)(mixins_StatusMixin, custom_fields_vue_.CustomFieldsTableMixin, DurationMixin/* default */.A)));
/* harmony default export */ var ConstructionListvue_type_script_lang_ts_external = (ConstructionList);

;// ./src/components/ConstructionList/ConstructionList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionList_ConstructionListvue_type_script_lang_ts_external = (ConstructionListvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionList/ConstructionList.vue





/* normalize component */
;
var ConstructionList_component = (0,componentNormalizer/* default */.A)(
  ConstructionList_ConstructionListvue_type_script_lang_ts_external,
  ConstructionListvue_type_template_id_248ebcde_render,
  ConstructionListvue_type_template_id_248ebcde_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionList_ConstructionList = (ConstructionList_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ConstructionParams/ConstructionParams.vue?vue&type=template&id=595dfe35
var ConstructionParamsvue_type_template_id_595dfe35_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[(_vm.loading)?_c('Spinner'):[(_vm.user.is_admin)?_c('div',{staticClass:"mb-3"},[_c('input',{attrs:{"type":"hidden","name":"configs[construction_active_contacts]"},domProps:{"value":_vm.localConfig.construction_active_contacts ? _vm.localConfig.construction_active_contacts : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.construction_active_contacts),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_active_contacts", $$v)},expression:"localConfig.construction_active_contacts"}},[_vm._v(" Activer la gestion des contacts sur les chantiers ")])],1):_vm._e(),_c('div',{staticClass:"accordion",attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-1",modifiers:{"accordion-1":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Processus des chantiers")])],1),_c('b-collapse',{attrs:{"id":"accordion-1","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Saisie de la main d'oeuvre lors de la rédaction des documents de vente (devis, bons de commande...)"}},[_c('k-form-select',{attrs:{"options":_vm.workforceEntries,"reduce":opt => opt.id,"clearable":false,"name":"configs[sales_workforce_entries]"},model:{value:(_vm.localConfig.sales_workforce_entries),callback:function ($$v) {_vm.$set(_vm.localConfig, "sales_workforce_entries", $$v)},expression:"localConfig.sales_workforce_entries"}})],1),_c('b-form-group',{attrs:{"label":"Création d'un chantier lors de l'acception d'un devis","description":"Il est toujours possible de créer manuellement un chantier depuis un devis"}},[_c('k-form-select',{attrs:{"options":_vm.constructionCreationOptions,"reduce":opt => opt.id,"clearable":false,"name":"configs[construction_automatic_creation]"},model:{value:(_vm.localConfig.construction_automatic_creation),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_automatic_creation", $$v)},expression:"localConfig.construction_automatic_creation"}})],1),_c('b-form-group',{attrs:{"label":"Validation des planifications"},scopedSlots:_vm._u([{key:"description",fn:function(){return [_vm._v(" La planification possède deux statuts : À faire et Terminé. Le statut peut être automatiquement modifié dans l'heure qui suit la fin de la planification ou en cliquant manuellement sur un bouton. ")]},proxy:true}])},[_c('k-form-select',{attrs:{"options":_vm.planificationValidation,"reduce":opt => opt.id,"clearable":false,"name":"configs[construction_planification_validation]"},model:{value:(_vm.localConfig.construction_planification_validation),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_validation", $$v)},expression:"localConfig.construction_planification_validation"}})],1),_c('b-form-group',{attrs:{"label":"Modèle d'email par défaut pour les confirmations de planification"}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_planification_confirmation]"},domProps:{"value":_vm.localConfig.communication_model_planification_confirmation ? _vm.localConfig.communication_model_planification_confirmation.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_planification_confirmation),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_planification_confirmation", $$v)},expression:"localConfig.communication_model_planification_confirmation"}})],1),_c('b-form-group',{attrs:{"label":"Création d'un devis à partir du chantier"}},[_c('input',{attrs:{"type":"hidden","name":"configs[construction_invoice_address]"},domProps:{"value":_vm.localConfig.construction_invoice_address ? _vm.localConfig.construction_invoice_address : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.construction_invoice_address),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_invoice_address", $$v)},expression:"localConfig.construction_invoice_address"}},[_vm._v(" Utiliser l'adresse de facturation du client au lieu de l'adresse du chantier ")])],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-2",modifiers:{"accordion-2":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Notifications des techniciens")])],1),_c('b-collapse',{attrs:{"id":"accordion-2","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-form-group',{attrs:{"label":"Envoi des notifications aux techniciens"}},[_c('k-form-select',{attrs:{"options":_vm.notificationOptions,"reduce":opt => opt.id,"clearable":false,"name":"configs[construction_send_planification]"},model:{value:(_vm.localConfig.construction_send_planification),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_send_planification", $$v)},expression:"localConfig.construction_send_planification"}})],1),(_vm.localConfig.construction_send_planification !== 0)?[_c('b-form-group',{attrs:{"label":"Jour(s) d'envoi des planifications"}},[_c('k-form-checkbox-group',{attrs:{"name":"configs[construction_send_planification_days][]"},model:{value:(_vm.localConfig.construction_send_planification_days),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_send_planification_days", $$v)},expression:"localConfig.construction_send_planification_days"}},_vm._l((_vm.days),function(day){return _c('k-form-checkbox',{key:day.id,attrs:{"value":day.id}},[_vm._v(" "+_vm._s(day.label)+" ")])}),1)],1),_c('b-form-group',{attrs:{"label":"Heure d'envoi des planifications"}},[_c('k-form-select',{attrs:{"options":_vm.notificationHoursOptions,"getOptionLabel":hour => hour.toString().padStart(2, '0') + 'h00',"clearable":false,"name":"configs[construction_send_planification_hour]"},model:{value:(_vm.localConfig.construction_send_planification_hour),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_send_planification_hour", $$v)},expression:"localConfig.construction_send_planification_hour"}})],1)]:_vm._e()],2)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-3",modifiers:{"accordion-3":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Numérotation des chantiers")])],1),_c('b-collapse',{attrs:{"id":"accordion-3","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-row',[_c('b-col',[_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap table-sm",attrs:{"bordered":"","responsive":""}},[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referencePrefix')))]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.construction_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_reference_prefix", $$v)},expression:"localConfig.construction_reference_prefix"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceTypeNumber')))]),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.construction_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_reference_mode", $$v)},expression:"localConfig.construction_reference_mode"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceNextNumber')))]),_c('td',[_c('k-form-number',{attrs:{"name":"configs[construction_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.construction_reference_mode !== 1},model:{value:(_vm.localConfig.construction_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_reference_number", $$v)},expression:"localConfig.construction_reference_number"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceLength')))]),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.construction_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_reference_length", $$v)},expression:"localConfig.construction_reference_length"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('interface.example')))]),_c('td',[_vm._v(_vm._s(_vm.constructionReferenceExample))])])])])],1),_c('b-col',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceDay')))])])])])],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-planification-reference",modifiers:{"accordion-planification-reference":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Numérotation des planifications")])],1),_c('b-collapse',{attrs:{"id":"accordion-planification-reference","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('b-row',[_c('b-col',[_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap table-sm",attrs:{"bordered":"","responsive":""}},[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referencePrefix')))]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_planification_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.construction_planification_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_reference_prefix", $$v)},expression:"localConfig.construction_planification_reference_prefix"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceTypeNumber')))]),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_planification_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.construction_planification_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_reference_mode", $$v)},expression:"localConfig.construction_planification_reference_mode"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceNextNumber')))]),_c('td',[_c('k-form-number',{attrs:{"name":"configs[construction_planification_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.construction_planification_reference_mode !== 1},model:{value:(_vm.localConfig.construction_planification_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_reference_number", $$v)},expression:"localConfig.construction_planification_reference_number"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceLength')))]),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_planification_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.construction_planification_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_reference_length", $$v)},expression:"localConfig.construction_planification_reference_length"}})],1)]),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('interface.example')))]),_c('td',[_vm._v(_vm._s(_vm.planificationReferenceExample))])])])])],1),_c('b-col',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('sales.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('sales.params.referenceDay')))])])])])],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-32",modifiers:{"accordion-32":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Interventions")])],1),_c('b-collapse',{attrs:{"id":"accordion-32","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('input',{attrs:{"type":"hidden","name":"configs[construction_show_planifications_customer]"},domProps:{"value":_vm.localConfig.construction_show_planifications_customer ? _vm.localConfig.construction_show_planifications_customer : false}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localConfig.construction_show_planifications_customer),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_show_planifications_customer", $$v)},expression:"localConfig.construction_show_planifications_customer"}},[_vm._v(" Afficher la liste des planifications sur la fiche client ")]),_c('b-form-group',{attrs:{"label":"Lors de la création d'une intervention :"}},[_c('input',{attrs:{"type":"hidden","name":"configs[construction_planification_auto_date]"},domProps:{"value":_vm.localConfig.construction_planification_auto_date ? _vm.localConfig.construction_planification_auto_date : false}}),_c('k-form-checkbox',{staticClass:"mb-3 mt-2",model:{value:(_vm.localConfig.construction_planification_auto_date),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_auto_date", $$v)},expression:"localConfig.construction_planification_auto_date"}},[_vm._v(" Renseigner automatiquement la date de début avec date du jour ")]),(_vm.localConfig.construction_planification_auto_date)?[_c('b-row',{staticClass:"mb-3",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[construction_planification_auto_begin]"},domProps:{"value":_vm.localConfig.construction_planification_auto_begin ? _vm.localConfig.construction_planification_auto_begin : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.construction_planification_auto_begin),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_auto_begin", $$v)},expression:"localConfig.construction_planification_auto_begin"}},[_vm._v(" Renseigner automatiquement l'heure de début avec l'heure actuelle plus ")])],1),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"auto"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"mn","size":"sm"}},[_c('k-form-spinner',{attrs:{"name":"configs[construction_planification_auto_begin_number]","size":"sm","max-decimals":0,"left":"","disabled":!_vm.localConfig.construction_planification_auto_begin},model:{value:(_vm.localConfig.construction_planification_auto_begin_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_auto_begin_number", $$v)},expression:"localConfig.construction_planification_auto_begin_number"}})],1)],1)],1),(_vm.localConfig.construction_planification_auto_begin)?[_c('input',{attrs:{"type":"hidden","name":"configs[construction_planification_auto_begin_round]"},domProps:{"value":_vm.localConfig.construction_planification_auto_begin_round ? _vm.localConfig.construction_planification_auto_begin_round : false}}),_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.localConfig.construction_planification_auto_begin_round),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_auto_begin_round", $$v)},expression:"localConfig.construction_planification_auto_begin_round"}},[_vm._v(" Arrondir l'heure de début à la dizaine inférieure ")]),_c('b-row',{staticClass:"mb-3",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[construction_planification_auto_end]"},domProps:{"value":_vm.localConfig.construction_planification_auto_end ? _vm.localConfig.construction_planification_auto_end : false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.construction_planification_auto_end),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_auto_end", $$v)},expression:"localConfig.construction_planification_auto_end"}},[_vm._v(" Renseigner automatiquement l'heure de fin avec l'heure de début plus ")])],1),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"auto"}},[_c('b-input-group',{staticStyle:{"width":"120px"},attrs:{"append":"mn","size":"sm"}},[_c('k-form-spinner',{attrs:{"name":"configs[construction_planification_auto_end_count]","size":"sm","max-decimals":0,"min":0,"left":"","disabled":!_vm.localConfig.construction_planification_auto_end},model:{value:(_vm.localConfig.construction_planification_auto_end_count),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_auto_end_count", $$v)},expression:"localConfig.construction_planification_auto_end_count"}})],1)],1)],1)]:_vm._e()]:_vm._e()],2),_c('h3',{staticClass:"form-title-alt mt-3"},[_vm._v(" Calcul de la durée des interventions ")]),_c('p',[_vm._v(" Les paramètres ci-dessous ne s'appliquent que lorsqu'une planification se déroule sur plusieurs jours. ")]),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Heure de début d'une journée"}},[_c('k-form-select',{attrs:{"options":_vm.planificationBeginHours,"name":"configs[construction_planification_begin_hour]","getOptionLabel":hour => hour.toString().padStart(2, '0') + 'h00',"clearable":false},model:{value:(_vm.localConfig.construction_planification_begin_hour),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_begin_hour", $$v)},expression:"localConfig.construction_planification_begin_hour"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Heure de fin d'une journée"}},[_c('k-form-select',{attrs:{"options":_vm.planificationEndHours,"name":"configs[construction_planification_end_hour]","getOptionLabel":hour => hour.toString().padStart(2, '0') + 'h00',"clearable":false},model:{value:(_vm.localConfig.construction_planification_end_hour),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_end_hour", $$v)},expression:"localConfig.construction_planification_end_hour"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":"Jours travaillés"}},[_c('k-form-checkbox-group',{attrs:{"name":"configs[construction_planification_days][]"},model:{value:(_vm.localConfig.construction_planification_days),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_planification_days", $$v)},expression:"localConfig.construction_planification_days"}},_vm._l((_vm.days),function(day){return _c('k-form-checkbox',{key:day.id,attrs:{"value":day.id}},[_vm._v(" "+_vm._s(day.label)+" ")])}),1)],1)],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-31",modifiers:{"accordion-31":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Fiche d'intervention PDF")])],1),_c('b-collapse',{attrs:{"id":"accordion-31","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('PlanificationDocumentModel')],1)],1)],1),_c('b-card',{staticClass:"mb-2",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-0",attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-4",modifiers:{"accordion-4":true}}],staticClass:"text-left",attrs:{"block":"","variant":"light"}},[_vm._v("Personnalisation")])],1),_c('b-collapse',{attrs:{"id":"accordion-4","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('input',{attrs:{"type":"hidden","name":"configs[construction_customize]"},domProps:{"value":_vm.localConfig.construction_customize}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.construction_customize),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize", $$v)},expression:"localConfig.construction_customize"}},[_vm._v(" Personnaliser le nom du module ")]),(_vm.localConfig.construction_customize)?_c('table',{staticClass:"table table-sm table-bordered align-middle mt-2"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Élément")]),_c('th',[_vm._v("Singulier")]),_c('th',[_vm._v("Pluriel")]),_c('th',[_vm._v("Genre")])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("Chantier")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_chantier_one]","placeholder":"chantier","size":"sm"},model:{value:(_vm.localConfig.construction_customize_chantier_one),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_chantier_one", $$v)},expression:"localConfig.construction_customize_chantier_one"}})],1),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_chantier_more]","placeholder":"chantiers","size":"sm"},model:{value:(_vm.localConfig.construction_customize_chantier_more),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_chantier_more", $$v)},expression:"localConfig.construction_customize_chantier_more"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_customize_chantier_gender]","options":_vm.genderOptions,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.localConfig.construction_customize_chantier_gender),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_chantier_gender", $$v)},expression:"localConfig.construction_customize_chantier_gender"}})],1)]),_c('tr',[_c('td',[_vm._v("Technicien")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_technician_one]","placeholder":"technicien","size":"sm"},model:{value:(_vm.localConfig.construction_customize_technician_one),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_technician_one", $$v)},expression:"localConfig.construction_customize_technician_one"}})],1),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_technician_more]","placeholder":"techniciens","size":"sm"},model:{value:(_vm.localConfig.construction_customize_technician_more),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_technician_more", $$v)},expression:"localConfig.construction_customize_technician_more"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_customize_technician_gender]","options":_vm.genderOptions,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.localConfig.construction_customize_technician_gender),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_technician_gender", $$v)},expression:"localConfig.construction_customize_technician_gender"}})],1)]),_c('tr',[_c('td',[_vm._v("Planification")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_planning_one]","placeholder":"planification","size":"sm"},model:{value:(_vm.localConfig.construction_customize_planning_one),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_planning_one", $$v)},expression:"localConfig.construction_customize_planning_one"}})],1),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_planning_more]","placeholder":"planifications","size":"sm"},model:{value:(_vm.localConfig.construction_customize_planning_more),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_planning_more", $$v)},expression:"localConfig.construction_customize_planning_more"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[construction_customize_planning_gender]","options":_vm.genderOptions,"reduce":opt => opt.value,"size":"sm","clearable":false},model:{value:(_vm.localConfig.construction_customize_planning_gender),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_planning_gender", $$v)},expression:"localConfig.construction_customize_planning_gender"}})],1)]),_c('tr',[_c('td',[_vm._v("Menu principal")]),_c('td',[_c('k-form-input',{attrs:{"name":"configs[construction_customize_menu_label]","placeholder":"Chantiers","size":"sm"},model:{value:(_vm.localConfig.construction_customize_menu_label),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_menu_label", $$v)},expression:"localConfig.construction_customize_menu_label"}})],1),_c('td',{attrs:{"colspan":"2"}},[_c('b-form-radio-group',{staticClass:"construction-params-icons",attrs:{"name":"configs[construction_customize_menu_icon]","buttons":"","button-variant":"light"},model:{value:(_vm.localConfig.construction_customize_menu_icon),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_menu_icon", $$v)},expression:"localConfig.construction_customize_menu_icon"}},_vm._l((_vm.icons),function(icon,i){return _c('b-form-radio',{key:i,attrs:{"value":icon}},[_c('font-awesome-icon',{attrs:{"icon":['fas', icon]}})],1)}),1)],1)])])]):_vm._e(),_c('b-row',{staticClass:"mt-3"},[_c('b-col',[_c('b-form-group',{attrs:{"label":"Préfixe utilisé pour le nom du fichier (Bon d'invention PDF)","description":"Caractères alphanumérique seulement, sans accent"}},[_c('k-form-input',{attrs:{"name":"configs[construction_customize_filename]","required":""},on:{"change":_vm.filenameFormat},model:{value:(_vm.localConfig.construction_customize_filename),callback:function ($$v) {_vm.$set(_vm.localConfig, "construction_customize_filename", $$v)},expression:"localConfig.construction_customize_filename"}})],1)],1),_c('b-col',[_c('b-form-group',{staticClass:"form-text",attrs:{"label":"Exemple :"}},[_vm._v(" "+_vm._s(_vm.filenamePreview)+" ")])],1)],1)],1)],1)],1)],1),_c('p',{staticClass:"mt-3 mb-2 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)]],2)
}
var ConstructionParamsvue_type_template_id_595dfe35_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PlanificationDocumentModel/PlanificationDocumentModel.vue?vue&type=template&id=2d0703ae
var PlanificationDocumentModelvue_type_template_id_2d0703ae_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" Vous avez la possibilité de personnaliser les bons d'intervention PDF qui seront générés depuis le logiciel en utilisant un document Word. ")]),_c('b-form-group',{attrs:{"label":"Bon d'intervention"}},[(_vm.localTeam.construction_planification_model)?_c('div',{staticClass:"mt-2"},[_c('div',[_c('p',{staticClass:"text-center d-inline-block mb-1"},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: '#5959ff', 'font-size': '2rem' }),attrs:{"icon":['fad', 'file-word' ]}}),_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(_vm.localTeam.construction_planification_model.filename)+" ")])],1)]),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('div',{staticClass:"my-2"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadCustomModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1)]),_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-esc":_vm.loadingDelete,"hide-header-close":_vm.loadingDelete,"no-close-on-backdrop":_vm.loadingDelete,"busy":_vm.loadingDelete},on:{"ok":_vm.deleteModel},model:{value:(_vm.toDelete),callback:function ($$v) {_vm.toDelete=$$v},expression:"toDelete"}},[(_vm.loadingDelete)?_c('Spinner'):_c('div',[_vm._v(" Êtes-vous sûr de vouloir supprimer ce modèle de bon d'intervention ? ")])],1)],1):_c('div',[_c('small',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.fileType'))+" ")]),_c('k-form-file',{attrs:{"url":_vm.formAction,"name":"construction_planification_model","datas":{ _method: 'PUT' },"btnMode":"","btnSize":"sm","accept":['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text']},on:{"onUpload":_vm.applyNewTeam}})],1),_c('div',{staticClass:"mt-5"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.explain2'))),_c('br'),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('b-button',{staticClass:"my-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDefaultModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.downloadDefault'))+" ")])],1),_c('p',{staticClass:"mt-4 mb-2"},[_vm._v(" Liste des variables dynamiques qui peuvent être utilisées dans le document Word. Celles-ci seront automatiquement remplacées lors de la génération du bon d'intervention."),_c('br')]),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Votre entreprise"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$companyName$")]),_c('td',[_vm._v("Nom de l'entreprise")])]),_c('tr',[_c('td',[_vm._v("$companyRoad$")]),_c('td',[_vm._v("Adresse - Rue 1")])]),_c('tr',[_c('td',[_vm._v("$companyRoad2$")]),_c('td',[_vm._v("Adresse - Rue 2")])]),_c('tr',[_c('td',[_vm._v("$companyRoad3$")]),_c('td',[_vm._v("Adresse - Rue 3")])]),_c('tr',[_c('td',[_vm._v("$companyPostalCode$")]),_c('td',[_vm._v("Adresse - Code postal")])]),_c('tr',[_c('td',[_vm._v("$companyCity$")]),_c('td',[_vm._v("Adresse - Ville")])]),_c('tr',[_c('td',[_vm._v("$companyCountry$")]),_c('td',[_vm._v("Adresse - Pays")])]),_c('tr',[_c('td',[_vm._v("$companyPhone$")]),_c('td',[_vm._v("Téléphone")])]),_c('tr',[_c('td',[_vm._v("$companyMobile$")]),_c('td',[_vm._v("Portable")])]),_c('tr',[_c('td',[_vm._v("$companyEmail$")]),_c('td',[_vm._v("Email")])]),_c('tr',[_c('td',[_vm._v("$companyWebsite$")]),_c('td',[_vm._v("Site internet")])])])])]),_c('b-tab',{attrs:{"title":"Client & Contact"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$customerName$")]),_c('td',[_vm._v("Nom du client")])]),_c('tr',[_c('td',[_vm._v("$customerPhone$")]),_c('td',[_vm._v("Téléphone du client")])]),_c('tr',[_c('td',[_vm._v("$customerMobile$")]),_c('td',[_vm._v("Portable du client")])]),_c('tr',[_c('td',[_vm._v("$customerEmail$")]),_c('td',[_vm._v("Email du client")])]),_c('tr',[_c('td',[_vm._v("$contactName$")]),_c('td',[_vm._v("Nom du contact")])]),_c('tr',[_c('td',[_vm._v("$contactPhone$")]),_c('td',[_vm._v("Téléphone du contact")])]),_c('tr',[_c('td',[_vm._v("$contactMobile$")]),_c('td',[_vm._v("Portable du contact")])]),_c('tr',[_c('td',[_vm._v("$contactEmail$")]),_c('td',[_vm._v("Email du contact")])])])])]),_c('b-tab',{attrs:{"title":"Chantier"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$constructionReference$")]),_c('td',[_vm._v("Référence du chantier")])]),_c('tr',[_c('td',[_vm._v("$reference$")]),_c('td',[_vm._v("Référence du chantier ou de la planification si aucun chantier n'est lié")])]),_c('tr',[_c('td',[_vm._v("$constructionTitle$")]),_c('td',[_vm._v("Titre du chantier")])]),_c('tr',[_c('td',[_vm._v("$constructionAddress$")]),_c('td',[_vm._v("Adresse complète du chantier")])]),_c('tr',[_c('td',[_vm._v("$constructionRoad1$")]),_c('td',[_vm._v("Adresse - Rue 1")])]),_c('tr',[_c('td',[_vm._v("$constructionRoad2$")]),_c('td',[_vm._v("Adresse - Rue 2")])]),_c('tr',[_c('td',[_vm._v("$constructionRoad3$")]),_c('td',[_vm._v("Adresse - Rue 3")])]),_c('tr',[_c('td',[_vm._v("$constructionPostalCode$")]),_c('td',[_vm._v("Adresse - Code postal")])]),_c('tr',[_c('td',[_vm._v("$constructionCity$")]),_c('td',[_vm._v("Adresse - Ville")])]),_c('tr',[_c('td',[_vm._v("$constructionCountry$")]),_c('td',[_vm._v("Adresse - Pays")])]),_c('tr',[_c('td',[_vm._v("$constructionDuration$")]),_c('td',[_vm._v("Durée totale du chantier")])]),_c('tr',[_c('td',[_vm._v("$constructionNbTechncian$")]),_c('td',[_vm._v("Nombre de technicien requis")])])])]),_c('h3',{staticClass:"form-title-alt mb-1"},[_vm._v("Liste des produits nécessaires")]),_c('p',[_vm._v(" Les produits doivent être insérés dans un tableau sur une même ligne. Le ligne sera automatiquement dupliquée en fonction du nombre de produits nécessaires. ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$productReference$")]),_c('td',[_vm._v("Référence du produit")])]),_c('tr',[_c('td',[_vm._v("$productName$")]),_c('td',[_vm._v("Nom du produit")])]),_c('tr',[_c('td',[_vm._v("$productQuantity$")]),_c('td',[_vm._v("Quantité")])])])]),_c('h3',{staticClass:"form-title-alt mb-1"},[_vm._v("Liste du matériel nécessaire")]),_c('p',[_vm._v(" Les matériaux doivent être insérés dans un tableau sur une même ligne. Le ligne sera automatiquement dupliquée en fonction du nombre de matériaux nécessaires. ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$materialReference$")]),_c('td',[_vm._v("Référence du matériel")])]),_c('tr',[_c('td',[_vm._v("$materialName$")]),_c('td',[_vm._v("Nom du matériel")])]),_c('tr',[_c('td',[_vm._v("$materialQuantity$")]),_c('td',[_vm._v("Quantité")])])])]),_c('h3',{staticClass:"form-title-alt mb-0 border-0"},[_vm._v("Documents liés")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$quotation$")]),_c('td',[_vm._v("Devis lié")])]),_c('tr',[_c('td',[_vm._v("$command$")]),_c('td',[_vm._v("Bon de commande lié")])]),_c('tr',[_c('td',[_vm._v("$delivery$")]),_c('td',[_vm._v("Bon de livraison lié")])]),_c('tr',[_c('td',[_vm._v("$proforma$")]),_c('td',[_vm._v("Facture proforma liée")])]),_c('tr',[_c('td',[_vm._v("$invoice$")]),_c('td',[_vm._v("Facture liée")])]),_c('tr',[_c('td',[_vm._v("$credit$")]),_c('td',[_vm._v("Avoir lié")])])])])]),_c('b-tab',{attrs:{"title":"Planification"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$planificationReference$")]),_c('td',[_vm._v("Référence de la planification")])]),_c('tr',[_c('td',[_vm._v("$planificationBegin$")]),_c('td',[_vm._v("Début de la planification")])]),_c('tr',[_c('td',[_vm._v("$planificationEnd$")]),_c('td',[_vm._v("Fin de la planification")])]),_c('tr',[_c('td',[_vm._v("$planificationTechncians$")]),_c('td',[_vm._v("Liste des techniciens")])]),_c('tr',[_c('td',[_vm._v("$planificationDuration$")]),_c('td',[_vm._v("Durée totale de la planification")])]),_c('tr',[_c('td',[_vm._v("$planificationNbTechncian$")]),_c('td',[_vm._v("Nombre de technicien requis")])])])]),_c('h3',{staticClass:"form-title-alt"},[_vm._v("Contenu de la planification")]),_c('p',[_vm._v(" Le contenu doit être inséré dans un tableau sur une même ligne. Le ligne sera automatiquement dupliquée en fonction du nombre de prestation dans la planification. ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$contentReference$")]),_c('td',[_vm._v("Référence")])]),_c('tr',[_c('td',[_vm._v("$contentDesignation$")]),_c('td',[_vm._v("Désignation")])]),_c('tr',[_c('td',[_vm._v("$contentQuantity$")]),_c('td',[_vm._v("Quantité")])])])])]),_c('b-tab',{attrs:{"title":"Signature"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$signDate$")]),_c('td',[_vm._v("Date de signature")])]),_c('tr',[_c('td',[_vm._v("$signBlock$")]),_c('td',[_vm._v("Emplacement pour la signature électronique")])])])])]),(_vm.getCustomFields(['construction', 'planification']).length > 0)?_c('b-tab',{attrs:{"title":"Champs personnalisés"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_vm._l((_vm.getCustomFields(['construction', 'planification'])),function(field,i){return [_c('tr',{key:i},[_c('td',[_vm._v("$customField"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),(field.type === 'checkbox')?_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de texte. Les valeurs seront séparées par \", \". ")]):_vm._e()])]),(field.type === 'checkbox')?_c('tr',{key:i + '-multiple'},[_c('td',[_vm._v("$customFieldList"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de liste. Chaque valeur sera alors affichée sur une nouvelle ligne. Il est possible d'utiliser des listes à puce. ")])])]):_vm._e()]})],2)])]):_vm._e(),(_vm.getCustomFields(['customer']).length > 0)?_c('b-tab',{attrs:{"title":"Champs personnalisés du client"}},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v("Variable")]),_c('th',[_vm._v("Désignation")])])]),_c('tbody',[_vm._l((_vm.getCustomFields('customer')),function(field,i){return [_c('tr',{key:i},[_c('td',[_vm._v("$customField"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),(field.type === 'checkbox')?_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de texte. Les valeurs seront séparées par \", \". ")]):_vm._e()])]),(field.type === 'checkbox')?_c('tr',{key:i + '-multiple'},[_c('td',[_vm._v("$customFieldList"+_vm._s(field.id)+"$")]),_c('td',[_vm._v(" "+_vm._s(field.label)+" "),_c('p',{staticClass:"mb-0 text-muted"},[_vm._v(" Sous forme de liste. Chaque valeur sera alors affichée sur une nouvelle ligne. Il est possible d'utiliser des listes à puce. ")])])]):_vm._e()]})],2)])]):_vm._e()],1)],1)])],1)
}
var PlanificationDocumentModelvue_type_template_id_2d0703ae_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/PlanificationDocumentModel/PlanificationDocumentModel.ts?vue&type=script&lang=ts&external







var PlanificationDocumentModel = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationDocumentModel, _super);
    function PlanificationDocumentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingDefaultModel = false;
        _this.loadingCustomModel = false;
        _this.toDelete = false;
        _this.loadingDelete = false;
        return _this;
    }
    PlanificationDocumentModel.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadCustomFields()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanificationDocumentModel.prototype.downloadCustomModel = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var model;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        model = (_a = this.localTeam) === null || _a === void 0 ? void 0 : _a.construction_planification_model;
                        if (!model) {
                            return [2 /*return*/];
                        }
                        this.loadingCustomModel = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.get('/file/' + model.id + '?with_file=1')
                                .then(function (response) {
                                _this.downloadFile(response.data.file, model.filename);
                            })
                                .finally(function () {
                                _this.loadingCustomModel = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanificationDocumentModel.prototype.downloadDefaultModel = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingDefaultModel = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.get('/construction/default-intervention-model')
                                .then(function (response) {
                                _this.downloadFile(response.data, 'intervention-model.docx');
                            })
                                .finally(function () {
                                _this.loadingDefaultModel = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanificationDocumentModel.prototype.deleteModel = function (evt) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.preventDefault();
                        this.loadingDelete = true;
                        return [4 /*yield*/, this.$kwConstructions.axios.put(this.formAction, {
                                construction_planification_model: null
                            })
                                .then(function (response) {
                                _this.applyNewTeam(response.data);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.toDelete = false;
                                _this.loadingDelete = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlanificationDocumentModel = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay, BModal: external_bootstrap_vue_.BModal,
                KFormFile: form_vue_.KFormFile,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('customFields', ['loadCustomFields'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('customFields', ['getCustomFields']))
        })
    ], PlanificationDocumentModel);
    return PlanificationDocumentModel;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, interface_vue_.FileMixin)));
/* harmony default export */ var PlanificationDocumentModelvue_type_script_lang_ts_external = (PlanificationDocumentModel);

;// ./src/components/PlanificationDocumentModel/PlanificationDocumentModel.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationDocumentModel_PlanificationDocumentModelvue_type_script_lang_ts_external = (PlanificationDocumentModelvue_type_script_lang_ts_external); 
;// ./src/components/PlanificationDocumentModel/PlanificationDocumentModel.vue





/* normalize component */
;
var PlanificationDocumentModel_component = (0,componentNormalizer/* default */.A)(
  PlanificationDocumentModel_PlanificationDocumentModelvue_type_script_lang_ts_external,
  PlanificationDocumentModelvue_type_template_id_2d0703ae_render,
  PlanificationDocumentModelvue_type_template_id_2d0703ae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationDocumentModel_PlanificationDocumentModel = (PlanificationDocumentModel_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ConstructionParams/ConstructionParams.ts?vue&type=script&lang=ts&external








var ConstructionParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionParams, _super);
    function ConstructionParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        _this.workforceEntries = [
            { id: 0, label: _this.$t('sales.form.inputOptions.workforceChoice1') },
            { id: 1, label: _this.$t('sales.form.inputOptions.workforceChoice2') },
            { id: 2, label: _this.$t('sales.form.inputOptions.workforceChoice3') },
            { id: 3, label: _this.$t('sales.form.inputOptions.workforceChoice4') },
            { id: 4, label: _this.$t('sales.form.inputOptions.workforceChoice5') },
            { id: 5, label: _this.$t('sales.form.inputOptions.workforceChoice6') }
        ];
        _this.constructionCreationOptions = [
            { id: 0, label: 'Ne pas créer de chantier' },
            { id: 1, label: 'Créer automatiquement le chantier' },
            { id: 2, label: 'Demander si le chantier doit être créé' }
        ];
        _this.planificationValidation = [
            { id: true, label: 'Automatique' },
            { id: false, label: 'Manuelle' }
        ];
        _this.genderOptions = [
            { label: 'Masculin', value: 'male' },
            { label: 'Féminin', value: 'feminine' }
        ];
        _this.icons = [
            'traffic-cone', 'calendar-day', 'folders', 'copy', 'tags', 'cloud'
        ];
        _this.numberTypes = [
            { id: 1, label: 'Normal' },
            { id: 2, label: 'Remise à 0 tous les mois' },
            { id: 3, label: 'Remise à 0 tous les ans' }
        ];
        _this.notificationOptions = [
            { id: 0, label: 'Non' },
            { id: 1, label: 'Planning du jour' },
            { id: 2, label: 'Planning de la semaine' },
            { id: 3, label: 'Planning du lendemain' },
            { id: 4, label: 'Planning de la semaine prochaine' }
        ];
        _this.days = [
            { id: 1, label: 'Lundi' },
            { id: 2, label: 'Mardi' },
            { id: 3, label: 'Mercredi' },
            { id: 4, label: 'Jeudi' },
            { id: 5, label: 'Vendredi' },
            { id: 6, label: 'Samedi' },
            { id: 7, label: 'Dimanche' }
        ];
        _this.notificationHoursOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        return _this;
    }
    ConstructionParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadModels()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ConstructionParams.prototype, "planificationBeginHours", {
        get: function () {
            var _this = this;
            return this.notificationHoursOptions.filter(function (hour) { return hour < _this.localConfig.construction_planification_end_hour; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionParams.prototype, "planificationEndHours", {
        get: function () {
            var _this = this;
            return this.notificationHoursOptions.filter(function (hour) { return hour > _this.localConfig.construction_planification_begin_hour; });
        },
        enumerable: false,
        configurable: true
    });
    ConstructionParams.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    ConstructionParams.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    Object.defineProperty(ConstructionParams.prototype, "constructionReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.construction_reference_prefix, this.localConfig.construction_reference_number, this.localConfig.construction_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionParams.prototype, "planificationReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.construction_planification_reference_prefix, this.localConfig.construction_planification_reference_number, this.localConfig.construction_planification_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionParams.prototype, "filenamePreview", {
        get: function () {
            return this.localConfig.construction_customize_filename + this.constructionReferenceExample + '.pdf';
        },
        enumerable: false,
        configurable: true
    });
    ConstructionParams.prototype.filenameFormat = function () {
        var regex = /[^a-zA-Z0-9_-]/ig;
        var filename = this.localConfig.construction_customize_filename;
        if (regex.test(filename)) {
            this.localConfig.construction_customize_filename = filename.replace(regex, '');
        }
    };
    ConstructionParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BTableSimple: external_bootstrap_vue_.BTableSimple, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BCardHeader: external_bootstrap_vue_.BCardHeader, BCardBody: external_bootstrap_vue_.BCardBody, BCollapse: external_bootstrap_vue_.BCollapse, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup,
                KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormCheckboxGroup: form_vue_.KFormCheckboxGroup, KForm: form_vue_.KForm, KFormSpinner: form_vue_.KFormSpinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner,
                PlanificationDocumentModel: PlanificationDocumentModel_PlanificationDocumentModel
            },
            directives: {
                'b-toggle': external_bootstrap_vue_.VBToggle
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['models'])), (0,external_vuex_.mapState)('user', ['user']))
        })
    ], ConstructionParams);
    return ConstructionParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var ConstructionParamsvue_type_script_lang_ts_external = (ConstructionParams);

;// ./src/components/ConstructionParams/ConstructionParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionParams_ConstructionParamsvue_type_script_lang_ts_external = (ConstructionParamsvue_type_script_lang_ts_external); 
;// ./src/components/ConstructionParams/ConstructionParams.vue





/* normalize component */
;
var ConstructionParams_component = (0,componentNormalizer/* default */.A)(
  ConstructionParams_ConstructionParamsvue_type_script_lang_ts_external,
  ConstructionParamsvue_type_template_id_595dfe35_render,
  ConstructionParamsvue_type_template_id_595dfe35_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionParams_ConstructionParams = (ConstructionParams_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Materials/Materials.vue?vue&type=template&id=54c14c03
var Materialsvue_type_template_id_54c14c03_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/construction/material","columns":_vm.columns,"createTitle":_vm.$t('constructions.materials.new'),"updateTitle":_vm.$t('constructions.materials.edit'),"deleteMsg":_vm.$t('constructions.materials.deleteMsg'),"sort":"name"},on:{"submitted":_vm.setMaterial,"deleted":_vm.deleteMaterial}})
}
var Materialsvue_type_template_id_54c14c03_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Materials/Materials.ts?vue&type=script&lang=ts&external




var Materials = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Materials, _super);
    function Materials() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Materials.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('constructions.materials.reference'),
                    key: 'reference',
                    required: false
                },
                {
                    label: this.$t('constructions.materials.name'),
                    key: 'name',
                    required: true
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Materials = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('constructions', ['setMaterial', 'deleteMaterial']))
        })
    ], Materials);
    return Materials;
}(lib/* Vue */.lD));
/* harmony default export */ var Materialsvue_type_script_lang_ts_external = (Materials);

;// ./src/components/Materials/Materials.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Materials_Materialsvue_type_script_lang_ts_external = (Materialsvue_type_script_lang_ts_external); 
;// ./src/components/Materials/Materials.vue





/* normalize component */
;
var Materials_component = (0,componentNormalizer/* default */.A)(
  Materials_Materialsvue_type_script_lang_ts_external,
  Materialsvue_type_template_id_54c14c03_render,
  Materialsvue_type_template_id_54c14c03_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Materials_Materials = (Materials_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Technicians/Technicians.vue?vue&type=template&id=771fdd7c
var Techniciansvue_type_template_id_771fdd7c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" Vous avez deux possibilités pour ajouter des techniciens : "),_c('ul',[_c('li',[_c('p',[_c('strong',[_vm._v("Utiliser des utilisateurs du logiciel.")]),_c('br'),_vm._v(" Ils pourront alors accéder à leurs planifications et y apporter des notes et des photos."),_c('br'),_vm._v(" Pour cela vous devez créer un utilisateur et lui attribuer le rôle Technicien : "),_c('router-link',{attrs:{"to":{ name: 'config-users' }}},[_vm._v("Gérer mes utilisateurs")]),_c('b-alert',{staticClass:"mt-1",attrs:{"show":"","variant":"warning"}},[_vm._v(" Vous pouvez activer une interface simplifiée spéciale technicien où ils n'auront accès qu'a leurs planifications et planning."),_c('br'),_vm._v(" Pour cela, vous devez modifier l'utilisateur et aller dans la section \"Droits d'accès\", puis \"Chantiers\", et activer l'interface technicien."),_c('br'),_vm._v(" Vous pouvez en complement, attribuer différents droits aux chantiers (Interdiction, Lecture seule...). ")])],1)]),_vm._m(0)]),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Utilisateur(s) ayant le rôle technicien ")]),(_vm.loading)?_c('Spinner'):[(_vm.teamUsersRole('technical').length === 0)?_c('p',{staticClass:"text-center p-2"},[_vm._v(" Aucun utilisateur n'a le rôle technicien ")]):_c('table',{staticClass:"table table-sm table-bordered mb-1"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Utilisateur")]),_c('th',[_vm._v("Email")])])]),_c('tbody',_vm._l((_vm.teamUsersRole('technical')),function(user){return _c('tr',{key:user.id},[_c('td',[_vm._v(_vm._s(user.fullname))]),_c('td',[_vm._v(_vm._s(user.email))])])}),0)]),_c('b-button',{attrs:{"to":{ name: 'config-users' },"variant":"primary","size":"sm"}},[_vm._v(" Gérer mes utilisateurs ")])],_c('h2',{staticClass:"form-title-alt"},[_vm._v(" Technicien(s) simple(s) ")]),_c('DynamicList',{attrs:{"url":"/construction/technical","columns":_vm.columns,"createTitle":_vm.$t('constructions.technicals.new'),"updateTitle":_vm.$t('constructions.technicals.edit'),"deleteMsg":_vm.$t('constructions.technicals.deleteMsg'),"sort":"name"},on:{"submitted":_vm.setTechnical,"deleted":_vm.deleteTechnical}})],2)
}
var Techniciansvue_type_template_id_771fdd7c_staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',[_c('strong',[_vm._v("Ajouter des techniciens qui n'auront pas accès au logiciel.")]),_c('br'),_vm._v(" Vous pouvez les ajouter ci-dessous. Ils ne pourront que recevoir les notifications par email avec leur planification mais n'auront pas accès aux fiches des chantiers. ")])
}]


;// ./src/components/Technicians/Technicians.vue?vue&type=template&id=771fdd7c

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Technicians/Technicians.ts?vue&type=script&lang=ts&external





var Technicians = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Technicians, _super);
    function Technicians() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    Technicians.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Technicians.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('constructions.technicals.name'),
                    key: 'name',
                    required: true
                },
                {
                    label: this.$t('constructions.technicals.email'),
                    key: 'email',
                    required: false,
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Technicians = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList,
                Spinner: interface_vue_.Spinner,
                BButton: external_bootstrap_vue_.BButton, BAlert: external_bootstrap_vue_.BAlert
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])), (0,external_vuex_.mapActions)('constructions', ['setTechnical', 'deleteTechnical']))
        })
    ], Technicians);
    return Technicians;
}(lib/* Vue */.lD));
/* harmony default export */ var Techniciansvue_type_script_lang_ts_external = (Technicians);

;// ./src/components/Technicians/Technicians.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Technicians_Techniciansvue_type_script_lang_ts_external = (Techniciansvue_type_script_lang_ts_external); 
;// ./src/components/Technicians/Technicians.vue





/* normalize component */
;
var Technicians_component = (0,componentNormalizer/* default */.A)(
  Technicians_Techniciansvue_type_script_lang_ts_external,
  Techniciansvue_type_template_id_771fdd7c_render,
  Techniciansvue_type_template_id_771fdd7c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Technicians_Technicians = (Technicians_component.exports);
// EXTERNAL MODULE: ./src/components/TechniciansCalendar/TechniciansCalendar.vue + 7 modules
var TechniciansCalendar = __webpack_require__(8994);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/fetchDatas/construction.ts


var constructionRelations = [
    'customer', 'contact', 'country', 'contents', 'customFields', 'tags', 'products', 'materials', 'linked_documents', 'signatures'
];
var needFetchConstruction = function (model) {
    return !constructionRelations.every(function (relation) { return relation in model; });
};
var fetchConstruction = function (id) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, external_vue_default().prototype.$kwConstructions.axios.get('/construction/' + id, {
                    params: {
                        include: constructionRelations.join(','),
                        with_document: true
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };


// EXTERNAL MODULE: ./src/fetchDatas/planification.ts
var planification = __webpack_require__(3385);
;// ./src/mixins/LoadConstructionMixin.ts






var setPageTitle = function (construction, route) {
    var title;
    if (route.name === 'construction-form') {
        title = (0,utils_text/* termText */.a)(construction === null ? 'construction.newTitle' : 'construction.editTitle', 'chantier', false, { reference: construction === null || construction === void 0 ? void 0 : construction.reference });
    }
    else {
        title = (0,utils_text/* termText */.a)('construction.title', 'chantier', false, { reference: construction === null || construction === void 0 ? void 0 : construction.reference });
    }
    window.document.title = (0,utils_text/* uppercaseFirst */.t)(title);
};
var LoadConstructionMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LoadConstructionMixin, _super);
    function LoadConstructionMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.construction = null;
        _this.loading = true;
        return _this;
    }
    LoadConstructionMixin = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['pageParams'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var id;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                if (!id) {
                                    next(function (vm) {
                                        var _a;
                                        vm.loading = true;
                                        if (vm.pageParams) {
                                            var construction = JSON.parse(JSON.stringify(vm.pageParams));
                                            construction.reference = null;
                                            construction.id = null;
                                            (_a = construction.contents) === null || _a === void 0 ? void 0 : _a.map(function (content) {
                                                content.affair_content = null;
                                                content.affair_content_id = null;
                                                content.id = null;
                                                return content;
                                            });
                                            vm.construction = construction;
                                            vm.setPageParams(null);
                                        }
                                        else {
                                            vm.construction = null;
                                        }
                                        vm.loading = false;
                                    });
                                    setPageTitle(null, to);
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, fetchConstruction(id)
                                        .then(function (construction) {
                                        next(function (vm) {
                                            vm.construction = construction;
                                            setPageTitle(construction, to);
                                            vm.loading = false;
                                        });
                                    })
                                        .catch(function (error) {
                                        throw new Error(error);
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var id;
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                id = to.params.id;
                                this.loading = true;
                                this.construction = null;
                                if (!id) {
                                    setPageTitle(null, to);
                                    this.loading = false;
                                    next();
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, fetchConstruction(to.params.id)
                                        .then(function (construction) {
                                        _this.construction = construction;
                                        _this.loading = false;
                                        setPageTitle(construction, to);
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], LoadConstructionMixin);
    return LoadConstructionMixin;
}(lib/* Vue */.lD));
/* harmony default export */ var mixins_LoadConstructionMixin = (LoadConstructionMixin);

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionListView/ConstructionListView.vue?vue&type=template&id=391ced94
var ConstructionListViewvue_type_template_id_391ced94_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle,"buttons":_vm.buttons}}),_c('AppMessages'),_c('ConstructionList')],1)
}
var ConstructionListViewvue_type_template_id_391ced94_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/ConstructionListView/ConstructionListView.ts?vue&type=script&lang=ts&external





var ConstructionListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionListView, _super);
    function ConstructionListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstructionListView.prototype.mounted = function () {
        document.title = (0,utils_text/* termText */.a)('construction.menu', 'chantier', true);
    };
    Object.defineProperty(ConstructionListView.prototype, "pageTitle", {
        get: function () {
            return (0,utils_text/* termText */.a)('construction.menu', 'chantier', true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConstructionListView.prototype, "buttons", {
        get: function () {
            return [
                {
                    label: (0,utils_text/* termText */.a)('construction.menuAddTitle', 'chantier'),
                    to: { name: 'construction-form' }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ConstructionListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ConstructionList: ConstructionList_ConstructionList,
                PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages
            }
        })
    ], ConstructionListView);
    return ConstructionListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ConstructionListViewvue_type_script_lang_ts_external = (ConstructionListView);

;// ./src/views/ConstructionListView/ConstructionListView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ConstructionListView_ConstructionListViewvue_type_script_lang_ts_external = (ConstructionListViewvue_type_script_lang_ts_external); 
;// ./src/views/ConstructionListView/ConstructionListView.vue





/* normalize component */
;
var ConstructionListView_component = (0,componentNormalizer/* default */.A)(
  ConstructionListView_ConstructionListViewvue_type_script_lang_ts_external,
  ConstructionListViewvue_type_template_id_391ced94_render,
  ConstructionListViewvue_type_template_id_391ced94_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ConstructionListView_ConstructionListView = (ConstructionListView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/PlanificationListView/PlanificationListView.vue?vue&type=template&id=a77e9644
var PlanificationListViewvue_type_template_id_a77e9644_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.pageTitle,"buttons":_vm.buttons}}),_c('AppMessages'),_c('PlanificationList')],1)
}
var PlanificationListViewvue_type_template_id_a77e9644_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/PlanificationListView/PlanificationListView.ts?vue&type=script&lang=ts&external






var PlanificationListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(PlanificationListView, _super);
    function PlanificationListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlanificationListView.prototype.mounted = function () {
        document.title = this.pageTitle;
    };
    Object.defineProperty(PlanificationListView.prototype, "pageTitle", {
        get: function () {
            return (0,utils_text/* termText */.a)('construction.menu', 'planning', true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanificationListView.prototype, "buttons", {
        get: function () {
            return [
                {
                    component: PlanificationForm["default"],
                    attributes: {
                        label: (0,utils_text/* uppercaseFirst */.t)((0,utils_text/* termText */.a)('planification.newTitle', 'planning'))
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    PlanificationListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PlanificationList: PlanificationList_PlanificationList, PlanificationForm: PlanificationForm["default"],
                PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages
            }
        })
    ], PlanificationListView);
    return PlanificationListView;
}(lib/* Vue */.lD));
/* harmony default export */ var PlanificationListViewvue_type_script_lang_ts_external = (PlanificationListView);

;// ./src/views/PlanificationListView/PlanificationListView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var PlanificationListView_PlanificationListViewvue_type_script_lang_ts_external = (PlanificationListViewvue_type_script_lang_ts_external); 
;// ./src/views/PlanificationListView/PlanificationListView.vue





/* normalize component */
;
var PlanificationListView_component = (0,componentNormalizer/* default */.A)(
  PlanificationListView_PlanificationListViewvue_type_script_lang_ts_external,
  PlanificationListViewvue_type_template_id_a77e9644_render,
  PlanificationListViewvue_type_template_id_a77e9644_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanificationListView_PlanificationListView = (PlanificationListView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionCalendarView.vue?vue&type=template&id=0e1a1d82
var ConstructionCalendarViewvue_type_template_id_0e1a1d82_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ConstructionCalendar')
}
var ConstructionCalendarViewvue_type_template_id_0e1a1d82_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionCalendarView.vue?vue&type=script&lang=ts





var ConstructionCalendarView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionCalendarView, _super);
    function ConstructionCalendarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstructionCalendarView.prototype.mounted = function () {
        document.title = (0,utils_text/* termText */.a)('construction.planning.menu', 'chantier', true);
    };
    ConstructionCalendarView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ConstructionCalendar: ConstructionCalendar_ConstructionCalendar,
                PageHeader: interface_vue_.PageHeader
            }
        })
    ], ConstructionCalendarView);
    return ConstructionCalendarView;
}(lib/* Vue */.lD));
/* harmony default export */ var ConstructionCalendarViewvue_type_script_lang_ts = (ConstructionCalendarView);

;// ./src/views/ConstructionCalendarView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ConstructionCalendarViewvue_type_script_lang_ts = (ConstructionCalendarViewvue_type_script_lang_ts); 
;// ./src/views/ConstructionCalendarView.vue





/* normalize component */
;
var ConstructionCalendarView_component = (0,componentNormalizer/* default */.A)(
  views_ConstructionCalendarViewvue_type_script_lang_ts,
  ConstructionCalendarViewvue_type_template_id_0e1a1d82_render,
  ConstructionCalendarViewvue_type_template_id_0e1a1d82_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ConstructionCalendarView = (ConstructionCalendarView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionFormView.vue?vue&type=template&id=e602b800
var ConstructionFormViewvue_type_template_id_e602b800_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ConstructionForm',{model:{value:(_vm.construction),callback:function ($$v) {_vm.construction=$$v},expression:"construction"}})],1)
}
var ConstructionFormViewvue_type_template_id_e602b800_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionFormView.vue?vue&type=script&lang=ts




var ConstructionFormView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionFormView, _super);
    function ConstructionFormView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstructionFormView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ConstructionForm: ConstructionForm_ConstructionForm
            }
        })
    ], ConstructionFormView);
    return ConstructionFormView;
}((0,lib/* Mixins */.Xe)(mixins_LoadConstructionMixin)));
/* harmony default export */ var ConstructionFormViewvue_type_script_lang_ts = (ConstructionFormView);

;// ./src/views/ConstructionFormView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ConstructionFormViewvue_type_script_lang_ts = (ConstructionFormViewvue_type_script_lang_ts); 
;// ./src/views/ConstructionFormView.vue





/* normalize component */
;
var ConstructionFormView_component = (0,componentNormalizer/* default */.A)(
  views_ConstructionFormViewvue_type_script_lang_ts,
  ConstructionFormViewvue_type_template_id_e602b800_render,
  ConstructionFormViewvue_type_template_id_e602b800_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ConstructionFormView = (ConstructionFormView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionItemView.vue?vue&type=template&id=bd704e1e
var ConstructionItemViewvue_type_template_id_bd704e1e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('ConstructionItem',{model:{value:(_vm.construction),callback:function ($$v) {_vm.construction=$$v},expression:"construction"}})],1)
}
var ConstructionItemViewvue_type_template_id_bd704e1e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionItemView.vue?vue&type=script&lang=ts




var ConstructionItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionItemView, _super);
    function ConstructionItemView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstructionItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ConstructionItem: ConstructionItem_ConstructionItem
            }
        })
    ], ConstructionItemView);
    return ConstructionItemView;
}((0,lib/* Mixins */.Xe)(mixins_LoadConstructionMixin)));
/* harmony default export */ var ConstructionItemViewvue_type_script_lang_ts = (ConstructionItemView);

;// ./src/views/ConstructionItemView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ConstructionItemViewvue_type_script_lang_ts = (ConstructionItemViewvue_type_script_lang_ts); 
;// ./src/views/ConstructionItemView.vue





/* normalize component */
;
var ConstructionItemView_component = (0,componentNormalizer/* default */.A)(
  views_ConstructionItemViewvue_type_script_lang_ts,
  ConstructionItemViewvue_type_template_id_bd704e1e_render,
  ConstructionItemViewvue_type_template_id_bd704e1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ConstructionItemView = (ConstructionItemView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionParamsView.vue?vue&type=template&id=72aa7918
var ConstructionParamsViewvue_type_template_id_72aa7918_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Paramètres","lazy":""}},[_c('ConstructionParams')],1),_c('b-tab',{attrs:{"title":"Techniciens","lazy":""}},[_c('Technicians')],1),_c('b-tab',{attrs:{"title":"Matériels","lazy":""}},[_c('Materials')],1)],1)
}
var ConstructionParamsViewvue_type_template_id_72aa7918_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConstructionParamsView.vue?vue&type=script&lang=ts






var ConstructionParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConstructionParamsView, _super);
    function ConstructionParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConstructionParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BFormGroup: external_bootstrap_vue_.BFormGroup,
                ConstructionParams: ConstructionParams_ConstructionParams,
                Materials: Materials_Materials,
                Technicians: Technicians_Technicians
            }
        })
    ], ConstructionParamsView);
    return ConstructionParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var ConstructionParamsViewvue_type_script_lang_ts = (ConstructionParamsView);

;// ./src/views/ConstructionParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ConstructionParamsViewvue_type_script_lang_ts = (ConstructionParamsViewvue_type_script_lang_ts); 
;// ./src/views/ConstructionParamsView.vue





/* normalize component */
;
var ConstructionParamsView_component = (0,componentNormalizer/* default */.A)(
  views_ConstructionParamsViewvue_type_script_lang_ts,
  ConstructionParamsViewvue_type_template_id_72aa7918_render,
  ConstructionParamsViewvue_type_template_id_72aa7918_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ConstructionParamsView = (ConstructionParamsView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MaterialsView.vue?vue&type=template&id=be8d159c
var MaterialsViewvue_type_template_id_be8d159c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Materials')],1)
}
var MaterialsViewvue_type_template_id_be8d159c_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MaterialsView.vue?vue&type=script&lang=ts



var MaterialsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MaterialsView, _super);
    function MaterialsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Materials: Materials_Materials
            }
        })
    ], MaterialsView);
    return MaterialsView;
}(lib/* Vue */.lD));
/* harmony default export */ var MaterialsViewvue_type_script_lang_ts = (MaterialsView);

;// ./src/views/MaterialsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_MaterialsViewvue_type_script_lang_ts = (MaterialsViewvue_type_script_lang_ts); 
;// ./src/views/MaterialsView.vue





/* normalize component */
;
var MaterialsView_component = (0,componentNormalizer/* default */.A)(
  views_MaterialsViewvue_type_script_lang_ts,
  MaterialsViewvue_type_template_id_be8d159c_render,
  MaterialsViewvue_type_template_id_be8d159c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_MaterialsView = (MaterialsView_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TechniciansCalendarView.vue?vue&type=template&id=4e9c4a24
var TechniciansCalendarViewvue_type_template_id_4e9c4a24_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TechniciansCalendar')
}
var TechniciansCalendarViewvue_type_template_id_4e9c4a24_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TechniciansCalendarView.vue?vue&type=script&lang=ts




var TechniciansCalendarView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TechniciansCalendarView, _super);
    function TechniciansCalendarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TechniciansCalendarView.prototype.mounted = function () {
        document.title = (0,utils_text/* termText */.a)('construction.planning.menu', 'technician', true);
    };
    TechniciansCalendarView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TechniciansCalendar: TechniciansCalendar/* default */.A
            }
        })
    ], TechniciansCalendarView);
    return TechniciansCalendarView;
}(lib/* Vue */.lD));
/* harmony default export */ var TechniciansCalendarViewvue_type_script_lang_ts = (TechniciansCalendarView);

;// ./src/views/TechniciansCalendarView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TechniciansCalendarViewvue_type_script_lang_ts = (TechniciansCalendarViewvue_type_script_lang_ts); 
;// ./src/views/TechniciansCalendarView.vue





/* normalize component */
;
var TechniciansCalendarView_component = (0,componentNormalizer/* default */.A)(
  views_TechniciansCalendarViewvue_type_script_lang_ts,
  TechniciansCalendarViewvue_type_template_id_4e9c4a24_render,
  TechniciansCalendarViewvue_type_template_id_4e9c4a24_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TechniciansCalendarView = (TechniciansCalendarView_component.exports);
;// ./src/router/goToHome.ts

var goToHome = function (router, store) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    var can;
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        switch (_a.label) {
            case 0:
                can = store.getters['user/can'];
                if (!can('constructionInterface', 1)) return [3 /*break*/, 2];
                return [4 /*yield*/, router.push({ name: 'technician-dashboard' })];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2: return [2 /*return*/, false];
        }
    });
}); };
/* harmony default export */ var router_goToHome = (goToHome);

;// ./src/showSidebar.ts
var showSidebar = function (store) {
    var can = store.getters['user/can'];
    return !can('constructionInterface', 1);
};
/* harmony default export */ var src_showSidebar = (showSidebar);

;// ./src/index.ts








































;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=constructions.common.js.map